import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  /**
   * Fleet health filter values stored as flexible JSON organized by category.
   * Each category contains only service group breakdowns (no category-level totals).
   * Structures without a category are grouped under "uncategorized".
   * Example structure:
   * {
   *   "coatings_manager": {
   *     "hydrocarbon_lines": { "ri0": 754.83, "ri1": 731.93, "ri2": 475.93, "ri3": 1840.85, "ri4": 873.11, "ri5": 25.15 },
   *     "flare_and_vent_systems": { "ri0": 226.38, "ri1": 186.36, "ri2": 128.19, "ri3": 406.97, "ri4": 157.78, "ri5": 3.84 },
   *     "unknown_services": { "ri0": 1636.67, "ri1": 1139.36, "ri2": 621.81, "ri3": 1713.01, "ri4": 783.46, "ri5": 45.96 }
   *   },
   *   "structure": {
   *     "unknown_services": { "ri0": 4094.53, "ri1": 3442.54, "ri2": 2578.72, "ri3": 9220.51, "ri4": 1646.96, "ri5": 37.09 }
   *   },
   *   "uncategorized": {
   *     "hydrocarbon_lines": { "ri0": 500.00, "ri1": 300.00, "ri2": 200.00, "ri3": 1000.00, "ri4": 400.00, "ri5": 50.00 },
   *     "other_services": { "ri0": 300.00, "ri1": 200.00, "ri2": 100.00, "ri3": 500.00, "ri4": 250.00, "ri5": 30.00 }
   *   }
   * }
   */
  FleetHealthFilters: { input: any; output: any; }
  /**
   * scalar JSON
   * can be used to json datatype
   */
  JSON: { input: any; output: any; }
  ObjectId: { input: any; output: any; }
  StringFloatInt: { input: any; output: any; }
};

export type AddLogsTemplateInput = {
  /** Category of log entry (WORKLOG, COST_LOG, QAQC_FORM) */
  category: LogCategory;
  logsTemplateId: Scalars['ID']['input'];
  structureId: Scalars['ID']['input'];
};

export type AddNewAssemblyTagNameInput = {
  isNewlyAdded?: InputMaybe<Scalars['Boolean']['input']>;
  lastModifiedFor: Scalars['String']['input'];
  structureId: Scalars['ID']['input'];
  tagName: Scalars['String']['input'];
};

export type AddPartialRemediationInput = {
  /** Assembly paint region IDs to update */
  assemblyPaintRegionIds: Array<Scalars['ID']['input']>;
  /** Completion date */
  completedAt?: InputMaybe<Scalars['String']['input']>;
  /** Reason for modification */
  lastModifiedFor?: InputMaybe<Scalars['String']['input']>;
  /** Date when remediation is planned or completed */
  remediationAt?: InputMaybe<Scalars['String']['input']>;
  /** Status of the remediation */
  status: PaintRegionStatus;
  /** Total remediated area (sqft) entered by user - will be converted to percentage and applied proportionally to each Ri. May exceed total area. */
  totalRemediatedArea: Scalars['Float']['input'];
};

export type AddPartsToAssemblyInput = {
  /** Object Id for Assembly to add Parts to */
  assemblyId: Scalars['ID']['input'];
  /** Object Ids of parts to link to assembly */
  partIds: Array<Scalars['ID']['input']>;
  /** Object Id for the structure this assembly belongs to */
  structureId: Scalars['ID']['input'];
  /** Object Id for the zone the user is tagging in to filter the subscriptions */
  zoneId?: InputMaybe<Scalars['ID']['input']>;
};

export type AddRemoveStructuresToFromUserGroupsInput = {
  structureIds: Array<Scalars['ID']['input']>;
  userGroupIds: Array<Scalars['ID']['input']>;
};

export type AddRemoveUsersToFromUserGroupInput = {
  userGroupId: Scalars['ID']['input'];
  userIds: Array<Scalars['ID']['input']>;
};

export type AddStructurePipesInput = {
  imperialSteelPipes?: InputMaybe<Scalars['JSON']['input']>;
  structureId: Scalars['ID']['input'];
};

export type AddUpdateBatchInput = {
  archivePath: Scalars['String']['input'];
  id: Scalars['ID']['input'];
  locationIds: Array<Scalars['ObjectId']['input']>;
  status?: InputMaybe<BatchStatus>;
  structureId: Scalars['ID']['input'];
};

export type AddUpdateCuboidInput = {
  cuboidClassId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
  position: Array<Scalars['Float']['input']>;
  rotation: Array<Scalars['Float']['input']>;
  scale: Array<Scalars['Float']['input']>;
  structureId: Scalars['ID']['input'];
  zoneId: Scalars['ID']['input'];
};

export type AddUpdateProcessingJobInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  processingId: Scalars['String']['input'];
  structureId: Scalars['ID']['input'];
};

export type AddUpdateSplitCuboidOnPartInput = {
  /** Object Id of part to add cuboid to */
  partId: Scalars['ID']['input'];
  /** Object Id for the cuboid to update */
  splitCuboid: SplitCuboidInput;
  /** Object Id for the structure this part belongs to */
  structureId: Scalars['ID']['input'];
  /** Object Id for the zone the user is tagging in to filter the subscriptions */
  zoneId?: InputMaybe<Scalars['ID']['input']>;
};

export type AddUpdateSplitCuboidOnPartNotification = {
  __typename?: 'AddUpdateSplitCuboidOnPartNotification';
  /** Object Id of part to add cuboid to */
  partId: Scalars['ID']['output'];
  /** Split Cuboid to add or update */
  splitCuboid: SplitCuboid;
  /** Object Id for the structure this part belongs to */
  structureId: Scalars['ID']['output'];
  /** Object Id for the zone the user is tagging in to filter the subscriptions */
  zoneId?: Maybe<Scalars['ID']['output']>;
};

export type AddWorkpackTemplateInput = {
  structureId: Scalars['ID']['input'];
  workpackTemplateId: Scalars['ID']['input'];
};

export type AggregatedKpiField = {
  __typename?: 'AggregatedKpiField';
  fieldKey: Scalars['String']['output'];
  value: Scalars['Float']['output'];
};

export type AggregatedKpiLogEntriesInput = {
  /** Category of log entry (WORKLOG, COST_LOG) */
  category: Array<LogCategory>;
  /** Collection name filter (e.g., 'workpacks', 'structures') */
  collectionName?: InputMaybe<Scalars['String']['input']>;
  endDate?: InputMaybe<Scalars['String']['input']>;
  groupBy?: InputMaybe<AggregationGroupBy>;
  /** Reference ID filter (workpackId, structureId, etc.) */
  referenceIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  startDate?: InputMaybe<Scalars['String']['input']>;
  structureIds: Array<Scalars['ID']['input']>;
  /** IANA timezone identifier (e.g. 'America/New_York', 'Australia/Sydney') for date grouping */
  timezone: Scalars['String']['input'];
  /** Filter by workpack WBS (only applies when collectionName is 'workpacks') */
  wbs?: InputMaybe<WorkpackWbsFilterOption>;
  /** Filter by workpack types (only applies when collectionName is 'workpacks') */
  workpackTypes?: InputMaybe<Array<WorkpackTypeFilterOption>>;
};

export type AggregatedKpiLogEntriesPerDate = {
  __typename?: 'AggregatedKpiLogEntriesPerDate';
  endDate: Scalars['String']['output'];
  fieldTotals: Array<LogEntryLogFieldTotal>;
  fields: Array<AggregatedKpiLogEntryField>;
  logDate: Scalars['String']['output'];
  startDate: Scalars['String']['output'];
};

export type AggregatedKpiLogEntryField = {
  __typename?: 'AggregatedKpiLogEntryField';
  fieldKey: Scalars['String']['output'];
  value: Scalars['Float']['output'];
};

export type AggregatedKpiLogsPerDate = {
  __typename?: 'AggregatedKpiLogsPerDate';
  endDate: Scalars['String']['output'];
  fieldTotals: Array<WorkpackLogFieldTotal>;
  fields: Array<AggregatedKpiField>;
  logDate: Scalars['String']['output'];
  startDate: Scalars['String']['output'];
};

export type Aggregation = {
  __typename?: 'Aggregation';
  fieldKey: Scalars['String']['output'];
  operation: MathOperator;
  source: Scalars['String']['output'];
};

export enum AggregationGroupBy {
  Daily = 'DAILY',
  Monthly = 'MONTHLY',
  Quarterly = 'QUARTERLY',
  Weekly = 'WEEKLY',
  Yearly = 'YEARLY'
}

export type AggregationInput = {
  fieldKey: Scalars['String']['input'];
  operation: MathOperator;
  source: Scalars['String']['input'];
};

export type AggregratedKpiLogsInput = {
  endDate?: InputMaybe<Scalars['String']['input']>;
  groupBy?: InputMaybe<AggregationGroupBy>;
  startDate?: InputMaybe<Scalars['String']['input']>;
  structureIds: Array<Scalars['ID']['input']>;
  /** IANA timezone identifier (e.g. 'America/New_York', 'Australia/Sydney') for date grouping */
  timezone: Scalars['String']['input'];
  wbs?: InputMaybe<WorkpackWbsFilterOption>;
  workpackTypes?: InputMaybe<Array<WorkpackTypeFilterOption>>;
};

export type AlarmLevelRecommendation = {
  __typename?: 'AlarmLevelRecommendation';
  /** Any supplementary comments about the recommendation for this assembly from initial analysis by the reviewer */
  additionalComments?: Maybe<Scalars['String']['output']>;
  /** Recommended alarm level after analysis stage, valid values: see alarm levels enum */
  alarmLevel: AlarmLevels;
  /** Any supplementary comments about the recommendation for this assembly that is only relevant to the internal team */
  internalTeamComments?: Maybe<Scalars['String']['output']>;
  /**
   * User id of the user in charge of analysis/review/finalization of this assembly,
   * equivalent to user_id in Auth0 user profile and sub claim in the jwt
   */
  recommendationByUser?: Maybe<User>;
  /** User name of the user in charge of analysis/review/finalization of this assembly, */
  recommendationByUserName?: Maybe<Scalars['String']['output']>;
  /** Comment about the recommendation for this assembly from initial analysis from a standardised set of supporting comments */
  supportingComment?: Maybe<Scalars['String']['output']>;
  /** Whether the alarm level was manually updated for subjective reasons to override the alarm level that was automatically calculated based on governing value */
  wasAnalysisAlarmLevelManuallySet?: Maybe<Scalars['Boolean']['output']>;
};

export type AlarmLevelRecommendationInput = {
  additionalComments?: InputMaybe<Scalars['String']['input']>;
  alarmLevel: AlarmLevels;
  internalTeamComments?: InputMaybe<Scalars['String']['input']>;
  supportingComment?: InputMaybe<Scalars['String']['input']>;
};

export type AlarmLevelSummaryInput = {
  platformId?: InputMaybe<Scalars['ID']['input']>;
  structureIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type AlarmLevelSummaryResult = {
  __typename?: 'AlarmLevelSummaryResult';
  _id: Scalars['ID']['output'];
  structureId: Scalars['ID']['output'];
  structureName: Scalars['String']['output'];
  total: Array<TypeAndCount>;
};

export enum AlarmLevels {
  BorderlineLevel_1Or_2 = 'BORDERLINE_LEVEL_1_OR_2',
  Level_1 = 'LEVEL_1',
  Level_2 = 'LEVEL_2',
  Level_3 = 'LEVEL_3',
  None = 'NONE'
}

export type AllCommentsInput = {
  collectionName: Scalars['String']['input'];
  metadata?: InputMaybe<Scalars['JSON']['input']>;
  referenceId: Scalars['ID']['input'];
  structureId: Scalars['ID']['input'];
  type?: InputMaybe<Scalars['String']['input']>;
};

export type AllStructuresByRegion = {
  __typename?: 'AllStructuresByRegion';
  defectArea: Array<DefectArea>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  structures: Array<StructureWithDefects>;
};

export type Analysed = {
  __typename?: 'Analysed';
  /** User who analysed this Part */
  analysedBy: Scalars['ID']['output'];
  /** Last time this Part was analysed */
  updatedAt: Scalars['String']['output'];
};

export type Analytics = {
  __typename?: 'Analytics';
  /** Date this analytics record was created */
  createdAt: Scalars['String']['output'];
  /** Analytics data stored as JSON */
  data: Scalars['JSON']['output'];
  /** Display configuration metadata for graphs or views */
  displayConfig?: Maybe<Scalars['JSON']['output']>;
  /** Unique Analytics ID */
  id: Scalars['ID']['output'];
  /** Structures that this analytics data relates to */
  structureIds: Array<Scalars['ID']['output']>;
  /** Type of analytics data */
  type: Scalars['String']['output'];
  /** Date this analytics record was last updated */
  updatedAt: Scalars['String']['output'];
};

export type AnalyticsFiltersInput = {
  structureIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  type: Array<Scalars['String']['input']>;
};

export type Annotation = {
  __typename?: 'Annotation';
  /** Integer ID of this Annotation in point cloud */
  annotationId: Scalars['Int']['output'];
  /** Unique Annotation ID */
  id: Scalars['ID']['output'];
  /** Location that this Annotation belongs to */
  location: Location;
  locationId?: Maybe<Scalars['ID']['output']>;
  /** Overlap info related to part Annotation */
  overlapInfo?: Maybe<OverlapInfo>;
  /** Part that this Annotation belongs to */
  part?: Maybe<Part>;
  partId?: Maybe<Scalars['ID']['output']>;
  processingReferences?: Maybe<ProcessingReferences>;
  /** Structure that this Annotation belongs to */
  structure: Structure;
  structureId?: Maybe<Scalars['ID']['output']>;
  /** Assembly template that this Annotation is linked to */
  templateId: Template;
};

export type AnomalyCount = {
  __typename?: 'AnomalyCount';
  count?: Maybe<Scalars['Float']['output']>;
  key?: Maybe<Scalars['String']['output']>;
};

export type ArchivedPointOfInterestsResponse = {
  __typename?: 'ArchivedPointOfInterestsResponse';
  pois: Array<PointOfInterest>;
  totalCount: Scalars['Int']['output'];
};

export type AreaAndType = {
  __typename?: 'AreaAndType';
  type: Scalars['String']['output'];
  value: Scalars['Float']['output'];
};

export type AssembliesFilterInput = {
  assemblyIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  selectedDeckIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  selectedFilters?: InputMaybe<Array<InputMaybe<FiltersInput>>>;
  selectedPaintRegionIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  selectedTemplateFilters?: InputMaybe<Array<InputMaybe<FiltersInput>>>;
  selectedWorkpackIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  structureId: Scalars['ID']['input'];
  templateId: Scalars['ID']['input'];
  type?: InputMaybe<Scalars['String']['input']>;
};

/** An Assembly of Parts that facilitates some operation in the Structure. */
export type Assembly = {
  __typename?: 'Assembly';
  /**
   * Total surface area of the assembly in sq ft.
   * TODO: this should be deprecated, included in the templateFieldData
   */
  area?: Maybe<Scalars['Float']['output']>;
  /** Visibility Box of this Assembly */
  box?: Maybe<Box>;
  /**
   * Relative resource path to the cad model of the assembly.
   * Relative to structure.assemblyCadModelsBasePath
   */
  cadModelPath?: Maybe<Scalars['String']['output']>;
  /**
   * An alternative for focal point to define the camera position and point to look at (focal point) to view this assembly.
   * When a user selects an assembly the camera pose will be set to this value (position and look at point).
   */
  cameraPose?: Maybe<AssemblyCameraPose>;
  /**
   * Maximum corrosion level across all parts belonging to this assembly,
   * this aggregate value is stored here for convenience as it is a frequently queried value when filtering assemblies,
   * valid values: HEAVY, MODERATE, LIGHT, CLEAN
   * TODO: this should be deprecated, included in the templateFieldData
   */
  corrosionLevel?: Maybe<Scalars['String']['output']>;
  /** Date this Assembly was created */
  createdAt: Scalars['String']['output'];
  /**
   * Deck detail of assembly. A single assembly can be a part of multiple decks.
   * decks would contain the deckId in which this assembly exist and area that assembly occupied on that deck.
   */
  decks?: Maybe<Array<Maybe<DecksDetails>>>;
  /** Files attached to assembly */
  files?: Maybe<Array<File>>;
  /**
   * This is used to help a user focus on a selected assembly as they navigate around the spatial viewer.
   * When a user selects an assembly the camera will look at this point.
   * This is superseded if cameraPose it defined.
   */
  focalPoint?: Maybe<Vector3>;
  /** General note for all Attachments */
  generalAttachmentsNote?: Maybe<Scalars['String']['output']>;
  /** Unique Assembly ID */
  id: Scalars['ID']['output'];
  /** Integer ID of this Assembly in point cloud data */
  integerId?: Maybe<Scalars['Int']['output']>;
  /**
   * If the assembly is newly added by the admin than this flag would
   * be set to true.
   *
   * This  boolean can be used to differentiate between the predefined
   * assembly from newly added assembly
   */
  isNewlyAdded?: Maybe<Scalars['Boolean']['output']>;
  /** A boolean for whether the assembly is contextualized or not. This will be true if assembly is made manually */
  isUncontextualized?: Maybe<Scalars['Boolean']['output']>;
  /** Auth0 ID of the user who last updated this assembly */
  lastModifiedBy?: Maybe<Scalars['String']['output']>;
  /** Timestamp for the last update made from the API */
  lastModifiedByAPI?: Maybe<Scalars['String']['output']>;
  /** User who made the last update */
  lastModifiedByUser?: Maybe<User>;
  /** Reason for the last update */
  lastModifiedFor?: Maybe<Scalars['String']['output']>;
  /** Tagname that is fixed via some process, e.g. Fabric line fixing or manual by Linears */
  originalTagname?: Maybe<Scalars['String']['output']>;
  /**
   * Pipe specification related to this assembly, used for calculating the effect of corrosion on this assembly and
   * Abyss' subsequent recommendation
   * TODO: this should be deprecated, included in the templateFieldData
   */
  pipeSpec?: Maybe<PipeSpec>;
  /** Counts of Point of Interests by type associated with this assembly (virtual field) */
  poiCounts?: Maybe<Array<PoiTypeCount>>;
  /**
   * Abyss' recommendations for this particular assembly,
   * currently just one recommendation object per assembly because "structure" currently means scan/deployment,
   * and there would only be one recommendation per scan/deployment
   */
  recommendation?: Maybe<Recommendation>;
  /**
   * All the viewpoints that can see any portion of this assembly,
   * calculated from viewpoints that can see parts belonging to this assembly, stored here for convenience
   */
  seenByViewpoints?: Maybe<Array<SeenByViewpoint>>;
  /**
   * Service that this piece of equipment provides, for oil & gas this the content of an assembly
   * e.g. fuel gas, sewage water. This helps priorities assemblies for analysis and reporting
   * TODO: this should be deprecated, included in the templateFieldData
   */
  service?: Maybe<Service>;
  /** Identifier for the Structure that this Assembly belongs to */
  structure: Structure;
  /**
   * Super category of the assembly
   * TODO: this should be deprecated, included in the templateFieldData
   */
  superCategory?: Maybe<Scalars['String']['output']>;
  /** User readable identifier for the Assembly */
  tagName: Scalars['String']['output'];
  /** Template related to this assembly for dynamic data */
  template: Template;
  /** Data values from template for this assembly */
  templateFieldData?: Maybe<Scalars['JSON']['output']>;
  /** Date this Assembly was last updated */
  updatedAt: Scalars['String']['output'];
};

export type AssemblyCameraPose = {
  __typename?: 'AssemblyCameraPose';
  lookAt: Vector3;
  position: Vector3;
};

export type AssemblyDataForTableInput = {
  assemblyData?: InputMaybe<Scalars['JSON']['input']>;
  templateFieldData: Scalars['JSON']['input'];
};

export type AssemblyImageCaptionInput = {
  assemblyAttachmentId: Scalars['String']['input'];
  assemblyId: Scalars['ID']['input'];
  caption: Scalars['String']['input'];
  lastModifiedFor: Scalars['String']['input'];
  uuid?: InputMaybe<Scalars['String']['input']>;
};

export type AssemblyPaintRegion = {
  __typename?: 'AssemblyPaintRegion';
  /** Total remediation area entered by user (sqft) - may exceed total area, stored for record-keeping */
  actualTotalRemediatedArea?: Maybe<Scalars['Float']['output']>;
  /** Assembly that this Paint Block belongs to */
  assembly?: Maybe<Assembly>;
  assemblyId?: Maybe<Scalars['ID']['output']>;
  /** Date this Paint Block was created */
  createdAt: Scalars['String']['output'];
  /** Deck that this Paint Region belongs to */
  deck?: Maybe<Deck>;
  deckId?: Maybe<Scalars['ID']['output']>;
  /** Unique Paint Block ID */
  id: Scalars['ID']['output'];
  /** Date when last modified via API */
  lastModifiedByAPI?: Maybe<Scalars['String']['output']>;
  /** User who made the last update */
  lastModifiedByUser?: Maybe<User>;
  /** Reason for the last modification */
  lastModifiedFor?: Maybe<Scalars['String']['output']>;
  /** Paint Region that this paint block data belongs to */
  paintRegion?: Maybe<PaintRegion>;
  /** Paint region group that this paint block belongs to */
  paintRegionGroup?: Maybe<PaintRegionGroup>;
  paintRegionGroupId?: Maybe<Scalars['ID']['output']>;
  paintRegionId?: Maybe<Scalars['ID']['output']>;
  /** POI type based count maintaining key-value pairs as JSON */
  poiTypeCount?: Maybe<Scalars['JSON']['output']>;
  /** Date when remediation is planned or completed */
  remediationAt?: Maybe<Scalars['String']['output']>;
  /** Remediated area by Ri type (sqft) - used for calculations (capped at remaining area) */
  remediationByRi?: Maybe<Scalars['JSON']['output']>;
  /** Risk remediation score configuration */
  riskRemediationScore?: Maybe<RiskRemediationScore>;
  /** Status of the Assembly Paint Region */
  status?: Maybe<PaintRegionStatus>;
  /** Identifier for the Structure that this Paint Block belongs to */
  structure?: Maybe<Structure>;
  structureId?: Maybe<Scalars['ID']['output']>;
  /** Template related to this paint block for dynamic data */
  template?: Maybe<Template>;
  /** Data values from template for this paint block */
  templateData?: Maybe<Array<TemplateData>>;
  templateFieldData?: Maybe<Scalars['JSON']['output']>;
  templateId?: Maybe<Scalars['ID']['output']>;
  uncalibratedTemplateFieldData?: Maybe<Scalars['JSON']['output']>;
  /** Date this Paint Block was last updated */
  updatedAt: Scalars['String']['output'];
};

export type AssemblySummary = {
  __typename?: 'AssemblySummary';
  data?: Maybe<Scalars['JSON']['output']>;
  displayConfig?: Maybe<Array<DisplaySettings>>;
  displayType: DisplayType;
  id: Scalars['ID']['output'];
  key?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  operation: Scalars['String']['output'];
  rowOrder: Scalars['Int']['output'];
};

export type AssemblyTagNameAdded = {
  __typename?: 'AssemblyTagNameAdded';
  id: Scalars['ID']['output'];
  isNewlyAdded: Scalars['Boolean']['output'];
  structureId: Scalars['ID']['output'];
  tagName: Scalars['String']['output'];
};

export type AssemblyTemplateField = TemplateField & {
  __typename?: 'AssemblyTemplateField';
  /** Logic engine expression to evaluate the equation key used for calculating the field value */
  calculatedBy?: Maybe<LogicEvaluationRule>;
  /** Should this field be visible on first load inside a list or table */
  defaultVisible?: Maybe<Scalars['Boolean']['output']>;
  /** Dependent field keys */
  dependencyMapping?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Key of field which has additional data for this field */
  detailFieldKey?: Maybe<Scalars['String']['output']>;
  /** Table configuration */
  displayConfig?: Maybe<DisplayConfig>;
  /** Identify if field should be shown in the query tab */
  displayInQuery?: Maybe<Scalars['Boolean']['output']>;
  /** Should this field be displayed in report filters */
  displayInReportFilters?: Maybe<Scalars['Boolean']['output']>;
  /** Should this field be displayed in report */
  displayInReports?: Maybe<Scalars['Boolean']['output']>;
  /** Should this field be visible in review */
  displayInReview?: Maybe<Scalars['Boolean']['output']>;
  /** Identify if field should be shown in the risk assessment tab */
  displayInRisk?: Maybe<Scalars['Boolean']['output']>;
  /** Identify if field should be shown in the equipment table */
  displayInTable?: Maybe<Scalars['Boolean']['output']>;
  /** Unit to display the actual value in */
  displayUnit?: Maybe<UnitsEnum>;
  /** Roles that the user needs to have to edit template data */
  editRoles?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** To enable edit for component table */
  enableInlineEdit?: Maybe<Scalars['Boolean']['output']>;
  /** Unique Template Field ID */
  id: Scalars['ID']['output'];
  /** Specifies if field allows editing or not */
  isEditable?: Maybe<Scalars['Boolean']['output']>;
  /** Identify if a risk field can be exported */
  isExportable?: Maybe<Scalars['Boolean']['output']>;
  /** Should not be shown in the UI. Used for identifying certain fields */
  isHidden?: Maybe<Scalars['Boolean']['output']>;
  /** Is this Template Field read-only; i.e. value cannot be updated */
  isReadOnly: Scalars['Boolean']['output'];
  /** Is this Template Field always required */
  isRequired: Scalars['Boolean']['output'];
  /** Should not be shown in the UI. Used for identifying risk assessment filters */
  isRiskAssessment?: Maybe<Scalars['Boolean']['output']>;
  /** Key to identify field in the risk fields */
  key?: Maybe<Scalars['String']['output']>;
  /** Logic engine expression to evaluate the field value */
  logicRule?: Maybe<LogicEvaluationRule>;
  metaData?: Maybe<Scalars['JSON']['output']>;
  /** Name of this Template Field */
  name: Scalars['String']['output'];
  /** Valid options for this Template Field value */
  options: Array<Scalars['String']['output']>;
  /** Details of valid options for this Template Field value */
  optionsData?: Maybe<Array<OptionData>>;
  /** Type of permission that a user have to read the template */
  permission?: Maybe<Scalars['String']['output']>;
  /** Identify fixed decimal place */
  roundToDecimal?: Maybe<Scalars['Int']['output']>;
  /** Should the template options be fetched from the server on runtime */
  serverSide: Scalars['Boolean']['output'];
  /** Identify if field's value should be evaluated using the logic engine */
  shouldEvaluateLogic?: Maybe<Scalars['Boolean']['output']>;
  /** Identify if field's value should be evaluated using the logic engine after the math engine */
  shouldEvaluateLogicPostCalculation?: Maybe<Scalars['Boolean']['output']>;
  /** Identify if field's value should be evaluated using the math engine */
  shouldEvaluateMath?: Maybe<Scalars['Boolean']['output']>;
  /** Type of this Template Field */
  type: TemplateFieldTypeEnum;
  /** Identity about the unit of the field */
  unit?: Maybe<UnitsEnum>;
};

export type AssemblyTemplateFieldDataInput = {
  tagName: Scalars['String']['input'];
  templateFieldData: Array<TemplateFieldDataValues>;
};

export type AssemblyUpdatedEventResult = {
  __typename?: 'AssemblyUpdatedEventResult';
  id: Scalars['String']['output'];
  structureId: Scalars['String']['output'];
  templateFieldData?: Maybe<Array<Scalars['JSON']['output']>>;
  templateId: Scalars['String']['output'];
};

export type AssessmentDetailOptionFieldSchema = {
  __typename?: 'AssessmentDetailOptionFieldSchema';
  editRoles: Array<Maybe<Scalars['String']['output']>>;
  /** Unique human-readable key. It should be same as field key in template */
  fieldKey: Scalars['String']['output'];
  /** Unique Assessment Detail Field */
  id: Scalars['ID']['output'];
  isEditable: Scalars['Boolean']['output'];
  /** Name associated for the Assessment Detail option field */
  name: Scalars['String']['output'];
  /** Type associated with the Equipment option field */
  type: OptionFieldTypeEnum;
};

export type AssessmentDetails = {
  __typename?: 'AssessmentDetails';
  /** Unique Assessment Detail Section ID */
  id: Scalars['ID']['output'];
  /** Is this Assessment Detail Section visible */
  isVisible: Scalars['Boolean']['output'];
  /** Name of this Assessment Detail Section */
  name: Scalars['String']['output'];
  /** Valid options for this Assessment Details Section */
  options: Array<AssessmentDetailOptionFieldSchema>;
  /** Order of the Assessment Details Section */
  position: Scalars['Int']['output'];
  /** Type of this Assessment Detail Section */
  type: Scalars['String']['output'];
};

export type AssessmentDetailsInput = {
  structureId: Scalars['ID']['input'];
  templateId: Scalars['ID']['input'];
  type: Scalars['String']['input'];
};

export type AssignRemoveRoleToFromUsersInput = {
  roleId: Scalars['ID']['input'];
  userIds: Array<Scalars['ID']['input']>;
};

export type Auth0UserRoles = {
  __typename?: 'Auth0UserRoles';
  auth0Id?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  permissions?: Maybe<Array<Maybe<Permission>>>;
};

/** Batch represents a processing result. */
export type Batch = {
  __typename?: 'Batch';
  /** Path to archive file in the bucket */
  archivePath?: Maybe<Scalars['String']['output']>;
  /** List of defects for processing to detect */
  defects?: Maybe<Array<Scalars['String']['output']>>;
  /** Unique batch ID */
  id: Scalars['ID']['output'];
  /** List of images in this batch */
  images: Array<Scalars['String']['output']>;
  /** Last time we received the notification of this batch completion */
  lastCompletedAt?: Maybe<Scalars['String']['output']>;
  /** Last time processing of the batch was completed */
  lastProcessedAt?: Maybe<Scalars['String']['output']>;
  /** Last time pull was requested for this batch */
  lastPullRequestedAt?: Maybe<Scalars['String']['output']>;
  /** Last time the batch was ready for processing */
  lastReadyToProcessAt?: Maybe<Scalars['String']['output']>;
  /** Metadata for this batch */
  metadata?: Maybe<Scalars['JSON']['output']>;
  /** Processing id received from the client application */
  processingId?: Maybe<Scalars['String']['output']>;
  /** Status of this batch */
  status?: Maybe<BatchStatus>;
  /** Structure that this batch belongs to */
  structureId: Scalars['ObjectId']['output'];
};

export enum BatchStatus {
  Completed = 'COMPLETED',
  Created = 'CREATED',
  Processed = 'PROCESSED',
  PullRequested = 'PULL_REQUESTED',
  ReadyToProcess = 'READY_TO_PROCESS'
}

export type BenchmarkDownloadInput = {
  size: Scalars['Int']['input'];
};

export type BenchmarkDownloadOutput = {
  __typename?: 'BenchmarkDownloadOutput';
  data: Scalars['String']['output'];
};

export type BenchmarkUploadInput = {
  data: Scalars['String']['input'];
};

/** Benchmark provides API to upload and download data for network benchmark. */
export type BenchmarkUploadOutput = {
  __typename?: 'BenchmarkUploadOutput';
  size: Scalars['Int']['output'];
};

export type Blister = {
  __typename?: 'Blister';
  /** Angle of the defect from the camera location (in degrees) */
  angle?: Maybe<Scalars['Float']['output']>;
  /** Manual blister height index for highlight exact point on blister profile */
  blisterHeightIndex?: Maybe<Scalars['Int']['output']>;
  /**
   * Borders that make up the polygon where the blister was measured from
   * - specifically for display within a spherical image viewpoint
   */
  borders: Array<Maybe<PolarPoint>>;
  /**
   * 3d Borders consisting of one or more polygons of the area where the blister was
   * measured from in 3d space. Multiple polygons may be returned, for example when
   * the blister surface is obstructed by a separate pipe in the foreground of the
   * depth image
   */
  borders3d: Array<Polygon3d>;
  /** Blister center (texture coordinates, see convertImagePointsToPolarPoints) */
  centerPoint: PolarPoint;
  /** Defect Id */
  defectId?: Maybe<Scalars['Int']['output']>;
  /** Degree of rusting */
  degreeOfRusting?: Maybe<Scalars['Int']['output']>;
  /** Distance of the defect from the camera location (in meters) */
  distance?: Maybe<Scalars['Float']['output']>;
  /** Confidence level based on distance from scanner */
  distanceConfidence?: Maybe<Scalars['String']['output']>;
  /** Estimated height of the blister (in millimetres) */
  estimatedHeight: Scalars['Float']['output'];
  /**
   * Radius used for fitting, this is a larger area around the blister so that
   * there is more flat surface for us to figure out the actual surface of the
   * object, currently defaults to a ratio of 1.33x blister radius (in millimetres)
   */
  fittingRadius: Scalars['Float']['output'];
  /** Height type */
  heightType?: Maybe<BlisterHeightType>;
  /** Flag to indicate if the System height type is manually overridden */
  isManuallyOverridden?: Maybe<Scalars['Boolean']['output']>;
  /** Manually set height of the blister (in millimetres) */
  manualSetHeight?: Maybe<Scalars['Float']['output']>;
  /** Maximum height of the blister (in millimetres) */
  maxHeight?: Maybe<Scalars['Float']['output']>;
  /** Overall measurement confidence (distance, angle, pipe size) */
  measurementConfidence?: Maybe<Scalars['String']['output']>;
  /** PDR height of the blister (in millimetres) */
  pdrHeight?: Maybe<Scalars['Float']['output']>;
  /** Radius calculated based on centerPoint and radiusPoint (in millimetres) */
  radius: Scalars['Float']['output'];
  /** Radius of a blister is measured from blister center to this point (texture coordinates) */
  radiusPoint: PolarPoint;
  /**  Residual corrosion allowance */
  residualCorrosionAllowance?: Maybe<ValueAndPercentage>;
  /** Residual thickness */
  residualThickness?: Maybe<ValueAndPercentage>;
  /** SC Category of Blister */
  scCategory?: Maybe<Scalars['String']['output']>;
  /** URL */
  url?: Maybe<Scalars['String']['output']>;
  /** Verified maximum blister height */
  verifiedMaxHeight?: Maybe<Scalars['String']['output']>;
  /** Verified Residual Thickness */
  verifiedResidualThickness?: Maybe<Scalars['String']['output']>;
  /** Wall loss */
  wallLoss?: Maybe<ValueAndPercentage>;
};

export type BlisterFieldsConfig = {
  __typename?: 'BlisterFieldsConfig';
  blisterHeightIndex?: Maybe<FieldDetails>;
  distanceConfidence?: Maybe<FieldDetails>;
  estimatedHeight?: Maybe<FieldDetails>;
  heightType?: Maybe<FieldDetails>;
  manualSetHeight?: Maybe<FieldDetails>;
  maxHeight?: Maybe<FieldDetails>;
  measurementConfidence?: Maybe<FieldDetails>;
  pdrHeight?: Maybe<FieldDetails>;
  residualCorrosionAllowance?: Maybe<FieldDetails>;
  residualThickness?: Maybe<FieldDetails>;
  verifiedMaxHeight?: Maybe<FieldDetails>;
  verifiedResidualCorrosionAllowance?: Maybe<FieldDetails>;
  verifiedResidualThickness?: Maybe<FieldDetails>;
  wallLoss?: Maybe<FieldDetails>;
};

export type BlisterFieldsConfigInput = {
  blisterHeightIndex?: InputMaybe<FieldDetailsInput>;
  distanceConfidence?: InputMaybe<FieldDetailsInput>;
  estimatedHeight?: InputMaybe<FieldDetailsInput>;
  heightType?: InputMaybe<FieldDetailsInput>;
  manualSetHeight?: InputMaybe<FieldDetailsInput>;
  maxHeight?: InputMaybe<FieldDetailsInput>;
  measurementConfidence?: InputMaybe<FieldDetailsInput>;
  pdrHeight?: InputMaybe<FieldDetailsInput>;
  residualCorrosionAllowance?: InputMaybe<FieldDetailsInput>;
  residualThickness?: InputMaybe<FieldDetailsInput>;
  verifiedMaxHeight?: InputMaybe<FieldDetailsInput>;
  verifiedResidualCorrosionAllowance?: InputMaybe<FieldDetailsInput>;
  verifiedResidualThickness?: InputMaybe<FieldDetailsInput>;
  wallLoss?: InputMaybe<FieldDetailsInput>;
};

export type BlisterHeightMeasurement = {
  __typename?: 'BlisterHeightMeasurement';
  /** Blister height measurements */
  blister: BlisterHeightMeasurementResult;
  /** Signed URL of Location depth image used to calculate line distance */
  id: Scalars['String']['output'];
  /** Blister height measurements API status */
  status: MeasurementStatus;
};

export type BlisterHeightMeasurementResult = {
  __typename?: 'BlisterHeightMeasurementResult';
  blisterProfilePlotPoints: Array<BlisterProfilePlotPoint>;
  borders3d: Array<Polygon3d>;
  centerPoint3d: Vector3;
  fittedSurfacePoints: Array<Point>;
  /** The max difference from the estimated height in metres */
  maxHeight: Scalars['Float']['output'];
};

export enum BlisterHeightType {
  BlisterTool = 'BLISTER_TOOL',
  Manual = 'MANUAL',
  Pdr = 'PDR',
  Uncertain = 'UNCERTAIN'
}

export type BlisterInput = {
  /** Angle of the defect from the camera location (in degrees) */
  angle?: InputMaybe<Scalars['Float']['input']>;
  /** Manual blister height index for highlight exact point on blister profile */
  blisterHeightIndex?: InputMaybe<Scalars['Int']['input']>;
  /**
   * Borders that make up the polygon where the blister was measured from
   * - specifically for display within a spherical image viewpoint
   */
  borders: Array<InputMaybe<PolarPointInput>>;
  /**
   * 3d Borders consisting of one or more polygons of the area where the blister was
   * measured from in 3d space. Multiple polygons may be returned, for example when
   * the blister surface is obstructed by a separate pipe in the foreground of the
   * depth image
   */
  borders3d: Array<Polygon3dInput>;
  /** Blister center */
  centerPoint: PolarPointInput;
  /** Defect Id */
  defectId?: InputMaybe<Scalars['Int']['input']>;
  /** Degree of rusting */
  degreeOfRusting?: InputMaybe<Scalars['Int']['input']>;
  /** Distance of the defect from the camera location (in meters) */
  distance?: InputMaybe<Scalars['Float']['input']>;
  /** Confidence level based on distance from scanner */
  distanceConfidence?: InputMaybe<Scalars['String']['input']>;
  /** Estimated height of the blister (in millimetres) */
  estimatedHeight?: InputMaybe<Scalars['Float']['input']>;
  /**
   * Radius used for fitting, this is a larger area around the blister so that
   * there is more flat surface for us to figure out the actual surface of the
   * object, currently defaults to a ratio of 1.33x blister radius (in millimetres)
   */
  fittingRadius: Scalars['Float']['input'];
  /** Height type */
  heightType?: InputMaybe<BlisterHeightType>;
  /** Flag to indicate if the System height type is manually overridden */
  isManuallyOverridden?: InputMaybe<Scalars['Boolean']['input']>;
  /** Manually set height of the blister (in millimetres) */
  manualSetHeight?: InputMaybe<Scalars['Float']['input']>;
  /** Maximum height of the blister (in millimetres) */
  maxHeight?: InputMaybe<Scalars['Float']['input']>;
  /** Overall measurement confidence (distance, angle, pipe size) */
  measurementConfidence?: InputMaybe<Scalars['String']['input']>;
  /** PDR height of the blister (in millimetres) */
  pdrHeight?: InputMaybe<Scalars['Float']['input']>;
  /** Radius calculated based on centerPoint and radiusPoint (in millimetres) */
  radius: Scalars['Float']['input'];
  /** Radius of a blister is measured from blister center to this point */
  radiusPoint: PolarPointInput;
  /**  Residual corrosion allowance */
  residualCorrosionAllowance?: InputMaybe<ValueAndPercentageInput>;
  /** Residual thickness */
  residualThickness?: InputMaybe<ValueAndPercentageInput>;
  /** SC Category of Blister */
  scCategory?: InputMaybe<Scalars['String']['input']>;
  /** URL */
  url?: InputMaybe<Scalars['String']['input']>;
  /** Verified maximum blister height */
  verifiedMaxHeight?: InputMaybe<Scalars['String']['input']>;
  /** Verified Residual Thickness */
  verifiedResidualThickness?: InputMaybe<Scalars['String']['input']>;
  /** Wall loss */
  wallLoss?: InputMaybe<ValueAndPercentageInput>;
};

export type BlisterMeasurementInput = {
  centerPoint: ImagePointInput;
  edgePoint: ImagePointInput;
};

export type BlisterProfilePlotPoint = {
  __typename?: 'BlisterProfilePlotPoint';
  /** Distance from the estimated height in metres */
  height: Scalars['Float']['output'];
  x: Scalars['Float']['output'];
  y: Scalars['Float']['output'];
  z: Scalars['Float']['output'];
};

export type BoundingBoxInput = {
  max: CenterPoint;
  min: CenterPoint;
};

export type Box = {
  __typename?: 'Box';
  /** Max Vector3 point of this Box */
  max: Vector3;
  /** Min Vector3 point of this Box */
  min: Vector3;
};

export type BulkArchiveResponse = {
  __typename?: 'BulkArchiveResponse';
  count: Scalars['Int']['output'];
};

export type BulkCreateForAssembliesInput = {
  clearPreviousComments?: InputMaybe<Scalars['Boolean']['input']>;
  collectionName: Scalars['String']['input'];
  comments: Array<CommentFieldsInput>;
  excludedAssemblyIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  referenceIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  searchText?: InputMaybe<Scalars['String']['input']>;
  selectedFilters?: InputMaybe<Array<InputMaybe<RiskAssessmentSelectedFiltersInput>>>;
  structureId: Scalars['ID']['input'];
  updateAllAssemblies: Scalars['Boolean']['input'];
};

export type BulkCreateOrUpdateCommentsForAssemblies = {
  __typename?: 'BulkCreateOrUpdateCommentsForAssemblies';
  insertedCount: Scalars['Float']['output'];
  modifiedCount: Scalars['Float']['output'];
  upsertedCount: Scalars['Float']['output'];
};

export type BulkLineFixingInput = {
  csv: Scalars['String']['input'];
  structureId: Scalars['ID']['input'];
};

export type BulkLineFixingResult = {
  __typename?: 'BulkLineFixingResult';
  message: Scalars['String']['output'];
  updatedCount: Scalars['Int']['output'];
};

export type BulkPipeSpecUploadInput = {
  csv: Scalars['String']['input'];
  structureId: Scalars['ID']['input'];
  validateOnly?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BulkPipeSpecUploadResponse = {
  __typename?: 'BulkPipeSpecUploadResponse';
  message: Scalars['String']['output'];
  onlyValidated: Scalars['Boolean']['output'];
  updatedCount: Scalars['Int']['output'];
};

export type BulkServiceGroupsResponse = {
  __typename?: 'BulkServiceGroupsResponse';
  message: Scalars['String']['output'];
  updatedCount: Scalars['Int']['output'];
};

export type BulkUpdateReviewActionInput = {
  accessibility?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  action: Scalars['String']['input'];
  baseUrl?: InputMaybe<Scalars['String']['input']>;
  componentIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  deckRelativeHeight?: InputMaybe<Array<InputMaybe<RangeInput>>>;
  excludePoisWithWorkpack?: InputMaybe<Scalars['Boolean']['input']>;
  includeManuallyCreated?: InputMaybe<Scalars['Boolean']['input']>;
  isGoverning?: InputMaybe<Array<InputMaybe<Scalars['Boolean']['input']>>>;
  isManuallyCreated?: InputMaybe<Array<InputMaybe<Scalars['Boolean']['input']>>>;
  isVerified?: InputMaybe<Array<InputMaybe<Scalars['Boolean']['input']>>>;
  mediaAttachment?: InputMaybe<Array<InputMaybe<Scalars['Boolean']['input']>>>;
  paintRegionIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  paintRegionNames?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  partId?: InputMaybe<Scalars['ID']['input']>;
  pointOfInterestIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  priorityFieldKeys?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  searchTerm?: InputMaybe<Scalars['String']['input']>;
  selectedDeckIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  selectedPoiFilters?: InputMaybe<Array<InputMaybe<FiltersInput>>>;
  selectedTemplateFilters?: InputMaybe<Array<InputMaybe<FiltersInput>>>;
  status?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  structureId: Scalars['ID']['input'];
  templateId?: InputMaybe<Scalars['ID']['input']>;
  unAssignedPoi?: InputMaybe<Array<InputMaybe<Scalars['Boolean']['input']>>>;
  workpackId?: InputMaybe<Scalars['ID']['input']>;
  workpackIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
};

export type BulkUpdateReviewActionResponse = {
  __typename?: 'BulkUpdateReviewActionResponse';
  count?: Maybe<Scalars['Int']['output']>;
};

export type BulkUploadPoisInput = {
  assemblyTemplateId: Scalars['ID']['input'];
  csv: Scalars['String']['input'];
  poiType: Scalars['String']['input'];
  structureId: Scalars['ID']['input'];
  unitSystem: UnitSystemEnum;
};

export type BulkUploadServiceGroupsInput = {
  csv: Scalars['String']['input'];
  structureId: Scalars['ID']['input'];
  validateOnly?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CalculatedToActualPofInput = {
  actualValue: Scalars['String']['input'];
  calculatedValue: Scalars['Float']['input'];
};

export enum CalculationType {
  Base = 'BASE',
  Breasting = 'BREASTING',
  FenderPanelFacing = 'FENDER_PANEL_FACING',
  FenderPanelFraming = 'FENDER_PANEL_FRAMING',
  Loading = 'LOADING',
  Mooring = 'MOORING',
  RubberFender = 'RUBBER_FENDER'
}

export type Calculations = {
  __typename?: 'Calculations';
  cof: Scalars['Float']['output'];
  pof: Scalars['Float']['output'];
  total: Scalars['Float']['output'];
  transitionPeriod: Scalars['Float']['output'];
};

export type Card = {
  __typename?: 'Card';
  icon?: Maybe<Scalars['String']['output']>;
  key: Scalars['String']['output'];
  roundToDecimal?: Maybe<Scalars['Int']['output']>;
  subtitle?: Maybe<Subtitle>;
  title?: Maybe<Scalars['String']['output']>;
  unit?: Maybe<SectionUnitsEnum>;
  unitPosition?: Maybe<UnitPositionEnum>;
  value?: Maybe<Scalars['Float']['output']>;
};

export type CardConfig = {
  __typename?: 'CardConfig';
  aggregation?: Maybe<Aggregation>;
  equationKey?: Maybe<Scalars['String']['output']>;
  icon?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  key: Scalars['String']['output'];
  order: Scalars['Int']['output'];
  roundToDecimal?: Maybe<Scalars['Int']['output']>;
  subtitleConfig?: Maybe<SubtitleConfig>;
  title?: Maybe<Scalars['String']['output']>;
  unit?: Maybe<SectionUnitsEnum>;
  unitPosition?: Maybe<UnitPositionEnum>;
};

export type CardConfigInput = {
  aggregation?: InputMaybe<AggregationInput>;
  equationKey?: InputMaybe<Scalars['String']['input']>;
  icon?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  key: Scalars['String']['input'];
  order: Scalars['Int']['input'];
  roundToDecimal?: InputMaybe<Scalars['Int']['input']>;
  subtitleConfig?: InputMaybe<SubtitleConfigInput>;
  title?: InputMaybe<Scalars['String']['input']>;
  unit?: InputMaybe<SectionUnitsEnum>;
  unitPosition?: InputMaybe<UnitPositionEnum>;
};

export type CardInsights = {
  __typename?: 'CardInsights';
  color?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  type: Scalars['String']['output'];
  value: Scalars['StringFloatInt']['output'];
  visible?: Maybe<Scalars['Boolean']['output']>;
};

export type CenterPoint = {
  x: Scalars['Float']['input'];
  y: Scalars['Float']['input'];
  z: Scalars['Float']['input'];
};

/**
 * Client of Abyss Solutions.
 *
 * Clients own the Structures whose conditions are being assessed using automated ML technologies by Abyss Solutions.
 */
export type Client = {
  __typename?: 'Client';
  /**
   * Configuration at a customer level, this will be the
   * default configuration for all structures for this customer
   */
  config?: Maybe<Config>;
  /** Date this Client was created */
  createdAt: Scalars['String']['output'];
  /** Unique Client ID */
  id: Scalars['ID']['output'];
  /** Relative file path to logo for Client */
  logoPath?: Maybe<Scalars['String']['output']>;
  /** Client company name */
  name: Scalars['String']['output'];
  /** Date this Client was last updated */
  updatedAt: Scalars['String']['output'];
};

export type Comment = {
  __typename?: 'Comment';
  /** Name of MongoDB Collection where Reference Document resides */
  collectionName: Scalars['String']['output'];
  /** Date this Comment was created */
  createdAt: Scalars['String']['output'];
  /** Auth0 ID of user who created this Comment */
  createdBy: Scalars['String']['output'];
  /** Details of User who created this Comment */
  createdByDetails: CreatedByDetails;
  /** Details of User who created this comment */
  createdByUser: User;
  /** Date this Comment was deleted - for soft delete */
  deletedAt?: Maybe<Scalars['String']['output']>;
  /** Unique Comment ID */
  id: Scalars['ID']['output'];
  /** Check if this Comment has been edited */
  isEdited: Scalars['Boolean']['output'];
  /** To identtify with which field this comments is linked */
  key?: Maybe<Scalars['String']['output']>;
  /** Untyped key-value metadata associated with this Comment */
  metadata?: Maybe<Scalars['JSON']['output']>;
  /** Status of the linked zone */
  status?: Maybe<ZoneStatus>;
  /** Structure that this Comment belongs to  */
  structureId: Scalars['ObjectId']['output'];
  /** Text content of the Comment */
  text: Scalars['String']['output'];
  /** Title content of the Comment */
  title?: Maybe<Scalars['String']['output']>;
  /** Type of comment belongs to i.e COF, POF etc */
  type?: Maybe<Scalars['String']['output']>;
  /** Date this Comment was last updated */
  updatedAt: Scalars['String']['output'];
};

export type CommentFieldsInput = {
  key: Scalars['String']['input'];
  text: Scalars['String']['input'];
  title: Scalars['String']['input'];
  type: Scalars['String']['input'];
};

export type ComplexPrismVolume = {
  __typename?: 'ComplexPrismVolume';
  /** Optional exclusion volumes */
  exclusions?: Maybe<Array<PrismVolume>>;
  /** Main volume defines inclusion volume */
  inclusion: PrismVolume;
};

export type ComplexPrismVolumeInput = {
  /** Optional exclusion volumes */
  exclusions?: InputMaybe<Array<PrismVolumeInput>>;
  /** Main volume defines inclusion volume */
  inclusion: PrismVolumeInput;
};

export type ConditionNode = {
  __typename?: 'ConditionNode';
  /** For GROUP nodes, the child conditions */
  conditions?: Maybe<Array<ConditionNode>>;
  /** For SIMPLE nodes, the field to check */
  inputVariable?: Maybe<Scalars['String']['output']>;
  /** For GROUP nodes, the logical operator to combine child conditions */
  logicOperator?: Maybe<LogicOperator>;
  /** Type of this node (SIMPLE for leaf nodes, GROUP for logical group nodes) */
  nodeType: ConditionNodeType;
  /** For SIMPLE nodes, the comparison operator */
  operator?: Maybe<ConditionOperator>;
  /** For SIMPLE nodes, the value to compare against */
  value?: Maybe<Scalars['String']['output']>;
};

export type ConditionNodeInput = {
  /** For GROUP nodes, the child conditions */
  conditions?: InputMaybe<Array<ConditionNodeInput>>;
  /** For SIMPLE nodes, the field to check */
  inputVariable?: InputMaybe<Scalars['String']['input']>;
  /** For GROUP nodes, the logical operator to combine child conditions */
  logicOperator?: InputMaybe<LogicOperator>;
  /** Type of this node (SIMPLE for leaf nodes, GROUP for logical group nodes) */
  nodeType: ConditionNodeType;
  /** For SIMPLE nodes, the comparison operator */
  operator?: InputMaybe<ConditionOperator>;
  /** For SIMPLE nodes, the value to compare against */
  value?: InputMaybe<Scalars['String']['input']>;
};

export enum ConditionNodeType {
  Group = 'GROUP',
  Simple = 'SIMPLE'
}

export enum ConditionOperator {
  Equal = 'EQUAL',
  GreaterThan = 'GREATER_THAN',
  GreaterThanOrEqual = 'GREATER_THAN_OR_EQUAL',
  LessThan = 'LESS_THAN',
  LessThanOrEqual = 'LESS_THAN_OR_EQUAL',
  NotEqual = 'NOT_EQUAL'
}

export type ConditionalValueMapping = {
  __typename?: 'ConditionalValueMapping';
  /** Logic operator to combine conditions (defaults to AND) */
  combineOperator?: Maybe<LogicOperator>;
  /** Complex condition tree that evaluates to true or false */
  conditionTree: ConditionNode;
  /** Value to be returned if conditions are met */
  value: Scalars['String']['output'];
};

export type ConditionalValueMappingInput = {
  /** Logic operator to combine conditions (defaults to AND) */
  combineOperator?: InputMaybe<LogicOperator>;
  /** Complex condition tree that evaluates to true or false */
  conditionTree: ConditionNodeInput;
  /** Value to be returned if conditions are met */
  value: Scalars['String']['input'];
};

export type Config = {
  __typename?: 'Config';
  features?: Maybe<Features>;
  /** Default measurement units, i.e. IMPERIAL or METRIC */
  measurementUnit?: Maybe<MeasurementUnitEnum>;
};

export type Configurations = {
  __typename?: 'Configurations';
  id: Scalars['ID']['output'];
  key: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

export type ConfigurationsInput = {
  id: Scalars['ID']['input'];
  key: Scalars['String']['input'];
  title: Scalars['String']['input'];
};

/** Auth0 Connection */
export type ConnectionAuth0 = {
  __typename?: 'ConnectionAuth0';
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type CoordinatesInput = {
  x: Scalars['Float']['input'];
  y: Scalars['Float']['input'];
  z: Scalars['Float']['input'];
};

export type CopyLogsTemplateInput = {
  /** Source structure ID */
  sourceStructureId: Scalars['ID']['input'];
  /** Source template ID */
  sourceTemplateId: Scalars['ID']['input'];
  /** Target structure ID */
  targetStructureId: Scalars['ID']['input'];
};

export type CopyWorkpackTemplateInput = {
  /** Structure relation for this workpack template */
  sourceStructureId: Scalars['ID']['input'];
  /** Workpack template ID */
  sourceTemplateId: Scalars['ID']['input'];
  /** Target structure ID */
  targetStructureId: Scalars['ID']['input'];
};

export type Corrosion = {
  __typename?: 'Corrosion';
  /** Primary category of corrosion detected */
  primaryCategory?: Maybe<Scalars['String']['output']>;
};

export enum CorrosionLevel {
  Clean = 'CLEAN',
  CoatingBreakdown = 'COATING_BREAKDOWN',
  Heavy = 'HEAVY',
  Light = 'LIGHT',
  Moderate = 'MODERATE'
}

export type CorrosivityCategoryItem = {
  __typename?: 'CorrosivityCategoryItem';
  /** Name for the corrosivity category */
  name: Scalars['String']['output'];
  /** Value for the corrosivity category */
  values: Scalars['JSON']['output'];
};

export type Count = {
  __typename?: 'Count';
  count: Scalars['Int']['output'];
};

export type Counter = {
  __typename?: 'Counter';
  /** Count of the groupBy column */
  count: Scalars['Int']['output'];
  /** Group by an arbitrary column like poi.type */
  groupBy: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  /** Structure that this Counter belongs to */
  structureId: Scalars['ObjectId']['output'];
};

export type CoverageMetrics = {
  __typename?: 'CoverageMetrics';
  /** Coverage area metric */
  area?: Maybe<Scalars['Float']['output']>;
  /** Coverage mean metric */
  mean?: Maybe<Scalars['Float']['output']>;
  /** Coverage slice metric */
  slice?: Maybe<CoverageSlice>;
};

export type CoverageSlice = {
  __typename?: 'CoverageSlice';
  count: Array<Scalars['Int']['output']>;
  mean: Array<Scalars['Float']['output']>;
  start: Scalars['Float']['output'];
  step: Scalars['Float']['output'];
};

export type CreateAssemblyInput = {
  /** Identifier for the Structure that this Assembly belongs to */
  structureId: Scalars['ID']['input'];
  /** User readable identifier for the Assembly */
  tagName: Scalars['String']['input'];
  /** Data values from template for this assembly */
  templateFieldData?: InputMaybe<Scalars['JSON']['input']>;
};

export type CreateCommentInput = {
  collectionName: Scalars['String']['input'];
  key?: InputMaybe<Scalars['String']['input']>;
  metadata?: InputMaybe<Scalars['JSON']['input']>;
  referenceId: Scalars['ID']['input'];
  structureId: Scalars['ID']['input'];
  text: Scalars['String']['input'];
  type?: InputMaybe<Scalars['String']['input']>;
};

export type CreateInspectionPlanInput = {
  filters?: InputMaybe<InspectionPlanFiltersInput>;
  name: Scalars['String']['input'];
  structureId: Scalars['ID']['input'];
};

export type CreateLogEntryInput = {
  /** Category of log entry (WORKLOG, COST_LOG, QAQC_FORM) */
  category: LogCategory;
  /** Name of MongoDB Collection where Reference Document resides (e.g., 'workpacks', 'structures') */
  collectionName: Scalars['String']['input'];
  /** Field values (for WORKLOG and COST_LOG) */
  fieldValues?: InputMaybe<Array<LogFieldValueInput>>;
  /** Date of the log entry (format: yyyy-mm-dd) */
  logDate: Scalars['String']['input'];
  /** LogsTemplate ID */
  logsTemplateId: Scalars['ID']['input'];
  /** ID of the referenced entity (workpackId, structureId, etc.) */
  referenceId?: InputMaybe<Scalars['ID']['input']>;
  /** Day/Night shift */
  shift?: InputMaybe<ShiftType>;
  /** Structure ID */
  structureId: Scalars['ID']['input'];
};

export type CreatePointOfInterestInput = {
  /** Accessibility of this POI */
  accessibility?: InputMaybe<PoiAccessibilityEnum>;
  /** Assembly relation for this POI */
  assemblyId: Scalars['ID']['input'];
  /** What assembly template this POI belongs to. Used in combined deployment */
  assemblyTemplateId: Scalars['ID']['input'];
  /** User who created this Point of interest */
  assignee?: InputMaybe<Scalars['String']['input']>;
  /** Blister metadata for this POI (if type is BLISTER) */
  blister?: InputMaybe<BlisterInput>;
  /** Camera location for this POI */
  cameraLocation?: InputMaybe<Vector3Input>;
  /** Center point for this POI */
  centerPoint3d?: InputMaybe<Vector3Input>;
  /** Comment for this POI */
  comment?: InputMaybe<Scalars['String']['input']>;
  /** Cuboids of volume of interest */
  cuboids?: InputMaybe<Array<CuboidInput>>;
  /** Due date of rectification for this Point of interest */
  dueDate?: InputMaybe<Scalars['String']['input']>;
  /** POI is created by a source other than the viewer or imported from a file */
  isManuallyCreated?: InputMaybe<Scalars['Boolean']['input']>;
  /** Reason for the last update */
  lastModifiedFor: Scalars['String']['input'];
  /** Line measurements for this POI. */
  lineMeasurement?: InputMaybe<PoiLineMeasurementInput>;
  /** Linked POIs to the cuboid */
  linkedPointOfInterestIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Location relation for this POI */
  locationId?: InputMaybe<Scalars['ID']['input']>;
  /** Metadata for this POI */
  meta?: InputMaybe<Scalars['JSON']['input']>;
  /** Name for this POI */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Paint region relation for this POI */
  paintRegionId?: InputMaybe<Scalars['ID']['input']>;
  /** Parent paint region relation for this POI */
  parentPaintRegionId?: InputMaybe<Scalars['ID']['input']>;
  /** Part relation for this POI */
  partId?: InputMaybe<Scalars['ID']['input']>;
  /** Priority of this Point of interest */
  priority?: InputMaybe<PoiPriority>;
  /** Current status of this Point of interest (dynamic - can be any string value) */
  status?: InputMaybe<Scalars['String']['input']>;
  /** Structure relation for this POI */
  structureId: Scalars['ID']['input'];
  /** Teams that this POI is shared with */
  teamIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Data values associated with Template for this POI */
  templateData?: InputMaybe<Array<TemplateDataInput>>;
  templateFieldData?: InputMaybe<Scalars['JSON']['input']>;
  /** Template related to this POI for dynamic data */
  templateId?: InputMaybe<Scalars['ID']['input']>;
  /** Type for this POI */
  type: Scalars['String']['input'];
  /** Unlinked POIs to the cuboid */
  unlinkedPointOfInterestIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Height of the POI relative to the viewpoint it was created from */
  viewpointRelativeHeight?: InputMaybe<Scalars['Float']['input']>;
  /** Visibility for this POI */
  visibility?: InputMaybe<VisibilityEnum>;
  /** Workpack id of this poi */
  workpackId?: InputMaybe<Scalars['ID']['input']>;
  /** Workpack number of POI */
  workpackNumber?: InputMaybe<Scalars['String']['input']>;
};

export type CreateRegionInput = {
  name: Scalars['String']['input'];
};

export type CreateRiskAssessmentDetailsInput = {
  /** TODO: deprecated */
  age?: InputMaybe<Scalars['Int']['input']>;
  /** TODO: deprecated */
  berthingCalculation?: InputMaybe<Scalars['Int']['input']>;
  /** TODO: deprecated */
  corrosionCategory?: InputMaybe<Scalars['String']['input']>;
  /** TODO: deprecated */
  hoursAtBerth?: InputMaybe<Scalars['Int']['input']>;
  /** TODO: deprecated */
  mooringAnalysis?: InputMaybe<Scalars['Int']['input']>;
  /** TODO: deprecated */
  percentDraftCondition?: InputMaybe<Scalars['Float']['input']>;
  /** TODO: deprecated */
  percentOfHours?: InputMaybe<Scalars['Float']['input']>;
  /** TODO: deprecated */
  shipsAtBerth?: InputMaybe<Scalars['Int']['input']>;
  /** ID of the structure that will be updated */
  structureId: Scalars['ID']['input'];
  /** Data values associated with Template for this structure */
  templateData: Array<TemplateDataInput>;
  /** Template related to this structure for dynamic data */
  templateId: Scalars['ID']['input'];
};

export type CreateStructureInput = {
  deploymentLevel: StructureDeploymentLevel;
  features: Scalars['JSON']['input'];
  name: Scalars['String']['input'];
  status: StructureStatus;
  type: StructureTypes;
  userGroupIds: Array<Scalars['ID']['input']>;
};

export type CreateSupervoxelClass = {
  color: Scalars['String']['input'];
  name: Scalars['String']['input'];
  structureId: Scalars['ID']['input'];
};

export type CreateUserGroupInput = {
  name: Scalars['String']['input'];
  userIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
};

export type CreateWorkflowStageInput = {
  orderInWorkflow: Scalars['Int']['input'];
  stageType?: InputMaybe<StageType>;
  structureId: Scalars['ID']['input'];
  workflowStageName: Scalars['String']['input'];
};

export type CreateWorkpackInput = {
  name: Scalars['String']['input'];
  structureId: Scalars['ID']['input'];
  type?: InputMaybe<WorkpackType>;
  wbs?: InputMaybe<WorkpackWbs>;
  workpackTemplateId?: InputMaybe<Scalars['ID']['input']>;
};

export type CreateWorkpackItemInput = {
  meta?: InputMaybe<Scalars['JSON']['input']>;
  name: Scalars['String']['input'];
  partId?: InputMaybe<Scalars['String']['input']>;
  view: WorkpackItemViewInput;
  workpackId: Scalars['ID']['input'];
};

export type CreatedByDetails = {
  __typename?: 'CreatedByDetails';
  name: Scalars['String']['output'];
  profilePicture: Scalars['String']['output'];
};

/** Cuboid represents a labelled 3d-volume (rectangular box). */
export type Cuboid = {
  __typename?: 'Cuboid';
  /** Assembly that this Cuboid belongs to */
  assemblyId?: Maybe<Scalars['ID']['output']>;
  /** CuboidClass assigned to this cuboid - Structure.cudoidClass */
  cuboidClassId?: Maybe<Scalars['ID']['output']>;
  /** Unique role ID */
  id: Scalars['ID']['output'];
  /** Integer ID of this cuboid */
  integerId?: Maybe<Scalars['Int']['output']>;
  /** Position of the cuboid (x,y,z) */
  position: Array<Scalars['Float']['output']>;
  /** Rotation of the cuboid (roll,pitch,yaw). Euler angles using Three.js Euler conventions. */
  rotation: Array<Scalars['Float']['output']>;
  /** Size of the cuboid in 3 axes (x,y,z) */
  scale: Array<Scalars['Float']['output']>;
  /** Structure that this cuboid belongs to */
  structureId: Scalars['ObjectId']['output'];
  /** Zone this cuboid was created in */
  zoneId?: Maybe<Scalars['ID']['output']>;
};

export type CuboidInput = {
  /** Position of the cuboid (x,y,z) */
  position: Array<Scalars['Float']['input']>;
  /** Rotation of the cuboid (roll,pitch,yaw). Euler angles using Abyss conventions. */
  rotation: Array<Scalars['Float']['input']>;
  /** Size of the cuboid in 3 axes (x,y,z) */
  scale: Array<Scalars['Float']['input']>;
};

/** Currently logged in user. */
export type CurrentUser = {
  __typename?: 'CurrentUser';
  /** Auth0 Connection name used to authenticate logged in user */
  connection: Scalars['String']['output'];
  /** User Groups which logged in user belongs to */
  groups: Array<Scalars['String']['output']>;
  /** Auth0 ID of the logged in user */
  id: Scalars['ID']['output'];
  /** Auth0 Roles which logged in user has */
  roles: Array<UserRolesEnum>;
};

export type DamageClass = {
  name: Scalars['String']['input'];
  value: Scalars['Float']['input'];
};

export type DamageClassCountType = {
  __typename?: 'DamageClassCountType';
  count?: Maybe<Scalars['Float']['output']>;
  key?: Maybe<Scalars['String']['output']>;
};

/**
 * Deck is a floor level on the Structure.
 *
 * A Structure can have multiple Decks on which day-to-day operations take place.
 */
export type Deck = {
  __typename?: 'Deck';
  /** Absolute height of deck from 0m */
  cadFloorHeight?: Maybe<Scalars['Float']['output']>;
  /** Transform matrix from platform grid coordinate system to 2D pixels on deck map */
  cadTransform: Array<Scalars['Float']['output']>;
  /** Date this Deck was created */
  createdAt?: Maybe<Scalars['String']['output']>;
  /** Defect Area for the structure */
  defectArea?: Maybe<Scalars['JSON']['output']>;
  /** [min, max] height range for spatial heatmap slider */
  heightRange: Array<Scalars['Float']['output']>;
  /** Increment step for spatial heatmap slider */
  heightStep?: Maybe<Scalars['Int']['output']>;
  /** Unique Deck ID */
  id: Scalars['ID']['output'];
  /** [width, height] dimensions of deck plan image */
  imageDimensions: Array<Scalars['Int']['output']>;
  /** User readable name */
  name: Scalars['String']['output'];
  /** URL for deck plan image file */
  resourcePath: Scalars['String']['output'];
  /** URL for voxel SQLite db file */
  spatialHeatmapPath?: Maybe<Scalars['String']['output']>;
  /** Structure that the deck belongs to */
  structure: Structure;
  /** Date this Deck was last updated */
  updatedAt?: Maybe<Scalars['String']['output']>;
};

export type DeckAreaSummary = {
  __typename?: 'DeckAreaSummary';
  deckId: Scalars['ID']['output'];
  totalArea: Scalars['Float']['output'];
};

export type DeckInfoInput = {
  voxelDataUri: Scalars['String']['input'];
};

export type DeckRelativeBounds = {
  __typename?: 'DeckRelativeBounds';
  /** Bottom of the paint region relative to the deck in meters */
  bottom: Scalars['Int']['output'];
  /** Top of the paint region relative to the deck in meters */
  top: Scalars['Int']['output'];
};

export type DeckWithDefects = {
  __typename?: 'DeckWithDefects';
  defectArea: Array<DefectArea>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type DecksDetails = {
  __typename?: 'DecksDetails';
  area?: Maybe<Scalars['Float']['output']>;
  deckId: Deck;
};

export type DecksDetailsInput = {
  area: Scalars['Float']['input'];
  deckId: Scalars['ID']['input'];
};

export type Defect = {
  __typename?: 'Defect';
  key: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type DefectArea = {
  __typename?: 'DefectArea';
  area: Scalars['Float']['output'];
  key: Scalars['String']['output'];
};

export type DefectCalculationsInput = {
  /** Structure ID to calculate analytics for */
  structureId: Scalars['ID']['input'];
};

export type DefectCalculationsResult = {
  __typename?: 'DefectCalculationsResult';
  /** Coating analytics data */
  coating: Analytics;
  /** Corrosion analytics data */
  corrosion: Analytics;
};

export type DefectColorMeta = {
  __typename?: 'DefectColorMeta';
  key: Scalars['String']['output'];
  value: Array<DefectColorMetaValue>;
};

export type DefectColorMetaValue = {
  __typename?: 'DefectColorMetaValue';
  colour: Scalars['String']['output'];
  name: Scalars['String']['output'];
  octreeIndex: Scalars['Int']['output'];
};

export type DefectLegend = {
  __typename?: 'DefectLegend';
  color: Scalars['String']['output'];
  groupKey: Scalars['String']['output'];
  groupName: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  key?: Maybe<Scalars['String']['output']>;
  legendText?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  octreeKey: OctreeKey;
  octreeValue: Scalars['Int']['output'];
};

export type DefectLegendInput = {
  color?: InputMaybe<Scalars['String']['input']>;
  groupKey?: InputMaybe<Scalars['String']['input']>;
  groupName?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  key?: InputMaybe<Scalars['String']['input']>;
  legendText?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  octreeKey?: InputMaybe<OctreeKey>;
  octreeValue?: InputMaybe<Scalars['Int']['input']>;
};

export type DefectMetrics = {
  __typename?: 'DefectMetrics';
  /** Coverage metrics of defect */
  coverage: CoverageMetrics;
  /** Type of defect */
  defectType: Scalars['String']['output'];
};

export type DefectsAreaByStructuresResult = {
  __typename?: 'DefectsAreaByStructuresResult';
  structureId: Scalars['ID']['output'];
  structureName: Scalars['String']['output'];
  totalArea: Array<AreaAndType>;
};

export type DeleteCuboidInput = {
  id: Scalars['ID']['input'];
};

export type DeleteFilesInput = {
  collectionName: Scalars['String']['input'];
  fileIds: Array<Scalars['ID']['input']>;
  referenceId: Scalars['ID']['input'];
};

export type DeleteFilesPayload = {
  __typename?: 'DeleteFilesPayload';
  deletedFiles: Array<Scalars['ID']['output']>;
  message: Scalars['String']['output'];
};

export type DeleteInspectionPlanInput = {
  planId: Scalars['ID']['input'];
  structureId: Scalars['ID']['input'];
};

export type DeleteLogEntryInput = {
  /** LogEntry ID */
  logEntryId: Scalars['ID']['input'];
  /** Structure ID */
  structureId: Scalars['ID']['input'];
};

export type DeletePlannerColumnInput = {
  fieldKey: Scalars['String']['input'];
  structureId: Scalars['ID']['input'];
  templateId: Scalars['ID']['input'];
  type: TemplateTypeEnum;
};

export type DeleteUserGroupInput = {
  userGroupId: Scalars['ID']['input'];
};

export type DeleteWorkflowStageInput = {
  /** Unique Structure ID */
  structureId: Scalars['ID']['input'];
  workflowStageId: Scalars['ID']['input'];
};

export type DeleteWorkpackInput = {
  workpackId: Scalars['ID']['input'];
};

export type DeleteWorkpackItemInput = {
  workpackId: Scalars['ID']['input'];
  workpackItemId: Scalars['ID']['input'];
};

export enum DifficultyLevel {
  High = 'HIGH',
  Low = 'LOW',
  Medium = 'MEDIUM'
}

export type DisplayColor = {
  __typename?: 'DisplayColor';
  /** One of the value from options */
  key: Scalars['String']['output'];
  /** Define color for that option */
  value: Scalars['String']['output'];
};

export type DisplayColorInput = {
  /** One of the value from options */
  key: Scalars['String']['input'];
  /** Define color for that option */
  value: Scalars['String']['input'];
};

export type DisplayConfig = {
  __typename?: 'DisplayConfig';
  /** Define the color for options */
  color?: Maybe<Array<Maybe<DisplayColor>>>;
  /** Unique ID */
  id: Scalars['ID']['output'];
  /** Defines Input Adorment for the text field */
  inputAdorment?: Maybe<InputAdormentType>;
  /** Is this Template Field can be sorted when used in table */
  isSortable: Scalars['Boolean']['output'];
  /** Sorting type based on the data that this field contian i.e number or string */
  sortType: SortTypeEnum;
  /** Used to define Number of rows to be rendered in Text Area field */
  textAreaRows?: Maybe<Scalars['Float']['output']>;
  /** Formatting of the text when displayed */
  textFormat?: Maybe<TextFormatEnum>;
  /** Type or Style of the Table Cell */
  type: TableCellStyleEnum;
};

export type DisplayConfigInput = {
  /** Define the color for options */
  color?: InputMaybe<Array<InputMaybe<DisplayColorInput>>>;
  /** Unique ID */
  id: Scalars['ID']['input'];
  /** Defines Input Adorment for the text field */
  inputAdorment?: InputMaybe<InputAdormentInput>;
  /** Is this Template Field can be sorted when used in table */
  isSortable: Scalars['Boolean']['input'];
  /** Sorting type based on the data that this field contian i.e number or string */
  sortType: SortTypeEnum;
  /** Used to define Number of rows to be rendered in Text Area field */
  textAreaRows?: InputMaybe<Scalars['Float']['input']>;
  /** Formatting of the text when displayed */
  textFormat?: InputMaybe<TextFormatEnum>;
  /** Type or Style of the Table Cell */
  type: TableCellStyleEnum;
};

export type DisplaySettingInput = {
  color: Scalars['String']['input'];
  fieldValue: Scalars['String']['input'];
};

export type DisplaySettings = {
  __typename?: 'DisplaySettings';
  color: Scalars['String']['output'];
  fieldValue: Scalars['String']['output'];
};

export enum DisplayType {
  CircularBar = 'CIRCULAR_BAR',
  Counter = 'COUNTER',
  DeckImages = 'DECK_IMAGES',
  StackedBar = 'STACKED_BAR'
}

export type DynamicBlockCalculationInput = {
  assemblyId?: InputMaybe<Scalars['ID']['input']>;
  bbox: BoundingBoxInput;
  structureId: Scalars['ID']['input'];
};

export type DynamicSpatialHeatmapInput = {
  /** Extents to aggregate within */
  bbox: BoundingBoxInput;
  /** Offset to apply to Z values in request to match Z values in DB */
  cadFloorHeight: Scalars['Float']['input'];
  /** Used to find URI of heatmaps DB (same as in spatial heatmap call) */
  deckInfo: DeckInfoInput;
  /** Optional list of part IDs (integer IDs) to filter by */
  parts?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type EditFields = {
  isEditable: Scalars['Boolean']['input'];
  key: Scalars['String']['input'];
  roles: Array<InputMaybe<Scalars['String']['input']>>;
};

export type EditRolesInput = {
  editRoles: Array<InputMaybe<EditFields>>;
  structureId: Scalars['ID']['input'];
  templateId: Scalars['ID']['input'];
  type: Scalars['String']['input'];
};

export type EnvironmentalClassificationItem = {
  __typename?: 'EnvironmentalClassificationItem';
  /** Name for the environmental classification */
  name: Scalars['String']['output'];
  /** Value for the environmental classification */
  values: Scalars['JSON']['output'];
};

export type EnvironmentalExposureItem = {
  __typename?: 'EnvironmentalExposureItem';
  /** Code for the environmental exposure */
  code: Scalars['String']['output'];
  /** Name for the environmental exposure */
  name: Scalars['String']['output'];
  /** Time to visibility for the environmental exposure */
  timeToVisibility: Scalars['Int']['output'];
};

export enum EqiupmentCardFieldTypeEnum {
  AlarmLevel = 'ALARM_LEVEL',
  DamageClass = 'DAMAGE_CLASS',
  PercentageIndicator = 'PERCENTAGE_INDICATOR',
  ScCategory = 'SC_CATEGORY',
  SimpleText = 'SIMPLE_TEXT',
  TextWithTitle = 'TEXT_WITH_TITLE'
}

export type Equation = {
  __typename?: 'Equation';
  /** The root expression node of the equation */
  expression?: Maybe<Expression>;
  /** Unique identifier/key for the equation */
  key: Scalars['String']['output'];
  /** Name for the equation */
  name?: Maybe<Scalars['String']['output']>;
  /** Value to return in case of no calculations */
  value?: Maybe<Scalars['String']['output']>;
  /** List of variables used in the equation */
  variables?: Maybe<Array<Variable>>;
};

export type EquationInput = {
  /** The root expression node of the equation */
  expression?: InputMaybe<ExpressionInput>;
  /** Unique identifier/key for the equation */
  key: Scalars['String']['input'];
  /** Name for the equation */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Value to return in case of no calculations */
  value?: InputMaybe<Scalars['String']['input']>;
  /** List of variables used in the equation */
  variables?: InputMaybe<Array<VariableInput>>;
};

export type Equipment = {
  __typename?: 'Equipment';
  code: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type EquipmentCardField = {
  __typename?: 'EquipmentCardField';
  /** Key of the template field from templateFieldData */
  fieldKey?: Maybe<Scalars['String']['output']>;
  /** Unique Equipment Card Field ID */
  id: Scalars['ID']['output'];
  /** Location where this card should be shown in the application */
  location: EquipmentCardLocationEnum;
  /** Name of this Equipment Card Field */
  name: Scalars['String']['output'];
  /** Position of this Equipment Card Field */
  position: EquipmentCardPositionEnum;
  /** Type of this Equipment Card Field */
  type: EqiupmentCardFieldTypeEnum;
};

export enum EquipmentCardLocationEnum {
  Default = 'DEFAULT',
  EsSheet = 'ES_SHEET',
  MiViewer = 'MI_VIEWER'
}

export enum EquipmentCardPositionEnum {
  BottomMiddle = 'BOTTOM_MIDDLE',
  BottomRight = 'BOTTOM_RIGHT',
  Subtitle = 'SUBTITLE',
  TopMiddle = 'TOP_MIDDLE',
  TopRight = 'TOP_RIGHT'
}

export type EquipmentClasses = {
  __typename?: 'EquipmentClasses';
  classes: Array<Equipment>;
  name: Scalars['String']['output'];
};

export type EquipmentDetailField = {
  __typename?: 'EquipmentDetailField';
  /** Table configuration */
  displayConfig?: Maybe<DisplayConfig>;
  /** Unique human-readable key. It should be same as field key in template */
  fieldKey: Scalars['String']['output'];
  /** Unique Equipment Field ID */
  id: Scalars['ID']['output'];
  /** Should not be shown in the UI. Used for identifying certian fields */
  isHidden?: Maybe<Scalars['Boolean']['output']>;
  /** Is this Equipment Template Field read-only; i.e. value cannot be updated */
  isReadOnly: Scalars['Boolean']['output'];
  /** Is this Equipment Field always required */
  isRequired: Scalars['Boolean']['output'];
  /** Name of this Equipment Field */
  name: Scalars['String']['output'];
  /** Valid options for this Equipment Field value */
  options: Array<EquipmentDetailOptionField>;
  /** Should the Equipment template options be fetched from the server on runtime */
  serverSide: Scalars['Boolean']['output'];
  /** Sub-Type of this Equipment  Field */
  subType?: Maybe<EquipmentDetailSubTypeEnum>;
  /** Type of this Equipment Field */
  type: EquipmentDetailTypeEnum;
};

export type EquipmentDetailFieldInput = {
  displayConfig?: InputMaybe<DisplayConfigInput>;
  fieldKey: Scalars['String']['input'];
  id: Scalars['ID']['input'];
  isHidden?: InputMaybe<Scalars['Boolean']['input']>;
  isReadOnly: Scalars['Boolean']['input'];
  isRequired: Scalars['Boolean']['input'];
  name: Scalars['String']['input'];
  options: Array<EquipmentDetailOptionFieldInput>;
  serverSide: Scalars['Boolean']['input'];
  subType?: InputMaybe<EquipmentDetailSubTypeEnum>;
  type: EquipmentDetailTypeEnum;
};

export type EquipmentDetailOptionField = {
  __typename?: 'EquipmentDetailOptionField';
  /** Unique human-readable key. It should be same as field key in template */
  fieldKey?: Maybe<Scalars['String']['output']>;
  /** Unique Equipment Option Field */
  id: Scalars['ID']['output'];
  /** Name associated for the Equipment option field */
  name: Scalars['String']['output'];
  /** Type associated with the Equipment option field */
  type: OptionFieldTypeEnum;
};

export type EquipmentDetailOptionFieldInput = {
  fieldKey?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  name: Scalars['String']['input'];
  type?: InputMaybe<OptionFieldTypeEnum>;
};

export enum EquipmentDetailSubTypeEnum {
  DefectConsolidatedDegreeOfRusting = 'DEFECT_CONSOLIDATED_DEGREE_OF_RUSTING',
  DefectCorrosion = 'DEFECT_CORROSION',
  DefectDegreeOfRusting = 'DEFECT_DEGREE_OF_RUSTING',
  DefectSubstrateCondition = 'DEFECT_SUBSTRATE_CONDITION'
}

export enum EquipmentDetailTypeEnum {
  DefectConsolidatedDegree = 'DEFECT_CONSOLIDATED_DEGREE',
  DefectCorrosionArea = 'DEFECT_CORROSION_AREA',
  DefectCorrosionRatio = 'DEFECT_CORROSION_RATIO',
  DefectMaxSeverity = 'DEFECT_MAX_SEVERITY',
  TemplateList = 'TEMPLATE_LIST'
}

export type EsSheet = {
  __typename?: 'EsSheet';
  /** The actual data payload (present on data-chunk documents only) */
  data?: Maybe<Scalars['JSON']['output']>;
  /** Type of data stored in this document: ORIGINAL_DATA, FINAL_DATA, COLUMN_MAPPINGS, VALUE_MAPPINGS, INLINE_EDITS (present on data-chunk documents only) */
  dataType?: Maybe<Scalars['String']['output']>;
  /** Reference to the parent ES sheet document (present on data-chunk documents only) */
  esSheetId?: Maybe<Scalars['String']['output']>;
  /** Array of row indices to exclude from import. Example: [3, 7, 15] means skip rows 3, 7, and 15 (present on parent documents only) */
  excludedRows?: Maybe<Array<Scalars['Int']['output']>>;
  /** Headers of the ES sheet (present on parent documents only) */
  headers?: Maybe<Array<Scalars['String']['output']>>;
  /** Unique ES sheet ID */
  id: Scalars['ID']['output'];
  /** Auth0 ID of the user who last updated this POI Template */
  lastModifiedBy?: Maybe<Scalars['String']['output']>;
  /** Timestamp for the last update made from the API */
  lastModifiedByAPI?: Maybe<Scalars['String']['output']>;
  /** User who made the last update */
  lastModifiedByUser?: Maybe<User>;
  /** Reason for the last update */
  lastModifiedFor?: Maybe<Scalars['String']['output']>;
  /** Structure that this ES sheet belongs to */
  structure?: Maybe<Structure>;
  /** Template related to this ES sheet for assembly data */
  template?: Maybe<Template>;
};

export enum EsSheetStatus {
  Published = 'PUBLISHED',
  Unpublished = 'UNPUBLISHED'
}

export type EvaluateTemplateFieldLogicRuleInput = {
  context: Scalars['JSON']['input'];
  fieldKey: Scalars['String']['input'];
  structureId: Scalars['ID']['input'];
  templateId: Scalars['ID']['input'];
  templateType: TemplateTypeEnum;
};

export type EvaluateTemplateFieldLogicRuleResult = {
  __typename?: 'EvaluateTemplateFieldLogicRuleResult';
  result: Scalars['String']['output'];
};

export type Expression = {
  __typename?: 'Expression';
  /** Child expressions for operations (e.g. operands for binary operations) */
  args?: Maybe<Array<Maybe<Expression>>>;
  /** Mathematical operator (+, -, *, /, etc.), used when type is 'OPERATION' */
  operator?: Maybe<MathOperator>;
  /** The type of expression */
  type: ExpressionType;
  /** Numeric value, used when type is 'NUMBER' */
  value?: Maybe<Scalars['Float']['output']>;
  /** Variable name, used when type is 'VARIABLE' */
  variable?: Maybe<Scalars['String']['output']>;
};

export type ExpressionInput = {
  /** Child expressions for operations (e.g. operands for binary operations) */
  args?: InputMaybe<Array<InputMaybe<ExpressionInput>>>;
  /** Mathematical operator (+, -, *, /, etc.), used when type is 'OPERATION' */
  operator?: InputMaybe<MathOperator>;
  /** The type of expression */
  type: ExpressionType;
  /** Numeric value, used when type is 'NUMBER' */
  value?: InputMaybe<Scalars['Float']['input']>;
  /** Variable name, used when type is 'VARIABLE' */
  variable?: InputMaybe<Scalars['String']['input']>;
};

export enum ExpressionType {
  Number = 'NUMBER',
  Operation = 'OPERATION',
  Variable = 'VARIABLE'
}

export type FailedUserInfo = {
  __typename?: 'FailedUserInfo';
  email: Scalars['String']['output'];
  errorMessage: Scalars['String']['output'];
};

/** Abyss fabric Features */
export type Features = {
  __typename?: 'Features';
  blisterHeights?: Maybe<Scalars['Boolean']['output']>;
};

export type FeaturesInput = {
  deckPlan?: InputMaybe<Array<Scalars['String']['input']>>;
  idms?: InputMaybe<Array<Scalars['String']['input']>>;
  insights?: InputMaybe<Array<Scalars['String']['input']>>;
  reports?: InputMaybe<Array<Scalars['String']['input']>>;
  riskAssessment?: InputMaybe<Array<Scalars['String']['input']>>;
  viewer?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type FieldDetails = {
  __typename?: 'FieldDetails';
  hidden?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type FieldDetailsInput = {
  hidden?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type File = {
  __typename?: 'File';
  caption?: Maybe<Scalars['String']['output']>;
  fileName: Scalars['String']['output'];
  id?: Maybe<Scalars['ID']['output']>;
  imagePosition?: Maybe<Scalars['Int']['output']>;
  imageType?: Maybe<ImageType>;
  name: FileNameTypes;
  resourcePath: Scalars['String']['output'];
  size?: Maybe<Scalars['Int']['output']>;
  type: FileTypes;
  uploadStatus?: Maybe<FileUploadStatus>;
  uuid?: Maybe<Scalars['String']['output']>;
};

export type FileAttributes = {
  imageType?: InputMaybe<ImageType>;
  mimeType: Scalars['String']['input'];
  name: Scalars['String']['input'];
  size: Scalars['Int']['input'];
  uuid: Scalars['String']['input'];
};

export type FileCreateInput = {
  fileName: Scalars['String']['input'];
  imageType?: InputMaybe<ImageType>;
  name: FileNameTypes;
  resourcePath: Scalars['String']['input'];
  size?: InputMaybe<Scalars['Int']['input']>;
  type: FileTypes;
  uploadStatus: FileUploadStatus;
  uuid?: InputMaybe<Scalars['String']['input']>;
};

export type FileInput = {
  fileName: Scalars['String']['input'];
  imageType?: InputMaybe<ImageType>;
  name: FileNameTypes;
  resourcePath: Scalars['String']['input'];
  type: FileTypes;
  uuid?: InputMaybe<Scalars['String']['input']>;
};

export enum FileNameTypes {
  DeckImage = 'DECK_IMAGE',
  IsometricDrawing = 'ISOMETRIC_DRAWING',
  PoiAttachments = 'POI_ATTACHMENTS',
  PoiScreenshot = 'POI_SCREENSHOT',
  ReferenceDrawing = 'REFERENCE_DRAWING',
  UserAttachments = 'USER_ATTACHMENTS'
}

export enum FileTypes {
  Jpeg = 'JPEG',
  Mp4 = 'MP4',
  Pdf = 'PDF',
  Png = 'PNG'
}

export type FileUpdates = {
  fileId: Scalars['String']['input'];
  uploadStatus: FileUploadStatus;
};

export enum FileUploadStatus {
  Failed = 'FAILED',
  Inprogress = 'INPROGRESS',
  Pending = 'PENDING',
  Success = 'SUCCESS'
}

export type FileWithStatus = {
  __typename?: 'FileWithStatus';
  file: File;
  selectedStatus: Scalars['Boolean']['output'];
};

export type FilterForStructures = {
  name?: InputMaybe<Scalars['String']['input']>;
  userGroupId?: InputMaybe<Scalars['ID']['input']>;
};

export type FilterForUserGroups = {
  name?: InputMaybe<Scalars['String']['input']>;
  structureId?: InputMaybe<Scalars['ID']['input']>;
};

export type FilterForUsers = {
  connection?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  excludeRoleIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  excludeTeamId?: InputMaybe<Scalars['ID']['input']>;
  excludeUserGroupId?: InputMaybe<Scalars['ID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  q?: InputMaybe<Scalars['String']['input']>;
  roleId?: InputMaybe<Scalars['ID']['input']>;
  status?: InputMaybe<UserStatusEnum>;
};

export type FilterForUsersByUserGroup = {
  q?: InputMaybe<Scalars['String']['input']>;
  userGroupId?: InputMaybe<Scalars['ID']['input']>;
};

export type FilteredOptions = {
  __typename?: 'FilteredOptions';
  /** Filtered options for this Template */
  options: Array<Scalars['String']['output']>;
};

export type FiltersForPreRegisteredUsers = {
  searchTerm?: InputMaybe<Scalars['String']['input']>;
};

export type FiltersForStructureByUserGroup = {
  name?: InputMaybe<Scalars['String']['input']>;
  userGroupId: Scalars['ID']['input'];
};

export type FiltersForUsersCount = {
  connection?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  q?: InputMaybe<Scalars['String']['input']>;
  roleId?: InputMaybe<Scalars['ID']['input']>;
  userGroupId?: InputMaybe<Scalars['String']['input']>;
};

export type FiltersInput = {
  id: Scalars['String']['input'];
  value: Array<Scalars['String']['input']>;
};

export type FindAllPaintRegionsInput = {
  deckIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  onlyIncludeDefault?: InputMaybe<Scalars['Boolean']['input']>;
  paintRegionGroupIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  structureId?: InputMaybe<Scalars['ID']['input']>;
};

export type FindAllPointOfInterestsInput = {
  assemblyIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  assemblyTemplateId: Scalars['ID']['input'];
  includeManuallyCreated?: InputMaybe<Scalars['Boolean']['input']>;
  partId?: InputMaybe<Scalars['ID']['input']>;
  selectedTemplateFilters?: InputMaybe<Array<InputMaybe<FiltersInput>>>;
  structureId?: InputMaybe<Scalars['ID']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  workpackId?: InputMaybe<Scalars['ID']['input']>;
  workpackIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
};

export type FindClosestPaintRegionInput = {
  position: Vector3Input;
  structureId: Scalars['ID']['input'];
};

export type FindClosestPaintRegionResult = {
  __typename?: 'FindClosestPaintRegionResult';
  distance?: Maybe<Scalars['Float']['output']>;
  paintRegion?: Maybe<PaintRegion>;
};

export type FindLogEntriesByReferenceInput = {
  /** Category of log entry (WORKLOG, COST_LOG, QAQC_FORM) */
  category?: InputMaybe<LogCategory>;
  /** ID of the referenced entity (workpackId, structureId, etc.) */
  referenceId: Scalars['ID']['input'];
  /** Day/Night shift (optional) */
  shift?: InputMaybe<ShiftType>;
  /** Structure ID */
  structureId: Scalars['ID']['input'];
};

export type FindLogEntriesInput = {
  /** Category of log entry (WORKLOG, COST_LOG, QAQC_FORM) */
  category?: InputMaybe<LogCategory>;
  /** Name of MongoDB Collection where Reference Document resides (e.g., 'workpacks', 'structures') */
  collectionName?: InputMaybe<Scalars['String']['input']>;
  /** End date for filtering (format: yyyy-mm-dd) */
  endDate?: InputMaybe<Scalars['String']['input']>;
  /** LogsTemplate ID */
  logsTemplateId?: InputMaybe<Scalars['ID']['input']>;
  /** ID of the referenced entity (workpackId, structureId, etc.) */
  referenceId?: InputMaybe<Scalars['ID']['input']>;
  /** Day/Night shift */
  shift?: InputMaybe<ShiftType>;
  /** Start date for filtering (format: yyyy-mm-dd) */
  startDate?: InputMaybe<Scalars['String']['input']>;
  /** Structure ID */
  structureId?: InputMaybe<Scalars['ID']['input']>;
  /** Type of log entry field value (POB_CONFIG, OTHER, etc.) */
  type?: InputMaybe<LogEntryType>;
};

/** Float (number) metadata */
export type FloatMeta = {
  __typename?: 'FloatMeta';
  key: Scalars['String']['output'];
  value: Scalars['Float']['output'];
};

/** Configuration of processing flow run. */
export type FlowRunConfig = {
  __typename?: 'FlowRunConfig';
  /** Flow deployment name to create run from */
  deploymentName: Scalars['String']['output'];
  /** Flow name to create run from */
  flowName: Scalars['String']['output'];
  /** Labels to create run with */
  labels?: Maybe<Scalars['JSON']['output']>;
  /** Flow parameters to create run with */
  parameters?: Maybe<Scalars['JSON']['output']>;
  /** Override default Prefect Server API URL */
  prefectServerApiUrl?: Maybe<Scalars['String']['output']>;
  /** Tags to create run with */
  tags?: Maybe<Array<Scalars['String']['output']>>;
};

export type GenerateCropFromRectilinearInput = {
  /** X Y Z Position of the clicked point */
  centerPoint?: InputMaybe<CenterPoint>;
  /** Location information from the image */
  image: Image;
  /** Output image height */
  outputHeight: Scalars['Float']['input'];
  /** Output Vertical Field Of View */
  outputVerticalFov: Scalars['Float']['input'];
  /** Output image width */
  outputWidth: Scalars['Float']['input'];
};

export type GenerateImageInput = {
  /** Rotation of camera angle */
  bearing: Scalars['Float']['input'];
  /** Elevation of camera angle */
  elevation: Scalars['Float']['input'];
  /** Image name */
  imageName: Scalars['String']['input'];
  /** Image URL to download from */
  imageUrl: Scalars['String']['input'];
  /** Id of Location */
  locationId: Scalars['String']['input'];
  /** Output image height */
  outputHeight: Scalars['Float']['input'];
  /** Output image width */
  outputWidth: Scalars['Float']['input'];
  /** Vertical field of view (degrees) */
  verticalFovDegrees: Scalars['Float']['input'];
};

export type GenerateImageResult = {
  __typename?: 'GenerateImageResult';
  /** Base64 encoded string of image data */
  imageData: Scalars['String']['output'];
};

export type GeneratedPresignedUrl = {
  __typename?: 'GeneratedPresignedURL';
  id: Scalars['String']['output'];
  resourcePath: Scalars['String']['output'];
  url: Scalars['String']['output'];
  uuid: Scalars['String']['output'];
};

export type GetAllWorkpackAttachmentsInput = {
  logDate: Scalars['String']['input'];
  /** Shift for which attachments are being fetched (DAY or NIGHT) */
  shift?: InputMaybe<ShiftType>;
  structureId: Scalars['ID']['input'];
  /** IANA timezone identifier (e.g. 'America/New_York', 'Australia/Sydney') for date filtering */
  timezone: Scalars['String']['input'];
  workpackId: Scalars['ID']['input'];
};

export type GetAssembliesByPaintRegionIdsInput = {
  selectedPaintRegionIds: Array<Scalars['ID']['input']>;
  structureId: Scalars['ID']['input'];
  templateId: Scalars['ID']['input'];
};

export type GoverningValueBlister = {
  __typename?: 'GoverningValueBlister';
  /** Estimated value of thickness of pipe wall that has been lost to corrosion based on blister height (in millimeters) */
  estimatedWallLoss: Scalars['Float']['output'];
  /** Calculated wall loss as a percentage of nominal pipe wall thickness (in %) */
  estimatedWallLossPercentage: Scalars['Float']['output'];
  /** Recorded height of the blister (in millimeters) */
  height: Scalars['Float']['output'];
  /** Remaining allowance for corrosion based on estimated thickness loss and pipe spec (in millimeters) */
  residualCorrosionAllowance: Scalars['Float']['output'];
  /** Calculated residual corrosion allowance as a percentage of nominal corrosion allowance (in %) */
  residualCorrosionAllowancePercentage: Scalars['Float']['output'];
  /** Calculated residual thickness based on wall loss and pipe spec (in millimeters) */
  residualThickness: Scalars['Float']['output'];
  /** Calculated residual thickness as a percentage of nominal thickness (in %) */
  residualThicknessPercentage: Scalars['Float']['output'];
};

export type GoverningValueInput = {
  estimatedWallLoss: Scalars['Float']['input'];
  estimatedWallLossPercentage: Scalars['Float']['input'];
  height: Scalars['Float']['input'];
  residualCorrosionAllowance: Scalars['Float']['input'];
  residualCorrosionAllowancePercentage: Scalars['Float']['input'];
  residualThickness: Scalars['Float']['input'];
  residualThicknessPercentage: Scalars['Float']['input'];
};

export type GoverningValueRecommendation = {
  __typename?: 'GoverningValueRecommendation';
  blister?: Maybe<PointOfInterest>;
  calculations?: Maybe<GoverningValueBlister>;
  manuallyUpdated?: Maybe<Scalars['Boolean']['output']>;
  pointOfInterest?: Maybe<PointOfInterest>;
};

export type GoverningValueRecommendationInput = {
  blisterId: Scalars['ID']['input'];
  calculations: GoverningValueInput;
};

export type GroupSection = {
  __typename?: 'GroupSection';
  /** Unique human-readable keys to be displayed in Review Panel. It should be same as field key in template */
  fieldKeys: Array<Maybe<Scalars['String']['output']>>;
  /** Unique Assessment Detail Field */
  id: Scalars['ID']['output'];
  /** Unique identifier for the section */
  sectionKey: Scalars['String']['output'];
  /** Name of the section */
  title: Scalars['String']['output'];
};

export type GroupSectionInput = {
  /** Unique human-readable keys to be displayed in Review Panel. It should be same as field key in template */
  fieldKeys: Array<InputMaybe<Scalars['String']['input']>>;
  /** Unique Group Section ID */
  id: Scalars['ID']['input'];
  /** Unique identifier for the section */
  sectionKey: Scalars['String']['input'];
  /** Name of the section */
  title: Scalars['String']['input'];
};

export type GroupedReports = {
  __typename?: 'GroupedReports';
  count: Scalars['Int']['output'];
  groupId: Scalars['ID']['output'];
  groupName: Scalars['String']['output'];
};

export type GroupsByPartIdsInput = {
  partIds: Array<Scalars['String']['input']>;
  structureId: Scalars['String']['input'];
};

/**
 * History Document
 *
 * A history document is a detailed snapshot of a MongoDB document from another MongoDB collection at a particular point in time.
 */
export type History = {
  __typename?: 'History';
  /** Name of MongoDB Collection where Reference Document resides */
  collectionName: Scalars['String']['output'];
  /** Date this History was created */
  createdAt: Scalars['String']['output'];
  /** User who created this History */
  createdBy: Scalars['String']['output'];
  /** Auth0 Name and Profile Picture of the user associated to createdBy from auth0 fetched at request time. */
  createdByDetails?: Maybe<CreatedByDetails>;
  /** Name of the user associated to createdBy from auth0 fetched at request time. createdBy must be present to use this */
  createdByName?: Maybe<Scalars['String']['output']>;
  /** Full Document capture at the time of History */
  document: Scalars['JSON']['output'];
  /** Name of Event that triggered creation of History */
  eventName: Scalars['String']['output'];
  /** Unique History ID */
  id: Scalars['ID']['output'];
  /** Structure that this History event belongs to  */
  structureId?: Maybe<Scalars['ID']['output']>;
};

export type IdmsTask = {
  __typename?: 'IdmsTask';
  /** Task Start Date */
  createdAt?: Maybe<Scalars['String']['output']>;
  /** Unique Task ID */
  id: Scalars['ID']['output'];
  /** Task Number */
  idmsTaskNumber: Scalars['String']['output'];
  /** Line Number of Task */
  lineNumber: Scalars['String']['output'];
  /** Recommendations for this task */
  recommendations: Array<TaskRecommendation>;
  /** Task Status */
  status?: Maybe<Scalars['String']['output']>;
  /** Task Status Updated At */
  statusUpdatedAt?: Maybe<Scalars['String']['output']>;
  /** Structure ID to which this Task belongs to */
  structureId: Scalars['ObjectId']['output'];
  /** Task Due Date */
  taskDueDate?: Maybe<Scalars['String']['output']>;
};

export type IdmsTasksWithCount = {
  __typename?: 'IdmsTasksWithCount';
  count: Scalars['Int']['output'];
  tasks: Array<IdmsTask>;
};

export type IdmsUpload = {
  __typename?: 'IdmsUpload';
  /** Date this File was created */
  createdAt: Scalars['String']['output'];
  /** User who created this File */
  createdBy: User;
  /** File path where file is present */
  filePath: Scalars['String']['output'];
  /** Unique File ID */
  id: Scalars['ID']['output'];
  /** File name */
  name: Scalars['String']['output'];
  /** Structure to which this file belongs to */
  structure: Structure;
  /** Template Type of File */
  templateType: IdmsUploadsTypeEnum;
  /** Date this File was last updated */
  updatedAt: Scalars['String']['output'];
};

export type IdmsUploadMutationInput = {
  /** File to be uploaded in base64 format */
  file: Scalars['String']['input'];
  isPlannerColumn?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  structureId: Scalars['ID']['input'];
  templateType: IdmsUploadsTypeEnum;
};

export enum IdmsUploadsTypeEnum {
  AfInspectionPriority = 'AF_INSPECTION_PRIORITY',
  ApmLineMetadata = 'APM_LINE_METADATA',
  ApmRecommendation = 'APM_RECOMMENDATION',
  ApmRecommendationStatus = 'APM_RECOMMENDATION_STATUS',
  ApmTaskNumber = 'APM_TASK_NUMBER',
  ApmTaskStatus = 'APM_TASK_STATUS',
  ApmWorkOrder = 'APM_WORK_ORDER',
  ChildComponents = 'CHILD_COMPONENTS',
  MountedPipes = 'MOUNTED_PIPES',
  PipeSupport = 'PIPE_SUPPORT',
  SpanDistance = 'SPAN_DISTANCE',
  UpdateEquipments = 'UPDATE_EQUIPMENTS',
  WorkOrderStatus = 'WORK_ORDER_STATUS'
}

export type Image = {
  /** Image Sensor */
  imageSensor: ImageSensorInput;
  /** Pose of the camera */
  pose: Pose;
  /** path to the Location image */
  url: Scalars['String']['input'];
};

export enum ImageOrientation {
  Default = 'DEFAULT',
  Landscape = 'LANDSCAPE',
  Portrait = 'PORTRAIT'
}

export type ImageOrientationConfig = {
  __typename?: 'ImageOrientationConfig';
  componentReportDeckImages?: Maybe<Scalars['String']['output']>;
  componentReportPoiImages?: Maybe<Scalars['String']['output']>;
  deckPlanImages?: Maybe<Scalars['String']['output']>;
  poiImages?: Maybe<Scalars['String']['output']>;
  poiReportDeckImages?: Maybe<Scalars['String']['output']>;
  poiReportPoiImages?: Maybe<Scalars['String']['output']>;
};

export type ImageOrientationConfigInput = {
  componentReportDeckImages?: InputMaybe<Scalars['String']['input']>;
  componentReportPoiImages?: InputMaybe<Scalars['String']['input']>;
  deckPlanImages?: InputMaybe<Scalars['String']['input']>;
  poiImages?: InputMaybe<Scalars['String']['input']>;
  poiReportDeckImages?: InputMaybe<Scalars['String']['input']>;
  poiReportPoiImages?: InputMaybe<Scalars['String']['input']>;
};

export type ImagePointInput = {
  /** Position along the x axis of the image with a value between 0 and 1 */
  x: Scalars['Float']['input'];
  /** Position along the y axis of the image with a value between 0 and 1 */
  y: Scalars['Float']['input'];
};

/**
 * Image Sensor data of a Structure that has been inspected.
 *
 * An inspection takes place on the Location that has a certain image sensor in some cases such as Drones
 */
export type ImageSensor = {
  __typename?: 'ImageSensor';
  /** Calibration coordinates X */
  cx: Scalars['Float']['output'];
  /** Calibration coordinates Y */
  cy: Scalars['Float']['output'];
  /** Sensor Image Focal Length */
  focalLength: Scalars['Float']['output'];
  /** Sensor Image Height */
  height: Scalars['Int']['output'];
  /** Unique role ID */
  id: Scalars['ID']['output'];
  /** Sensor Name */
  name: Scalars['String']['output'];
  /** Structure that this Location data belongs to */
  structure: Structure;
  /** Sensor Image Width */
  width: Scalars['Int']['output'];
};

export type ImageSensorInput = {
  /** Calibration coordinates X */
  cx: Scalars['Float']['input'];
  /** Calibration coordinates Y */
  cy: Scalars['Float']['input'];
  /** Sensor Image Focal Length */
  focalLength: Scalars['Float']['input'];
  /** Sensor Image Height */
  height: Scalars['Int']['input'];
  /** Sensor Image Width */
  width: Scalars['Int']['input'];
};

export enum ImageType {
  Other = 'OTHER',
  Primary = 'PRIMARY',
  Secondary = 'SECONDARY',
  WhiteBgPdf = 'WHITE_BG_PDF'
}

export enum InputAdormentIconTypeEnum {
  MeasurementTool = 'MEASUREMENT_TOOL',
  Reload = 'RELOAD'
}

export type InputAdormentInput = {
  /** If the Icon Path is present, we will fetch icons from the path. */
  iconPath?: InputMaybe<Scalars['String']['input']>;
  /** If the Icon Path is undefined, fallback to use static map on frontend. */
  iconType?: InputMaybe<InputAdormentIconTypeEnum>;
  /** Position of the Input Adorment */
  position?: InputMaybe<InputAdormentPositionEnum>;
};

export enum InputAdormentPositionEnum {
  End = 'END',
  Start = 'START'
}

export type InputAdormentType = {
  __typename?: 'InputAdormentType';
  /** If the Icon Path is present, we will fetch icons from the path. */
  iconPath?: Maybe<Scalars['String']['output']>;
  /** If the Icon Path is undefined, fallback to use static map on frontend. */
  iconType?: Maybe<InputAdormentIconTypeEnum>;
  /** Position of the Input Adorment */
  position?: Maybe<InputAdormentPositionEnum>;
};

export type InputGroupByWorkpackId = {
  pointOfInterestIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  workpackId?: InputMaybe<Scalars['ID']['input']>;
};

export type InputPointOfInterestTemplateField = {
  /** Logic engine expression to evaluate the equation key used for calculating the field value */
  calculatedBy?: InputMaybe<LogicEvaluationRuleInput>;
  /** Should this field be visible on first load inside a list or table */
  defaultVisible?: InputMaybe<Scalars['Boolean']['input']>;
  /** Key of field which has additional data for this field */
  detailFieldKey?: InputMaybe<Scalars['String']['input']>;
  /** Table configuration */
  displayConfig?: InputMaybe<DisplayConfigInput>;
  /** Identify if field should be shown in the poi filters */
  displayInQuery?: InputMaybe<Scalars['Boolean']['input']>;
  /** Should this field be displayed in report filters */
  displayInReportFilters?: InputMaybe<Scalars['Boolean']['input']>;
  /** Should this field be displayed in report */
  displayInReports?: InputMaybe<Scalars['Boolean']['input']>;
  /** Should this field be visible in review */
  displayInReview?: InputMaybe<Scalars['Boolean']['input']>;
  /** Identify if field should be shown in the poi table */
  displayInTable?: InputMaybe<Scalars['Boolean']['input']>;
  /** Unique Template Field ID */
  id?: InputMaybe<Scalars['ID']['input']>;
  /** Should not be shown in the UI. Used for identifying certain fields */
  isHidden?: InputMaybe<Scalars['Boolean']['input']>;
  /** Enable Measurement Tool */
  isMeasurementToolEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** Is this Template Field read-only; i.e. value cannot be updated */
  isReadOnly: Scalars['Boolean']['input'];
  /** Is this Template Field always required */
  isRequired: Scalars['Boolean']['input'];
  /** Key to identify field in template data */
  key?: InputMaybe<Scalars['String']['input']>;
  /** Logic engine expression to evaluate the field value */
  logicRule?: InputMaybe<LogicEvaluationRuleInput>;
  /** Name of this Template Field */
  name: Scalars['String']['input'];
  /** Valid options for this Template Field value */
  options: Array<Scalars['String']['input']>;
  /** Details of valid options for this Template Field value */
  optionsData?: InputMaybe<Array<OptionDataInput>>;
  /** Type of permission that a user have to read the template */
  permission?: InputMaybe<Scalars['String']['input']>;
  /** Should the template options be fetched from the server on runtime */
  serverSide: Scalars['Boolean']['input'];
  /** Identify if field's value should be evaluated using the logic engine */
  shouldEvaluateLogic?: InputMaybe<Scalars['Boolean']['input']>;
  /** Identify if field's value should be evaluated using the logic engine after the math engine */
  shouldEvaluateLogicPostCalculation?: InputMaybe<Scalars['Boolean']['input']>;
  /** Identify if field's value should be evaluated using the math engine */
  shouldEvaluateMath?: InputMaybe<Scalars['Boolean']['input']>;
  /** Type of this Template Field */
  type: TemplateFieldTypeEnum;
  /** Identity about the unit of the field */
  unit?: InputMaybe<UnitsEnum>;
};

export type InputUpdateFileForPointOfInterest = {
  /** File id which status needs to be updated */
  fileId: Scalars['ID']['input'];
  /** POI for which to attach files */
  pointOfInterestId: Scalars['ID']['input'];
  /** Upload status */
  uploadStatus: FileUploadStatus;
};

export type InputUpdateFileForWorkpack = {
  /** File id which status needs to be updated */
  fileId: Scalars['ID']['input'];
  /** Upload status */
  uploadStatus: FileUploadStatus;
  /** Workpack for which to update file status */
  workpackId: Scalars['ID']['input'];
};

export type InspectionPlan = {
  __typename?: 'InspectionPlan';
  createdBy?: Maybe<Scalars['String']['output']>;
  filters?: Maybe<InspectionPlanFilters>;
  id: Scalars['ID']['output'];
  isPlanPinned?: Maybe<Scalars['Boolean']['output']>;
  name: Scalars['String']['output'];
  structure: Structure;
};

export type InspectionPlanFilters = {
  __typename?: 'InspectionPlanFilters';
  deckIds?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  paintRegionIds?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  templateFilters?: Maybe<Array<Maybe<TemplateFilters>>>;
  workpackIds?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type InspectionPlanFiltersInput = {
  deckIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  paintRegionIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  templateFilters?: InputMaybe<Array<InputMaybe<TemplateFiltersInput>>>;
  workpackIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

/** Integer (number) metadata */
export type IntMeta = {
  __typename?: 'IntMeta';
  key: Scalars['String']['output'];
  value: Scalars['Int']['output'];
};

export type InviteUsersInput = {
  clientId: Scalars['String']['input'];
  connection: Scalars['String']['input'];
  emails: Array<Scalars['String']['input']>;
  groups: Array<Scalars['String']['input']>;
  roles: Array<Scalars['String']['input']>;
};

export type LabelAnnotation = {
  __typename?: 'LabelAnnotation';
  /** Unique Label Annotation ID */
  id: Scalars['ID']['output'];
  /** LabelClass this label-annotation belongs (structures.labelClass) */
  labelClassId: Scalars['ObjectId']['output'];
  /** Octree id the label-annotation belongs to */
  octreeId: Scalars['Int']['output'];
  /** Structure that this Label Annotation belongs to */
  structureId: Scalars['ObjectId']['output'];
};

export type LabelClass = {
  __typename?: 'LabelClass';
  color: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export enum LabelPositionEnum {
  Bottom = 'BOTTOM',
  End = 'END',
  Start = 'START',
  Top = 'TOP'
}

export type LineMeasurement = {
  __typename?: 'LineMeasurement';
  /** Signed URL of Location depth image used to calculate line distance */
  id: Scalars['String']['output'];
  /** Location document ID */
  image_id: Scalars['String']['output'];
  /** Line measurements */
  line: LineMeasurementResult;
  /** Measurements API status */
  status: MeasurementStatus;
};

export type LineMeasurementResult = {
  __typename?: 'LineMeasurementResult';
  /** Distance between line endpoints */
  distance: Array<Array<Scalars['Float']['output']>>;
  points2D: Array<Array<Scalars['Float']['output']>>;
  points3D: Array<Array<Scalars['Float']['output']>>;
};

/**
 * Location data of a Structure that has been inspected.
 *
 * An inspection takes place on the Location that involves data capture of a Structure in the form of spherical (panoramic) images or LIDAR scans.
 * This Location data of the Structure is then used to assess the conditions of Parts that compose the Structure and identify any defects on these Parts, such as corrosion.
 */
export type Location = {
  __typename?: 'Location';
  /** User who last analysed this Location */
  analysedBy?: Maybe<Scalars['String']['output']>;
  /** Resource path for angle calculation */
  angleResourcePath?: Maybe<Scalars['String']['output']>;
  /** Default resource path used as base path for layers */
  baseResourcePath?: Maybe<Scalars['String']['output']>;
  /** Path to contextualisation mapping json file */
  contextualisationMappingPath?: Maybe<Scalars['String']['output']>;
  /** Path to contextualised image */
  contextualisationPath?: Maybe<Scalars['String']['output']>;
  /** Date this Location was created */
  createdAt: Scalars['String']['output'];
  /** Deck that this Location data belongs to */
  deck: Deck;
  /** Position of Location on Deck plan */
  deckPlan?: Maybe<LocationDeckPlan>;
  /** URL for the Location depth map */
  depthResource?: Maybe<Scalars['String']['output']>;
  /** Relative path to the location depth map */
  depthResourcePath?: Maybe<Scalars['String']['output']>;
  /** Distance from asset */
  distance?: Maybe<Scalars['Float']['output']>;
  /** Unique Location ID */
  id: Scalars['ID']['output'];
  /** Image Sensor that was use for this location */
  imageSensor?: Maybe<ImageSensor>;
  /** Image layers that can be toggled */
  layers?: Maybe<Array<Maybe<LocationLayer>>>;
  /** User readable identifier for the Location */
  name: Scalars['String']['output'];
  /** Paint Region that this Location data belongs to */
  paintRegion?: Maybe<PaintRegion>;
  /** Id of the location in the external system */
  panoramaId?: Maybe<Scalars['String']['output']>;
  /** Camera pose of Location in grid coordinate system */
  pose?: Maybe<LocationPose>;
  /** URL for the Location scan data */
  resource?: Maybe<Scalars['String']['output']>;
  /** Relative path to the location scan data */
  resourcePath?: Maybe<Scalars['String']['output']>;
  /** Scan key used to identify the image and deck eg. LD/LDW0250 */
  scanKey?: Maybe<Scalars['String']['output']>;
  /** Size of the images used to build the resource path in layers */
  size?: Maybe<Scalars['String']['output']>;
  /** Structure that this Location data belongs to */
  structure: Structure;
  /** Date this Location was last updated */
  updatedAt: Scalars['String']['output'];
  /** User who last updated this Location */
  updatedBy?: Maybe<Scalars['String']['output']>;
  /** Video resource path */
  videoResourcePath?: Maybe<Scalars['String']['output']>;
  /** Video timestamp */
  videoTimestamp?: Maybe<Scalars['Float']['output']>;
};

export type LocationDeckPlan = {
  __typename?: 'LocationDeckPlan';
  /** [x,y] coordinates of Location on Deck plan */
  coordinates: Array<Scalars['Float']['output']>;
  /** Id of Location on Deck plan */
  id: Scalars['ID']['output'];
};

export type LocationLayer = {
  __typename?: 'LocationLayer';
  /** Name To Be Displayed */
  displayName: Scalars['String']['output'];
  /** File Extension eg. jpg, png, svg */
  fileExt?: Maybe<Scalars['String']['output']>;
  /** Type used in the url eg. rgb or bv (blister-vision) */
  type: Scalars['String']['output'];
};

export type LocationPose = {
  __typename?: 'LocationPose';
  /** Pitch angle (in radians) */
  pitch: Scalars['Float']['output'];
  /** Roll angle (in radians) */
  roll: Scalars['Float']['output'];
  /** X-axis */
  x: Scalars['Float']['output'];
  /** Y-axis */
  y: Scalars['Float']['output'];
  /** Yaw angle (in radians) */
  yaw: Scalars['Float']['output'];
  /** Yaw offset angle (in radians). Aligns spherical image with scan point cloud (depends on camera type) */
  yawOffset: Scalars['Float']['output'];
  /** Z-axis */
  z: Scalars['Float']['output'];
};

export type LocationsForAssemblyInput = {
  deckId: Scalars['ID']['input'];
  selectedTemplateFilters?: InputMaybe<Array<InputMaybe<FiltersInput>>>;
  structureId: Scalars['ID']['input'];
  workpackIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type LogCardsInput = {
  endDate?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['String']['input']>;
  structureIds: Array<Scalars['ID']['input']>;
  timezone: Scalars['String']['input'];
  workpackId?: InputMaybe<Scalars['ID']['input']>;
};

export enum LogCategory {
  CostLog = 'COST_LOG',
  QaqcForm = 'QAQC_FORM',
  Worklog = 'WORKLOG'
}

export enum LogEntriesPerDateFetchStrategy {
  Aggregated = 'AGGREGATED',
  Individual = 'INDIVIDUAL'
}

export type LogEntriesPerDateInput = {
  /** Category of log entry (WORKLOG, COST_LOG) */
  category: LogCategory;
  collectionName: Scalars['String']['input'];
  /**
   * Strategy to fetch log entries
   * AGGREGATED: Returns aggregated log entries from the first log, till `logDate`.
   * INDIVIDUAL: Returns only the logs for `logDate`. Returned array will only ever have one element
   */
  fetchStrategy: LogEntriesPerDateFetchStrategy;
  logDate: Scalars['String']['input'];
  /** Type of log entry (POB_CONFIG, OTHER, etc.) */
  logEntryType?: InputMaybe<LogEntryType>;
  referenceId: Scalars['ID']['input'];
  /** Day/Night shift */
  shift?: InputMaybe<ShiftType>;
  structureId: Scalars['ID']['input'];
  /** IANA timezone identifier (e.g. 'America/New_York', 'Australia/Sydney') for date filtering */
  timezone: Scalars['String']['input'];
};

export type LogEntry = {
  __typename?: 'LogEntry';
  /** Category of log entry (WORKLOG, COST_LOG, QAQC_FORM) */
  category: LogCategory;
  /** Name of MongoDB Collection where Reference Document resides (e.g., 'workpacks', 'structures') */
  collectionName: Scalars['String']['output'];
  /** Date this LogEntry was created */
  createdAt: Scalars['String']['output'];
  /** Auth0 ID of user who created this LogEntry */
  createdBy: Scalars['String']['output'];
  /** Field values (for WORKLOG and COST_LOG) */
  fieldValues: Array<LogFieldValue>;
  /** Unique LogEntry ID */
  id: Scalars['ID']['output'];
  /** Auth0 ID of user who last updated this Workpack */
  lastModifiedBy?: Maybe<Scalars['String']['output']>;
  /** Timestamp for the last update made from the API */
  lastModifiedByAPI?: Maybe<Scalars['String']['output']>;
  /** User who made the last update */
  lastModifiedByUser?: Maybe<User>;
  /** Reason for the last update */
  lastModifiedFor?: Maybe<Scalars['String']['output']>;
  /** Date of the log entry */
  logDate: Scalars['String']['output'];
  /** Identifier for the logs template that this log entry belongs to */
  logsTemplate: LogsTemplate;
  /** ID of the referenced entity (workpackId, structureId, etc.) */
  referenceId?: Maybe<Scalars['ID']['output']>;
  /** Section data (for QAQC_FORM) */
  sections: Array<LogSectionData>;
  /** Day/Night shift */
  shift?: Maybe<ShiftType>;
  /** Identifier for the Structure that this log entry belongs to */
  structure: Structure;
  /** Date this LogEntry was last updated */
  updatedAt: Scalars['String']['output'];
  /** Auth0 ID of user who last updated this LogEntry */
  updatedBy?: Maybe<Scalars['String']['output']>;
};

export type LogEntryCardsInput = {
  /** Category of log entry (WORKLOG, COST_LOG) */
  category: Array<LogCategory>;
  collectionName: Scalars['String']['input'];
  endDate?: InputMaybe<Scalars['String']['input']>;
  referenceId?: InputMaybe<Scalars['ID']['input']>;
  startDate?: InputMaybe<Scalars['String']['input']>;
  structureIds: Array<Scalars['ID']['input']>;
  timezone: Scalars['String']['input'];
};

export type LogEntryLogFieldTotal = {
  __typename?: 'LogEntryLogFieldTotal';
  fieldKey: Scalars['String']['output'];
  total: Scalars['Float']['output'];
};

export enum LogEntryType {
  Other = 'OTHER',
  PobConfig = 'POB_CONFIG'
}

export type LogFieldValue = {
  __typename?: 'LogFieldValue';
  /** Date this field value was created */
  createdAt: Scalars['String']['output'];
  /** Field key from template */
  fieldKey: Scalars['String']['output'];
  /** Unique LogFieldValue ID */
  id: Scalars['ID']['output'];
  /** Type of log entry field value (POB_CONFIG, OTHER, etc.) */
  type?: Maybe<LogEntryType>;
  /** Date this field value was last updated */
  updatedAt: Scalars['String']['output'];
  /** Numeric value */
  value: Scalars['Float']['output'];
};

export type LogFieldValueInput = {
  /** When true, this field value should be removed from the log entry */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Field key from template */
  fieldKey: Scalars['String']['input'];
  /** Type of log entry field value (POB_CONFIG, OTHER, etc.) */
  type?: InputMaybe<LogEntryType>;
  /** Numeric value */
  value: Scalars['Float']['input'];
};

export type LogSection = {
  __typename?: 'LogSection';
  defaultOpen?: Maybe<Scalars['Boolean']['output']>;
  /** Show in the logging screen */
  displayInLogging?: Maybe<Scalars['Boolean']['output']>;
  fieldKeys: Array<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  key: Scalars['String']['output'];
  order: Scalars['Int']['output'];
  sectionUnit?: Maybe<SectionUnitsEnum>;
  title: Scalars['String']['output'];
};

export type LogSectionData = {
  __typename?: 'LogSectionData';
  /** Date this section data was created */
  createdAt: Scalars['String']['output'];
  /** Multiple entries per section */
  entries: Array<LogSectionEntry>;
  /** Unique LogSectionData ID */
  id: Scalars['ID']['output'];
  /** Key from template (e.g., 'blast_phase', 'coating_phase') */
  sectionKey: Scalars['String']['output'];
  /** Display title */
  title: Scalars['String']['output'];
  /** Date this section data was last updated */
  updatedAt: Scalars['String']['output'];
};

export type LogSectionEntry = {
  __typename?: 'LogSectionEntry';
  /** Date this entry was created */
  createdAt: Scalars['String']['output'];
  /** Entry/row number (1, 2, 3, etc.) */
  entryIndex: Scalars['Int']['output'];
  /** Field values for this entry */
  fieldValues: Array<LogSectionFieldValue>;
  /** Unique LogSectionEntry ID */
  id: Scalars['ID']['output'];
  /** Date this entry was last updated */
  updatedAt: Scalars['String']['output'];
};

export type LogSectionFieldValue = {
  __typename?: 'LogSectionFieldValue';
  /** Date this field value was created */
  createdAt: Scalars['String']['output'];
  /** Field key from template field */
  fieldKey: Scalars['String']['output'];
  /** Unique LogSectionFieldValue ID */
  id: Scalars['ID']['output'];
  /** Numeric value (for numeric fields) */
  numericValue?: Maybe<Scalars['Float']['output']>;
  /** Unit for the field */
  unit?: Maybe<SectionUnitsEnum>;
  /** Date this field value was last updated */
  updatedAt: Scalars['String']['output'];
  /** Text value (for text inputs and dropdown selections) */
  value?: Maybe<Scalars['String']['output']>;
};

export type LogSectionInput = {
  /** Default open status of the section */
  defaultOpen?: InputMaybe<Scalars['Boolean']['input']>;
  /** Field keys of the section */
  fieldKeys: Array<Scalars['String']['input']>;
  /** Unique ID of the section */
  id?: InputMaybe<Scalars['ID']['input']>;
  /** Key of the section */
  key: Scalars['String']['input'];
  /** Order of the section */
  order: Scalars['Int']['input'];
  /** Section unit */
  sectionUnit?: InputMaybe<SectionUnitsEnum>;
  /** Title of the section */
  title: Scalars['String']['input'];
};

export enum LogTemplateType {
  CostLogTemplate = 'COST_LOG_TEMPLATE',
  QaqcTemplate = 'QAQC_TEMPLATE',
  WorklogTemplate = 'WORKLOG_TEMPLATE'
}

export type LogicEvaluationRule = {
  __typename?: 'LogicEvaluationRule';
  /** Array of conditional value mappings */
  conditionalMappings: Array<ConditionalValueMapping>;
  /** Default value to return if no conditions match */
  defaultValue?: Maybe<Scalars['String']['output']>;
  /** Description of what this rule evaluates */
  description?: Maybe<Scalars['String']['output']>;
  /** Strategy for evaluating the conditional mappings */
  evaluationStrategy: LogicEvaluationStrategy;
  /** List of variables used in the Rule */
  variables: Array<Variable>;
};

export type LogicEvaluationRuleInput = {
  /** Array of conditional value mappings */
  conditionalMappings: Array<ConditionalValueMappingInput>;
  /** Default value to return if no conditions match */
  defaultValue?: InputMaybe<Scalars['String']['input']>;
  /** Description of what this rule evaluates */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Strategy for evaluating the conditional mappings */
  evaluationStrategy: LogicEvaluationStrategy;
  /** List of variables used in the Rule */
  variables: Array<VariableInput>;
};

export enum LogicEvaluationStrategy {
  AllMatch = 'ALL_MATCH',
  AnyMatch = 'ANY_MATCH',
  FirstMatch = 'FIRST_MATCH'
}

export enum LogicOperator {
  And = 'AND',
  Or = 'OR'
}

/** Login Types */
export enum LoginTypeEnum {
  Email = 'EMAIL',
  Google = 'GOOGLE',
  Microsoft = 'MICROSOFT'
}

export type LogsTemplate = {
  __typename?: 'LogsTemplate';
  /** Aggregation level (workpack or structure) */
  aggregationLevel?: Maybe<Scalars['String']['output']>;
  /** Card configurations */
  cardsConfig?: Maybe<Array<Maybe<CardConfig>>>;
  /** Date this template was created */
  createdAt: Scalars['String']['output'];
  /** Auth0 ID of user who created this template */
  createdBy?: Maybe<Scalars['String']['output']>;
  /** Equations for calculations */
  equations?: Maybe<Array<Equation>>;
  /** Field definitions */
  fields: Array<LogsTemplateField>;
  /** Unique LogsTemplate ID */
  id: Scalars['ID']['output'];
  /** Key to identify this template */
  key: Scalars['String']['output'];
  /** Auth0 ID of the user who last updated this template */
  lastModifiedBy?: Maybe<Scalars['String']['output']>;
  /** Timestamp for the last update made from the API */
  lastModifiedByAPI?: Maybe<Scalars['String']['output']>;
  /** User who made the last update */
  lastModifiedByUser?: Maybe<User>;
  /** Reason for the last update */
  lastModifiedFor?: Maybe<Scalars['String']['output']>;
  /** List of structure IDs that are linked to this template (for syncing across structures) */
  linkedStructureIds?: Maybe<Array<Scalars['ID']['output']>>;
  /** Name of this LogsTemplate */
  name: Scalars['String']['output'];
  /** QA/QC specific configuration */
  qaqcConfig: Array<QaqcSectionConfig>;
  /** Sections for organizing fields */
  sections: Array<LogSection>;
  /** Identifier for the Structure that this log template belongs to */
  structure: Structure;
  /** Template-specific settings - supports multiple entries (for QA/QC forms) */
  supportsMultipleEntries?: Maybe<Scalars['Boolean']['output']>;
  /** Template-specific settings - supports day/night shifts */
  supportsShifts?: Maybe<Scalars['Boolean']['output']>;
  /** Type of template (WORKLOG_TEMPLATE, COST_LOG_TEMPLATE, QAQC_TEMPLATE) */
  type: LogTemplateType;
  /** Date this template was last updated */
  updatedAt: Scalars['String']['output'];
};

export type LogsTemplateField = {
  __typename?: 'LogsTemplateField';
  /** Logic engine expression to evaluate the equation key used for calculating the field value */
  calculatedBy?: Maybe<LogicEvaluationRule>;
  /** Should this field be visible on first load inside a list or table */
  defaultVisible?: Maybe<Scalars['Boolean']['output']>;
  derivedEquationKey?: Maybe<Scalars['String']['output']>;
  /** Key of field which has additional data for this field */
  detailFieldKey?: Maybe<Scalars['String']['output']>;
  /** Table configuration */
  displayConfig?: Maybe<DisplayConfig>;
  displayInLogAggregation?: Maybe<Scalars['Boolean']['output']>;
  /** Show in the logging screen */
  displayInLogging?: Maybe<Scalars['Boolean']['output']>;
  /** Identify if field should be shown in the poi filters */
  displayInQuery?: Maybe<Scalars['Boolean']['output']>;
  /** Should this field be displayed in report filters */
  displayInReportFilters?: Maybe<Scalars['Boolean']['output']>;
  /** Should this field be hidden in report */
  displayInReports?: Maybe<Scalars['Boolean']['output']>;
  /** Should this field be visible in review */
  displayInReview?: Maybe<Scalars['Boolean']['output']>;
  /** Identify if field should be shown in the poi table */
  displayInTable?: Maybe<Scalars['Boolean']['output']>;
  fieldDescription?: Maybe<Scalars['String']['output']>;
  fieldUnit?: Maybe<SectionUnitsEnum>;
  /** Unique Template Field ID */
  id: Scalars['ID']['output'];
  isDerived?: Maybe<Scalars['Boolean']['output']>;
  /** Should not be shown in the UI. Used for identifying certain fields */
  isHidden?: Maybe<Scalars['Boolean']['output']>;
  /** Enable Measurement Tool */
  isMeasurementToolEnabled?: Maybe<Scalars['Boolean']['output']>;
  /** Is this field part of QA/QC form */
  isQaqc?: Maybe<Scalars['Boolean']['output']>;
  /** Is this Template Field read-only; i.e. value cannot be updated */
  isReadOnly: Scalars['Boolean']['output'];
  /** Is this Template Field always required */
  isRequired: Scalars['Boolean']['output'];
  /** Key to identify field in template data */
  key?: Maybe<Scalars['String']['output']>;
  /** Logic engine expression to evaluate the field value */
  logicRule?: Maybe<LogicEvaluationRule>;
  /** Name of this Template Field */
  name: Scalars['String']['output'];
  /** Valid options for this Template Field value */
  options: Array<Scalars['String']['output']>;
  /** Details of valid options for this Template Field value */
  optionsData?: Maybe<Array<OptionData>>;
  /** Type of permission that a user have to read the template */
  permission?: Maybe<Scalars['String']['output']>;
  /** Round to decimal places */
  roundToDecimal?: Maybe<Scalars['Int']['output']>;
  sectionKey?: Maybe<Scalars['String']['output']>;
  /** Should the template options be fetched from the server on runtime */
  serverSide: Scalars['Boolean']['output'];
  /** Identify if field's value should be evaluated using the logic engine */
  shouldEvaluateLogic?: Maybe<Scalars['Boolean']['output']>;
  /** Identify if field's value should be evaluated using the logic engine after the math engine */
  shouldEvaluateLogicPostCalculation?: Maybe<Scalars['Boolean']['output']>;
  /** Identify if field's value should be evaluated using the math engine */
  shouldEvaluateMath?: Maybe<Scalars['Boolean']['output']>;
  /** Type of this Template Field */
  type: TemplateFieldTypeEnum;
  /** Identity about the unit of the field */
  unit?: Maybe<UnitsEnum>;
};

export type LogsTemplateFieldInput = {
  /** Logic engine expression to evaluate the equation key used for calculating the field value */
  calculatedBy?: InputMaybe<LogicEvaluationRuleInput>;
  /** Should this field be visible on first load inside a list or table */
  defaultVisible?: InputMaybe<Scalars['Boolean']['input']>;
  derivedEquationKey?: InputMaybe<Scalars['String']['input']>;
  /** Key of field which has additional data for this field */
  detailFieldKey?: InputMaybe<Scalars['String']['input']>;
  /** Table configuration */
  displayConfig?: InputMaybe<DisplayConfigInput>;
  displayInLogAggregation?: InputMaybe<Scalars['Boolean']['input']>;
  /** Show in the logging screen */
  displayInLogging?: InputMaybe<Scalars['Boolean']['input']>;
  /** Identify if field should be shown in the poi filters */
  displayInQuery?: InputMaybe<Scalars['Boolean']['input']>;
  /** Should this field be displayed in report filters */
  displayInReportFilters?: InputMaybe<Scalars['Boolean']['input']>;
  /** Should this field be hidden in report */
  displayInReports?: InputMaybe<Scalars['Boolean']['input']>;
  /** Should this field be visible in review */
  displayInReview?: InputMaybe<Scalars['Boolean']['input']>;
  /** Identify if field should be shown in the poi table */
  displayInTable?: InputMaybe<Scalars['Boolean']['input']>;
  fieldDescription?: InputMaybe<Scalars['String']['input']>;
  fieldUnit?: InputMaybe<SectionUnitsEnum>;
  /** Unique ID Template Field */
  id?: InputMaybe<Scalars['ID']['input']>;
  isDerived?: InputMaybe<Scalars['Boolean']['input']>;
  /** Should not be shown in the UI. Used for identifying certain fields */
  isHidden?: InputMaybe<Scalars['Boolean']['input']>;
  /** Enable Measurement Tool */
  isMeasurementToolEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** Is this field part of QA/QC form */
  isQaqc?: InputMaybe<Scalars['Boolean']['input']>;
  /** Is this Template Field read-only; i.e. value cannot be updated */
  isReadOnly?: InputMaybe<Scalars['Boolean']['input']>;
  /** Is this Template Field always required */
  isRequired?: InputMaybe<Scalars['Boolean']['input']>;
  /** Key to identify field in template data */
  key?: InputMaybe<Scalars['String']['input']>;
  /** Logic engine expression to evaluate the field value */
  logicRule?: InputMaybe<LogicEvaluationRuleInput>;
  /** Name of this Template Field */
  name: Scalars['String']['input'];
  /** Valid options for this Template Field value */
  options?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Details of valid options for this Template Field value */
  optionsData?: InputMaybe<Array<OptionDataInput>>;
  /** Type of permission that a user have to read the template */
  permission?: InputMaybe<Scalars['String']['input']>;
  /** Round to decimal places */
  roundToDecimal?: InputMaybe<Scalars['Int']['input']>;
  sectionKey?: InputMaybe<Scalars['String']['input']>;
  /** Should the template options be fetched from the server on runtime */
  serverSide?: InputMaybe<Scalars['Boolean']['input']>;
  /** Identify if field's value should be evaluated using the logic engine */
  shouldEvaluateLogic?: InputMaybe<Scalars['Boolean']['input']>;
  /** Identify if field's value should be evaluated using the logic engine after the math engine */
  shouldEvaluateLogicPostCalculation?: InputMaybe<Scalars['Boolean']['input']>;
  /** Identify if field's value should be evaluated using the math engine */
  shouldEvaluateMath?: InputMaybe<Scalars['Boolean']['input']>;
  /** Type of this Template Field */
  type: TemplateFieldTypeEnum;
  /** Identity about the unit of the field */
  unit?: InputMaybe<UnitsEnum>;
};

export type LogsTemplateInput = {
  /** Structure relation for this logs template */
  structureId: Scalars['ID']['input'];
  /** Type of template (WORKLOG_TEMPLATE, COST_LOG_TEMPLATE, QAQC_TEMPLATE) */
  type: LogTemplateType;
};

export type MarkLocationAnalysedInput = {
  isAnalysed: Scalars['Boolean']['input'];
  locationId: Scalars['ID']['input'];
};

export type MarkViewPointAsAnalysedFromCurrentAssemblyInput = {
  assemblyId: Scalars['ID']['input'];
  lastModifiedFor: Scalars['String']['input'];
  viewpointId: Scalars['ID']['input'];
};

export type MarkerLabelConfig = {
  __typename?: 'MarkerLabelConfig';
  /** List of fields to display in the marker label */
  fields: Array<MarkerLabelField>;
  /** Optional header field for the marker label */
  headerField?: Maybe<MarkerLabelField>;
  /** Flag to hide name in marker label */
  hideName?: Maybe<Scalars['Boolean']['output']>;
  /** Type of marker label configuration (compact by default) */
  type: MarkerLabelConfigTypeEnum;
};

export type MarkerLabelConfigInput = {
  /** List of fields to display in the marker label */
  fields: Array<MarkerLabelFieldInput>;
  /** Optional header field for the marker label */
  headerField?: InputMaybe<MarkerLabelFieldInput>;
  /** Flag to hide name in marker label */
  hideName?: InputMaybe<Scalars['Boolean']['input']>;
  /** Type of marker label configuration (compact by default) */
  type?: InputMaybe<MarkerLabelConfigTypeEnum>;
};

export enum MarkerLabelConfigTypeEnum {
  Compact = 'COMPACT',
  Detailed = 'DETAILED'
}

export type MarkerLabelField = {
  __typename?: 'MarkerLabelField';
  /** Field key */
  key: Scalars['String']['output'];
  /** Type of marker label field */
  type?: Maybe<MarkerLabelFieldTypeEnum>;
};

export type MarkerLabelFieldInput = {
  /** Field key */
  key: Scalars['String']['input'];
  /** Type of marker label field */
  type?: InputMaybe<MarkerLabelFieldTypeEnum>;
};

export enum MarkerLabelFieldTypeEnum {
  Blister = 'BLISTER',
  PointOfInterest = 'POINT_OF_INTEREST',
  TemplateField = 'TEMPLATE_FIELD'
}

export type MaterialType = {
  __typename?: 'MaterialType';
  /** Category representing the material's resistance to corrosion */
  corrosivityCategory?: Maybe<Array<CorrosivityCategoryItem>>;
  /** Classification that quantifies material performance across different thickness ranges */
  environmentalClassification?: Maybe<Array<EnvironmentalClassificationItem>>;
  /** Envionmental Exposure for the material */
  environmentalExposure?: Maybe<Array<EnvironmentalExposureItem>>;
  /** Different thickness ranges of the material */
  thickness?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Identifying type of material */
  type: Scalars['String']['output'];
};

export enum MathOperator {
  Add = 'ADD',
  Avg = 'AVG',
  Cosine = 'COSINE',
  Count = 'COUNT',
  DailyAvg = 'DAILY_AVG',
  Divide = 'DIVIDE',
  Logarithm = 'LOGARITHM',
  Max = 'MAX',
  Min = 'MIN',
  Multiply = 'MULTIPLY',
  Power = 'POWER',
  Sine = 'SINE',
  SquareRoot = 'SQUARE_ROOT',
  Subtract = 'SUBTRACT'
}

export type MeasurementStatus = {
  __typename?: 'MeasurementStatus';
  /** Location depth image cache status */
  cacheStatus: Scalars['String']['output'];
  /** Blister measurement fitting radius */
  fittingRadius?: Maybe<Scalars['Float']['output']>;
  /** Blister measurement target radius */
  targetRadius?: Maybe<Scalars['Float']['output']>;
  /** Blister measurement window size */
  windowSize: Array<Scalars['Int']['output']>;
};

export enum MeasurementUnitEnum {
  /** US Imperial units of measurement */
  Imperial = 'IMPERIAL',
  /** Metric units of measurement */
  Metric = 'METRIC'
}

export type MechanicalIntegrityServicesResponse = {
  __typename?: 'MechanicalIntegrityServicesResponse';
  message?: Maybe<Scalars['String']['output']>;
  status: Scalars['String']['output'];
};

/** Meta is used for storing data with dynamic keys */
export type Meta = DefectColorMeta | FloatMeta | IntMeta | StringArrayMeta | StringMeta;

export type MiServicesInput = {
  structureId: Scalars['ID']['input'];
  templateId: Scalars['ID']['input'];
  type: Scalars['String']['input'];
};

export type MiServicesPoiTemplateInput = {
  structureId: Scalars['ID']['input'];
  templateIds: Array<Scalars['ID']['input']>;
};

export type ModeInput = {
  defects: Array<Scalars['String']['input']>;
  heightRange: Array<Scalars['Int']['input']>;
  includeValues?: InputMaybe<Array<Scalars['Int']['input']>>;
  modes: Array<Scalars['String']['input']>;
  type: Scalars['String']['input'];
};

export type Mutation = {
  __typename?: 'Mutation';
  /** Group POI into a single workpack group */
  GroupPointOfInterestsByWorkpackId?: Maybe<Array<Maybe<PointOfInterest>>>;
  /** Remove POI from Workpack */
  RemoveWorkpackIdFromPointOfInterests?: Maybe<Array<Maybe<PointOfInterest>>>;
  /** Add alarm level field to POI templates */
  addAlarmLevelFieldToPoiTemplates?: Maybe<Array<Maybe<PointOfInterestTemplate>>>;
  addAndRemoveFiles?: Maybe<Scalars['Boolean']['output']>;
  addAssemblyImageCaption?: Maybe<Scalars['String']['output']>;
  /** Option to add Assessment Details Fields to the template */
  addAssessmentDetailsFields?: Maybe<Template>;
  /** Option to add BSP MI Services overhaul fields to the template */
  addBspMiServicesOverhaulFields?: Maybe<Template>;
  /** Option to add BSP MI Services overhaul fields to the blister and pit template */
  addBspMiServicesOverhaulFieldsToPoiTemplates?: Maybe<Array<Maybe<PointOfInterestTemplate>>>;
  /** Handle Edit Roles for Template Fields */
  addEditRolesToTemplateField?: Maybe<Template>;
  /** Add logs template to all log entries for a structure and category */
  addLogsTemplate: Array<LogEntry>;
  /** Option to add MI Services fields to the template */
  addMiServicesFields?: Maybe<Template>;
  /** Option to add MI Services overhaul fields to the template */
  addMiServicesOverhaulFields?: Maybe<Template>;
  /** Option to add MI Services overhaul fields to the blister and pit template */
  addMiServicesOverhaulFieldsToPoiTemplates?: Maybe<Array<Maybe<PointOfInterestTemplate>>>;
  addNewAssemblyTagName?: Maybe<Assembly>;
  /** Add partial remediation entry for paint blocks. */
  addPartialRemediation: Array<AssemblyPaintRegion>;
  addPartsToAssembly: Array<Part>;
  /** Add report configuration for structure */
  addReportConfiguration?: Maybe<Structure>;
  addStructurePipes?: Maybe<Scalars['String']['output']>;
  /** Adds or Updates the batch */
  addUpdateBatchInput?: Maybe<Batch>;
  /** Adds or Updates the Split Cuboid on the Part */
  addUpdateCuboid?: Maybe<Cuboid>;
  /** Adds or Updates the processing job */
  addUpdateProcessingJobInput?: Maybe<ProcessingJob>;
  /** Adds or Updates the Split Cuboid on the Part */
  addUpdateSplitCuboidOnPart: AddUpdateSplitCuboidOnPartNotification;
  addUserGroupsToStructure?: Maybe<StructuresAndGroups>;
  addUsersToTeam: Team;
  addUsersToUserGroup?: Maybe<UserGroup>;
  /** Option to add Viewpoint Count field to the assembly template */
  addViewpointCountField?: Maybe<Template>;
  addWorkpackTemplate?: Maybe<Array<Maybe<Workpack>>>;
  /** Archive (soft delete) an existing POI */
  archivePointOfInterest?: Maybe<PointOfInterest>;
  /** Calculate area and POI risk scores for assembly paint regions */
  areaAndPoiRiskScoreCalculation: Scalars['JSON']['output'];
  assignRoleToUsers: Role;
  backfillViewpointCounts: Scalars['Boolean']['output'];
  benchmarkDownload?: Maybe<BenchmarkDownloadOutput>;
  benchmarkUpload?: Maybe<BenchmarkUploadOutput>;
  blockOrUnblockUser: User;
  /** Bulk archive multiple points of interest */
  bulkArchivePointOfInterests: BulkArchiveResponse;
  bulkCreateCommentsForAssemblies?: Maybe<BulkCreateOrUpdateCommentsForAssemblies>;
  bulkLineFixing: BulkLineFixingResult;
  bulkPipeSpecUpload: BulkPipeSpecUploadResponse;
  /** Bulk Update Review Action */
  bulkUpdateReviewAction?: Maybe<BulkUpdateReviewActionResponse>;
  bulkUploadPois: Array<PointOfInterest>;
  bulkUploadServiceGroups: BulkServiceGroupsResponse;
  /** Calculate defect calculations (coating and corrosion) */
  calculateDefectCalculations: DefectCalculationsResult;
  /** Calculate risk remediation analytics for dashboard */
  calculateRiskRemediationAnalytics: Analytics;
  /** Clones an existing POITemplate with a different structureId */
  clonePointOfInterestTemplate?: Maybe<Array<Maybe<PointOfInterestTemplate>>>;
  /** Clones an existing POITemplate with a different structureId */
  cloneQuerySummary?: Maybe<Template>;
  /** Clones an existing POITemplate with a different structureId */
  cloneTemplateFields?: Maybe<Template>;
  /** Copy logs template */
  copyLogsTemplate?: Maybe<LogsTemplate>;
  /** Copy workpack template */
  copyWorkpackTemplate?: Maybe<WorkpackTemplate>;
  createAnnotation?: Maybe<Annotation>;
  createAssembly?: Maybe<Template>;
  createBulkReports: Array<Maybe<Report>>;
  createComment: Comment;
  createInspectionPlan?: Maybe<InspectionPlan>;
  /** Create a new log entry */
  createLogEntry: LogEntry;
  /** Create a new logs template */
  createLogsTemplate?: Maybe<LogsTemplate>;
  createNewReport: Report;
  /** Create a new POI */
  createPointOfInterest?: Maybe<PointOfInterest>;
  /** Creates a new POITemplate */
  createPointOfInterestTemplate?: Maybe<PointOfInterestTemplate>;
  createPreRegisteredUsers: UserInvite;
  createRegion?: Maybe<Region>;
  /** Creates risk assessment details */
  createRiskAssessmentDetails?: Maybe<Structure>;
  /** Creates a new structure */
  createStructure?: Maybe<Structure>;
  createSupervoxelClass?: Maybe<SupervoxelClass>;
  createTeam: Team;
  /** Create a new Template */
  createTemplate?: Maybe<Template>;
  createUserGroup?: Maybe<UserGroup>;
  /** Create a new workflow stage */
  createWorkflowStage?: Maybe<Structure>;
  createWorkpack?: Maybe<Workpack>;
  createWorkpackItem?: Maybe<WorkpackItem>;
  /** Create a new workpack template */
  createWorkpackTemplate?: Maybe<WorkpackTemplate>;
  deleteAssemblyFromReport: Report;
  deleteComment: Comment;
  /** Removes the Split Cuboid on the Part */
  deleteCuboid?: Maybe<Scalars['ID']['output']>;
  deleteDraftReport: Report;
  deleteFiles: DeleteFilesPayload;
  deleteInspectionPlan?: Maybe<InspectionPlan>;
  /** Delete a log entry */
  deleteLogEntry: LogEntry;
  /** Remove a planner column from a template */
  deletePlannerColumn?: Maybe<Template>;
  deletePointOfInterestFromReport: Report;
  /** Deletes a POI Template */
  deletePointOfInterestTemplate?: Maybe<PointOfInterestTemplate>;
  deletePreRegisteredUser?: Maybe<PreRegisteredUser>;
  deleteReport: Scalars['Boolean']['output'];
  deleteStructurePipe?: Maybe<Scalars['String']['output']>;
  deleteTeam: Scalars['ID']['output'];
  /** Delete an existing Template */
  deleteTemplate?: Maybe<Template>;
  deleteUserGroup?: Maybe<UserGroup>;
  /** Delete workflow stage */
  deleteWorkflowStage?: Maybe<Structure>;
  deleteWorkpack?: Maybe<Workpack>;
  deleteWorkpackItem?: Maybe<WorkpackItem>;
  editStructurePipe?: Maybe<Scalars['String']['output']>;
  evaluateAllAssembliesForStructure?: Maybe<Structure>;
  /** Evaluate all POIs for a structure */
  evaluateAllPOIsForStructure?: Maybe<Structure>;
  evaluateTemplateFieldLogicRule?: Maybe<EvaluateTemplateFieldLogicRuleResult>;
  generateReportPdf: PdfGenerationResult;
  idmsFileUpload?: Maybe<IdmsUpload>;
  inviteUsers: UserInvite;
  markLocationAnalysed?: Maybe<Location>;
  markViewPointAsAnalysedFromCurrentAssembly?: Maybe<Assembly>;
  nominateGoverningPointOfInterest?: Maybe<Scalars['String']['output']>;
  /** Perform Mechanical Integrity Services */
  performMechanicalIntegrityServices?: Maybe<MechanicalIntegrityServicesResponse>;
  /** Permanently delete an archived point of interest */
  permanentlyDeletePointOfInterest: PermanentDeleteResponse;
  /** Add Caption To Poi Image */
  poiImageCaption?: Maybe<Scalars['String']['output']>;
  preSignedUrlToUploadFiles: Array<GeneratedPresignedUrl>;
  /** Process and extract POI data from PDF documents using LLM, creating new POIs with partial results and error details */
  processPdfForPoi: ProcessPdfForPoiResponse;
  reOrderAssemblyImages?: Maybe<Array<Maybe<File>>>;
  /** Recalculate platform risk scores by aggregating from assembly paint regions */
  recalculatePlatformRiskScores: RecalculatePlatformRiskScoresResult;
  /** Recalculate risk remediation analytics for dashboard */
  recalculateRiskRemediationAnalytics: RecalculateRiskRemediationAnalyticsResult;
  /** Remove attachments from a POI */
  removeAttachmentsFromPoi?: Maybe<PointOfInterest>;
  removeRoleFromUsers: Role;
  /** Removes the Split Cuboid on the Part */
  removeSplitCuboidOnPart: RemoveSplitCuboidOnPartNotification;
  removeUserGroupsFromStructure?: Maybe<StructuresAndGroups>;
  removeUsersFromTeam: Team;
  removeUsersFromUserGroup?: Maybe<UserGroup>;
  removeWorkpackAttachments?: Maybe<Workpack>;
  resetPassword: Scalars['String']['output'];
  /** Restore an archived point of interest */
  restorePointOfInterest?: Maybe<PointOfInterest>;
  revertBulkLineFixing: BulkLineFixingResult;
  /** Rollback to a previous version of a document */
  rollbackVersion: Version;
  saveAssemblyScreenshot?: Maybe<Array<Maybe<Assembly>>>;
  /** Save screenshot of a POI */
  savePointOfInterestScreenshot?: Maybe<PointOfInterest>;
  setAlarmLevel?: Maybe<AlarmLevelRecommendation>;
  setHiddenForParts: Array<Scalars['String']['output']>;
  setReviewedForParts: Array<Scalars['String']['output']>;
  splitPart: Part;
  /** Sync analytics data for multiple structures and platform */
  syncAnalyticsData: SyncAnalyticsDataResult;
  /** Sync logs templates */
  syncLogsTemplates: LogsTemplate;
  /** Sync nested field options from assembly template field data */
  syncNestedFieldOptions?: Maybe<Template>;
  /** Sync workpack templates */
  syncWorkpackTemplates: WorkpackTemplate;
  updateAssembliesProbabilityOfFailureRiskFactors?: Maybe<Array<Maybe<Assembly>>>;
  updateAssembly?: Maybe<Assembly>;
  /** Create or Update Blister POI Recommendation for Assembly (unique by Assembly ID / Blister POI name pair) */
  updateAssemblyBlisters: PointOfInterest;
  updateAssemblyRemediation?: Maybe<Scalars['String']['output']>;
  updateAssemblyTable?: Maybe<Scalars['String']['output']>;
  /** Override calculation method for a POI */
  updateCalculationMethod?: Maybe<PointOfInterest>;
  updateComment: Comment;
  updateCuiPriority?: Maybe<Assembly>;
  updateEsSheetStatus: Structure;
  updateFilesStatus?: Maybe<Scalars['Boolean']['output']>;
  updateFleetHealth: Array<Platform>;
  updateGoverningValue?: Maybe<Assembly>;
  updateInspectionPlan?: Maybe<InspectionPlan>;
  /** Update an existing log entry */
  updateLogEntry: LogEntry;
  /** Update logs template */
  updateLogsTemplate?: Maybe<LogsTemplate>;
  /** Bulk update Paint Region ID for POIs */
  updatePaintRegionId?: Maybe<Array<Maybe<PointOfInterest>>>;
  updatePaintRegionStatus: PaintRegion;
  /** Update an existing POI */
  updatePointOfInterest?: Maybe<PointOfInterest>;
  /** Update file upload status of specific file */
  updatePointOfInterestFile: PointOfInterest;
  /** Update Point of Interest Image */
  updatePointOfInterestImageType?: Maybe<PointOfInterest>;
  /** Update Point of Interest Location */
  updatePointOfInterestLocation?: Maybe<PointOfInterest>;
  /** Updates an exists POITemplate */
  updatePointOfInterestTemplate?: Maybe<PointOfInterestTemplate>;
  /** Update existing POIs visibility */
  updatePointOfInterestVisibility: Array<PointOfInterest>;
  /** Update POI status */
  updatePointOfInterestsStatus?: Maybe<Scalars['String']['output']>;
  /** Update Remediation Score Configuration */
  updateRemediationScoreConfig?: Maybe<Template>;
  updateReport: Report;
  updateReportByPointOfInterests: Report;
  updateReportPointOfInterestImages: Report;
  updateReportStatus: Report;
  /** Update Risk Assement In Template Field Data And Calculate Transition Period As Well */
  updateRiskAssessmentTemplateFieldDataAndTransitionPeriod?: Maybe<UpdateRiskAssessmentTemplateFieldDataAndTransitionPeriod>;
  updateRiskAssessmentTemplateFieldDataForAssemblies?: Maybe<Array<Maybe<Assembly>>>;
  updateScCategory?: Maybe<Assembly>;
  /** Updates scansToCadTransfrom of structure */
  updateScansToCadTransform?: Maybe<Structure>;
  updateSingleTemplateFieldData?: Maybe<Assembly>;
  /** Updates an existing Structure */
  updateStructure?: Maybe<Structure>;
  updateSupervoxels: Array<SuperVoxels>;
  /** Update a Template */
  updateTemplate?: Maybe<Template>;
  /** UpdateTemplateFieldData mutation is used by ES-Sheet in v1 to directly populate features in v2 */
  updateTemplateFieldData?: Maybe<UpdatedTemplateFieldDataResult>;
  updateUserColumnPreferences?: Maybe<User>;
  updateUserGroup?: Maybe<UserGroup>;
  /** Create or update auth0 user profile info in mongo */
  updateUserInfo?: Maybe<User>;
  updateUserPlatformPreferences?: Maybe<User>;
  updateUserPreferences?: Maybe<User>;
  updateUserStructurePreferences?: Maybe<UserPreferences>;
  /** Bulk update of WalllossFactor and its Calculations */
  updateWallLossFactor?: Maybe<Scalars['String']['output']>;
  updateWorkLog?: Maybe<Workpack>;
  /** Update workflow status of the structure */
  updateWorkflowStage?: Maybe<Structure>;
  updateWorkflowStatus?: Maybe<Array<Maybe<Zone>>>;
  updateWorkflowTimeAndState?: Maybe<Zone>;
  updateWorkpack?: Maybe<Workpack>;
  /** Update file upload status of specific file */
  updateWorkpackAttachmentFileStatus: Workpack;
  updateWorkpackItem?: Maybe<WorkpackItem>;
  updateWorkpackStatus?: Maybe<Workpack>;
  /** Update workpack template */
  updateWorkpackTemplate?: Maybe<WorkpackTemplate>;
  updateZoneStatus: ZoneUpdate;
  /** Upload attachments to a POI */
  uploadAttachmentsToPoi: Array<GeneratedPresignedUrl>;
  /** Upload cover image for structure */
  uploadCoverImage?: Maybe<Structure>;
  uploadEsSheet: Scalars['String']['output'];
  uploadLegacyEsSheet: Scalars['String']['output'];
  uploadWorkpackAttachments: Array<GeneratedPresignedUrl>;
  /** Create or update a log entry (upsert) */
  upsertLogEntry: LogEntry;
  validateEsSheet: Scalars['String']['output'];
  /** Verify a POI */
  verifyPointOfInterest?: Maybe<PointOfInterest>;
};


export type MutationGroupPointOfInterestsByWorkpackIdArgs = {
  input?: InputMaybe<InputGroupByWorkpackId>;
};


export type MutationRemoveWorkpackIdFromPointOfInterestsArgs = {
  input?: InputMaybe<InputGroupByWorkpackId>;
};


export type MutationAddAlarmLevelFieldToPoiTemplatesArgs = {
  input?: InputMaybe<MiServicesPoiTemplateInput>;
};


export type MutationAddAndRemoveFilesArgs = {
  input: UpdateFilesInput;
};


export type MutationAddAssemblyImageCaptionArgs = {
  input?: InputMaybe<AssemblyImageCaptionInput>;
};


export type MutationAddAssessmentDetailsFieldsArgs = {
  input?: InputMaybe<AssessmentDetailsInput>;
};


export type MutationAddBspMiServicesOverhaulFieldsArgs = {
  input?: InputMaybe<MiServicesInput>;
};


export type MutationAddBspMiServicesOverhaulFieldsToPoiTemplatesArgs = {
  input?: InputMaybe<MiServicesPoiTemplateInput>;
};


export type MutationAddEditRolesToTemplateFieldArgs = {
  input?: InputMaybe<EditRolesInput>;
};


export type MutationAddLogsTemplateArgs = {
  input: AddLogsTemplateInput;
};


export type MutationAddMiServicesFieldsArgs = {
  input?: InputMaybe<MiServicesInput>;
};


export type MutationAddMiServicesOverhaulFieldsArgs = {
  input?: InputMaybe<MiServicesInput>;
};


export type MutationAddMiServicesOverhaulFieldsToPoiTemplatesArgs = {
  input?: InputMaybe<MiServicesPoiTemplateInput>;
};


export type MutationAddNewAssemblyTagNameArgs = {
  input?: InputMaybe<AddNewAssemblyTagNameInput>;
};


export type MutationAddPartialRemediationArgs = {
  input: AddPartialRemediationInput;
};


export type MutationAddPartsToAssemblyArgs = {
  input?: InputMaybe<AddPartsToAssemblyInput>;
};


export type MutationAddReportConfigurationArgs = {
  structureId: Scalars['ID']['input'];
};


export type MutationAddStructurePipesArgs = {
  input?: InputMaybe<AddStructurePipesInput>;
};


export type MutationAddUpdateBatchInputArgs = {
  input?: InputMaybe<AddUpdateBatchInput>;
};


export type MutationAddUpdateCuboidArgs = {
  input?: InputMaybe<AddUpdateCuboidInput>;
};


export type MutationAddUpdateProcessingJobInputArgs = {
  input?: InputMaybe<AddUpdateProcessingJobInput>;
};


export type MutationAddUpdateSplitCuboidOnPartArgs = {
  input?: InputMaybe<AddUpdateSplitCuboidOnPartInput>;
};


export type MutationAddUserGroupsToStructureArgs = {
  input?: InputMaybe<AddRemoveStructuresToFromUserGroupsInput>;
};


export type MutationAddUsersToTeamArgs = {
  input: UpdateTeamInput;
};


export type MutationAddUsersToUserGroupArgs = {
  input?: InputMaybe<AddRemoveUsersToFromUserGroupInput>;
};


export type MutationAddViewpointCountFieldArgs = {
  input?: InputMaybe<MiServicesInput>;
};


export type MutationAddWorkpackTemplateArgs = {
  input: AddWorkpackTemplateInput;
};


export type MutationArchivePointOfInterestArgs = {
  pointOfInterestId: Scalars['ID']['input'];
};


export type MutationAreaAndPoiRiskScoreCalculationArgs = {
  structureId: Scalars['ID']['input'];
};


export type MutationAssignRoleToUsersArgs = {
  input?: InputMaybe<AssignRemoveRoleToFromUsersInput>;
};


export type MutationBackfillViewpointCountsArgs = {
  structureId: Scalars['String']['input'];
};


export type MutationBenchmarkDownloadArgs = {
  input?: InputMaybe<BenchmarkDownloadInput>;
};


export type MutationBenchmarkUploadArgs = {
  input?: InputMaybe<BenchmarkUploadInput>;
};


export type MutationBlockOrUnblockUserArgs = {
  userId: Scalars['ID']['input'];
};


export type MutationBulkArchivePointOfInterestsArgs = {
  pointOfInterestIds: Array<Scalars['ID']['input']>;
};


export type MutationBulkCreateCommentsForAssembliesArgs = {
  input?: InputMaybe<BulkCreateForAssembliesInput>;
};


export type MutationBulkLineFixingArgs = {
  input: BulkLineFixingInput;
};


export type MutationBulkPipeSpecUploadArgs = {
  input: BulkPipeSpecUploadInput;
};


export type MutationBulkUpdateReviewActionArgs = {
  input?: InputMaybe<BulkUpdateReviewActionInput>;
};


export type MutationBulkUploadPoisArgs = {
  input: BulkUploadPoisInput;
};


export type MutationBulkUploadServiceGroupsArgs = {
  input: BulkUploadServiceGroupsInput;
};


export type MutationCalculateDefectCalculationsArgs = {
  input: DefectCalculationsInput;
};


export type MutationCalculateRiskRemediationAnalyticsArgs = {
  input: RiskRemediationAnalyticsInput;
};


export type MutationClonePointOfInterestTemplateArgs = {
  input?: InputMaybe<PoiTemplateCloneInput>;
};


export type MutationCloneQuerySummaryArgs = {
  input?: InputMaybe<QuerySummaryCloneInput>;
};


export type MutationCloneTemplateFieldsArgs = {
  input?: InputMaybe<TemplateFieldsCloneInput>;
};


export type MutationCopyLogsTemplateArgs = {
  input: CopyLogsTemplateInput;
};


export type MutationCopyWorkpackTemplateArgs = {
  input: CopyWorkpackTemplateInput;
};


export type MutationCreateAnnotationArgs = {
  imageId: Scalars['String']['input'];
};


export type MutationCreateAssemblyArgs = {
  input?: InputMaybe<CreateAssemblyInput>;
};


export type MutationCreateBulkReportsArgs = {
  input?: InputMaybe<CreateNewReportInput>;
};


export type MutationCreateCommentArgs = {
  input: CreateCommentInput;
};


export type MutationCreateInspectionPlanArgs = {
  input: CreateInspectionPlanInput;
};


export type MutationCreateLogEntryArgs = {
  input: CreateLogEntryInput;
};


export type MutationCreateLogsTemplateArgs = {
  input: LogsTemplateInput;
};


export type MutationCreateNewReportArgs = {
  input?: InputMaybe<CreateNewReportInput>;
};


export type MutationCreatePointOfInterestArgs = {
  input?: InputMaybe<CreatePointOfInterestInput>;
};


export type MutationCreatePointOfInterestTemplateArgs = {
  input?: InputMaybe<PointOfInterestTemplateInput>;
};


export type MutationCreatePreRegisteredUsersArgs = {
  input?: InputMaybe<PreRegisteredUserInput>;
};


export type MutationCreateRegionArgs = {
  input?: InputMaybe<CreateRegionInput>;
};


export type MutationCreateRiskAssessmentDetailsArgs = {
  input?: InputMaybe<CreateRiskAssessmentDetailsInput>;
};


export type MutationCreateStructureArgs = {
  input: CreateStructureInput;
};


export type MutationCreateSupervoxelClassArgs = {
  input?: InputMaybe<CreateSupervoxelClass>;
};


export type MutationCreateTeamArgs = {
  name: Scalars['String']['input'];
};


export type MutationCreateTemplateArgs = {
  input?: InputMaybe<TemplateInput>;
};


export type MutationCreateUserGroupArgs = {
  input?: InputMaybe<CreateUserGroupInput>;
};


export type MutationCreateWorkflowStageArgs = {
  input?: InputMaybe<CreateWorkflowStageInput>;
};


export type MutationCreateWorkpackArgs = {
  input?: InputMaybe<CreateWorkpackInput>;
};


export type MutationCreateWorkpackItemArgs = {
  input?: InputMaybe<CreateWorkpackItemInput>;
};


export type MutationCreateWorkpackTemplateArgs = {
  input: WorkpackTemplateInput;
};


export type MutationDeleteAssemblyFromReportArgs = {
  input?: InputMaybe<DeleteAssemblyFromReportInput>;
};


export type MutationDeleteCommentArgs = {
  commentId?: InputMaybe<Scalars['ID']['input']>;
  structureId?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationDeleteCuboidArgs = {
  input?: InputMaybe<DeleteCuboidInput>;
};


export type MutationDeleteDraftReportArgs = {
  input?: InputMaybe<DeleteDraftReportInput>;
};


export type MutationDeleteFilesArgs = {
  input: DeleteFilesInput;
};


export type MutationDeleteInspectionPlanArgs = {
  input: DeleteInspectionPlanInput;
};


export type MutationDeleteLogEntryArgs = {
  input: DeleteLogEntryInput;
};


export type MutationDeletePlannerColumnArgs = {
  input: DeletePlannerColumnInput;
};


export type MutationDeletePointOfInterestFromReportArgs = {
  input?: InputMaybe<DeletePointOfInterestFromReportInput>;
};


export type MutationDeletePointOfInterestTemplateArgs = {
  templateId: Scalars['String']['input'];
};


export type MutationDeletePreRegisteredUserArgs = {
  userId?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationDeleteReportArgs = {
  reportId: Scalars['ID']['input'];
};


export type MutationDeleteStructurePipeArgs = {
  pipeSize: Scalars['String']['input'];
  structureId: Scalars['ID']['input'];
};


export type MutationDeleteTeamArgs = {
  teamId: Scalars['ID']['input'];
};


export type MutationDeleteTemplateArgs = {
  templateId: Scalars['ID']['input'];
};


export type MutationDeleteUserGroupArgs = {
  input?: InputMaybe<DeleteUserGroupInput>;
};


export type MutationDeleteWorkflowStageArgs = {
  input?: InputMaybe<DeleteWorkflowStageInput>;
};


export type MutationDeleteWorkpackArgs = {
  input?: InputMaybe<DeleteWorkpackInput>;
};


export type MutationDeleteWorkpackItemArgs = {
  input?: InputMaybe<DeleteWorkpackItemInput>;
};


export type MutationEditStructurePipeArgs = {
  pipeSize: Scalars['String']['input'];
  pipeValue: Scalars['Float']['input'];
  structureId: Scalars['ID']['input'];
};


export type MutationEvaluateAllAssembliesForStructureArgs = {
  evaluateManuallyAddedFields: Scalars['Boolean']['input'];
  structureId: Scalars['String']['input'];
};


export type MutationEvaluateAllPoIsForStructureArgs = {
  evaluateManuallyAddedFields: Scalars['Boolean']['input'];
  structureId: Scalars['String']['input'];
};


export type MutationEvaluateTemplateFieldLogicRuleArgs = {
  input: EvaluateTemplateFieldLogicRuleInput;
};


export type MutationGenerateReportPdfArgs = {
  reportIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};


export type MutationIdmsFileUploadArgs = {
  input: IdmsUploadMutationInput;
};


export type MutationInviteUsersArgs = {
  input?: InputMaybe<InviteUsersInput>;
};


export type MutationMarkLocationAnalysedArgs = {
  input?: InputMaybe<MarkLocationAnalysedInput>;
};


export type MutationMarkViewPointAsAnalysedFromCurrentAssemblyArgs = {
  input?: InputMaybe<MarkViewPointAsAnalysedFromCurrentAssemblyInput>;
};


export type MutationNominateGoverningPointOfInterestArgs = {
  input?: InputMaybe<NominateGoverningPointOfInterestInput>;
};


export type MutationPerformMechanicalIntegrityServicesArgs = {
  input?: InputMaybe<PerformMechanicalIntegrityServicesInput>;
};


export type MutationPermanentlyDeletePointOfInterestArgs = {
  pointOfInterestId: Scalars['ID']['input'];
};


export type MutationPoiImageCaptionArgs = {
  input?: InputMaybe<PoiImageCaptionInput>;
};


export type MutationPreSignedUrlToUploadFilesArgs = {
  input: UploadFileInput;
};


export type MutationProcessPdfForPoiArgs = {
  input?: InputMaybe<ProcessPdfForPoiInput>;
};


export type MutationReOrderAssemblyImagesArgs = {
  input?: InputMaybe<ReOrderImagesInput>;
};


export type MutationRecalculatePlatformRiskScoresArgs = {
  platformId: Scalars['ID']['input'];
};


export type MutationRecalculateRiskRemediationAnalyticsArgs = {
  input: RecalculateRiskRemediationAnalyticsInput;
};


export type MutationRemoveAttachmentsFromPoiArgs = {
  input?: InputMaybe<RemoveAttachmentsInput>;
};


export type MutationRemoveRoleFromUsersArgs = {
  input?: InputMaybe<AssignRemoveRoleToFromUsersInput>;
};


export type MutationRemoveSplitCuboidOnPartArgs = {
  input?: InputMaybe<RemoveSplitCuboidOnPartInput>;
};


export type MutationRemoveUserGroupsFromStructureArgs = {
  input?: InputMaybe<AddRemoveStructuresToFromUserGroupsInput>;
};


export type MutationRemoveUsersFromTeamArgs = {
  input: UpdateTeamInput;
};


export type MutationRemoveUsersFromUserGroupArgs = {
  input?: InputMaybe<AddRemoveUsersToFromUserGroupInput>;
};


export type MutationRemoveWorkpackAttachmentsArgs = {
  input: RemoveWorkpackAttachmentsInput;
};


export type MutationResetPasswordArgs = {
  input: ResetPasswordInput;
};


export type MutationRestorePointOfInterestArgs = {
  pointOfInterestId: Scalars['ID']['input'];
};


export type MutationRevertBulkLineFixingArgs = {
  input: RevertBulkLineFixingInput;
};


export type MutationRollbackVersionArgs = {
  input?: InputMaybe<RollbackVersionInput>;
};


export type MutationSaveAssemblyScreenshotArgs = {
  input?: InputMaybe<ScreenshotInput>;
};


export type MutationSavePointOfInterestScreenshotArgs = {
  input?: InputMaybe<SavePointOfInterestScreenshotInput>;
};


export type MutationSetAlarmLevelArgs = {
  input?: InputMaybe<SetAlarmLevelInput>;
};


export type MutationSetHiddenForPartsArgs = {
  input?: InputMaybe<UpdatePartsHiddenFlagInput>;
};


export type MutationSetReviewedForPartsArgs = {
  input?: InputMaybe<UpdatePartsReviewedFlagInput>;
};


export type MutationSplitPartArgs = {
  input?: InputMaybe<SplitPartInput>;
};


export type MutationSyncAnalyticsDataArgs = {
  platformId: Scalars['ID']['input'];
  structureIds: Array<Scalars['ID']['input']>;
};


export type MutationSyncLogsTemplatesArgs = {
  input: SyncLogsTemplatesInput;
};


export type MutationSyncNestedFieldOptionsArgs = {
  templateId: Scalars['ID']['input'];
};


export type MutationSyncWorkpackTemplatesArgs = {
  input: SyncWorkpackTemplatesInput;
};


export type MutationUpdateAssembliesProbabilityOfFailureRiskFactorsArgs = {
  input?: InputMaybe<UpdateTemplateFieldDataPofInput>;
};


export type MutationUpdateAssemblyArgs = {
  input?: InputMaybe<UpdateAssemblyInput>;
};


export type MutationUpdateAssemblyBlistersArgs = {
  input?: InputMaybe<CreatePointOfInterestInput>;
};


export type MutationUpdateAssemblyRemediationArgs = {
  input?: InputMaybe<UpdateAssemblyRemediationInput>;
};


export type MutationUpdateAssemblyTableArgs = {
  input: UpdateAssemblyTableValuesInput;
};


export type MutationUpdateCalculationMethodArgs = {
  input?: InputMaybe<UpdateCalculationMethodInput>;
};


export type MutationUpdateCommentArgs = {
  input: UpdateCommentInput;
};


export type MutationUpdateCuiPriorityArgs = {
  input?: InputMaybe<UpdateCuiPriorityInput>;
};


export type MutationUpdateEsSheetStatusArgs = {
  status: EsSheetStatus;
  structureId: Scalars['String']['input'];
};


export type MutationUpdateFilesStatusArgs = {
  input: UpdateFilesStatusInput;
};


export type MutationUpdateFleetHealthArgs = {
  platformIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
};


export type MutationUpdateGoverningValueArgs = {
  input?: InputMaybe<UpdateGoverningValueInput>;
};


export type MutationUpdateInspectionPlanArgs = {
  input: UpdateInspectionPlanInput;
};


export type MutationUpdateLogEntryArgs = {
  input: UpdateLogEntryInput;
};


export type MutationUpdateLogsTemplateArgs = {
  input: UpdateLogsTemplateInput;
};


export type MutationUpdatePaintRegionIdArgs = {
  input?: InputMaybe<UpdatePaintRegionIdInput>;
};


export type MutationUpdatePaintRegionStatusArgs = {
  input?: InputMaybe<UpdatePaintRegionStatusInput>;
};


export type MutationUpdatePointOfInterestArgs = {
  input?: InputMaybe<UpdatePointOfInterestInput>;
};


export type MutationUpdatePointOfInterestFileArgs = {
  input?: InputMaybe<InputUpdateFileForPointOfInterest>;
};


export type MutationUpdatePointOfInterestImageTypeArgs = {
  input: UpdatePointOfInterestImageTypeInput;
};


export type MutationUpdatePointOfInterestLocationArgs = {
  input: UpdatePointOfInterestLocationInput;
};


export type MutationUpdatePointOfInterestTemplateArgs = {
  input?: InputMaybe<UpdatePointOfInterestTemplateInput>;
};


export type MutationUpdatePointOfInterestVisibilityArgs = {
  filters?: InputMaybe<PointOfInterestInput>;
  input?: InputMaybe<UpdatePointOfInterestVisibilityInput>;
};


export type MutationUpdatePointOfInterestsStatusArgs = {
  input: UpdatePointOfInterestsStatusInput;
};


export type MutationUpdateRemediationScoreConfigArgs = {
  input?: InputMaybe<UpdateRemediationScoreConfigInput>;
};


export type MutationUpdateReportArgs = {
  input?: InputMaybe<UpdateReportInput>;
};


export type MutationUpdateReportByPointOfInterestsArgs = {
  input?: InputMaybe<UpdateReportByPointOfInterestsInput>;
};


export type MutationUpdateReportPointOfInterestImagesArgs = {
  input?: InputMaybe<UpdateReportPointOfInterestImagesInput>;
};


export type MutationUpdateReportStatusArgs = {
  input?: InputMaybe<UpdateReportStatusInput>;
};


export type MutationUpdateRiskAssessmentTemplateFieldDataAndTransitionPeriodArgs = {
  input: UpdateRiskAssessmentTemplateFieldDataForAssembliesInput;
};


export type MutationUpdateRiskAssessmentTemplateFieldDataForAssembliesArgs = {
  input: UpdateRiskAssessmentTemplateFieldDataForAssembliesInput;
};


export type MutationUpdateScCategoryArgs = {
  input: UpdateScCategoryInput;
};


export type MutationUpdateScansToCadTransformArgs = {
  scansToCadTransform: Array<Scalars['Float']['input']>;
  structureId: Scalars['ID']['input'];
};


export type MutationUpdateSingleTemplateFieldDataArgs = {
  input?: InputMaybe<UpdateSingleTemplateFieldDataInput>;
};


export type MutationUpdateStructureArgs = {
  input?: InputMaybe<UpdateStructureInput>;
};


export type MutationUpdateSupervoxelsArgs = {
  input?: InputMaybe<UpdateSupervoxel>;
};


export type MutationUpdateTemplateArgs = {
  input?: InputMaybe<TemplateInput>;
};


export type MutationUpdateTemplateFieldDataArgs = {
  input?: InputMaybe<UpdateTemplateFieldDataInput>;
};


export type MutationUpdateUserColumnPreferencesArgs = {
  input?: InputMaybe<UpdateUserColumnPreferencesInput>;
};


export type MutationUpdateUserGroupArgs = {
  input?: InputMaybe<UpdateUserGroupInput>;
};


export type MutationUpdateUserInfoArgs = {
  input?: InputMaybe<UpdateUserInfoInput>;
};


export type MutationUpdateUserPlatformPreferencesArgs = {
  input?: InputMaybe<UpdateUserPlatformPreferencesInput>;
};


export type MutationUpdateUserPreferencesArgs = {
  input?: InputMaybe<UpdateUserPreferencesInput>;
};


export type MutationUpdateUserStructurePreferencesArgs = {
  input?: InputMaybe<UpdateUserStructurePreferencesInput>;
};


export type MutationUpdateWallLossFactorArgs = {
  structureId?: InputMaybe<Scalars['ID']['input']>;
  wallLossFactor?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationUpdateWorkLogArgs = {
  input: UpdateWorkLogInput;
};


export type MutationUpdateWorkflowStageArgs = {
  input?: InputMaybe<UpdateWorkflowStageInput>;
};


export type MutationUpdateWorkflowStatusArgs = {
  input?: InputMaybe<UpdateWorkflowStatusInput>;
};


export type MutationUpdateWorkflowTimeAndStateArgs = {
  input?: InputMaybe<UpdateWorkflowTimeAndStateInput>;
};


export type MutationUpdateWorkpackArgs = {
  input?: InputMaybe<UpdateWorkpackInput>;
};


export type MutationUpdateWorkpackAttachmentFileStatusArgs = {
  input?: InputMaybe<InputUpdateFileForWorkpack>;
};


export type MutationUpdateWorkpackItemArgs = {
  input?: InputMaybe<UpdateWorkpackItemInput>;
};


export type MutationUpdateWorkpackStatusArgs = {
  status: Scalars['String']['input'];
  workpackId: Scalars['ID']['input'];
};


export type MutationUpdateWorkpackTemplateArgs = {
  input: UpdateWorkpackTemplateInput;
};


export type MutationUpdateZoneStatusArgs = {
  input?: InputMaybe<UpdateZoneStatusInput>;
};


export type MutationUploadAttachmentsToPoiArgs = {
  input?: InputMaybe<UploadAttachmentsInput>;
};


export type MutationUploadCoverImageArgs = {
  input: UploadImageInput;
};


export type MutationUploadEsSheetArgs = {
  input: UploadEsSheetInput;
};


export type MutationUploadLegacyEsSheetArgs = {
  input: UploadLegacyEsSheetInput;
};


export type MutationUploadWorkpackAttachmentsArgs = {
  input?: InputMaybe<UploadWorkpackAttachmentsInput>;
};


export type MutationUpsertLogEntryArgs = {
  input: UpsertLogEntryInput;
};


export type MutationValidateEsSheetArgs = {
  headers: Array<Scalars['String']['input']>;
  isLegacy: Scalars['Boolean']['input'];
};


export type MutationVerifyPointOfInterestArgs = {
  input?: InputMaybe<VerifyPointOfInterestInput>;
};

export type NameAndArea = {
  __typename?: 'NameAndArea';
  deckIds?: Maybe<Array<Maybe<Scalars['ID']['output']>>>;
  name: Scalars['String']['output'];
  paintRegionIds?: Maybe<Array<Maybe<Scalars['ID']['output']>>>;
  totalArea?: Maybe<Array<Maybe<AreaAndType>>>;
};

/** Paint region defects grouped by paint region group */
export type NameAndAreaByGroup = {
  __typename?: 'NameAndAreaByGroup';
  name: Scalars['String']['output'];
  paintRegionId: Scalars['ID']['output'];
  totalArea?: Maybe<Array<Maybe<AreaAndType>>>;
  totalCountByPoiType?: Maybe<Array<Maybe<AreaAndType>>>;
};

export type NeighbouringImagesOptions = {
  __typename?: 'NeighbouringImagesOptions';
  defaultMeanDistance?: Maybe<Scalars['Float']['output']>;
  isEnabledByDefault?: Maybe<Scalars['Boolean']['output']>;
  maxImagesToShow?: Maybe<Scalars['Int']['output']>;
  showFrames?: Maybe<Scalars['Boolean']['output']>;
  showImages?: Maybe<Scalars['Boolean']['output']>;
};

export type NominateGoverningPointOfInterestInput = {
  lastModifiedFor: Scalars['String']['input'];
  pointOfInterestId: Scalars['ID']['input'];
};

export type NominationCalculations = {
  __typename?: 'NominationCalculations';
  alarmLevel: Scalars['String']['output'];
  governingValue?: Maybe<GoverningValueBlister>;
};

export type NominationCalculationsInput = {
  assemblyId: Scalars['ID']['input'];
  blisterId: Scalars['ID']['input'];
};

export type NominationConfig = {
  __typename?: 'NominationConfig';
  nominationTableConfig?: Maybe<NominationTableConfig>;
  poiTemplateNominationTypes?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type NominationConfigInput = {
  nominationTableConfig?: InputMaybe<NominationTableConfigInput>;
  poiTemplateNominationTypes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type NominationTableConfig = {
  __typename?: 'NominationTableConfig';
  columns?: Maybe<Array<Maybe<TableColumn>>>;
  title?: Maybe<Scalars['String']['output']>;
};

export type NominationTableConfigInput = {
  columns?: InputMaybe<Array<InputMaybe<TableColumnInput>>>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export enum OctreeKey {
  Corrosion = 'CORROSION',
  Defect = 'DEFECT',
  Degree = 'DEGREE',
  DegreeOfRusting = 'DEGREE_OF_RUSTING'
}

export type OptionData = {
  __typename?: 'OptionData';
  max?: Maybe<Scalars['Float']['output']>;
  maxIncluded?: Maybe<Scalars['Boolean']['output']>;
  min?: Maybe<Scalars['Float']['output']>;
  minIncluded?: Maybe<Scalars['Boolean']['output']>;
  value: Scalars['String']['output'];
  weight?: Maybe<Scalars['Float']['output']>;
};

export type OptionDataInput = {
  max?: InputMaybe<Scalars['Float']['input']>;
  maxIncluded?: InputMaybe<Scalars['Boolean']['input']>;
  min?: InputMaybe<Scalars['Float']['input']>;
  minIncluded?: InputMaybe<Scalars['Boolean']['input']>;
  value: Scalars['String']['input'];
  weight?: InputMaybe<Scalars['Float']['input']>;
};

export enum OptionFieldTypeEnum {
  CircularProgressBar = 'CIRCULAR_PROGRESS_BAR',
  SimpleText = 'SIMPLE_TEXT'
}

export type Overlap = {
  __typename?: 'Overlap';
  annotationId: Scalars['Int']['output'];
  locationId: Scalars['Int']['output'];
  /** Number of voxels that overlap with the reference annotation */
  voxelCount: Scalars['Int']['output'];
};

export type OverlapInfo = {
  __typename?: 'OverlapInfo';
  overlaps: Array<Overlap>;
};

export type PageInfo = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sortBy?: InputMaybe<Scalars['String']['input']>;
  sortDir?: InputMaybe<Scalars['Int']['input']>;
};

export type PaintBlockFiltersInput = {
  deckIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  excludeAlreadyPlannedBlocks?: InputMaybe<Scalars['Boolean']['input']>;
  paintRegionGroupIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  paintRegionIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Filter results by paint region name (case-insensitive substring match) */
  search?: InputMaybe<Scalars['String']['input']>;
  selectedTemplateFilters?: InputMaybe<Array<InputMaybe<FiltersInput>>>;
  showUncalibratedData?: InputMaybe<Scalars['Boolean']['input']>;
  structureIds: Array<Scalars['ID']['input']>;
};

export type PaintBlocksCorrodedArea = {
  __typename?: 'PaintBlocksCorrodedArea';
  defectsByDeck: Array<NameAndArea>;
  defectsByPaintBlock: Array<NameAndArea>;
  structureIds: Array<Scalars['ID']['output']>;
};

/** Response type for paint region defects by group with pagination */
export type PaintBlocksCorrodedAreaByGroup = {
  __typename?: 'PaintBlocksCorrodedAreaByGroup';
  defectsByPaintBlock: Array<NameAndAreaByGroup>;
  structureId: Scalars['ID']['output'];
  totalCount: Scalars['Int']['output'];
};

/**
 * A Paint Region is a region of space on a Deck of the Structure.
 *
 * Each deck is made up of different Paint Regions that can be actioned upon by human workers.
 */
export type PaintRegion = {
  __typename?: 'PaintRegion';
  /** Date this Paint Region was created */
  createdAt: Scalars['String']['output'];
  /** Deck that this Paint Region belongs to */
  deck: Deck;
  /** Bounds of the paint region relative to the deck in meters */
  deckRelativeBounds?: Maybe<DeckRelativeBounds>;
  defectMetrics: Array<DefectMetrics>;
  /** User uploaded files to the paint region */
  files?: Maybe<Array<File>>;
  /** Unique Paint Region ID */
  id: Scalars['ID']['output'];
  /** Linked Point of Interests */
  linkedPoiIds?: Maybe<Array<Scalars['ID']['output']>>;
  /** User readable identifier for the Paint Region */
  name: Scalars['String']['output'];
  /** Paint region group (e.g. Original, 5m, 10m block) */
  paintRegionGroup?: Maybe<PaintRegionGroup>;
  /** Paint region group id (e.g. Original, 5m, 10m block) */
  paintRegionGroupId?: Maybe<Scalars['ID']['output']>;
  polygons: Array<PaintRegionPolygons>;
  /** Date this Paint Region was remediated */
  remediationDate?: Maybe<Scalars['String']['output']>;
  /** Status of the Paint Region (dynamic - values come from Settings collection) */
  status?: Maybe<Scalars['String']['output']>;
  /** Date this Paint Region was last updated */
  updatedAt: Scalars['String']['output'];
  /** 3d-volume of paint region */
  volume?: Maybe<ComplexPrismVolume>;
};

/** CM analytics metrics by paint region */
export type PaintRegionAnalyticsCm = {
  __typename?: 'PaintRegionAnalyticsCm';
  actual_total_remediated_area?: Maybe<Scalars['Float']['output']>;
  calibrated_coating_breakdown_area?: Maybe<Scalars['Float']['output']>;
  calibrated_coating_breakdown_score?: Maybe<Scalars['Float']['output']>;
  calibrated_ri0_area?: Maybe<Scalars['Float']['output']>;
  calibrated_ri1_area?: Maybe<Scalars['Float']['output']>;
  calibrated_ri2_area?: Maybe<Scalars['Float']['output']>;
  calibrated_ri3_area?: Maybe<Scalars['Float']['output']>;
  calibrated_ri4_area?: Maybe<Scalars['Float']['output']>;
  calibrated_ri5_area?: Maybe<Scalars['Float']['output']>;
  calibrated_total_area?: Maybe<Scalars['Float']['output']>;
  remediated_ri0?: Maybe<Scalars['Float']['output']>;
  remediated_ri1?: Maybe<Scalars['Float']['output']>;
  remediated_ri2?: Maybe<Scalars['Float']['output']>;
  remediated_ri3?: Maybe<Scalars['Float']['output']>;
  remediated_ri4?: Maybe<Scalars['Float']['output']>;
  remediated_ri5?: Maybe<Scalars['Float']['output']>;
  total_already_completed?: Maybe<Scalars['Float']['output']>;
  total_risk_score?: Maybe<Scalars['Float']['output']>;
  uncalibrated_coating_breakdown_area?: Maybe<Scalars['Float']['output']>;
  uncalibrated_ri0_area?: Maybe<Scalars['Float']['output']>;
  uncalibrated_ri1_area?: Maybe<Scalars['Float']['output']>;
  uncalibrated_ri2_area?: Maybe<Scalars['Float']['output']>;
  uncalibrated_ri3_area?: Maybe<Scalars['Float']['output']>;
  uncalibrated_ri4_area?: Maybe<Scalars['Float']['output']>;
  uncalibrated_ri5_area?: Maybe<Scalars['Float']['output']>;
  uncalibrated_total_area?: Maybe<Scalars['Float']['output']>;
};

/** Combined CM + PSIM analytics by paint region */
export type PaintRegionAnalyticsInput = {
  structureIds: Array<Scalars['ID']['input']>;
};

/** PSIM analytics sections for baseline/remediation */
export type PaintRegionAnalyticsPsim = {
  __typename?: 'PaintRegionAnalyticsPsim';
  baseline: Array<PaintRegionAnalyticsPsimRow>;
  remediation: Array<PaintRegionAnalyticsPsimRow>;
};

/** PSIM analytics row per COF category */
export type PaintRegionAnalyticsPsimRow = {
  __typename?: 'PaintRegionAnalyticsPsimRow';
  area?: Maybe<Scalars['Float']['output']>;
  cofCategory: Scalars['String']['output'];
  heavy?: Maybe<Scalars['Float']['output']>;
  light?: Maybe<Scalars['Float']['output']>;
  moderate?: Maybe<Scalars['Float']['output']>;
  remediatedArea?: Maybe<Scalars['Float']['output']>;
  ri0?: Maybe<Scalars['Float']['output']>;
  ri1?: Maybe<Scalars['Float']['output']>;
  ri2?: Maybe<Scalars['Float']['output']>;
  ri3?: Maybe<Scalars['Float']['output']>;
  ri4?: Maybe<Scalars['Float']['output']>;
  ri5?: Maybe<Scalars['Float']['output']>;
  riskAreaRemediationScore?: Maybe<Scalars['Float']['output']>;
  totalArea?: Maybe<Scalars['Float']['output']>;
};

/** Combined CM + PSIM analytics by paint region name */
export type PaintRegionAnalyticsResult = {
  __typename?: 'PaintRegionAnalyticsResult';
  cm?: Maybe<PaintRegionAnalyticsCm>;
  paintRegionName: Scalars['String']['output'];
  psim?: Maybe<PaintRegionAnalyticsPsim>;
};

/** Generic paint region group collection */
export type PaintRegionGroup = {
  __typename?: 'PaintRegionGroup';
  /** Grid size for voxel grid type */
  gridSize?: Maybe<Scalars['Int']['output']>;
  /** Unique Paint Region Group ID */
  id: Scalars['ID']['output'];
  /** Whether this is the default paint region group */
  isDefault: Scalars['Boolean']['output'];
  /** Name of the paint region group */
  name: Scalars['String']['output'];
  /** Structure that this Paint Region Group belongs to */
  structure: Structure;
  /** Used to link to an assembly template. Used for combined deployment. */
  template: Template;
  /** Type of the paint region group */
  type: PaintRegionGroupTypeEnum;
};

export type PaintRegionGroupFiltersInput = {
  structureId: Scalars['ID']['input'];
  templateId: Scalars['ID']['input'];
};

/** Types of paint region groups */
export enum PaintRegionGroupTypeEnum {
  PaintRegion = 'PAINT_REGION',
  VoxelGrid = 'VOXEL_GRID'
}

export type PaintRegionPolygons = {
  __typename?: 'PaintRegionPolygons';
  area: Scalars['Float']['output'];
  points: Array<Array<Scalars['Float']['output']>>;
  /** Type of this PaintRegion polygon; i.e. plan */
  type?: Maybe<Scalars['String']['output']>;
};

/**
 * Default paint region status values.
 * Note: The actual status field accepts any string value for flexibility.
 * Custom status labels are configured in the Settings collection (PAINT_REGION_STATUS_LABELS).
 */
export enum PaintRegionStatus {
  Completed = 'COMPLETED',
  InspectionPending = 'INSPECTION_PENDING',
  InProgress = 'IN_PROGRESS',
  NoWorkRequired = 'NO_WORK_REQUIRED',
  PartiallyCompleted = 'PARTIALLY_COMPLETED',
  Scheduled = 'SCHEDULED'
}

/** Assembly/POI Version with additional assembly/POI information */
export type PaintRegionVersion = {
  __typename?: 'PaintRegionVersion';
  /** Name of MongoDB Collection where Reference Document resides */
  collectionName: Scalars['String']['output'];
  /** Date this Version was created */
  createdAt: Scalars['String']['output'];
  /** Event ID for the version */
  eventId?: Maybe<Scalars['String']['output']>;
  /** Unique Version ID */
  id: Scalars['ID']['output'];
  /** Auth0 ID of user who triggered the version */
  lastModifiedBy?: Maybe<Scalars['String']['output']>;
  /** User who made the last update */
  lastModifiedByUser?: Maybe<User>;
  /** Reason for the last update */
  lastModifiedFor: Scalars['String']['output'];
  /** Assembly/POI name */
  name?: Maybe<Scalars['String']['output']>;
  /** Poi Id */
  poiId?: Maybe<Scalars['String']['output']>;
  /** Previous data in this version */
  previousData?: Maybe<Scalars['JSON']['output']>;
  /** Reference Id for the Document */
  referenceId?: Maybe<Scalars['ID']['output']>;
  /** Structure that this Version belongs to  */
  structureId?: Maybe<Scalars['ID']['output']>;
  /** Changed fields in this version */
  updatedData?: Maybe<Scalars['JSON']['output']>;
};

export type PaintRegionVolumeInput = {
  /** Integer id of paint region */
  id?: InputMaybe<Scalars['Int']['input']>;
  /** 3d-volume of paint region */
  volume?: InputMaybe<ComplexPrismVolumeInput>;
};

export type PaintRegionVolumesInput = {
  /** All paint region volumes for the structure */
  regions?: InputMaybe<Array<InputMaybe<PaintRegionVolumeInput>>>;
};

/** An individual Part of the Structure. */
export type Part = {
  __typename?: 'Part';
  /** Assembly that this Part belongs to */
  assembly?: Maybe<Assembly>;
  assemblyId?: Maybe<Scalars['ID']['output']>;
  /** Class (grouping) of this Part */
  class: Scalars['String']['output'];
  /** Corrosion detected on the entire part */
  corrosion?: Maybe<Corrosion>;
  /** Date this Part was created */
  createdAt: Scalars['String']['output'];
  /** Parts this part grouped with for graph assisted tagging */
  groupedPartIds?: Maybe<Array<Maybe<Scalars['ID']['output']>>>;
  /** Unique Part ID */
  id: Scalars['ID']['output'];
  integerId?: Maybe<Scalars['Int']['output']>;
  /** Part is hidden if it is not relevant to this structure */
  isHidden?: Maybe<Scalars['Boolean']['output']>;
  /** User marks if a Part is reviewed */
  isReviewed?: Maybe<Scalars['Boolean']['output']>;
  /** Unstructured metadata about this Part */
  meta: Array<Meta>;
  /** All the viewpoints that can see any portion of this part */
  seenByViewpoints?: Maybe<Array<SeenByViewpoint>>;
  /** Split Cuboids define split points from this Part in data processing */
  splitCuboids?: Maybe<Array<SplitCuboid>>;
  /** Identifier for the Structure that this  belongs to */
  structure: Structure;
  template: Template;
  /** Date this Part was last updated */
  updatedAt: Scalars['String']['output'];
  /** User who last updated this Part */
  updatedBy?: Maybe<Scalars['String']['output']>;
};

export type PartGroup = {
  __typename?: 'PartGroup';
  /** Part Ids part of this group */
  groupedParts: Array<Scalars['String']['output']>;
  /** Unique Zone ID */
  id: Scalars['ID']['output'];
  /** Structure of this Zone */
  structure: Structure;
};

export type PartHiddenFlagUpdatedNotification = {
  __typename?: 'PartHiddenFlagUpdatedNotification';
  assemblyName?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isHidden?: Maybe<Scalars['Boolean']['output']>;
  isReviewed?: Maybe<Scalars['Boolean']['output']>;
  userId: Scalars['String']['output'];
  zoneId?: Maybe<Scalars['String']['output']>;
};

export type PartLegend = {
  __typename?: 'PartLegend';
  color: Scalars['String']['output'];
  legendText?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
};

export type PartReviewFlagUpdatedNotification = {
  __typename?: 'PartReviewFlagUpdatedNotification';
  assemblyName?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isReviewed?: Maybe<Scalars['Boolean']['output']>;
  structureId: Scalars['ID']['output'];
  userId: Scalars['String']['output'];
  zoneId?: Maybe<Scalars['String']['output']>;
};

export type PartSplitNotification = {
  __typename?: 'PartSplitNotification';
  assemblyName?: Maybe<Scalars['String']['output']>;
  newPartId: Scalars['ID']['output'];
  originalPartId: Scalars['ID']['output'];
  structureId?: Maybe<Scalars['ID']['output']>;
  updatedAnnotationIds: Array<Scalars['ID']['output']>;
  updatedAnnotations: Array<Annotation>;
  userId: Scalars['String']['output'];
  zoneId?: Maybe<Scalars['String']['output']>;
};

export type PartsAddedToAssemblyNotification = {
  __typename?: 'PartsAddedToAssemblyNotification';
  assemblyId?: Maybe<Scalars['ID']['output']>;
  assemblyName?: Maybe<Scalars['String']['output']>;
  isReviewed?: Maybe<Scalars['Boolean']['output']>;
  partId: Scalars['ID']['output'];
  structureId?: Maybe<Scalars['ID']['output']>;
  userId: Scalars['String']['output'];
  zoneId?: Maybe<Scalars['String']['output']>;
};

export enum PausedBy {
  System = 'SYSTEM',
  User = 'USER'
}

export type PdfDocumentInput = {
  /** Base64-encoded PDF document content */
  base64Data: Scalars['String']['input'];
  /** Original filename */
  fileName: Scalars['String']['input'];
  /** MIME type of the file (should be application/pdf) */
  mimeType: Scalars['String']['input'];
};

export type PdfGenerationResult = {
  __typename?: 'PdfGenerationResult';
  downloadUrl: Array<Scalars['String']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  filename: Array<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type PdfProcessingError = {
  __typename?: 'PdfProcessingError';
  /** Error code for categorization */
  code?: Maybe<Scalars['String']['output']>;
  /** PDF filename that caused the error */
  fileName: Scalars['String']['output'];
  /** Error message */
  message: Scalars['String']['output'];
};

export type PerformMechanicalIntegrityServicesInput = {
  /** Add MI fields flag */
  addMIFields?: InputMaybe<Scalars['Boolean']['input']>;
  /** Unique Assembly IDs */
  assemblyIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Force update flag */
  forceUpdate?: InputMaybe<Scalars['Boolean']['input']>;
  /** Blister height type */
  heightType?: InputMaybe<BlisterHeightType>;
  /** Initialize flag */
  initialize?: InputMaybe<Scalars['Boolean']['input']>;
  /** Bulk update flag */
  isBulkUpdate?: InputMaybe<Scalars['Boolean']['input']>;
  /** Reason for the last update */
  lastModifiedFor?: InputMaybe<Scalars['String']['input']>;
  /** Unique Point of Interest IDs */
  pointOfInterestIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Reset overridden flag */
  resetOverridden?: InputMaybe<Scalars['Boolean']['input']>;
  /** Flag to skip anomaly count update */
  skipCountUpdate?: InputMaybe<Scalars['Boolean']['input']>;
  /** Flag to skip governing check and update */
  skipGoverning?: InputMaybe<Scalars['Boolean']['input']>;
  /** Unique Structure ID */
  structureId: Scalars['ID']['input'];
};

export type PermanentDeleteResponse = {
  __typename?: 'PermanentDeleteResponse';
  deleted: Scalars['Boolean']['output'];
};

export type Permission = {
  __typename?: 'Permission';
  description?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type PipeSpec = {
  __typename?: 'PipeSpec';
  /** The material used in the construction of this pipe */
  material?: Maybe<Scalars['String']['output']>;
  /** Amount of corrosion allowed for the pipe (in mm) */
  nominalCorrosionAllowance?: Maybe<Scalars['Float']['output']>;
  /** Nominal thickness of the pipe wall (in mm) */
  nominalThickness?: Maybe<Scalars['Float']['output']>;
  /** Pipe schedule is how the wall thickness of a pipe is described */
  schedule?: Maybe<Scalars['String']['output']>;
  /** Standard pipe size - Nominal pipe size (NPS) for non-metric or Diametre nominal (DN) for metric) */
  size?: Maybe<Scalars['String']['output']>;
  /** Pipe specification code */
  spec?: Maybe<Scalars['String']['output']>;
};

export type PipeSpecInput = {
  /** The material used in the construction of this pipe */
  material?: InputMaybe<Scalars['String']['input']>;
  /** Amount of corrosion allowed for the pipe (in mm) */
  nominalCorrosionAllowance?: InputMaybe<Scalars['Float']['input']>;
  /** Nominal thickness of the pipe wall (in mm) */
  nominalThickness?: InputMaybe<Scalars['Float']['input']>;
  /** Pipe schedule is how the wall thickness of a pipe is described */
  schedule?: InputMaybe<Scalars['String']['input']>;
  /** Standard pipe size - Nominal pipe size (NPS) for non-metric or Diametre nominal (DN) for metric) */
  size: Scalars['String']['input'];
  /** Pipe specification code */
  spec: Scalars['String']['input'];
};

export type Platform = {
  __typename?: 'Platform';
  /** Path for cover image for this Platform */
  coverImagePath: Scalars['String']['output'];
  /** Fleet health filter values for this platform */
  fleetHealthFilters?: Maybe<Scalars['FleetHealthFilters']['output']>;
  /** Unique platform ID */
  id: Scalars['ID']['output'];
  /** Name of this platform */
  name: Scalars['String']['output'];
  /** Card insight detail for a platform */
  platformCardInsights?: Maybe<Array<PlatformCardInsights>>;
  /** Card summary detail for a platform */
  platformSummary?: Maybe<Array<PlatformCardSummary>>;
  /** Region to which this platform belongs */
  region?: Maybe<Region>;
};

export type PlatformCardInsights = {
  __typename?: 'PlatformCardInsights';
  displayConfig?: Maybe<PlatformCardInsightsDisplayConfig>;
  /** Filter options associated with this insight (e.g., structure categories) */
  filterOptions?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  group: Scalars['String']['output'];
  name: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type PlatformCardInsightsDisplayConfig = {
  __typename?: 'PlatformCardInsightsDisplayConfig';
  /** Where this insight should show up in the bar chart */
  barIndex?: Maybe<Scalars['Int']['output']>;
  /** Color indicator for the insight. Can be used in multiple contexts like bar chars or legends */
  color?: Maybe<Scalars['String']['output']>;
  /** Whether to display a divider after this Card's list entry or not */
  divider?: Maybe<Scalars['Boolean']['output']>;
  /** Where this insight should show up in the list */
  listIndex?: Maybe<Scalars['Int']['output']>;
  /** Display unit i.e ft2, m, mm */
  unit?: Maybe<Scalars['String']['output']>;
};

export type PlatformCardSummary = {
  __typename?: 'PlatformCardSummary';
  displayConfig?: Maybe<PlatformCardInsightsDisplayConfig>;
  group: Scalars['String']['output'];
  name: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export enum PoiAccessibilityEnum {
  NotApplicable = 'NOT_APPLICABLE',
  NoScaffoldingRequired = 'NO_SCAFFOLDING_REQUIRED',
  ScaffoldingRequired = 'SCAFFOLDING_REQUIRED'
}

export type PoiCuboid = {
  __typename?: 'PoiCuboid';
  /** Unique ID for this cuboid */
  id: Scalars['ID']['output'];
  /** Position of the cuboid (x,y,z) */
  position: Array<Scalars['Float']['output']>;
  /** Rotation of the cuboid (roll,pitch,yaw). Euler angles using Abyss conventions. */
  rotation: Array<Scalars['Float']['output']>;
  /** Size of the cuboid in 3 axes (x,y,z) */
  scale: Array<Scalars['Float']['output']>;
};

export type PoiImageCaptionInput = {
  caption: Scalars['String']['input'];
  lastModifiedFor: Scalars['String']['input'];
  poiAttachmentId: Scalars['String']['input'];
  pointOfInterestId: Scalars['ID']['input'];
  uuid?: InputMaybe<Scalars['String']['input']>;
};

export type PoiLineMeasurement = {
  __typename?: 'PoiLineMeasurement';
  points?: Maybe<Array<Maybe<PoiMeasurementPoint>>>;
};

export type PoiLineMeasurementInput = {
  points?: InputMaybe<Array<InputMaybe<PoiMeasurementPointInput>>>;
};

export type PoiMeasurementPoint = {
  __typename?: 'PoiMeasurementPoint';
  coordinates: Array<Scalars['Float']['output']>;
  templateFieldId: Scalars['ID']['output'];
};

export type PoiMeasurementPointInput = {
  coordinates: Array<Scalars['Float']['input']>;
  templateFieldId: Scalars['ID']['input'];
};

export type PoiOperationalTable = {
  __typename?: 'PoiOperationalTable';
  fields?: Maybe<Array<Maybe<ReportOperationalFields>>>;
  title?: Maybe<Scalars['String']['output']>;
};

export type PoiOperationalTableInput = {
  fields?: InputMaybe<Array<InputMaybe<ReportOperationalFieldsInput>>>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export enum PoiPriority {
  High = 'HIGH',
  Low = 'LOW',
  Medium = 'MEDIUM'
}

/**
 * Default POI status values.
 * Note: The actual status field accepts any string value for flexibility.
 * Custom status labels are configured in the Settings collection (POI_STATUS_LABELS).
 */
export enum PoiStatus {
  ChaseItemAdded = 'CHASE_ITEM_ADDED',
  Completed = 'COMPLETED',
  Inprogress = 'INPROGRESS',
  Inreview = 'INREVIEW',
  PartiallyCompleted = 'PARTIALLY_COMPLETED'
}

export type PoiTemplateCloneInput = {
  /** Assembly template relation for this POITemplate */
  assemblyTemplateId: Scalars['ID']['input'];
  /** Reason for the last update */
  lastModifiedFor: Scalars['String']['input'];
  /** Point of interest template IDs */
  pointOfInterestTemplateIds: Array<Scalars['ID']['input']>;
  /** Structure relation for this Template */
  structureId: Scalars['ID']['input'];
};

/** POI Type Count - represents count of POIs by type */
export type PoiTypeCount = {
  __typename?: 'PoiTypeCount';
  /** Count of POIs of this type associated with the assembly */
  count: Scalars['Int']['output'];
  /** The type of POI (e.g., BLISTER, PIT, etc.) */
  poiType: Scalars['String']['output'];
};

export type Point = {
  __typename?: 'Point';
  x: Scalars['Float']['output'];
  y: Scalars['Float']['output'];
  z: Scalars['Float']['output'];
};

/**
 * A point of interest (POI) marked in 3d space.
 * POI can be marked from a Location and for a specific Part optionally.
 */
export type PointOfInterest = {
  __typename?: 'PointOfInterest';
  /** Accessibility of this POI */
  accessibility?: Maybe<PoiAccessibilityEnum>;
  /** Assembly that this POI belongs to */
  assembly: Assembly;
  /**
   * Linked to a structure's assembly template, to create a distinction b/w
   * a structure's different offerings i.e structure, pressure, combined
   */
  assemblyTemplate?: Maybe<Template>;
  /** User whom this Point of interest is assigned to */
  assignee?: Maybe<Scalars['String']['output']>;
  /** Additional Blister metadata for this POI (if type is BLISTER) */
  blister?: Maybe<Blister>;
  /** Camera point in 3d space looking at this POI */
  cameraLocation?: Maybe<Vector3>;
  /**
   * Approximate center of where the POI was measured from in 3d space.
   * This is used to navigate to and display POIs.
   * Marking them as optional to allow for bulk upload of POIs
   * since bulk uploaded POIs wont have any 3D data associated with them
   */
  centerPoint3d?: Maybe<Vector3>;
  /**
   * A comment left by the creator of the POI. This comment is different
   * from the comments in the comment tab, in the sense that this one
   * appears in the POI table, is sortable and works just like any other field
   */
  comment?: Maybe<Scalars['String']['output']>;
  /** Date this Point of interest was created */
  createdAt: Scalars['String']['output'];
  /** User who created this Point of interest */
  createdByUser?: Maybe<User>;
  /** Cuboids of volume of interest */
  cuboids?: Maybe<Array<PoiCuboid>>;
  /** Height of this POI from nearest deck */
  deckRelativeHeight?: Maybe<Scalars['Float']['output']>;
  /** Date when this POI was archived (soft deleted). Null if not archived. */
  deletedAt?: Maybe<Scalars['String']['output']>;
  /** Due date of rectification for this Point of interest */
  dueDate?: Maybe<Scalars['String']['output']>;
  /** Image or PDF attached to POI */
  files?: Maybe<Array<File>>;
  /** Unique POI ID */
  id: Scalars['ID']['output'];
  /** POI is auto generated after the scans */
  isAutoGenerated?: Maybe<Scalars['Boolean']['output']>;
  /** Flag to indicate if the POI fields should be evaluated */
  isFieldEvaluationSkipped?: Maybe<Scalars['Boolean']['output']>;
  isGoverning?: Maybe<Scalars['Boolean']['output']>;
  /** POI is created by a source other than the viewer or imported from a file */
  isManuallyCreated?: Maybe<Scalars['Boolean']['output']>;
  /** Whether this POI has been verified by an inspector */
  isVerified?: Maybe<Scalars['Boolean']['output']>;
  /** Timestamp for the last update made from the API */
  lastModifiedByAPI?: Maybe<Scalars['String']['output']>;
  /** User who made the last update */
  lastModifiedByUser?: Maybe<User>;
  /** Reason for the last update */
  lastModifiedFor?: Maybe<Scalars['String']['output']>;
  /** Line measurements for this POI. This measurment is a list of points and an optional styles object. The measurement is recorded on the frontend using the **Measurement Tool** */
  lineMeasurement?: Maybe<PoiLineMeasurement>;
  /** Linked POIs to the cuboid */
  linkedPointOfInterestIds?: Maybe<Array<Scalars['ID']['output']>>;
  /** Location that this POI belongs to (if POI marked from a Location) */
  location?: Maybe<Location>;
  /** Location ID that this POI belongs to (if POI marked from a Location) */
  locationId?: Maybe<Scalars['ID']['output']>;
  /** Unstructured metadata about this POI */
  meta: Array<Meta>;
  /** Name of this POI */
  name?: Maybe<Scalars['String']['output']>;
  /** Paint Region that this POI belongs to (backward-compatible, maps to the first paint region in paintRegions) */
  paintRegion?: Maybe<PaintRegion>;
  /** List of Paint Regions that this POI belongs to */
  paintRegions?: Maybe<Array<PaintRegion>>;
  /** Parent Paint Region used only for cuboids */
  parentPaintRegionId?: Maybe<PaintRegion>;
  /** Part that this POI belongs to (if Part selected from UI before POI marked) */
  part?: Maybe<Part>;
  /** A user friendly ID in the format of {POI Type}-{Number} */
  poiId?: Maybe<Scalars['String']['output']>;
  /** Priority of this Point of interest */
  priority?: Maybe<PoiPriority>;
  /** Date when this POI was remediated */
  remediationAt?: Maybe<Scalars['String']['output']>;
  /** Remediation Note with POI */
  remediationNote?: Maybe<Scalars['String']['output']>;
  /** Paths to saved screenshots for this POI */
  screenshotPaths?: Maybe<ScreenshotPaths>;
  /** Status of this Point of interest (dynamic - values come from Settings collection) */
  status?: Maybe<Scalars['String']['output']>;
  /** Tab from where poi status is updated */
  statusRemediatedThrough?: Maybe<StatusRemediatedThrough>;
  /** Teams that this POI is shared with */
  teams: Array<Team>;
  /** Template related to this POI for dynamic data */
  template?: Maybe<PointOfInterestTemplate>;
  /** Data values associated with Template for this POI */
  templateData?: Maybe<Array<TemplateData>>;
  /** Template data, but store as key value pairs */
  templateFieldData?: Maybe<Scalars['JSON']['output']>;
  /** Template ID related to this POI */
  templateId?: Maybe<Scalars['ID']['output']>;
  /** Type of this POI */
  type: Scalars['String']['output'];
  /** Unlinked POIs to the cuboid */
  unlinkedPointOfInterestIds?: Maybe<Array<Scalars['ID']['output']>>;
  /** User who verified this Point of interest */
  verifiedByUser?: Maybe<User>;
  /** Height of the POI relative to the viewpoint it was created from */
  viewpointRelativeHeight?: Maybe<Scalars['Float']['output']>;
  /** Visibility settings for this POI (private, public, custom) */
  visibility?: Maybe<VisibilityEnum>;
  /** Workpack id of this poi */
  workpack?: Maybe<Workpack>;
  /** Workpack number of POI */
  workpackNumber?: Maybe<Scalars['String']['output']>;
};

export type PointOfInterestFindingAndName = {
  __typename?: 'PointOfInterestFindingAndName';
  name: Scalars['String']['output'];
  pointOfInterestFindings: Array<PointOfInterestFindings>;
  totalCount: Scalars['Float']['output'];
};

export type PointOfInterestFindings = {
  __typename?: 'PointOfInterestFindings';
  count: Scalars['Int']['output'];
  poiTemplateName?: Maybe<Scalars['String']['output']>;
  type: Scalars['String']['output'];
};

export type PointOfInterestImages = {
  __typename?: 'PointOfInterestImages';
  pointOfInterestId: Scalars['ObjectId']['output'];
  selectedImages?: Maybe<Array<Maybe<File>>>;
};

export type PointOfInterestInput = {
  accessibility?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  assemblyIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  assemblyTemplateId?: InputMaybe<Scalars['ID']['input']>;
  deckIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  deckRelativeHeight?: InputMaybe<Array<InputMaybe<RangeInput>>>;
  excludePoisWithWorkpack?: InputMaybe<Scalars['Boolean']['input']>;
  includeManuallyCreated?: InputMaybe<Scalars['Boolean']['input']>;
  isGoverning?: InputMaybe<Array<InputMaybe<Scalars['Boolean']['input']>>>;
  isManuallyCreated?: InputMaybe<Array<InputMaybe<Scalars['Boolean']['input']>>>;
  isVerified?: InputMaybe<Array<InputMaybe<Scalars['Boolean']['input']>>>;
  mediaAttachment?: InputMaybe<Array<InputMaybe<Scalars['Boolean']['input']>>>;
  paintRegionIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  paintRegionNames?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  parentPaintRegionId?: InputMaybe<Scalars['ID']['input']>;
  partId?: InputMaybe<Scalars['ID']['input']>;
  poiIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  priorityFieldKeys?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  searchTerm?: InputMaybe<Scalars['String']['input']>;
  selectedDeckIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  selectedPoiFilters?: InputMaybe<Array<InputMaybe<FiltersInput>>>;
  selectedTemplateFilters?: InputMaybe<Array<InputMaybe<FiltersInput>>>;
  status?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  structureId: Scalars['ID']['input'];
  type?: InputMaybe<Scalars['String']['input']>;
  unAssignedPoi?: InputMaybe<Array<InputMaybe<Scalars['Boolean']['input']>>>;
  workpackId?: InputMaybe<Scalars['ID']['input']>;
  workpackIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
};

export type PointOfInterestMultiStructureInput = {
  accessibility?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  assemblyIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  assemblyTemplateId?: InputMaybe<Scalars['ID']['input']>;
  deckIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  deckRelativeHeight?: InputMaybe<Array<InputMaybe<RangeInput>>>;
  excludePoisWithWorkpack?: InputMaybe<Scalars['Boolean']['input']>;
  includeManuallyCreated?: InputMaybe<Scalars['Boolean']['input']>;
  isGoverning?: InputMaybe<Array<InputMaybe<Scalars['Boolean']['input']>>>;
  isManuallyCreated?: InputMaybe<Array<InputMaybe<Scalars['Boolean']['input']>>>;
  isVerified?: InputMaybe<Array<InputMaybe<Scalars['Boolean']['input']>>>;
  mediaAttachment?: InputMaybe<Array<InputMaybe<Scalars['Boolean']['input']>>>;
  paintRegionIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  paintRegionNames?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  partId?: InputMaybe<Scalars['ID']['input']>;
  poiIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  priorityFieldKeys?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  searchTerm?: InputMaybe<Scalars['String']['input']>;
  selectedDeckIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  selectedPoiFilters?: InputMaybe<Array<InputMaybe<FiltersInput>>>;
  selectedTemplateFilters?: InputMaybe<Array<InputMaybe<FiltersInput>>>;
  status?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  structureIds: Array<Scalars['ID']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  unAssignedPoi?: InputMaybe<Array<InputMaybe<Scalars['Boolean']['input']>>>;
  workpackId?: InputMaybe<Scalars['ID']['input']>;
  workpackIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
};

export type PointOfInterestPdfs = {
  __typename?: 'PointOfInterestPdfs';
  pointOfInterestId: Scalars['ObjectId']['output'];
  selectedPdfs?: Maybe<Array<FileWithStatus>>;
};

export type PointOfInterestTemplate = {
  __typename?: 'PointOfInterestTemplate';
  /** Color used for graph legends */
  accentColor?: Maybe<Scalars['String']['output']>;
  /** What assembly template this POI template is related to. Used in combined deployment */
  assemblyTemplate: Template;
  /** Blister fields configuration */
  blisterFieldsConfig?: Maybe<BlisterFieldsConfig>;
  /** User who created this Template */
  createdBy?: Maybe<Scalars['String']['output']>;
  /** Field definitions for this Template */
  fields: Array<PointOfInterestTemplateField>;
  /** Icon for POI */
  icon?: Maybe<TemplateIcon>;
  /** Unique Template ID */
  id: Scalars['ID']['output'];
  /** Should this field be allowed to be uploaded via CSV bulk upload */
  isCsvUploadable?: Maybe<Scalars['Boolean']['output']>;
  /** Key to identify template in template data in kabab case */
  key?: Maybe<Scalars['String']['output']>;
  /** Auth0 ID of the user who last updated this POI Template */
  lastModifiedBy?: Maybe<Scalars['String']['output']>;
  /** Timestamp for the last update made from the API */
  lastModifiedByAPI?: Maybe<Scalars['String']['output']>;
  /** User who made the last update */
  lastModifiedByUser?: Maybe<User>;
  /** Reason for the last update */
  lastModifiedFor?: Maybe<Scalars['String']['output']>;
  /** Configuration for marker labels */
  markerLabelConfig?: Maybe<MarkerLabelConfig>;
  /** Name of this Template */
  name: Scalars['String']['output'];
  /** Permission the user should have to access this template. e.g generic engineer don't have read:defects permission so he cannot access those template if permission = read:defects */
  permissions?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Identifier for the Structure that this  belongs to */
  structure: Structure;
  /** Type of this Template */
  type?: Maybe<PointOfInterestTemplateTypeEnum>;
};

export type PointOfInterestTemplateField = TemplateField & {
  __typename?: 'PointOfInterestTemplateField';
  /** Logic engine expression to evaluate the equation key used for calculating the field value */
  calculatedBy?: Maybe<LogicEvaluationRule>;
  /** Should this field be visible on first load inside a list or table */
  defaultVisible?: Maybe<Scalars['Boolean']['output']>;
  /** Key of field which has additional data for this field */
  detailFieldKey?: Maybe<Scalars['String']['output']>;
  /** Table configuration */
  displayConfig?: Maybe<DisplayConfig>;
  /** Identify if field should be shown in the poi filters */
  displayInQuery?: Maybe<Scalars['Boolean']['output']>;
  /** Should this field be displayed in report filters */
  displayInReportFilters?: Maybe<Scalars['Boolean']['output']>;
  /** Should this field be hidden in report */
  displayInReports?: Maybe<Scalars['Boolean']['output']>;
  /** Should this field be visible in review */
  displayInReview?: Maybe<Scalars['Boolean']['output']>;
  /** Identify if field should be shown in the poi table */
  displayInTable?: Maybe<Scalars['Boolean']['output']>;
  /** Unique Template Field ID */
  id: Scalars['ID']['output'];
  /** Should not be shown in the UI. Used for identifying certain fields */
  isHidden?: Maybe<Scalars['Boolean']['output']>;
  /** Enable Measurement Tool */
  isMeasurementToolEnabled?: Maybe<Scalars['Boolean']['output']>;
  /** Is this Template Field read-only; i.e. value cannot be updated */
  isReadOnly: Scalars['Boolean']['output'];
  /** Is this Template Field always required */
  isRequired: Scalars['Boolean']['output'];
  /** Key to identify field in template data */
  key?: Maybe<Scalars['String']['output']>;
  /** Logic engine expression to evaluate the field value */
  logicRule?: Maybe<LogicEvaluationRule>;
  /** Name of this Template Field */
  name: Scalars['String']['output'];
  /** Valid options for this Template Field value */
  options: Array<Scalars['String']['output']>;
  /** Details of valid options for this Template Field value */
  optionsData?: Maybe<Array<OptionData>>;
  /** Type of permission that a user have to read the template */
  permission?: Maybe<Scalars['String']['output']>;
  /** Should the template options be fetched from the server on runtime */
  serverSide: Scalars['Boolean']['output'];
  /** Identify if field's value should be evaluated using the logic engine */
  shouldEvaluateLogic?: Maybe<Scalars['Boolean']['output']>;
  /** Identify if field's value should be evaluated using the logic engine after the math engine */
  shouldEvaluateLogicPostCalculation?: Maybe<Scalars['Boolean']['output']>;
  /** Identify if field's value should be evaluated using the math engine */
  shouldEvaluateMath?: Maybe<Scalars['Boolean']['output']>;
  /** Type of this Template Field */
  type: TemplateFieldTypeEnum;
  /** Identity about the unit of the field */
  unit?: Maybe<UnitsEnum>;
};

export type PointOfInterestTemplateInput = {
  /** Color used for graph legends */
  accentColor?: InputMaybe<Scalars['String']['input']>;
  /** Assembly template relation for this POITemplate */
  assemblyTemplateId: Scalars['ID']['input'];
  /** Blister fields configuration */
  blisterFieldsConfig?: InputMaybe<BlisterFieldsConfigInput>;
  /** Field definitions for this Template */
  fields: Array<InputPointOfInterestTemplateField>;
  /** Icon for POI */
  icon?: InputMaybe<TemplateIconInput>;
  /** Reason for the last update */
  lastModifiedFor: Scalars['String']['input'];
  /** Configuration for annotations */
  markerLabelConfig?: InputMaybe<MarkerLabelConfigInput>;
  /** Name of this Template */
  name: Scalars['String']['input'];
  /** Permission the user should have to access this template. e.g generic engineer don't have read:defects permission so he cannot access those template if permission = read:defects */
  permissions?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Structure relation for this POITemplate */
  structureId: Scalars['ID']['input'];
  /** Type of this Template */
  type?: InputMaybe<PointOfInterestTemplateTypeEnum>;
};

export enum PointOfInterestTemplateTypeEnum {
  PaintBlockVolumeOfInterest = 'PAINT_BLOCK_VOLUME_OF_INTEREST',
  PointOfInterest = 'POINT_OF_INTEREST',
  VolumeOfInterest = 'VOLUME_OF_INTEREST'
}

export type PointOfInterestsCountByType = {
  __typename?: 'PointOfInterestsCountByType';
  count?: Maybe<Scalars['Int']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type PointOfInterestsFindingsByDeckAndPaintBlock = {
  __typename?: 'PointOfInterestsFindingsByDeckAndPaintBlock';
  findingsByDeck: Array<PointOfInterestFindingAndName>;
  findingsByPaintBlock: Array<PointOfInterestFindingAndName>;
  structureIds: Array<Scalars['ID']['output']>;
};

export type PointOfInterestsGroupedByWorkpack = {
  __typename?: 'PointOfInterestsGroupedByWorkpack';
  _id?: Maybe<Scalars['ID']['output']>;
  assembliesCount?: Maybe<Scalars['Float']['output']>;
  pointOfInterestsCount?: Maybe<Scalars['Float']['output']>;
  verifiedPointOfInterestsCount?: Maybe<Scalars['Float']['output']>;
  workpack?: Maybe<Workpack>;
};

export type PolarCoordinates = {
  __typename?: 'PolarCoordinates';
  /** Rotation of camera angle */
  bearing: Scalars['Float']['output'];
  /** Elevation of camera angle */
  elevation: Scalars['Float']['output'];
  /** Distance to camera */
  range: Scalars['Float']['output'];
};

export type PolarPoint = {
  __typename?: 'PolarPoint';
  bearing: Scalars['Float']['output'];
  elevation: Scalars['Float']['output'];
};

export type PolarPointInput = {
  bearing: Scalars['Float']['input'];
  elevation: Scalars['Float']['input'];
};

export type PolarPointMeasurementInput = {
  /** Rotation of camera angle */
  bearing: Scalars['Float']['input'];
  /** Elevation of camera angle */
  elevation: Scalars['Float']['input'];
};

export type Polygon = {
  __typename?: 'Polygon';
  area: Scalars['Float']['output'];
  centroid: Array<Scalars['Float']['output']>;
  points: Array<Array<Scalars['Float']['output']>>;
};

export type Polygon3d = {
  __typename?: 'Polygon3d';
  points: Array<Vector3>;
};

export type Polygon3dInput = {
  points: Array<Vector3Input>;
};

export type Pose = {
  pitch: Scalars['Float']['input'];
  roll: Scalars['Float']['input'];
  x: Scalars['Float']['input'];
  y: Scalars['Float']['input'];
  yaw: Scalars['Float']['input'];
  z: Scalars['Float']['input'];
};

/** PreRegisteredUser is a user but not yet loggedin. */
export type PreRegisteredUser = {
  __typename?: 'PreRegisteredUser';
  /** Email of this PreRegisteredUser */
  email: Scalars['String']['output'];
  /** User Group Ids of this PreRegisteredUser */
  groups: Array<UserGroup>;
  /** Unique PreRegisteredUser ID */
  id: Scalars['ID']['output'];
  /** Roles of user */
  roleIds: Array<Maybe<Role>>;
  /** When a user logins it's object id will be stored here */
  userId?: Maybe<Scalars['ID']['output']>;
};

export type PreRegisteredUserInput = {
  emails: Array<Scalars['String']['input']>;
  groups: Array<Scalars['String']['input']>;
  roleIds: Array<Scalars['String']['input']>;
};

export enum PrimaryAngleEnum {
  East = 'EAST',
  North = 'NORTH',
  South = 'SOUTH',
  West = 'WEST'
}

export type PrismVolume = {
  __typename?: 'PrismVolume';
  /** Closed 2d polygon (points) */
  xy_polygon: Array<Array<Scalars['Float']['output']>>;
  /** Prism low and high level in z-dimention */
  z_range: Array<Scalars['Float']['output']>;
};

export type PrismVolumeInput = {
  /** Closed 2d polygon (points) */
  xy_polygon: Array<Array<Scalars['Float']['input']>>;
  /** Prism low and high level in z-dimention */
  z_range: Array<Scalars['Float']['input']>;
};

export type ProcessPdfForPoiInput = {
  /** Assembly template ID for POI creation (optional, inferred from structure if not provided) */
  assemblyTemplateId?: InputMaybe<Scalars['ID']['input']>;
  /** Reason for the last update */
  lastModifiedFor: Scalars['String']['input'];
  /** PDF documents to process and extract POI data from */
  pdfDocuments: Array<PdfDocumentInput>;
  /** Structure for which to create POIs from PDF data */
  structureId: Scalars['ID']['input'];
  /** Unit system for field conversions (METRIC or IMPERIAL, can be used later for value conversion) */
  unitSystem?: InputMaybe<UnitSystemEnum>;
};

export type ProcessPdfForPoiResponse = {
  __typename?: 'ProcessPdfForPoiResponse';
  /** Number of PDFs that failed to process */
  errorCount: Scalars['Int']['output'];
  /** Errors encountered during processing */
  errors: Array<PdfProcessingError>;
  /** Successfully created POIs */
  pointOfInterests: Array<PointOfInterest>;
  /** Number of POIs successfully created */
  successCount: Scalars['Int']['output'];
  /** Total number of PDFs processed */
  totalProcessed: Scalars['Int']['output'];
};

/**
 * Processing Job represents a processing work for the structure.
 * Data can be supplied, processed and delivered back in batches.
 */
export type ProcessingJob = {
  __typename?: 'ProcessingJob';
  /** Processing job description */
  description?: Maybe<Scalars['String']['output']>;
  /** Configuration of processing flow run */
  flowRunConfig?: Maybe<FlowRunConfig>;
  /** Unique processing job ID */
  id: Scalars['ID']['output'];
  /** Processing id to be used by client applications */
  processingId: Scalars['String']['output'];
  /** Structure that this processing job belongs to */
  structureId: Scalars['ObjectId']['output'];
  /** Path to use for data uploading from the client (starts with bucket name) */
  uploadPath?: Maybe<Scalars['String']['output']>;
};

export type ProcessingReferences = {
  __typename?: 'ProcessingReferences';
  localAnnotationId: Scalars['Int']['output'];
};

export type QaqcSectionConfig = {
  __typename?: 'QaqcSectionConfig';
  /** Whether section is expanded by default */
  defaultOpen?: Maybe<Scalars['Boolean']['output']>;
  /** Unique Section Config ID */
  id: Scalars['ID']['output'];
  /** Display order */
  order: Scalars['Int']['output'];
  /** Key for the section (e.g., 'blast_phase', 'coating_phase') */
  sectionKey: Scalars['String']['output'];
  /** Can have multiple entries/tables */
  supportsMultipleEntries: Scalars['Boolean']['output'];
  /** Multiple tables per section */
  tables: Array<QaqcTableConfig>;
  /** Display title (e.g., 'Blast Phase', 'Coating Phase') */
  title: Scalars['String']['output'];
};

export type QaqcSectionConfigInput = {
  /** Whether section is expanded by default */
  defaultOpen?: InputMaybe<Scalars['Boolean']['input']>;
  /** Display order */
  order: Scalars['Int']['input'];
  /** Key for the section (e.g., 'blast_phase', 'coating_phase') */
  sectionKey: Scalars['String']['input'];
  /** Can have multiple entries/tables */
  supportsMultipleEntries: Scalars['Boolean']['input'];
  /** Multiple tables per section */
  tables: Array<QaqcTableConfigInput>;
  /** Display title (e.g., 'Blast Phase', 'Coating Phase') */
  title: Scalars['String']['input'];
};

export type QaqcTableConfig = {
  __typename?: 'QaqcTableConfig';
  /** Field keys from template fields */
  fieldKeys: Array<Scalars['String']['output']>;
  /** Unique Table Config ID */
  id: Scalars['ID']['output'];
  /** Order within section */
  order: Scalars['Int']['output'];
  /** Can add multiple rows (entries) */
  supportsMultipleRows: Scalars['Boolean']['output'];
  /** Unique key for this table */
  tableKey: Scalars['String']['output'];
  /** Table title (e.g., 'Ambient Conditions') */
  title: Scalars['String']['output'];
};

export type QaqcTableConfigInput = {
  /** Field keys from template fields */
  fieldKeys: Array<Scalars['String']['input']>;
  /** Order within section */
  order: Scalars['Int']['input'];
  /** Can add multiple rows (entries) */
  supportsMultipleRows: Scalars['Boolean']['input'];
  /** Unique key for this table */
  tableKey: Scalars['String']['input'];
  /** Table title (e.g., 'Ambient Conditions') */
  title: Scalars['String']['input'];
};

export type Query = {
  __typename?: 'Query';
  Annotations: Array<Annotation>;
  GetPointOfInterestGroupedByWorkpack: Array<PointOfInterestsGroupedByWorkpack>;
  GetPointOfInterestGroupedByWorkpackCount?: Maybe<Count>;
  UserGroupsByStructureId?: Maybe<Array<Maybe<UserGroup>>>;
  allAnnotations: Array<Annotation>;
  allAssemblies: Array<Assembly>;
  allAssemblyPaintRegions: Array<AssemblyPaintRegion>;
  allBatches: Array<Batch>;
  allClients: Array<Client>;
  allComments?: Maybe<Array<Comment>>;
  allCuboids: Array<Maybe<Cuboid>>;
  allDecks: Array<Deck>;
  allDefects: Array<Defect>;
  allHistories: Array<History>;
  allImageSensors: Array<ImageSensor>;
  allLabelAnnotations: Array<Maybe<LabelAnnotation>>;
  allLocations: Array<Location>;
  allLocationsForAssembly?: Maybe<Array<Location>>;
  /** Get all logs templates */
  allLogsTemplates?: Maybe<Array<LogsTemplate>>;
  allPaintRegions: Array<PaintRegion>;
  allParts: Array<Part>;
  allPlatforms: Array<Platform>;
  /** Get all POITemplate */
  allPointOfInterestTemplate: Array<PointOfInterestTemplate>;
  /** Find all points of interest with optional filter arguments */
  allPointOfInterests: Array<PointOfInterest>;
  allProcessingJobs: Array<ProcessingJob>;
  allRegions?: Maybe<Array<Region>>;
  allReportImages: Array<PointOfInterestImages>;
  allReports: Array<Maybe<Report>>;
  allRoles: Array<Maybe<Role>>;
  allStructures: Array<Structure>;
  allStructuresByRegion: Array<AllStructuresByRegion>;
  allTeams: Array<Team>;
  allTemplates: Array<Template>;
  allUserGroups: Array<UserGroup>;
  allUsers: Array<User>;
  allVersions: Array<Version>;
  allWorkpackItems: Array<WorkpackItem>;
  /** Get all workpack templates */
  allWorkpackTemplates?: Maybe<Array<WorkpackTemplate>>;
  allWorkpacks: Array<Workpack>;
  /** Get analytics records with flexible filtering */
  analytics: Array<Analytics>;
  annotation?: Maybe<Annotation>;
  /** Find all archived (soft-deleted) points of interest for a structure */
  archivedPointOfInterests: ArchivedPointOfInterestsResponse;
  assembly?: Maybe<Assembly>;
  assemblyByTagName?: Maybe<Assembly>;
  client?: Maybe<Client>;
  cuboidsByClassId: Array<Maybe<Cuboid>>;
  cuboidsByZoneId: Array<Maybe<Cuboid>>;
  deck?: Maybe<Deck>;
  decksWithDefects: Array<DeckWithDefects>;
  defectsAreaByStructures: Array<DefectsAreaByStructuresResult>;
  defectsAreaForAssemblyPaintRegions: PaintBlocksCorrodedArea;
  /** Get paint region defects grouped by paint region group */
  defectsAreaForAssemblyPaintRegionsByGroup: PaintBlocksCorrodedAreaByGroup;
  /** Calculate dynamic block information for assembly paint regions */
  dynamicBlockCalculation: Scalars['JSON']['output'];
  fetchAssemblyScreenshot?: Maybe<Scalars['JSON']['output']>;
  /** Measure max height of a blister on the Location */
  fetchBlisterHeightMeasurement?: Maybe<BlisterHeightMeasurement>;
  fetchCropFromRectilinear?: Maybe<GenerateImageResult>;
  fetchDynamicSpatialBlockCalculation?: Maybe<Scalars['JSON']['output']>;
  fetchGenerateImage?: Maybe<GenerateImageResult>;
  fetchGetPaintRegionOfPoint?: Maybe<Scalars['Int']['output']>;
  /** Measure distance between two line points on the Location */
  fetchLineMeasurement?: Maybe<LineMeasurement>;
  fetchSpatialHeatmap?: Maybe<SpatialHeatmap>;
  filteredOptions: Array<FilteredOptions>;
  findClosestPaintRegion: FindClosestPaintRegionResult;
  /** Get aggregated KPI log entries */
  getAggregatedKpiLogEntries: Array<AggregatedKpiLogEntriesPerDate>;
  getAggregatedKpiLogs: Array<AggregatedKpiLogsPerDate>;
  getAlarmLevelSummary?: Maybe<Array<Maybe<AlarmLevelSummaryResult>>>;
  /** Get all POI icons */
  getAllPoiIcons: Array<Maybe<Scalars['String']['output']>>;
  getAllWorkpackAttachments: Array<WorkpackFile>;
  getAssembliesByPaintRegionIds: Array<Assembly>;
  getAssembliesByRiskAssessmentFilters: Array<Assembly>;
  getAssembliesByTemplateFieldDataFilters: Array<Assembly>;
  getAssembliesByTemplateFieldsFilters: Array<Assembly>;
  getAssembliesByTemplateFieldsFiltersForChat: Array<Assembly>;
  getAssembliesCount?: Maybe<Count>;
  getAssembliesDecksSummary: Array<Maybe<DeckAreaSummary>>;
  getAssembliesRiskAssessmentSummary: Array<Maybe<RiskAssessmentSummary>>;
  getAssembliesSummary: Array<AssemblySummary>;
  getAuth0Connections: Array<ConnectionAuth0>;
  getAuth0Permissions: Array<Permission>;
  getDependentRiskAssessmentOptions?: Maybe<Array<Maybe<RiskAssessmentDependentOptions>>>;
  getDirectlyAssignedUserPermissions: Array<Permission>;
  getInspectionPlans: Array<InspectionPlan>;
  getLogCards?: Maybe<Array<Maybe<Card>>>;
  /** Get log entry cards */
  getLogEntryCards?: Maybe<Array<Maybe<Card>>>;
  getNominationCalculations?: Maybe<NominationCalculations>;
  getPreRegisteredUserRoles: Array<Role>;
  getRiskAssembliesCount?: Maybe<Count>;
  getRiskAssessmentSummaryCounts?: Maybe<RiskAssessmentSummaryCounts>;
  getRiskAssessmentSummaryData?: Maybe<Array<Maybe<RiskAssessmentSummaryData>>>;
  getRiskAssessmentSummaryTableData: Array<RiskAssessmentSummaryTableData>;
  getSummarySheetGraphsCount?: Maybe<Array<Maybe<SummarySheetGraphsCount>>>;
  getUserAbilities?: Maybe<Scalars['String']['output']>;
  getUserColumnPreferences?: Maybe<UserColumnPreferences>;
  getUserPermissionsByRoles: Array<Auth0UserRoles>;
  getUserPreferences?: Maybe<UserPreferences>;
  getWorkpackAttachmentsPerDate: Array<WorkpackFile>;
  groupedReports: Array<Maybe<GroupedReports>>;
  groupsByPartIds: Array<PartGroup>;
  idmsTasks: IdmsTasksWithCount;
  idmsUploads: Array<IdmsUpload>;
  imageSensor?: Maybe<ImageSensor>;
  latestIdmsUploadsByType: Array<IdmsUpload>;
  location?: Maybe<Location>;
  /** Find log entries with filters */
  logEntries: Array<LogEntry>;
  /** Get all log entries for a given referenceId */
  logEntriesByReference: Array<LogEntry>;
  /** Get log entries per date (aggregated or individual) */
  logEntriesPerDate: Array<LogEntryLogFieldTotal>;
  /** Find one log entry by ID */
  logEntry?: Maybe<LogEntry>;
  /** Find one logs template */
  logsTemplate?: Maybe<LogsTemplate>;
  me?: Maybe<CurrentUser>;
  myUserGroups: Array<UserGroup>;
  paintDamageCountByAlarmLevel?: Maybe<Array<Maybe<AnomalyCount>>>;
  paintRegion?: Maybe<PaintRegion>;
  /** Combined CM + PSIM analytics by paint region name */
  paintRegionAnalyticsByStructures: Array<PaintRegionAnalyticsResult>;
  paintRegionByName?: Maybe<PaintRegion>;
  /** Get all paint region groups */
  paintRegionGroups: Array<PaintRegionGroup>;
  part?: Maybe<Part>;
  permissionsByRole: Array<RolePermission>;
  platform?: Maybe<Platform>;
  /** Find one point of interest */
  pointOfInterest?: Maybe<PointOfInterest>;
  pointOfInterestCountByPaintRegions: PointOfInterestsFindingsByDeckAndPaintBlock;
  /** Find one point of interest template */
  pointOfInterestTemplate?: Maybe<PointOfInterestTemplate>;
  pointOfInterests: Array<PointOfInterest>;
  pointOfInterestsCount?: Maybe<Count>;
  pointOfInterestsCountByDueDate?: Maybe<Array<Maybe<AnomalyCount>>>;
  pointOfInterestsCountByInspectionPriority?: Maybe<Array<Maybe<AnomalyCount>>>;
  pointOfInterestsCountByStatus?: Maybe<Array<Maybe<AnomalyCount>>>;
  pointOfInterestsCountByType?: Maybe<Array<Maybe<PointOfInterestsCountByType>>>;
  pointOfInterestsCountForChat?: Maybe<Count>;
  pointOfInterestsForChat: Array<PointOfInterest>;
  preRegisteredUsers: Array<PreRegisteredUser>;
  preRegisteredUsersCount: Count;
  /**
   * Get version history for all assembly paint regions which were remediated in a paint region
   * Returns assembly paint region versions with assembly tag name included
   */
  remediatedAssemblyPaintRegionVersionsByPaintRegion: Array<PaintRegionVersion>;
  /**
   * Get version history for all POIs which were remediated in a paint region
   * Returns POI versions with POI name and ID included
   */
  remediatedPOIVersionsByPaintRegion: Array<PaintRegionVersion>;
  report: Report;
  scCategoryOptions: Array<Scalars['String']['output']>;
  setting?: Maybe<Setting>;
  sphericalsPerZone?: Maybe<Array<SphericalsPerZone>>;
  structure?: Maybe<Structure>;
  structuresByUserGroup: Array<Structure>;
  structuresCount?: Maybe<Count>;
  supervoxelsClassesForStructure: Array<SupervoxelClass>;
  supervoxelsForStructure: Array<Maybe<SuperVoxels>>;
  team: Team;
  /** Find one Template */
  template?: Maybe<Template>;
  user?: Maybe<User>;
  userDetails: UserProfile;
  userGroup?: Maybe<UserGroup>;
  userGroupsCount?: Maybe<Count>;
  usersByRoleId: Array<User>;
  usersByTeam: Array<User>;
  usersByUserGroup: Array<User>;
  usersCount?: Maybe<Count>;
  validateBulkPoiUpload: Scalars['String']['output'];
  validateIdmsTemplate?: Maybe<Scalars['String']['output']>;
  validateReportScope: ValidateReportScopeResult;
  workpack?: Maybe<Workpack>;
  workpackItem?: Maybe<WorkpackItem>;
  workpackLogsPerDate: Array<WorkpackLogFieldTotal>;
  /** Find one workpack template */
  workpackTemplate?: Maybe<WorkpackTemplate>;
  zonesAndHistoriesFor: Array<ZoneAndHistory>;
  zonesForStructure: Array<Zone>;
  zonesForStructureCSV: Scalars['String']['output'];
  zonesPerStage?: Maybe<Array<ZonesPerWorklowStage>>;
  zonesPerStatusCount: Array<ZoneStatusCount>;
};


export type QueryAnnotationsArgs = {
  imageId: Scalars['String']['input'];
};


export type QueryGetPointOfInterestGroupedByWorkpackArgs = {
  input?: InputMaybe<PointOfInterestInput>;
  pageInfo?: InputMaybe<PageInfo>;
};


export type QueryGetPointOfInterestGroupedByWorkpackCountArgs = {
  input?: InputMaybe<PointOfInterestInput>;
};


export type QueryUserGroupsByStructureIdArgs = {
  structureId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryAllAnnotationsArgs = {
  locationId?: InputMaybe<Scalars['String']['input']>;
  structureId?: InputMaybe<Scalars['String']['input']>;
  templateId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryAllAssembliesArgs = {
  structureId?: InputMaybe<Scalars['String']['input']>;
  templateId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryAllAssemblyPaintRegionsArgs = {
  input?: InputMaybe<PaintBlockFiltersInput>;
};


export type QueryAllBatchesArgs = {
  structureId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryAllCommentsArgs = {
  input?: InputMaybe<AllCommentsInput>;
};


export type QueryAllCuboidsArgs = {
  structureId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryAllDecksArgs = {
  structureId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryAllDefectsArgs = {
  structureId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryAllHistoriesArgs = {
  collectionName?: InputMaybe<Scalars['String']['input']>;
  eventNames?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  referenceId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryAllImageSensorsArgs = {
  structureId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryAllLabelAnnotationsArgs = {
  structureId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryAllLocationsArgs = {
  pageInfo?: InputMaybe<PageInfo>;
  structureId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryAllLocationsForAssemblyArgs = {
  input?: InputMaybe<LocationsForAssemblyInput>;
};


export type QueryAllLogsTemplatesArgs = {
  input: LogsTemplateInput;
};


export type QueryAllPaintRegionsArgs = {
  input?: InputMaybe<FindAllPaintRegionsInput>;
};


export type QueryAllPartsArgs = {
  structureId?: InputMaybe<Scalars['String']['input']>;
  templateId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryAllPlatformsArgs = {
  regionId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryAllPointOfInterestTemplateArgs = {
  assemblyTemplateId?: InputMaybe<Scalars['ID']['input']>;
  structureId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryAllPointOfInterestsArgs = {
  input?: InputMaybe<FindAllPointOfInterestsInput>;
};


export type QueryAllProcessingJobsArgs = {
  structureId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryAllReportImagesArgs = {
  reportId: Scalars['ID']['input'];
};


export type QueryAllReportsArgs = {
  input?: InputMaybe<ReportsInput>;
};


export type QueryAllStructuresArgs = {
  input?: InputMaybe<StructureFilters>;
};


export type QueryAllTemplatesArgs = {
  structureId?: InputMaybe<Scalars['ID']['input']>;
  type?: InputMaybe<TemplateTypeEnum>;
};


export type QueryAllUserGroupsArgs = {
  userId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryAllUsersArgs = {
  input?: InputMaybe<FilterForUsers>;
  pageInfo?: InputMaybe<PageInfo>;
};


export type QueryAllVersionsArgs = {
  input?: InputMaybe<VersionInput>;
};


export type QueryAllWorkpackItemsArgs = {
  workpackId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryAllWorkpackTemplatesArgs = {
  input: WorkpackTemplateInput;
};


export type QueryAllWorkpacksArgs = {
  hasPois?: InputMaybe<Scalars['Boolean']['input']>;
  structureId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryAnalyticsArgs = {
  input?: InputMaybe<AnalyticsFiltersInput>;
};


export type QueryAnnotationArgs = {
  annotationId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryArchivedPointOfInterestsArgs = {
  pageInfo?: InputMaybe<PageInfo>;
  structureId: Scalars['ID']['input'];
};


export type QueryAssemblyArgs = {
  assemblyId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryAssemblyByTagNameArgs = {
  structureId: Scalars['ID']['input'];
  tagName: Scalars['String']['input'];
};


export type QueryClientArgs = {
  clientId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryCuboidsByClassIdArgs = {
  cuboidClassId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryCuboidsByZoneIdArgs = {
  zoneId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryDeckArgs = {
  deckId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryDecksWithDefectsArgs = {
  structureId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryDefectsAreaByStructuresArgs = {
  platformId: Scalars['ID']['input'];
};


export type QueryDefectsAreaForAssemblyPaintRegionsArgs = {
  input: PaintBlockFiltersInput;
};


export type QueryDefectsAreaForAssemblyPaintRegionsByGroupArgs = {
  input: PaintBlockFiltersInput;
  pageInfo?: InputMaybe<PageInfo>;
};


export type QueryDynamicBlockCalculationArgs = {
  input: DynamicBlockCalculationInput;
};


export type QueryFetchAssemblyScreenshotArgs = {
  s3Path: Scalars['String']['input'];
  url: Scalars['String']['input'];
};


export type QueryFetchBlisterHeightMeasurementArgs = {
  blisterMeasurementPoints?: InputMaybe<BlisterMeasurementInput>;
  locationId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryFetchCropFromRectilinearArgs = {
  input?: InputMaybe<GenerateCropFromRectilinearInput>;
};


export type QueryFetchDynamicSpatialBlockCalculationArgs = {
  input?: InputMaybe<DynamicSpatialHeatmapInput>;
};


export type QueryFetchGenerateImageArgs = {
  input?: InputMaybe<GenerateImageInput>;
};


export type QueryFetchGetPaintRegionOfPointArgs = {
  paintRegions?: InputMaybe<PaintRegionVolumesInput>;
  point?: InputMaybe<Array<Scalars['Float']['input']>>;
};


export type QueryFetchLineMeasurementArgs = {
  input?: InputMaybe<Array<InputMaybe<PolarPointMeasurementInput>>>;
  locationId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryFetchSpatialHeatmapArgs = {
  heatmapParameters?: InputMaybe<SpatialHeatmapInput>;
};


export type QueryFilteredOptionsArgs = {
  count?: InputMaybe<Scalars['Int']['input']>;
  fieldId?: InputMaybe<Scalars['ID']['input']>;
  fieldKey: Scalars['String']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  q?: InputMaybe<Scalars['String']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  templateId: Scalars['ID']['input'];
};


export type QueryFindClosestPaintRegionArgs = {
  input: FindClosestPaintRegionInput;
};


export type QueryGetAggregatedKpiLogEntriesArgs = {
  input: AggregatedKpiLogEntriesInput;
  pageInfo?: InputMaybe<PageInfo>;
};


export type QueryGetAggregatedKpiLogsArgs = {
  input?: InputMaybe<AggregratedKpiLogsInput>;
  pageInfo?: InputMaybe<PageInfo>;
};


export type QueryGetAlarmLevelSummaryArgs = {
  input?: InputMaybe<AlarmLevelSummaryInput>;
};


export type QueryGetAllWorkpackAttachmentsArgs = {
  input?: InputMaybe<GetAllWorkpackAttachmentsInput>;
};


export type QueryGetAssembliesByPaintRegionIdsArgs = {
  input: GetAssembliesByPaintRegionIdsInput;
};


export type QueryGetAssembliesByRiskAssessmentFiltersArgs = {
  input?: InputMaybe<RiskAssessmentFiltersInput>;
  pageInfo?: InputMaybe<PageInfo>;
};


export type QueryGetAssembliesByTemplateFieldDataFiltersArgs = {
  input?: InputMaybe<AssembliesFilterInput>;
  pageInfo?: InputMaybe<PageInfo>;
};


export type QueryGetAssembliesByTemplateFieldsFiltersArgs = {
  input?: InputMaybe<AssembliesFilterInput>;
  pageInfo?: InputMaybe<PageInfo>;
};


export type QueryGetAssembliesByTemplateFieldsFiltersForChatArgs = {
  input?: InputMaybe<AssembliesFilterInput>;
  pageInfo?: InputMaybe<PageInfo>;
};


export type QueryGetAssembliesCountArgs = {
  input?: InputMaybe<AssembliesFilterInput>;
};


export type QueryGetAssembliesDecksSummaryArgs = {
  input?: InputMaybe<AssembliesFilterInput>;
};


export type QueryGetAssembliesRiskAssessmentSummaryArgs = {
  input?: InputMaybe<RiskAssessmentSummaryInput>;
};


export type QueryGetAssembliesSummaryArgs = {
  input?: InputMaybe<AssembliesFilterInput>;
};


export type QueryGetAuth0ConnectionsArgs = {
  applicationId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetDependentRiskAssessmentOptionsArgs = {
  input?: InputMaybe<RiskAssessmentFiltersInput>;
};


export type QueryGetDirectlyAssignedUserPermissionsArgs = {
  userId: Scalars['String']['input'];
};


export type QueryGetInspectionPlansArgs = {
  structureId: Scalars['String']['input'];
};


export type QueryGetLogCardsArgs = {
  input?: InputMaybe<LogCardsInput>;
};


export type QueryGetLogEntryCardsArgs = {
  input: LogEntryCardsInput;
};


export type QueryGetNominationCalculationsArgs = {
  input?: InputMaybe<NominationCalculationsInput>;
};


export type QueryGetPreRegisteredUserRolesArgs = {
  email: Scalars['String']['input'];
};


export type QueryGetRiskAssembliesCountArgs = {
  input?: InputMaybe<RiskAssessmentFiltersInput>;
};


export type QueryGetRiskAssessmentSummaryCountsArgs = {
  structureId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetRiskAssessmentSummaryDataArgs = {
  input?: InputMaybe<RiskAssessmentSummaryDataInput>;
};


export type QueryGetRiskAssessmentSummaryTableDataArgs = {
  input?: InputMaybe<RiskAssessmentSummaryTableDataInput>;
};


export type QueryGetSummarySheetGraphsCountArgs = {
  input?: InputMaybe<SummarySheetGraphsCountInput>;
};


export type QueryGetUserColumnPreferencesArgs = {
  input?: InputMaybe<UserColumnPreferencesInput>;
};


export type QueryGetUserPermissionsByRolesArgs = {
  userId: Scalars['String']['input'];
};


export type QueryGetWorkpackAttachmentsPerDateArgs = {
  input?: InputMaybe<WorkpackAttachmentsPerDateInput>;
};


export type QueryGroupedReportsArgs = {
  input?: InputMaybe<ReportsInput>;
};


export type QueryGroupsByPartIdsArgs = {
  input?: InputMaybe<GroupsByPartIdsInput>;
};


export type QueryIdmsTasksArgs = {
  pageInfo?: InputMaybe<PageInfo>;
  structureId: Scalars['ID']['input'];
};


export type QueryIdmsUploadsArgs = {
  structureId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryImageSensorArgs = {
  imageSensorId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryLatestIdmsUploadsByTypeArgs = {
  structureId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryLocationArgs = {
  locationId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryLogEntriesArgs = {
  input: FindLogEntriesInput;
};


export type QueryLogEntriesByReferenceArgs = {
  input: FindLogEntriesByReferenceInput;
};


export type QueryLogEntriesPerDateArgs = {
  input: LogEntriesPerDateInput;
};


export type QueryLogEntryArgs = {
  logEntryId: Scalars['ID']['input'];
};


export type QueryLogsTemplateArgs = {
  logsTemplateId: Scalars['ID']['input'];
};


export type QueryPaintDamageCountByAlarmLevelArgs = {
  input?: InputMaybe<PointOfInterestMultiStructureInput>;
};


export type QueryPaintRegionArgs = {
  paintRegionId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryPaintRegionAnalyticsByStructuresArgs = {
  input: PaintRegionAnalyticsInput;
};


export type QueryPaintRegionByNameArgs = {
  paintRegionName?: InputMaybe<Scalars['String']['input']>;
  structureId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryPaintRegionGroupsArgs = {
  input: PaintRegionGroupFiltersInput;
};


export type QueryPartArgs = {
  partId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryPermissionsByRoleArgs = {
  roleId: Scalars['String']['input'];
};


export type QueryPlatformArgs = {
  platformId: Scalars['ID']['input'];
};


export type QueryPointOfInterestArgs = {
  pointOfInterestId: Scalars['ID']['input'];
};


export type QueryPointOfInterestCountByPaintRegionsArgs = {
  input?: InputMaybe<PaintBlockFiltersInput>;
};


export type QueryPointOfInterestTemplateArgs = {
  pointOfInterestTemplateId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryPointOfInterestsArgs = {
  input?: InputMaybe<PointOfInterestInput>;
  pageInfo?: InputMaybe<PageInfo>;
};


export type QueryPointOfInterestsCountArgs = {
  input?: InputMaybe<PointOfInterestInput>;
};


export type QueryPointOfInterestsCountByDueDateArgs = {
  input?: InputMaybe<PointOfInterestMultiStructureInput>;
};


export type QueryPointOfInterestsCountByInspectionPriorityArgs = {
  input?: InputMaybe<PointOfInterestInput>;
};


export type QueryPointOfInterestsCountByStatusArgs = {
  input?: InputMaybe<PointOfInterestMultiStructureInput>;
};


export type QueryPointOfInterestsCountByTypeArgs = {
  input?: InputMaybe<PointOfInterestInput>;
};


export type QueryPointOfInterestsCountForChatArgs = {
  input?: InputMaybe<PointOfInterestInput>;
};


export type QueryPointOfInterestsForChatArgs = {
  input?: InputMaybe<PointOfInterestInput>;
  pageInfo?: InputMaybe<PageInfo>;
};


export type QueryPreRegisteredUsersArgs = {
  input?: InputMaybe<FiltersForPreRegisteredUsers>;
  pageInfo?: InputMaybe<PageInfo>;
};


export type QueryPreRegisteredUsersCountArgs = {
  input?: InputMaybe<FiltersForPreRegisteredUsers>;
};


export type QueryRemediatedAssemblyPaintRegionVersionsByPaintRegionArgs = {
  input?: InputMaybe<RemediatedAssemblyPaintRegionVersionsByPaintRegionInput>;
};


export type QueryRemediatedPoiVersionsByPaintRegionArgs = {
  input?: InputMaybe<RemediatedPoiVersionsByPaintRegionInput>;
};


export type QueryReportArgs = {
  input?: InputMaybe<ReportInput>;
};


export type QueryScCategoryOptionsArgs = {
  structureId: Scalars['ID']['input'];
};


export type QuerySettingArgs = {
  revision?: InputMaybe<Scalars['Float']['input']>;
  type: SettingTypesEnum;
};


export type QuerySphericalsPerZoneArgs = {
  structureId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryStructureArgs = {
  structureId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryStructuresByUserGroupArgs = {
  input?: InputMaybe<FiltersForStructureByUserGroup>;
  pageInfo?: InputMaybe<PageInfo>;
};


export type QueryStructuresCountArgs = {
  input?: InputMaybe<FilterForStructures>;
};


export type QuerySupervoxelsClassesForStructureArgs = {
  structureId?: InputMaybe<Scalars['String']['input']>;
};


export type QuerySupervoxelsForStructureArgs = {
  supervoxelsForStructureInput?: InputMaybe<SupervoxelsForStructureInput>;
};


export type QueryTeamArgs = {
  teamId: Scalars['ID']['input'];
};


export type QueryTemplateArgs = {
  templateId: Scalars['ID']['input'];
  type?: InputMaybe<TemplateTypeEnum>;
};


export type QueryUserArgs = {
  userId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryUserDetailsArgs = {
  userId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryUserGroupArgs = {
  userGroupId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryUserGroupsCountArgs = {
  input?: InputMaybe<FilterForUserGroups>;
};


export type QueryUsersByRoleIdArgs = {
  input?: InputMaybe<UsersByRoleInput>;
  pageInfo?: InputMaybe<PageInfo>;
};


export type QueryUsersByTeamArgs = {
  pageInfo?: InputMaybe<PageInfo>;
  teamId: Scalars['ID']['input'];
};


export type QueryUsersByUserGroupArgs = {
  input?: InputMaybe<FilterForUsersByUserGroup>;
  pageInfo?: InputMaybe<PageInfo>;
};


export type QueryUsersCountArgs = {
  input?: InputMaybe<FiltersForUsersCount>;
};


export type QueryValidateBulkPoiUploadArgs = {
  input: BulkUploadPoisInput;
};


export type QueryValidateIdmsTemplateArgs = {
  input: ValidateIdmsTemplateQueryInput;
};


export type QueryValidateReportScopeArgs = {
  input?: InputMaybe<ValidateReportScopeInput>;
};


export type QueryWorkpackArgs = {
  workpackId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryWorkpackItemArgs = {
  workpackItemId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryWorkpackLogsPerDateArgs = {
  input?: InputMaybe<WorkpackLogsPerDateInput>;
};


export type QueryWorkpackTemplateArgs = {
  workpackTemplateId: Scalars['ID']['input'];
};


export type QueryZonesAndHistoriesForArgs = {
  structureId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryZonesForStructureArgs = {
  includeUnassigned?: InputMaybe<Scalars['Boolean']['input']>;
  searchTerm?: InputMaybe<Scalars['String']['input']>;
  structureId?: InputMaybe<Scalars['String']['input']>;
  userIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryZonesForStructureCsvArgs = {
  structureId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryZonesPerStageArgs = {
  input?: InputMaybe<ZonesPerStageInput>;
  pageInfo?: InputMaybe<PageInfo>;
};


export type QueryZonesPerStatusCountArgs = {
  searchTerm?: InputMaybe<Scalars['String']['input']>;
  structureId?: InputMaybe<Scalars['String']['input']>;
};

export type QuerySummaryCloneInput = {
  /** Name of template */
  name: Scalars['String']['input'];
  /** Source structure for the template Fields */
  sourceStructureId: Scalars['ID']['input'];
  /** Target structure for the template Fields */
  targetStructureId: Scalars['ID']['input'];
  /** Type of template */
  type: TemplateTypeEnum;
};

export type QuerySummaryInput = {
  /** Name of the collection where the item is stored */
  collectionName: Scalars['String']['input'];
  /** Array of display settings for the item */
  displayConfig?: InputMaybe<Array<DisplaySettingInput>>;
  /** Enum type representing how the item should be displayed */
  displayType: DisplayType;
  id: Scalars['ID']['input'];
  /** Optional field to store the key associated with the item */
  key?: InputMaybe<Scalars['String']['input']>;
  /** Match conditions, allowing complex filtering logic */
  matchCondition?: InputMaybe<Scalars['JSON']['input']>;
  /** Name of the query summary item */
  name: Scalars['String']['input'];
  /** Operation type for the item */
  operation: Scalars['String']['input'];
  /** Order of the item in the row */
  rowOrder: Scalars['Int']['input'];
  /** Direction of sort i.e. Ascending or Descending */
  sortDirection?: InputMaybe<Scalars['Int']['input']>;
  /** Sorting criteria for query summary items */
  sortType?: InputMaybe<SummaryItemSortType>;
};

export type QuerySummaryItem = {
  __typename?: 'QuerySummaryItem';
  /** Name of the collection where the item is stored */
  collectionName: Scalars['String']['output'];
  /** Array of display settings for the item */
  displayConfig?: Maybe<Array<DisplaySettings>>;
  /** Enum type representing how the item should be displayed */
  displayType: DisplayType;
  /** Unique identifier for each item */
  id: Scalars['ID']['output'];
  /** Optional field to store the key associated with the item */
  key?: Maybe<Scalars['String']['output']>;
  /** Match conditions, allowing complex filtering logic */
  matchCondition?: Maybe<Scalars['JSON']['output']>;
  /** Name of the query summary item */
  name: Scalars['String']['output'];
  /** Operation type for the item */
  operation: Scalars['String']['output'];
  /** Order of the item in the row */
  rowOrder: Scalars['Int']['output'];
  /** Direction of sort i.e. Ascending or Descending */
  sortDirection?: Maybe<Scalars['Int']['output']>;
  /** Sorting criteria for query summary items */
  sortType?: Maybe<SummaryItemSortType>;
};

export type RangeInput = {
  max?: InputMaybe<Scalars['Float']['input']>;
  maxIncluded?: InputMaybe<Scalars['Boolean']['input']>;
  min?: InputMaybe<Scalars['Float']['input']>;
  minIncluded?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ReOrderImagesInput = {
  assemblyId: Scalars['ID']['input'];
  reOrderImages: Array<ReOrderImagesItemInput>;
};

export type ReOrderImagesItemInput = {
  imageId: Scalars['ID']['input'];
  imagePosition: Scalars['Int']['input'];
};

export type RecalculatePlatformRiskScoresResult = {
  __typename?: 'RecalculatePlatformRiskScoresResult';
  /** Error message if recalculation failed */
  error?: Maybe<Scalars['String']['output']>;
  /** Success or error message */
  message: Scalars['String']['output'];
  /** Success status of the recalculation */
  success: Scalars['Boolean']['output'];
};

export type RecalculateRiskRemediationAnalyticsInput = {
  /** Structure ID to calculate analytics for */
  structureId: Scalars['ID']['input'];
};

export type RecalculateRiskRemediationAnalyticsResult = {
  __typename?: 'RecalculateRiskRemediationAnalyticsResult';
  /** Error message if recalculation failed */
  error?: Maybe<Scalars['String']['output']>;
  /** Success status of the recalculation */
  success: Scalars['Boolean']['output'];
};

export type Recommendation = {
  __typename?: 'Recommendation';
  /** Recommendation made during initial analysis of the assembly */
  analysisRecommendation?: Maybe<AlarmLevelRecommendation>;
  analysisStatus?: Maybe<RecommendationStatus>;
  blisters: Array<PointOfInterest>;
  /** Final recommendation */
  finalRecommendation?: Maybe<AlarmLevelRecommendation>;
  /**
   * Worst blister identified that would affect Abyss' recommendation for this assembly
   * (judgment of 'worst' may be subjective
   * e.g based on shape and position of blister and not just its height and corresponding wall loss)
   */
  governingValue?: Maybe<GoverningValueRecommendation>;
  /** Whether or not a final review is required after peer review, typically when analysis recommendation and review recommendation are conflicting */
  isFinalisationRequired?: Maybe<Scalars['Boolean']['output']>;
  /** Recommendation made during peer review of the recommendation from initial analysis */
  reviewRecommendation?: Maybe<AlarmLevelRecommendation>;
};

export type RecommendationDetailField = {
  __typename?: 'RecommendationDetailField';
  /** Unique human-readable key of the RecomendationDetalsField */
  fieldKey: Scalars['String']['output'];
  /** Unique Id of the RecomendationDetalsField */
  id: Scalars['ID']['output'];
};

export type RecommendationField = {
  __typename?: 'RecommendationField';
  /** Details field describe the dynamic field to render in the UI */
  details: Array<Maybe<RecommendationDetailField>>;
  /** Header field describe the text to display on the header of the UI */
  header: Scalars['String']['output'];
};

export enum RecommendationStatus {
  /** Assembly analysis has been completed by Abyss and recommendation recorded */
  Complete = 'COMPLETE',
  /** Recommendation not yet made by Abyss */
  Incomplete = 'INCOMPLETE'
}

export type Region = {
  __typename?: 'Region';
  /** Unique region ID */
  id: Scalars['ID']['output'];
  /** Name of this region */
  name: Scalars['String']['output'];
};

export type RemediatedAssemblyPaintRegionVersionsByPaintRegionInput = {
  eventId?: InputMaybe<Scalars['String']['input']>;
  paintRegionId: Scalars['String']['input'];
  structureId: Scalars['String']['input'];
};

export type RemediatedPoiVersionsByPaintRegionInput = {
  eventId?: InputMaybe<Scalars['String']['input']>;
  paintRegionId: Scalars['String']['input'];
  structureId: Scalars['String']['input'];
};

export type RemediationScoreAreaField = {
  __typename?: 'RemediationScoreAreaField';
  /** Field key for the area field */
  fieldKey: Scalars['String']['output'];
  /** Score value for the area field (minimum 1) */
  score: Scalars['Float']['output'];
  /** Threshold value for the area field (minimum 0.001) */
  threshold: Scalars['Float']['output'];
};

export type RemediationScoreAreaFieldInput = {
  /** Field key for the area field */
  fieldKey: Scalars['String']['input'];
  /** Score value for the area field (minimum 1) */
  score: Scalars['Float']['input'];
  /** Threshold value for the area field (minimum 0.001) */
  threshold: Scalars['Float']['input'];
};

export type RemediationScoreAreaSection = {
  __typename?: 'RemediationScoreAreaSection';
  /** Array of area fields */
  fields?: Maybe<Array<RemediationScoreAreaField>>;
};

export type RemediationScoreAreaSectionInput = {
  /** Array of area fields */
  fields?: InputMaybe<Array<RemediationScoreAreaFieldInput>>;
};

export type RemediationScoreCofField = {
  __typename?: 'RemediationScoreCofField';
  /** Field key for the COF field */
  fieldKey: Scalars['String']['output'];
  /** Map of option scores (all values minimum 1) */
  optionScores: Scalars['JSON']['output'];
};

export type RemediationScoreCofFieldInput = {
  /** Field key for the COF field */
  fieldKey: Scalars['String']['input'];
  /** Map of option scores (all values minimum 1) */
  optionScores: Scalars['JSON']['input'];
};

export type RemediationScoreCofSection = {
  __typename?: 'RemediationScoreCofSection';
  /** Array of COF fields */
  fields?: Maybe<Array<RemediationScoreCofField>>;
};

export type RemediationScoreCofSectionInput = {
  /** Array of COF fields */
  fields?: InputMaybe<Array<RemediationScoreCofFieldInput>>;
};

export type RemediationScoreConfig = {
  __typename?: 'RemediationScoreConfig';
  /** Area section configuration */
  area?: Maybe<RemediationScoreAreaSection>;
  /** COF section configuration */
  cof?: Maybe<RemediationScoreCofSection>;
  /** POI section configuration */
  poi?: Maybe<RemediationScorePoiSection>;
};

export type RemediationScoreConfigInput = {
  /** Area section configuration (can be null) */
  area?: InputMaybe<RemediationScoreAreaSectionInput>;
  /** COF section configuration (can be null) */
  cof?: InputMaybe<RemediationScoreCofSectionInput>;
  /** POI section configuration (can be null) */
  poi?: InputMaybe<RemediationScorePoiSectionInput>;
};

export type RemediationScorePoiField = {
  __typename?: 'RemediationScorePoiField';
  /** POI score value (minimum 1) */
  poiScore: Scalars['Float']['output'];
  /** POI template key identifier */
  poiTemplateKey: Scalars['String']['output'];
  /** Optional subcategory configuration */
  subcategory?: Maybe<RemediationScoreSubcategory>;
};

export type RemediationScorePoiFieldInput = {
  /** POI score value (minimum 1) */
  poiScore: Scalars['Float']['input'];
  /** POI template key identifier */
  poiTemplateKey: Scalars['String']['input'];
  /** Optional subcategory configuration */
  subcategory?: InputMaybe<RemediationScoreSubcategoryInput>;
};

export type RemediationScorePoiSection = {
  __typename?: 'RemediationScorePoiSection';
  /** Array of POI fields */
  fields?: Maybe<Array<RemediationScorePoiField>>;
};

export type RemediationScorePoiSectionInput = {
  /** Array of POI fields */
  fields?: InputMaybe<Array<RemediationScorePoiFieldInput>>;
};

export type RemediationScoreSubcategory = {
  __typename?: 'RemediationScoreSubcategory';
  /** Field key for the subcategory */
  fieldKey: Scalars['String']['output'];
  /** Map of option scores (all values minimum 1) */
  optionScores: Scalars['JSON']['output'];
};

export type RemediationScoreSubcategoryInput = {
  /** Field key for the subcategory */
  fieldKey: Scalars['String']['input'];
  /** Map of option scores (all values minimum 1) */
  optionScores: Scalars['JSON']['input'];
};

export type RemoveAttachmentsInput = {
  fileIds: Array<Scalars['ID']['input']>;
  pointOfInterestId: Scalars['ID']['input'];
};

export type RemoveSplitCuboidOnPartInput = {
  /** Object Id of part to remove split cuboid from */
  partId: Scalars['ID']['input'];
  /** Object Id of cuboid to remove */
  splitCuboidId: Scalars['ID']['input'];
  /** Object Id for the structure this part belongs to */
  structureId: Scalars['ID']['input'];
  /** Object Id for the zone the user is tagging in to filter the subscriptions */
  zoneId?: InputMaybe<Scalars['ID']['input']>;
};

export type RemoveSplitCuboidOnPartNotification = {
  __typename?: 'RemoveSplitCuboidOnPartNotification';
  /** Object Id of part to add cuboid to */
  partId: Scalars['ID']['output'];
  /** Object Id for the cuboid to remove */
  splitCuboidId: Scalars['ID']['output'];
  /** Object Id for the structure this part belongs to */
  structureId: Scalars['ID']['output'];
  /** Object Id for the zone the user is tagging in to filter the subscriptions */
  zoneId?: Maybe<Scalars['ID']['output']>;
};

export type RemoveWorkpackAttachmentsInput = {
  /** List of file IDs to remove */
  fileIds: Array<Scalars['ID']['input']>;
  /** Reason for the last update */
  lastModifiedFor: Scalars['String']['input'];
  /** Log date for which attachments are being removed (format: yyyy-mm-dd) */
  logDate: Scalars['String']['input'];
  /** Shift for which attachments are being removed (DAY or NIGHT) */
  shift?: InputMaybe<ShiftType>;
  /** Structure ID */
  structureId: Scalars['ID']['input'];
  /** IANA timezone identifier (e.g. 'America/New_York', 'Australia/Sydney') for date parsing */
  timezone: Scalars['String']['input'];
  /** Workpack from which to remove files */
  workpackId: Scalars['ID']['input'];
};

export type Report = {
  __typename?: 'Report';
  /** Current status of the action on the report i.e Backlog, In progress or Complete */
  actionStatus?: Maybe<ReportActionStatus>;
  /** All images references for each point of interest for updating Selected images for add or delete case */
  allPointOfInterestImages?: Maybe<Array<Maybe<PointOfInterestImages>>>;
  /** All pdfs references for each point of interest for updating Selected pdfs for add or delete case */
  allPointOfInterestPdfs?: Maybe<Array<Maybe<PointOfInterestPdfs>>>;
  /** Component ID this report refers to */
  components?: Maybe<Array<Assembly>>;
  /** Date this Report was created */
  createdAt: Scalars['String']['output'];
  /** User Who created the report */
  createdByUser: User;
  /** Deadline Date for action on the report */
  dueDate?: Maybe<Scalars['String']['output']>;
  /** User uploaded files to the report */
  files?: Maybe<Array<File>>;
  /** Report group the report belongs to */
  group?: Maybe<ReportGroup>;
  /** Unique Report ID */
  id?: Maybe<Scalars['ID']['output']>;
  /** Internal status of the report i.e POINT_OF_INTEREST or PAINT_BLOCK */
  internalType: ReportInternalType;
  /** Name of the report decided by the user */
  name: Scalars['String']['output'];
  /** Paint region Document IDs this Reports refers to */
  paintRegion?: Maybe<PaintRegion>;
  /** Paint region ID this Reports refers to */
  paintRegionId?: Maybe<Scalars['ID']['output']>;
  /** Point of Interests Document IDs this Reports refers to */
  pointOfInterests?: Maybe<Array<PointOfInterest>>;
  /** Order of assemblies and point of interests */
  reportOrder?: Maybe<ReportOrder>;
  /** Dynamic grouping of point of interest IDs by review action */
  reviewActionPoiIds?: Maybe<Scalars['JSON']['output']>;
  /** Dynamic grouping of point of interests by review action (populated from reviewActionPoiIds) */
  reviewActionPois?: Maybe<Scalars['JSON']['output']>;
  /** Selected images for point of interests */
  selectedPointOfInterestImages?: Maybe<Array<Maybe<PointOfInterestImages>>>;
  /** Start Date for workpack reports */
  startDate?: Maybe<Scalars['String']['output']>;
  /** Current status of the report i.e Draft, Published or Closed */
  status: ReportStatus;
  structure: Structure;
  /** Only to Store Data values  dynamically for this Report. Template doesnot exist for Reports */
  templateFieldData?: Maybe<Scalars['JSON']['output']>;
  /** Type of report i.e FM Workpack or MI Workpack or Inspection or Maintainance */
  type?: Maybe<ReportType>;
  /** Workpack number of Report */
  workpackNumber?: Maybe<Scalars['String']['output']>;
};

export enum ReportActionStatus {
  Backlog = 'BACKLOG',
  Complete = 'COMPLETE',
  InProgress = 'IN_PROGRESS'
}

export type ReportConfig = {
  __typename?: 'ReportConfig';
  configurations?: Maybe<Array<Configurations>>;
  id: Scalars['ID']['output'];
  imageOrientationConfig?: Maybe<ImageOrientationConfig>;
  paintBlockReportPoiTemplateTypes?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  poiReportOperationalTable?: Maybe<PoiOperationalTable>;
  poiSummaryChartsConfig?: Maybe<Scalars['JSON']['output']>;
  reviewActionTableConfigs?: Maybe<Scalars['JSON']['output']>;
  title: Scalars['String']['output'];
};

export type ReportConfigInput = {
  configurations?: InputMaybe<Array<InputMaybe<ConfigurationsInput>>>;
  id: Scalars['ID']['input'];
  imageOrientationConfig?: InputMaybe<ImageOrientationConfigInput>;
  paintBlockReportPoiTemplateTypes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  poiReportOperationalTable?: InputMaybe<PoiOperationalTableInput>;
  poiSummaryChartsConfig?: InputMaybe<Scalars['JSON']['input']>;
  reviewActionTableConfigs?: InputMaybe<Scalars['JSON']['input']>;
  title: Scalars['String']['input'];
};

export type ReportGroup = {
  __typename?: 'ReportGroup';
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export enum ReportInternalType {
  Component = 'COMPONENT',
  PaintBlock = 'PAINT_BLOCK',
  PointOfInterest = 'POINT_OF_INTEREST'
}

export type ReportOperationalFields = {
  __typename?: 'ReportOperationalFields';
  id?: Maybe<Scalars['ID']['output']>;
  key: Scalars['String']['output'];
  title: Scalars['String']['output'];
  visibility: Scalars['Boolean']['output'];
};

export type ReportOperationalFieldsInput = {
  key: Scalars['String']['input'];
  title: Scalars['String']['input'];
  visibility: Scalars['Boolean']['input'];
};

export type ReportOrder = {
  __typename?: 'ReportOrder';
  assemblyOrder?: Maybe<Array<Maybe<Scalars['ID']['output']>>>;
  poiOrder?: Maybe<Scalars['JSON']['output']>;
};

export type ReportOrderInput = {
  assemblyOrder?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  poiOrder?: InputMaybe<Scalars['JSON']['input']>;
};

export enum ReportStatus {
  Closed = 'CLOSED',
  Deleted = 'DELETED',
  Draft = 'DRAFT',
  Published = 'PUBLISHED'
}

export enum ReportType {
  FmWorkpack = 'FM_WORKPACK',
  Inspection = 'INSPECTION',
  InspectionWorkpack = 'INSPECTION_WORKPACK',
  Maintenance = 'MAINTENANCE',
  MiWorkpack = 'MI_WORKPACK'
}

export type ResetPasswordInput = {
  clientId: Scalars['String']['input'];
  connection: Scalars['String']['input'];
  email: Scalars['String']['input'];
};

export type RevertBulkLineFixingInput = {
  structureId: Scalars['ID']['input'];
};

export type ReviewActionChecklistConfig = {
  __typename?: 'ReviewActionChecklistConfig';
  /** Display name for the checklist (e.g., 'CVI Checklist', 'Close Visual Inspection Checklist') */
  displayName: Scalars['String']['output'];
  /** Unique Review Action Checklist Configuration ID */
  id: Scalars['ID']['output'];
  /** Whether to show this checklist in reports */
  isEnabled: Scalars['Boolean']['output'];
  /** Order of display */
  position: Scalars['Int']['output'];
  /** Review action value (e.g., 'CVI', 'GVI') */
  reviewActionValue: Scalars['String']['output'];
};

export type ReviewActionChecklistConfigInput = {
  /** Display name for the checklist (e.g., 'CVI Checklist', 'Close Visual Inspection Checklist') */
  displayName: Scalars['String']['input'];
  /** Unique Review Action Checklist Configuration ID */
  id: Scalars['ID']['input'];
  /** Whether to show this checklist in reports */
  isEnabled: Scalars['Boolean']['input'];
  /** Order of display */
  position: Scalars['Int']['input'];
  /** Review action value (e.g., 'CVI', 'GVI') */
  reviewActionValue: Scalars['String']['input'];
};

export type ReviewPanelConfig = {
  __typename?: 'ReviewPanelConfig';
  /** Unique identifier for the group */
  groupKey: Scalars['String']['output'];
  /** Name associated for the group in Review Panel */
  groupName: Scalars['String']['output'];
  /** Sections to be displayed within this group */
  groupSection: Array<Maybe<GroupSection>>;
  /** Unique Review Panel Configuration */
  id: Scalars['ID']['output'];
};

export type ReviewPanelConfigInput = {
  /** Unique identifier for the group */
  groupKey: Scalars['String']['input'];
  /** Name associated for the group in Review Panel */
  groupName: Scalars['String']['input'];
  /** Sections to be displayed within this group */
  groupSection: Array<GroupSectionInput>;
  /** Unique Review Panel Configuration ID */
  id: Scalars['ID']['input'];
};

export type RiskAssessment = {
  __typename?: 'RiskAssessment';
  /** TODO: Deprecated (RiskAssessment */
  age?: Maybe<Scalars['Int']['output']>;
  berthingCalculation?: Maybe<Scalars['Int']['output']>;
  corrosionCategory?: Maybe<Scalars['String']['output']>;
  hoursAtBerth?: Maybe<Scalars['Int']['output']>;
  mooringAnalysis?: Maybe<Scalars['Int']['output']>;
  percentDraftCondition?: Maybe<Scalars['Float']['output']>;
  percentOfHours?: Maybe<Scalars['Float']['output']>;
  shipsAtBerth?: Maybe<Scalars['Int']['output']>;
};

export type RiskAssessmentDependentOptions = {
  __typename?: 'RiskAssessmentDependentOptions';
  key?: Maybe<Scalars['String']['output']>;
  options?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type RiskAssessmentFiltersInput = {
  assemblyId?: InputMaybe<Scalars['ID']['input']>;
  includeComments?: InputMaybe<Scalars['Boolean']['input']>;
  searchText?: InputMaybe<Scalars['String']['input']>;
  selectedFilters?: InputMaybe<Array<RiskAssessmentSelectedFiltersInput>>;
  structureId: Scalars['ID']['input'];
  templateId: Scalars['ID']['input'];
};

export type RiskAssessmentSelectedFiltersInput = {
  id: Scalars['String']['input'];
  value: Scalars['String']['input'];
};

export type RiskAssessmentSummary = {
  __typename?: 'RiskAssessmentSummary';
  key?: Maybe<Scalars['String']['output']>;
  values?: Maybe<Array<Maybe<RiskType>>>;
};

export type RiskAssessmentSummaryCounts = {
  __typename?: 'RiskAssessmentSummaryCounts';
  cofCalculated?: Maybe<Scalars['Float']['output']>;
  pofCalculated?: Maybe<Scalars['Float']['output']>;
  totalAssemblies?: Maybe<Scalars['Float']['output']>;
  transitionPeriodCalculated?: Maybe<Scalars['Float']['output']>;
};

export type RiskAssessmentSummaryData = {
  __typename?: 'RiskAssessmentSummaryData';
  _id?: Maybe<Scalars['ID']['output']>;
  completedCalculationsCount?: Maybe<Scalars['Float']['output']>;
  damageClassCount?: Maybe<Array<Maybe<DamageClassCountType>>>;
  level1Component?: Maybe<Scalars['String']['output']>;
  totalCalculationsCount?: Maybe<Scalars['Float']['output']>;
};

export type RiskAssessmentSummaryDataInput = {
  selectedFilters?: InputMaybe<Array<RiskAssessmentSelectedFiltersInput>>;
  structureId: Scalars['ID']['input'];
};

export type RiskAssessmentSummaryInput = {
  assemblyId?: InputMaybe<Scalars['ID']['input']>;
  structureId: Scalars['ID']['input'];
  templateFieldKeys: Array<Scalars['String']['input']>;
  templateId: Scalars['ID']['input'];
};

export type RiskAssessmentSummaryTableData = {
  __typename?: 'RiskAssessmentSummaryTableData';
  calculations: Calculations;
  risk_damage_class: Scalars['String']['output'];
  risk_level_1_component: Scalars['String']['output'];
  risk_level_2_component: Scalars['String']['output'];
  risk_structure: Scalars['String']['output'];
};

export type RiskAssessmentSummaryTableDataInput = {
  selectedFilters?: InputMaybe<Array<RiskAssessmentSelectedFiltersInput>>;
  selectedLevel1Component: Scalars['String']['input'];
  structureId: Scalars['ID']['input'];
};

export type RiskFields = {
  __typename?: 'RiskFields';
  /** Key to identify template field */
  fieldKey: Scalars['String']['output'];
  /** Unique Risk Field ID */
  id: Scalars['ID']['output'];
  /** Identify whether the field needs to be displayed */
  isHiddenColumn: Scalars['Boolean']['output'];
  /** Identify where the field needs to be shown */
  type: Array<Maybe<RiskFieldsTypeEnum>>;
};

export type RiskFieldsInput = {
  /** Key to identify template field */
  fieldKey: Scalars['String']['input'];
  /** Identify whether the field needs to be displayed */
  isHiddenColumn: Scalars['Boolean']['input'];
  /** Identify where the field needs to be shown */
  type: Array<InputMaybe<RiskFieldsTypeEnum>>;
};

export enum RiskFieldsTypeEnum {
  Cof = 'COF',
  Pof = 'POF',
  Review = 'REVIEW',
  TransitionPeriod = 'TRANSITION_PERIOD'
}

export type RiskRemediationAnalyticsInput = {
  /** Structure ID to calculate analytics for */
  structureId: Scalars['ID']['input'];
};

export type RiskRemediationScore = {
  __typename?: 'RiskRemediationScore';
  /** Area risk score */
  areaRiskScore?: Maybe<Scalars['Float']['output']>;
  /** COF risk score */
  cofRiskScore?: Maybe<Scalars['Float']['output']>;
  /** Combined risk score */
  combinedScore?: Maybe<Scalars['Float']['output']>;
  /** POI risk score */
  poiRiskScore?: Maybe<Scalars['Float']['output']>;
};

export type RiskType = {
  __typename?: 'RiskType';
  count?: Maybe<Scalars['Int']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

export type Role = {
  __typename?: 'Role';
  /** Auth0 id of role */
  auth0Id: Scalars['String']['output'];
  /** Description of role */
  description?: Maybe<Scalars['String']['output']>;
  /** Unique role ID */
  id: Scalars['ID']['output'];
  /** Name of this role */
  name: Scalars['String']['output'];
  /** Permissions of role */
  permissions?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type RolePermission = {
  __typename?: 'RolePermission';
  description: Scalars['String']['output'];
  key: Scalars['String']['output'];
};

export type RollbackVersionInput = {
  referenceId: Scalars['String']['input'];
  rollbackVersionId: Scalars['String']['input'];
  structureId: Scalars['String']['input'];
};

export type SavePointOfInterestScreenshotInput = {
  /** Base64-encoded string of screenshot image */
  image: Scalars['String']['input'];
  /** Reason for the last update */
  lastModifiedFor?: InputMaybe<Scalars['String']['input']>;
  /** POI for which to save screenshot */
  pointOfInterestId: Scalars['ID']['input'];
  /** Type of screenshot, i.e. VIEWPOINT */
  type: ScreenshotTypeEnum;
};

export type ScreenshotInput = {
  assemblyIds: Array<Scalars['ID']['input']>;
  baseUrl: Scalars['String']['input'];
  fov?: InputMaybe<Scalars['Int']['input']>;
  includeBoundingBox?: InputMaybe<Scalars['Boolean']['input']>;
  lookAt?: InputMaybe<CoordinatesInput>;
  poiId?: InputMaybe<Scalars['String']['input']>;
  position?: InputMaybe<CoordinatesInput>;
  primaryAngle: PrimaryAngleEnum;
  selectedSpherical?: InputMaybe<Scalars['String']['input']>;
  structureId: Scalars['ID']['input'];
};

export type ScreenshotPaths = {
  __typename?: 'ScreenshotPaths';
  viewer?: Maybe<Scalars['String']['output']>;
  viewpoint?: Maybe<Scalars['String']['output']>;
};

export enum ScreenshotTypeEnum {
  Viewer = 'VIEWER',
  Viewpoint = 'VIEWPOINT'
}

export enum SectionUnitsEnum {
  Area = 'AREA',
  Gbp = 'GBP',
  Hours = 'HOURS',
  Na = 'NA',
  Usd = 'USD'
}

export type SeenByViewpoint = {
  __typename?: 'SeenByViewpoint';
  /** Metadata about if a viewpoint has been analysed, with respect to the relavant assembly */
  analysed?: Maybe<Analysed>;
  /** Corrosion detected on the portion of the part or assembly that the viewpoint can see */
  corrosion?: Maybe<Corrosion>;
  /**
   * Mean distance from the viewpoint's location to the portion of the part or assembly it can see -
   * ie how far away was the camera/scanner from the part (in metres)
   */
  distance?: Maybe<Scalars['Float']['output']>;
  /** Focal point for this assembly from this location */
  focalPoint?: Maybe<Vector3>;
  /** Viewpoint details including exact location and scan data */
  location: Location;
};

export type Service = {
  __typename?: 'Service';
  /** Code or acronym for the service an assembly provides e.g PG for Process Gas, can be empty when unknown */
  code?: Maybe<Scalars['String']['output']>;
  /**
   * Name of the group this service belongs to
   * - services are currently grouped to help ease prioritisation of assemblies
   * e.g. Hydrocarbon Lines include services Process Gas, Fuel Gas, etc
   */
  group: Scalars['String']['output'];
};

export type ServiceInput = {
  /** Code or acronym for the service an assembly provides e.g PG for Process Gas, can be empty when unknown */
  code?: InputMaybe<Scalars['String']['input']>;
  /** Name of the group this service belongs to */
  group?: InputMaybe<Scalars['String']['input']>;
};

export type SetAlarmLevelInput = {
  alarmLevelRecommendation: AlarmLevelRecommendationInput;
  assemblyId: Scalars['ID']['input'];
};

export type Setting = {
  __typename?: 'Setting';
  /** Unique Setting ID */
  id: Scalars['ID']['output'];
  meta: Array<Meta>;
  /** Name of this Setting */
  name: Scalars['String']['output'];
  /** Revision of this Setting, i.e. 0 */
  revision: Scalars['Int']['output'];
  /** Type of this Setting, i.e. COLOUR_MAP_FOR_3D_VIEWER_PARTS */
  type: SettingTypesEnum;
};

export enum SettingTypesEnum {
  ColourMapForAbyssViewerDefects = 'COLOUR_MAP_FOR_ABYSS_VIEWER_DEFECTS',
  ColourMapForAbyssViewerParts = 'COLOUR_MAP_FOR_ABYSS_VIEWER_PARTS',
  ColourMapForDeckHeatmapApiModes = 'COLOUR_MAP_FOR_DECK_HEATMAP_API_MODES',
  /** Status labels for Paint Region statuses (e.g., Completed vs Remediated) */
  PaintRegionStatusLabels = 'PAINT_REGION_STATUS_LABELS',
  /** Status labels for POI statuses */
  PoiStatusLabels = 'POI_STATUS_LABELS',
  /** Status labels for Workpack statuses */
  WorkpackStatusLabels = 'WORKPACK_STATUS_LABELS'
}

export type SheetData = {
  service: ServiceInput;
  tagName: Scalars['String']['input'];
  templateFieldData: Scalars['String']['input'];
};

export enum ShiftType {
  Day = 'DAY',
  Night = 'NIGHT'
}

export enum SortTypeEnum {
  Number = 'NUMBER',
  String = 'STRING'
}

export type SpatialHeatmap = {
  __typename?: 'SpatialHeatmap';
  svg: Scalars['String']['output'];
};

export type SpatialHeatmapInput = {
  deckId: Scalars['ID']['input'];
  modes: ModeInput;
  selectedTemplateFilters?: InputMaybe<Array<InputMaybe<FiltersInput>>>;
  structureId: Scalars['ID']['input'];
  workpackIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type SpatialHeatmapStep = {
  __typename?: 'SpatialHeatmapStep';
  x: Scalars['Float']['output'];
  y: Scalars['Float']['output'];
  z: Scalars['Float']['output'];
};

export type SphericalsPerZone = {
  __typename?: 'SphericalsPerZone';
  totalSphericals: Scalars['Int']['output'];
  zoneId: Scalars['ID']['output'];
};

export type SplitCuboid = {
  __typename?: 'SplitCuboid';
  /** Assembly that this cuboid volume should belong to */
  assembly?: Maybe<Assembly>;
  assemblyId?: Maybe<Scalars['ID']['output']>;
  /** Cuboid colour (RGB) */
  color: Scalars['Int']['output'];
  /** Unique ID */
  id: Scalars['ID']['output'];
  /** Position of the cuboid (x,y,z) */
  position: Array<Scalars['Float']['output']>;
  /** Rotation of the cuboid (roll,pitch,yaw). Euler angles using Three.js Euler conventions. */
  rotation: Array<Scalars['Float']['output']>;
  /** Size of the cuboid in 3 axes (x,y,z) */
  scale: Array<Scalars['Float']['output']>;
};

export type SplitCuboidInput = {
  /** Assembly that this cuboid volume should belong to */
  assemblyId?: InputMaybe<Scalars['ID']['input']>;
  /** Cuboid colour (RGB) */
  color: Scalars['Int']['input'];
  /** Unique Cuboid ID */
  id: Scalars['ID']['input'];
  /** Position of the cuboid (x,y,z) */
  position: Array<Scalars['Float']['input']>;
  /** Rotation of the cuboid (roll,pitch,yaw). Euler angles using Abyss conventions. */
  rotation: Array<Scalars['Float']['input']>;
  /** Size of the cuboid in 3 axes (x,y,z) */
  scale: Array<Scalars['Float']['input']>;
};

export type SplitPartInput = {
  /** Object Ids of all the annotations to split from given part into a new part */
  annotationIdsForNewPart: Array<Scalars['ID']['input']>;
  /** Object Id of the part to split */
  partId: Scalars['ID']['input'];
  /** Object Id for the structure this part belongs to */
  structureId: Scalars['ID']['input'];
  /** Object Id for the zone the user is tagging in to filter the subscriptions */
  zoneId?: InputMaybe<Scalars['ID']['input']>;
};

export enum StageType {
  Annotation = 'ANNOTATION',
  Review = 'REVIEW'
}

export enum StatusRemediatedThrough {
  PaintRegion = 'PAINT_REGION'
}

/** String array metadata */
export type StringArrayMeta = {
  __typename?: 'StringArrayMeta';
  key: Scalars['String']['output'];
  value: Array<Scalars['String']['output']>;
};

/** String metadata */
export type StringMeta = {
  __typename?: 'StringMeta';
  key: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

/**
 * A Structure whose condition is being inspected.
 *
 * A Structure exists on a Location where data is captured, processed, then analysed to assess the overall condition of the Structure.
 */
export type Structure = {
  __typename?: 'Structure';
  /** Base path for assembly CAD-model resources */
  assemblyCadModelsBasePath?: Maybe<Scalars['String']['output']>;
  /** Assembly types existing for each structure, valid values may vary from platform to platform */
  assemblyTypes: Array<Scalars['String']['output']>;
  /** URL for base image for this Structure */
  baseImage?: Maybe<Scalars['String']['output']>;
  /**
   * List of all base paths in CDN where static assets for this Structure have been deployed.
   * Used to determine access control for CDN assets.
   */
  basePaths: Array<Scalars['String']['output']>;
  /** Blister height type */
  blisterHeightType?: Maybe<BlisterHeightType>;
  /** Path to JSON file with CAD octree files hierarchy */
  cadOctreeResourcesPath?: Maybe<Scalars['String']['output']>;
  /** Card insight detail for a structure */
  cardInsights?: Maybe<Array<CardInsights>>;
  /** Category assigned to this structure for analytics grouping */
  category?: Maybe<Scalars['String']['output']>;
  /**
   * Coating Condition Category Mapping
   * In some platforms we use different terminology for the same thing, this is a mapping to help us translate between the two platforms
   */
  coatingCategoryMapping?: Maybe<Scalars['JSON']['output']>;
  /** Structure Config */
  config?: Maybe<StructureConfig>;
  /** URL for cover image for this Structure */
  coverImage?: Maybe<Scalars['String']['output']>;
  /** Path for cover image for this Structure */
  coverImagePath: Scalars['String']['output'];
  /** Date this Structure was created */
  createdAt: Scalars['String']['output'];
  /** Classes assigned to Cuboids for 3D Asset Labelling */
  cuboidClasses?: Maybe<Array<LabelClass>>;
  /** Default assembly id for the structure (When adding a poi without assembly this assembly id will be used) */
  defaultAssemblyId?: Maybe<Scalars['ID']['output']>;
  /** Defect Area for the structure */
  defectArea?: Maybe<Scalars['JSON']['output']>;
  /** List of legends and colors for the structure defects */
  defectLegends: Array<DefectLegend>;
  /** Deployment level of this Structure, i.e. COMPONENT LEVEL, FACILITY LEVEL */
  deploymentLevel?: Maybe<StructureDeploymentLevel>;
  /** Description of this Structure */
  description: Scalars['String']['output'];
  /** Equipment Classes defined on a particular structure */
  equipmentClasses: Array<EquipmentClasses>;
  /** Status of the ES Sheet for this structure */
  esSheetStatus?: Maybe<EsSheetStatus>;
  /** Features enabled for the structure */
  features?: Maybe<Scalars['JSON']['output']>;
  /** Template Field to be used to calculate fleet health score */
  fleetHealthTemplateField?: Maybe<Scalars['String']['output']>;
  /** Octree data for this platform contains RGB colors */
  hasRGB?: Maybe<Scalars['Boolean']['output']>;
  /**
   * If this structure can perform a risk assesment. If this structure has the data needed to
   * perform a risk assesment, then this field will be set to 'true'
   */
  hasRiskAssessment?: Maybe<Scalars['Boolean']['output']>;
  /** Structure Has find viewpoint by point data and feature enabled */
  hasVoxelLocations?: Maybe<Scalars['Boolean']['output']>;
  /** Unique Structure ID */
  id: Scalars['ID']['output'];
  /** It will check if the structure is an active deployment or not */
  isActive?: Maybe<Scalars['Boolean']['output']>;
  /** Whether the structure is using the legacy equipment strategy */
  isLegacyEquipmentStrategy?: Maybe<Scalars['Boolean']['output']>;
  /** To switch the Abyss Rating Equation and incorporate the wall loss calculations in it */
  isWallLossEnabled?: Maybe<Scalars['Boolean']['output']>;
  /** Input Classes for 3D Asset Labelling */
  labelClasses?: Maybe<Array<LabelClass>>;
  /** Large voxel size parameter of voxel locations data (deployed file per large voxel in s3 bucket) */
  largeVoxelSize?: Maybe<Scalars['Float']['output']>;
  /** Auth0 ID of the user who last updated this POI Template */
  lastModifiedBy?: Maybe<Scalars['String']['output']>;
  /** Timestamp for the last update made from the API */
  lastModifiedByAPI?: Maybe<Scalars['String']['output']>;
  /** User who made the last update */
  lastModifiedByUser?: Maybe<User>;
  /** Reason for the last update */
  lastModifiedFor?: Maybe<Scalars['String']['output']>;
  /** Name of this Structure */
  name: Scalars['String']['output'];
  /** Path to directory contatining JSON file per assembly with the list of octree nodes for the assembly */
  nodesPerAssemblyPath?: Maybe<Scalars['String']['output']>;
  /** Nomination configuration stored at structure level */
  nominationConfig?: Maybe<NominationConfig>;
  /** Path to JSON file with octree files hierarchy */
  octreeResourcesPath: Scalars['String']['output'];
  /** List of and colors for each part */
  partLegends?: Maybe<Array<PartLegend>>;
  /** Path to photogrammetry 3d-tiles tileset.json */
  photogrammetryTilesPath?: Maybe<Scalars['String']['output']>;
  /** Platform this Structure belongs to */
  platform?: Maybe<Platform>;
  /** Region this Structure belongs to */
  region?: Maybe<Region>;
  /** POI report configuration */
  reportConfig?: Maybe<ReportConfig>;
  /** TODO: deprecated */
  riskAssessment?: Maybe<RiskAssessment>;
  /**
   * Subtract Condition Category Mapping
   * In some platforms we use different terminology for the same thing, this is a mapping to help us translate between the two platforms
   */
  scCategoryMapping?: Maybe<Scalars['JSON']['output']>;
  /** Date representing the last time the structure was scanned */
  scanDate?: Maybe<Scalars['String']['output']>;
  /** Transform of Scans to CAD space in Abyss convention (x,y,z,roll,pitch,yaw) */
  scansToCadTransform?: Maybe<Array<Scalars['Float']['output']>>;
  /**
   * List of service groups that assemblies in this rootAsset belong to,
   * stored here so we can easily get a list of service groups to filter
   * assemblies by
   */
  serviceGroups: Array<Scalars['String']['output']>;
  /** The current processing stage of the structure */
  status: StructureStatus;
  structurePipesConfig?: Maybe<StructurePipesConfig>;
  /** Path to JSON file with structure relationships */
  structureRelationshipPath?: Maybe<Scalars['String']['output']>;
  /** Template related to this structure for dynamic data */
  template?: Maybe<Template>;
  /** Data values associated with Template for this structure */
  templateData?: Maybe<Array<TemplateData>>;
  /** Type of this Structure, i.e. PLATFORM */
  type: StructureTypes;
  /** Date this Structure was last updated */
  updatedAt: Scalars['String']['output'];
  /** User who last updated this Structure */
  updatedBy?: Maybe<Scalars['String']['output']>;
  /** User groups with access to this Structure */
  userGroups: Array<UserGroup>;
  /** Path to voxel locations directory containing large voxel json files */
  voxelLocationsPath?: Maybe<Scalars['String']['output']>;
  /** Voxel size parameter of voxel locations data (voxel size for locations lookup) */
  voxelSize?: Maybe<Scalars['Float']['output']>;
  /** Value that will calculate wall loss for different deployments */
  wallLossFactor?: Maybe<Scalars['Float']['output']>;
  /** Details about the labelling workflow */
  workflowStages?: Maybe<Array<Maybe<WorkflowStages>>>;
};

export type StructureConfig = {
  __typename?: 'StructureConfig';
  /** Disables click on hidden points */
  disableClickOnHiddenPoints?: Maybe<Scalars['Boolean']['output']>;
  /** Neighbouring images options */
  neighbouringImagesOptions?: Maybe<NeighbouringImagesOptions>;
  /**
   * Used to set the initial north value of the Viewer compass.
   * The scale value is around 0-7, where 0 is the default north value.
   * Setting it to 7 will rotate the compass 360 degrees.
   */
  northRotation?: Maybe<Scalars['Float']['output']>;
  /**
   * For the cuboid editor feature, used in spacial query.
   * This value determines the 'step' size for the resizing of the workscope cuboid.
   * This should be in metres.
   * Normal value ranges from 0.1 to 1.0
   */
  spatialHeatmapStep?: Maybe<SpatialHeatmapStep>;
  /** Spherical Viewer Visibility Radius */
  sphereRadius?: Maybe<Scalars['Float']['output']>;
};

export enum StructureDeploymentLevel {
  ComponentLevel = 'COMPONENT_LEVEL',
  EsDeployment = 'ES_DEPLOYMENT',
  FacilityLevel = 'FACILITY_LEVEL'
}

export type StructureFilters = {
  clientId?: InputMaybe<Scalars['String']['input']>;
  excludeByUserGroupId?: InputMaybe<Scalars['ID']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  platformId?: InputMaybe<Scalars['ID']['input']>;
  regionId?: InputMaybe<Scalars['ID']['input']>;
};

export type StructurePipesConfig = {
  __typename?: 'StructurePipesConfig';
  imperialSteelPipes?: Maybe<Scalars['JSON']['output']>;
};

export enum StructureStatus {
  /** All assests of a structure have been tagged and are ready for MI analysis */
  Analysis = 'ANALYSIS',
  /** For 3D asset labelling using Cuboids */
  AssetLabelling_3D = 'ASSET_LABELLING_3D',
  /** For labelling of a structure */
  Labelling = 'LABELLING',
  /** Structure tag data has been captured and processed and are ready for quality checks */
  Tagging = 'TAGGING'
}

export enum StructureTypes {
  ChainLink = 'CHAIN_LINK',
  Jacket = 'JACKET',
  Platform = 'PLATFORM'
}

export type StructureWithDefects = {
  __typename?: 'StructureWithDefects';
  defectArea: Array<DefectArea>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  status: StructureStatus;
};

export type StructuresAndGroups = {
  __typename?: 'StructuresAndGroups';
  structures: Array<Structure>;
  userGroups: Array<UserGroup>;
};

export type Subscription = {
  __typename?: 'Subscription';
  annotationUpdated?: Maybe<Annotation>;
  assemblyTagNameAdded?: Maybe<AssemblyTagNameAdded>;
  assemblyUpdated?: Maybe<AssemblyUpdatedEventResult>;
  commentAdded: Comment;
  commentDeleted: Comment;
  partSplit: PartSplitNotification;
  partsAddedToAssembly: Array<PartsAddedToAssemblyNotification>;
  partsHiddenFlagUpdated: Array<PartHiddenFlagUpdatedNotification>;
  partsReviewedFlagUpdated: Array<PartReviewFlagUpdatedNotification>;
  /** Event that is fired after the point of interest activity is updated */
  pointOfInterestActivity: PointOfInterest;
  /** Event that is fired after POI is created */
  pointOfInterestCreated?: Maybe<PointOfInterest>;
  /** Event that is fired after POI is deleted */
  pointOfInterestDeleted?: Maybe<PointOfInterest>;
  /** Event that is fired after POI screenshot is saved */
  pointOfInterestScreenshotSaved?: Maybe<PointOfInterest>;
  /** Event that is fired after POI is updated */
  pointOfInterestUpdated?: Maybe<PointOfInterest>;
  /** Event that is fired after POI Visibility is updated */
  pointOfInterestVisibilityUpdated: Array<PointOfInterest>;
  reportPointOfInterestVerified: VerifiedDetails;
  roleAssignedToUsers?: Maybe<Role>;
  roleRemovedFromUsers?: Maybe<Role>;
  /** Event that is fired after the selected POI is updated */
  selectedPointOfInterestUpdated: PointOfInterest;
  /** Removing notification for a Split Cuboid on the Part */
  splitCuboidOnPartRemoved: Array<RemoveSplitCuboidOnPartNotification>;
  /** Adding/Updating notification for a Split Cuboid on the Part */
  splitCuboidOnPartUpdated: Array<AddUpdateSplitCuboidOnPartNotification>;
  supervoxelsUpdated: Array<SuperVoxels>;
  /** Event that is fired after Template is created */
  templateCreated?: Maybe<Template>;
  /** Event that is fired after Template is deleted */
  templateDeleted?: Maybe<Template>;
  /** Event that is fired after Template is updated */
  templateUpdated?: Maybe<Template>;
  userAddedToUserGroup?: Maybe<UserGroup>;
  userGroupCreated?: Maybe<UserGroup>;
  userGroupDeleted?: Maybe<UserGroup>;
  userGroupRemovedFromStructure?: Maybe<Structure>;
  userGroupUpdated?: Maybe<UserGroup>;
  userGroupsAddedToStructure?: Maybe<StructuresAndGroups>;
  userGroupsRemovedFromStructure?: Maybe<StructuresAndGroups>;
  userRemovedFromUserGroup?: Maybe<UserGroup>;
  workFlowTimeUpdated: Zone;
  workpackCreated?: Maybe<Workpack>;
  workpackDeleted?: Maybe<Workpack>;
  workpackItemCreated?: Maybe<WorkpackItem>;
  workpackItemDeleted?: Maybe<WorkpackItem>;
  workpackItemUpdated?: Maybe<WorkpackItem>;
  workpackUpdated?: Maybe<Workpack>;
};


export type SubscriptionAssemblyTagNameAddedArgs = {
  structureId?: InputMaybe<Scalars['String']['input']>;
};


export type SubscriptionAssemblyUpdatedArgs = {
  assemblyId: Scalars['String']['input'];
  structureId: Scalars['String']['input'];
};


export type SubscriptionCommentAddedArgs = {
  referenceId?: InputMaybe<Scalars['ID']['input']>;
  structureId?: InputMaybe<Scalars['ID']['input']>;
};


export type SubscriptionCommentDeletedArgs = {
  referenceId?: InputMaybe<Scalars['ID']['input']>;
  structureId?: InputMaybe<Scalars['ID']['input']>;
};


export type SubscriptionPartSplitArgs = {
  structureId?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
};


export type SubscriptionPartsAddedToAssemblyArgs = {
  structureId?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
};


export type SubscriptionPartsHiddenFlagUpdatedArgs = {
  structureId?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
};


export type SubscriptionPartsReviewedFlagUpdatedArgs = {
  structureId?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
};


export type SubscriptionPointOfInterestActivityArgs = {
  assemblyId?: InputMaybe<Scalars['ID']['input']>;
  structureId: Scalars['ID']['input'];
};


export type SubscriptionReportPointOfInterestVerifiedArgs = {
  reportId?: InputMaybe<Scalars['ID']['input']>;
};


export type SubscriptionSelectedPointOfInterestUpdatedArgs = {
  poiId?: InputMaybe<Scalars['ID']['input']>;
};


export type SubscriptionSplitCuboidOnPartRemovedArgs = {
  structureId?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
};


export type SubscriptionSplitCuboidOnPartUpdatedArgs = {
  structureId?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
};


export type SubscriptionSupervoxelsUpdatedArgs = {
  structureId?: InputMaybe<Scalars['String']['input']>;
};


export type SubscriptionTemplateCreatedArgs = {
  structureId?: InputMaybe<Scalars['String']['input']>;
};


export type SubscriptionTemplateDeletedArgs = {
  structureId?: InputMaybe<Scalars['String']['input']>;
};


export type SubscriptionTemplateUpdatedArgs = {
  structureId?: InputMaybe<Scalars['String']['input']>;
};


export type SubscriptionWorkFlowTimeUpdatedArgs = {
  structureId?: InputMaybe<Scalars['ID']['input']>;
  zoneId?: InputMaybe<Scalars['ID']['input']>;
};

export type Subtitle = {
  __typename?: 'Subtitle';
  icon?: Maybe<Scalars['String']['output']>;
  iconPosition?: Maybe<InputAdormentPositionEnum>;
  position?: Maybe<LabelPositionEnum>;
  roundToDecimal?: Maybe<Scalars['Int']['output']>;
  text?: Maybe<Scalars['String']['output']>;
  unit?: Maybe<SectionUnitsEnum>;
  unitPosition?: Maybe<UnitPositionEnum>;
  value?: Maybe<Scalars['Float']['output']>;
};

export type SubtitleConfig = {
  __typename?: 'SubtitleConfig';
  aggregation?: Maybe<Aggregation>;
  equationKey?: Maybe<Scalars['String']['output']>;
  icon?: Maybe<Scalars['String']['output']>;
  iconPosition?: Maybe<InputAdormentPositionEnum>;
  position?: Maybe<LabelPositionEnum>;
  prefix?: Maybe<Scalars['String']['output']>;
  roundToDecimal?: Maybe<Scalars['Int']['output']>;
  suffix?: Maybe<Scalars['String']['output']>;
  text?: Maybe<Scalars['String']['output']>;
  textFormat?: Maybe<TextFormatEnum>;
  unit?: Maybe<SectionUnitsEnum>;
  unitPosition?: Maybe<UnitPositionEnum>;
};

export type SubtitleConfigInput = {
  aggregation?: InputMaybe<AggregationInput>;
  equationKey?: InputMaybe<Scalars['String']['input']>;
  icon?: InputMaybe<Scalars['String']['input']>;
  iconPosition?: InputMaybe<InputAdormentPositionEnum>;
  position?: InputMaybe<LabelPositionEnum>;
  prefix?: InputMaybe<Scalars['String']['input']>;
  roundToDecimal?: InputMaybe<Scalars['Int']['input']>;
  suffix?: InputMaybe<Scalars['String']['input']>;
  text?: InputMaybe<Scalars['String']['input']>;
  textFormat?: InputMaybe<TextFormatEnum>;
  unit?: InputMaybe<SectionUnitsEnum>;
  unitPosition?: InputMaybe<UnitPositionEnum>;
};

export enum SummaryItemSortType {
  Count = 'COUNT',
  Default = 'DEFAULT'
}

export type SummarySheetGraphsCount = {
  __typename?: 'SummarySheetGraphsCount';
  count?: Maybe<Scalars['Float']['output']>;
  key?: Maybe<Scalars['String']['output']>;
};

export type SummarySheetGraphsCountInput = {
  key: Scalars['String']['input'];
  structureId: Scalars['ID']['input'];
};

export type SuperVoxels = {
  __typename?: 'SuperVoxels';
  /** Unique SuperVoxel ID */
  id?: Maybe<Scalars['ID']['output']>;
  /** Structure of this super voxel */
  structureId: Scalars['ObjectId']['output'];
  /** 3D reference of super voxel */
  supervoxel3DReference: Scalars['Int']['output'];
  /** Super voxel class of the this super voxel */
  supervoxelClassId?: Maybe<Scalars['ID']['output']>;
  /** Zone of this super voxel */
  zoneId: Scalars['ObjectId']['output'];
};

export type SupervoxelClass = {
  __typename?: 'SupervoxelClass';
  /** Color of the supervoxel class */
  color: Scalars['String']['output'];
  /** SuperVoxel ID */
  id: Scalars['ID']['output'];
  /** Name of supervoxel class */
  name: Scalars['String']['output'];
  /** Structure of this supervoxel class */
  structureId: Scalars['ObjectId']['output'];
};

export type SyncAnalyticsDataResult = {
  __typename?: 'SyncAnalyticsDataResult';
  /** Success message */
  message: Scalars['String']['output'];
  /** Overall success status */
  success: Scalars['Boolean']['output'];
};

export type SyncLogsTemplatesInput = {
  structureId: Scalars['ID']['input'];
  templateId: Scalars['ID']['input'];
};

export type SyncWorkpackTemplatesInput = {
  structureId: Scalars['ID']['input'];
  templateId: Scalars['ID']['input'];
};

export enum TableCellStyleEnum {
  ArrowUpward = 'ARROW_UPWARD',
  Boolean = 'BOOLEAN',
  Bullet = 'BULLET',
  Chip = 'CHIP',
  Date = 'DATE',
  Dropdown = 'DROPDOWN',
  Link = 'LINK',
  Note = 'NOTE',
  Number = 'NUMBER',
  Squircle = 'SQUIRCLE',
  Text = 'TEXT'
}

export type TableColumn = {
  __typename?: 'TableColumn';
  displayName?: Maybe<Scalars['String']['output']>;
  key?: Maybe<Scalars['String']['output']>;
};

export type TableColumnInput = {
  displayName?: InputMaybe<Scalars['String']['input']>;
  key?: InputMaybe<Scalars['String']['input']>;
};

export type TaskRecommendation = {
  __typename?: 'TaskRecommendation';
  createdAt?: Maybe<Scalars['String']['output']>;
  dueDate?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  lineNumber: Scalars['String']['output'];
  recommendationNumber: Scalars['String']['output'];
  recommendationType: Scalars['String']['output'];
  status?: Maybe<Scalars['String']['output']>;
  statusUpdatedAt?: Maybe<Scalars['String']['output']>;
  workOrders: Array<WorkOrder>;
};

/**
 * Team is a groups of users that can have particular access.
 *
 * A Structure can have multiple Teams.
 */
export type Team = {
  __typename?: 'Team';
  /** Date this Team was created */
  createdAt?: Maybe<Scalars['String']['output']>;
  /** User who created this User Team */
  createdByUser: User;
  /** Unique Team ID */
  id: Scalars['ID']['output'];
  /** Team name */
  name: Scalars['String']['output'];
  /** Date this Team was last updated */
  updatedAt?: Maybe<Scalars['String']['output']>;
  /** User who last updated this User Team */
  updatedByUser: User;
  /** Users belongs to the Team */
  users: Array<User>;
};

export type Template = {
  __typename?: 'Template';
  /** Assessment Details Configuration */
  assessmentDetails?: Maybe<Array<AssessmentDetails>>;
  /** User who created this Template */
  createdBy?: Maybe<Scalars['String']['output']>;
  /** Defects Array allow different defects to be visible based on the Assembly Type i.e Pipe, Structure etc */
  defectsArray: Array<Scalars['String']['output']>;
  /** List of equations associated with this template */
  equations?: Maybe<Array<Equation>>;
  /** Equipment Card definitions for this Template */
  equipmentCard: Array<EquipmentCardField>;
  /** Equipment Detail Field definitions for this Template */
  equipmentDetails: Array<EquipmentDetailField>;
  /** Field definitions for this Template */
  fields: Array<AssemblyTemplateField>;
  /** Add icon detail here */
  icon?: Maybe<TemplateIcon>;
  /** Unique Template ID */
  id: Scalars['ID']['output'];
  /** Used to 'combine' multiple templates for combined deployment, should only exist if the template type is 'combined' */
  includedTemplateIds?: Maybe<Array<Scalars['ID']['output']>>;
  /** Auth0 ID of the user who last updated this POI Template */
  lastModifiedBy?: Maybe<Scalars['String']['output']>;
  /** Timestamp for the last update made from the API */
  lastModifiedByAPI?: Maybe<Scalars['String']['output']>;
  /** User who made the last update */
  lastModifiedByUser?: Maybe<User>;
  /** Reason for the last update */
  lastModifiedFor?: Maybe<Scalars['String']['output']>;
  /** Material Type Item */
  materialType?: Maybe<Array<Maybe<MaterialType>>>;
  /** Name of this Template */
  name: Scalars['String']['output'];
  octreeResourcesPath?: Maybe<Scalars['String']['output']>;
  /** Permission the user should have to access this template. e.g generic engineer don't have read:defects permission so he cannot access those template if permission = read:defects */
  permissions?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Fields for Query Summary */
  querySummary?: Maybe<Array<QuerySummaryItem>>;
  /** Recommendation Field Definition used to render alarm levels or damage class UI */
  recommendation?: Maybe<RecommendationField>;
  /** Remediation Score Configuration */
  remediationScoreConfig?: Maybe<RemediationScoreConfig>;
  /** Review Action Checklist Configuration */
  reviewActionChecklistConfig?: Maybe<Array<ReviewActionChecklistConfig>>;
  /** Review Panel Configuration */
  reviewPanelConfig?: Maybe<Array<ReviewPanelConfig>>;
  /** Risk assessment fields definition */
  riskFields?: Maybe<Array<RiskFields>>;
  /** Identifier for the Structure that this  belongs to */
  structure: Structure;
  /** Path for the statically generated structure relationship on S3 */
  structureRelationshipPath?: Maybe<Scalars['String']['output']>;
  /** Type of this Template */
  type: TemplateTypeEnum;
};

export type TemplateData = {
  __typename?: 'TemplateData';
  /** Unique Template Field ID */
  id: Scalars['ID']['output'];
  /** Data Value associated with the Template Field */
  templateFieldId?: Maybe<Scalars['ID']['output']>;
  /** Data Value associated with the Template Field */
  value?: Maybe<Scalars['StringFloatInt']['output']>;
  /** Verified value associated with the Template Field */
  verifiedValue?: Maybe<Scalars['StringFloatInt']['output']>;
};

export type TemplateDataInput = {
  /** Unique Template Field ID */
  id: Scalars['ID']['input'];
  /** Data Value associated with the Template Field */
  value: Scalars['String']['input'];
};

export type TemplateField = {
  /** Should this field be visible on first load inside a list or table */
  defaultVisible?: Maybe<Scalars['Boolean']['output']>;
  /** Key of field which has additional data for this field */
  detailFieldKey?: Maybe<Scalars['String']['output']>;
  /** Table configuration */
  displayConfig?: Maybe<DisplayConfig>;
  /** Should this field be displayed in report filters */
  displayInReportFilters?: Maybe<Scalars['Boolean']['output']>;
  /** Should this field be hidden in report */
  displayInReports?: Maybe<Scalars['Boolean']['output']>;
  /** Should this field be visible in review */
  displayInReview?: Maybe<Scalars['Boolean']['output']>;
  /** Unique Template Field ID */
  id: Scalars['ID']['output'];
  /** Should not be shown in the UI. Used for identifying certain fields */
  isHidden?: Maybe<Scalars['Boolean']['output']>;
  /** Is this Template Field read-only; i.e. value cannot be updated */
  isReadOnly: Scalars['Boolean']['output'];
  /** Is this Template Field always required */
  isRequired: Scalars['Boolean']['output'];
  /** Key to identify field in template data */
  key?: Maybe<Scalars['String']['output']>;
  /** Name of this Template Field */
  name: Scalars['String']['output'];
  /** Valid options for this Template Field value */
  options: Array<Scalars['String']['output']>;
  /** Details of valid options for this Template Field value */
  optionsData?: Maybe<Array<OptionData>>;
  /** Type of permission that a user have to read the template */
  permission?: Maybe<Scalars['String']['output']>;
  /** Should the template options be fetched from the server on runtime */
  serverSide: Scalars['Boolean']['output'];
  /** Type of this Template Field */
  type: TemplateFieldTypeEnum;
  /** Identity about the unit of the field */
  unit?: Maybe<UnitsEnum>;
};

export type TemplateFieldDataValues = {
  key: Scalars['String']['input'];
  value: Scalars['String']['input'];
};

export type TemplateFieldInput = {
  /** Logic engine expression to evaluate the equation key used for calculating the field value */
  calculatedBy?: InputMaybe<LogicEvaluationRuleInput>;
  /** Should this field be visible on first load inside a list or table */
  defaultVisible?: InputMaybe<Scalars['Boolean']['input']>;
  /** Dependent field keys */
  dependencyMapping?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Key of field which has additional data for this field */
  detailFieldKey?: InputMaybe<Scalars['String']['input']>;
  /** Table configuration */
  displayConfig?: InputMaybe<DisplayConfigInput>;
  /** Identify if field should be shown in the query tab */
  displayInQuery?: InputMaybe<Scalars['Boolean']['input']>;
  /** Should this field be displayed in report filters */
  displayInReportFilters?: InputMaybe<Scalars['Boolean']['input']>;
  /** Should this field be hidden in report */
  displayInReports?: InputMaybe<Scalars['Boolean']['input']>;
  /** Should this field be visible in review */
  displayInReview?: InputMaybe<Scalars['Boolean']['input']>;
  /** Identify if field should be shown in the risk assessment tab */
  displayInRisk?: InputMaybe<Scalars['Boolean']['input']>;
  displayInTable?: InputMaybe<Scalars['Boolean']['input']>;
  /** Unit to display te actual value in */
  displayUnit?: InputMaybe<UnitsEnum>;
  /** Roles that the user needs to have to edit template data */
  editRoles?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  enableInlineEdit?: InputMaybe<Scalars['Boolean']['input']>;
  /** Unique ID Template Field */
  id?: InputMaybe<Scalars['ID']['input']>;
  /** Specifies if field allows editing or not */
  isEditable?: InputMaybe<Scalars['Boolean']['input']>;
  /** Should this field be exportable */
  isExportable?: InputMaybe<Scalars['Boolean']['input']>;
  /** Should not be shown in the UI. Used for identifying certain fields */
  isHidden?: InputMaybe<Scalars['Boolean']['input']>;
  /** Is this Template Field read-only; i.e. cannot be updated */
  isReadOnly?: InputMaybe<Scalars['Boolean']['input']>;
  /** Is this Template Field always required */
  isRequired?: InputMaybe<Scalars['Boolean']['input']>;
  /** Should not be shown in the UI. Used for identifying risk assessment filters */
  isRiskAssessment?: InputMaybe<Scalars['Boolean']['input']>;
  /** Key to identify field in the risk fields */
  key?: InputMaybe<Scalars['String']['input']>;
  /** Logic engine expression to evaluate the field value */
  logicRule?: InputMaybe<LogicEvaluationRuleInput>;
  metaData?: InputMaybe<Scalars['JSON']['input']>;
  /** Name of this Template Field */
  name: Scalars['String']['input'];
  /** Valid options for this Template Field value */
  options?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Details of valid options for this Template Field value */
  optionsData?: InputMaybe<Array<OptionDataInput>>;
  /** Type of permission that a user have to read the template */
  permission?: InputMaybe<Scalars['String']['input']>;
  /** Identify fixed decimal place */
  roundToDecimal?: InputMaybe<Scalars['Int']['input']>;
  /** Should the template options be fetched from the server on runtime */
  serverSide: Scalars['Boolean']['input'];
  /** Identify if field's value should be evaluated using the logic engine */
  shouldEvaluateLogic?: InputMaybe<Scalars['Boolean']['input']>;
  /** Identify if field's value should be evaluated using the logic engine after the math engine */
  shouldEvaluateLogicPostCalculation?: InputMaybe<Scalars['Boolean']['input']>;
  /** Identify if field's value should be evaluated using the math engine */
  shouldEvaluateMath?: InputMaybe<Scalars['Boolean']['input']>;
  /** Type of this Template Field */
  type: TemplateFieldTypeEnum;
  /** Identity about the unit of the field */
  unit?: InputMaybe<UnitsEnum>;
};

export enum TemplateFieldTypeEnum {
  AutoAssemblyPressureService = 'AUTO_ASSEMBLY_PRESSURE_SERVICE',
  /** Auto Populated Fields that is rendered in Paint Damage */
  AutoAssemblyService = 'AUTO_ASSEMBLY_SERVICE',
  Checkbox = 'CHECKBOX',
  Date = 'DATE',
  Input = 'INPUT',
  MeasurementPaintArea = 'MEASUREMENT_PAINT_AREA',
  MeasurementPaintDiameter = 'MEASUREMENT_PAINT_DIAMETER',
  /** Measurement Enums is used to render calculated fields for paint-damage */
  MeasurementPaintLength = 'MEASUREMENT_PAINT_LENGTH',
  MultiSelect = 'MULTI_SELECT',
  Numeric = 'NUMERIC',
  RadioButton = 'RADIO_BUTTON',
  SingleSelect = 'SINGLE_SELECT',
  Textarea = 'TEXTAREA'
}

export type TemplateFieldsCloneInput = {
  /** Point of interest template IDs */
  fieldIds: Array<Scalars['ID']['input']>;
  /** Name of template */
  name: Scalars['String']['input'];
  /** Source structure for the template Fields */
  sourceStructureId: Scalars['ID']['input'];
  /** Target structure for the template Fields */
  targetStructureId: Scalars['ID']['input'];
  /** Type of template */
  type: TemplateTypeEnum;
};

export type TemplateFilters = {
  __typename?: 'TemplateFilters';
  id?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type TemplateFiltersInput = {
  id?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type TemplateIcon = {
  __typename?: 'TemplateIcon';
  color?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
};

export type TemplateIconInput = {
  color?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
};

export type TemplateInput = {
  /** List of equations associated with this template */
  equations?: InputMaybe<Array<EquationInput>>;
  /** Equipment details definition and new option mappings */
  equipmentDetails?: InputMaybe<Array<EquipmentDetailFieldInput>>;
  /** Field definitions for this Template */
  fields?: InputMaybe<Array<TemplateFieldInput>>;
  /** Reason for the last update */
  lastModifiedFor: Scalars['String']['input'];
  /** Name of this Template */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Fields for Query Summary */
  querySummary?: InputMaybe<Array<QuerySummaryInput>>;
  /** Remediation Score Configuration */
  remediationScoreConfig?: InputMaybe<RemediationScoreConfigInput>;
  /** Review Action Checklist Configuration */
  reviewActionChecklistConfig?: InputMaybe<Array<ReviewActionChecklistConfigInput>>;
  /** Review Panel Configuration */
  reviewPanelConfig?: InputMaybe<Array<ReviewPanelConfigInput>>;
  /** Risk Fields definition for each risk assessment field */
  riskFields?: InputMaybe<Array<InputMaybe<RiskFieldsInput>>>;
  /** Structure relation for this Template */
  structureId: Scalars['ID']['input'];
  /** Template ID */
  templateId: Scalars['ID']['input'];
  /** Type of this Template */
  type: TemplateTypeEnum;
};

export enum TemplateTypeEnum {
  Assembly = 'ASSEMBLY',
  PaintBlocks = 'PAINT_BLOCKS',
  Planner = 'PLANNER',
  PointOfInterest = 'POINT_OF_INTEREST',
  Structure = 'STRUCTURE',
  Workpack = 'WORKPACK'
}

export enum TextFormatEnum {
  LowerCase = 'LOWER_CASE',
  None = 'NONE',
  TitleCase = 'TITLE_CASE',
  UpperCase = 'UPPER_CASE'
}

export type TransitionPeriodType = {
  __typename?: 'TransitionPeriodType';
  futureDate: Scalars['String']['output'];
  nextDate: Scalars['String']['output'];
  transitionPeriod?: Maybe<Scalars['Int']['output']>;
};

export type TypeAndCount = {
  __typename?: 'TypeAndCount';
  count: Scalars['Int']['output'];
  type?: Maybe<Scalars['String']['output']>;
};

export enum UnitPositionEnum {
  End = 'END',
  Start = 'START'
}

/** Unit Types used in preferences */
export enum UnitSystemEnum {
  Imperial = 'IMPERIAL',
  Metric = 'METRIC'
}

export enum UnitsEnum {
  Meter = 'METER',
  Millimeter = 'MILLIMETER',
  SquareMeter = 'SQUARE_METER'
}

export type UpdateAssemblyInput = {
  assemblyId: Scalars['ID']['input'];
  /** Update Bounding Box of a Assembly */
  box?: InputMaybe<Scalars['JSON']['input']>;
  /** Update Focal Point of the assembly. */
  focalPoint?: InputMaybe<Vector3Input>;
  /** Update data values associated with Template for this Assembly */
  generalAttachmentsNote?: InputMaybe<Scalars['String']['input']>;
  lastModifiedFor: Scalars['String']['input'];
  structureId: Scalars['ID']['input'];
  templateFieldData?: InputMaybe<Scalars['JSON']['input']>;
  /** Update Template related to this Assembly for dynamic data */
  templateId?: InputMaybe<Scalars['ID']['input']>;
};

export type UpdateAssemblyRemediationInput = {
  assemblyIds: Array<Scalars['ID']['input']>;
  lastModifiedFor: Scalars['String']['input'];
  paintRegionId: Scalars['ID']['input'];
  remediatedAt: Scalars['String']['input'];
  structureId: Scalars['ID']['input'];
};

export type UpdateAssemblyTableValuesInput = {
  assembly: AssemblyDataForTableInput;
  assemblyIds: Array<Scalars['ID']['input']>;
  isTemplateData: Scalars['Boolean']['input'];
  structureId: Scalars['ID']['input'];
  templateId?: InputMaybe<Scalars['ID']['input']>;
};

export type UpdateCalculationMethodInput = {
  heightType: BlisterHeightType;
  isManuallyOverridden: Scalars['Boolean']['input'];
  lastModifiedBy?: InputMaybe<Scalars['String']['input']>;
  lastModifiedFor?: InputMaybe<Scalars['String']['input']>;
  pointOfInterestId: Scalars['ID']['input'];
  uncertainFieldKey?: InputMaybe<Scalars['String']['input']>;
  uncertainReason?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateCommentInput = {
  id: Scalars['ID']['input'];
  metadata?: InputMaybe<Scalars['JSON']['input']>;
  structureId: Scalars['ID']['input'];
  text: Scalars['String']['input'];
};

export type UpdateCuiPriorityInput = {
  assemblyId: Scalars['ID']['input'];
  isManuallyUpdated: Scalars['Boolean']['input'];
  lastModifiedFor: Scalars['String']['input'];
  priority: Scalars['String']['input'];
  structureId: Scalars['ID']['input'];
  templateId: Scalars['ID']['input'];
};

export type UpdateFilesInput = {
  addFiles: Array<FileCreateInput>;
  collectionName: Scalars['String']['input'];
  /** Optional log date for workpack files (format: yyyy-mm-dd). Defaults to current date if not provided. */
  logDate?: InputMaybe<Scalars['String']['input']>;
  referenceId: Scalars['String']['input'];
  removeFileIds: Array<Scalars['ID']['input']>;
};

export type UpdateFilesStatusInput = {
  collectionName: Scalars['String']['input'];
  fileUpdates: Array<FileUpdates>;
  referenceId: Scalars['String']['input'];
};

export type UpdateGoverningValueInput = {
  alarmLevel?: InputMaybe<AlarmLevels>;
  analysisStatus?: InputMaybe<RecommendationStatus>;
  assemblyId: Scalars['ID']['input'];
  governingValue: GoverningValueRecommendationInput;
};

export type UpdateInspectionPlanInput = {
  isPlanPinned?: InputMaybe<Scalars['Boolean']['input']>;
  planId: Scalars['ID']['input'];
  structureId: Scalars['ID']['input'];
};

export type UpdateLogEntryInput = {
  /** Field values (for WORKLOG and COST_LOG) */
  fieldValues?: InputMaybe<Array<LogFieldValueInput>>;
  /** LogEntry ID */
  logEntryId: Scalars['ID']['input'];
  /** Day/Night Shift */
  shift?: InputMaybe<ShiftType>;
  /** Structure ID */
  structureId: Scalars['ID']['input'];
};

export type UpdateLogsTemplateInput = {
  /** Aggregation level (workpack or structure) */
  aggregationLevel?: InputMaybe<Scalars['String']['input']>;
  /** Card configurations */
  cardsConfig?: InputMaybe<Array<CardConfigInput>>;
  /** Equations for calculations */
  equations?: InputMaybe<Array<EquationInput>>;
  /** Field definitions for this Template */
  fields?: InputMaybe<Array<LogsTemplateFieldInput>>;
  /** Reason for the last update */
  lastModifiedFor: Scalars['String']['input'];
  /** QA/QC specific configuration */
  qaqcConfig?: InputMaybe<Array<QaqcSectionConfigInput>>;
  /** Section definitions for this Template */
  sections?: InputMaybe<Array<LogSectionInput>>;
  /** Structure relation for this logs template */
  structureId: Scalars['ID']['input'];
  /** Template-specific settings - supports multiple entries (for QA/QC forms) */
  supportsMultipleEntries?: InputMaybe<Scalars['Boolean']['input']>;
  /** Template-specific settings - supports day/night shifts */
  supportsShifts?: InputMaybe<Scalars['Boolean']['input']>;
  /** LogsTemplate ID */
  templateId: Scalars['ID']['input'];
};

export type UpdatePaintRegionIdInput = {
  poiIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  structureId: Scalars['ID']['input'];
  type?: InputMaybe<Scalars['String']['input']>;
};

export type UpdatePaintRegionStatusInput = {
  lastModifiedFor?: InputMaybe<Scalars['String']['input']>;
  paintRegionId: Scalars['ID']['input'];
  remediationDate?: InputMaybe<Scalars['String']['input']>;
  /** Status value (can be any string - enum values or custom values from Settings) */
  status?: InputMaybe<Scalars['String']['input']>;
};

export type UpdatePartsHiddenFlagInput = {
  /** String part mongo ids from Part documents */
  ids: Array<Scalars['String']['input']>;
  /** Boolean flag for is out of scope */
  isHidden: Scalars['Boolean']['input'];
  /** Object Id for the structure the user is tagging in */
  structureId: Scalars['ID']['input'];
  /** Object Id for the zone the user is tagging in to filter the subscriptions */
  zoneId?: InputMaybe<Scalars['ID']['input']>;
};

export type UpdatePartsReviewedFlagInput = {
  /** String part mongo ids from Part documents */
  ids: Array<Scalars['String']['input']>;
  /** Boolean flag for a part is reviewed or not */
  isReviewed: Scalars['Boolean']['input'];
  /** Object Id for the structure the user is tagging in */
  structureId: Scalars['ID']['input'];
  /** Object Id for the zone the user is tagging in to filter the subscriptions */
  zoneId?: InputMaybe<Scalars['ID']['input']>;
};

export type UpdatePointOfInterestImageTypeInput = {
  imageId: Scalars['ID']['input'];
  imageType: ImageType;
  pointOfInterestId: Scalars['ID']['input'];
};

export type UpdatePointOfInterestInput = {
  /** Accessibility of this POI */
  accessibility?: InputMaybe<PoiAccessibilityEnum>;
  /** Update Assembly relation for this POI */
  assemblyId?: InputMaybe<Scalars['ID']['input']>;
  /** Assembly template relation for this POI */
  assemblyTemplateId?: InputMaybe<Scalars['ID']['input']>;
  /** User who created this Point of interest */
  assignee?: InputMaybe<Scalars['String']['input']>;
  /** Update blister metadata for this POI (if type is BLISTER) */
  blister?: InputMaybe<BlisterInput>;
  /** Update camera location for this POI */
  cameraLocation?: InputMaybe<Vector3Input>;
  /** Update center point for this POI */
  centerPoint3d?: InputMaybe<Vector3Input>;
  /** Comment for this POI */
  comment?: InputMaybe<Scalars['String']['input']>;
  /** Cuboids of volume of interest */
  cuboids?: InputMaybe<Array<CuboidInput>>;
  /** Due date of rectification for this Point of interest */
  dueDate?: InputMaybe<Scalars['String']['input']>;
  /** Blister height type */
  heightType?: InputMaybe<BlisterHeightType>;
  /** Flag to indicate if the POI fields should be evaluated */
  isFieldEvaluationSkipped?: InputMaybe<Scalars['Boolean']['input']>;
  /** Flag to indicate if the System height type is manually overridden */
  isManuallyOverridden?: InputMaybe<Scalars['Boolean']['input']>;
  /** Uninitialized Auto POI being updated to be treated as being created */
  isUninitialized?: InputMaybe<Scalars['Boolean']['input']>;
  /** Reason for the update */
  lastModifiedFor: Scalars['String']['input'];
  /** Line measurements for this POI. */
  lineMeasurement?: InputMaybe<PoiLineMeasurementInput>;
  /** Linked POIs to the cuboid */
  linkedPointOfInterestIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Update Location relation for this POI */
  locationId?: InputMaybe<Scalars['ID']['input']>;
  /** Update metadata for this POI */
  meta?: InputMaybe<Scalars['JSON']['input']>;
  /** Update name for this POI */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Update Paint Region relation for this POI */
  paintRegionId?: InputMaybe<Scalars['ID']['input']>;
  /** Parent Paint Region */
  parentPaintRegionId?: InputMaybe<Scalars['ID']['input']>;
  /** Update Part relation for this POI */
  partId?: InputMaybe<Scalars['ID']['input']>;
  /** Unique ID for POI to update */
  pointOfInterestId: Scalars['ID']['input'];
  /** Priority of this Point of interest */
  priority?: InputMaybe<PoiPriority>;
  /** Remediation note for this POI */
  remediationNote?: InputMaybe<Scalars['String']['input']>;
  /** Current status of this Point of interest (dynamic - can be any string value) */
  status?: InputMaybe<Scalars['String']['input']>;
  /** Update Structure relation for this POI */
  structureId?: InputMaybe<Scalars['ID']['input']>;
  /** Teams that this POI is shared with */
  teamIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Update data values associated with Template for this POI */
  templateData?: InputMaybe<Array<TemplateDataInput>>;
  templateFieldData?: InputMaybe<Scalars['JSON']['input']>;
  /** Update Template related to this POI for dynamic data */
  templateId?: InputMaybe<Scalars['ID']['input']>;
  /** Update type for this POI */
  type?: InputMaybe<Scalars['String']['input']>;
  /** Unlinked POIs to the cuboid */
  unlinkedPointOfInterestIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Height of the POI relative to the viewpoint it was created from */
  viewpointRelativeHeight?: InputMaybe<Scalars['Float']['input']>;
  /** Visibility for this POI */
  visibility?: InputMaybe<VisibilityEnum>;
  /** Workpack id of this poi */
  workpackId?: InputMaybe<Scalars['ID']['input']>;
  /** Workpack number of POI */
  workpackNumber?: InputMaybe<Scalars['String']['input']>;
};

export type UpdatePointOfInterestLocationInput = {
  cuboid?: InputMaybe<CuboidInput>;
  locationId?: InputMaybe<Scalars['ID']['input']>;
  point: Vector3Input;
  pointOfInterestId: Scalars['ID']['input'];
};

export type UpdatePointOfInterestTemplateInput = {
  accentColor?: InputMaybe<Scalars['String']['input']>;
  /** Blister fields configuration */
  blisterFieldsConfig?: InputMaybe<BlisterFieldsConfigInput>;
  fields: Array<InputPointOfInterestTemplateField>;
  icon?: InputMaybe<TemplateIconInput>;
  /** Reason for the last update */
  lastModifiedFor: Scalars['String']['input'];
  /** Configuration for annotations */
  markerLabelConfig?: InputMaybe<MarkerLabelConfigInput>;
  /** Name of this template */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Unique ID for POITemplate for update */
  pointOfInterestTemplateId: Scalars['ID']['input'];
  /** Type of this Template */
  type?: InputMaybe<PointOfInterestTemplateTypeEnum>;
};

export type UpdatePointOfInterestVisibilityInput = {
  /** Bulk poi update */
  isBulkUpdate: Scalars['Boolean']['input'];
  /** Reason for the last update */
  lastModifiedFor: Scalars['String']['input'];
  /** Unique IDs for POIs to update */
  pointOfInterestIds: Array<Scalars['ID']['input']>;
  /** Teams that this POI is shared with */
  teamIds: Array<Scalars['ID']['input']>;
  /** Visibility for this POI */
  visibility: VisibilityEnum;
};

export type UpdatePointOfInterestsStatusFiltersInput = {
  paintRegionIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  poiTypes?: InputMaybe<Array<Scalars['String']['input']>>;
  workpackIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type UpdatePointOfInterestsStatusInput = {
  filters?: InputMaybe<UpdatePointOfInterestsStatusFiltersInput>;
  pointOfInterestIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  remediationAt?: InputMaybe<Scalars['String']['input']>;
  /** Status value (dynamic - can be any string value) */
  status: Scalars['String']['input'];
  statusRemediatedThrough?: InputMaybe<StatusRemediatedThrough>;
};

export type UpdateRemediationScoreConfigInput = {
  /** Remediation Score Configuration to update */
  remediationScoreConfig: RemediationScoreConfigInput;
  /** Structure ID for the template */
  structureId: Scalars['ID']['input'];
  /** Template ID to update */
  templateId: Scalars['ID']['input'];
};

export type UpdateRiskAssessmentTemplateFieldDataAndTransitionPeriod = {
  __typename?: 'UpdateRiskAssessmentTemplateFieldDataAndTransitionPeriod';
  assembly?: Maybe<Array<Maybe<Assembly>>>;
  calculatedTransitionPeriod?: Maybe<TransitionPeriodType>;
  invalidDamageClassCount?: Maybe<Scalars['Int']['output']>;
};

export type UpdateRiskAssessmentTemplateFieldDataForAssembliesInput = {
  assemblyIds: Array<Scalars['ID']['input']>;
  calculationType?: InputMaybe<RiskFieldsTypeEnum>;
  excludedAssemblyIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  lastModifiedFor: Scalars['String']['input'];
  selectedFilters?: InputMaybe<Array<InputMaybe<RiskAssessmentSelectedFiltersInput>>>;
  selectedInputs: Array<RiskAssessmentSelectedFiltersInput>;
  structureId: Scalars['ID']['input'];
  templateId: Scalars['ID']['input'];
  updateAllAssemblies: Scalars['Boolean']['input'];
};

export type UpdateScCategoryInput = {
  assemblyId: Scalars['ID']['input'];
  scCategory: Scalars['String']['input'];
  structureId: Scalars['ID']['input'];
};

export type UpdateSingleTemplateFieldDataInput = {
  assemblyId: Scalars['ID']['input'];
  key: Scalars['String']['input'];
  lastModifiedFor: Scalars['String']['input'];
  newValue: Scalars['String']['input'];
  templateId: Scalars['ID']['input'];
};

export type UpdateStructureInput = {
  /** Blister height type */
  blisterHeightType?: InputMaybe<BlisterHeightType>;
  /** Category assigned to this structure for analytics grouping */
  category?: InputMaybe<Scalars['String']['input']>;
  /** List of legends and colors for the structure defects */
  defectLegends?: InputMaybe<Array<InputMaybe<DefectLegendInput>>>;
  /** Structure features to be enabled/disabled */
  features?: InputMaybe<FeaturesInput>;
  /** Template Field to be used to calculate fleet health score */
  fleetHealthTemplateField?: InputMaybe<Scalars['String']['input']>;
  /** Enable Risk Assessment */
  hasRiskAssessment?: InputMaybe<Scalars['Boolean']['input']>;
  /** Active of inactive deployment */
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  /** To switch the Abyss Rating Equation and incorporate the wall loss calculations in it */
  isWallLossEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** Reason for the last update */
  lastModifiedFor: Scalars['String']['input'];
  /** Structure Name */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Nomination configuration stored at structure level */
  nominationConfig?: InputMaybe<NominationConfigInput>;
  /** Platform this Structure belongs to */
  platformId?: InputMaybe<Scalars['ID']['input']>;
  /** Report Configurations */
  reportConfig?: InputMaybe<ReportConfigInput>;
  /** Scan Date for the structure */
  scanDate?: InputMaybe<Scalars['String']['input']>;
  /** Unique Structure ID */
  structureId: Scalars['ID']['input'];
};

export type UpdateTeamInput = {
  teamId: Scalars['ID']['input'];
  userIds: Array<Scalars['ID']['input']>;
};

export type UpdateTemplateFieldDataInput = {
  assemblyTemplateFieldData: Array<AssemblyTemplateFieldDataInput>;
  lastModifiedFor?: InputMaybe<Scalars['String']['input']>;
  structureId: Scalars['ID']['input'];
  templateId: Scalars['String']['input'];
  type: Scalars['String']['input'];
};

export type UpdateTemplateFieldDataPofInput = {
  assemblyIds: Array<Scalars['ID']['input']>;
  excludedAssemblyIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  inputValues?: InputMaybe<Array<InputMaybe<RiskAssessmentSelectedFiltersInput>>>;
  lastModifiedFor: Scalars['String']['input'];
  selectedEquation: CalculationType;
  selectedFilters?: InputMaybe<Array<InputMaybe<RiskAssessmentSelectedFiltersInput>>>;
  selectedInputs: Array<RiskAssessmentSelectedFiltersInput>;
  structureId: Scalars['ID']['input'];
  templateId: Scalars['ID']['input'];
  updateAllAssemblies: Scalars['Boolean']['input'];
};

export type UpdateUserColumnPreferencesInput = {
  columns?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  key: Scalars['String']['input'];
  structureId: Scalars['ID']['input'];
  xlsx?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type UpdateUserGroupInput = {
  name: Scalars['String']['input'];
  userGroupId: Scalars['ID']['input'];
};

export type UpdateUserInfoInput = {
  connection: Scalars['String']['input'];
  email: Scalars['String']['input'];
  loginType?: InputMaybe<LoginTypeEnum>;
  name?: InputMaybe<Scalars['String']['input']>;
  permissions?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  picture: Scalars['String']['input'];
  roles?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  status: UserStatusEnum;
  userId: Scalars['ID']['input'];
};

export type UpdateUserPlatformPreferencesInput = {
  platformId: Scalars['ID']['input'];
  /**
   * Fields to add or update in 'user.preferences.platform'
   * Can be used to create new fields as well as update existing ones
   * Example:
   * Adding a column to kpi tracker column preferences
   * set: { "columns.kpi_tracker": ["column1", "column2"] }
   * Setting a filter value
   * set: { "filters.kpi_date_range": { "from": "2022-01-01", "to": "2022-12-31" } }
   */
  set?: InputMaybe<Scalars['JSON']['input']>;
  unset?: InputMaybe<Scalars['JSON']['input']>;
};

export type UpdateUserPreferencesInput = {
  unit: UnitSystemEnum;
};

export type UpdateUserStructurePreferencesInput = {
  /**
   * Fields to add or update in 'user.preferences.structure.$structureId'
   * Example:
   * set: { "filters": { "WORKPACK_FILTERS": ["poi_status", "deckRelativeHeight"] } }
   */
  set?: InputMaybe<Scalars['JSON']['input']>;
  structureId: Scalars['ID']['input'];
  /** Fields to completely remove (unset) from 'user.preferences.structure.$structureId' */
  unset?: InputMaybe<Scalars['JSON']['input']>;
};

export type UpdateWorkLogInput = {
  logDate: Scalars['String']['input'];
  logEntries: Array<WorkLogIncrementInput>;
  structureId: Scalars['ID']['input'];
  workpackId: Scalars['ID']['input'];
};

export type UpdateWorkflowStageInput = {
  /** Unique Structure ID */
  structureId: Scalars['ID']['input'];
  workflowStageId: Scalars['ID']['input'];
  workflowStageName?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateWorkflowStatusInput = {
  assigneeId?: InputMaybe<Scalars['ID']['input']>;
  difficultyLevel?: InputMaybe<DifficultyLevel>;
  state?: InputMaybe<ZoneState>;
  structureId: Scalars['ID']['input'];
  workflowStageId?: InputMaybe<Scalars['ID']['input']>;
  zoneIds: Array<Scalars['ID']['input']>;
};

export type UpdateWorkflowTimeAndStateInput = {
  assignedToUser?: InputMaybe<Scalars['JSON']['input']>;
  assigneeId?: InputMaybe<Scalars['ID']['input']>;
  pausedBy?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<ZoneState>;
  statusId?: InputMaybe<Scalars['ID']['input']>;
  structureId: Scalars['ID']['input'];
  timeInMs?: InputMaybe<Scalars['Float']['input']>;
  trackedTime?: InputMaybe<Scalars['Boolean']['input']>;
  trackedTimeInMs?: InputMaybe<Scalars['Float']['input']>;
  typeOfTimeLog?: InputMaybe<Scalars['String']['input']>;
  zoneId: Scalars['ID']['input'];
};

export type UpdateWorkpackInput = {
  name: Scalars['String']['input'];
  structureId: Scalars['ID']['input'];
  type?: InputMaybe<WorkpackType>;
  wbs?: InputMaybe<WorkpackWbs>;
  workpackId: Scalars['ID']['input'];
};

export type UpdateWorkpackItemInput = {
  meta?: InputMaybe<Scalars['JSON']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  workpackId: Scalars['ID']['input'];
  workpackItemId: Scalars['ID']['input'];
};

export type UpdateWorkpackTemplateInput = {
  cardsConfig?: InputMaybe<Array<CardConfigInput>>;
  /** Section definitions for this Template */
  equations?: InputMaybe<Array<EquationInput>>;
  /** Field definitions for this Template */
  fields?: InputMaybe<Array<WorkpackTemplateFieldInput>>;
  /** Reason for the last update */
  lastModifiedFor: Scalars['String']['input'];
  sections?: InputMaybe<Array<LogSectionInput>>;
  /** Structure relation for this workpack template */
  structureId: Scalars['ID']['input'];
  /** Workpack template ID */
  templateId: Scalars['ID']['input'];
};

export type UpdateZoneStatusInput = {
  status: ZoneStatus;
  zoneId: Scalars['ID']['input'];
};

export type UpdatedTemplateFieldDataResult = {
  __typename?: 'UpdatedTemplateFieldDataResult';
  isUpdated: Scalars['Boolean']['output'];
};

export type UploadAttachmentsInput = {
  /** Attachments list */
  files: Array<FileAttributes>;
  /** Reason for the last update */
  lastModifiedFor: Scalars['String']['input'];
  /** POI for which to attach files */
  pointOfInterestId: Scalars['ID']['input'];
  /** Remediation note */
  remediationNote?: InputMaybe<Scalars['String']['input']>;
};

export type UploadEsSheetInput = {
  data: Array<SheetData>;
  headers: Array<Scalars['String']['input']>;
  isLegacy: Scalars['Boolean']['input'];
  structureId: Scalars['String']['input'];
};

export type UploadFileInput = {
  collectionName: Scalars['String']['input'];
  fileNameType: FileNameTypes;
  files: Array<FileAttributes>;
  referenceId: Scalars['String']['input'];
  structureId: Scalars['String']['input'];
};

export type UploadImageInput = {
  /** Base64-encoded string of cover image */
  image: Scalars['String']['input'];
  /** Reason for the last update */
  lastModifiedFor: Scalars['String']['input'];
  /** Unique Structure ID */
  structureId: Scalars['ID']['input'];
};

export type UploadLegacyEsSheetInput = {
  columnMappings?: InputMaybe<Scalars['JSON']['input']>;
  excludedRows?: InputMaybe<Array<Scalars['Int']['input']>>;
  finalData: Scalars['JSON']['input'];
  headers: Array<Scalars['String']['input']>;
  inlineEdits?: InputMaybe<Scalars['JSON']['input']>;
  lastModifiedFor?: InputMaybe<Scalars['String']['input']>;
  originalData: Scalars['JSON']['input'];
  structureId: Scalars['String']['input'];
  templateId?: InputMaybe<Scalars['String']['input']>;
  valueMappings?: InputMaybe<Scalars['JSON']['input']>;
};

export type UploadWorkpackAttachmentsInput = {
  /** Attachments list */
  files: Array<WorkpackFileAttributes>;
  /** Reason for the last update */
  lastModifiedFor: Scalars['String']['input'];
  /** Log date for which attachments are being uploaded (format: yyyy-mm-dd) */
  logDate: Scalars['String']['input'];
  /** Shift for which attachments are being uploaded (DAY or NIGHT) */
  shift?: InputMaybe<ShiftType>;
  /** Structure ID */
  structureId: Scalars['ID']['input'];
  /** IANA timezone identifier (e.g. 'America/New_York', 'Australia/Sydney') for date parsing */
  timezone: Scalars['String']['input'];
  /** Workpack for which to attach files */
  workpackId: Scalars['ID']['input'];
};

export type UpsertLogEntryInput = {
  /** Category of log entry (WORKLOG, COST_LOG, QAQC_FORM) */
  category: LogCategory;
  /** Name of MongoDB Collection where Reference Document resides (e.g., 'workpacks', 'structures') */
  collectionName: Scalars['String']['input'];
  /** Field values (for WORKLOG and COST_LOG) */
  fieldValues?: InputMaybe<Array<LogFieldValueInput>>;
  lastModifiedFor?: InputMaybe<Scalars['String']['input']>;
  /** Date of the log entry (format: yyyy-mm-dd) */
  logDate: Scalars['String']['input'];
  /** LogsTemplate ID */
  logsTemplateId: Scalars['ID']['input'];
  /** ID of the referenced entity (workpackId, structureId, etc.) */
  referenceId?: InputMaybe<Scalars['ID']['input']>;
  /** Day/Night shift */
  shift?: InputMaybe<ShiftType>;
  /** Structure ID */
  structureId: Scalars['ID']['input'];
};

/** User profile info */
export type User = {
  __typename?: 'User';
  /** Aplication's clientId from auth0 */
  clientId?: Maybe<Scalars['String']['output']>;
  /** Auth0 connection name for this user */
  connection?: Maybe<Scalars['String']['output']>;
  /** Unique email (per Auth0 connection) for this User */
  email: Scalars['String']['output'];
  /** Unique User ID */
  id: Scalars['String']['output'];
  /** This is a user for an application (machine to machine access) */
  isApplication?: Maybe<Scalars['Boolean']['output']>;
  /** Last time the user logged in */
  lastLogin?: Maybe<Scalars['String']['output']>;
  /** Total number of counts the user logged in to the fabric */
  loginCount?: Maybe<Scalars['Int']['output']>;
  /** Last time the user logged in via which channel i.e. email, google, microsoft */
  loginType?: Maybe<LoginTypeEnum>;
  /** Full name of this user */
  name?: Maybe<Scalars['String']['output']>;
  /** Permissions the user synced from auth0 */
  permissions?: Maybe<Array<Scalars['String']['output']>>;
  /** URL to profile picture for this User */
  picture?: Maybe<Scalars['String']['output']>;
  /** Preferences of the user */
  preferences?: Maybe<UserPreferences>;
  /** Roles of user */
  roleIds: Array<Maybe<Role>>;
  /** User Status if invite is sent or not and if user logged in or not */
  status?: Maybe<UserStatusEnum>;
};

export type UserColumnPreferences = {
  __typename?: 'UserColumnPreferences';
  columns?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  xlsx?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type UserColumnPreferencesInput = {
  key: Scalars['String']['input'];
  structureId: Scalars['ID']['input'];
};

/**
 * User Group is a grouping of Users.
 *
 * Users who belong to a User Group have access to all Structures that belong to the User Group.
 */
export type UserGroup = {
  __typename?: 'UserGroup';
  /** Date this User Group was created */
  createdAt?: Maybe<Scalars['String']['output']>;
  /** User who created this User Group */
  createdBy?: Maybe<Scalars['String']['output']>;
  /** Unique UserGroup ID */
  id: Scalars['ID']['output'];
  /** Name of this User Group */
  name: Scalars['String']['output'];
  /** Date this User Group was last updated */
  updatedAt?: Maybe<Scalars['String']['output']>;
  /** User who last updated this User Group */
  updatedBy?: Maybe<Scalars['String']['output']>;
  /** Unique IDs of Users that belong to this User Group */
  userIds: Array<Scalars['String']['output']>;
};

export type UserInvite = {
  __typename?: 'UserInvite';
  createdUsers: Array<Maybe<User>>;
  failedUsers?: Maybe<Array<Maybe<FailedUserInfo>>>;
};

export type UserPreferences = {
  __typename?: 'UserPreferences';
  platform?: Maybe<Scalars['JSON']['output']>;
  structure?: Maybe<Scalars['JSON']['output']>;
  unit?: Maybe<UnitSystemEnum>;
};

export type UserProfile = {
  __typename?: 'UserProfile';
  structures: Array<Structure>;
  user: User;
  userGroups: Array<UserGroup>;
};

/** Roles assigned to user by Auth0 authentication provider */
export enum UserRolesEnum {
  Admin = 'ADMIN',
  AitEngineer = 'AIT_ENGINEER',
  AssetTaggingUser = 'ASSET_TAGGING_USER',
  WorkpackManager = 'WORKPACK_MANAGER'
}

/** User Status assigned to user after creating */
export enum UserStatusEnum {
  Active = 'ACTIVE',
  Blocked = 'BLOCKED',
  Failed = 'FAILED',
  Pending = 'PENDING'
}

export type UsersByRoleInput = {
  q?: InputMaybe<Scalars['String']['input']>;
  roleId: Scalars['String']['input'];
};

export type ValidateIdmsTemplateQueryInput = {
  csvString: Scalars['String']['input'];
  structureId: Scalars['ID']['input'];
  template: IdmsUploadsTypeEnum;
};

export type ValidateReportScopeInput = {
  componentIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  groupName?: InputMaybe<Scalars['String']['input']>;
  selectedAssemblyTemplateFilters?: InputMaybe<Array<InputMaybe<FiltersInput>>>;
  selectedDeckIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  selectedPaintRegionIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  structureId: Scalars['ID']['input'];
};

export type ValidateReportScopeResult = {
  __typename?: 'ValidateReportScopeResult';
  countPerReport?: Maybe<Scalars['JSON']['output']>;
  isValid: Scalars['Boolean']['output'];
};

export type ValueAndPercentage = {
  __typename?: 'ValueAndPercentage';
  percentage: Scalars['Float']['output'];
  value: Scalars['Float']['output'];
};

export type ValueAndPercentageInput = {
  percentage: Scalars['Float']['input'];
  value: Scalars['Float']['input'];
};

export type Variable = {
  __typename?: 'Variable';
  /** The key of the field in the template */
  fieldKey: Scalars['String']['output'];
  /** If the field exists in the POI blister object */
  isBlisterField?: Maybe<Scalars['Boolean']['output']>;
  /** The name of the variable */
  name: Scalars['String']['output'];
  /** The type of the field */
  templateType: TemplateTypeEnum;
};

export type VariableInput = {
  /** The key of the field in the template */
  fieldKey: Scalars['String']['input'];
  /** If the field exists in the POI blister object */
  isBlisterField?: InputMaybe<Scalars['Boolean']['input']>;
  /** The name of the variable */
  name: Scalars['String']['input'];
  /** The type of the field */
  templateType: TemplateTypeEnum;
};

export type Vector3 = {
  __typename?: 'Vector3';
  /** X axis of this Point */
  x: Scalars['Float']['output'];
  /** Y axis of this Point */
  y: Scalars['Float']['output'];
  /** Z axis of this Point */
  z: Scalars['Float']['output'];
};

export type Vector3Input = {
  x: Scalars['Float']['input'];
  y: Scalars['Float']['input'];
  z: Scalars['Float']['input'];
};

export type VerifiedDetails = {
  __typename?: 'VerifiedDetails';
  pointOfInterest: PointOfInterest;
  reportId: Scalars['ID']['output'];
};

export type VerifiedTemplateDataInput = {
  /** Unique Template Field ID */
  id: Scalars['ID']['input'];
  /** Verified Data Value associated with the Template Field */
  verifiedValue: Scalars['String']['input'];
};

export type VerifyPointOfInterestInput = {
  /** Unique ID for POI to verify */
  pointOfInterestId: Scalars['ID']['input'];
  /** Used to verify or unverify a POI */
  verified: Scalars['Boolean']['input'];
  /** Object of verified data for this POI where keys match template field keys */
  verifiedData?: InputMaybe<Scalars['JSON']['input']>;
  verifiedMaxHeight?: InputMaybe<Scalars['String']['input']>;
  verifiedResidualThickness?: InputMaybe<Scalars['String']['input']>;
};

/**
 * Version Document
 *
 * A version document is a detailed snapshot of a MongoDB collection at a specicifc point in time for auditing or rollback purposes.
 */
export type Version = {
  __typename?: 'Version';
  /** Name of MongoDB Collection where Reference Document resides */
  collectionName: Scalars['String']['output'];
  /** Date this Version was created */
  createdAt: Scalars['String']['output'];
  /** Event ID for the version */
  eventId?: Maybe<Scalars['String']['output']>;
  /** Unique Version ID */
  id: Scalars['ID']['output'];
  /** Auth0 ID of user who triggered the version */
  lastModifiedBy?: Maybe<Scalars['String']['output']>;
  /** User who made the last update */
  lastModifiedByUser?: Maybe<User>;
  /** Reason for the last update */
  lastModifiedFor: Scalars['String']['output'];
  /** Previous data in this version */
  previousData?: Maybe<Scalars['JSON']['output']>;
  /** Reference Id for the Document */
  referenceId?: Maybe<Scalars['ID']['output']>;
  /** Structure that this Version belongs to  */
  structureId?: Maybe<Scalars['ID']['output']>;
  /** Changed fields in this version */
  updatedData?: Maybe<Scalars['JSON']['output']>;
};

export type VersionInput = {
  collectionName: Scalars['String']['input'];
  createdAt?: InputMaybe<Scalars['String']['input']>;
  logDate?: InputMaybe<Scalars['String']['input']>;
  referenceId?: InputMaybe<Scalars['String']['input']>;
  referenceIds?: InputMaybe<Array<Scalars['String']['input']>>;
  shift?: InputMaybe<ShiftType>;
  structureId: Scalars['String']['input'];
  timezone?: InputMaybe<Scalars['String']['input']>;
};

export enum VisibilityEnum {
  Custom = 'CUSTOM',
  Private = 'PRIVATE',
  Public = 'PUBLIC'
}

export type WorkLogEntry = {
  __typename?: 'WorkLogEntry';
  createdAt: Scalars['String']['output'];
  fieldKey: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  logDate: Scalars['String']['output'];
  type?: Maybe<WorklogEntryType>;
  updatedAt: Scalars['String']['output'];
  value: Scalars['Float']['output'];
};

export type WorkLogIncrementInput = {
  fieldKey: Scalars['String']['input'];
  type?: InputMaybe<WorklogEntryType>;
  value: Scalars['Float']['input'];
};

export type WorkOrder = {
  __typename?: 'WorkOrder';
  id: Scalars['ID']['output'];
  lineNumber: Scalars['String']['output'];
  poiName: Scalars['String']['output'];
  recommendationNumber?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  statusUpdatedAt?: Maybe<Scalars['String']['output']>;
  workOrderNumber: Scalars['String']['output'];
};

export type WorkflowStages = {
  __typename?: 'WorkflowStages';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  orderInWorkflow: Scalars['Int']['output'];
  stageType: StageType;
};

export type WorkflowStatus = {
  __typename?: 'WorkflowStatus';
  /** User assigned to this zone */
  assignedToUser?: Maybe<User>;
  /** Difficulty level of the zone */
  difficultyLevel?: Maybe<DifficultyLevel>;
  /** Idle time tracked for this zone */
  idleTime?: Maybe<Scalars['JSON']['output']>;
  /** Track if the zone is paused by user or system due to inactivity */
  pausedBy?: Maybe<PausedBy>;
  /** State of the zone */
  state?: Maybe<ZoneState>;
  /** Idle time tracked for this zone */
  totalTime?: Maybe<Scalars['JSON']['output']>;
  /** Total time tracked without starting */
  trackedTime?: Maybe<Scalars['JSON']['output']>;
  /** Details of the workflow status of this zone */
  workflowStageId: Scalars['ID']['output'];
};

export enum WorklogEntryType {
  Other = 'OTHER',
  PobConfig = 'POB_CONFIG'
}

export type Workpack = {
  __typename?: 'Workpack';
  /** Created by User ID */
  createdBy: Scalars['String']['output'];
  /** Files attached to workpack, organized by logDate */
  files?: Maybe<Array<WorkpackFile>>;
  /** Unique Workpack ID */
  id: Scalars['ID']['output'];
  /** Auth0 ID of user who last updated this Workpack */
  lastModifiedBy?: Maybe<Scalars['String']['output']>;
  /** Timestamp for the last update made from the API */
  lastModifiedByAPI?: Maybe<Scalars['String']['output']>;
  /** User who made the last update */
  lastModifiedByUser?: Maybe<User>;
  /** Reason for the last update */
  lastModifiedFor?: Maybe<Scalars['String']['output']>;
  /** Name of this Workpack */
  name: Scalars['String']['output'];
  /** Status of this Workpack (dynamic - values come from Settings collection) */
  status?: Maybe<Scalars['String']['output']>;
  /** Structure this Workpack belongs to */
  structure: Structure;
  /** Type of this Workpack */
  type?: Maybe<WorkpackType>;
  wbs?: Maybe<WorkpackWbs>;
  worklogs?: Maybe<Array<WorkLogEntry>>;
  workpackTemplate?: Maybe<WorkpackTemplate>;
};

export type WorkpackAttachmentsByDate = {
  __typename?: 'WorkpackAttachmentsByDate';
  files: Array<WorkpackFile>;
  logDate: Scalars['String']['output'];
};

export type WorkpackAttachmentsPerDateInput = {
  logDate: Scalars['String']['input'];
  /** Shift for which attachments are being fetched (DAY or NIGHT) */
  shift?: InputMaybe<ShiftType>;
  structureId: Scalars['ID']['input'];
  /** IANA timezone identifier (e.g. 'America/New_York', 'Australia/Sydney') for date filtering */
  timezone: Scalars['String']['input'];
  workpackId: Scalars['ID']['input'];
};

export type WorkpackFile = {
  __typename?: 'WorkpackFile';
  caption?: Maybe<Scalars['String']['output']>;
  fileName: Scalars['String']['output'];
  id?: Maybe<Scalars['ID']['output']>;
  imagePosition?: Maybe<Scalars['Int']['output']>;
  logDate: Scalars['String']['output'];
  name: Scalars['String']['output'];
  resourcePath: Scalars['String']['output'];
  shift?: Maybe<ShiftType>;
  size?: Maybe<Scalars['Int']['output']>;
  type: FileTypes;
  uploadStatus?: Maybe<FileUploadStatus>;
  url?: Maybe<Scalars['String']['output']>;
  uuid?: Maybe<Scalars['String']['output']>;
};

export type WorkpackFileAttributes = {
  mimeType: Scalars['String']['input'];
  name: Scalars['String']['input'];
  size: Scalars['Int']['input'];
  uuid: Scalars['String']['input'];
};

export type WorkpackItem = {
  __typename?: 'WorkpackItem';
  /** Date this Workpack Item was created */
  createdAt: Scalars['String']['output'];
  /** User who created this Workpack Item */
  createdBy?: Maybe<Scalars['String']['output']>;
  /** Unique Workpack Item ID */
  id: Scalars['ID']['output'];
  /** Name of this Workpack Item */
  name: Scalars['String']['output'];
  /** Parts of interest in this Workpack Item */
  parts: Array<WorkpackItemPart>;
  /** Date this Workpack Item was last updated */
  updatedAt: Scalars['String']['output'];
  /** User who last updated this Workpack Item */
  updatedBy?: Maybe<Scalars['String']['output']>;
  /** Workpack this Workpack Item belongs to */
  workpack: Workpack;
};

export type WorkpackItemPart = {
  __typename?: 'WorkpackItemPart';
  /** Metadata associated with this related Part */
  meta: Array<Meta>;
  /** Part this Workpack Item relates to */
  part: Part;
  /** Views of this related Part from Location data */
  views: Array<WorkpackItemView>;
};

export type WorkpackItemView = {
  __typename?: 'WorkpackItemView';
  /** Coordinates in Location Data for this Workpack Item */
  coordinates: PolarCoordinates;
  /** Location data which this Workpack Item belongs to */
  location: Location;
  /** Metadata associated with this view */
  meta: Array<Meta>;
};

export type WorkpackItemViewInput = {
  bearing: Scalars['Float']['input'];
  elevation: Scalars['Float']['input'];
  locationId: Scalars['ID']['input'];
  range: Scalars['Float']['input'];
};

export type WorkpackLogFieldTotal = {
  __typename?: 'WorkpackLogFieldTotal';
  fieldKey: Scalars['String']['output'];
  total: Scalars['Float']['output'];
};

export enum WorkpackLogsPerDateFetchStrategy {
  Aggregated = 'AGGREGATED',
  Individual = 'INDIVIDUAL'
}

export type WorkpackLogsPerDateInput = {
  /**
   * Strategy to fetch worklogs
   * AGGREGATED: Returns aggregated worklogs from the fist log, till `logDate`.
   * INDIVIDUAL: Returns only the logs for `logDate`. Returned array will on ever have one element
   */
  fetchStrategy: WorkpackLogsPerDateFetchStrategy;
  logDate: Scalars['String']['input'];
  structureId: Scalars['ID']['input'];
  /** IANA timezone identifier (e.g. 'America/New_York', 'Australia/Sydney') for date filtering */
  timezone: Scalars['String']['input'];
  worklogType?: InputMaybe<WorklogEntryType>;
  workpackId: Scalars['ID']['input'];
};

/**
 * Default Workpack status values.
 * Note: The actual status field accepts any string value for flexibility.
 * Custom status labels are configured in the Settings collection (WORKPACK_STATUS_LABELS).
 */
export enum WorkpackStatus {
  ChaseItemAdded = 'CHASE_ITEM_ADDED',
  Completed = 'COMPLETED',
  DesktopReviewComplete = 'DESKTOP_REVIEW_COMPLETE',
  DesktopReviewInProgress = 'DESKTOP_REVIEW_IN_PROGRESS',
  FieldVerificationComplete = 'FIELD_VERIFICATION_COMPLETE',
  FieldVerificationInProgress = 'FIELD_VERIFICATION_IN_PROGRESS',
  FinalReviewComplete = 'FINAL_REVIEW_COMPLETE',
  FinalReviewInProgress = 'FINAL_REVIEW_IN_PROGRESS',
  Inprogress = 'INPROGRESS',
  Inreview = 'INREVIEW'
}

export type WorkpackTemplate = {
  __typename?: 'WorkpackTemplate';
  /** What assembly template this POI template is related to. Used in combined deployment */
  assemblyTemplate: Template;
  cardsConfig?: Maybe<Array<Maybe<CardConfig>>>;
  createdBy?: Maybe<Scalars['String']['output']>;
  equations?: Maybe<Array<Equation>>;
  fields: Array<WorkpackTemplateField>;
  id: Scalars['ID']['output'];
  key: Scalars['String']['output'];
  /** Auth0 ID of the user who last updated this POI Template */
  lastModifiedBy?: Maybe<Scalars['String']['output']>;
  /** Timestamp for the last update made from the API */
  lastModifiedByAPI?: Maybe<Scalars['String']['output']>;
  /** User who made the last update */
  lastModifiedByUser?: Maybe<User>;
  /** Reason for the last update */
  lastModifiedFor?: Maybe<Scalars['String']['output']>;
  /** Linked child templates */
  linkedStructureIds?: Maybe<Array<Scalars['ID']['output']>>;
  name: Scalars['String']['output'];
  sections: Array<LogSection>;
  structure: Structure;
  type: TemplateTypeEnum;
};

export type WorkpackTemplateField = TemplateField & {
  __typename?: 'WorkpackTemplateField';
  /** Logic engine expression to evaluate the equation key used for calculating the field value */
  calculatedBy?: Maybe<LogicEvaluationRule>;
  /** Should this field be visible on first load inside a list or table */
  defaultVisible?: Maybe<Scalars['Boolean']['output']>;
  derivedEquationKey?: Maybe<Scalars['String']['output']>;
  /** Key of field which has additional data for this field */
  detailFieldKey?: Maybe<Scalars['String']['output']>;
  /** Table configuration */
  displayConfig?: Maybe<DisplayConfig>;
  displayInLogAggregation?: Maybe<Scalars['Boolean']['output']>;
  /** Show in the logging screen */
  displayInLogging?: Maybe<Scalars['Boolean']['output']>;
  /** Identify if field should be shown in the poi filters */
  displayInQuery?: Maybe<Scalars['Boolean']['output']>;
  /** Should this field be displayed in report filters */
  displayInReportFilters?: Maybe<Scalars['Boolean']['output']>;
  /** Should this field be hidden in report */
  displayInReports?: Maybe<Scalars['Boolean']['output']>;
  /** Should this field be visible in review */
  displayInReview?: Maybe<Scalars['Boolean']['output']>;
  /** Identify if field should be shown in the poi table */
  displayInTable?: Maybe<Scalars['Boolean']['output']>;
  fieldDescription?: Maybe<Scalars['String']['output']>;
  fieldUnit?: Maybe<SectionUnitsEnum>;
  /** Unique Template Field ID */
  id: Scalars['ID']['output'];
  isDerived?: Maybe<Scalars['Boolean']['output']>;
  /** Should not be shown in the UI. Used for identifying certain fields */
  isHidden?: Maybe<Scalars['Boolean']['output']>;
  /** Enable Measurement Tool */
  isMeasurementToolEnabled?: Maybe<Scalars['Boolean']['output']>;
  /** Is this Template Field read-only; i.e. value cannot be updated */
  isReadOnly: Scalars['Boolean']['output'];
  /** Is this Template Field always required */
  isRequired: Scalars['Boolean']['output'];
  /** Key to identify field in template data */
  key?: Maybe<Scalars['String']['output']>;
  /** Logic engine expression to evaluate the field value */
  logicRule?: Maybe<LogicEvaluationRule>;
  /** Name of this Template Field */
  name: Scalars['String']['output'];
  /** Valid options for this Template Field value */
  options: Array<Scalars['String']['output']>;
  /** Details of valid options for this Template Field value */
  optionsData?: Maybe<Array<OptionData>>;
  /** Type of permission that a user have to read the template */
  permission?: Maybe<Scalars['String']['output']>;
  /** Round to decimal places */
  roundToDecimal?: Maybe<Scalars['Int']['output']>;
  sectionKey?: Maybe<Scalars['String']['output']>;
  /** Should the template options be fetched from the server on runtime */
  serverSide: Scalars['Boolean']['output'];
  /** Identify if field's value should be evaluated using the logic engine */
  shouldEvaluateLogic?: Maybe<Scalars['Boolean']['output']>;
  /** Identify if field's value should be evaluated using the logic engine after the math engine */
  shouldEvaluateLogicPostCalculation?: Maybe<Scalars['Boolean']['output']>;
  /** Identify if field's value should be evaluated using the math engine */
  shouldEvaluateMath?: Maybe<Scalars['Boolean']['output']>;
  /** Type of this Template Field */
  type: TemplateFieldTypeEnum;
  /** Identity about the unit of the field */
  unit?: Maybe<UnitsEnum>;
};

export type WorkpackTemplateFieldInput = {
  /** Logic engine expression to evaluate the equation key used for calculating the field value */
  calculatedBy?: InputMaybe<LogicEvaluationRuleInput>;
  /** Should this field be visible on first load inside a list or table */
  defaultVisible?: InputMaybe<Scalars['Boolean']['input']>;
  /** Dependent field keys */
  dependencyMapping?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  derivedEquationKey?: InputMaybe<Scalars['String']['input']>;
  /** Key of field which has additional data for this field */
  detailFieldKey?: InputMaybe<Scalars['String']['input']>;
  /** Table configuration */
  displayConfig?: InputMaybe<DisplayConfigInput>;
  displayInLogAggregation?: InputMaybe<Scalars['Boolean']['input']>;
  /** Identify if field should be shown in the query tab */
  displayInQuery?: InputMaybe<Scalars['Boolean']['input']>;
  /** Should this field be displayed in report filters */
  displayInReportFilters?: InputMaybe<Scalars['Boolean']['input']>;
  /** Should this field be hidden in report */
  displayInReports?: InputMaybe<Scalars['Boolean']['input']>;
  /** Should this field be visible in review */
  displayInReview?: InputMaybe<Scalars['Boolean']['input']>;
  /** Identify if field should be shown in the risk assessment tab */
  displayInRisk?: InputMaybe<Scalars['Boolean']['input']>;
  displayInTable?: InputMaybe<Scalars['Boolean']['input']>;
  /** Unit to display te actual value in */
  displayUnit?: InputMaybe<UnitsEnum>;
  /** Roles that the user needs to have to edit template data */
  editRoles?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  fieldDescription?: InputMaybe<Scalars['String']['input']>;
  fieldUnit?: InputMaybe<SectionUnitsEnum>;
  /** Unique ID Template Field */
  id?: InputMaybe<Scalars['ID']['input']>;
  isDerived?: InputMaybe<Scalars['Boolean']['input']>;
  /** Specifies if field allows editing or not */
  isEditable?: InputMaybe<Scalars['Boolean']['input']>;
  /** Should this field be exportable */
  isExportable?: InputMaybe<Scalars['Boolean']['input']>;
  /** Should not be shown in the UI. Used for identifying certain fields */
  isHidden?: InputMaybe<Scalars['Boolean']['input']>;
  /** Is this Template Field read-only; i.e. cannot be updated */
  isReadOnly?: InputMaybe<Scalars['Boolean']['input']>;
  /** Is this Template Field always required */
  isRequired?: InputMaybe<Scalars['Boolean']['input']>;
  /** Should not be shown in the UI. Used for identifying risk assessment filters */
  isRiskAssessment?: InputMaybe<Scalars['Boolean']['input']>;
  /** Key to identify field in the risk fields */
  key?: InputMaybe<Scalars['String']['input']>;
  /** Logic engine expression to evaluate the field value */
  logicRule?: InputMaybe<LogicEvaluationRuleInput>;
  /** Name of this Template Field */
  name: Scalars['String']['input'];
  /** Valid options for this Template Field value */
  options?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Details of valid options for this Template Field value */
  optionsData?: InputMaybe<Array<OptionDataInput>>;
  /** Type of permission that a user have to read the template */
  permission?: InputMaybe<Scalars['String']['input']>;
  roundToDecimal?: InputMaybe<Scalars['Int']['input']>;
  sectionKey?: InputMaybe<Scalars['String']['input']>;
  /** Should the template options be fetched from the server on runtime */
  serverSide?: InputMaybe<Scalars['Boolean']['input']>;
  /** Identify if field's value should be evaluated using the logic engine */
  shouldEvaluateLogic?: InputMaybe<Scalars['Boolean']['input']>;
  /** Identify if field's value should be evaluated using the logic engine after the math engine */
  shouldEvaluateLogicPostCalculation?: InputMaybe<Scalars['Boolean']['input']>;
  /** Identify if field's value should be evaluated using the math engine */
  shouldEvaluateMath?: InputMaybe<Scalars['Boolean']['input']>;
  /** Type of this Template Field */
  type: TemplateFieldTypeEnum;
  /** Identity about the unit of the field */
  unit?: InputMaybe<UnitsEnum>;
};

export type WorkpackTemplateInput = {
  /** Assembly template relation for this workpack template */
  assemblyTemplateId: Scalars['ID']['input'];
  /** Structure relation for this workpack template */
  structureId: Scalars['ID']['input'];
};

export enum WorkpackType {
  Block = 'BLOCK',
  BreakIn = 'BREAK_IN',
  Chase = 'CHASE'
}

export enum WorkpackTypeFilterOption {
  Block = 'BLOCK',
  BreakIn = 'BREAK_IN',
  Chase = 'CHASE',
  Na = 'NA'
}

export enum WorkpackWbs {
  Fm = 'FM',
  Other = 'OTHER'
}

export enum WorkpackWbsFilterOption {
  Fm = 'FM',
  Na = 'NA',
  Other = 'OTHER'
}

export type Zone = {
  __typename?: 'Zone';
  /** Visibility Box of this Zone */
  box: Box;
  /** Unique Zone ID */
  id: Scalars['ID']['output'];
  /** Timestamp for the last update made from the API */
  lastModifiedByAPI?: Maybe<Scalars['String']['output']>;
  /** User who made the last update */
  lastModifiedByUser?: Maybe<User>;
  /** Reason for the last update */
  lastModifiedFor?: Maybe<Scalars['String']['output']>;
  /** Name of this Zone */
  name: Scalars['String']['output'];
  /** Status of the this zone */
  status: ZoneStatus;
  /** Structure of this Zone */
  structure?: Maybe<Structure>;
  /** Unique Zone ID */
  structureId: Scalars['ID']['output'];
  /** Used as meta data for the Fabric V2 in workflow management so AIT can make informed decision on who to assign this zone based upon the number of parts present in a zone */
  totalParts?: Maybe<Scalars['Int']['output']>;
  /** Used to determine the density of the zone i.e low / medium / high depending upon total points present in the zone */
  totalPoints?: Maybe<Scalars['Int']['output']>;
  /** Used as meta data for the Fabric V2 in workflow management so AIT can make informed decision on who to assign this zone based upon the number of sphericals present in a zone */
  totalSphericals?: Maybe<Scalars['Int']['output']>;
  /** Details of the workflow status of this zone */
  workflowStatus?: Maybe<WorkflowStatus>;
};

export type ZoneAndHistory = {
  __typename?: 'ZoneAndHistory';
  _id: Scalars['ID']['output'];
  box: Box;
  histories?: Maybe<Array<Maybe<History>>>;
  name: Scalars['String']['output'];
  status?: Maybe<ZoneStatus>;
  structureId: Scalars['ID']['output'];
  totalParts?: Maybe<Scalars['Int']['output']>;
  totalPoints?: Maybe<Scalars['Int']['output']>;
  totalSphericals?: Maybe<Scalars['Int']['output']>;
  workflowStatus?: Maybe<WorkflowStatus>;
};

export enum ZoneState {
  Approve = 'APPROVE',
  Backlog = 'BACKLOG',
  Pause = 'PAUSE',
  Reject = 'REJECT',
  Review = 'REVIEW',
  Start = 'START'
}

export enum ZoneStatus {
  Completed = 'COMPLETED',
  InProgress = 'IN_PROGRESS',
  InReview = 'IN_REVIEW',
  NotStarted = 'NOT_STARTED',
  ReviewReady = 'REVIEW_READY'
}

export type ZoneStatusCount = {
  __typename?: 'ZoneStatusCount';
  count: Scalars['Int']['output'];
  status: Scalars['String']['output'];
};

export type ZoneUpdate = {
  __typename?: 'ZoneUpdate';
  createdBy: Scalars['String']['output'];
  currentStatus: ZoneStatus;
  prevStatus: ZoneStatus;
  referenceId: Scalars['ID']['output'];
};

export type ZonesPerStageInput = {
  includeUnassigned?: InputMaybe<Scalars['Boolean']['input']>;
  searchTerm?: InputMaybe<Scalars['String']['input']>;
  structureId: Scalars['String']['input'];
  userIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ZonesPerWorklowStage = {
  __typename?: 'ZonesPerWorklowStage';
  totalCount: Scalars['Int']['output'];
  workflowStageId: Scalars['String']['output'];
  zones: Array<Zone>;
};

export type CreateNewReportInput = {
  actionStatus?: InputMaybe<ReportActionStatus>;
  componentIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  dueDate?: InputMaybe<Scalars['String']['input']>;
  groupId?: InputMaybe<Scalars['ID']['input']>;
  groupName?: InputMaybe<Scalars['String']['input']>;
  internalType: ReportInternalType;
  name: Scalars['String']['input'];
  paintRegionId?: InputMaybe<Scalars['ID']['input']>;
  pointOfInterestIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  pointOfInterestType?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  selectedAssemblyTemplateFilters?: InputMaybe<Array<InputMaybe<FiltersInput>>>;
  selectedDeckIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  selectedPaintRegionIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  startDate?: InputMaybe<Scalars['String']['input']>;
  structureId: Scalars['String']['input'];
  type?: InputMaybe<ReportType>;
  workpackNumber?: InputMaybe<Scalars['String']['input']>;
};

export type DeleteAssemblyFromReportInput = {
  assemblyId: Scalars['ID']['input'];
  reportId: Scalars['ID']['input'];
};

export type DeleteDraftReportInput = {
  reportId: Scalars['ID']['input'];
};

export type DeletePointOfInterestFromReportInput = {
  pointOfInterestId: Scalars['ID']['input'];
  reportId: Scalars['ID']['input'];
};

export type PointOfInterestsCountByTypeFiltersInput = {
  paintRegionId?: InputMaybe<Scalars['ID']['input']>;
};

export type ReportInput = {
  reportId: Scalars['ID']['input'];
};

export type ReportsInput = {
  componentIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  dueDate?: InputMaybe<Scalars['String']['input']>;
  groupId?: InputMaybe<Scalars['ID']['input']>;
  groupName?: InputMaybe<Scalars['String']['input']>;
  internalType?: InputMaybe<ReportInternalType>;
  name?: InputMaybe<Scalars['String']['input']>;
  selectedAssemblyTemplateFilters?: InputMaybe<Array<InputMaybe<FiltersInput>>>;
  selectedDeckIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  selectedPaintRegionIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  selectedReportFilters?: InputMaybe<Array<InputMaybe<FiltersInput>>>;
  status?: InputMaybe<ReportStatus>;
  structureId: Scalars['ID']['input'];
};

export type SupervoxelsForStructureInput = {
  structureId: Scalars['String']['input'];
  supervoxelClassId?: InputMaybe<Scalars['String']['input']>;
  zoneId?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateReportByPointOfInterestsInput = {
  pointOfInterestIds: Array<InputMaybe<Scalars['ID']['input']>>;
  reportId: Scalars['ID']['input'];
};

export type UpdateReportInput = {
  actionStatus?: InputMaybe<ReportActionStatus>;
  dueDate?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  pointOfInterestsIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  removedPointOfInterestsIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  reportId: Scalars['ID']['input'];
  reportOrder?: InputMaybe<ReportOrderInput>;
  startDate?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<ReportStatus>;
  structureId?: InputMaybe<Scalars['ID']['input']>;
  templateFieldData?: InputMaybe<Scalars['JSON']['input']>;
};

export type UpdateReportPointOfInterestImagesInput = {
  pointOfInterestId: Scalars['ID']['input'];
  reportId: Scalars['ID']['input'];
  selectedImages: Array<InputMaybe<FileInput>>;
  selectedPdfs?: InputMaybe<Array<InputMaybe<FileInput>>>;
};

export type UpdateReportStatusInput = {
  reportId: Scalars['ID']['input'];
  status: ReportStatus;
};

export type UpdateSupervoxel = {
  structureId: Scalars['ID']['input'];
  supervoxel3DReference: Array<Scalars['Int']['input']>;
  supervoxelClassId: Scalars['ID']['input'];
};

export type GetStructureForCadAlignmentQueryVariables = Exact<{
  structureId?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetStructureForCadAlignmentQuery = { __typename?: 'Query', structure?: { __typename?: 'Structure', octreeResourcesPath: string, cadOctreeResourcesPath?: string | null, scansToCadTransform?: Array<number> | null } | null };

export type UpdateScansToCadTransformMutationVariables = Exact<{
  structureId: Scalars['ID']['input'];
  scansToCadTransform: Array<Scalars['Float']['input']> | Scalars['Float']['input'];
}>;


export type UpdateScansToCadTransformMutation = { __typename?: 'Mutation', updateScansToCadTransform?: { __typename?: 'Structure', id: string, scansToCadTransform?: Array<number> | null } | null };

export type AllDecksForDeckPlanExplorerQueryVariables = Exact<{
  structureId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type AllDecksForDeckPlanExplorerQuery = { __typename?: 'Query', allDecks: Array<{ __typename?: 'Deck', id: string, name: string, resourcePath: string, heightRange: Array<number>, heightStep?: number | null }> };

export type FetchSpatialHeatmapQueryVariables = Exact<{
  heatmapParameters?: InputMaybe<SpatialHeatmapInput>;
}>;


export type FetchSpatialHeatmapQuery = { __typename?: 'Query', fetchSpatialHeatmap?: { __typename?: 'SpatialHeatmap', svg: string } | null };

export type AllDefectsInDeckQueryVariables = Exact<{
  structureId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type AllDefectsInDeckQuery = { __typename?: 'Query', allDefects: Array<{ __typename?: 'Defect', key: string, name: string }> };

export type AllLocationsForAssemblyForDeckPlanQueryVariables = Exact<{
  input?: InputMaybe<LocationsForAssemblyInput>;
}>;


export type AllLocationsForAssemblyForDeckPlanQuery = { __typename?: 'Query', allLocationsForAssembly?: Array<{ __typename?: 'Location', id: string, resource?: string | null, resourcePath?: string | null, depthResourcePath?: string | null, name: string, distance?: number | null, videoResourcePath?: string | null, videoTimestamp?: number | null, deckPlan?: { __typename?: 'LocationDeckPlan', id: string, coordinates: Array<number> } | null, deck: { __typename?: 'Deck', name: string }, imageSensor?: { __typename?: 'ImageSensor', width: number, height: number, cx: number, cy: number, focalLength: number } | null, pose?: { __typename?: 'LocationPose', yaw: number, yawOffset: number, z: number, y: number, x: number, roll: number, pitch: number } | null }> | null };

export type AllPaintRegionsForDeckPlanQueryVariables = Exact<{
  input: FindAllPaintRegionsInput;
}>;


export type AllPaintRegionsForDeckPlanQuery = { __typename?: 'Query', allPaintRegions: Array<{ __typename?: 'PaintRegion', id: string, name: string, polygons: Array<{ __typename?: 'PaintRegionPolygons', area: number, points: Array<Array<number>>, type?: string | null }> }> };

export type DefectLegendsDeckSummaryQueryVariables = Exact<{
  structureId?: InputMaybe<Scalars['String']['input']>;
}>;


export type DefectLegendsDeckSummaryQuery = { __typename?: 'Query', structure?: { __typename?: 'Structure', id: string, name: string, defectLegends: Array<{ __typename?: 'DefectLegend', id: number, name: string, color: string, groupName: string, groupKey: string, octreeKey: OctreeKey, octreeValue: number, legendText?: string | null }> } | null };

export type AssembliesDecksSummaryQueryVariables = Exact<{
  input?: InputMaybe<AssembliesFilterInput>;
}>;


export type AssembliesDecksSummaryQuery = { __typename?: 'Query', getAssembliesDecksSummary: Array<{ __typename?: 'DeckAreaSummary', deckId: string, totalArea: number } | null> };

export type AllPointOfInterestsForDecksQueryVariables = Exact<{
  structureId?: InputMaybe<Scalars['ID']['input']>;
  assemblyTemplateId: Scalars['ID']['input'];
  input?: InputMaybe<FindAllPointOfInterestsInput>;
}>;


export type AllPointOfInterestsForDecksQuery = { __typename?: 'Query', allPointOfInterestTemplate: Array<{ __typename?: 'PointOfInterestTemplate', id: string, name: string, type?: PointOfInterestTemplateTypeEnum | null, key?: string | null }>, allPointOfInterests: Array<{ __typename?: 'PointOfInterest', template?: { __typename?: 'PointOfInterestTemplate', id: string } | null, centerPoint3d?: { __typename?: 'Vector3', x: number, y: number } | null, paintRegion?: { __typename?: 'PaintRegion', deck: { __typename?: 'Deck', id: string, cadTransform: Array<number> } } | null }> };

export type ValidateIdmsFileQueryVariables = Exact<{
  input: ValidateIdmsTemplateQueryInput;
}>;


export type ValidateIdmsFileQuery = { __typename?: 'Query', validateIdmsTemplate?: string | null };

export type IdmsFileUploadMutationVariables = Exact<{
  input: IdmsUploadMutationInput;
}>;


export type IdmsFileUploadMutation = { __typename?: 'Mutation', idmsFileUpload?: { __typename?: 'IdmsUpload', name: string, filePath: string } | null };

export type IdmsUploadsQueryVariables = Exact<{
  structureId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type IdmsUploadsQuery = { __typename?: 'Query', idmsUploads: Array<{ __typename?: 'IdmsUpload', id: string, name: string, templateType: IdmsUploadsTypeEnum, createdAt: string, filePath: string }> };

export type IdmsTasksQueryVariables = Exact<{
  structureId: Scalars['ID']['input'];
  pageInfo?: InputMaybe<PageInfo>;
}>;


export type IdmsTasksQuery = { __typename?: 'Query', idmsTasks: { __typename?: 'IdmsTasksWithCount', count: number, tasks: Array<{ __typename?: 'IdmsTask', id: string, idmsTaskNumber: string, taskDueDate?: string | null, createdAt?: string | null, lineNumber: string, status?: string | null, statusUpdatedAt?: string | null, recommendations: Array<{ __typename?: 'TaskRecommendation', id: string, lineNumber: string, recommendationNumber: string, recommendationType: string, status?: string | null, statusUpdatedAt?: string | null, workOrders: Array<{ __typename?: 'WorkOrder', id: string, lineNumber: string, poiName: string, recommendationNumber?: string | null, status?: string | null, statusUpdatedAt?: string | null, workOrderNumber: string }> }> }> } };

export type LatestIdmsUploadsByTypeQueryVariables = Exact<{
  structureId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type LatestIdmsUploadsByTypeQuery = { __typename?: 'Query', latestIdmsUploadsByType: Array<{ __typename?: 'IdmsUpload', name: string, createdAt: string, templateType: IdmsUploadsTypeEnum, filePath: string }> };

export type SaveAssemblyScreenshotMutationVariables = Exact<{
  input?: InputMaybe<ScreenshotInput>;
}>;


export type SaveAssemblyScreenshotMutation = { __typename?: 'Mutation', saveAssemblyScreenshot?: Array<{ __typename?: 'Assembly', id: string, tagName: string } | null> | null };

export type BulkPipeSpecUploadMutationVariables = Exact<{
  input: BulkPipeSpecUploadInput;
}>;


export type BulkPipeSpecUploadMutation = { __typename?: 'Mutation', bulkPipeSpecUpload: { __typename?: 'BulkPipeSpecUploadResponse', message: string, onlyValidated: boolean, updatedCount: number } };

export type BulkUploadServiceGroupsMutationVariables = Exact<{
  input: BulkUploadServiceGroupsInput;
}>;


export type BulkUploadServiceGroupsMutation = { __typename?: 'Mutation', bulkUploadServiceGroups: { __typename?: 'BulkServiceGroupsResponse', message: string, updatedCount: number } };

export type UpdateAssemblyTableMutationVariables = Exact<{
  input: UpdateAssemblyTableValuesInput;
}>;


export type UpdateAssemblyTableMutation = { __typename?: 'Mutation', updateAssemblyTable?: string | null };

export type GetAssembliesByTemplateFieldsFiltersForEquipmentExportQueryVariables = Exact<{
  input?: InputMaybe<AssembliesFilterInput>;
  pageInfo?: InputMaybe<PageInfo>;
}>;


export type GetAssembliesByTemplateFieldsFiltersForEquipmentExportQuery = { __typename?: 'Query', getAssembliesByTemplateFieldsFilters: Array<{ __typename?: 'Assembly', id: string, tagName: string, templateFieldData?: any | null, poiCounts?: Array<{ __typename?: 'PoiTypeCount', poiType: string, count: number }> | null }> };

export type AllDecksQueryVariables = Exact<{
  structureId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type AllDecksQuery = { __typename?: 'Query', allDecks: Array<{ __typename?: 'Deck', id: string, name: string }> };

export type DecksWithDefectsQueryVariables = Exact<{
  structureId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type DecksWithDefectsQuery = { __typename?: 'Query', allDefects: Array<{ __typename?: 'Defect', key: string, name: string }>, decksWithDefects: Array<{ __typename?: 'DeckWithDefects', id: string, name: string, defectArea: Array<{ __typename?: 'DefectArea', key: string, area: number }> }> };

export type UpdatePaintRegionStatusMutationVariables = Exact<{
  input?: InputMaybe<UpdatePaintRegionStatusInput>;
}>;


export type UpdatePaintRegionStatusMutation = { __typename?: 'Mutation', updatePaintRegionStatus: { __typename?: 'PaintRegion', status?: string | null, remediationDate?: string | null } };

export type UpdatePointOfInterestsStatusMutationVariables = Exact<{
  input: UpdatePointOfInterestsStatusInput;
}>;


export type UpdatePointOfInterestsStatusMutation = { __typename?: 'Mutation', updatePointOfInterestsStatus?: string | null };

export type AllPaintRegionsForPaintBlockTableQueryVariables = Exact<{
  input: FindAllPaintRegionsInput;
}>;


export type AllPaintRegionsForPaintBlockTableQuery = { __typename?: 'Query', allPaintRegions: Array<{ __typename?: 'PaintRegion', id: string, name: string, status?: string | null, remediationDate?: string | null, paintRegionGroup?: { __typename?: 'PaintRegionGroup', id: string, name: string } | null }> };

export type DefectsAreaAndPointOfInterestCountByPaintRegionsQueryVariables = Exact<{
  input: PaintBlockFiltersInput;
}>;


export type DefectsAreaAndPointOfInterestCountByPaintRegionsQuery = { __typename?: 'Query', defectsAreaForAssemblyPaintRegions: { __typename?: 'PaintBlocksCorrodedArea', structureIds: Array<string>, defectsByDeck: Array<{ __typename?: 'NameAndArea', name: string, deckIds?: Array<string | null> | null, totalArea?: Array<{ __typename?: 'AreaAndType', type: string, value: number } | null> | null }>, defectsByPaintBlock: Array<{ __typename?: 'NameAndArea', name: string, paintRegionIds?: Array<string | null> | null, totalArea?: Array<{ __typename?: 'AreaAndType', type: string, value: number } | null> | null }> }, pointOfInterestCountByPaintRegions: { __typename?: 'PointOfInterestsFindingsByDeckAndPaintBlock', structureIds: Array<string>, findingsByDeck: Array<{ __typename?: 'PointOfInterestFindingAndName', name: string, totalCount: number, pointOfInterestFindings: Array<{ __typename?: 'PointOfInterestFindings', type: string, count: number, poiTemplateName?: string | null }> }>, findingsByPaintBlock: Array<{ __typename?: 'PointOfInterestFindingAndName', name: string, totalCount: number, pointOfInterestFindings: Array<{ __typename?: 'PointOfInterestFindings', type: string, count: number, poiTemplateName?: string | null }> }> } };

export type DefectsAreaForCustomBlocksQueryVariables = Exact<{
  input: PaintBlockFiltersInput;
  pageInfo?: InputMaybe<PageInfo>;
}>;


export type DefectsAreaForCustomBlocksQuery = { __typename?: 'Query', defectsAreaForAssemblyPaintRegionsByGroup: { __typename?: 'PaintBlocksCorrodedAreaByGroup', structureId: string, totalCount: number, defectsByPaintBlock: Array<{ __typename?: 'NameAndAreaByGroup', name: string, paintRegionId: string, totalArea?: Array<{ __typename?: 'AreaAndType', value: number, type: string } | null> | null, totalCountByPoiType?: Array<{ __typename?: 'AreaAndType', type: string, value: number } | null> | null }> } };

export type RiskRemediationTrendAnalyticsQueryVariables = Exact<{
  input?: InputMaybe<AnalyticsFiltersInput>;
}>;


export type RiskRemediationTrendAnalyticsQuery = { __typename?: 'Query', analytics: Array<{ __typename?: 'Analytics', data: any, id: string, structureIds: Array<string>, displayConfig?: any | null }> };

export type UpdateAssemblyRemediationMutationVariables = Exact<{
  input?: InputMaybe<UpdateAssemblyRemediationInput>;
}>;


export type UpdateAssemblyRemediationMutation = { __typename?: 'Mutation', updateAssemblyRemediation?: string | null };

export type AddPartialRemediationMutationVariables = Exact<{
  input: AddPartialRemediationInput;
}>;


export type AddPartialRemediationMutation = { __typename?: 'Mutation', addPartialRemediation: Array<{ __typename?: 'AssemblyPaintRegion', id: string, status?: PaintRegionStatus | null, remediationByRi?: any | null, remediationAt?: string | null }> };

export type GetAssemblyPaintRegionsByPaintRegionIdQueryVariables = Exact<{
  input: PaintBlockFiltersInput;
}>;


export type GetAssemblyPaintRegionsByPaintRegionIdQuery = { __typename?: 'Query', allAssemblyPaintRegions: Array<{ __typename?: 'AssemblyPaintRegion', id: string, status?: PaintRegionStatus | null, remediationAt?: string | null, templateFieldData?: any | null, remediationByRi?: any | null }> };

export type RemediatedPoiVersionsByPaintRegionQueryVariables = Exact<{
  input: RemediatedPoiVersionsByPaintRegionInput;
}>;


export type RemediatedPoiVersionsByPaintRegionQuery = { __typename?: 'Query', remediatedPOIVersionsByPaintRegion: Array<{ __typename?: 'PaintRegionVersion', id: string, createdAt: string, name?: string | null, poiId?: string | null, updatedData?: any | null, lastModifiedFor: string, lastModifiedByUser?: { __typename?: 'User', id: string, name?: string | null } | null }> };

export type RemediatedAssemblyPaintRegionVersionsByPaintRegionQueryVariables = Exact<{
  input?: InputMaybe<RemediatedAssemblyPaintRegionVersionsByPaintRegionInput>;
}>;


export type RemediatedAssemblyPaintRegionVersionsByPaintRegionQuery = { __typename?: 'Query', remediatedAssemblyPaintRegionVersionsByPaintRegion: Array<{ __typename?: 'PaintRegionVersion', id: string, createdAt: string, name?: string | null, updatedData?: any | null, lastModifiedFor: string, lastModifiedByUser?: { __typename?: 'User', id: string, name?: string | null } | null }> };

export type GetAssembliesByPaintRegionIdsQueryVariables = Exact<{
  input: GetAssembliesByPaintRegionIdsInput;
}>;


export type GetAssembliesByPaintRegionIdsQuery = { __typename?: 'Query', getAssembliesByPaintRegionIds: Array<{ __typename?: 'Assembly', id: string, tagName: string, templateFieldData?: any | null, isUncontextualized?: boolean | null, poiCounts?: Array<{ __typename?: 'PoiTypeCount', poiType: string, count: number }> | null, decks?: Array<{ __typename?: 'DecksDetails', deckId: { __typename?: 'Deck', id: string } } | null> | null }> };

export type PointOfInterestsCountByDueDateQueryVariables = Exact<{
  input?: InputMaybe<PointOfInterestMultiStructureInput>;
}>;


export type PointOfInterestsCountByDueDateQuery = { __typename?: 'Query', pointOfInterestsCountByDueDate?: Array<{ __typename?: 'AnomalyCount', count?: number | null, key?: string | null } | null> | null };

export type PaintDamageCountByAlarmLevelQueryVariables = Exact<{
  input?: InputMaybe<PointOfInterestMultiStructureInput>;
}>;


export type PaintDamageCountByAlarmLevelQuery = { __typename?: 'Query', paintDamageCountByAlarmLevel?: Array<{ __typename?: 'AnomalyCount', key?: string | null, count?: number | null } | null> | null };

export type PointOfInterestsCountByInspectionPriorityQueryVariables = Exact<{
  input?: InputMaybe<PointOfInterestInput>;
}>;


export type PointOfInterestsCountByInspectionPriorityQuery = { __typename?: 'Query', pointOfInterestsCountByInspectionPriority?: Array<{ __typename?: 'AnomalyCount', count?: number | null, key?: string | null } | null> | null };

export type PointOfInterestsCountByStatusQueryVariables = Exact<{
  input?: InputMaybe<PointOfInterestMultiStructureInput>;
}>;


export type PointOfInterestsCountByStatusQuery = { __typename?: 'Query', pointOfInterestsCountByStatus?: Array<{ __typename?: 'AnomalyCount', key?: string | null, count?: number | null } | null> | null };

export type PoiWorkflowQueryVariables = Exact<{
  input?: InputMaybe<PointOfInterestInput>;
  pageInfo?: InputMaybe<PageInfo>;
}>;


export type PoiWorkflowQuery = { __typename?: 'Query', pointOfInterests: Array<{ __typename?: 'PointOfInterest', id: string, name?: string | null, status?: string | null, assignee?: string | null, dueDate?: string | null, visibility?: VisibilityEnum | null, accessibility?: PoiAccessibilityEnum | null, comment?: string | null, isAutoGenerated?: boolean | null, linkedPointOfInterestIds?: Array<string> | null, poiId?: string | null, workpackNumber?: string | null }>, pointOfInterestsCount?: { __typename?: 'Count', count: number } | null };

export type AllWorkpacksQueryVariables = Exact<{
  structureId?: InputMaybe<Scalars['String']['input']>;
  hasPois?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type AllWorkpacksQuery = { __typename?: 'Query', allWorkpacks: Array<{ __typename?: 'Workpack', id: string, name: string }> };

export type DeleteWorkpackMutationVariables = Exact<{
  input?: InputMaybe<DeleteWorkpackInput>;
}>;


export type DeleteWorkpackMutation = { __typename?: 'Mutation', deleteWorkpack?: { __typename?: 'Workpack', id: string, name: string } | null };

export type RemoveWorkpackIdFromPointOfInterestsMutationVariables = Exact<{
  input?: InputMaybe<InputGroupByWorkpackId>;
}>;


export type RemoveWorkpackIdFromPointOfInterestsMutation = { __typename?: 'Mutation', RemoveWorkpackIdFromPointOfInterests?: Array<{ __typename?: 'PointOfInterest', name?: string | null } | null> | null };

export type CreateWorkpackMutationVariables = Exact<{
  input?: InputMaybe<CreateWorkpackInput>;
}>;


export type CreateWorkpackMutation = { __typename?: 'Mutation', createWorkpack?: { __typename?: 'Workpack', name: string, id: string, type?: WorkpackType | null } | null };

export type UpdateWorkpackMutationVariables = Exact<{
  input?: InputMaybe<UpdateWorkpackInput>;
}>;


export type UpdateWorkpackMutation = { __typename?: 'Mutation', updateWorkpack?: { __typename?: 'Workpack', id: string, name: string, wbs?: WorkpackWbs | null, type?: WorkpackType | null } | null };

export type UpdateWorkpackStatusMutationVariables = Exact<{
  workpackId: Scalars['ID']['input'];
  status: Scalars['String']['input'];
}>;


export type UpdateWorkpackStatusMutation = { __typename?: 'Mutation', updateWorkpackStatus?: { __typename?: 'Workpack', status?: string | null } | null };

export type GroupPointOfInterestsByWorkpackIdMutationVariables = Exact<{
  input?: InputMaybe<InputGroupByWorkpackId>;
}>;


export type GroupPointOfInterestsByWorkpackIdMutation = { __typename?: 'Mutation', GroupPointOfInterestsByWorkpackId?: Array<{ __typename?: 'PointOfInterest', poiId?: string | null } | null> | null };

export type GetPointOfInterestGroupedByWorkpackQueryVariables = Exact<{
  input?: InputMaybe<PointOfInterestInput>;
  pageInfo?: InputMaybe<PageInfo>;
}>;


export type GetPointOfInterestGroupedByWorkpackQuery = { __typename?: 'Query', allWorkpacks: Array<{ __typename?: 'PointOfInterestsGroupedByWorkpack', _id?: string | null, verifiedPointOfInterestsCount?: number | null, pointOfInterestsCount?: number | null, assembliesCount?: number | null, workpack?: { __typename?: 'Workpack', name: string, status?: string | null, type?: WorkpackType | null, wbs?: WorkpackWbs | null } | null }>, workpacksCount?: { __typename?: 'Count', count: number } | null };

export type AllWorkpackTemplatesForPoiContainerQueryVariables = Exact<{
  input: WorkpackTemplateInput;
}>;


export type AllWorkpackTemplatesForPoiContainerQuery = { __typename?: 'Query', allWorkpackTemplates?: Array<{ __typename?: 'WorkpackTemplate', id: string, name: string }> | null };

export type AllPointOfInterestsQueryVariables = Exact<{
  input?: InputMaybe<FindAllPointOfInterestsInput>;
}>;


export type AllPointOfInterestsQuery = { __typename?: 'Query', allPointOfInterests: Array<{ __typename?: 'PointOfInterest', id: string, name?: string | null, templateFieldData?: any | null, assembly: { __typename?: 'Assembly', tagName: string, id: string }, template?: { __typename?: 'PointOfInterestTemplate', id: string } | null, workpack?: { __typename?: 'Workpack', id: string, name: string, status?: string | null } | null }> };

export type UpdateReportByPointOfInterestsMutationVariables = Exact<{
  input?: InputMaybe<UpdateReportByPointOfInterestsInput>;
}>;


export type UpdateReportByPointOfInterestsMutation = { __typename?: 'Mutation', updateReportByPointOfInterests: { __typename?: 'Report', createdAt: string, id?: string | null, name: string, status: ReportStatus } };

export type UpdatePointOfInterestVisibilityMutationVariables = Exact<{
  input?: InputMaybe<UpdatePointOfInterestVisibilityInput>;
  filters?: InputMaybe<PointOfInterestInput>;
}>;


export type UpdatePointOfInterestVisibilityMutation = { __typename?: 'Mutation', updatePointOfInterestVisibility: Array<{ __typename?: 'PointOfInterest', id: string }> };

export type GetUserPreferencesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetUserPreferencesQuery = { __typename?: 'Query', getUserPreferences?: { __typename?: 'UserPreferences', structure?: any | null, platform?: any | null } | null };

export type PointOfInterestsCountByTypeQueryVariables = Exact<{
  input?: InputMaybe<PointOfInterestInput>;
}>;


export type PointOfInterestsCountByTypeQuery = { __typename?: 'Query', pointOfInterestsCountByType?: Array<{ __typename?: 'PointOfInterestsCountByType', count?: number | null, type?: string | null } | null> | null };

export type UpdateUserColumnPreferencesMutationVariables = Exact<{
  input?: InputMaybe<UpdateUserColumnPreferencesInput>;
}>;


export type UpdateUserColumnPreferencesMutation = { __typename?: 'Mutation', updateUserColumnPreferences?: { __typename?: 'User', preferences?: { __typename?: 'UserPreferences', structure?: any | null } | null } | null };

export type UpdateUserStructurePreferencesMutationVariables = Exact<{
  input?: InputMaybe<UpdateUserStructurePreferencesInput>;
}>;


export type UpdateUserStructurePreferencesMutation = { __typename?: 'Mutation', updateUserStructurePreferences?: { __typename?: 'UserPreferences', structure?: any | null } | null };

export type GetInspectionPlansQueryVariables = Exact<{
  structureId: Scalars['String']['input'];
}>;


export type GetInspectionPlansQuery = { __typename?: 'Query', getInspectionPlans: Array<{ __typename?: 'InspectionPlan', id: string, name: string, isPlanPinned?: boolean | null, filters?: { __typename?: 'InspectionPlanFilters', deckIds?: Array<string | null> | null, workpackIds?: Array<string | null> | null, paintRegionIds?: Array<string | null> | null, templateFilters?: Array<{ __typename?: 'TemplateFilters', id?: string | null, value?: Array<string | null> | null } | null> | null } | null }> };

export type CreateInspectionPlanMutationVariables = Exact<{
  input: CreateInspectionPlanInput;
}>;


export type CreateInspectionPlanMutation = { __typename?: 'Mutation', createInspectionPlan?: { __typename?: 'InspectionPlan', id: string, name: string, isPlanPinned?: boolean | null, filters?: { __typename?: 'InspectionPlanFilters', deckIds?: Array<string | null> | null, workpackIds?: Array<string | null> | null, paintRegionIds?: Array<string | null> | null, templateFilters?: Array<{ __typename?: 'TemplateFilters', id?: string | null, value?: Array<string | null> | null } | null> | null } | null } | null };

export type UpdateInspectionPlanMutationVariables = Exact<{
  input: UpdateInspectionPlanInput;
}>;


export type UpdateInspectionPlanMutation = { __typename?: 'Mutation', updateInspectionPlan?: { __typename?: 'InspectionPlan', id: string, name: string, isPlanPinned?: boolean | null, filters?: { __typename?: 'InspectionPlanFilters', deckIds?: Array<string | null> | null, workpackIds?: Array<string | null> | null, paintRegionIds?: Array<string | null> | null, templateFilters?: Array<{ __typename?: 'TemplateFilters', id?: string | null, value?: Array<string | null> | null } | null> | null } | null } | null };

export type DeleteInspectionPlanMutationVariables = Exact<{
  input: DeleteInspectionPlanInput;
}>;


export type DeleteInspectionPlanMutation = { __typename?: 'Mutation', deleteInspectionPlan?: { __typename?: 'InspectionPlan', id: string, name: string, isPlanPinned?: boolean | null, filters?: { __typename?: 'InspectionPlanFilters', deckIds?: Array<string | null> | null, workpackIds?: Array<string | null> | null, paintRegionIds?: Array<string | null> | null, templateFilters?: Array<{ __typename?: 'TemplateFilters', id?: string | null, value?: Array<string | null> | null } | null> | null } | null } | null };

export type DeletePlannerColumnMutationVariables = Exact<{
  input: DeletePlannerColumnInput;
}>;


export type DeletePlannerColumnMutation = { __typename?: 'Mutation', deletePlannerColumn?: { __typename?: 'Template', id: string } | null };

export type CreateAssemblyMutationVariables = Exact<{
  input?: InputMaybe<CreateAssemblyInput>;
}>;


export type CreateAssemblyMutation = { __typename?: 'Mutation', createAssembly?: { __typename?: 'Template', name: string, id: string, defectsArray: Array<string>, recommendation?: { __typename?: 'RecommendationField', header: string, details: Array<{ __typename?: 'RecommendationDetailField', id: string, fieldKey: string } | null> } | null, equipmentCard: Array<{ __typename?: 'EquipmentCardField', id: string, name: string, type: EqiupmentCardFieldTypeEnum, position: EquipmentCardPositionEnum, fieldKey?: string | null, location: EquipmentCardLocationEnum }>, equipmentDetails: Array<{ __typename?: 'EquipmentDetailField', id: string, name: string, subType?: EquipmentDetailSubTypeEnum | null, type: EquipmentDetailTypeEnum, fieldKey: string, options: Array<{ __typename?: 'EquipmentDetailOptionField', id: string, name: string, type: OptionFieldTypeEnum, fieldKey?: string | null }> }>, querySummary?: Array<{ __typename?: 'QuerySummaryItem', name: string, key?: string | null, operation: string }> | null, fields: Array<{ __typename?: 'AssemblyTemplateField', isEditable?: boolean | null, editRoles?: Array<string | null> | null, options: Array<string>, id: string, name: string, key?: string | null, type: TemplateFieldTypeEnum, serverSide: boolean, permission?: string | null, displayInQuery?: boolean | null, displayInRisk?: boolean | null, roundToDecimal?: number | null, unit?: UnitsEnum | null, displayUnit?: UnitsEnum | null, displayConfig?: { __typename?: 'DisplayConfig', id: string, type: TableCellStyleEnum, isSortable: boolean, sortType: SortTypeEnum, color?: Array<{ __typename?: 'DisplayColor', key: string, value: string } | null> | null } | null }> } | null };

export type GetAllTemplatesByTypeQueryVariables = Exact<{
  structureId: Scalars['ID']['input'];
  type: TemplateTypeEnum;
}>;


export type GetAllTemplatesByTypeQuery = { __typename?: 'Query', allTemplates: Array<{ __typename?: 'Template', id: string, name: string, permissions?: Array<string | null> | null, fields: Array<{ __typename?: 'AssemblyTemplateField', options: Array<string>, name: string, type: TemplateFieldTypeEnum, id: string }> }> };

export type GetStructureDeploymentLevelQueryVariables = Exact<{
  structureId?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetStructureDeploymentLevelQuery = { __typename?: 'Query', structure?: { __typename?: 'Structure', deploymentLevel?: StructureDeploymentLevel | null } | null };

export type GetAssembliesSummaryQueryVariables = Exact<{
  input?: InputMaybe<AssembliesFilterInput>;
}>;


export type GetAssembliesSummaryQuery = { __typename?: 'Query', getAssembliesSummary: Array<{ __typename?: 'AssemblySummary', id: string, name: string, key?: string | null, operation: string, displayType: DisplayType, rowOrder: number, data?: any | null, displayConfig?: Array<{ __typename?: 'DisplaySettings', fieldValue: string, color: string }> | null }> };

export type GetPaintblockTemplateQueryVariables = Exact<{
  structureId: Scalars['ID']['input'];
  type: TemplateTypeEnum;
}>;


export type GetPaintblockTemplateQuery = { __typename?: 'Query', allTemplates: Array<{ __typename?: 'Template', id: string, name: string, fields: Array<{ __typename?: 'AssemblyTemplateField', options: Array<string>, name: string, type: TemplateFieldTypeEnum, id: string, isHidden?: boolean | null, isReadOnly: boolean, defaultVisible?: boolean | null }> }> };

export type DefectLegendsForPaintBlockTableQueryVariables = Exact<{
  structureId?: InputMaybe<Scalars['String']['input']>;
}>;


export type DefectLegendsForPaintBlockTableQuery = { __typename?: 'Query', structure?: { __typename?: 'Structure', defectLegends: Array<{ __typename?: 'DefectLegend', id: number, name: string, groupKey: string, groupName: string, color: string }> } | null };

export type GetAnalysisStructureLocationsQueryVariables = Exact<{
  structureId: Scalars['ID']['input'];
}>;


export type GetAnalysisStructureLocationsQuery = { __typename?: 'Query', allLocations: Array<{ __typename?: 'Location', id: string, name: string, resourcePath?: string | null, baseResourcePath?: string | null, scanKey?: string | null, videoResourcePath?: string | null, videoTimestamp?: number | null, pose?: { __typename?: 'LocationPose', yaw: number, pitch: number, roll: number, z: number, y: number, x: number, yawOffset: number } | null, layers?: Array<{ __typename?: 'LocationLayer', fileExt?: string | null, type: string, displayName: string } | null> | null, imageSensor?: { __typename?: 'ImageSensor', width: number, height: number, cx: number, cy: number, focalLength: number } | null, deck: { __typename?: 'Deck', name: string } }> };

export type GetStructureDataQueryVariables = Exact<{
  structureId: Scalars['String']['input'];
}>;


export type GetStructureDataQuery = { __typename?: 'Query', structure?: { __typename?: 'Structure', hasRiskAssessment?: boolean | null, blisterHeightType?: BlisterHeightType | null, isActive?: boolean | null, id: string, name: string, category?: string | null, structurePipesConfig?: { __typename?: 'StructurePipesConfig', imperialSteelPipes?: any | null } | null, platform?: { __typename?: 'Platform', id: string } | null, reportConfig?: { __typename?: 'ReportConfig', poiSummaryChartsConfig?: any | null } | null } | null };

export type GetPaintRegionStatusLabelsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetPaintRegionStatusLabelsQuery = { __typename?: 'Query', setting?: { __typename?: 'Setting', id: string, name: string, type: SettingTypesEnum, revision: number, meta: Array<{ __typename: 'DefectColorMeta' } | { __typename: 'FloatMeta' } | { __typename: 'IntMeta' } | { __typename: 'StringArrayMeta' } | { __typename: 'StringMeta', key: string, value: string }> } | null };

export type GetPoiStatusLabelsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetPoiStatusLabelsQuery = { __typename?: 'Query', setting?: { __typename?: 'Setting', id: string, name: string, type: SettingTypesEnum, revision: number, meta: Array<{ __typename: 'DefectColorMeta' } | { __typename: 'FloatMeta' } | { __typename: 'IntMeta' } | { __typename: 'StringArrayMeta' } | { __typename: 'StringMeta', key: string, value: string }> } | null };

export type GetWorkpackStatusLabelsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetWorkpackStatusLabelsQuery = { __typename?: 'Query', setting?: { __typename?: 'Setting', id: string, name: string, type: SettingTypesEnum, revision: number, meta: Array<{ __typename: 'DefectColorMeta' } | { __typename: 'FloatMeta' } | { __typename: 'IntMeta' } | { __typename: 'StringArrayMeta' } | { __typename: 'StringMeta', key: string, value: string }> } | null };

export type GetAssemblyByTagNameQueryVariables = Exact<{
  tagName: Scalars['String']['input'];
  structureId: Scalars['ID']['input'];
}>;


export type GetAssemblyByTagNameQuery = { __typename?: 'Query', assemblyByTagName?: { __typename?: 'Assembly', id: string } | null };

export type UpdateWallLossFactorMutationVariables = Exact<{
  structureId?: InputMaybe<Scalars['ID']['input']>;
  wallLossFactor?: InputMaybe<Scalars['Int']['input']>;
}>;


export type UpdateWallLossFactorMutation = { __typename?: 'Mutation', updateWallLossFactor?: string | null };

export type AssembliesFragment = { __typename?: 'Assembly', templateFieldData?: any | null, id: string, tagName: string, area?: number | null, pipeSpec?: { __typename?: 'PipeSpec', material?: string | null, nominalCorrosionAllowance?: number | null, nominalThickness?: number | null, schedule?: string | null, size?: string | null, spec?: string | null } | null, template: { __typename?: 'Template', id: string, name: string, fields: Array<{ __typename?: 'AssemblyTemplateField', id: string, key?: string | null, name: string }>, reviewActionChecklistConfig?: Array<{ __typename?: 'ReviewActionChecklistConfig', id: string, reviewActionValue: string, displayName: string, isEnabled: boolean, position: number }> | null }, service?: { __typename?: 'Service', group: string } | null, files?: Array<{ __typename?: 'File', id?: string | null, name: FileNameTypes, resourcePath: string, type: FileTypes, fileName: string, uploadStatus?: FileUploadStatus | null, imageType?: ImageType | null, uuid?: string | null }> | null };

export type PointOfInterestsFragment = { __typename?: 'PointOfInterest', id: string, poiId?: string | null, name?: string | null, type: string, accessibility?: PoiAccessibilityEnum | null, workpackNumber?: string | null, isVerified?: boolean | null, status?: string | null, deckRelativeHeight?: number | null, templateFieldData?: any | null, remediationNote?: string | null, workpack?: { __typename?: 'Workpack', id: string, name: string, status?: string | null } | null, template?: { __typename?: 'PointOfInterestTemplate', createdBy?: string | null, id: string, name: string, fields: Array<{ __typename?: 'PointOfInterestTemplateField', id: string, key?: string | null, type: TemplateFieldTypeEnum }> } | null, templateData?: Array<{ __typename?: 'TemplateData', templateFieldId?: string | null, value?: any | null, verifiedValue?: any | null, id: string }> | null, assembly: { __typename?: 'Assembly', templateFieldData?: any | null, id: string, tagName: string, area?: number | null, pipeSpec?: { __typename?: 'PipeSpec', material?: string | null, nominalCorrosionAllowance?: number | null, nominalThickness?: number | null, schedule?: string | null, size?: string | null, spec?: string | null } | null, template: { __typename?: 'Template', id: string, name: string, fields: Array<{ __typename?: 'AssemblyTemplateField', id: string, key?: string | null, name: string }>, reviewActionChecklistConfig?: Array<{ __typename?: 'ReviewActionChecklistConfig', id: string, reviewActionValue: string, displayName: string, isEnabled: boolean, position: number }> | null }, service?: { __typename?: 'Service', group: string } | null, files?: Array<{ __typename?: 'File', id?: string | null, name: FileNameTypes, resourcePath: string, type: FileTypes, fileName: string, uploadStatus?: FileUploadStatus | null, imageType?: ImageType | null, uuid?: string | null }> | null }, paintRegion?: { __typename?: 'PaintRegion', name: string, deck: { __typename?: 'Deck', name: string, imageDimensions: Array<number>, resourcePath: string, cadTransform: Array<number> } } | null, centerPoint3d?: { __typename?: 'Vector3', x: number, y: number, z: number } | null, blister?: { __typename?: 'Blister', maxHeight?: number | null, verifiedMaxHeight?: string | null, estimatedHeight: number, pdrHeight?: number | null, heightType?: BlisterHeightType | null, isManuallyOverridden?: boolean | null, fittingRadius: number, manualSetHeight?: number | null, verifiedResidualThickness?: string | null, radius: number, distanceConfidence?: string | null, measurementConfidence?: string | null, wallLoss?: { __typename?: 'ValueAndPercentage', percentage: number, value: number } | null, residualCorrosionAllowance?: { __typename?: 'ValueAndPercentage', percentage: number, value: number } | null, residualThickness?: { __typename?: 'ValueAndPercentage', percentage: number, value: number } | null, radiusPoint: { __typename?: 'PolarPoint', bearing: number, elevation: number }, centerPoint: { __typename?: 'PolarPoint', bearing: number, elevation: number }, borders: Array<{ __typename?: 'PolarPoint', bearing: number, elevation: number } | null> } | null, screenshotPaths?: { __typename?: 'ScreenshotPaths', viewpoint?: string | null, viewer?: string | null } | null, location?: { __typename?: 'Location', id: string, name: string, deck: { __typename?: 'Deck', name: string, imageDimensions: Array<number>, resourcePath: string, cadTransform: Array<number> } } | null, files?: Array<{ __typename?: 'File', id?: string | null, name: FileNameTypes, resourcePath: string, type: FileTypes, fileName: string, uploadStatus?: FileUploadStatus | null, imageType?: ImageType | null, uuid?: string | null }> | null };

export type AllReportsListQueryVariables = Exact<{
  input?: InputMaybe<ReportsInput>;
}>;


export type AllReportsListQuery = { __typename?: 'Query', allReports: Array<{ __typename?: 'Report', internalType: ReportInternalType, createdAt: string, id?: string | null, name: string, status: ReportStatus, actionStatus?: ReportActionStatus | null, dueDate?: string | null, startDate?: string | null, workpackNumber?: string | null, type?: ReportType | null, createdByUser: { __typename?: 'User', name?: string | null, email: string }, pointOfInterests?: Array<{ __typename?: 'PointOfInterest', id: string, assembly: { __typename?: 'Assembly', id: string } }> | null } | null> };

export type UpdateReportDueDateMutationVariables = Exact<{
  input?: InputMaybe<UpdateReportInput>;
}>;


export type UpdateReportDueDateMutation = { __typename?: 'Mutation', updateReport: { __typename?: 'Report', id?: string | null, dueDate?: string | null, startDate?: string | null } };

export type UpdateReportActionStatusMutationVariables = Exact<{
  input?: InputMaybe<UpdateReportInput>;
}>;


export type UpdateReportActionStatusMutation = { __typename?: 'Mutation', updateReport: { __typename?: 'Report', id?: string | null, actionStatus?: ReportActionStatus | null } };

export type TemplatesFragment = { __typename?: 'PointOfInterestTemplate', createdBy?: string | null, id: string, name: string, fields: Array<{ __typename?: 'PointOfInterestTemplateField', id: string, key?: string | null, isReadOnly: boolean, isRequired: boolean, isHidden?: boolean | null, name: string, options: Array<string>, type: TemplateFieldTypeEnum }> };

export type AllReportImagesQueryVariables = Exact<{
  reportId: Scalars['ID']['input'];
}>;


export type AllReportImagesQuery = { __typename?: 'Query', allReportImages: Array<{ __typename?: 'PointOfInterestImages', pointOfInterestId: any, selectedImages?: Array<{ __typename?: 'File', name: FileNameTypes, resourcePath: string, type: FileTypes, fileName: string, id?: string | null, imageType?: ImageType | null, uuid?: string | null } | null> | null }> };

export type ReportDetailsQueryVariables = Exact<{
  input?: InputMaybe<ReportInput>;
}>;


export type ReportDetailsQuery = { __typename?: 'Query', report: { __typename?: 'Report', createdAt: string, id?: string | null, name: string, status: ReportStatus, templateFieldData?: any | null, actionStatus?: ReportActionStatus | null, dueDate?: string | null, startDate?: string | null, internalType: ReportInternalType, type?: ReportType | null, reviewActionPois?: any | null, createdByUser: { __typename?: 'User', name?: string | null, picture?: string | null }, paintRegion?: { __typename?: 'PaintRegion', name: string, id: string } | null, pointOfInterests?: Array<{ __typename?: 'PointOfInterest', id: string, poiId?: string | null, name?: string | null, type: string, accessibility?: PoiAccessibilityEnum | null, workpackNumber?: string | null, isVerified?: boolean | null, status?: string | null, deckRelativeHeight?: number | null, templateFieldData?: any | null, remediationNote?: string | null, workpack?: { __typename?: 'Workpack', id: string, name: string, status?: string | null } | null, template?: { __typename?: 'PointOfInterestTemplate', createdBy?: string | null, id: string, name: string, fields: Array<{ __typename?: 'PointOfInterestTemplateField', id: string, key?: string | null, type: TemplateFieldTypeEnum }> } | null, templateData?: Array<{ __typename?: 'TemplateData', templateFieldId?: string | null, value?: any | null, verifiedValue?: any | null, id: string }> | null, assembly: { __typename?: 'Assembly', templateFieldData?: any | null, id: string, tagName: string, area?: number | null, pipeSpec?: { __typename?: 'PipeSpec', material?: string | null, nominalCorrosionAllowance?: number | null, nominalThickness?: number | null, schedule?: string | null, size?: string | null, spec?: string | null } | null, template: { __typename?: 'Template', id: string, name: string, fields: Array<{ __typename?: 'AssemblyTemplateField', id: string, key?: string | null, name: string }>, reviewActionChecklistConfig?: Array<{ __typename?: 'ReviewActionChecklistConfig', id: string, reviewActionValue: string, displayName: string, isEnabled: boolean, position: number }> | null }, service?: { __typename?: 'Service', group: string } | null, files?: Array<{ __typename?: 'File', id?: string | null, name: FileNameTypes, resourcePath: string, type: FileTypes, fileName: string, uploadStatus?: FileUploadStatus | null, imageType?: ImageType | null, uuid?: string | null }> | null }, paintRegion?: { __typename?: 'PaintRegion', name: string, deck: { __typename?: 'Deck', name: string, imageDimensions: Array<number>, resourcePath: string, cadTransform: Array<number> } } | null, centerPoint3d?: { __typename?: 'Vector3', x: number, y: number, z: number } | null, blister?: { __typename?: 'Blister', maxHeight?: number | null, verifiedMaxHeight?: string | null, estimatedHeight: number, pdrHeight?: number | null, heightType?: BlisterHeightType | null, isManuallyOverridden?: boolean | null, fittingRadius: number, manualSetHeight?: number | null, verifiedResidualThickness?: string | null, radius: number, distanceConfidence?: string | null, measurementConfidence?: string | null, wallLoss?: { __typename?: 'ValueAndPercentage', percentage: number, value: number } | null, residualCorrosionAllowance?: { __typename?: 'ValueAndPercentage', percentage: number, value: number } | null, residualThickness?: { __typename?: 'ValueAndPercentage', percentage: number, value: number } | null, radiusPoint: { __typename?: 'PolarPoint', bearing: number, elevation: number }, centerPoint: { __typename?: 'PolarPoint', bearing: number, elevation: number }, borders: Array<{ __typename?: 'PolarPoint', bearing: number, elevation: number } | null> } | null, screenshotPaths?: { __typename?: 'ScreenshotPaths', viewpoint?: string | null, viewer?: string | null } | null, location?: { __typename?: 'Location', id: string, name: string, deck: { __typename?: 'Deck', name: string, imageDimensions: Array<number>, resourcePath: string, cadTransform: Array<number> } } | null, files?: Array<{ __typename?: 'File', id?: string | null, name: FileNameTypes, resourcePath: string, type: FileTypes, fileName: string, uploadStatus?: FileUploadStatus | null, imageType?: ImageType | null, uuid?: string | null }> | null }> | null, selectedPointOfInterestImages?: Array<{ __typename?: 'PointOfInterestImages', pointOfInterestId: any, selectedImages?: Array<{ __typename?: 'File', name: FileNameTypes, resourcePath: string, type: FileTypes, fileName: string, id?: string | null, imageType?: ImageType | null, uuid?: string | null, caption?: string | null } | null> | null } | null> | null, allPointOfInterestPdfs?: Array<{ __typename?: 'PointOfInterestPdfs', pointOfInterestId: any, selectedPdfs?: Array<{ __typename?: 'FileWithStatus', selectedStatus: boolean, file: { __typename?: 'File', name: FileNameTypes, resourcePath: string, fileName: string, type: FileTypes, uploadStatus?: FileUploadStatus | null, id?: string | null } }> | null } | null> | null, files?: Array<{ __typename?: 'File', fileName: string, id?: string | null, name: FileNameTypes, resourcePath: string, size?: number | null, type: FileTypes, uploadStatus?: FileUploadStatus | null, imageType?: ImageType | null, uuid?: string | null }> | null, reportOrder?: { __typename?: 'ReportOrder', assemblyOrder?: Array<string | null> | null, poiOrder?: any | null } | null, components?: Array<{ __typename?: 'Assembly', templateFieldData?: any | null, id: string, tagName: string, area?: number | null, pipeSpec?: { __typename?: 'PipeSpec', material?: string | null, nominalCorrosionAllowance?: number | null, nominalThickness?: number | null, schedule?: string | null, size?: string | null, spec?: string | null } | null, template: { __typename?: 'Template', id: string, name: string, fields: Array<{ __typename?: 'AssemblyTemplateField', id: string, key?: string | null, name: string }>, reviewActionChecklistConfig?: Array<{ __typename?: 'ReviewActionChecklistConfig', id: string, reviewActionValue: string, displayName: string, isEnabled: boolean, position: number }> | null }, service?: { __typename?: 'Service', group: string } | null, files?: Array<{ __typename?: 'File', id?: string | null, name: FileNameTypes, resourcePath: string, type: FileTypes, fileName: string, uploadStatus?: FileUploadStatus | null, imageType?: ImageType | null, uuid?: string | null }> | null }> | null } };

export type ReportPointOfInterestVerifiedSubscriptionVariables = Exact<{
  reportId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type ReportPointOfInterestVerifiedSubscription = { __typename?: 'Subscription', reportPointOfInterestVerified: { __typename?: 'VerifiedDetails', reportId: string, pointOfInterest: { __typename?: 'PointOfInterest', id: string, isVerified?: boolean | null, templateFieldData?: any | null, templateData?: Array<{ __typename?: 'TemplateData', templateFieldId?: string | null, value?: any | null, verifiedValue?: any | null, id: string }> | null } } };

export type UpdateReportStatusMutationVariables = Exact<{
  input?: InputMaybe<UpdateReportStatusInput>;
}>;


export type UpdateReportStatusMutation = { __typename?: 'Mutation', updateReportStatus: { __typename?: 'Report', id?: string | null, status: ReportStatus } };

export type UpdateReportOrderMutationVariables = Exact<{
  input?: InputMaybe<UpdateReportInput>;
}>;


export type UpdateReportOrderMutation = { __typename?: 'Mutation', updateReport: { __typename?: 'Report', id?: string | null, reportOrder?: { __typename?: 'ReportOrder', assemblyOrder?: Array<string | null> | null, poiOrder?: any | null } | null } };

export type DeleteReportMutationVariables = Exact<{
  reportId: Scalars['ID']['input'];
}>;


export type DeleteReportMutation = { __typename?: 'Mutation', deleteReport: boolean };

export type UpdatePoiImagesMutationVariables = Exact<{
  input?: InputMaybe<UpdateReportPointOfInterestImagesInput>;
}>;


export type UpdatePoiImagesMutation = { __typename?: 'Mutation', updateReportPointOfInterestImages: { __typename?: 'Report', id?: string | null, selectedPointOfInterestImages?: Array<{ __typename?: 'PointOfInterestImages', pointOfInterestId: any, selectedImages?: Array<{ __typename?: 'File', name: FileNameTypes, fileName: string, type: FileTypes, resourcePath: string, id?: string | null, uuid?: string | null, imageType?: ImageType | null } | null> | null } | null> | null, allPointOfInterestPdfs?: Array<{ __typename?: 'PointOfInterestPdfs', pointOfInterestId: any, selectedPdfs?: Array<{ __typename?: 'FileWithStatus', selectedStatus: boolean, file: { __typename?: 'File', name: FileNameTypes, resourcePath: string, fileName: string, type: FileTypes, uploadStatus?: FileUploadStatus | null, id?: string | null } }> | null } | null> | null } };

export type PreSignedUrlToUploadFilesMutationVariables = Exact<{
  input: UploadFileInput;
}>;


export type PreSignedUrlToUploadFilesMutation = { __typename?: 'Mutation', preSignedUrlToUploadFiles: Array<{ __typename?: 'GeneratedPresignedURL', url: string, id: string, resourcePath: string, uuid: string }> };

export type UpdateFileStatusForPaintBlockReportManualUploadsMutationVariables = Exact<{
  input: UpdateFilesStatusInput;
}>;


export type UpdateFileStatusForPaintBlockReportManualUploadsMutation = { __typename?: 'Mutation', updateFilesStatus?: boolean | null };

export type AddAndRemoveFilesMutationVariables = Exact<{
  input: UpdateFilesInput;
}>;


export type AddAndRemoveFilesMutation = { __typename?: 'Mutation', addAndRemoveFiles?: boolean | null };

export type UpdateReportMutationVariables = Exact<{
  input?: InputMaybe<UpdateReportInput>;
}>;


export type UpdateReportMutation = { __typename?: 'Mutation', updateReport: { __typename?: 'Report', templateFieldData?: any | null, id?: string | null, startDate?: string | null, selectedPointOfInterestImages?: Array<{ __typename?: 'PointOfInterestImages', pointOfInterestId: any, selectedImages?: Array<{ __typename?: 'File', name: FileNameTypes, fileName: string, type: FileTypes, resourcePath: string, id?: string | null, uuid?: string | null, imageType?: ImageType | null } | null> | null } | null> | null, allPointOfInterestPdfs?: Array<{ __typename?: 'PointOfInterestPdfs', pointOfInterestId: any, selectedPdfs?: Array<{ __typename?: 'FileWithStatus', selectedStatus: boolean, file: { __typename?: 'File', name: FileNameTypes, resourcePath: string, fileName: string, type: FileTypes, uploadStatus?: FileUploadStatus | null, id?: string | null } }> | null } | null> | null, files?: Array<{ __typename?: 'File', id?: string | null, name: FileNameTypes, type: FileTypes, resourcePath: string, fileName: string, uploadStatus?: FileUploadStatus | null, imageType?: ImageType | null, uuid?: string | null }> | null } };

export type DefectsAreaForAssemblyPaintRegionsQueryVariables = Exact<{
  input: PaintBlockFiltersInput;
}>;


export type DefectsAreaForAssemblyPaintRegionsQuery = { __typename?: 'Query', defectsAreaForAssemblyPaintRegions: { __typename?: 'PaintBlocksCorrodedArea', defectsByPaintBlock: Array<{ __typename?: 'NameAndArea', totalArea?: Array<{ __typename?: 'AreaAndType', type: string, value: number } | null> | null }> } };

export type ValidateReportScopeQueryVariables = Exact<{
  input?: InputMaybe<ValidateReportScopeInput>;
}>;


export type ValidateReportScopeQuery = { __typename?: 'Query', validateReportScope: { __typename?: 'ValidateReportScopeResult', isValid: boolean } };

export type StructureForReportQueryVariables = Exact<{
  structureId?: InputMaybe<Scalars['String']['input']>;
}>;


export type StructureForReportQuery = { __typename?: 'Query', structure?: { __typename?: 'Structure', reportConfig?: { __typename?: 'ReportConfig', title: string, id: string, reviewActionTableConfigs?: any | null, paintBlockReportPoiTemplateTypes?: Array<string | null> | null, configurations?: Array<{ __typename?: 'Configurations', id: string, title: string, key: string }> | null } | null } | null };

export type StructureDeploymentLevelQueryVariables = Exact<{
  structureId?: InputMaybe<Scalars['String']['input']>;
}>;


export type StructureDeploymentLevelQuery = { __typename?: 'Query', structure?: { __typename?: 'Structure', deploymentLevel?: StructureDeploymentLevel | null } | null };

export type GetAssemblyAttachmentsQueryVariables = Exact<{
  assemblyId?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetAssemblyAttachmentsQuery = { __typename?: 'Query', assembly?: { __typename?: 'Assembly', generalAttachmentsNote?: string | null, files?: Array<{ __typename?: 'File', id?: string | null, name: FileNameTypes, resourcePath: string, type: FileTypes, caption?: string | null, fileName: string, imagePosition?: number | null, uploadStatus?: FileUploadStatus | null, imageType?: ImageType | null, uuid?: string | null }> | null } | null };

export type ReOrderAssemblyImagesMutationVariables = Exact<{
  input?: InputMaybe<ReOrderImagesInput>;
}>;


export type ReOrderAssemblyImagesMutation = { __typename?: 'Mutation', reOrderAssemblyImages?: Array<{ __typename?: 'File', fileName: string, caption?: string | null, imagePosition?: number | null } | null> | null };

export type UpdatePointOfInterestImageTypeMutationVariables = Exact<{
  input: UpdatePointOfInterestImageTypeInput;
}>;


export type UpdatePointOfInterestImageTypeMutation = { __typename?: 'Mutation', updatePointOfInterestImageType?: { __typename?: 'PointOfInterest', files?: Array<{ __typename?: 'File', id?: string | null, imageType?: ImageType | null }> | null } | null };

export type GetAssemblyForEvaluationQueryVariables = Exact<{
  assemblyId?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetAssemblyForEvaluationQuery = { __typename?: 'Query', assembly?: { __typename?: 'Assembly', templateFieldData?: any | null, area?: number | null } | null };

export type GetAssembliesForEvaluationQueryVariables = Exact<{
  input?: InputMaybe<AssembliesFilterInput>;
  pageInfo?: InputMaybe<PageInfo>;
}>;


export type GetAssembliesForEvaluationQuery = { __typename?: 'Query', getAssembliesByTemplateFieldsFilters: Array<{ __typename?: 'Assembly', id: string, templateFieldData?: any | null, area?: number | null }> };

export type GetAllAssembliesForEvaluationQueryVariables = Exact<{
  input?: InputMaybe<AssembliesFilterInput>;
  pageInfo?: InputMaybe<PageInfo>;
}>;


export type GetAllAssembliesForEvaluationQuery = { __typename?: 'Query', getAssembliesByTemplateFieldsFilters: Array<{ __typename?: 'Assembly', id: string, tagName: string, templateFieldData?: any | null }> };

export type StructureDefectLegendsQueryVariables = Exact<{
  structureId?: InputMaybe<Scalars['String']['input']>;
}>;


export type StructureDefectLegendsQuery = { __typename?: 'Query', structure?: { __typename?: 'Structure', defectLegends: Array<{ __typename?: 'DefectLegend', id: number, groupName: string, groupKey: string, name: string, color: string, octreeKey: OctreeKey, octreeValue: number, legendText?: string | null }> } | null };

export type UpdateReportDataMutationVariables = Exact<{
  input?: InputMaybe<UpdateSingleTemplateFieldDataInput>;
}>;


export type UpdateReportDataMutation = { __typename?: 'Mutation', updateSingleTemplateFieldData?: { __typename?: 'Assembly', templateFieldData?: any | null } | null };

export type PointOfInterestActivitySubscriptionVariables = Exact<{
  structureId: Scalars['ID']['input'];
  assemblyId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type PointOfInterestActivitySubscription = { __typename?: 'Subscription', pointOfInterestActivity: { __typename?: 'PointOfInterest', name?: string | null } };

export type BulkUpdateReviewActionMutationVariables = Exact<{
  input?: InputMaybe<BulkUpdateReviewActionInput>;
}>;


export type BulkUpdateReviewActionMutation = { __typename?: 'Mutation', bulkUpdateReviewAction?: { __typename?: 'BulkUpdateReviewActionResponse', count?: number | null } | null };

export type AllCommentsForRiskAssessmentQueryVariables = Exact<{
  input?: InputMaybe<AllCommentsInput>;
}>;


export type AllCommentsForRiskAssessmentQuery = { __typename?: 'Query', allComments?: Array<{ __typename?: 'Comment', id: string, text: string, structureId: any, title?: string | null, updatedAt: string, collectionName: string, key?: string | null, createdByUser: { __typename?: 'User', picture?: string | null, name?: string | null } }> | null };

export type UpdateCommentMutationVariables = Exact<{
  input: UpdateCommentInput;
}>;


export type UpdateCommentMutation = { __typename?: 'Mutation', updateComment: { __typename?: 'Comment', id: string, text: string, title?: string | null, updatedAt: string } };

export type UpdateRiskAssessmentTemplateFieldDataForAssembliesMutationVariables = Exact<{
  input: UpdateRiskAssessmentTemplateFieldDataForAssembliesInput;
}>;


export type UpdateRiskAssessmentTemplateFieldDataForAssembliesMutation = { __typename?: 'Mutation', updateRiskAssessmentTemplateFieldDataForAssemblies?: Array<{ __typename?: 'Assembly', id: string, tagName: string, templateFieldData?: any | null } | null> | null };

export type UpdateAssembliesProbabilityOfFailureRiskFactorsMutationVariables = Exact<{
  input: UpdateTemplateFieldDataPofInput;
}>;


export type UpdateAssembliesProbabilityOfFailureRiskFactorsMutation = { __typename?: 'Mutation', updateAssembliesProbabilityOfFailureRiskFactors?: Array<{ __typename?: 'Assembly', id: string, tagName: string, templateFieldData?: any | null } | null> | null };

export type GetAssembliesRiskAssessmentSummaryQueryVariables = Exact<{
  input?: InputMaybe<RiskAssessmentSummaryInput>;
}>;


export type GetAssembliesRiskAssessmentSummaryQuery = { __typename?: 'Query', getAssembliesRiskAssessmentSummary: Array<{ __typename?: 'RiskAssessmentSummary', key?: string | null, values?: Array<{ __typename?: 'RiskType', count?: number | null, value?: string | null } | null> | null } | null> };

export type StructureForRiskAssessmentQueryVariables = Exact<{
  structureId?: InputMaybe<Scalars['String']['input']>;
}>;


export type StructureForRiskAssessmentQuery = { __typename?: 'Query', structure?: { __typename?: 'Structure', id: string, name: string, type: StructureTypes, hasRiskAssessment?: boolean | null, esSheetStatus?: EsSheetStatus | null, isLegacyEquipmentStrategy?: boolean | null, template?: { __typename?: 'Template', id: string } | null, templateData?: Array<{ __typename?: 'TemplateData', id: string, value?: any | null, templateFieldId?: string | null }> | null } | null };

export type AllAssemblyTemplatesForRiskAssessmentQueryVariables = Exact<{
  structureId?: InputMaybe<Scalars['ID']['input']>;
  type?: InputMaybe<TemplateTypeEnum>;
}>;


export type AllAssemblyTemplatesForRiskAssessmentQuery = { __typename?: 'Query', allTemplates: Array<{ __typename?: 'Template', name: string, id: string, fields: Array<{ __typename?: 'AssemblyTemplateField', id: string, name: string, key?: string | null, type: TemplateFieldTypeEnum, metaData?: any | null, enableInlineEdit?: boolean | null, options: Array<string>, permission?: string | null, displayInQuery?: boolean | null, displayInTable?: boolean | null, displayInRisk?: boolean | null, displayInReview?: boolean | null, displayInReports?: boolean | null, roundToDecimal?: number | null, unit?: UnitsEnum | null, displayUnit?: UnitsEnum | null, isExportable?: boolean | null, displayConfig?: { __typename?: 'DisplayConfig', id: string, type: TableCellStyleEnum, isSortable: boolean, sortType: SortTypeEnum, textFormat?: TextFormatEnum | null, color?: Array<{ __typename?: 'DisplayColor', key: string, value: string } | null> | null } | null, optionsData?: Array<{ __typename?: 'OptionData', value: string, min?: number | null, max?: number | null }> | null }>, riskFields?: Array<{ __typename?: 'RiskFields', type: Array<RiskFieldsTypeEnum | null>, isHiddenColumn: boolean, id: string, fieldKey: string }> | null }> };

export type GetTemplateByTypeQueryVariables = Exact<{
  structureId: Scalars['ID']['input'];
  type: TemplateTypeEnum;
}>;


export type GetTemplateByTypeQuery = { __typename?: 'Query', allTemplates: Array<{ __typename?: 'Template', id: string, name: string, fields: Array<{ __typename?: 'AssemblyTemplateField', options: Array<string>, name: string, type: TemplateFieldTypeEnum, id: string, key?: string | null, isHidden?: boolean | null, isReadOnly: boolean }> }> };

export type GetAssembliesByRiskAssessmentFiltersQueryVariables = Exact<{
  input: RiskAssessmentFiltersInput;
  pageInfo?: InputMaybe<PageInfo>;
}>;


export type GetAssembliesByRiskAssessmentFiltersQuery = { __typename?: 'Query', getAssembliesByRiskAssessmentFilters: Array<{ __typename?: 'Assembly', id: string, tagName: string, templateFieldData?: any | null, isUncontextualized?: boolean | null, decks?: Array<{ __typename?: 'DecksDetails', deckId: { __typename?: 'Deck', id: string } } | null> | null }>, getRiskAssembliesCount?: { __typename?: 'Count', count: number } | null };

export type GetDependentRiskAssessmentOptionsQueryVariables = Exact<{
  input?: InputMaybe<RiskAssessmentFiltersInput>;
}>;


export type GetDependentRiskAssessmentOptionsQuery = { __typename?: 'Query', getDependentRiskAssessmentOptions?: Array<{ __typename?: 'RiskAssessmentDependentOptions', key?: string | null, options?: Array<string | null> | null } | null> | null };

export type CreateRiskAssessmentDetailsMutationVariables = Exact<{
  input?: InputMaybe<CreateRiskAssessmentDetailsInput>;
}>;


export type CreateRiskAssessmentDetailsMutation = { __typename?: 'Mutation', createRiskAssessmentDetails?: { __typename?: 'Structure', id: string, name: string, type: StructureTypes, hasRiskAssessment?: boolean | null, template?: { __typename?: 'Template', id: string } | null, templateData?: Array<{ __typename?: 'TemplateData', id: string, value?: any | null, templateFieldId?: string | null }> | null } | null };

export type GetAssemblyForTaskModalQueryVariables = Exact<{
  assemblyId?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetAssemblyForTaskModalQuery = { __typename?: 'Query', assembly?: { __typename?: 'Assembly', templateFieldData?: any | null } | null };

export type UpdateRiskAssessmentTemplateFieldDataAndTransitionPeriodMutationVariables = Exact<{
  input: UpdateRiskAssessmentTemplateFieldDataForAssembliesInput;
}>;


export type UpdateRiskAssessmentTemplateFieldDataAndTransitionPeriodMutation = { __typename?: 'Mutation', updateRiskAssessmentTemplateFieldDataAndTransitionPeriod?: { __typename?: 'UpdateRiskAssessmentTemplateFieldDataAndTransitionPeriod', invalidDamageClassCount?: number | null, calculatedTransitionPeriod?: { __typename?: 'TransitionPeriodType', transitionPeriod?: number | null, nextDate: string, futureDate: string } | null } | null };

export type GetMaterialTemplateByTypeQueryVariables = Exact<{
  structureId: Scalars['ID']['input'];
  type: TemplateTypeEnum;
}>;


export type GetMaterialTemplateByTypeQuery = { __typename?: 'Query', allTemplates: Array<{ __typename?: 'Template', materialType?: Array<{ __typename?: 'MaterialType', type: string, thickness?: Array<string | null> | null, corrosivityCategory?: Array<{ __typename?: 'CorrosivityCategoryItem', name: string, values: any }> | null, environmentalClassification?: Array<{ __typename?: 'EnvironmentalClassificationItem', name: string, values: any }> | null, environmentalExposure?: Array<{ __typename?: 'EnvironmentalExposureItem', name: string, code: string, timeToVisibility: number }> | null } | null> | null }> };

export type BulkCreateCommentsForAssembliesMutationVariables = Exact<{
  input?: InputMaybe<BulkCreateForAssembliesInput>;
}>;


export type BulkCreateCommentsForAssembliesMutation = { __typename?: 'Mutation', bulkCreateCommentsForAssemblies?: { __typename?: 'BulkCreateOrUpdateCommentsForAssemblies', modifiedCount: number, insertedCount: number, upsertedCount: number } | null };

export type GetUnpublishedSummarySheetCountsQueryVariables = Exact<{
  input?: InputMaybe<SummarySheetGraphsCountInput>;
  structureId?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetUnpublishedSummarySheetCountsQuery = { __typename?: 'Query', getSummarySheetGraphsCount?: Array<{ __typename?: 'SummarySheetGraphsCount', count?: number | null, key?: string | null } | null> | null, getRiskAssessmentSummaryCounts?: { __typename?: 'RiskAssessmentSummaryCounts', cofCalculated?: number | null, pofCalculated?: number | null, totalAssemblies?: number | null, transitionPeriodCalculated?: number | null } | null };

export type GetPublishedSummarySheetCountsQueryVariables = Exact<{
  SHEInput?: InputMaybe<SummarySheetGraphsCountInput>;
  financialsInput?: InputMaybe<SummarySheetGraphsCountInput>;
  structureId?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetPublishedSummarySheetCountsQuery = { __typename?: 'Query', governingSHEData?: Array<{ __typename?: 'SummarySheetGraphsCount', count?: number | null, key?: string | null } | null> | null, governingFinancialData?: Array<{ __typename?: 'SummarySheetGraphsCount', count?: number | null, key?: string | null } | null> | null, calculationCounts?: { __typename?: 'RiskAssessmentSummaryCounts', cofCalculated?: number | null, pofCalculated?: number | null, totalAssemblies?: number | null, transitionPeriodCalculated?: number | null } | null };

export type GetRiskAssessmentSummaryDataQueryVariables = Exact<{
  input?: InputMaybe<RiskAssessmentSummaryDataInput>;
}>;


export type GetRiskAssessmentSummaryDataQuery = { __typename?: 'Query', getRiskAssessmentSummaryData?: Array<{ __typename?: 'RiskAssessmentSummaryData', _id?: string | null, completedCalculationsCount?: number | null, level1Component?: string | null, totalCalculationsCount?: number | null, damageClassCount?: Array<{ __typename?: 'DamageClassCountType', count?: number | null, key?: string | null } | null> | null } | null> | null };

export type GetRiskAssessmentSummaryTableDataQueryVariables = Exact<{
  input?: InputMaybe<RiskAssessmentSummaryTableDataInput>;
}>;


export type GetRiskAssessmentSummaryTableDataQuery = { __typename?: 'Query', getRiskAssessmentSummaryTableData: Array<{ __typename?: 'RiskAssessmentSummaryTableData', risk_level_1_component: string, risk_level_2_component: string, risk_structure: string, risk_damage_class: string, calculations: { __typename?: 'Calculations', cof: number, pof: number, total: number, transitionPeriod: number } }> };

export type UpdateEsSheetStatusMutationVariables = Exact<{
  structureId: Scalars['String']['input'];
  status: EsSheetStatus;
}>;


export type UpdateEsSheetStatusMutation = { __typename?: 'Mutation', updateEsSheetStatus: { __typename?: 'Structure', id: string, name: string, esSheetStatus?: EsSheetStatus | null } };

export type GetAssemblyDataForInsightsQueryVariables = Exact<{
  assemblyId?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetAssemblyDataForInsightsQuery = { __typename?: 'Query', assembly?: { __typename?: 'Assembly', id: string, templateFieldData?: any | null, focalPoint?: { __typename?: 'Vector3', x: number, y: number, z: number } | null, seenByViewpoints?: Array<{ __typename?: 'SeenByViewpoint', distance?: number | null, location: { __typename?: 'Location', id: string, name: string }, corrosion?: { __typename?: 'Corrosion', primaryCategory?: string | null } | null }> | null } | null };

export type GetAssembliesByTemplateFieldsFiltersForAitInsightsQueryVariables = Exact<{
  input?: InputMaybe<AssembliesFilterInput>;
}>;


export type GetAssembliesByTemplateFieldsFiltersForAitInsightsQuery = { __typename?: 'Query', getAssembliesByTemplateFieldsFilters: Array<{ __typename?: 'Assembly', id: string, tagName: string, corrosionLevel?: string | null, isUncontextualized?: boolean | null, recommendation?: { __typename?: 'Recommendation', analysisStatus?: RecommendationStatus | null, governingValue?: { __typename?: 'GoverningValueRecommendation', calculations?: { __typename?: 'GoverningValueBlister', residualCorrosionAllowancePercentage: number, residualCorrosionAllowance: number } | null } | null, analysisRecommendation?: { __typename?: 'AlarmLevelRecommendation', alarmLevel: AlarmLevels, recommendationByUserName?: string | null, wasAnalysisAlarmLevelManuallySet?: boolean | null } | null } | null, service?: { __typename?: 'Service', code?: string | null, group: string } | null }> };

export type MarkViewPointAsAnalysedFromCurrentAssemblyMutationVariables = Exact<{
  input?: InputMaybe<MarkViewPointAsAnalysedFromCurrentAssemblyInput>;
}>;


export type MarkViewPointAsAnalysedFromCurrentAssemblyMutation = { __typename?: 'Mutation', markViewPointAsAnalysedFromCurrentAssembly?: { __typename?: 'Assembly', id: string, seenByViewpoints?: Array<{ __typename?: 'SeenByViewpoint', location: { __typename?: 'Location', id: string }, analysed?: { __typename?: 'Analysed', analysedBy: string, updatedAt: string } | null }> | null } | null };

export type GetAllLocationInStructureQueryVariables = Exact<{
  structureId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type GetAllLocationInStructureQuery = { __typename?: 'Query', allLocations: Array<{ __typename?: 'Location', id: string, name: string }> };

export type AssemblyQueryVariables = Exact<{
  assemblyId?: InputMaybe<Scalars['String']['input']>;
}>;


export type AssemblyQuery = { __typename?: 'Query', assembly?: { __typename?: 'Assembly', id: string, tagName: string } | null };

export type PaintRegionQueryVariables = Exact<{
  paintRegionId?: InputMaybe<Scalars['String']['input']>;
}>;


export type PaintRegionQuery = { __typename?: 'Query', paintRegion?: { __typename?: 'PaintRegion', id: string, volume?: { __typename?: 'ComplexPrismVolume', exclusions?: Array<{ __typename?: 'PrismVolume', z_range: Array<number>, xy_polygon: Array<Array<number>> }> | null, inclusion: { __typename?: 'PrismVolume', xy_polygon: Array<Array<number>>, z_range: Array<number> } } | null } | null };

export type UpdatePointOfInterestLocationMutationVariables = Exact<{
  input: UpdatePointOfInterestLocationInput;
}>;


export type UpdatePointOfInterestLocationMutation = { __typename?: 'Mutation', updatePointOfInterestLocation?: { __typename?: 'PointOfInterest', id: string, type: string, status?: string | null, isVerified?: boolean | null, createdAt: string, name?: string | null, poiId?: string | null, isManuallyCreated?: boolean | null, isAutoGenerated?: boolean | null, templateFieldData?: any | null, visibility?: VisibilityEnum | null, comment?: string | null, accessibility?: PoiAccessibilityEnum | null, paintRegion?: { __typename?: 'PaintRegion', id: string, name: string } | null, template?: { __typename?: 'PointOfInterestTemplate', id: string, name: string, fields: Array<{ __typename?: 'PointOfInterestTemplateField', id: string, unit?: UnitsEnum | null, name: string, type: TemplateFieldTypeEnum }> } | null, centerPoint3d?: { __typename?: 'Vector3', x: number, y: number, z: number } | null, assembly: { __typename?: 'Assembly', id: string, tagName: string }, blister?: { __typename?: 'Blister', maxHeight?: number | null, heightType?: BlisterHeightType | null, pdrHeight?: number | null, estimatedHeight: number, isManuallyOverridden?: boolean | null, verifiedMaxHeight?: string | null, verifiedResidualThickness?: string | null, borders3d: Array<{ __typename?: 'Polygon3d', points: Array<{ __typename?: 'Vector3', x: number, y: number, z: number }> }>, wallLoss?: { __typename?: 'ValueAndPercentage', percentage: number, value: number } | null, residualCorrosionAllowance?: { __typename?: 'ValueAndPercentage', percentage: number, value: number } | null, residualThickness?: { __typename?: 'ValueAndPercentage', percentage: number, value: number } | null } | null } | null };

export type GetStructureForInspectionDataLoaderQueryVariables = Exact<{
  structureId: Scalars['String']['input'];
}>;


export type GetStructureForInspectionDataLoaderQuery = { __typename?: 'Query', structure?: { __typename?: 'Structure', id: string, octreeResourcesPath: string, nodesPerAssemblyPath?: string | null, hasRiskAssessment?: boolean | null, hasRGB?: boolean | null, structureRelationshipPath?: string | null, assemblyCadModelsBasePath?: string | null, photogrammetryTilesPath?: string | null, voxelLocationsPath?: string | null, voxelSize?: number | null, blisterHeightType?: BlisterHeightType | null, largeVoxelSize?: number | null, defectLegends: Array<{ __typename?: 'DefectLegend', id: number, groupName: string, groupKey: string, name: string, color: string, octreeKey: OctreeKey, octreeValue: number, legendText?: string | null }>, partLegends?: Array<{ __typename?: 'PartLegend', name: string, color: string }> | null, config?: { __typename?: 'StructureConfig', northRotation?: number | null, disableClickOnHiddenPoints?: boolean | null, spatialHeatmapStep?: { __typename?: 'SpatialHeatmapStep', x: number, y: number, z: number } | null, neighbouringImagesOptions?: { __typename?: 'NeighbouringImagesOptions', showFrames?: boolean | null, showImages?: boolean | null, isEnabledByDefault?: boolean | null, maxImagesToShow?: number | null, defaultMeanDistance?: number | null } | null } | null } | null };

export type GetStructureLocationsForInspectionDataLoaderQueryVariables = Exact<{
  structureId: Scalars['ID']['input'];
}>;


export type GetStructureLocationsForInspectionDataLoaderQuery = { __typename?: 'Query', allLocations: Array<{ __typename?: 'Location', id: string, name: string, resourcePath?: string | null, baseResourcePath?: string | null, angleResourcePath?: string | null, scanKey?: string | null, distance?: number | null, videoResourcePath?: string | null, videoTimestamp?: number | null, layers?: Array<{ __typename?: 'LocationLayer', fileExt?: string | null, type: string, displayName: string } | null> | null, paintRegion?: { __typename?: 'PaintRegion', name: string } | null, pose?: { __typename?: 'LocationPose', yaw: number, pitch: number, roll: number, z: number, y: number, x: number, yawOffset: number } | null, imageSensor?: { __typename?: 'ImageSensor', width: number, height: number, cx: number, cy: number, focalLength: number } | null, deck: { __typename?: 'Deck', name: string } }> };

export type GetAllDecksQueryVariables = Exact<{
  structureId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type GetAllDecksQuery = { __typename?: 'Query', allDecks: Array<{ __typename?: 'Deck', cadFloorHeight?: number | null, id: string, name: string }> };

export type GetAllPointOfInterestTemplatesQueryVariables = Exact<{
  structureId: Scalars['ID']['input'];
  assemblyTemplateId: Scalars['ID']['input'];
}>;


export type GetAllPointOfInterestTemplatesQuery = { __typename?: 'Query', allPointOfInterestTemplate: Array<{ __typename?: 'PointOfInterestTemplate', id: string, name: string, type?: PointOfInterestTemplateTypeEnum | null, key?: string | null, isCsvUploadable?: boolean | null, accentColor?: string | null, permissions?: Array<string | null> | null, icon?: { __typename?: 'TemplateIcon', name: string, color?: string | null } | null, fields: Array<{ __typename?: 'PointOfInterestTemplateField', options: Array<string>, name: string, type: TemplateFieldTypeEnum, id: string, isReadOnly: boolean, isHidden?: boolean | null, defaultVisible?: boolean | null, displayInQuery?: boolean | null, displayInTable?: boolean | null, displayInReview?: boolean | null, displayInReports?: boolean | null, serverSide: boolean, isRequired: boolean, key?: string | null, detailFieldKey?: string | null, isMeasurementToolEnabled?: boolean | null, unit?: UnitsEnum | null, optionsData?: Array<{ __typename?: 'OptionData', value: string, weight?: number | null, min?: number | null, max?: number | null, minIncluded?: boolean | null, maxIncluded?: boolean | null }> | null, displayConfig?: { __typename?: 'DisplayConfig', id: string, type: TableCellStyleEnum, isSortable: boolean, sortType: SortTypeEnum, textAreaRows?: number | null, textFormat?: TextFormatEnum | null, inputAdorment?: { __typename?: 'InputAdormentType', iconPath?: string | null, iconType?: InputAdormentIconTypeEnum | null, position?: InputAdormentPositionEnum | null } | null } | null }>, markerLabelConfig?: { __typename?: 'MarkerLabelConfig', type: MarkerLabelConfigTypeEnum, hideName?: boolean | null, fields: Array<{ __typename?: 'MarkerLabelField', key: string, type?: MarkerLabelFieldTypeEnum | null }>, headerField?: { __typename?: 'MarkerLabelField', key: string, type?: MarkerLabelFieldTypeEnum | null } | null } | null, blisterFieldsConfig?: { __typename?: 'BlisterFieldsConfig', estimatedHeight?: { __typename?: 'FieldDetails', name?: string | null, hidden?: boolean | null } | null, manualSetHeight?: { __typename?: 'FieldDetails', name?: string | null, hidden?: boolean | null } | null, blisterHeightIndex?: { __typename?: 'FieldDetails', name?: string | null, hidden?: boolean | null } | null, maxHeight?: { __typename?: 'FieldDetails', name?: string | null, hidden?: boolean | null } | null, wallLoss?: { __typename?: 'FieldDetails', name?: string | null, hidden?: boolean | null } | null, residualThickness?: { __typename?: 'FieldDetails', name?: string | null, hidden?: boolean | null } | null, residualCorrosionAllowance?: { __typename?: 'FieldDetails', name?: string | null, hidden?: boolean | null } | null, pdrHeight?: { __typename?: 'FieldDetails', name?: string | null, hidden?: boolean | null } | null, verifiedMaxHeight?: { __typename?: 'FieldDetails', name?: string | null, hidden?: boolean | null } | null, verifiedResidualThickness?: { __typename?: 'FieldDetails', name?: string | null, hidden?: boolean | null } | null, verifiedResidualCorrosionAllowance?: { __typename?: 'FieldDetails', name?: string | null, hidden?: boolean | null } | null, measurementConfidence?: { __typename?: 'FieldDetails', name?: string | null, hidden?: boolean | null } | null, distanceConfidence?: { __typename?: 'FieldDetails', name?: string | null, hidden?: boolean | null } | null } | null }> };

export type GetAllTemplatesForReportDocumentQueryVariables = Exact<{
  structureId: Scalars['ID']['input'];
  type: TemplateTypeEnum;
}>;


export type GetAllTemplatesForReportDocumentQuery = { __typename?: 'Query', allTemplates: Array<{ __typename?: 'Template', id: string, name: string, permissions?: Array<string | null> | null, fields: Array<{ __typename?: 'AssemblyTemplateField', options: Array<string>, name: string, type: TemplateFieldTypeEnum, id: string, isReadOnly: boolean, isHidden?: boolean | null, defaultVisible?: boolean | null, unit?: UnitsEnum | null, displayConfig?: { __typename?: 'DisplayConfig', id: string, type: TableCellStyleEnum, isSortable: boolean, sortType: SortTypeEnum, textAreaRows?: number | null, textFormat?: TextFormatEnum | null, inputAdorment?: { __typename?: 'InputAdormentType', iconPath?: string | null, iconType?: InputAdormentIconTypeEnum | null, position?: InputAdormentPositionEnum | null } | null } | null }> }> };

export type AllPointsOfInterestForInspectionDataLoaderQueryVariables = Exact<{
  input?: InputMaybe<FindAllPointOfInterestsInput>;
}>;


export type AllPointsOfInterestForInspectionDataLoaderQuery = { __typename?: 'Query', allPointOfInterests: Array<{ __typename?: 'PointOfInterest', id: string, poiId?: string | null, type: string, assignee?: string | null, dueDate?: string | null, status?: string | null, isVerified?: boolean | null, deckRelativeHeight?: number | null, workpackNumber?: string | null, templateId?: string | null, name?: string | null, templateFieldData?: any | null, createdAt: string, visibility?: VisibilityEnum | null, remediationNote?: string | null, comment?: string | null, accessibility?: PoiAccessibilityEnum | null, viewpointRelativeHeight?: number | null, paintRegion?: { __typename?: 'PaintRegion', name: string } | null, template?: { __typename?: 'PointOfInterestTemplate', id: string, fields: Array<{ __typename?: 'PointOfInterestTemplateField', id: string, name: string, type: TemplateFieldTypeEnum }> } | null, location?: { __typename?: 'Location', id: string } | null, centerPoint3d?: { __typename?: 'Vector3', x: number, y: number, z: number } | null, cameraLocation?: { __typename?: 'Vector3', x: number, y: number, z: number } | null, assembly: { __typename?: 'Assembly', id: string, tagName: string }, blister?: { __typename?: 'Blister', maxHeight?: number | null, distanceConfidence?: string | null, measurementConfidence?: string | null, pdrHeight?: number | null, heightType?: BlisterHeightType | null, isManuallyOverridden?: boolean | null, estimatedHeight: number, manualSetHeight?: number | null, radius: number, fittingRadius: number, scCategory?: string | null, wallLoss?: { __typename?: 'ValueAndPercentage', percentage: number, value: number } | null, residualCorrosionAllowance?: { __typename?: 'ValueAndPercentage', percentage: number, value: number } | null, residualThickness?: { __typename?: 'ValueAndPercentage', percentage: number, value: number } | null, centerPoint: { __typename?: 'PolarPoint', bearing: number, elevation: number }, radiusPoint: { __typename?: 'PolarPoint', bearing: number, elevation: number }, borders3d: Array<{ __typename?: 'Polygon3d', points: Array<{ __typename?: 'Vector3', x: number, y: number, z: number }> }> } | null, templateData?: Array<{ __typename?: 'TemplateData', id: string, value?: any | null, verifiedValue?: any | null, templateFieldId?: string | null }> | null, createdByUser?: { __typename?: 'User', id: string, name?: string | null, picture?: string | null, email: string, connection?: string | null, roleIds: Array<{ __typename?: 'Role', name: string } | null> } | null, screenshotPaths?: { __typename?: 'ScreenshotPaths', viewer?: string | null, viewpoint?: string | null } | null, teams: Array<{ __typename?: 'Team', id: string, name: string }>, files?: Array<{ __typename?: 'File', id?: string | null, name: FileNameTypes, resourcePath: string, type: FileTypes, fileName: string, uploadStatus?: FileUploadStatus | null, imageType?: ImageType | null, uuid?: string | null }> | null, cuboids?: Array<{ __typename?: 'PoiCuboid', id: string, position: Array<number>, rotation: Array<number>, scale: Array<number> }> | null }> };

export type AllPointOfInterestsForDataLoaderQueryVariables = Exact<{
  input?: InputMaybe<PointOfInterestInput>;
  pageInfo?: InputMaybe<PageInfo>;
}>;


export type AllPointOfInterestsForDataLoaderQuery = { __typename?: 'Query', pointOfInterests: Array<{ __typename?: 'PointOfInterest', id: string, type: string, name?: string | null, poiId?: string | null, status?: string | null, isVerified?: boolean | null, isGoverning?: boolean | null, createdAt: string, accessibility?: PoiAccessibilityEnum | null, dueDate?: string | null, locationId?: string | null, templateId?: string | null, deckRelativeHeight?: number | null, workpackNumber?: string | null, templateFieldData?: any | null, visibility?: VisibilityEnum | null, viewpointRelativeHeight?: number | null, paintRegion?: { __typename?: 'PaintRegion', name: string, id: string } | null, paintRegions?: Array<{ __typename?: 'PaintRegion', id: string, name: string }> | null, blister?: { __typename?: 'Blister', maxHeight?: number | null, heightType?: BlisterHeightType | null, estimatedHeight: number, pdrHeight?: number | null, isManuallyOverridden?: boolean | null, wallLoss?: { __typename?: 'ValueAndPercentage', percentage: number, value: number } | null, residualCorrosionAllowance?: { __typename?: 'ValueAndPercentage', percentage: number, value: number } | null, residualThickness?: { __typename?: 'ValueAndPercentage', percentage: number, value: number } | null, borders3d: Array<{ __typename?: 'Polygon3d', points: Array<{ __typename?: 'Vector3', x: number, y: number, z: number }> }> } | null, assembly: { __typename?: 'Assembly', id: string, tagName: string }, workpack?: { __typename?: 'Workpack', id: string } | null, centerPoint3d?: { __typename?: 'Vector3', x: number, y: number, z: number } | null, cuboids?: Array<{ __typename?: 'PoiCuboid', id: string, position: Array<number>, rotation: Array<number>, scale: Array<number> }> | null, createdByUser?: { __typename?: 'User', id: string, name?: string | null, picture?: string | null, email: string, connection?: string | null, roleIds: Array<{ __typename?: 'Role', name: string } | null> } | null, location?: { __typename?: 'Location', id: string, name: string } | null, files?: Array<{ __typename?: 'File', id?: string | null, name: FileNameTypes, resourcePath: string, type: FileTypes, fileName: string, uploadStatus?: FileUploadStatus | null, caption?: string | null, imageType?: ImageType | null, uuid?: string | null }> | null, screenshotPaths?: { __typename?: 'ScreenshotPaths', viewer?: string | null, viewpoint?: string | null } | null }> };

export type GetStructureRelationshipsForAnalysisDataLoaderQueryVariables = Exact<{
  structureId: Scalars['String']['input'];
}>;


export type GetStructureRelationshipsForAnalysisDataLoaderQuery = { __typename?: 'Query', allAnnotations: Array<{ __typename?: 'Annotation', id: string, annotationId: number, partId?: string | null, locationId?: string | null }>, allParts: Array<{ __typename?: 'Part', id: string, assemblyId?: string | null, class: string }>, allAssemblies: Array<{ __typename?: 'Assembly', id: string, tagName: string, integerId?: number | null }> };

export type UpdateAssemblyMutationVariables = Exact<{
  input?: InputMaybe<UpdateAssemblyInput>;
}>;


export type UpdateAssemblyMutation = { __typename?: 'Mutation', updateAssembly?: { __typename?: 'Assembly', id: string, templateFieldData?: any | null } | null };

export type GetAssemblyPipeSpecQueryVariables = Exact<{
  assemblyId: Scalars['String']['input'];
}>;


export type GetAssemblyPipeSpecQuery = { __typename?: 'Query', assembly?: { __typename?: 'Assembly', id: string, pipeSpec?: { __typename?: 'PipeSpec', size?: string | null, material?: string | null, spec?: string | null, nominalCorrosionAllowance?: number | null, schedule?: string | null, nominalThickness?: number | null } | null } | null };

export type GetAssemblyAlarmLevelQueryVariables = Exact<{
  assemblyId: Scalars['String']['input'];
}>;


export type GetAssemblyAlarmLevelQuery = { __typename?: 'Query', assembly?: { __typename?: 'Assembly', id: string, recommendation?: { __typename?: 'Recommendation', analysisRecommendation?: { __typename?: 'AlarmLevelRecommendation', alarmLevel: AlarmLevels, wasAnalysisAlarmLevelManuallySet?: boolean | null } | null } | null } | null };

export type FindAssemblyForViewPointsQueryVariables = Exact<{
  assemblyId?: InputMaybe<Scalars['String']['input']>;
}>;


export type FindAssemblyForViewPointsQuery = { __typename?: 'Query', assembly?: { __typename?: 'Assembly', id: string, seenByViewpoints?: Array<{ __typename?: 'SeenByViewpoint', analysed?: { __typename?: 'Analysed', analysedBy: string } | null, location: { __typename?: 'Location', id: string }, focalPoint?: { __typename?: 'Vector3', x: number, y: number, z: number } | null }> | null } | null };

export type PaintBlockTemplateQueryVariables = Exact<{
  structureId?: InputMaybe<Scalars['ID']['input']>;
  type?: InputMaybe<TemplateTypeEnum>;
}>;


export type PaintBlockTemplateQuery = { __typename?: 'Query', allTemplates: Array<{ __typename?: 'Template', id: string, fields: Array<{ __typename?: 'AssemblyTemplateField', id: string, name: string, key?: string | null }> }> };

export type PaintBlockPointsQueryVariables = Exact<{
  paintRegionId?: InputMaybe<Scalars['String']['input']>;
}>;


export type PaintBlockPointsQuery = { __typename?: 'Query', paintRegion?: { __typename?: 'PaintRegion', volume?: { __typename?: 'ComplexPrismVolume', exclusions?: Array<{ __typename?: 'PrismVolume', xy_polygon: Array<Array<number>>, z_range: Array<number> }> | null, inclusion: { __typename?: 'PrismVolume', z_range: Array<number>, xy_polygon: Array<Array<number>> } } | null, files?: Array<{ __typename?: 'File', id?: string | null, name: FileNameTypes, resourcePath: string, type: FileTypes, fileName: string, uploadStatus?: FileUploadStatus | null, imageType?: ImageType | null, uuid?: string | null }> | null } | null };

export type PaintRegionGroupsQueryVariables = Exact<{
  input: PaintRegionGroupFiltersInput;
}>;


export type PaintRegionGroupsQuery = { __typename?: 'Query', paintRegionGroups: Array<{ __typename?: 'PaintRegionGroup', name: string, id: string, isDefault: boolean }> };

export type SavedBlockPoIsQueryVariables = Exact<{
  input?: InputMaybe<PointOfInterestInput>;
  pageInfo?: InputMaybe<PageInfo>;
}>;


export type SavedBlockPoIsQuery = { __typename?: 'Query', pointOfInterests: Array<{ __typename?: 'PointOfInterest', id: string, poiId?: string | null, type: string, name?: string | null, templateFieldData?: any | null, workpackNumber?: string | null, paintRegion?: { __typename?: 'PaintRegion', id: string, deck: { __typename?: 'Deck', id: string, cadTransform: Array<number> } } | null, template?: { __typename?: 'PointOfInterestTemplate', id: string, fields: Array<{ __typename?: 'PointOfInterestTemplateField', id: string, name: string, key?: string | null, type: TemplateFieldTypeEnum, unit?: UnitsEnum | null }> } | null }>, pointOfInterestsCount?: { __typename?: 'Count', count: number } | null };

export type PointOfInterestCuboidsQueryVariables = Exact<{
  pointOfInterestId: Scalars['ID']['input'];
}>;


export type PointOfInterestCuboidsQuery = { __typename?: 'Query', pointOfInterest?: { __typename?: 'PointOfInterest', id: string, status?: string | null, cuboids?: Array<{ __typename?: 'PoiCuboid', id: string, position: Array<number>, rotation: Array<number>, scale: Array<number> }> | null } | null };

export type GetAllAnnotationInLocationQueryVariables = Exact<{
  locationId?: InputMaybe<Scalars['String']['input']>;
  structureId?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetAllAnnotationInLocationQuery = { __typename?: 'Query', allAnnotations: Array<{ __typename?: 'Annotation', annotationId: number, id: string }> };

export type GetAbyssViewerColoursForAnalysisQueryVariables = Exact<{
  type: SettingTypesEnum;
}>;


export type GetAbyssViewerColoursForAnalysisQuery = { __typename?: 'Query', setting?: { __typename?: 'Setting', id: string, name: string, type: SettingTypesEnum, revision: number, meta: Array<{ __typename: 'DefectColorMeta' } | { __typename: 'FloatMeta' } | { __typename: 'IntMeta' } | { __typename: 'StringArrayMeta', key: string, value: Array<string> } | { __typename: 'StringMeta', key: string, colour: string }> } | null };

export type GetDefectColoursQueryVariables = Exact<{
  type: SettingTypesEnum;
}>;


export type GetDefectColoursQuery = { __typename?: 'Query', setting?: { __typename?: 'Setting', id: string, name: string, type: SettingTypesEnum, revision: number, meta: Array<{ __typename: 'DefectColorMeta', key: string, value: Array<{ __typename?: 'DefectColorMetaValue', octreeIndex: number, name: string, colour: string }> } | { __typename: 'FloatMeta' } | { __typename: 'IntMeta' } | { __typename: 'StringArrayMeta' } | { __typename: 'StringMeta' }> } | null };

export type GetAssemblyContextualizedStatusQueryVariables = Exact<{
  assemblyId: Scalars['String']['input'];
}>;


export type GetAssemblyContextualizedStatusQuery = { __typename?: 'Query', assembly?: { __typename?: 'Assembly', id: string, isUncontextualized?: boolean | null } | null };

export type ProcessPdfForPoiMutationVariables = Exact<{
  input: ProcessPdfForPoiInput;
}>;


export type ProcessPdfForPoiMutation = { __typename?: 'Mutation', processPdfForPoi: { __typename?: 'ProcessPdfForPoiResponse', totalProcessed: number, successCount: number, errorCount: number, pointOfInterests: Array<{ __typename?: 'PointOfInterest', id: string, name?: string | null, type: string, status?: string | null, accessibility?: PoiAccessibilityEnum | null, priority?: PoiPriority | null, dueDate?: string | null, assignee?: string | null, comment?: string | null, templateFieldData?: any | null, createdAt: string }>, errors: Array<{ __typename?: 'PdfProcessingError', fileName: string, message: string, code?: string | null }> } };

export type BulkUploadPoisMutationVariables = Exact<{
  input: BulkUploadPoisInput;
}>;


export type BulkUploadPoisMutation = { __typename?: 'Mutation', bulkUploadPois: Array<{ __typename?: 'PointOfInterest', poiId?: string | null }> };

export type ValidateBulkPoiUploadQueryVariables = Exact<{
  input: BulkUploadPoisInput;
}>;


export type ValidateBulkPoiUploadQuery = { __typename?: 'Query', validateBulkPoiUpload: string };

export type GetAllDraftReportsQueryVariables = Exact<{
  input?: InputMaybe<ReportsInput>;
}>;


export type GetAllDraftReportsQuery = { __typename?: 'Query', allReports: Array<{ __typename?: 'Report', id?: string | null, name: string } | null> };

export type CreatePointOfInterestMutationVariables = Exact<{
  input?: InputMaybe<CreatePointOfInterestInput>;
}>;


export type CreatePointOfInterestMutation = { __typename?: 'Mutation', createPointOfInterest?: { __typename?: 'PointOfInterest', id: string, poiId?: string | null, type: string, name?: string | null, templateId?: string | null, locationId?: string | null, createdAt: string, assembly: { __typename?: 'Assembly', id: string, tagName: string }, centerPoint3d?: { __typename?: 'Vector3', x: number, y: number, z: number } | null, blister?: { __typename?: 'Blister', maxHeight?: number | null, estimatedHeight: number, pdrHeight?: number | null, heightType?: BlisterHeightType | null, isManuallyOverridden?: boolean | null, borders3d: Array<{ __typename?: 'Polygon3d', points: Array<{ __typename?: 'Vector3', x: number, y: number, z: number }> }> } | null, cuboids?: Array<{ __typename?: 'PoiCuboid', id: string, position: Array<number>, rotation: Array<number>, scale: Array<number> }> | null } | null };

export type AllAssembliesForCreatePoiQueryVariables = Exact<{
  structureId: Scalars['String']['input'];
  templateId: Scalars['String']['input'];
}>;


export type AllAssembliesForCreatePoiQuery = { __typename?: 'Query', allAssemblies: Array<{ __typename?: 'Assembly', id: string, tagName: string }> };

export type GetStructureDefaultAssemblyQueryVariables = Exact<{
  structureId: Scalars['String']['input'];
}>;


export type GetStructureDefaultAssemblyQuery = { __typename?: 'Query', structure?: { __typename?: 'Structure', id: string, name: string, defaultAssemblyId?: string | null } | null };

export type UpdatePoiGeneralFieldsMutationVariables = Exact<{
  input?: InputMaybe<UpdatePointOfInterestInput>;
}>;


export type UpdatePoiGeneralFieldsMutation = { __typename?: 'Mutation', updatePointOfInterest?: { __typename?: 'PointOfInterest', id: string, cuboids?: Array<{ __typename?: 'PoiCuboid', id: string, position: Array<number>, rotation: Array<number>, scale: Array<number> }> | null } | null };

export type UpdatePoiTemplateFieldsMutationVariables = Exact<{
  input?: InputMaybe<UpdatePointOfInterestInput>;
}>;


export type UpdatePoiTemplateFieldsMutation = { __typename?: 'Mutation', updatePointOfInterest?: { __typename?: 'PointOfInterest', id: string } | null };

export type VerifyPointOfInterestMutationVariables = Exact<{
  input?: InputMaybe<VerifyPointOfInterestInput>;
}>;


export type VerifyPointOfInterestMutation = { __typename?: 'Mutation', verifyPointOfInterest?: { __typename?: 'PointOfInterest', templateFieldData?: any | null, templateData?: Array<{ __typename?: 'TemplateData', verifiedValue?: any | null, value?: any | null, id: string }> | null } | null };

export type ScCategoryOptionsQueryVariables = Exact<{
  structureId: Scalars['ID']['input'];
}>;


export type ScCategoryOptionsQuery = { __typename?: 'Query', scCategoryOptions: Array<string> };

export type UpdateBlisterHeightTypeMutationVariables = Exact<{
  input?: InputMaybe<PerformMechanicalIntegrityServicesInput>;
}>;


export type UpdateBlisterHeightTypeMutation = { __typename?: 'Mutation', performMechanicalIntegrityServices?: { __typename?: 'MechanicalIntegrityServicesResponse', status: string, message?: string | null } | null };

export type UpdateCalculationMethodMutationVariables = Exact<{
  input?: InputMaybe<UpdateCalculationMethodInput>;
}>;


export type UpdateCalculationMethodMutation = { __typename?: 'Mutation', updateCalculationMethod?: { __typename?: 'PointOfInterest', id: string } | null };

export type PoiImageCaptionMutationVariables = Exact<{
  input?: InputMaybe<PoiImageCaptionInput>;
}>;


export type PoiImageCaptionMutation = { __typename?: 'Mutation', poiImageCaption?: string | null };

export type DeletePointOfInterestMutationVariables = Exact<{
  pointOfInterestId: Scalars['ID']['input'];
}>;


export type DeletePointOfInterestMutation = { __typename?: 'Mutation', archivePointOfInterest?: { __typename?: 'PointOfInterest', id: string, type: string } | null };

export type UpdatePointOfInterestMutationVariables = Exact<{
  input?: InputMaybe<UpdatePointOfInterestInput>;
}>;


export type UpdatePointOfInterestMutation = { __typename?: 'Mutation', updatePointOfInterest?: { __typename?: 'PointOfInterest', id: string } | null };

export type StructureForBlisterQueryVariables = Exact<{
  structureId?: InputMaybe<Scalars['String']['input']>;
}>;


export type StructureForBlisterQuery = { __typename?: 'Query', structure?: { __typename?: 'Structure', id: string, wallLossFactor?: number | null, scCategoryMapping?: any | null } | null };

export type UploadAttachmentsToPoiMutationVariables = Exact<{
  input?: InputMaybe<UploadAttachmentsInput>;
}>;


export type UploadAttachmentsToPoiMutation = { __typename?: 'Mutation', uploadAttachmentsToPoi: Array<{ __typename?: 'GeneratedPresignedURL', id: string, url: string, resourcePath: string, uuid: string }> };

export type RemoveAttachmentsFromPoiMutationVariables = Exact<{
  input?: InputMaybe<RemoveAttachmentsInput>;
}>;


export type RemoveAttachmentsFromPoiMutation = { __typename?: 'Mutation', removeAttachmentsFromPoi?: { __typename?: 'PointOfInterest', id: string } | null };

export type UpdatePaintRegionIdMutationVariables = Exact<{
  input?: InputMaybe<UpdatePaintRegionIdInput>;
}>;


export type UpdatePaintRegionIdMutation = { __typename?: 'Mutation', updatePaintRegionId?: Array<{ __typename?: 'PointOfInterest', paintRegion?: { __typename?: 'PaintRegion', id: string, name: string, volume?: { __typename?: 'ComplexPrismVolume', inclusion: { __typename?: 'PrismVolume', xy_polygon: Array<Array<number>>, z_range: Array<number> }, exclusions?: Array<{ __typename?: 'PrismVolume', xy_polygon: Array<Array<number>>, z_range: Array<number> }> | null } | null } | null } | null> | null };

export type FindClosestPaintRegionQueryVariables = Exact<{
  input: FindClosestPaintRegionInput;
}>;


export type FindClosestPaintRegionQuery = { __typename?: 'Query', findClosestPaintRegion: { __typename?: 'FindClosestPaintRegionResult', distance?: number | null, paintRegion?: { __typename?: 'PaintRegion', id: string } | null } };

export type SelectedPoiUpdatedSubscriptionVariables = Exact<{
  poiID?: InputMaybe<Scalars['ID']['input']>;
}>;


export type SelectedPoiUpdatedSubscription = { __typename?: 'Subscription', selectedPointOfInterestUpdated: { __typename?: 'PointOfInterest', id: string, paintRegion?: { __typename?: 'PaintRegion', id: string, name: string } | null, screenshotPaths?: { __typename?: 'ScreenshotPaths', viewer?: string | null, viewpoint?: string | null } | null } };

export type StructureWallLossFactorQueryVariables = Exact<{
  structureId?: InputMaybe<Scalars['String']['input']>;
}>;


export type StructureWallLossFactorQuery = { __typename?: 'Query', structure?: { __typename?: 'Structure', wallLossFactor?: number | null } | null };

export type EvaluateTemplateFieldLogicRuleMutationVariables = Exact<{
  input: EvaluateTemplateFieldLogicRuleInput;
}>;


export type EvaluateTemplateFieldLogicRuleMutation = { __typename?: 'Mutation', evaluateTemplateFieldLogicRule?: { __typename?: 'EvaluateTemplateFieldLogicRuleResult', result: string } | null };

export type WorkscopeDynamicBlockCalculationQueryVariables = Exact<{
  input: DynamicBlockCalculationInput;
}>;


export type WorkscopeDynamicBlockCalculationQuery = { __typename?: 'Query', dynamicBlockCalculation: any };

export type DeletePointOfInterestFromTabMutationVariables = Exact<{
  pointOfInterestId: Scalars['ID']['input'];
}>;


export type DeletePointOfInterestFromTabMutation = { __typename?: 'Mutation', archivePointOfInterest?: { __typename?: 'PointOfInterest', id: string, type: string } | null };

export type SelectedPointOfInterestQueryVariables = Exact<{
  pointOfInterestId: Scalars['ID']['input'];
}>;


export type SelectedPointOfInterestQuery = { __typename?: 'Query', pointOfInterest?: { __typename?: 'PointOfInterest', id: string, templateId?: string | null, type: string, linkedPointOfInterestIds?: Array<string> | null, assignee?: string | null, dueDate?: string | null, status?: string | null, isVerified?: boolean | null, deckRelativeHeight?: number | null, workpackNumber?: string | null, name?: string | null, poiId?: string | null, templateFieldData?: any | null, createdAt: string, visibility?: VisibilityEnum | null, remediationNote?: string | null, comment?: string | null, accessibility?: PoiAccessibilityEnum | null, viewpointRelativeHeight?: number | null, isAutoGenerated?: boolean | null, workpack?: { __typename?: 'Workpack', id: string, name: string, status?: string | null } | null, paintRegion?: { __typename?: 'PaintRegion', id: string, name: string } | null, parentPaintRegionId?: { __typename?: 'PaintRegion', id: string, name: string } | null, template?: { __typename?: 'PointOfInterestTemplate', id: string, fields: Array<{ __typename?: 'PointOfInterestTemplateField', id: string, name: string, type: TemplateFieldTypeEnum }> } | null, location?: { __typename?: 'Location', id: string, name: string } | null, lineMeasurement?: { __typename?: 'PoiLineMeasurement', points?: Array<{ __typename?: 'PoiMeasurementPoint', coordinates: Array<number>, templateFieldId: string } | null> | null } | null, centerPoint3d?: { __typename?: 'Vector3', x: number, y: number, z: number } | null, cameraLocation?: { __typename?: 'Vector3', x: number, y: number, z: number } | null, assembly: { __typename?: 'Assembly', id: string, tagName: string, pipeSpec?: { __typename?: 'PipeSpec', spec?: string | null, size?: string | null, material?: string | null, nominalCorrosionAllowance?: number | null, nominalThickness?: number | null } | null, structure: { __typename?: 'Structure', id: string } }, blister?: { __typename?: 'Blister', maxHeight?: number | null, estimatedHeight: number, blisterHeightIndex?: number | null, pdrHeight?: number | null, heightType?: BlisterHeightType | null, isManuallyOverridden?: boolean | null, verifiedMaxHeight?: string | null, distanceConfidence?: string | null, measurementConfidence?: string | null, verifiedResidualThickness?: string | null, manualSetHeight?: number | null, radius: number, fittingRadius: number, scCategory?: string | null, wallLoss?: { __typename?: 'ValueAndPercentage', percentage: number, value: number } | null, residualCorrosionAllowance?: { __typename?: 'ValueAndPercentage', percentage: number, value: number } | null, residualThickness?: { __typename?: 'ValueAndPercentage', percentage: number, value: number } | null, centerPoint: { __typename?: 'PolarPoint', bearing: number, elevation: number }, radiusPoint: { __typename?: 'PolarPoint', bearing: number, elevation: number }, borders3d: Array<{ __typename?: 'Polygon3d', points: Array<{ __typename?: 'Vector3', x: number, y: number, z: number }> }> } | null, templateData?: Array<{ __typename?: 'TemplateData', id: string, value?: any | null, verifiedValue?: any | null, templateFieldId?: string | null }> | null, createdByUser?: { __typename?: 'User', id: string, name?: string | null, picture?: string | null, email: string, connection?: string | null, roleIds: Array<{ __typename?: 'Role', name: string } | null> } | null, screenshotPaths?: { __typename?: 'ScreenshotPaths', viewer?: string | null, viewpoint?: string | null } | null, teams: Array<{ __typename?: 'Team', id: string, name: string }>, files?: Array<{ __typename?: 'File', id?: string | null, name: FileNameTypes, caption?: string | null, resourcePath: string, type: FileTypes, fileName: string, uploadStatus?: FileUploadStatus | null, imageType?: ImageType | null, uuid?: string | null }> | null, cuboids?: Array<{ __typename?: 'PoiCuboid', id: string, position: Array<number>, rotation: Array<number>, scale: Array<number> }> | null, verifiedByUser?: { __typename?: 'User', email: string } | null } | null };

export type PointOfInterestsQueryVariables = Exact<{
  input?: InputMaybe<PointOfInterestInput>;
  pageInfo?: InputMaybe<PageInfo>;
}>;


export type PointOfInterestsQuery = { __typename?: 'Query', pointOfInterests: Array<{ __typename?: 'PointOfInterest', isGoverning?: boolean | null, id: string, type: string, status?: string | null, isVerified?: boolean | null, templateFieldData?: any | null, name?: string | null, poiId?: string | null, isManuallyCreated?: boolean | null, isAutoGenerated?: boolean | null, visibility?: VisibilityEnum | null, comment?: string | null, accessibility?: PoiAccessibilityEnum | null, createdAt: string, dueDate?: string | null, deckRelativeHeight?: number | null, workpackNumber?: string | null, createdByUser?: { __typename?: 'User', name?: string | null, picture?: string | null, roleIds: Array<{ __typename?: 'Role', name: string } | null> } | null, paintRegion?: { __typename?: 'PaintRegion', id: string, name: string, deck: { __typename?: 'Deck', name: string } } | null, paintRegions?: Array<{ __typename?: 'PaintRegion', id: string, name: string, paintRegionGroup?: { __typename?: 'PaintRegionGroup', id: string, name: string, isDefault: boolean } | null }> | null, parentPaintRegionId?: { __typename?: 'PaintRegion', id: string, name: string } | null, template?: { __typename?: 'PointOfInterestTemplate', id: string, name: string, key?: string | null, fields: Array<{ __typename?: 'PointOfInterestTemplateField', id: string, unit?: UnitsEnum | null, name: string, type: TemplateFieldTypeEnum, key?: string | null, defaultVisible?: boolean | null }> } | null, centerPoint3d?: { __typename?: 'Vector3', x: number, y: number, z: number } | null, assembly: { __typename?: 'Assembly', id: string, tagName: string, structure: { __typename?: 'Structure', id: string } }, location?: { __typename?: 'Location', id: string, name: string } | null, blister?: { __typename?: 'Blister', maxHeight?: number | null, estimatedHeight: number, pdrHeight?: number | null, heightType?: BlisterHeightType | null, isManuallyOverridden?: boolean | null, verifiedMaxHeight?: string | null, verifiedResidualThickness?: string | null, distanceConfidence?: string | null, measurementConfidence?: string | null, centerPoint: { __typename?: 'PolarPoint', bearing: number, elevation: number }, radiusPoint: { __typename?: 'PolarPoint', bearing: number, elevation: number }, wallLoss?: { __typename?: 'ValueAndPercentage', percentage: number, value: number } | null, residualCorrosionAllowance?: { __typename?: 'ValueAndPercentage', percentage: number, value: number } | null, residualThickness?: { __typename?: 'ValueAndPercentage', percentage: number, value: number } | null } | null, screenshotPaths?: { __typename?: 'ScreenshotPaths', viewer?: string | null, viewpoint?: string | null } | null, files?: Array<{ __typename?: 'File', id?: string | null, name: FileNameTypes, resourcePath: string, type: FileTypes, fileName: string, uploadStatus?: FileUploadStatus | null, caption?: string | null, imageType?: ImageType | null, uuid?: string | null }> | null, workpack?: { __typename?: 'Workpack', id: string, name: string, status?: string | null } | null, cuboids?: Array<{ __typename?: 'PoiCuboid', id: string, position: Array<number>, rotation: Array<number>, scale: Array<number> }> | null }>, pointOfInterestsCount?: { __typename?: 'Count', count: number } | null };

export type PointOfInterestsCountQueryVariables = Exact<{
  input?: InputMaybe<PointOfInterestInput>;
}>;


export type PointOfInterestsCountQuery = { __typename?: 'Query', pointOfInterestsCount?: { __typename?: 'Count', count: number } | null };

export type GetNominationCalculationsQueryVariables = Exact<{
  input?: InputMaybe<NominationCalculationsInput>;
}>;


export type GetNominationCalculationsQuery = { __typename?: 'Query', getNominationCalculations?: { __typename?: 'NominationCalculations', alarmLevel: string, governingValue?: { __typename?: 'GoverningValueBlister', height: number, estimatedWallLoss: number, estimatedWallLossPercentage: number, residualCorrosionAllowance: number, residualCorrosionAllowancePercentage: number, residualThickness: number, residualThicknessPercentage: number } | null } | null };

export type NominateGoverningPointOfInterestMutationVariables = Exact<{
  input?: InputMaybe<NominateGoverningPointOfInterestInput>;
}>;


export type NominateGoverningPointOfInterestMutation = { __typename?: 'Mutation', nominateGoverningPointOfInterest?: string | null };

export type GetRecommendationsForAssemblyQueryVariables = Exact<{
  assemblyId: Scalars['String']['input'];
}>;


export type GetRecommendationsForAssemblyQuery = { __typename?: 'Query', assembly?: { __typename?: 'Assembly', id: string, tagName: string, recommendation?: { __typename?: 'Recommendation', governingValue?: { __typename?: 'GoverningValueRecommendation', pointOfInterest?: { __typename?: 'PointOfInterest', id: string } | null, blister?: { __typename?: 'PointOfInterest', id: string, name?: string | null } | null, calculations?: { __typename?: 'GoverningValueBlister', estimatedWallLoss: number, estimatedWallLossPercentage: number, height: number, residualCorrosionAllowance: number, residualCorrosionAllowancePercentage: number, residualThickness: number, residualThicknessPercentage: number } | null } | null } | null, pipeSpec?: { __typename?: 'PipeSpec', size?: string | null, material?: string | null, spec?: string | null, nominalCorrosionAllowance?: number | null, schedule?: string | null, nominalThickness?: number | null } | null } | null };

export type GetOneAssemblyForBlistersQueryVariables = Exact<{
  assemblyId?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetOneAssemblyForBlistersQuery = { __typename?: 'Query', assembly?: { __typename?: 'Assembly', id: string, recommendation?: { __typename?: 'Recommendation', governingValue?: { __typename?: 'GoverningValueRecommendation', pointOfInterest?: { __typename?: 'PointOfInterest', id: string } | null } | null } | null } | null };

export type GetOneAssemblyForDefectsQueryVariables = Exact<{
  assemblyId?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetOneAssemblyForDefectsQuery = { __typename?: 'Query', assembly?: { __typename?: 'Assembly', id: string, tagName: string, recommendation?: { __typename?: 'Recommendation', governingValue?: { __typename?: 'GoverningValueRecommendation', pointOfInterest?: { __typename?: 'PointOfInterest', id: string } | null } | null } | null } | null };

export type MeasureBlisterQueryVariables = Exact<{
  locationId?: InputMaybe<Scalars['String']['input']>;
  blisterMeasurementPoints?: InputMaybe<BlisterMeasurementInput>;
}>;


export type MeasureBlisterQuery = { __typename?: 'Query', fetchBlisterHeightMeasurement?: { __typename?: 'BlisterHeightMeasurement', blister: { __typename?: 'BlisterHeightMeasurementResult', maxHeight: number, blisterProfilePlotPoints: Array<{ __typename?: 'BlisterProfilePlotPoint', x: number, y: number, z: number, height: number }>, fittedSurfacePoints: Array<{ __typename?: 'Point', x: number, y: number, z: number }>, borders3d: Array<{ __typename?: 'Polygon3d', points: Array<{ __typename?: 'Vector3', x: number, y: number, z: number }> }>, centerPoint3d: { __typename?: 'Vector3', x: number, y: number, z: number } }, status: { __typename?: 'MeasurementStatus', cacheStatus: string, fittingRadius?: number | null, targetRadius?: number | null, windowSize: Array<number> } } | null };

export type GetAssemblyPipeSpecByIdQueryVariables = Exact<{
  assemblyId?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetAssemblyPipeSpecByIdQuery = { __typename?: 'Query', assembly?: { __typename?: 'Assembly', id: string, pipeSpec?: { __typename?: 'PipeSpec', material?: string | null, nominalCorrosionAllowance?: number | null, nominalThickness?: number | null, schedule?: string | null, size?: string | null, spec?: string | null } | null } | null };

export type GetAllTeamsForCreateOrEditPoiQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAllTeamsForCreateOrEditPoiQuery = { __typename?: 'Query', allTeams: Array<{ __typename?: 'Team', id: string, name: string }> };

export type DeletePointOfInterestFromCreateOrEditMutationVariables = Exact<{
  pointOfInterestId: Scalars['ID']['input'];
}>;


export type DeletePointOfInterestFromCreateOrEditMutation = { __typename?: 'Mutation', archivePointOfInterest?: { __typename?: 'PointOfInterest', id: string, type: string } | null };

export type SavePointOfInterestScreenshotMutationVariables = Exact<{
  input?: InputMaybe<SavePointOfInterestScreenshotInput>;
}>;


export type SavePointOfInterestScreenshotMutation = { __typename?: 'Mutation', savePointOfInterestScreenshot?: { __typename?: 'PointOfInterest', id: string } | null };

export type UpdatePointOfInterestFileMutationVariables = Exact<{
  input?: InputMaybe<InputUpdateFileForPointOfInterest>;
}>;


export type UpdatePointOfInterestFileMutation = { __typename?: 'Mutation', updatePointOfInterestFile: { __typename?: 'PointOfInterest', id: string } };

export type FetchGenerateImageQueryVariables = Exact<{
  input?: InputMaybe<GenerateImageInput>;
}>;


export type FetchGenerateImageQuery = { __typename?: 'Query', fetchGenerateImage?: { __typename?: 'GenerateImageResult', imageData: string } | null };

export type FetchCropFromRectilinearQueryVariables = Exact<{
  input?: InputMaybe<GenerateCropFromRectilinearInput>;
}>;


export type FetchCropFromRectilinearQuery = { __typename?: 'Query', fetchCropFromRectilinear?: { __typename?: 'GenerateImageResult', imageData: string } | null };

export type GetStructureFeaturesQueryVariables = Exact<{
  structureId: Scalars['String']['input'];
}>;


export type GetStructureFeaturesQuery = { __typename?: 'Query', structure?: { __typename?: 'Structure', id: string, features?: any | null } | null };

export type GetAllAssembliesQueryVariables = Exact<{
  structureId: Scalars['String']['input'];
}>;


export type GetAllAssembliesQuery = { __typename?: 'Query', allAssemblies: Array<{ __typename?: 'Assembly', id: string, tagName: string, service?: { __typename?: 'Service', code?: string | null } | null, recommendation?: { __typename?: 'Recommendation', analysisStatus?: RecommendationStatus | null, analysisRecommendation?: { __typename?: 'AlarmLevelRecommendation', recommendationByUserName?: string | null, alarmLevel: AlarmLevels, supportingComment?: string | null, additionalComments?: string | null, internalTeamComments?: string | null } | null, governingValue?: { __typename?: 'GoverningValueRecommendation', calculations?: { __typename?: 'GoverningValueBlister', height: number, estimatedWallLoss: number, estimatedWallLossPercentage: number, residualCorrosionAllowance: number, residualCorrosionAllowancePercentage: number, residualThickness: number, residualThicknessPercentage: number } | null } | null } | null, pipeSpec?: { __typename?: 'PipeSpec', size?: string | null, spec?: string | null, material?: string | null, nominalCorrosionAllowance?: number | null, schedule?: string | null, nominalThickness?: number | null } | null }>, structure?: { __typename?: 'Structure', name: string } | null };

export type AllPointOfInterestsForStructureQueryVariables = Exact<{
  input?: InputMaybe<FindAllPointOfInterestsInput>;
}>;


export type AllPointOfInterestsForStructureQuery = { __typename?: 'Query', allPointOfInterests: Array<{ __typename?: 'PointOfInterest', type: string, assembly: { __typename?: 'Assembly', id: string } }> };

export type GetAssemblyDetailsQueryVariables = Exact<{
  assemblyId?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetAssemblyDetailsQuery = { __typename?: 'Query', assembly?: { __typename?: 'Assembly', id: string, tagName: string, area?: number | null, generalAttachmentsNote?: string | null, corrosionLevel?: string | null, templateFieldData?: any | null, cadModelPath?: string | null, isUncontextualized?: boolean | null, seenByViewpoints?: Array<{ __typename?: 'SeenByViewpoint', distance?: number | null, location: { __typename?: 'Location', id: string, name: string }, corrosion?: { __typename?: 'Corrosion', primaryCategory?: string | null } | null }> | null, recommendation?: { __typename?: 'Recommendation', analysisRecommendation?: { __typename?: 'AlarmLevelRecommendation', alarmLevel: AlarmLevels } | null } | null, template: { __typename?: 'Template', id: string, name: string, type: TemplateTypeEnum, fields: Array<{ __typename?: 'AssemblyTemplateField', id: string, name: string, type: TemplateFieldTypeEnum, detailFieldKey?: string | null }>, equipmentDetails: Array<{ __typename?: 'EquipmentDetailField', id: string, name: string, subType?: EquipmentDetailSubTypeEnum | null, type: EquipmentDetailTypeEnum, fieldKey: string, options: Array<{ __typename?: 'EquipmentDetailOptionField', id: string, name: string, type: OptionFieldTypeEnum, fieldKey?: string | null }> }> }, box?: { __typename?: 'Box', min: { __typename?: 'Vector3', x: number, y: number, z: number }, max: { __typename?: 'Vector3', x: number, y: number, z: number } } | null, focalPoint?: { __typename?: 'Vector3', x: number, y: number, z: number } | null, cameraPose?: { __typename?: 'AssemblyCameraPose', position: { __typename?: 'Vector3', x: number, y: number, z: number }, lookAt: { __typename?: 'Vector3', x: number, y: number, z: number } } | null, files?: Array<{ __typename?: 'File', id?: string | null, name: FileNameTypes, resourcePath: string, type: FileTypes, caption?: string | null, fileName: string, uploadStatus?: FileUploadStatus | null, imageType?: ImageType | null, uuid?: string | null }> | null, pipeSpec?: { __typename?: 'PipeSpec', size?: string | null, material?: string | null, spec?: string | null, nominalCorrosionAllowance?: number | null, schedule?: string | null, nominalThickness?: number | null } | null } | null };

export type GetAssemblyViewpointsQueryVariables = Exact<{
  assemblyId: Scalars['String']['input'];
}>;


export type GetAssemblyViewpointsQuery = { __typename?: 'Query', assembly?: { __typename?: 'Assembly', id: string, seenByViewpoints?: Array<{ __typename?: 'SeenByViewpoint', location: { __typename?: 'Location', id: string, name: string } }> | null } | null };

export type InlineUpdateSingleAssemblyTemplateFieldDataMutationVariables = Exact<{
  input?: InputMaybe<UpdateSingleTemplateFieldDataInput>;
}>;


export type InlineUpdateSingleAssemblyTemplateFieldDataMutation = { __typename?: 'Mutation', updateSingleTemplateFieldData?: { __typename?: 'Assembly', templateFieldData?: any | null } | null };

export type DefectLegendsForEquipmentQueryVariables = Exact<{
  structureId?: InputMaybe<Scalars['String']['input']>;
}>;


export type DefectLegendsForEquipmentQuery = { __typename?: 'Query', structure?: { __typename?: 'Structure', id: string, defectLegends: Array<{ __typename?: 'DefectLegend', id: number, name: string, groupKey: string, groupName: string, color: string }> } | null };

export type StructureTemplateByTypeQueryVariables = Exact<{
  structureId?: InputMaybe<Scalars['ID']['input']>;
  type?: InputMaybe<TemplateTypeEnum>;
}>;


export type StructureTemplateByTypeQuery = { __typename?: 'Query', allTemplates: Array<{ __typename?: 'Template', id: string, name: string, type: TemplateTypeEnum, fields: Array<{ __typename?: 'AssemblyTemplateField', id: string, name: string, key?: string | null }> }> };

export type ScCategoryMappingQueryVariables = Exact<{
  structureId?: InputMaybe<Scalars['String']['input']>;
}>;


export type ScCategoryMappingQuery = { __typename?: 'Query', structure?: { __typename?: 'Structure', id: string, scCategoryMapping?: any | null } | null };

export type GetStructurePipesQueryVariables = Exact<{
  structureId?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetStructurePipesQuery = { __typename?: 'Query', structure?: { __typename?: 'Structure', structurePipesConfig?: { __typename?: 'StructurePipesConfig', imperialSteelPipes?: any | null } | null } | null };

export type AssemblyTemplateFieldDataQueryVariables = Exact<{
  assemblyId: Scalars['String']['input'];
}>;


export type AssemblyTemplateFieldDataQuery = { __typename?: 'Query', assembly?: { __typename?: 'Assembly', id: string, templateFieldData?: any | null } | null };

export type UpdateScCategoryMutationVariables = Exact<{
  input: UpdateScCategoryInput;
}>;


export type UpdateScCategoryMutation = { __typename?: 'Mutation', updateScCategory?: { __typename?: 'Assembly', templateFieldData?: any | null } | null };

export type DefectPointOfInterestsQueryVariables = Exact<{
  input?: InputMaybe<FindAllPointOfInterestsInput>;
}>;


export type DefectPointOfInterestsQuery = { __typename?: 'Query', allPointOfInterests: Array<{ __typename?: 'PointOfInterest', id: string, poiId?: string | null, type: string, name?: string | null, templateFieldData?: any | null }> };

export type AssemblyGoverningValueQueryVariables = Exact<{
  assemblyId?: InputMaybe<Scalars['String']['input']>;
}>;


export type AssemblyGoverningValueQuery = { __typename?: 'Query', assembly?: { __typename?: 'Assembly', id: string, tagName: string, recommendation?: { __typename?: 'Recommendation', governingValue?: { __typename?: 'GoverningValueRecommendation', pointOfInterest?: { __typename?: 'PointOfInterest', id: string } | null } | null } | null } | null };

export type GetAssemblyTemplateFieldDataQueryVariables = Exact<{
  assemblyId: Scalars['String']['input'];
}>;


export type GetAssemblyTemplateFieldDataQuery = { __typename?: 'Query', assembly?: { __typename?: 'Assembly', id: string, tagName: string, templateFieldData?: any | null } | null };

export type GetAssemblyPointOfInterestsQueryVariables = Exact<{
  input?: InputMaybe<FindAllPointOfInterestsInput>;
}>;


export type GetAssemblyPointOfInterestsQuery = { __typename?: 'Query', allPointOfInterests: Array<{ __typename?: 'PointOfInterest', id: string, poiId?: string | null, type: string, name?: string | null, templateFieldData?: any | null, remediationNote?: string | null, comment?: string | null, deckRelativeHeight?: number | null, accessibility?: PoiAccessibilityEnum | null, viewpointRelativeHeight?: number | null, location?: { __typename?: 'Location', id: string } | null, centerPoint3d?: { __typename?: 'Vector3', x: number, y: number, z: number } | null, cameraLocation?: { __typename?: 'Vector3', x: number, y: number, z: number } | null, assembly: { __typename?: 'Assembly', id: string }, blister?: { __typename?: 'Blister', scCategory?: string | null, estimatedHeight: number, manualSetHeight?: number | null, pdrHeight?: number | null, heightType?: BlisterHeightType | null, isManuallyOverridden?: boolean | null, maxHeight?: number | null, radius: number, fittingRadius: number, distanceConfidence?: string | null, measurementConfidence?: string | null, centerPoint: { __typename?: 'PolarPoint', bearing: number, elevation: number }, radiusPoint: { __typename?: 'PolarPoint', bearing: number, elevation: number }, borders3d: Array<{ __typename?: 'Polygon3d', points: Array<{ __typename?: 'Vector3', x: number, y: number, z: number }> }>, wallLoss?: { __typename?: 'ValueAndPercentage', value: number } | null } | null, files?: Array<{ __typename?: 'File', id?: string | null, name: FileNameTypes, resourcePath: string, type: FileTypes, fileName: string, uploadStatus?: FileUploadStatus | null, imageType?: ImageType | null, uuid?: string | null }> | null }> };

export type UpdateCuiPriorityMutationVariables = Exact<{
  input: UpdateCuiPriorityInput;
}>;


export type UpdateCuiPriorityMutation = { __typename?: 'Mutation', updateCuiPriority?: { __typename?: 'Assembly', templateFieldData?: any | null } | null };

export type GetAssembliesByTemplateFieldsFiltersForEquipmentsTabQueryVariables = Exact<{
  input?: InputMaybe<AssembliesFilterInput>;
}>;


export type GetAssembliesByTemplateFieldsFiltersForEquipmentsTabQuery = { __typename?: 'Query', getAssembliesByTemplateFieldsFilters: Array<{ __typename?: 'Assembly', id: string, tagName: string, templateFieldData?: any | null, isUncontextualized?: boolean | null, box?: { __typename?: 'Box', max: { __typename?: 'Vector3', x: number, y: number, z: number }, min: { __typename?: 'Vector3', x: number, y: number, z: number } } | null }>, getAssembliesCount?: { __typename?: 'Count', count: number } | null };

export type GetAssembliesWithTemplateFieldDataQueryVariables = Exact<{
  input?: InputMaybe<AssembliesFilterInput>;
  pageInfo?: InputMaybe<PageInfo>;
}>;


export type GetAssembliesWithTemplateFieldDataQuery = { __typename?: 'Query', getAssembliesByTemplateFieldsFilters: Array<{ __typename?: 'Assembly', id: string, tagName: string, templateFieldData?: any | null, isUncontextualized?: boolean | null }>, getAssembliesCount?: { __typename?: 'Count', count: number } | null };

export type AllDecksForFilterSideBarQueryVariables = Exact<{
  structureId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type AllDecksForFilterSideBarQuery = { __typename?: 'Query', allDecks: Array<{ __typename?: 'Deck', id: string, name: string }> };

export type AllPaintRegionsQueryVariables = Exact<{
  input?: InputMaybe<FindAllPaintRegionsInput>;
}>;


export type AllPaintRegionsQuery = { __typename?: 'Query', allPaintRegions: Array<{ __typename?: 'PaintRegion', id: string, name: string, deck: { __typename?: 'Deck', id: string } }> };

export type AllAssemblyTemplatesForFilterSideBarQueryVariables = Exact<{
  structureId?: InputMaybe<Scalars['ID']['input']>;
  type?: InputMaybe<TemplateTypeEnum>;
}>;


export type AllAssemblyTemplatesForFilterSideBarQuery = { __typename?: 'Query', allTemplates: Array<{ __typename?: 'Template', name: string, octreeResourcesPath?: string | null, includedTemplateIds?: Array<string> | null, structureRelationshipPath?: string | null, id: string, defectsArray: Array<string>, recommendation?: { __typename?: 'RecommendationField', header: string, details: Array<{ __typename?: 'RecommendationDetailField', id: string, fieldKey: string } | null> } | null, equipmentCard: Array<{ __typename?: 'EquipmentCardField', id: string, name: string, type: EqiupmentCardFieldTypeEnum, position: EquipmentCardPositionEnum, fieldKey?: string | null, location: EquipmentCardLocationEnum }>, equipmentDetails: Array<{ __typename?: 'EquipmentDetailField', id: string, name: string, subType?: EquipmentDetailSubTypeEnum | null, type: EquipmentDetailTypeEnum, fieldKey: string, options: Array<{ __typename?: 'EquipmentDetailOptionField', id: string, name: string, type: OptionFieldTypeEnum, fieldKey?: string | null }> }>, assessmentDetails?: Array<{ __typename?: 'AssessmentDetails', id: string, name: string, type: string, position: number, isVisible: boolean, options: Array<{ __typename?: 'AssessmentDetailOptionFieldSchema', id: string, name: string, type: OptionFieldTypeEnum, fieldKey: string, isEditable: boolean, editRoles: Array<string | null> }> }> | null, reviewPanelConfig?: Array<{ __typename?: 'ReviewPanelConfig', groupKey: string, groupName: string, id: string, groupSection: Array<{ __typename?: 'GroupSection', id: string, title: string, sectionKey: string, fieldKeys: Array<string | null> } | null> }> | null, querySummary?: Array<{ __typename?: 'QuerySummaryItem', name: string, key?: string | null, operation: string }> | null, fields: Array<{ __typename?: 'AssemblyTemplateField', isEditable?: boolean | null, editRoles?: Array<string | null> | null, options: Array<string>, metaData?: any | null, id: string, name: string, key?: string | null, type: TemplateFieldTypeEnum, serverSide: boolean, permission?: string | null, displayInQuery?: boolean | null, isHidden?: boolean | null, displayInTable?: boolean | null, enableInlineEdit?: boolean | null, displayInRisk?: boolean | null, displayInReview?: boolean | null, displayInReports?: boolean | null, displayInReportFilters?: boolean | null, roundToDecimal?: number | null, unit?: UnitsEnum | null, displayUnit?: UnitsEnum | null, isReadOnly: boolean, isRequired: boolean, detailFieldKey?: string | null, displayConfig?: { __typename?: 'DisplayConfig', id: string, type: TableCellStyleEnum, isSortable: boolean, sortType: SortTypeEnum, textFormat?: TextFormatEnum | null, color?: Array<{ __typename?: 'DisplayColor', key: string, value: string } | null> | null } | null, optionsData?: Array<{ __typename?: 'OptionData', value: string, min?: number | null, max?: number | null }> | null }> }> };

export type GetAssembliesByTemplateFieldsFiltersForFilterSideBarQueryVariables = Exact<{
  input?: InputMaybe<AssembliesFilterInput>;
  pageInfo?: InputMaybe<PageInfo>;
}>;


export type GetAssembliesByTemplateFieldsFiltersForFilterSideBarQuery = { __typename?: 'Query', getAssembliesByTemplateFieldsFilters: Array<{ __typename?: 'Assembly', id: string, tagName: string, templateFieldData?: any | null, isUncontextualized?: boolean | null, poiCounts?: Array<{ __typename?: 'PoiTypeCount', poiType: string, count: number }> | null, decks?: Array<{ __typename?: 'DecksDetails', deckId: { __typename?: 'Deck', id: string } } | null> | null }>, getAssembliesCount?: { __typename?: 'Count', count: number } | null };

export type AllWorkpacksForFilterSideBarQueryVariables = Exact<{
  structureId?: InputMaybe<Scalars['String']['input']>;
  hasPois?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type AllWorkpacksForFilterSideBarQuery = { __typename?: 'Query', allWorkpacks: Array<{ __typename?: 'Workpack', id: string, name: string }> };

export type UpdateFileStatusMutationVariables = Exact<{
  input: UpdateFilesStatusInput;
}>;


export type UpdateFileStatusMutation = { __typename?: 'Mutation', updateFilesStatus?: boolean | null };

export type UploadFilesMutationVariables = Exact<{
  input: UploadFileInput;
}>;


export type UploadFilesMutation = { __typename?: 'Mutation', preSignedUrlToUploadFiles: Array<{ __typename?: 'GeneratedPresignedURL', url: string, id: string, resourcePath: string, uuid: string }> };

export type DeleteFilesMutationVariables = Exact<{
  input: DeleteFilesInput;
}>;


export type DeleteFilesMutation = { __typename?: 'Mutation', deleteFiles: { __typename?: 'DeleteFilesPayload', message: string, deletedFiles: Array<string> } };

export type AssemblyImageCaptionMutationVariables = Exact<{
  input: AssemblyImageCaptionInput;
}>;


export type AssemblyImageCaptionMutation = { __typename?: 'Mutation', addAssemblyImageCaption?: string | null };

export type AssemblyAttachmentsGeneralNoteMutationVariables = Exact<{
  input?: InputMaybe<UpdateAssemblyInput>;
}>;


export type AssemblyAttachmentsGeneralNoteMutation = { __typename?: 'Mutation', updateAssembly?: { __typename?: 'Assembly', id: string, generalAttachmentsNote?: string | null } | null };

export type AddUpdateCuboidMutationVariables = Exact<{
  input?: InputMaybe<AddUpdateCuboidInput>;
}>;


export type AddUpdateCuboidMutation = { __typename?: 'Mutation', addUpdateCuboid?: { __typename?: 'Cuboid', id: string, structureId: any, cuboidClassId?: string | null, zoneId?: string | null, position: Array<number>, scale: Array<number>, rotation: Array<number> } | null };

export type DeleteCuboidMutationVariables = Exact<{
  input?: InputMaybe<DeleteCuboidInput>;
}>;


export type DeleteCuboidMutation = { __typename?: 'Mutation', deleteCuboid?: string | null };

export type GetStructureLocationsForAssetLabellingDataLoaderQueryVariables = Exact<{
  structureId: Scalars['ID']['input'];
}>;


export type GetStructureLocationsForAssetLabellingDataLoaderQuery = { __typename?: 'Query', allLocations: Array<{ __typename?: 'Location', id: string, name: string, resourcePath?: string | null, videoResourcePath?: string | null, videoTimestamp?: number | null, pose?: { __typename?: 'LocationPose', yaw: number, pitch: number, roll: number, z: number, y: number, x: number, yawOffset: number } | null, imageSensor?: { __typename?: 'ImageSensor', width: number, height: number, cx: number, cy: number, focalLength: number } | null }> };

export type GetAllLabelAnnotationsQueryVariables = Exact<{
  structureId: Scalars['String']['input'];
}>;


export type GetAllLabelAnnotationsQuery = { __typename?: 'Query', allLabelAnnotations: Array<{ __typename?: 'LabelAnnotation', id: string, labelClassId: any, octreeId: number } | null> };

export type GetStructureForAssetLabellingQueryVariables = Exact<{
  structureId: Scalars['String']['input'];
}>;


export type GetStructureForAssetLabellingQuery = { __typename?: 'Query', structure?: { __typename?: 'Structure', id: string, name: string, octreeResourcesPath: string, hasRGB?: boolean | null, labelClasses?: Array<{ __typename?: 'LabelClass', id: string, name: string, color: string }> | null, cuboidClasses?: Array<{ __typename?: 'LabelClass', id: string, name: string, color: string }> | null } | null };

export type GetAllZonesForAssetLabellingQueryVariables = Exact<{
  structureId: Scalars['String']['input'];
}>;


export type GetAllZonesForAssetLabellingQuery = { __typename?: 'Query', zonesForStructure: Array<{ __typename?: 'Zone', id: string, name: string, status: ZoneStatus, structureId: string, box: { __typename?: 'Box', min: { __typename?: 'Vector3', x: number, y: number, z: number }, max: { __typename?: 'Vector3', x: number, y: number, z: number } }, workflowStatus?: { __typename?: 'WorkflowStatus', workflowStageId: string, state?: ZoneState | null, pausedBy?: PausedBy | null, assignedToUser?: { __typename?: 'User', id: string, name?: string | null, email: string, picture?: string | null, roleIds: Array<{ __typename?: 'Role', name: string, auth0Id: string, id: string } | null> } | null } | null }> };

export type GetCuboidsByZoneIdQueryVariables = Exact<{
  zoneId: Scalars['String']['input'];
}>;


export type GetCuboidsByZoneIdQuery = { __typename?: 'Query', cuboidsByZoneId: Array<{ __typename?: 'Cuboid', id: string, structureId: any, cuboidClassId?: string | null, zoneId?: string | null, position: Array<number>, scale: Array<number>, rotation: Array<number> } | null> };

export type BenchmarkUploadMutationVariables = Exact<{
  input?: InputMaybe<BenchmarkUploadInput>;
}>;


export type BenchmarkUploadMutation = { __typename?: 'Mutation', benchmarkUpload?: { __typename?: 'BenchmarkUploadOutput', size: number } | null };

export type BenchmarkDownloadMutationVariables = Exact<{
  input?: InputMaybe<BenchmarkDownloadInput>;
}>;


export type BenchmarkDownloadMutation = { __typename?: 'Mutation', benchmarkDownload?: { __typename?: 'BenchmarkDownloadOutput', data: string } | null };

export type ValidateEsSheetMutationVariables = Exact<{
  headers: Array<Scalars['String']['input']> | Scalars['String']['input'];
  isLegacy: Scalars['Boolean']['input'];
}>;


export type ValidateEsSheetMutation = { __typename?: 'Mutation', validateEsSheet: string };

export type UploadEsSheetMutationVariables = Exact<{
  input: UploadEsSheetInput;
}>;


export type UploadEsSheetMutation = { __typename?: 'Mutation', uploadEsSheet: string };

export type GetStructureQueryVariables = Exact<{
  structureId?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetStructureQuery = { __typename?: 'Query', structure?: { __typename?: 'Structure', name: string, templateData?: Array<{ __typename?: 'TemplateData', id: string, value?: any | null }> | null } | null };

export type UploadLegacyEsSheetMutationVariables = Exact<{
  input: UploadLegacyEsSheetInput;
}>;


export type UploadLegacyEsSheetMutation = { __typename?: 'Mutation', uploadLegacyEsSheet: string };

export type GetStructureRelationshipsForLabellingInspectionDataLoaderQueryVariables = Exact<{
  structureId: Scalars['String']['input'];
  supervoxelsForStructureInput?: InputMaybe<SupervoxelsForStructureInput>;
}>;


export type GetStructureRelationshipsForLabellingInspectionDataLoaderQuery = { __typename?: 'Query', supervoxelsClassesForStructure: Array<{ __typename?: 'SupervoxelClass', color: string, id: string, name: string, structureId: any }>, supervoxelsForStructure: Array<{ __typename?: 'SuperVoxels', id?: string | null, zoneId: any, structureId: any, supervoxel3DReference: number, supervoxelClassId?: string | null } | null>, structure?: { __typename?: 'Structure', octreeResourcesPath: string } | null };

export type GetStructureLocationsForLabellingInspectionDataLoaderQueryVariables = Exact<{
  structureId: Scalars['ID']['input'];
}>;


export type GetStructureLocationsForLabellingInspectionDataLoaderQuery = { __typename?: 'Query', allLocations: Array<{ __typename?: 'Location', id: string, name: string, resourcePath?: string | null, videoResourcePath?: string | null, videoTimestamp?: number | null, pose?: { __typename?: 'LocationPose', yaw: number, pitch: number, roll: number, z: number, y: number, x: number, yawOffset: number } | null }> };

export type ZonesForStructureForLabellingQueryVariables = Exact<{
  structureId?: InputMaybe<Scalars['String']['input']>;
}>;


export type ZonesForStructureForLabellingQuery = { __typename?: 'Query', zonesForStructure: Array<{ __typename?: 'Zone', id: string, name: string, structureId: string, status: ZoneStatus, box: { __typename?: 'Box', min: { __typename?: 'Vector3', x: number, y: number, z: number }, max: { __typename?: 'Vector3', x: number, y: number, z: number } }, workflowStatus?: { __typename?: 'WorkflowStatus', workflowStageId: string, state?: ZoneState | null, pausedBy?: PausedBy | null, assignedToUser?: { __typename?: 'User', id: string, name?: string | null, email: string, picture?: string | null, roleIds: Array<{ __typename?: 'Role', name: string, auth0Id: string, id: string } | null> } | null } | null }> };

export type UpdateSupervoxelsMutationVariables = Exact<{
  input?: InputMaybe<UpdateSupervoxel>;
}>;


export type UpdateSupervoxelsMutation = { __typename?: 'Mutation', updateSupervoxels: Array<{ __typename?: 'SuperVoxels', id?: string | null, structureId: any, supervoxel3DReference: number, supervoxelClassId?: string | null, zoneId: any }> };

export type GetStructureRelationshipsForTaggingInspectionDataLoaderQueryVariables = Exact<{
  structureId: Scalars['String']['input'];
}>;


export type GetStructureRelationshipsForTaggingInspectionDataLoaderQuery = { __typename?: 'Query', allAnnotations: Array<{ __typename?: 'Annotation', id: string, annotationId: number, locationId?: string | null, partId?: string | null }>, allParts: Array<{ __typename?: 'Part', id: string, assemblyId?: string | null, class: string, isReviewed?: boolean | null, isHidden?: boolean | null, splitCuboids?: Array<{ __typename?: 'SplitCuboid', id: string, assemblyId?: string | null, position: Array<number>, scale: Array<number>, rotation: Array<number>, color: number }> | null }>, allAssemblies: Array<{ __typename?: 'Assembly', id: string, tagName: string, originalTagname?: string | null, superCategory?: string | null, isNewlyAdded?: boolean | null }>, structure?: { __typename?: 'Structure', octreeResourcesPath: string, nodesPerAssemblyPath?: string | null } | null };

export type GetStructureLocationsForTaggingDataLoaderQueryVariables = Exact<{
  structureId: Scalars['ID']['input'];
}>;


export type GetStructureLocationsForTaggingDataLoaderQuery = { __typename?: 'Query', allLocations: Array<{ __typename?: 'Location', id: string, name: string, resourcePath?: string | null, distance?: number | null, videoResourcePath?: string | null, videoTimestamp?: number | null, imageSensor?: { __typename?: 'ImageSensor', width: number, height: number, cx: number, cy: number, focalLength: number } | null, paintRegion?: { __typename?: 'PaintRegion', name: string } | null, pose?: { __typename?: 'LocationPose', yaw: number, pitch: number, roll: number, z: number, y: number, x: number, yawOffset: number } | null }> };

export type PartsAddedToAssemblySubscriptionVariables = Exact<{
  structureId: Scalars['String']['input'];
  userId: Scalars['String']['input'];
}>;


export type PartsAddedToAssemblySubscription = { __typename?: 'Subscription', partsAddedToAssembly: Array<{ __typename?: 'PartsAddedToAssemblyNotification', partId: string, assemblyId?: string | null, assemblyName?: string | null, isReviewed?: boolean | null, zoneId?: string | null, userId: string }> };

export type PartsHiddenFlagUpdatedSubscriptionVariables = Exact<{
  structureId: Scalars['String']['input'];
  userId: Scalars['String']['input'];
}>;


export type PartsHiddenFlagUpdatedSubscription = { __typename?: 'Subscription', partsHiddenFlagUpdated: Array<{ __typename?: 'PartHiddenFlagUpdatedNotification', id: string, isHidden?: boolean | null, isReviewed?: boolean | null, zoneId?: string | null, userId: string }> };

export type PartsReviewedFlagUpdatedSubscriptionVariables = Exact<{
  structureId: Scalars['String']['input'];
  userId: Scalars['String']['input'];
}>;


export type PartsReviewedFlagUpdatedSubscription = { __typename?: 'Subscription', partsReviewedFlagUpdated: Array<{ __typename?: 'PartReviewFlagUpdatedNotification', id: string, isReviewed?: boolean | null, assemblyName?: string | null, zoneId?: string | null, userId: string }> };

export type PartSplitSubscriptionVariables = Exact<{
  structureId: Scalars['String']['input'];
  userId: Scalars['String']['input'];
}>;


export type PartSplitSubscription = { __typename?: 'Subscription', partSplit: { __typename?: 'PartSplitNotification', originalPartId: string, newPartId: string, updatedAnnotationIds: Array<string>, zoneId?: string | null } };

export type AssemblyTagNameAddedSubscriptionVariables = Exact<{
  structureId?: InputMaybe<Scalars['String']['input']>;
}>;


export type AssemblyTagNameAddedSubscription = { __typename?: 'Subscription', assemblyTagNameAdded?: { __typename?: 'AssemblyTagNameAdded', id: string, structureId: string, tagName: string, isNewlyAdded: boolean } | null };

export type SplitCuboidOnPartUpdatedSubscriptionVariables = Exact<{
  structureId?: InputMaybe<Scalars['String']['input']>;
  userId: Scalars['String']['input'];
}>;


export type SplitCuboidOnPartUpdatedSubscription = { __typename?: 'Subscription', splitCuboidOnPartUpdated: Array<{ __typename?: 'AddUpdateSplitCuboidOnPartNotification', partId: string, structureId: string, zoneId?: string | null, splitCuboid: { __typename?: 'SplitCuboid', id: string, assemblyId?: string | null, position: Array<number>, scale: Array<number>, rotation: Array<number>, color: number } }> };

export type SplitCuboidOnPartRemovedSubscriptionVariables = Exact<{
  structureId?: InputMaybe<Scalars['String']['input']>;
  userId: Scalars['String']['input'];
}>;


export type SplitCuboidOnPartRemovedSubscription = { __typename?: 'Subscription', splitCuboidOnPartRemoved: Array<{ __typename?: 'RemoveSplitCuboidOnPartNotification', partId: string, splitCuboidId: string, structureId: string, zoneId?: string | null }> };

export type BulkLineFixingMutationVariables = Exact<{
  input: BulkLineFixingInput;
}>;


export type BulkLineFixingMutation = { __typename?: 'Mutation', bulkLineFixing: { __typename?: 'BulkLineFixingResult', message: string, updatedCount: number } };

export type RevertBulkLineFixingMutationVariables = Exact<{
  input: RevertBulkLineFixingInput;
}>;


export type RevertBulkLineFixingMutation = { __typename?: 'Mutation', revertBulkLineFixing: { __typename?: 'BulkLineFixingResult', message: string, updatedCount: number } };

export type AllPartsQueryVariables = Exact<{
  structureId: Scalars['String']['input'];
}>;


export type AllPartsQuery = { __typename?: 'Query', allParts: Array<{ __typename?: 'Part', id: string, assembly?: { __typename?: 'Assembly', id: string, tagName: string } | null }>, structure?: { __typename?: 'Structure', name: string } | null };

export type GetAbyssViewerColoursForTaggingQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAbyssViewerColoursForTaggingQuery = { __typename?: 'Query', setting?: { __typename?: 'Setting', id: string, name: string, type: SettingTypesEnum, revision: number, meta: Array<{ __typename: 'DefectColorMeta' } | { __typename: 'FloatMeta' } | { __typename: 'IntMeta' } | { __typename: 'StringArrayMeta', key: string, value: Array<string> } | { __typename: 'StringMeta', key: string, colour: string }> } | null };

export type AddUpdateSplitCuboidOnPartMutationVariables = Exact<{
  input?: InputMaybe<AddUpdateSplitCuboidOnPartInput>;
}>;


export type AddUpdateSplitCuboidOnPartMutation = { __typename?: 'Mutation', addUpdateSplitCuboidOnPart: { __typename?: 'AddUpdateSplitCuboidOnPartNotification', partId: string, splitCuboid: { __typename?: 'SplitCuboid', id: string, assemblyId?: string | null, position: Array<number>, scale: Array<number>, rotation: Array<number>, color: number } } };

export type RemoveSplitCuboidOnPartMutationVariables = Exact<{
  input?: InputMaybe<RemoveSplitCuboidOnPartInput>;
}>;


export type RemoveSplitCuboidOnPartMutation = { __typename?: 'Mutation', removeSplitCuboidOnPart: { __typename?: 'RemoveSplitCuboidOnPartNotification', partId: string, splitCuboidId: string } };

export type SplitAnnotationFromPartMutationVariables = Exact<{
  input?: InputMaybe<SplitPartInput>;
}>;


export type SplitAnnotationFromPartMutation = { __typename?: 'Mutation', splitPart: { __typename?: 'Part', id: string, updatedBy?: string | null, assemblyId?: string | null } };

export type GetLocalAnnotationIdQueryVariables = Exact<{
  annotationId: Scalars['String']['input'];
}>;


export type GetLocalAnnotationIdQuery = { __typename?: 'Query', annotation?: { __typename?: 'Annotation', processingReferences?: { __typename?: 'ProcessingReferences', localAnnotationId: number } | null } | null };

export type ZonesForStructureForTaggingQueryVariables = Exact<{
  structureId?: InputMaybe<Scalars['String']['input']>;
}>;


export type ZonesForStructureForTaggingQuery = { __typename?: 'Query', zonesForStructure: Array<{ __typename?: 'Zone', id: string, name: string, status: ZoneStatus, structureId: string, box: { __typename?: 'Box', min: { __typename?: 'Vector3', x: number, y: number, z: number }, max: { __typename?: 'Vector3', x: number, y: number, z: number } } }> };

export type ZoneAndHistoriesForQueryVariables = Exact<{
  structureId?: InputMaybe<Scalars['String']['input']>;
}>;


export type ZoneAndHistoriesForQuery = { __typename?: 'Query', zonesAndHistoriesFor: Array<{ __typename?: 'ZoneAndHistory', _id: string, histories?: Array<{ __typename?: 'History', id: string, createdBy: string, eventName: string, document: any, createdByDetails?: { __typename?: 'CreatedByDetails', name: string, profilePicture: string } | null } | null> | null }> };

export type GetGroupsByPartIdsQueryVariables = Exact<{
  input?: InputMaybe<GroupsByPartIdsInput>;
}>;


export type GetGroupsByPartIdsQuery = { __typename?: 'Query', groupsByPartIds: Array<{ __typename?: 'PartGroup', groupedParts: Array<string> }> };

export type SetHiddenFlagForPartsMutationVariables = Exact<{
  parts?: InputMaybe<UpdatePartsHiddenFlagInput>;
}>;


export type SetHiddenFlagForPartsMutation = { __typename?: 'Mutation', setHiddenForParts: Array<string> };

export type SetReviewedFlagForPartsMutationVariables = Exact<{
  parts?: InputMaybe<UpdatePartsReviewedFlagInput>;
}>;


export type SetReviewedFlagForPartsMutation = { __typename?: 'Mutation', setReviewedForParts: Array<string> };

export type AddPartsToAssemblyInputForDeletePartMutationVariables = Exact<{
  input?: InputMaybe<AddPartsToAssemblyInput>;
}>;


export type AddPartsToAssemblyInputForDeletePartMutation = { __typename?: 'Mutation', addPartsToAssembly: Array<{ __typename?: 'Part', id: string, class: string, updatedBy?: string | null, updatedAt: string, createdAt: string, assembly?: { __typename?: 'Assembly', id: string, tagName: string } | null }> };

export type AllHistoriesQueryVariables = Exact<{
  referenceId?: InputMaybe<Scalars['String']['input']>;
  eventNames?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
}>;


export type AllHistoriesQuery = { __typename?: 'Query', allHistories: Array<{ __typename?: 'History', id: string, collectionName: string, eventName: string, document: any, createdAt: string, createdBy: string, createdByName?: string | null }> };

export type PartQueryVariables = Exact<{
  partId?: InputMaybe<Scalars['String']['input']>;
}>;


export type PartQuery = { __typename?: 'Query', part?: { __typename?: 'Part', id: string, class: string, assembly?: { __typename?: 'Assembly', id: string, tagName: string } | null } | null };

export type AddNewAssemblyTagNameMutationVariables = Exact<{
  input?: InputMaybe<AddNewAssemblyTagNameInput>;
}>;


export type AddNewAssemblyTagNameMutation = { __typename?: 'Mutation', addNewAssemblyTagName?: { __typename?: 'Assembly', id: string, tagName: string } | null };

export type EquipmentClassesForStrunctureQueryVariables = Exact<{
  structureId?: InputMaybe<Scalars['String']['input']>;
}>;


export type EquipmentClassesForStrunctureQuery = { __typename?: 'Query', structure?: { __typename?: 'Structure', equipmentClasses: Array<{ __typename?: 'EquipmentClasses', name: string, classes: Array<{ __typename?: 'Equipment', name: string, code: string }> }> } | null };

export type GetStructureStatusQueryVariables = Exact<{
  structureId?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetStructureStatusQuery = { __typename?: 'Query', structure?: { __typename?: 'Structure', status: StructureStatus } | null };

export type AllStructuresForPlatformsQueryVariables = Exact<{
  input?: InputMaybe<StructureFilters>;
}>;


export type AllStructuresForPlatformsQuery = { __typename?: 'Query', allStructures: Array<{ __typename?: 'Structure', id: string, name: string, status: StructureStatus, coverImagePath: string, deploymentLevel?: StructureDeploymentLevel | null, description: string, octreeResourcesPath: string, category?: string | null, cardInsights?: Array<{ __typename?: 'CardInsights', color?: string | null, name: string, value: any, type: string, visible?: boolean | null }> | null }> };

export type AllRegionsQueryVariables = Exact<{ [key: string]: never; }>;


export type AllRegionsQuery = { __typename?: 'Query', allRegions?: Array<{ __typename?: 'Region', id: string, name: string }> | null };

export type AllStructuresByRegionQueryVariables = Exact<{ [key: string]: never; }>;


export type AllStructuresByRegionQuery = { __typename?: 'Query', allStructuresByRegion: Array<{ __typename?: 'AllStructuresByRegion', id: string, name: string, structures: Array<{ __typename?: 'StructureWithDefects', id: string, name: string, status: StructureStatus, defectArea: Array<{ __typename?: 'DefectArea', key: string, area: number }> }>, defectArea: Array<{ __typename?: 'DefectArea', key: string, area: number }> }>, allDefects: Array<{ __typename?: 'Defect', key: string, name: string }> };

export type StructureDecksWithDefectsQueryVariables = Exact<{
  structureId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type StructureDecksWithDefectsQuery = { __typename?: 'Query', decksWithDefects: Array<{ __typename?: 'DeckWithDefects', id: string, name: string, defectArea: Array<{ __typename?: 'DefectArea', key: string, area: number }> }> };

export type AllUserGroupsForPlatformsQueryVariables = Exact<{ [key: string]: never; }>;


export type AllUserGroupsForPlatformsQuery = { __typename?: 'Query', allUserGroups: Array<{ __typename?: 'UserGroup', id: string, name: string, userIds: Array<string>, createdBy?: string | null, updatedBy?: string | null, createdAt?: string | null, updatedAt?: string | null }> };

export type CreateStructureMutationVariables = Exact<{
  input: CreateStructureInput;
}>;


export type CreateStructureMutation = { __typename?: 'Mutation', createStructure?: { __typename?: 'Structure', id: string } | null };

export type AnalyticsQueryVariables = Exact<{
  input?: InputMaybe<AnalyticsFiltersInput>;
}>;


export type AnalyticsQuery = { __typename?: 'Query', analytics: Array<{ __typename?: 'Analytics', data: any, id: string, structureIds: Array<string>, type: string, displayConfig?: any | null }> };

export type AllPlatformsQueryVariables = Exact<{
  regionId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type AllPlatformsQuery = { __typename?: 'Query', allPlatforms: Array<{ __typename?: 'Platform', id: string, name: string, coverImagePath: string, fleetHealthFilters?: any | null, platformCardInsights?: Array<{ __typename?: 'PlatformCardInsights', name: string, value: string, group: string, filterOptions?: Array<string | null> | null, displayConfig?: { __typename?: 'PlatformCardInsightsDisplayConfig', color?: string | null, divider?: boolean | null, listIndex?: number | null, barIndex?: number | null } | null }> | null, platformSummary?: Array<{ __typename?: 'PlatformCardSummary', name: string, value: string, group: string, displayConfig?: { __typename?: 'PlatformCardInsightsDisplayConfig', color?: string | null, divider?: boolean | null, listIndex?: number | null, barIndex?: number | null } | null }> | null, region?: { __typename?: 'Region', id: string, name: string } | null }> };

export type PlatformQueryVariables = Exact<{
  platformId: Scalars['ID']['input'];
}>;


export type PlatformQuery = { __typename?: 'Query', platform?: { __typename?: 'Platform', id: string, name: string, platformCardInsights?: Array<{ __typename?: 'PlatformCardInsights', name: string, value: string, group: string, displayConfig?: { __typename?: 'PlatformCardInsightsDisplayConfig', color?: string | null } | null }> | null, region?: { __typename?: 'Region', id: string, name: string } | null } | null };

export type AllStructuresForHomePageQueryVariables = Exact<{
  input?: InputMaybe<StructureFilters>;
}>;


export type AllStructuresForHomePageQuery = { __typename?: 'Query', allStructures: Array<{ __typename?: 'Structure', id: string, name: string, isActive?: boolean | null, deploymentLevel?: StructureDeploymentLevel | null, octreeResourcesPath: string, coverImagePath: string, updatedAt: string, status: StructureStatus, scanDate?: string | null, defectLegends: Array<{ __typename?: 'DefectLegend', id: number, name: string, groupKey: string, groupName: string, color: string, octreeKey: OctreeKey, octreeValue: number }> }> };

export type DefectsAreaByPlatformQueryVariables = Exact<{
  platformId: Scalars['ID']['input'];
}>;


export type DefectsAreaByPlatformQuery = { __typename?: 'Query', defectsAreaByStructures: Array<{ __typename?: 'DefectsAreaByStructuresResult', structureId: string, structureName: string, totalArea: Array<{ __typename?: 'AreaAndType', type: string, value: number }> }> };

export type GetAlarmLevelSummaryQueryVariables = Exact<{
  input?: InputMaybe<AlarmLevelSummaryInput>;
}>;


export type GetAlarmLevelSummaryQuery = { __typename?: 'Query', getAlarmLevelSummary?: Array<{ __typename?: 'AlarmLevelSummaryResult', structureId: string, structureName: string, total: Array<{ __typename?: 'TypeAndCount', type?: string | null, count: number }> } | null> | null };

export type PaintRegionAnalyticsByStructuresQueryVariables = Exact<{
  input: PaintRegionAnalyticsInput;
}>;


export type PaintRegionAnalyticsByStructuresQuery = { __typename?: 'Query', paintRegionAnalyticsByStructures: Array<{ __typename?: 'PaintRegionAnalyticsResult', paintRegionName: string, cm?: { __typename?: 'PaintRegionAnalyticsCm', uncalibrated_ri0_area?: number | null, uncalibrated_ri1_area?: number | null, uncalibrated_ri2_area?: number | null, uncalibrated_ri3_area?: number | null, uncalibrated_ri4_area?: number | null, uncalibrated_ri5_area?: number | null, uncalibrated_coating_breakdown_area?: number | null, uncalibrated_total_area?: number | null, calibrated_ri0_area?: number | null, calibrated_ri1_area?: number | null, calibrated_ri2_area?: number | null, calibrated_ri3_area?: number | null, calibrated_ri4_area?: number | null, calibrated_ri5_area?: number | null, calibrated_coating_breakdown_area?: number | null, calibrated_coating_breakdown_score?: number | null, calibrated_total_area?: number | null, total_risk_score?: number | null, remediated_ri0?: number | null, remediated_ri1?: number | null, remediated_ri2?: number | null, remediated_ri3?: number | null, remediated_ri4?: number | null, remediated_ri5?: number | null, total_already_completed?: number | null, actual_total_remediated_area?: number | null } | null, psim?: { __typename?: 'PaintRegionAnalyticsPsim', baseline: Array<{ __typename?: 'PaintRegionAnalyticsPsimRow', cofCategory: string, area?: number | null, totalArea?: number | null, ri0?: number | null, ri1?: number | null, ri2?: number | null, ri3?: number | null, ri4?: number | null, ri5?: number | null, light?: number | null, moderate?: number | null, heavy?: number | null, riskAreaRemediationScore?: number | null, remediatedArea?: number | null }>, remediation: Array<{ __typename?: 'PaintRegionAnalyticsPsimRow', cofCategory: string, area?: number | null, totalArea?: number | null, ri0?: number | null, ri1?: number | null, ri2?: number | null, ri3?: number | null, ri4?: number | null, ri5?: number | null, light?: number | null, moderate?: number | null, heavy?: number | null, riskAreaRemediationScore?: number | null, remediatedArea?: number | null }> } | null }> };

export type SyncAnalyticsDataMutationVariables = Exact<{
  structureIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
  platformId: Scalars['ID']['input'];
}>;


export type SyncAnalyticsDataMutation = { __typename?: 'Mutation', syncAnalyticsData: { __typename?: 'SyncAnalyticsDataResult', success: boolean, message: string } };

export type GetAllStructuresForSystemRequirementQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAllStructuresForSystemRequirementQuery = { __typename?: 'Query', allStructures: Array<{ __typename?: 'Structure', id: string, name: string, octreeResourcesPath: string }> };

export type AllPointOfInterestTemplateQueryVariables = Exact<{
  structureId?: InputMaybe<Scalars['ID']['input']>;
  assemblyTemplateId: Scalars['ID']['input'];
}>;


export type AllPointOfInterestTemplateQuery = { __typename?: 'Query', allPointOfInterestTemplate: Array<{ __typename?: 'PointOfInterestTemplate', id: string, name: string, type?: PointOfInterestTemplateTypeEnum | null, key?: string | null, accentColor?: string | null, permissions?: Array<string | null> | null, icon?: { __typename?: 'TemplateIcon', name: string, color?: string | null } | null, fields: Array<{ __typename?: 'PointOfInterestTemplateField', options: Array<string>, name: string, type: TemplateFieldTypeEnum, id: string, key?: string | null, detailFieldKey?: string | null, isReadOnly: boolean, isHidden?: boolean | null, defaultVisible?: boolean | null, serverSide: boolean, isRequired: boolean, isMeasurementToolEnabled?: boolean | null, displayInReview?: boolean | null, displayInReports?: boolean | null, unit?: UnitsEnum | null, shouldEvaluateLogic?: boolean | null, shouldEvaluateMath?: boolean | null, shouldEvaluateLogicPostCalculation?: boolean | null, optionsData?: Array<{ __typename?: 'OptionData', value: string, weight?: number | null, min?: number | null, max?: number | null, minIncluded?: boolean | null, maxIncluded?: boolean | null }> | null, displayConfig?: { __typename?: 'DisplayConfig', id: string, type: TableCellStyleEnum, isSortable: boolean, sortType: SortTypeEnum, textAreaRows?: number | null, textFormat?: TextFormatEnum | null, inputAdorment?: { __typename?: 'InputAdormentType', iconPath?: string | null, iconType?: InputAdormentIconTypeEnum | null, position?: InputAdormentPositionEnum | null } | null } | null, logicRule?: { __typename?: 'LogicEvaluationRule', description?: string | null, evaluationStrategy: LogicEvaluationStrategy, defaultValue?: string | null, conditionalMappings: Array<{ __typename?: 'ConditionalValueMapping', value: string, combineOperator?: LogicOperator | null, conditionTree: { __typename?: 'ConditionNode', nodeType: ConditionNodeType, inputVariable?: string | null, operator?: ConditionOperator | null, value?: string | null, logicOperator?: LogicOperator | null, conditions?: Array<{ __typename?: 'ConditionNode', nodeType: ConditionNodeType, inputVariable?: string | null, operator?: ConditionOperator | null, value?: string | null, logicOperator?: LogicOperator | null, conditions?: Array<{ __typename?: 'ConditionNode', nodeType: ConditionNodeType, inputVariable?: string | null, operator?: ConditionOperator | null, value?: string | null, logicOperator?: LogicOperator | null, conditions?: Array<{ __typename?: 'ConditionNode', nodeType: ConditionNodeType, inputVariable?: string | null, operator?: ConditionOperator | null, value?: string | null, logicOperator?: LogicOperator | null }> | null }> | null }> | null } }>, variables: Array<{ __typename?: 'Variable', name: string, fieldKey: string, templateType: TemplateTypeEnum, isBlisterField?: boolean | null }> } | null, calculatedBy?: { __typename?: 'LogicEvaluationRule', description?: string | null, evaluationStrategy: LogicEvaluationStrategy, defaultValue?: string | null, conditionalMappings: Array<{ __typename?: 'ConditionalValueMapping', value: string, combineOperator?: LogicOperator | null, conditionTree: { __typename?: 'ConditionNode', nodeType: ConditionNodeType, inputVariable?: string | null, operator?: ConditionOperator | null, value?: string | null, logicOperator?: LogicOperator | null, conditions?: Array<{ __typename?: 'ConditionNode', nodeType: ConditionNodeType, inputVariable?: string | null, operator?: ConditionOperator | null, value?: string | null, logicOperator?: LogicOperator | null, conditions?: Array<{ __typename?: 'ConditionNode', nodeType: ConditionNodeType, inputVariable?: string | null, operator?: ConditionOperator | null, value?: string | null, logicOperator?: LogicOperator | null, conditions?: Array<{ __typename?: 'ConditionNode', nodeType: ConditionNodeType, inputVariable?: string | null, operator?: ConditionOperator | null, value?: string | null, logicOperator?: LogicOperator | null }> | null }> | null }> | null } }>, variables: Array<{ __typename?: 'Variable', name: string, fieldKey: string, templateType: TemplateTypeEnum, isBlisterField?: boolean | null }> } | null }>, markerLabelConfig?: { __typename?: 'MarkerLabelConfig', type: MarkerLabelConfigTypeEnum, hideName?: boolean | null, fields: Array<{ __typename?: 'MarkerLabelField', key: string, type?: MarkerLabelFieldTypeEnum | null }>, headerField?: { __typename?: 'MarkerLabelField', key: string, type?: MarkerLabelFieldTypeEnum | null } | null } | null, blisterFieldsConfig?: { __typename?: 'BlisterFieldsConfig', estimatedHeight?: { __typename?: 'FieldDetails', name?: string | null, hidden?: boolean | null } | null, manualSetHeight?: { __typename?: 'FieldDetails', name?: string | null, hidden?: boolean | null } | null, blisterHeightIndex?: { __typename?: 'FieldDetails', name?: string | null, hidden?: boolean | null } | null, maxHeight?: { __typename?: 'FieldDetails', name?: string | null, hidden?: boolean | null } | null, wallLoss?: { __typename?: 'FieldDetails', name?: string | null, hidden?: boolean | null } | null, residualThickness?: { __typename?: 'FieldDetails', name?: string | null, hidden?: boolean | null } | null, residualCorrosionAllowance?: { __typename?: 'FieldDetails', name?: string | null, hidden?: boolean | null } | null, pdrHeight?: { __typename?: 'FieldDetails', name?: string | null, hidden?: boolean | null } | null, heightType?: { __typename?: 'FieldDetails', name?: string | null, hidden?: boolean | null } | null, verifiedMaxHeight?: { __typename?: 'FieldDetails', name?: string | null, hidden?: boolean | null } | null, verifiedResidualThickness?: { __typename?: 'FieldDetails', name?: string | null, hidden?: boolean | null } | null, verifiedResidualCorrosionAllowance?: { __typename?: 'FieldDetails', name?: string | null, hidden?: boolean | null } | null, measurementConfidence?: { __typename?: 'FieldDetails', name?: string | null, hidden?: boolean | null } | null, distanceConfidence?: { __typename?: 'FieldDetails', name?: string | null, hidden?: boolean | null } | null } | null }> };

export type GetPaintBlockRemediationScoreQueryVariables = Exact<{
  structureId: Scalars['ID']['input'];
  type: TemplateTypeEnum;
}>;


export type GetPaintBlockRemediationScoreQuery = { __typename?: 'Query', allTemplates: Array<{ __typename?: 'Template', id: string, remediationScoreConfig?: { __typename?: 'RemediationScoreConfig', area?: { __typename?: 'RemediationScoreAreaSection', fields?: Array<{ __typename?: 'RemediationScoreAreaField', fieldKey: string, score: number, threshold: number }> | null } | null, cof?: { __typename?: 'RemediationScoreCofSection', fields?: Array<{ __typename?: 'RemediationScoreCofField', fieldKey: string, optionScores: any }> | null } | null, poi?: { __typename?: 'RemediationScorePoiSection', fields?: Array<{ __typename?: 'RemediationScorePoiField', poiScore: number, poiTemplateKey: string, subcategory?: { __typename?: 'RemediationScoreSubcategory', fieldKey: string, optionScores: any } | null }> | null } | null } | null }> };

export type GetAllStructuresListForTemplateBuilderQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAllStructuresListForTemplateBuilderQuery = { __typename?: 'Query', allStructures: Array<{ __typename?: 'Structure', id: string, name: string, coverImagePath: string }> };

export type StructureForTemplateBuilderQueryVariables = Exact<{
  structureId: Scalars['String']['input'];
}>;


export type StructureForTemplateBuilderQuery = { __typename?: 'Query', structure?: { __typename?: 'Structure', id: string, name: string, status: StructureStatus } | null };

export type GetStructureDefectsQueryVariables = Exact<{
  structureId: Scalars['String']['input'];
}>;


export type GetStructureDefectsQuery = { __typename?: 'Query', structure?: { __typename?: 'Structure', id: string, defectLegends: Array<{ __typename?: 'DefectLegend', id: number, groupName: string, groupKey: string, name: string, color: string, octreeKey: OctreeKey, octreeValue: number, legendText?: string | null }> } | null };

export type GetStructureDetailsQueryVariables = Exact<{
  structureId: Scalars['String']['input'];
}>;


export type GetStructureDetailsQuery = { __typename?: 'Query', structure?: { __typename?: 'Structure', id: string, name: string, scanDate?: string | null, coverImagePath: string, isActive?: boolean | null, isWallLossEnabled?: boolean | null, features?: any | null, hasRiskAssessment?: boolean | null, category?: string | null, fleetHealthTemplateField?: string | null, platform?: { __typename?: 'Platform', id: string, name: string } | null, reportConfig?: { __typename?: 'ReportConfig', title: string, id: string, reviewActionTableConfigs?: any | null, poiSummaryChartsConfig?: any | null, paintBlockReportPoiTemplateTypes?: Array<string | null> | null, configurations?: Array<{ __typename?: 'Configurations', id: string, title: string, key: string }> | null, poiReportOperationalTable?: { __typename?: 'PoiOperationalTable', title?: string | null, fields?: Array<{ __typename?: 'ReportOperationalFields', key: string, title: string, visibility: boolean } | null> | null } | null, imageOrientationConfig?: { __typename?: 'ImageOrientationConfig', poiImages?: string | null, deckPlanImages?: string | null, poiReportPoiImages?: string | null, poiReportDeckImages?: string | null, componentReportPoiImages?: string | null, componentReportDeckImages?: string | null } | null } | null, structurePipesConfig?: { __typename?: 'StructurePipesConfig', imperialSteelPipes?: any | null } | null, nominationConfig?: { __typename?: 'NominationConfig', poiTemplateNominationTypes?: Array<string | null> | null, nominationTableConfig?: { __typename?: 'NominationTableConfig', title?: string | null, columns?: Array<{ __typename?: 'TableColumn', key?: string | null, displayName?: string | null } | null> | null } | null } | null } | null };

export type AllTemplatesForBuilderQueryVariables = Exact<{
  type?: InputMaybe<TemplateTypeEnum>;
  structureId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type AllTemplatesForBuilderQuery = { __typename?: 'Query', allTemplates: Array<{ __typename?: 'Template', id: string, name: string, type: TemplateTypeEnum, defectsArray: Array<string>, permissions?: Array<string | null> | null, reviewPanelConfig?: Array<{ __typename?: 'ReviewPanelConfig', groupKey: string, groupName: string, id: string, groupSection: Array<{ __typename?: 'GroupSection', id: string, title: string, sectionKey: string, fieldKeys: Array<string | null> } | null> }> | null, fields: Array<{ __typename?: 'AssemblyTemplateField', id: string, name: string, type: TemplateFieldTypeEnum, options: Array<string>, metaData?: any | null, isRequired: boolean, isReadOnly: boolean, serverSide: boolean, isHidden?: boolean | null, permission?: string | null, isRiskAssessment?: boolean | null, key?: string | null, displayInQuery?: boolean | null, displayInTable?: boolean | null, enableInlineEdit?: boolean | null, displayInReview?: boolean | null, displayInReports?: boolean | null, displayInReportFilters?: boolean | null, displayInRisk?: boolean | null, defaultVisible?: boolean | null, unit?: UnitsEnum | null, roundToDecimal?: number | null, isEditable?: boolean | null, editRoles?: Array<string | null> | null, dependencyMapping?: Array<string | null> | null, displayUnit?: UnitsEnum | null, shouldEvaluateLogic?: boolean | null, shouldEvaluateMath?: boolean | null, shouldEvaluateLogicPostCalculation?: boolean | null, optionsData?: Array<{ __typename?: 'OptionData', value: string, weight?: number | null, min?: number | null, max?: number | null, minIncluded?: boolean | null, maxIncluded?: boolean | null }> | null, displayConfig?: { __typename?: 'DisplayConfig', id: string, type: TableCellStyleEnum, isSortable: boolean, sortType: SortTypeEnum, textAreaRows?: number | null, textFormat?: TextFormatEnum | null, color?: Array<{ __typename?: 'DisplayColor', key: string, value: string } | null> | null, inputAdorment?: { __typename?: 'InputAdormentType', iconPath?: string | null, iconType?: InputAdormentIconTypeEnum | null, position?: InputAdormentPositionEnum | null } | null } | null, logicRule?: { __typename?: 'LogicEvaluationRule', description?: string | null, evaluationStrategy: LogicEvaluationStrategy, defaultValue?: string | null, conditionalMappings: Array<{ __typename?: 'ConditionalValueMapping', value: string, combineOperator?: LogicOperator | null, conditionTree: { __typename?: 'ConditionNode', nodeType: ConditionNodeType, inputVariable?: string | null, operator?: ConditionOperator | null, value?: string | null, logicOperator?: LogicOperator | null, conditions?: Array<{ __typename?: 'ConditionNode', nodeType: ConditionNodeType, inputVariable?: string | null, operator?: ConditionOperator | null, value?: string | null, logicOperator?: LogicOperator | null, conditions?: Array<{ __typename?: 'ConditionNode', nodeType: ConditionNodeType, inputVariable?: string | null, operator?: ConditionOperator | null, value?: string | null, logicOperator?: LogicOperator | null, conditions?: Array<{ __typename?: 'ConditionNode', nodeType: ConditionNodeType, inputVariable?: string | null, operator?: ConditionOperator | null, value?: string | null, logicOperator?: LogicOperator | null }> | null }> | null }> | null } }>, variables: Array<{ __typename?: 'Variable', name: string, fieldKey: string, templateType: TemplateTypeEnum, isBlisterField?: boolean | null }> } | null, calculatedBy?: { __typename?: 'LogicEvaluationRule', description?: string | null, evaluationStrategy: LogicEvaluationStrategy, defaultValue?: string | null, conditionalMappings: Array<{ __typename?: 'ConditionalValueMapping', value: string, combineOperator?: LogicOperator | null, conditionTree: { __typename?: 'ConditionNode', nodeType: ConditionNodeType, inputVariable?: string | null, operator?: ConditionOperator | null, value?: string | null, logicOperator?: LogicOperator | null, conditions?: Array<{ __typename?: 'ConditionNode', nodeType: ConditionNodeType, inputVariable?: string | null, operator?: ConditionOperator | null, value?: string | null, logicOperator?: LogicOperator | null, conditions?: Array<{ __typename?: 'ConditionNode', nodeType: ConditionNodeType, inputVariable?: string | null, operator?: ConditionOperator | null, value?: string | null, logicOperator?: LogicOperator | null, conditions?: Array<{ __typename?: 'ConditionNode', nodeType: ConditionNodeType, inputVariable?: string | null, operator?: ConditionOperator | null, value?: string | null, logicOperator?: LogicOperator | null }> | null }> | null }> | null } }>, variables: Array<{ __typename?: 'Variable', name: string, fieldKey: string, templateType: TemplateTypeEnum, isBlisterField?: boolean | null }> } | null }>, reviewActionChecklistConfig?: Array<{ __typename?: 'ReviewActionChecklistConfig', id: string, reviewActionValue: string, displayName: string, isEnabled: boolean, position: number }> | null, equations?: Array<{ __typename?: 'Equation', key: string, name?: string | null, expression?: { __typename?: 'Expression', type: ExpressionType, value?: number | null, variable?: string | null, operator?: MathOperator | null, args?: Array<{ __typename?: 'Expression', type: ExpressionType, value?: number | null, variable?: string | null, operator?: MathOperator | null, args?: Array<{ __typename?: 'Expression', type: ExpressionType, value?: number | null, variable?: string | null, operator?: MathOperator | null, args?: Array<{ __typename?: 'Expression', type: ExpressionType, value?: number | null, variable?: string | null, operator?: MathOperator | null } | null> | null } | null> | null } | null> | null } | null, variables?: Array<{ __typename?: 'Variable', name: string, fieldKey: string, templateType: TemplateTypeEnum, isBlisterField?: boolean | null }> | null }> | null, equipmentDetails: Array<{ __typename?: 'EquipmentDetailField', id: string, name: string, type: EquipmentDetailTypeEnum, subType?: EquipmentDetailSubTypeEnum | null, isRequired: boolean, isReadOnly: boolean, serverSide: boolean, isHidden?: boolean | null, fieldKey: string, options: Array<{ __typename?: 'EquipmentDetailOptionField', id: string, name: string, type: OptionFieldTypeEnum, fieldKey?: string | null }>, displayConfig?: { __typename?: 'DisplayConfig', id: string, type: TableCellStyleEnum, isSortable: boolean, sortType: SortTypeEnum, textAreaRows?: number | null, textFormat?: TextFormatEnum | null, inputAdorment?: { __typename?: 'InputAdormentType', iconPath?: string | null, iconType?: InputAdormentIconTypeEnum | null, position?: InputAdormentPositionEnum | null } | null, color?: Array<{ __typename?: 'DisplayColor', key: string, value: string } | null> | null } | null }>, icon?: { __typename?: 'TemplateIcon', name: string, color?: string | null } | null, equipmentCard: Array<{ __typename?: 'EquipmentCardField', id: string, name: string, type: EqiupmentCardFieldTypeEnum, fieldKey?: string | null, position: EquipmentCardPositionEnum, location: EquipmentCardLocationEnum }>, riskFields?: Array<{ __typename?: 'RiskFields', id: string, fieldKey: string, type: Array<RiskFieldsTypeEnum | null>, isHiddenColumn: boolean }> | null, recommendation?: { __typename?: 'RecommendationField', header: string, details: Array<{ __typename?: 'RecommendationDetailField', id: string, fieldKey: string } | null> } | null, querySummary?: Array<{ __typename?: 'QuerySummaryItem', id: string, name: string, key?: string | null, operation: string, matchCondition?: any | null, displayType: DisplayType, rowOrder: number, collectionName: string, sortType?: SummaryItemSortType | null, sortDirection?: number | null, displayConfig?: Array<{ __typename?: 'DisplaySettings', fieldValue: string, color: string }> | null }> | null, materialType?: Array<{ __typename?: 'MaterialType', type: string, thickness?: Array<string | null> | null, environmentalClassification?: Array<{ __typename?: 'EnvironmentalClassificationItem', name: string, values: any }> | null, corrosivityCategory?: Array<{ __typename?: 'CorrosivityCategoryItem', name: string, values: any }> | null, environmentalExposure?: Array<{ __typename?: 'EnvironmentalExposureItem', name: string, timeToVisibility: number, code: string }> | null } | null> | null }> };

export type AllPlatformsForTemplateBuilderQueryVariables = Exact<{ [key: string]: never; }>;


export type AllPlatformsForTemplateBuilderQuery = { __typename?: 'Query', allPlatforms: Array<{ __typename?: 'Platform', name: string, id: string }> };

export type GetAllPoiIconsForTemplateBuilderQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAllPoiIconsForTemplateBuilderQuery = { __typename?: 'Query', getAllPoiIcons: Array<string | null> };

export type UpdatePointOfInterestTemplateMutationVariables = Exact<{
  input?: InputMaybe<UpdatePointOfInterestTemplateInput>;
}>;


export type UpdatePointOfInterestTemplateMutation = { __typename?: 'Mutation', updatePointOfInterestTemplate?: { __typename?: 'PointOfInterestTemplate', id: string, name: string, fields: Array<{ __typename?: 'PointOfInterestTemplateField', options: Array<string>, name: string, type: TemplateFieldTypeEnum, id: string, isReadOnly: boolean, isHidden?: boolean | null, defaultVisible?: boolean | null, serverSide: boolean, isRequired: boolean, displayInReview?: boolean | null, displayInReports?: boolean | null, unit?: UnitsEnum | null, shouldEvaluateLogic?: boolean | null, shouldEvaluateMath?: boolean | null, shouldEvaluateLogicPostCalculation?: boolean | null, displayConfig?: { __typename?: 'DisplayConfig', id: string, type: TableCellStyleEnum, isSortable: boolean, sortType: SortTypeEnum, textAreaRows?: number | null, inputAdorment?: { __typename?: 'InputAdormentType', iconPath?: string | null, iconType?: InputAdormentIconTypeEnum | null, position?: InputAdormentPositionEnum | null } | null } | null, logicRule?: { __typename?: 'LogicEvaluationRule', description?: string | null, evaluationStrategy: LogicEvaluationStrategy, defaultValue?: string | null, conditionalMappings: Array<{ __typename?: 'ConditionalValueMapping', value: string, combineOperator?: LogicOperator | null, conditionTree: { __typename?: 'ConditionNode', nodeType: ConditionNodeType, inputVariable?: string | null, operator?: ConditionOperator | null, value?: string | null, logicOperator?: LogicOperator | null, conditions?: Array<{ __typename?: 'ConditionNode', nodeType: ConditionNodeType, inputVariable?: string | null, operator?: ConditionOperator | null, value?: string | null, logicOperator?: LogicOperator | null, conditions?: Array<{ __typename?: 'ConditionNode', nodeType: ConditionNodeType, inputVariable?: string | null, operator?: ConditionOperator | null, value?: string | null, logicOperator?: LogicOperator | null, conditions?: Array<{ __typename?: 'ConditionNode', nodeType: ConditionNodeType, inputVariable?: string | null, operator?: ConditionOperator | null, value?: string | null, logicOperator?: LogicOperator | null }> | null }> | null }> | null } }>, variables: Array<{ __typename?: 'Variable', name: string, fieldKey: string, templateType: TemplateTypeEnum, isBlisterField?: boolean | null }> } | null, calculatedBy?: { __typename?: 'LogicEvaluationRule', description?: string | null, evaluationStrategy: LogicEvaluationStrategy, defaultValue?: string | null, conditionalMappings: Array<{ __typename?: 'ConditionalValueMapping', value: string, combineOperator?: LogicOperator | null, conditionTree: { __typename?: 'ConditionNode', nodeType: ConditionNodeType, inputVariable?: string | null, operator?: ConditionOperator | null, value?: string | null, logicOperator?: LogicOperator | null, conditions?: Array<{ __typename?: 'ConditionNode', nodeType: ConditionNodeType, inputVariable?: string | null, operator?: ConditionOperator | null, value?: string | null, logicOperator?: LogicOperator | null, conditions?: Array<{ __typename?: 'ConditionNode', nodeType: ConditionNodeType, inputVariable?: string | null, operator?: ConditionOperator | null, value?: string | null, logicOperator?: LogicOperator | null, conditions?: Array<{ __typename?: 'ConditionNode', nodeType: ConditionNodeType, inputVariable?: string | null, operator?: ConditionOperator | null, value?: string | null, logicOperator?: LogicOperator | null }> | null }> | null }> | null } }>, variables: Array<{ __typename?: 'Variable', name: string, fieldKey: string, templateType: TemplateTypeEnum, isBlisterField?: boolean | null }> } | null }> } | null };

export type CreatePointOfInterestTemplateMutationVariables = Exact<{
  input?: InputMaybe<PointOfInterestTemplateInput>;
}>;


export type CreatePointOfInterestTemplateMutation = { __typename?: 'Mutation', createPointOfInterestTemplate?: { __typename?: 'PointOfInterestTemplate', id: string, name: string, fields: Array<{ __typename?: 'PointOfInterestTemplateField', options: Array<string>, name: string, type: TemplateFieldTypeEnum, id: string, key?: string | null, isReadOnly: boolean, isHidden?: boolean | null, defaultVisible?: boolean | null, serverSide: boolean, isRequired: boolean, displayInReview?: boolean | null, displayInReports?: boolean | null, unit?: UnitsEnum | null, shouldEvaluateLogic?: boolean | null, shouldEvaluateMath?: boolean | null, shouldEvaluateLogicPostCalculation?: boolean | null, displayConfig?: { __typename?: 'DisplayConfig', id: string, type: TableCellStyleEnum, isSortable: boolean, sortType: SortTypeEnum, textAreaRows?: number | null, inputAdorment?: { __typename?: 'InputAdormentType', iconPath?: string | null, iconType?: InputAdormentIconTypeEnum | null, position?: InputAdormentPositionEnum | null } | null } | null, logicRule?: { __typename?: 'LogicEvaluationRule', description?: string | null, evaluationStrategy: LogicEvaluationStrategy, defaultValue?: string | null, conditionalMappings: Array<{ __typename?: 'ConditionalValueMapping', value: string, combineOperator?: LogicOperator | null, conditionTree: { __typename?: 'ConditionNode', nodeType: ConditionNodeType, inputVariable?: string | null, operator?: ConditionOperator | null, value?: string | null, logicOperator?: LogicOperator | null, conditions?: Array<{ __typename?: 'ConditionNode', nodeType: ConditionNodeType, inputVariable?: string | null, operator?: ConditionOperator | null, value?: string | null, logicOperator?: LogicOperator | null, conditions?: Array<{ __typename?: 'ConditionNode', nodeType: ConditionNodeType, inputVariable?: string | null, operator?: ConditionOperator | null, value?: string | null, logicOperator?: LogicOperator | null, conditions?: Array<{ __typename?: 'ConditionNode', nodeType: ConditionNodeType, inputVariable?: string | null, operator?: ConditionOperator | null, value?: string | null, logicOperator?: LogicOperator | null }> | null }> | null }> | null } }>, variables: Array<{ __typename?: 'Variable', name: string, fieldKey: string, templateType: TemplateTypeEnum, isBlisterField?: boolean | null }> } | null, calculatedBy?: { __typename?: 'LogicEvaluationRule', description?: string | null, evaluationStrategy: LogicEvaluationStrategy, defaultValue?: string | null, conditionalMappings: Array<{ __typename?: 'ConditionalValueMapping', value: string, combineOperator?: LogicOperator | null, conditionTree: { __typename?: 'ConditionNode', nodeType: ConditionNodeType, inputVariable?: string | null, operator?: ConditionOperator | null, value?: string | null, logicOperator?: LogicOperator | null, conditions?: Array<{ __typename?: 'ConditionNode', nodeType: ConditionNodeType, inputVariable?: string | null, operator?: ConditionOperator | null, value?: string | null, logicOperator?: LogicOperator | null, conditions?: Array<{ __typename?: 'ConditionNode', nodeType: ConditionNodeType, inputVariable?: string | null, operator?: ConditionOperator | null, value?: string | null, logicOperator?: LogicOperator | null, conditions?: Array<{ __typename?: 'ConditionNode', nodeType: ConditionNodeType, inputVariable?: string | null, operator?: ConditionOperator | null, value?: string | null, logicOperator?: LogicOperator | null }> | null }> | null }> | null } }>, variables: Array<{ __typename?: 'Variable', name: string, fieldKey: string, templateType: TemplateTypeEnum, isBlisterField?: boolean | null }> } | null }> } | null };

export type PointOfInterestTemplateQueryVariables = Exact<{
  pointOfInterestTemplateId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type PointOfInterestTemplateQuery = { __typename?: 'Query', pointOfInterestTemplate?: { __typename?: 'PointOfInterestTemplate', id: string, name: string, accentColor?: string | null, createdBy?: string | null, permissions?: Array<string | null> | null, icon?: { __typename?: 'TemplateIcon', color?: string | null, name: string } | null, fields: Array<{ __typename?: 'PointOfInterestTemplateField', id: string, name: string, type: TemplateFieldTypeEnum, options: Array<string>, isRequired: boolean, isReadOnly: boolean, serverSide: boolean, displayInReview?: boolean | null, displayInReports?: boolean | null, isHidden?: boolean | null, permission?: string | null, defaultVisible?: boolean | null, unit?: UnitsEnum | null, key?: string | null, shouldEvaluateLogic?: boolean | null, shouldEvaluateMath?: boolean | null, shouldEvaluateLogicPostCalculation?: boolean | null, displayConfig?: { __typename?: 'DisplayConfig', id: string, type: TableCellStyleEnum, textAreaRows?: number | null, isSortable: boolean, sortType: SortTypeEnum, color?: Array<{ __typename?: 'DisplayColor', key: string, value: string } | null> | null, inputAdorment?: { __typename?: 'InputAdormentType', position?: InputAdormentPositionEnum | null, iconPath?: string | null, iconType?: InputAdormentIconTypeEnum | null } | null } | null, logicRule?: { __typename?: 'LogicEvaluationRule', description?: string | null, evaluationStrategy: LogicEvaluationStrategy, defaultValue?: string | null, conditionalMappings: Array<{ __typename?: 'ConditionalValueMapping', value: string, combineOperator?: LogicOperator | null, conditionTree: { __typename?: 'ConditionNode', nodeType: ConditionNodeType, inputVariable?: string | null, operator?: ConditionOperator | null, value?: string | null, logicOperator?: LogicOperator | null, conditions?: Array<{ __typename?: 'ConditionNode', nodeType: ConditionNodeType, inputVariable?: string | null, operator?: ConditionOperator | null, value?: string | null, logicOperator?: LogicOperator | null, conditions?: Array<{ __typename?: 'ConditionNode', nodeType: ConditionNodeType, inputVariable?: string | null, operator?: ConditionOperator | null, value?: string | null, logicOperator?: LogicOperator | null, conditions?: Array<{ __typename?: 'ConditionNode', nodeType: ConditionNodeType, inputVariable?: string | null, operator?: ConditionOperator | null, value?: string | null, logicOperator?: LogicOperator | null }> | null }> | null }> | null } }>, variables: Array<{ __typename?: 'Variable', name: string, fieldKey: string, templateType: TemplateTypeEnum, isBlisterField?: boolean | null }> } | null, calculatedBy?: { __typename?: 'LogicEvaluationRule', description?: string | null, evaluationStrategy: LogicEvaluationStrategy, defaultValue?: string | null, conditionalMappings: Array<{ __typename?: 'ConditionalValueMapping', value: string, combineOperator?: LogicOperator | null, conditionTree: { __typename?: 'ConditionNode', nodeType: ConditionNodeType, inputVariable?: string | null, operator?: ConditionOperator | null, value?: string | null, logicOperator?: LogicOperator | null, conditions?: Array<{ __typename?: 'ConditionNode', nodeType: ConditionNodeType, inputVariable?: string | null, operator?: ConditionOperator | null, value?: string | null, logicOperator?: LogicOperator | null, conditions?: Array<{ __typename?: 'ConditionNode', nodeType: ConditionNodeType, inputVariable?: string | null, operator?: ConditionOperator | null, value?: string | null, logicOperator?: LogicOperator | null, conditions?: Array<{ __typename?: 'ConditionNode', nodeType: ConditionNodeType, inputVariable?: string | null, operator?: ConditionOperator | null, value?: string | null, logicOperator?: LogicOperator | null }> | null }> | null }> | null } }>, variables: Array<{ __typename?: 'Variable', name: string, fieldKey: string, templateType: TemplateTypeEnum, isBlisterField?: boolean | null }> } | null }>, blisterFieldsConfig?: { __typename?: 'BlisterFieldsConfig', estimatedHeight?: { __typename?: 'FieldDetails', name?: string | null, hidden?: boolean | null } | null, manualSetHeight?: { __typename?: 'FieldDetails', name?: string | null, hidden?: boolean | null } | null, blisterHeightIndex?: { __typename?: 'FieldDetails', name?: string | null, hidden?: boolean | null } | null, maxHeight?: { __typename?: 'FieldDetails', name?: string | null, hidden?: boolean | null } | null, wallLoss?: { __typename?: 'FieldDetails', name?: string | null, hidden?: boolean | null } | null, residualThickness?: { __typename?: 'FieldDetails', name?: string | null, hidden?: boolean | null } | null, residualCorrosionAllowance?: { __typename?: 'FieldDetails', name?: string | null, hidden?: boolean | null } | null, pdrHeight?: { __typename?: 'FieldDetails', name?: string | null, hidden?: boolean | null } | null, heightType?: { __typename?: 'FieldDetails', name?: string | null, hidden?: boolean | null } | null, verifiedMaxHeight?: { __typename?: 'FieldDetails', name?: string | null, hidden?: boolean | null } | null, verifiedResidualThickness?: { __typename?: 'FieldDetails', name?: string | null, hidden?: boolean | null } | null, verifiedResidualCorrosionAllowance?: { __typename?: 'FieldDetails', name?: string | null, hidden?: boolean | null } | null, measurementConfidence?: { __typename?: 'FieldDetails', name?: string | null, hidden?: boolean | null } | null, distanceConfidence?: { __typename?: 'FieldDetails', name?: string | null, hidden?: boolean | null } | null } | null } | null };

export type GetAllRolesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAllRolesQuery = { __typename?: 'Query', allRoles: Array<{ __typename?: 'Role', id: string, name: string } | null> };

export type ClonePointOfInterestTemplateMutationVariables = Exact<{
  input?: InputMaybe<PoiTemplateCloneInput>;
}>;


export type ClonePointOfInterestTemplateMutation = { __typename?: 'Mutation', clonePointOfInterestTemplate?: Array<{ __typename?: 'PointOfInterestTemplate', id: string, name: string } | null> | null };

export type UpdateStructureMutationVariables = Exact<{
  input?: InputMaybe<UpdateStructureInput>;
}>;


export type UpdateStructureMutation = { __typename?: 'Mutation', updateStructure?: { __typename?: 'Structure', id: string, name: string, status: StructureStatus, isActive?: boolean | null, deploymentLevel?: StructureDeploymentLevel | null, scanDate?: string | null, isWallLossEnabled?: boolean | null, category?: string | null, fleetHealthTemplateField?: string | null, defectLegends: Array<{ __typename?: 'DefectLegend', id: number, groupName: string, groupKey: string, name: string, color: string, octreeKey: OctreeKey, octreeValue: number, legendText?: string | null }>, nominationConfig?: { __typename?: 'NominationConfig', poiTemplateNominationTypes?: Array<string | null> | null, nominationTableConfig?: { __typename?: 'NominationTableConfig', title?: string | null, columns?: Array<{ __typename?: 'TableColumn', key?: string | null, displayName?: string | null } | null> | null } | null } | null } | null };

export type DeletePointOfInterestTemplateMutationVariables = Exact<{
  templateId: Scalars['String']['input'];
}>;


export type DeletePointOfInterestTemplateMutation = { __typename?: 'Mutation', deletePointOfInterestTemplate?: { __typename?: 'PointOfInterestTemplate', id: string } | null };

export type UpdateTemplateMutationVariables = Exact<{
  input?: InputMaybe<TemplateInput>;
}>;


export type UpdateTemplateMutation = { __typename?: 'Mutation', updateTemplate?: { __typename?: 'Template', id: string, fields: Array<{ __typename?: 'AssemblyTemplateField', id: string, name: string, key?: string | null, type: TemplateFieldTypeEnum, shouldEvaluateLogic?: boolean | null, shouldEvaluateMath?: boolean | null, shouldEvaluateLogicPostCalculation?: boolean | null, logicRule?: { __typename?: 'LogicEvaluationRule', description?: string | null, evaluationStrategy: LogicEvaluationStrategy, defaultValue?: string | null, conditionalMappings: Array<{ __typename?: 'ConditionalValueMapping', value: string, combineOperator?: LogicOperator | null, conditionTree: { __typename?: 'ConditionNode', nodeType: ConditionNodeType, inputVariable?: string | null, operator?: ConditionOperator | null, value?: string | null, logicOperator?: LogicOperator | null, conditions?: Array<{ __typename?: 'ConditionNode', nodeType: ConditionNodeType, inputVariable?: string | null, operator?: ConditionOperator | null, value?: string | null, logicOperator?: LogicOperator | null, conditions?: Array<{ __typename?: 'ConditionNode', nodeType: ConditionNodeType, inputVariable?: string | null, operator?: ConditionOperator | null, value?: string | null, logicOperator?: LogicOperator | null, conditions?: Array<{ __typename?: 'ConditionNode', nodeType: ConditionNodeType, inputVariable?: string | null, operator?: ConditionOperator | null, value?: string | null, logicOperator?: LogicOperator | null }> | null }> | null }> | null } }>, variables: Array<{ __typename?: 'Variable', name: string, fieldKey: string, templateType: TemplateTypeEnum, isBlisterField?: boolean | null }> } | null, calculatedBy?: { __typename?: 'LogicEvaluationRule', description?: string | null, evaluationStrategy: LogicEvaluationStrategy, defaultValue?: string | null, conditionalMappings: Array<{ __typename?: 'ConditionalValueMapping', value: string, combineOperator?: LogicOperator | null, conditionTree: { __typename?: 'ConditionNode', nodeType: ConditionNodeType, inputVariable?: string | null, operator?: ConditionOperator | null, value?: string | null, logicOperator?: LogicOperator | null, conditions?: Array<{ __typename?: 'ConditionNode', nodeType: ConditionNodeType, inputVariable?: string | null, operator?: ConditionOperator | null, value?: string | null, logicOperator?: LogicOperator | null, conditions?: Array<{ __typename?: 'ConditionNode', nodeType: ConditionNodeType, inputVariable?: string | null, operator?: ConditionOperator | null, value?: string | null, logicOperator?: LogicOperator | null, conditions?: Array<{ __typename?: 'ConditionNode', nodeType: ConditionNodeType, inputVariable?: string | null, operator?: ConditionOperator | null, value?: string | null, logicOperator?: LogicOperator | null }> | null }> | null }> | null } }>, variables: Array<{ __typename?: 'Variable', name: string, fieldKey: string, templateType: TemplateTypeEnum, isBlisterField?: boolean | null }> } | null }> } | null };

export type CloneTemplateFieldsMutationVariables = Exact<{
  input?: InputMaybe<TemplateFieldsCloneInput>;
}>;


export type CloneTemplateFieldsMutation = { __typename?: 'Mutation', cloneTemplateFields?: { __typename?: 'Template', fields: Array<{ __typename?: 'AssemblyTemplateField', name: string, id: string }> } | null };

export type CloneQuerySummaryMutationVariables = Exact<{
  input?: InputMaybe<QuerySummaryCloneInput>;
}>;


export type CloneQuerySummaryMutation = { __typename?: 'Mutation', cloneQuerySummary?: { __typename?: 'Template', querySummary?: Array<{ __typename?: 'QuerySummaryItem', id: string, name: string }> | null } | null };

export type AddMiServicesFieldsMutationVariables = Exact<{
  input?: InputMaybe<MiServicesInput>;
}>;


export type AddMiServicesFieldsMutation = { __typename?: 'Mutation', addMiServicesFields?: { __typename?: 'Template', fields: Array<{ __typename?: 'AssemblyTemplateField', id: string, name: string, key?: string | null }> } | null };

export type AddMiServicesOverhaulFieldsForAssemblyTemplateMutationVariables = Exact<{
  input?: InputMaybe<MiServicesInput>;
}>;


export type AddMiServicesOverhaulFieldsForAssemblyTemplateMutation = { __typename?: 'Mutation', addMiServicesOverhaulFields?: { __typename?: 'Template', fields: Array<{ __typename?: 'AssemblyTemplateField', id: string, name: string, key?: string | null }> } | null };

export type AddViewpointCountFieldMutationVariables = Exact<{
  input?: InputMaybe<MiServicesInput>;
}>;


export type AddViewpointCountFieldMutation = { __typename?: 'Mutation', addViewpointCountField?: { __typename?: 'Template', fields: Array<{ __typename?: 'AssemblyTemplateField', id: string, name: string, key?: string | null }> } | null };

export type BackfillViewpointCountsMutationVariables = Exact<{
  structureId: Scalars['String']['input'];
}>;


export type BackfillViewpointCountsMutation = { __typename?: 'Mutation', backfillViewpointCounts: boolean };

export type AddBspMiServicesOverhaulFieldsMutationVariables = Exact<{
  input?: InputMaybe<MiServicesInput>;
}>;


export type AddBspMiServicesOverhaulFieldsMutation = { __typename?: 'Mutation', addBspMiServicesOverhaulFields?: { __typename?: 'Template', fields: Array<{ __typename?: 'AssemblyTemplateField', id: string, name: string, key?: string | null }> } | null };

export type AddMiServicesOverhaulFieldsToPoiTemplatesMutationVariables = Exact<{
  input?: InputMaybe<MiServicesPoiTemplateInput>;
}>;


export type AddMiServicesOverhaulFieldsToPoiTemplatesMutation = { __typename?: 'Mutation', addMiServicesOverhaulFieldsToPoiTemplates?: Array<{ __typename?: 'PointOfInterestTemplate', fields: Array<{ __typename?: 'PointOfInterestTemplateField', id: string, name: string, key?: string | null }> } | null> | null };

export type AddBspMiServicesOverhaulFieldsToPoiTemplatesMutationVariables = Exact<{
  input?: InputMaybe<MiServicesPoiTemplateInput>;
}>;


export type AddBspMiServicesOverhaulFieldsToPoiTemplatesMutation = { __typename?: 'Mutation', addBspMiServicesOverhaulFieldsToPoiTemplates?: Array<{ __typename?: 'PointOfInterestTemplate', fields: Array<{ __typename?: 'PointOfInterestTemplateField', id: string, name: string, key?: string | null }> } | null> | null };

export type AddAlarmLevelFieldToPoiTemplatesMutationVariables = Exact<{
  input?: InputMaybe<MiServicesPoiTemplateInput>;
}>;


export type AddAlarmLevelFieldToPoiTemplatesMutation = { __typename?: 'Mutation', addAlarmLevelFieldToPoiTemplates?: Array<{ __typename?: 'PointOfInterestTemplate', fields: Array<{ __typename?: 'PointOfInterestTemplateField', id: string, name: string, key?: string | null }> } | null> | null };

export type AddEditRolesToTemplateFieldMutationVariables = Exact<{
  input?: InputMaybe<EditRolesInput>;
}>;


export type AddEditRolesToTemplateFieldMutation = { __typename?: 'Mutation', addEditRolesToTemplateField?: { __typename?: 'Template', fields: Array<{ __typename?: 'AssemblyTemplateField', key?: string | null, isEditable?: boolean | null, editRoles?: Array<string | null> | null }> } | null };

export type EvaluateAllAssembliesForStructureMutationVariables = Exact<{
  structureId: Scalars['String']['input'];
  evaluateManuallyAddedFields: Scalars['Boolean']['input'];
}>;


export type EvaluateAllAssembliesForStructureMutation = { __typename?: 'Mutation', evaluateAllAssembliesForStructure?: { __typename?: 'Structure', name: string } | null };

export type EvaluateAllPoIsForStructureMutationVariables = Exact<{
  structureId: Scalars['String']['input'];
  evaluateManuallyAddedFields: Scalars['Boolean']['input'];
}>;


export type EvaluateAllPoIsForStructureMutation = { __typename?: 'Mutation', evaluateAllPOIsForStructure?: { __typename?: 'Structure', name: string } | null };

export type AddAssessmentDetailsFieldsMutationVariables = Exact<{
  input?: InputMaybe<AssessmentDetailsInput>;
}>;


export type AddAssessmentDetailsFieldsMutation = { __typename?: 'Mutation', addAssessmentDetailsFields?: { __typename?: 'Template', fields: Array<{ __typename?: 'AssemblyTemplateField', id: string, name: string, key?: string | null }>, assessmentDetails?: Array<{ __typename?: 'AssessmentDetails', id: string, isVisible: boolean, name: string, position: number, type: string, options: Array<{ __typename?: 'AssessmentDetailOptionFieldSchema', fieldKey: string, id: string, name: string, type: OptionFieldTypeEnum }> }> | null, reviewPanelConfig?: Array<{ __typename?: 'ReviewPanelConfig', groupKey: string, groupName: string, id: string, groupSection: Array<{ __typename?: 'GroupSection', id: string, title: string, sectionKey: string, fieldKeys: Array<string | null> } | null> }> | null } | null };

export type UploadCoverImageMutationVariables = Exact<{
  input: UploadImageInput;
}>;


export type UploadCoverImageMutation = { __typename?: 'Mutation', uploadCoverImage?: { __typename?: 'Structure', coverImagePath: string } | null };

export type UpdateRemediationScoreConfigMutationVariables = Exact<{
  input: UpdateRemediationScoreConfigInput;
}>;


export type UpdateRemediationScoreConfigMutation = { __typename?: 'Mutation', updateRemediationScoreConfig?: { __typename?: 'Template', remediationScoreConfig?: { __typename?: 'RemediationScoreConfig', area?: { __typename?: 'RemediationScoreAreaSection', fields?: Array<{ __typename?: 'RemediationScoreAreaField', fieldKey: string, score: number, threshold: number }> | null } | null, cof?: { __typename?: 'RemediationScoreCofSection', fields?: Array<{ __typename?: 'RemediationScoreCofField', fieldKey: string, optionScores: any }> | null } | null, poi?: { __typename?: 'RemediationScorePoiSection', fields?: Array<{ __typename?: 'RemediationScorePoiField', poiScore: number, poiTemplateKey: string, subcategory?: { __typename?: 'RemediationScoreSubcategory', fieldKey: string, optionScores: any } | null }> | null } | null } | null } | null };

export type AddReportConfigurationMutationVariables = Exact<{
  structureId: Scalars['ID']['input'];
}>;


export type AddReportConfigurationMutation = { __typename?: 'Mutation', addReportConfiguration?: { __typename?: 'Structure', reportConfig?: { __typename?: 'ReportConfig', title: string, id: string, paintBlockReportPoiTemplateTypes?: Array<string | null> | null, configurations?: Array<{ __typename?: 'Configurations', id: string, title: string, key: string }> | null } | null } | null };

export type RecalculateRiskRemediationAnalyticsMutationVariables = Exact<{
  input: RecalculateRiskRemediationAnalyticsInput;
}>;


export type RecalculateRiskRemediationAnalyticsMutation = { __typename?: 'Mutation', recalculateRiskRemediationAnalytics: { __typename?: 'RecalculateRiskRemediationAnalyticsResult', success: boolean, error?: string | null } };

export type AllLogsTemplatesQueryVariables = Exact<{
  input: LogsTemplateInput;
}>;


export type AllLogsTemplatesQuery = { __typename?: 'Query', allLogsTemplates?: Array<{ __typename?: 'LogsTemplate', id: string, name: string, key: string }> | null };

export type LogsTemplateQueryVariables = Exact<{
  logsTemplateId: Scalars['ID']['input'];
}>;


export type LogsTemplateQuery = { __typename?: 'Query', logsTemplate?: { __typename?: 'LogsTemplate', id: string, name: string, sections: Array<{ __typename?: 'LogSection', id: string, key: string, title: string, sectionUnit?: SectionUnitsEnum | null, order: number, defaultOpen?: boolean | null, fieldKeys: Array<string> }>, fields: Array<{ __typename?: 'LogsTemplateField', id: string, name: string, type: TemplateFieldTypeEnum, options: Array<string>, isRequired: boolean, isReadOnly: boolean, serverSide: boolean, roundToDecimal?: number | null, key?: string | null, detailFieldKey?: string | null, shouldEvaluateLogic?: boolean | null, shouldEvaluateMath?: boolean | null, shouldEvaluateLogicPostCalculation?: boolean | null, displayInQuery?: boolean | null, displayInTable?: boolean | null, displayInReview?: boolean | null, displayInReports?: boolean | null, displayInReportFilters?: boolean | null, sectionKey?: string | null, displayInLogAggregation?: boolean | null, isDerived?: boolean | null, derivedEquationKey?: string | null, fieldDescription?: string | null, fieldUnit?: SectionUnitsEnum | null, optionsData?: Array<{ __typename?: 'OptionData', value: string, weight?: number | null, min?: number | null, max?: number | null, minIncluded?: boolean | null, maxIncluded?: boolean | null }> | null, displayConfig?: { __typename?: 'DisplayConfig', id: string, type: TableCellStyleEnum, textAreaRows?: number | null, isSortable: boolean, sortType: SortTypeEnum, textFormat?: TextFormatEnum | null, color?: Array<{ __typename?: 'DisplayColor', key: string, value: string } | null> | null, inputAdorment?: { __typename?: 'InputAdormentType', position?: InputAdormentPositionEnum | null, iconPath?: string | null, iconType?: InputAdormentIconTypeEnum | null } | null } | null }>, cardsConfig?: Array<{ __typename?: 'CardConfig', id: string, key: string, order: number, title?: string | null, icon?: string | null, unit?: SectionUnitsEnum | null, unitPosition?: UnitPositionEnum | null, roundToDecimal?: number | null, equationKey?: string | null, aggregation?: { __typename?: 'Aggregation', source: string, fieldKey: string, operation: MathOperator } | null, subtitleConfig?: { __typename?: 'SubtitleConfig', text?: string | null, unit?: SectionUnitsEnum | null, unitPosition?: UnitPositionEnum | null, equationKey?: string | null, position?: LabelPositionEnum | null, icon?: string | null, iconPosition?: InputAdormentPositionEnum | null, textFormat?: TextFormatEnum | null, prefix?: string | null, suffix?: string | null, roundToDecimal?: number | null, aggregation?: { __typename?: 'Aggregation', source: string, fieldKey: string, operation: MathOperator } | null } | null } | null> | null, equations?: Array<{ __typename?: 'Equation', key: string, name?: string | null, value?: string | null, expression?: { __typename?: 'Expression', type: ExpressionType, value?: number | null, variable?: string | null, operator?: MathOperator | null, args?: Array<{ __typename?: 'Expression', type: ExpressionType, value?: number | null, variable?: string | null, operator?: MathOperator | null, args?: Array<{ __typename?: 'Expression', type: ExpressionType, value?: number | null, variable?: string | null, operator?: MathOperator | null, args?: Array<{ __typename?: 'Expression', type: ExpressionType, value?: number | null, variable?: string | null, operator?: MathOperator | null } | null> | null } | null> | null } | null> | null } | null, variables?: Array<{ __typename?: 'Variable', name: string, fieldKey: string, templateType: TemplateTypeEnum, isBlisterField?: boolean | null }> | null }> | null } | null };

export type CreateLogsTemplateMutationVariables = Exact<{
  input: LogsTemplateInput;
}>;


export type CreateLogsTemplateMutation = { __typename?: 'Mutation', createLogsTemplate?: { __typename?: 'LogsTemplate', id: string, name: string } | null };

export type AddLogsTemplateMutationVariables = Exact<{
  input: AddLogsTemplateInput;
}>;


export type AddLogsTemplateMutation = { __typename?: 'Mutation', addLogsTemplate: Array<{ __typename?: 'LogEntry', id: string, logsTemplate: { __typename?: 'LogsTemplate', id: string, name: string } }> };

export type UpdateLogsTemplateMutationVariables = Exact<{
  input: UpdateLogsTemplateInput;
}>;


export type UpdateLogsTemplateMutation = { __typename?: 'Mutation', updateLogsTemplate?: { __typename?: 'LogsTemplate', id: string, name: string } | null };

export type AddStructurePipesMutationVariables = Exact<{
  input?: InputMaybe<AddStructurePipesInput>;
}>;


export type AddStructurePipesMutation = { __typename?: 'Mutation', addStructurePipes?: string | null };

export type DeleteStructurePipeMutationVariables = Exact<{
  structureId: Scalars['ID']['input'];
  pipeSize: Scalars['String']['input'];
}>;


export type DeleteStructurePipeMutation = { __typename?: 'Mutation', deleteStructurePipe?: string | null };

export type EditStructurePipeMutationVariables = Exact<{
  structureId: Scalars['ID']['input'];
  pipeSize: Scalars['String']['input'];
  pipeValue: Scalars['Float']['input'];
}>;


export type EditStructurePipeMutation = { __typename?: 'Mutation', editStructurePipe?: string | null };

export type UpdateFleetHealthMutationVariables = Exact<{
  platformIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>> | InputMaybe<Scalars['ID']['input']>>;
}>;


export type UpdateFleetHealthMutation = { __typename?: 'Mutation', updateFleetHealth: Array<{ __typename?: 'Platform', id: string }> };

export type SyncNestedFieldOptionsMutationVariables = Exact<{
  templateId: Scalars['ID']['input'];
}>;


export type SyncNestedFieldOptionsMutation = { __typename?: 'Mutation', syncNestedFieldOptions?: { __typename?: 'Template', id: string } | null };

export type CopyLogsTemplateMutationVariables = Exact<{
  input: CopyLogsTemplateInput;
}>;


export type CopyLogsTemplateMutation = { __typename?: 'Mutation', copyLogsTemplate?: { __typename?: 'LogsTemplate', id: string, name: string } | null };

export type SyncLogsTemplatesMutationVariables = Exact<{
  input: SyncLogsTemplatesInput;
}>;


export type SyncLogsTemplatesMutation = { __typename?: 'Mutation', syncLogsTemplates: { __typename?: 'LogsTemplate', id: string, name: string } };

export type AllUsersForUserManagementQueryVariables = Exact<{
  pageInfo?: InputMaybe<PageInfo>;
  input?: InputMaybe<FilterForUsers>;
  usersCountInput?: InputMaybe<FiltersForUsersCount>;
}>;


export type AllUsersForUserManagementQuery = { __typename?: 'Query', usersCount?: { __typename?: 'Count', count: number } | null, allUsers: Array<{ __typename?: 'User', id: string, email: string, picture?: string | null, name?: string | null, connection?: string | null, status?: UserStatusEnum | null, loginCount?: number | null, lastLogin?: string | null, loginType?: LoginTypeEnum | null, roleIds: Array<{ __typename?: 'Role', id: string, name: string, description?: string | null, auth0Id: string } | null> }> };

export type BlockOrUnblockUserMutationVariables = Exact<{
  userId: Scalars['ID']['input'];
}>;


export type BlockOrUnblockUserMutation = { __typename?: 'Mutation', blockOrUnblockUser: { __typename?: 'User', id: string, status?: UserStatusEnum | null } };

export type ResetPasswordMutationVariables = Exact<{
  input: ResetPasswordInput;
}>;


export type ResetPasswordMutation = { __typename?: 'Mutation', resetPassword: string };

export type AllStructuresForAddPlatformDialogQueryVariables = Exact<{
  input?: InputMaybe<StructureFilters>;
}>;


export type AllStructuresForAddPlatformDialogQuery = { __typename?: 'Query', allStructures: Array<{ __typename?: 'Structure', coverImagePath: string, id: string, name: string, description: string }> };

export type AllUsersForAddUserDialogQueryVariables = Exact<{
  input?: InputMaybe<FilterForUsers>;
}>;


export type AllUsersForAddUserDialogQuery = { __typename?: 'Query', allUsers: Array<{ __typename?: 'User', id: string, email: string, picture?: string | null, name?: string | null, connection?: string | null, status?: UserStatusEnum | null, loginCount?: number | null, lastLogin?: string | null, loginType?: LoginTypeEnum | null, roleIds: Array<{ __typename?: 'Role', id: string, name: string, description?: string | null, auth0Id: string } | null> }> };

export type PreRegisteredUsersQueryVariables = Exact<{
  pageInfo?: InputMaybe<PageInfo>;
  input?: InputMaybe<FiltersForPreRegisteredUsers>;
}>;


export type PreRegisteredUsersQuery = { __typename?: 'Query', preRegisteredUsers: Array<{ __typename?: 'PreRegisteredUser', id: string, email: string }>, preRegisteredUsersCount: { __typename?: 'Count', count: number } };

export type CreatePreRegisteredUsersMutationVariables = Exact<{
  input?: InputMaybe<PreRegisteredUserInput>;
}>;


export type CreatePreRegisteredUsersMutation = { __typename?: 'Mutation', createPreRegisteredUsers: { __typename?: 'UserInvite', createdUsers: Array<{ __typename?: 'User', email: string, status?: UserStatusEnum | null, id: string } | null>, failedUsers?: Array<{ __typename?: 'FailedUserInfo', email: string, errorMessage: string } | null> | null } };

export type DeletePreRegisteredUserMutationVariables = Exact<{
  userId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type DeletePreRegisteredUserMutation = { __typename?: 'Mutation', deletePreRegisteredUser?: { __typename?: 'PreRegisteredUser', email: string } | null };

export type AddUsersToUserGroupMutationVariables = Exact<{
  input?: InputMaybe<AddRemoveUsersToFromUserGroupInput>;
}>;


export type AddUsersToUserGroupMutation = { __typename?: 'Mutation', addUsersToUserGroup?: { __typename?: 'UserGroup', id: string, name: string, userIds: Array<string>, createdBy?: string | null, updatedBy?: string | null, createdAt?: string | null, updatedAt?: string | null } | null };

export type GetAllTeamsForUserManagementQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAllTeamsForUserManagementQuery = { __typename?: 'Query', allTeams: Array<{ __typename?: 'Team', id: string, name: string, users: Array<{ __typename?: 'User', id: string }> }> };

export type GetUsersByTeamQueryVariables = Exact<{
  teamId: Scalars['ID']['input'];
  pageInfo?: InputMaybe<PageInfo>;
}>;


export type GetUsersByTeamQuery = { __typename?: 'Query', usersByTeam: Array<{ __typename?: 'User', id: string, name?: string | null, email: string, picture?: string | null }> };

export type CreateTeamMutationVariables = Exact<{
  name: Scalars['String']['input'];
}>;


export type CreateTeamMutation = { __typename?: 'Mutation', createTeam: { __typename?: 'Team', id: string, name: string } };

export type DeleteTeamMutationVariables = Exact<{
  teamId: Scalars['ID']['input'];
}>;


export type DeleteTeamMutation = { __typename?: 'Mutation', deleteTeam: string };

export type AddUsersToTeamMutationVariables = Exact<{
  input: UpdateTeamInput;
}>;


export type AddUsersToTeamMutation = { __typename?: 'Mutation', addUsersToTeam: { __typename?: 'Team', id: string } };

export type RemoveUsersFromTeamMutationVariables = Exact<{
  input: UpdateTeamInput;
}>;


export type RemoveUsersFromTeamMutation = { __typename?: 'Mutation', removeUsersFromTeam: { __typename?: 'Team', id: string } };

export type AllUserGroupsForUserManagementQueryVariables = Exact<{
  userId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type AllUserGroupsForUserManagementQuery = { __typename?: 'Query', allUserGroups: Array<{ __typename?: 'UserGroup', id: string, name: string, userIds: Array<string>, createdBy?: string | null, updatedBy?: string | null, createdAt?: string | null, updatedAt?: string | null }> };

export type AllRolesQueryVariables = Exact<{ [key: string]: never; }>;


export type AllRolesQuery = { __typename?: 'Query', allRoles: Array<{ __typename?: 'Role', id: string, auth0Id: string, name: string, description?: string | null } | null> };

export type UsersCountQueryVariables = Exact<{
  input?: InputMaybe<FiltersForUsersCount>;
}>;


export type UsersCountQuery = { __typename?: 'Query', usersCount?: { __typename?: 'Count', count: number } | null };

export type UsersByUserGroupQueryVariables = Exact<{
  input?: InputMaybe<FilterForUsersByUserGroup>;
  pageInfo?: InputMaybe<PageInfo>;
  usersCountInput?: InputMaybe<FiltersForUsersCount>;
}>;


export type UsersByUserGroupQuery = { __typename?: 'Query', usersCount?: { __typename?: 'Count', count: number } | null, usersByUserGroup: Array<{ __typename?: 'User', id: string, email: string, picture?: string | null, name?: string | null, connection?: string | null, roleIds: Array<{ __typename?: 'Role', id: string, name: string, description?: string | null, auth0Id: string, permissions?: Array<string | null> | null } | null> }> };

export type GetAuth0ConnectionsQueryVariables = Exact<{
  applicationId: Scalars['String']['input'];
}>;


export type GetAuth0ConnectionsQuery = { __typename?: 'Query', auth0Connections: Array<{ __typename?: 'ConnectionAuth0', id: string, name: string }> };

export type RemoveUsersFromUserGroupMutationVariables = Exact<{
  input?: InputMaybe<AddRemoveUsersToFromUserGroupInput>;
}>;


export type RemoveUsersFromUserGroupMutation = { __typename?: 'Mutation', removeUsersFromUserGroup?: { __typename?: 'UserGroup', id: string, name: string, userIds: Array<string>, createdBy?: string | null, updatedBy?: string | null, createdAt?: string | null, updatedAt?: string | null } | null };

export type InviteUsersMutationVariables = Exact<{
  input?: InputMaybe<InviteUsersInput>;
}>;


export type InviteUsersMutation = { __typename?: 'Mutation', inviteUsers: { __typename?: 'UserInvite', createdUsers: Array<{ __typename?: 'User', email: string, status?: UserStatusEnum | null, id: string } | null>, failedUsers?: Array<{ __typename?: 'FailedUserInfo', email: string, errorMessage: string } | null> | null } };

export type CreateUserGroupMutationVariables = Exact<{
  input?: InputMaybe<CreateUserGroupInput>;
}>;


export type CreateUserGroupMutation = { __typename?: 'Mutation', createUserGroup?: { __typename?: 'UserGroup', id: string, name: string, userIds: Array<string>, createdBy?: string | null, updatedBy?: string | null, createdAt?: string | null, updatedAt?: string | null } | null };

export type AllStructuresForUserManagementQueryVariables = Exact<{ [key: string]: never; }>;


export type AllStructuresForUserManagementQuery = { __typename?: 'Query', allStructures: Array<{ __typename?: 'Structure', id: string, name: string, coverImagePath: string, userGroups: Array<{ __typename?: 'UserGroup', id: string, name: string }> }> };

export type StructuresByUserGroupQueryVariables = Exact<{
  structuresInput?: InputMaybe<FiltersForStructureByUserGroup>;
  pageInfo?: InputMaybe<PageInfo>;
  input?: InputMaybe<FilterForStructures>;
}>;


export type StructuresByUserGroupQuery = { __typename?: 'Query', structuresByUserGroup: Array<{ __typename?: 'Structure', id: string, name: string, coverImagePath: string, description: string }>, structuresCount?: { __typename?: 'Count', count: number } | null };

export type RemoveUserGroupsFromStructureMutationVariables = Exact<{
  input?: InputMaybe<AddRemoveStructuresToFromUserGroupsInput>;
}>;


export type RemoveUserGroupsFromStructureMutation = { __typename?: 'Mutation', removeUserGroupsFromStructure?: { __typename?: 'StructuresAndGroups', userGroups: Array<{ __typename?: 'UserGroup', id: string, name: string, userIds: Array<string>, createdBy?: string | null, updatedBy?: string | null, createdAt?: string | null, updatedAt?: string | null }>, structures: Array<{ __typename?: 'Structure', id: string, name: string }> } | null };

export type AddUserGroupsToStructureMutationVariables = Exact<{
  input?: InputMaybe<AddRemoveStructuresToFromUserGroupsInput>;
}>;


export type AddUserGroupsToStructureMutation = { __typename?: 'Mutation', addUserGroupsToStructure?: { __typename?: 'StructuresAndGroups', userGroups: Array<{ __typename?: 'UserGroup', id: string, name: string, userIds: Array<string>, createdBy?: string | null, updatedBy?: string | null, createdAt?: string | null, updatedAt?: string | null }>, structures: Array<{ __typename?: 'Structure', id: string, name: string }> } | null };

export type UsersByRoleIdQueryVariables = Exact<{
  input?: InputMaybe<UsersByRoleInput>;
  pageInfo?: InputMaybe<PageInfo>;
  usersCountInput?: InputMaybe<FiltersForUsersCount>;
}>;


export type UsersByRoleIdQuery = { __typename?: 'Query', usersCount?: { __typename?: 'Count', count: number } | null, usersByRoleId: Array<{ __typename?: 'User', id: string, email: string, picture?: string | null, name?: string | null }> };

export type RemoveRoleFromUsersMutationVariables = Exact<{
  input?: InputMaybe<AssignRemoveRoleToFromUsersInput>;
}>;


export type RemoveRoleFromUsersMutation = { __typename?: 'Mutation', removeRoleFromUsers: { __typename?: 'Role', id: string, name: string, auth0Id: string, description?: string | null } };

export type AssignRoleToUsersMutationVariables = Exact<{
  input?: InputMaybe<AssignRemoveRoleToFromUsersInput>;
}>;


export type AssignRoleToUsersMutation = { __typename?: 'Mutation', assignRoleToUsers: { __typename?: 'Role', id: string, name: string, auth0Id: string, description?: string | null } };

export type UserDetailsQueryVariables = Exact<{
  userId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type UserDetailsQuery = { __typename?: 'Query', userDetails: { __typename?: 'UserProfile', user: { __typename?: 'User', email: string, picture?: string | null, name?: string | null, permissions?: Array<string> | null, connection?: string | null, loginCount?: number | null, roleIds: Array<{ __typename?: 'Role', name: string, auth0Id: string, description?: string | null, permissions?: Array<string | null> | null } | null> }, userGroups: Array<{ __typename?: 'UserGroup', name: string }>, structures: Array<{ __typename?: 'Structure', id: string, name: string, coverImagePath: string, description: string }> } };

export type GetDirectlyAssignedUserPermissionsQueryVariables = Exact<{
  userId: Scalars['String']['input'];
}>;


export type GetDirectlyAssignedUserPermissionsQuery = { __typename?: 'Query', getDirectlyAssignedUserPermissions: Array<{ __typename?: 'Permission', description?: string | null, name?: string | null }> };

export type GetAuth0PermissionsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAuth0PermissionsQuery = { __typename?: 'Query', getAuth0Permissions: Array<{ __typename?: 'Permission', name?: string | null, description?: string | null }> };

export type GetUserPermissionsByRolesQueryVariables = Exact<{
  userId: Scalars['String']['input'];
}>;


export type GetUserPermissionsByRolesQuery = { __typename?: 'Query', getUserPermissionsByRoles: Array<{ __typename?: 'Auth0UserRoles', name?: string | null, auth0Id?: string | null, description?: string | null, permissions?: Array<{ __typename?: 'Permission', name?: string | null, description?: string | null } | null> | null }> };

export type PermissionsByRoleQueryVariables = Exact<{
  roleId: Scalars['String']['input'];
}>;


export type PermissionsByRoleQuery = { __typename?: 'Query', permissionsByRole: Array<{ __typename?: 'RolePermission', key: string, description: string }> };

export type DeleteUserGroupMutationVariables = Exact<{
  input?: InputMaybe<DeleteUserGroupInput>;
}>;


export type DeleteUserGroupMutation = { __typename?: 'Mutation', deleteUserGroup?: { __typename?: 'UserGroup', id: string, name: string, userIds: Array<string>, createdBy?: string | null, updatedBy?: string | null, createdAt?: string | null, updatedAt?: string | null } | null };

export type GetUserAbilitiesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetUserAbilitiesQuery = { __typename?: 'Query', getUserAbilities?: string | null };

export type UpdateWorkflowStatusMutationVariables = Exact<{
  input?: InputMaybe<UpdateWorkflowStatusInput>;
}>;


export type UpdateWorkflowStatusMutation = { __typename?: 'Mutation', updateWorkflowStatus?: Array<{ __typename?: 'Zone', id: string, name: string, workflowStatus?: { __typename?: 'WorkflowStatus', workflowStageId: string, state?: ZoneState | null, difficultyLevel?: DifficultyLevel | null, totalTime?: any | null, idleTime?: any | null, trackedTime?: any | null, pausedBy?: PausedBy | null, assignedToUser?: { __typename?: 'User', id: string, name?: string | null, email: string, picture?: string | null, roleIds: Array<{ __typename?: 'Role', name: string, auth0Id: string, id: string } | null> } | null } | null } | null> | null };

export type WorkFlowTimeUpdatedSubscriptionVariables = Exact<{
  structureId?: InputMaybe<Scalars['ID']['input']>;
  zoneId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type WorkFlowTimeUpdatedSubscription = { __typename?: 'Subscription', workFlowTimeUpdated: { __typename?: 'Zone', id: string, name: string, status: ZoneStatus, structureId: string, box: { __typename?: 'Box', min: { __typename?: 'Vector3', x: number, y: number, z: number }, max: { __typename?: 'Vector3', x: number, y: number, z: number } }, workflowStatus?: { __typename?: 'WorkflowStatus', workflowStageId: string, state?: ZoneState | null, totalTime?: any | null, idleTime?: any | null, pausedBy?: PausedBy | null, trackedTime?: any | null, assignedToUser?: { __typename?: 'User', id: string, name?: string | null, email: string, picture?: string | null, roleIds: Array<{ __typename?: 'Role', name: string, auth0Id: string, id: string } | null> } | null } | null } };

export type WorkflowStagesQueryVariables = Exact<{
  structureId?: InputMaybe<Scalars['String']['input']>;
}>;


export type WorkflowStagesQuery = { __typename?: 'Query', structure?: { __typename?: 'Structure', workflowStages?: Array<{ __typename?: 'WorkflowStages', id: string, name: string, orderInWorkflow: number, stageType: StageType } | null> | null } | null };

export type DeleteWorkflowStageMutationVariables = Exact<{
  input?: InputMaybe<DeleteWorkflowStageInput>;
}>;


export type DeleteWorkflowStageMutation = { __typename?: 'Mutation', deleteWorkflowStage?: { __typename?: 'Structure', workflowStages?: Array<{ __typename?: 'WorkflowStages', id: string } | null> | null } | null };

export type UpdateZoneWorkFlowStatusMutationVariables = Exact<{
  input?: InputMaybe<UpdateWorkflowStatusInput>;
}>;


export type UpdateZoneWorkFlowStatusMutation = { __typename?: 'Mutation', updateWorkflowStatus?: Array<{ __typename?: 'Zone', name: string } | null> | null };

export type ZonesPerStatusCountQueryVariables = Exact<{
  structureId?: InputMaybe<Scalars['String']['input']>;
  searchTerm?: InputMaybe<Scalars['String']['input']>;
}>;


export type ZonesPerStatusCountQuery = { __typename?: 'Query', zonesPerStatusCount: Array<{ __typename?: 'ZoneStatusCount', status: string, count: number }> };

export type WorkflowStagesAndZonesQueryVariables = Exact<{
  structureId?: InputMaybe<Scalars['String']['input']>;
  searchTerm?: InputMaybe<Scalars['String']['input']>;
}>;


export type WorkflowStagesAndZonesQuery = { __typename?: 'Query', structure?: { __typename?: 'Structure', workflowStages?: Array<{ __typename?: 'WorkflowStages', id: string, name: string, orderInWorkflow: number, stageType: StageType } | null> | null } | null, zonesForStructure: Array<{ __typename?: 'Zone', id: string, name: string, status: ZoneStatus, structureId: string, box: { __typename?: 'Box', min: { __typename?: 'Vector3', x: number, y: number, z: number }, max: { __typename?: 'Vector3', x: number, y: number, z: number } }, workflowStatus?: { __typename?: 'WorkflowStatus', workflowStageId: string, pausedBy?: PausedBy | null, state?: ZoneState | null, difficultyLevel?: DifficultyLevel | null, assignedToUser?: { __typename?: 'User', id: string, name?: string | null, email: string, picture?: string | null, roleIds: Array<{ __typename?: 'Role', name: string, auth0Id: string, id: string } | null> } | null } | null }> };

export type CreateWorkflowStageMutationVariables = Exact<{
  input?: InputMaybe<CreateWorkflowStageInput>;
}>;


export type CreateWorkflowStageMutation = { __typename?: 'Mutation', createWorkflowStage?: { __typename?: 'Structure', workflowStages?: Array<{ __typename?: 'WorkflowStages', id: string, name: string, orderInWorkflow: number, stageType: StageType } | null> | null } | null };

export type UpdateWorkflowStageMutationVariables = Exact<{
  input?: InputMaybe<UpdateWorkflowStageInput>;
}>;


export type UpdateWorkflowStageMutation = { __typename?: 'Mutation', updateWorkflowStage?: { __typename?: 'Structure', workflowStages?: Array<{ __typename?: 'WorkflowStages', id: string, name: string, orderInWorkflow: number, stageType: StageType } | null> | null } | null };

export type ZonesForStructureQueryVariables = Exact<{
  structureId?: InputMaybe<Scalars['String']['input']>;
}>;


export type ZonesForStructureQuery = { __typename?: 'Query', zonesForStructure: Array<{ __typename?: 'Zone', id: string, name: string, status: ZoneStatus, structureId: string, totalParts?: number | null, totalPoints?: number | null, totalSphericals?: number | null, box: { __typename?: 'Box', min: { __typename?: 'Vector3', x: number, y: number, z: number }, max: { __typename?: 'Vector3', x: number, y: number, z: number } }, workflowStatus?: { __typename?: 'WorkflowStatus', workflowStageId: string, state?: ZoneState | null, assignedToUser?: { __typename?: 'User', id: string, name?: string | null, email: string, picture?: string | null, roleIds: Array<{ __typename?: 'Role', name: string, auth0Id: string, id: string } | null> } | null } | null }> };

export type ZoneAndHistoriesForZoneManagementQueryVariables = Exact<{
  structureId?: InputMaybe<Scalars['String']['input']>;
}>;


export type ZoneAndHistoriesForZoneManagementQuery = { __typename?: 'Query', zonesAndHistoriesFor: Array<{ __typename?: 'ZoneAndHistory', _id: string, name: string, status?: ZoneStatus | null, structureId: string, totalParts?: number | null, totalPoints?: number | null, totalSphericals?: number | null, histories?: Array<{ __typename?: 'History', id: string, createdBy: string, eventName: string, document: any, collectionName: string, createdAt: string, createdByName?: string | null, createdByDetails?: { __typename?: 'CreatedByDetails', name: string, profilePicture: string } | null } | null> | null, box: { __typename?: 'Box', min: { __typename?: 'Vector3', x: number, y: number, z: number }, max: { __typename?: 'Vector3', x: number, y: number, z: number } } }> };

export type UpdateZoneStatusMutationVariables = Exact<{
  input?: InputMaybe<UpdateZoneStatusInput>;
}>;


export type UpdateZoneStatusMutation = { __typename?: 'Mutation', updateZoneStatus: { __typename?: 'ZoneUpdate', createdBy: string, currentStatus: ZoneStatus, prevStatus: ZoneStatus, referenceId: string } };

export type UpdateWorkflowTimeAndStateMutationVariables = Exact<{
  input?: InputMaybe<UpdateWorkflowTimeAndStateInput>;
}>;


export type UpdateWorkflowTimeAndStateMutation = { __typename?: 'Mutation', updateWorkflowTimeAndState?: { __typename?: 'Zone', workflowStatus?: { __typename?: 'WorkflowStatus', workflowStageId: string, state?: ZoneState | null, difficultyLevel?: DifficultyLevel | null, totalTime?: any | null, idleTime?: any | null, trackedTime?: any | null, assignedToUser?: { __typename?: 'User', id: string, name?: string | null, email: string, picture?: string | null, roleIds: Array<{ __typename?: 'Role', name: string, auth0Id: string, id: string } | null> } | null } | null } | null };

export type ZonesForStructureCsvQueryVariables = Exact<{
  structureId?: InputMaybe<Scalars['String']['input']>;
}>;


export type ZonesForStructureCsvQuery = { __typename?: 'Query', zonesForStructureCSV: string };

export type SphericalsPerZoneQueryVariables = Exact<{
  structureId?: InputMaybe<Scalars['String']['input']>;
}>;


export type SphericalsPerZoneQuery = { __typename?: 'Query', sphericalsPerZone?: Array<{ __typename?: 'SphericalsPerZone', totalSphericals: number, zoneId: string }> | null };

export type AllUsersForZonesQueryVariables = Exact<{
  pageInfo?: InputMaybe<PageInfo>;
  input?: InputMaybe<FilterForUsers>;
}>;


export type AllUsersForZonesQuery = { __typename?: 'Query', allUsers: Array<{ __typename?: 'User', id: string, email: string, picture?: string | null, name?: string | null, roleIds: Array<{ __typename?: 'Role', id: string, name: string } | null> }> };

export type AssignZoneToUserMutationVariables = Exact<{
  input?: InputMaybe<UpdateWorkflowStatusInput>;
}>;


export type AssignZoneToUserMutation = { __typename?: 'Mutation', updateWorkflowStatus?: Array<{ __typename?: 'Zone', id: string } | null> | null };

export type GetAssemblyServiceAndPipeSpecQueryVariables = Exact<{
  assemblyId?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetAssemblyServiceAndPipeSpecQuery = { __typename?: 'Query', assembly?: { __typename?: 'Assembly', id: string, service?: { __typename?: 'Service', group: string, code?: string | null } | null, pipeSpec?: { __typename?: 'PipeSpec', spec?: string | null } | null } | null };

export type GetStructureNameQueryVariables = Exact<{
  structureId: Scalars['String']['input'];
}>;


export type GetStructureNameQuery = { __typename?: 'Query', structure?: { __typename?: 'Structure', id: string, name: string } | null };

export type GetAllStructuresListForBreadcrumbQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAllStructuresListForBreadcrumbQuery = { __typename?: 'Query', allStructures: Array<{ __typename?: 'Structure', id: string, name: string, status: StructureStatus }> };

export type AllCommentsGenericQueryVariables = Exact<{
  input?: InputMaybe<AllCommentsInput>;
}>;


export type AllCommentsGenericQuery = { __typename?: 'Query', allComments?: Array<{ __typename?: 'Comment', id: string, key?: string | null, text: string, isEdited: boolean, status?: ZoneStatus | null, updatedAt: string, structureId: any, createdBy: string, createdAt: string, collectionName: string, metadata?: any | null, createdByDetails: { __typename?: 'CreatedByDetails', name: string, profilePicture: string } }> | null };

export type CreateCommentMutationVariables = Exact<{
  input: CreateCommentInput;
}>;


export type CreateCommentMutation = { __typename?: 'Mutation', createComment: { __typename?: 'Comment', text: string, structureId: any, createdByDetails: { __typename?: 'CreatedByDetails', name: string, profilePicture: string } } };

export type DeleteCommentMutationVariables = Exact<{
  structureId?: InputMaybe<Scalars['ID']['input']>;
  commentId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type DeleteCommentMutation = { __typename?: 'Mutation', deleteComment: { __typename?: 'Comment', id: string } };

export type CommentAddedSubscriptionVariables = Exact<{
  structureId?: InputMaybe<Scalars['ID']['input']>;
  referenceId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type CommentAddedSubscription = { __typename?: 'Subscription', commentAdded: { __typename?: 'Comment', id: string, text: string, isEdited: boolean, status?: ZoneStatus | null, updatedAt: string, structureId: any, createdBy: string, createdAt: string, collectionName: string, createdByDetails: { __typename?: 'CreatedByDetails', name: string, profilePicture: string } } };

export type CommentDeletedSubscriptionVariables = Exact<{
  structureId?: InputMaybe<Scalars['ID']['input']>;
  referenceId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type CommentDeletedSubscription = { __typename?: 'Subscription', commentDeleted: { __typename?: 'Comment', id: string } };

export type DecksForDeckListQueryVariables = Exact<{
  structureId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type DecksForDeckListQuery = { __typename?: 'Query', allDecks: Array<{ __typename?: 'Deck', id: string, name: string, resourcePath: string, heightRange: Array<number>, heightStep?: number | null }> };

export type GetActiveDeploymentForPlatformQueryVariables = Exact<{
  input: StructureFilters;
}>;


export type GetActiveDeploymentForPlatformQuery = { __typename?: 'Query', allStructures: Array<{ __typename?: 'Structure', id: string, name: string, isActive?: boolean | null, platform?: { __typename?: 'Platform', id: string } | null }> };

export type GetUserPreferencesForUnitSelectionQueryVariables = Exact<{ [key: string]: never; }>;


export type GetUserPreferencesForUnitSelectionQuery = { __typename?: 'Query', getUserPreferences?: { __typename?: 'UserPreferences', unit?: UnitSystemEnum | null } | null };

export type UpdatePreferencesMutationVariables = Exact<{
  input?: InputMaybe<UpdateUserPreferencesInput>;
}>;


export type UpdatePreferencesMutation = { __typename?: 'Mutation', updateUserPreferences?: { __typename?: 'User', preferences?: { __typename?: 'UserPreferences', unit?: UnitSystemEnum | null } | null } | null };

export type LocationQueryVariables = Exact<{
  locationId?: InputMaybe<Scalars['String']['input']>;
}>;


export type LocationQuery = { __typename?: 'Query', location?: { __typename?: 'Location', id: string, name: string, depthResourcePath?: string | null, depthResource?: string | null, resourcePath?: string | null, resource?: string | null, deck: { __typename?: 'Deck', id: string, name: string, resourcePath: string, cadTransform: Array<number> }, deckPlan?: { __typename?: 'LocationDeckPlan', id: string, coordinates: Array<number> } | null } | null };

export type GroupedReportsQueryVariables = Exact<{
  input?: InputMaybe<ReportsInput>;
}>;


export type GroupedReportsQuery = { __typename?: 'Query', groupedReports: Array<{ __typename?: 'GroupedReports', groupName: string, groupId: string, count: number } | null> };

export type CreateNewReportMutationVariables = Exact<{
  input?: InputMaybe<CreateNewReportInput>;
}>;


export type CreateNewReportMutation = { __typename?: 'Mutation', createNewReport: { __typename?: 'Report', createdAt: string, id?: string | null, name: string, status: ReportStatus, dueDate?: string | null, startDate?: string | null, actionStatus?: ReportActionStatus | null, type?: ReportType | null, workpackNumber?: string | null } };

export type CreateBulkReportsMutationVariables = Exact<{
  input?: InputMaybe<CreateNewReportInput>;
}>;


export type CreateBulkReportsMutation = { __typename?: 'Mutation', createBulkReports: Array<{ __typename?: 'Report', createdAt: string, id?: string | null, name: string, status: ReportStatus, dueDate?: string | null, startDate?: string | null, actionStatus?: ReportActionStatus | null, type?: ReportType | null, workpackNumber?: string | null } | null> };

export type GenerateReportPdfMutationVariables = Exact<{
  reportIds?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
}>;


export type GenerateReportPdfMutation = { __typename?: 'Mutation', generateReportPdf: { __typename?: 'PdfGenerationResult', downloadUrl: Array<string>, filename: Array<string> } };

export type FilteredOptionsQueryVariables = Exact<{
  templateId: Scalars['ID']['input'];
  fieldKey: Scalars['String']['input'];
  fieldId?: InputMaybe<Scalars['ID']['input']>;
  q?: InputMaybe<Scalars['String']['input']>;
  count?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type FilteredOptionsQuery = { __typename?: 'Query', filteredOptions: Array<{ __typename?: 'FilteredOptions', options: Array<string> }> };

export type AllPaintRegionsForFilterAndSearchPanelQueryVariables = Exact<{
  input: FindAllPaintRegionsInput;
}>;


export type AllPaintRegionsForFilterAndSearchPanelQuery = { __typename?: 'Query', allPaintRegions: Array<{ __typename?: 'PaintRegion', id: string, name: string, paintRegionGroupId?: string | null }> };

export type GetVersionsQueryVariables = Exact<{
  input?: InputMaybe<VersionInput>;
}>;


export type GetVersionsQuery = { __typename?: 'Query', allVersions: Array<{ __typename?: 'Version', id: string, structureId?: string | null, referenceId?: string | null, updatedData?: any | null, previousData?: any | null, collectionName: string, lastModifiedFor: string, lastModifiedBy?: string | null, createdAt: string, lastModifiedByUser?: { __typename?: 'User', id: string, name?: string | null, picture?: string | null, email: string, connection?: string | null, roleIds: Array<{ __typename?: 'Role', name: string, auth0Id: string, id: string } | null> } | null }> };

export type RollbackVersionMutationVariables = Exact<{
  input?: InputMaybe<RollbackVersionInput>;
}>;


export type RollbackVersionMutation = { __typename?: 'Mutation', rollbackVersion: { __typename?: 'Version', id: string } };

export type WorkpackForKpiTrackerQueryVariables = Exact<{
  workpackId?: InputMaybe<Scalars['String']['input']>;
}>;


export type WorkpackForKpiTrackerQuery = { __typename?: 'Query', workpack?: { __typename?: 'Workpack', id: string, name: string } | null };

export type AllWorklogsTemplatesForKpiTrackerQueryVariables = Exact<{
  input: LogsTemplateInput;
}>;


export type AllWorklogsTemplatesForKpiTrackerQuery = { __typename?: 'Query', allLogsTemplates?: Array<{ __typename?: 'LogsTemplate', id: string, name: string, sections: Array<{ __typename?: 'LogSection', id: string, key: string, title: string, sectionUnit?: SectionUnitsEnum | null, order: number, defaultOpen?: boolean | null, fieldKeys: Array<string>, displayInLogging?: boolean | null }>, fields: Array<{ __typename?: 'LogsTemplateField', id: string, key?: string | null, name: string, sectionKey?: string | null, displayInLogAggregation?: boolean | null, isDerived?: boolean | null, fieldDescription?: string | null, fieldUnit?: SectionUnitsEnum | null, roundToDecimal?: number | null }> }> | null };

export type AssemblyTemplatesQueryVariables = Exact<{
  structureId?: InputMaybe<Scalars['ID']['input']>;
  type?: InputMaybe<TemplateTypeEnum>;
}>;


export type AssemblyTemplatesQuery = { __typename?: 'Query', allTemplates: Array<{ __typename?: 'Template', id: string }> };

export type LogEntriesPerDateQueryVariables = Exact<{
  input: LogEntriesPerDateInput;
}>;


export type LogEntriesPerDateQuery = { __typename?: 'Query', logEntriesPerDate: Array<{ __typename?: 'LogEntryLogFieldTotal', fieldKey: string, total: number }> };

export type UpdateLogEntryMutationVariables = Exact<{
  input: UpdateLogEntryInput;
}>;


export type UpdateLogEntryMutation = { __typename?: 'Mutation', updateLogEntry: { __typename?: 'LogEntry', id: string, shift?: ShiftType | null, logDate: string } };

export type UpsertLogEntryMutationVariables = Exact<{
  input: UpsertLogEntryInput;
}>;


export type UpsertLogEntryMutation = { __typename?: 'Mutation', upsertLogEntry: { __typename?: 'LogEntry', id: string, shift?: ShiftType | null, logDate: string } };

export type GetAggregatedKpiLogEntriesQueryVariables = Exact<{
  input: AggregatedKpiLogEntriesInput;
  pageInfo?: InputMaybe<PageInfo>;
}>;


export type GetAggregatedKpiLogEntriesQuery = { __typename?: 'Query', getAggregatedKpiLogEntries: Array<{ __typename?: 'AggregatedKpiLogEntriesPerDate', endDate: string, logDate: string, startDate: string, fields: Array<{ __typename?: 'AggregatedKpiLogEntryField', value: number, fieldKey: string }>, fieldTotals: Array<{ __typename?: 'LogEntryLogFieldTotal', total: number, fieldKey: string }> }> };

export type GetLogEntryCardsQueryVariables = Exact<{
  input: LogEntryCardsInput;
}>;


export type GetLogEntryCardsQuery = { __typename?: 'Query', getLogEntryCards?: Array<{ __typename?: 'Card', icon?: string | null, key: string, roundToDecimal?: number | null, title?: string | null, unit?: SectionUnitsEnum | null, unitPosition?: UnitPositionEnum | null, value?: number | null, subtitle?: { __typename?: 'Subtitle', icon?: string | null, iconPosition?: InputAdormentPositionEnum | null, value?: number | null, unitPosition?: UnitPositionEnum | null, unit?: SectionUnitsEnum | null, text?: string | null } | null } | null> | null };

export type GetWorkpackAttachmentsPerDateQueryVariables = Exact<{
  input?: InputMaybe<WorkpackAttachmentsPerDateInput>;
}>;


export type GetWorkpackAttachmentsPerDateQuery = { __typename?: 'Query', getWorkpackAttachmentsPerDate: Array<{ __typename?: 'WorkpackFile', id?: string | null, uuid?: string | null, resourcePath: string, caption?: string | null, fileName: string, imagePosition?: number | null, logDate: string, name: string, size?: number | null, type: FileTypes, uploadStatus?: FileUploadStatus | null, url?: string | null }> };

export type UpdateKpiFiltersInPlatformPreferencesMutationVariables = Exact<{
  input?: InputMaybe<UpdateUserPlatformPreferencesInput>;
}>;


export type UpdateKpiFiltersInPlatformPreferencesMutation = { __typename?: 'Mutation', updateUserPlatformPreferences?: { __typename?: 'User', preferences?: { __typename?: 'UserPreferences', platform?: any | null } | null } | null };

export type UploadWorkpackAttachmentsMutationVariables = Exact<{
  input?: InputMaybe<UploadWorkpackAttachmentsInput>;
}>;


export type UploadWorkpackAttachmentsMutation = { __typename?: 'Mutation', uploadWorkpackAttachments: Array<{ __typename?: 'GeneratedPresignedURL', id: string, resourcePath: string, url: string, uuid: string }> };

export type RemoveWorkpackAttachmentsMutationVariables = Exact<{
  input: RemoveWorkpackAttachmentsInput;
}>;


export type RemoveWorkpackAttachmentsMutation = { __typename?: 'Mutation', removeWorkpackAttachments?: { __typename?: 'Workpack', name: string, id: string } | null };

export type UpdateWorkpackAttachmentFileStatusMutationVariables = Exact<{
  input?: InputMaybe<InputUpdateFileForWorkpack>;
}>;


export type UpdateWorkpackAttachmentFileStatusMutation = { __typename?: 'Mutation', updateWorkpackAttachmentFileStatus: { __typename?: 'Workpack', id: string, name: string } };

export type LogEntriesByReferenceQueryVariables = Exact<{
  input: FindLogEntriesByReferenceInput;
}>;


export type LogEntriesByReferenceQuery = { __typename?: 'Query', logEntriesByReference: Array<{ __typename?: 'LogEntry', id: string }> };

export const AssembliesFragmentDoc = gql`
    fragment assemblies on Assembly {
  pipeSpec {
    material
    nominalCorrosionAllowance
    nominalThickness
    schedule
    size
    spec
  }
  template {
    id
    name
    fields {
      id
      key
      name
    }
    reviewActionChecklistConfig {
      id
      reviewActionValue
      displayName
      isEnabled
      position
    }
  }
  templateFieldData
  service {
    group
  }
  id
  tagName
  area
  files {
    id
    name
    resourcePath
    type
    fileName
    uploadStatus
    imageType
    uuid
  }
}
    `;
export const PointOfInterestsFragmentDoc = gql`
    fragment pointOfInterests on PointOfInterest {
  id
  poiId
  name
  type
  accessibility
  workpackNumber
  workpack {
    id
    name
    status
  }
  isVerified
  status
  template {
    createdBy
    id
    name
    fields {
      id
      key
      type
    }
  }
  templateData {
    templateFieldId
    value
    verifiedValue
    id
  }
  assembly {
    ...assemblies
  }
  paintRegion {
    name
    deck {
      name
      imageDimensions
      resourcePath
      cadTransform
    }
  }
  centerPoint3d {
    x
    y
    z
  }
  blister {
    wallLoss {
      percentage
      value
    }
    residualCorrosionAllowance {
      percentage
      value
    }
    maxHeight
    verifiedMaxHeight
    estimatedHeight
    pdrHeight
    heightType
    isManuallyOverridden
    fittingRadius
    manualSetHeight
    residualThickness {
      percentage
      value
    }
    verifiedResidualThickness
    radius
    radiusPoint {
      bearing
      elevation
    }
    centerPoint {
      bearing
      elevation
    }
    borders {
      bearing
      elevation
    }
    distanceConfidence
    measurementConfidence
  }
  screenshotPaths {
    viewpoint
    viewer
  }
  location {
    id
    name
    deck {
      name
      imageDimensions
      resourcePath
      cadTransform
    }
  }
  files {
    id
    name
    resourcePath
    type
    fileName
    uploadStatus
    imageType
    uuid
  }
  deckRelativeHeight
  templateFieldData
  remediationNote
}
    ${AssembliesFragmentDoc}`;
export const TemplatesFragmentDoc = gql`
    fragment templates on PointOfInterestTemplate {
  createdBy
  fields {
    id
    key
    isReadOnly
    isRequired
    isHidden
    name
    options
    type
  }
  id
  name
}
    `;
export const GetStructureForCadAlignmentDocument = gql`
    query getStructureForCadAlignment($structureId: String) {
  structure(structureId: $structureId) {
    octreeResourcesPath
    cadOctreeResourcesPath
    scansToCadTransform
  }
}
    `;

/**
 * __useGetStructureForCadAlignmentQuery__
 *
 * To run a query within a React component, call `useGetStructureForCadAlignmentQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetStructureForCadAlignmentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetStructureForCadAlignmentQuery({
 *   variables: {
 *      structureId: // value for 'structureId'
 *   },
 * });
 */
export function useGetStructureForCadAlignmentQuery(baseOptions?: Apollo.QueryHookOptions<GetStructureForCadAlignmentQuery, GetStructureForCadAlignmentQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetStructureForCadAlignmentQuery, GetStructureForCadAlignmentQueryVariables>(GetStructureForCadAlignmentDocument, options);
      }
export function useGetStructureForCadAlignmentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetStructureForCadAlignmentQuery, GetStructureForCadAlignmentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetStructureForCadAlignmentQuery, GetStructureForCadAlignmentQueryVariables>(GetStructureForCadAlignmentDocument, options);
        }
// @ts-ignore
export function useGetStructureForCadAlignmentSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetStructureForCadAlignmentQuery, GetStructureForCadAlignmentQueryVariables>): Apollo.UseSuspenseQueryResult<GetStructureForCadAlignmentQuery, GetStructureForCadAlignmentQueryVariables>;
export function useGetStructureForCadAlignmentSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetStructureForCadAlignmentQuery, GetStructureForCadAlignmentQueryVariables>): Apollo.UseSuspenseQueryResult<GetStructureForCadAlignmentQuery | undefined, GetStructureForCadAlignmentQueryVariables>;
export function useGetStructureForCadAlignmentSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetStructureForCadAlignmentQuery, GetStructureForCadAlignmentQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetStructureForCadAlignmentQuery, GetStructureForCadAlignmentQueryVariables>(GetStructureForCadAlignmentDocument, options);
        }
export type GetStructureForCadAlignmentQueryHookResult = ReturnType<typeof useGetStructureForCadAlignmentQuery>;
export type GetStructureForCadAlignmentLazyQueryHookResult = ReturnType<typeof useGetStructureForCadAlignmentLazyQuery>;
export type GetStructureForCadAlignmentSuspenseQueryHookResult = ReturnType<typeof useGetStructureForCadAlignmentSuspenseQuery>;
export type GetStructureForCadAlignmentQueryResult = Apollo.QueryResult<GetStructureForCadAlignmentQuery, GetStructureForCadAlignmentQueryVariables>;
export const UpdateScansToCadTransformDocument = gql`
    mutation updateScansToCadTransform($structureId: ID!, $scansToCadTransform: [Float!]!) {
  updateScansToCadTransform(
    structureId: $structureId
    scansToCadTransform: $scansToCadTransform
  ) {
    id
    scansToCadTransform
  }
}
    `;
export type UpdateScansToCadTransformMutationFn = Apollo.MutationFunction<UpdateScansToCadTransformMutation, UpdateScansToCadTransformMutationVariables>;

/**
 * __useUpdateScansToCadTransformMutation__
 *
 * To run a mutation, you first call `useUpdateScansToCadTransformMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateScansToCadTransformMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateScansToCadTransformMutation, { data, loading, error }] = useUpdateScansToCadTransformMutation({
 *   variables: {
 *      structureId: // value for 'structureId'
 *      scansToCadTransform: // value for 'scansToCadTransform'
 *   },
 * });
 */
export function useUpdateScansToCadTransformMutation(baseOptions?: Apollo.MutationHookOptions<UpdateScansToCadTransformMutation, UpdateScansToCadTransformMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateScansToCadTransformMutation, UpdateScansToCadTransformMutationVariables>(UpdateScansToCadTransformDocument, options);
      }
export type UpdateScansToCadTransformMutationHookResult = ReturnType<typeof useUpdateScansToCadTransformMutation>;
export type UpdateScansToCadTransformMutationResult = Apollo.MutationResult<UpdateScansToCadTransformMutation>;
export type UpdateScansToCadTransformMutationOptions = Apollo.BaseMutationOptions<UpdateScansToCadTransformMutation, UpdateScansToCadTransformMutationVariables>;
export const AllDecksForDeckPlanExplorerDocument = gql`
    query AllDecksForDeckPlanExplorer($structureId: ID) {
  allDecks(structureId: $structureId) {
    id
    name
    resourcePath
    heightRange
    heightStep
  }
}
    `;

/**
 * __useAllDecksForDeckPlanExplorerQuery__
 *
 * To run a query within a React component, call `useAllDecksForDeckPlanExplorerQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllDecksForDeckPlanExplorerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllDecksForDeckPlanExplorerQuery({
 *   variables: {
 *      structureId: // value for 'structureId'
 *   },
 * });
 */
export function useAllDecksForDeckPlanExplorerQuery(baseOptions?: Apollo.QueryHookOptions<AllDecksForDeckPlanExplorerQuery, AllDecksForDeckPlanExplorerQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AllDecksForDeckPlanExplorerQuery, AllDecksForDeckPlanExplorerQueryVariables>(AllDecksForDeckPlanExplorerDocument, options);
      }
export function useAllDecksForDeckPlanExplorerLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AllDecksForDeckPlanExplorerQuery, AllDecksForDeckPlanExplorerQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AllDecksForDeckPlanExplorerQuery, AllDecksForDeckPlanExplorerQueryVariables>(AllDecksForDeckPlanExplorerDocument, options);
        }
// @ts-ignore
export function useAllDecksForDeckPlanExplorerSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<AllDecksForDeckPlanExplorerQuery, AllDecksForDeckPlanExplorerQueryVariables>): Apollo.UseSuspenseQueryResult<AllDecksForDeckPlanExplorerQuery, AllDecksForDeckPlanExplorerQueryVariables>;
export function useAllDecksForDeckPlanExplorerSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AllDecksForDeckPlanExplorerQuery, AllDecksForDeckPlanExplorerQueryVariables>): Apollo.UseSuspenseQueryResult<AllDecksForDeckPlanExplorerQuery | undefined, AllDecksForDeckPlanExplorerQueryVariables>;
export function useAllDecksForDeckPlanExplorerSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AllDecksForDeckPlanExplorerQuery, AllDecksForDeckPlanExplorerQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AllDecksForDeckPlanExplorerQuery, AllDecksForDeckPlanExplorerQueryVariables>(AllDecksForDeckPlanExplorerDocument, options);
        }
export type AllDecksForDeckPlanExplorerQueryHookResult = ReturnType<typeof useAllDecksForDeckPlanExplorerQuery>;
export type AllDecksForDeckPlanExplorerLazyQueryHookResult = ReturnType<typeof useAllDecksForDeckPlanExplorerLazyQuery>;
export type AllDecksForDeckPlanExplorerSuspenseQueryHookResult = ReturnType<typeof useAllDecksForDeckPlanExplorerSuspenseQuery>;
export type AllDecksForDeckPlanExplorerQueryResult = Apollo.QueryResult<AllDecksForDeckPlanExplorerQuery, AllDecksForDeckPlanExplorerQueryVariables>;
export const FetchSpatialHeatmapDocument = gql`
    query FetchSpatialHeatmap($heatmapParameters: SpatialHeatmapInput) {
  fetchSpatialHeatmap(heatmapParameters: $heatmapParameters) {
    svg
  }
}
    `;

/**
 * __useFetchSpatialHeatmapQuery__
 *
 * To run a query within a React component, call `useFetchSpatialHeatmapQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchSpatialHeatmapQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchSpatialHeatmapQuery({
 *   variables: {
 *      heatmapParameters: // value for 'heatmapParameters'
 *   },
 * });
 */
export function useFetchSpatialHeatmapQuery(baseOptions?: Apollo.QueryHookOptions<FetchSpatialHeatmapQuery, FetchSpatialHeatmapQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchSpatialHeatmapQuery, FetchSpatialHeatmapQueryVariables>(FetchSpatialHeatmapDocument, options);
      }
export function useFetchSpatialHeatmapLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchSpatialHeatmapQuery, FetchSpatialHeatmapQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchSpatialHeatmapQuery, FetchSpatialHeatmapQueryVariables>(FetchSpatialHeatmapDocument, options);
        }
// @ts-ignore
export function useFetchSpatialHeatmapSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<FetchSpatialHeatmapQuery, FetchSpatialHeatmapQueryVariables>): Apollo.UseSuspenseQueryResult<FetchSpatialHeatmapQuery, FetchSpatialHeatmapQueryVariables>;
export function useFetchSpatialHeatmapSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FetchSpatialHeatmapQuery, FetchSpatialHeatmapQueryVariables>): Apollo.UseSuspenseQueryResult<FetchSpatialHeatmapQuery | undefined, FetchSpatialHeatmapQueryVariables>;
export function useFetchSpatialHeatmapSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FetchSpatialHeatmapQuery, FetchSpatialHeatmapQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FetchSpatialHeatmapQuery, FetchSpatialHeatmapQueryVariables>(FetchSpatialHeatmapDocument, options);
        }
export type FetchSpatialHeatmapQueryHookResult = ReturnType<typeof useFetchSpatialHeatmapQuery>;
export type FetchSpatialHeatmapLazyQueryHookResult = ReturnType<typeof useFetchSpatialHeatmapLazyQuery>;
export type FetchSpatialHeatmapSuspenseQueryHookResult = ReturnType<typeof useFetchSpatialHeatmapSuspenseQuery>;
export type FetchSpatialHeatmapQueryResult = Apollo.QueryResult<FetchSpatialHeatmapQuery, FetchSpatialHeatmapQueryVariables>;
export const AllDefectsInDeckDocument = gql`
    query AllDefectsInDeck($structureId: ID) {
  allDefects(structureId: $structureId) {
    key
    name
  }
}
    `;

/**
 * __useAllDefectsInDeckQuery__
 *
 * To run a query within a React component, call `useAllDefectsInDeckQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllDefectsInDeckQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllDefectsInDeckQuery({
 *   variables: {
 *      structureId: // value for 'structureId'
 *   },
 * });
 */
export function useAllDefectsInDeckQuery(baseOptions?: Apollo.QueryHookOptions<AllDefectsInDeckQuery, AllDefectsInDeckQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AllDefectsInDeckQuery, AllDefectsInDeckQueryVariables>(AllDefectsInDeckDocument, options);
      }
export function useAllDefectsInDeckLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AllDefectsInDeckQuery, AllDefectsInDeckQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AllDefectsInDeckQuery, AllDefectsInDeckQueryVariables>(AllDefectsInDeckDocument, options);
        }
// @ts-ignore
export function useAllDefectsInDeckSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<AllDefectsInDeckQuery, AllDefectsInDeckQueryVariables>): Apollo.UseSuspenseQueryResult<AllDefectsInDeckQuery, AllDefectsInDeckQueryVariables>;
export function useAllDefectsInDeckSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AllDefectsInDeckQuery, AllDefectsInDeckQueryVariables>): Apollo.UseSuspenseQueryResult<AllDefectsInDeckQuery | undefined, AllDefectsInDeckQueryVariables>;
export function useAllDefectsInDeckSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AllDefectsInDeckQuery, AllDefectsInDeckQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AllDefectsInDeckQuery, AllDefectsInDeckQueryVariables>(AllDefectsInDeckDocument, options);
        }
export type AllDefectsInDeckQueryHookResult = ReturnType<typeof useAllDefectsInDeckQuery>;
export type AllDefectsInDeckLazyQueryHookResult = ReturnType<typeof useAllDefectsInDeckLazyQuery>;
export type AllDefectsInDeckSuspenseQueryHookResult = ReturnType<typeof useAllDefectsInDeckSuspenseQuery>;
export type AllDefectsInDeckQueryResult = Apollo.QueryResult<AllDefectsInDeckQuery, AllDefectsInDeckQueryVariables>;
export const AllLocationsForAssemblyForDeckPlanDocument = gql`
    query AllLocationsForAssemblyForDeckPlan($input: LocationsForAssemblyInput) {
  allLocationsForAssembly(input: $input) {
    id
    resource
    resourcePath
    depthResourcePath
    name
    deckPlan {
      id
      coordinates
    }
    deck {
      name
    }
    distance
    imageSensor {
      width
      height
      cx
      cy
      focalLength
    }
    videoResourcePath
    videoTimestamp
    pose {
      yaw
      yawOffset
      z
      y
      x
      roll
      pitch
    }
  }
}
    `;

/**
 * __useAllLocationsForAssemblyForDeckPlanQuery__
 *
 * To run a query within a React component, call `useAllLocationsForAssemblyForDeckPlanQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllLocationsForAssemblyForDeckPlanQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllLocationsForAssemblyForDeckPlanQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAllLocationsForAssemblyForDeckPlanQuery(baseOptions?: Apollo.QueryHookOptions<AllLocationsForAssemblyForDeckPlanQuery, AllLocationsForAssemblyForDeckPlanQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AllLocationsForAssemblyForDeckPlanQuery, AllLocationsForAssemblyForDeckPlanQueryVariables>(AllLocationsForAssemblyForDeckPlanDocument, options);
      }
export function useAllLocationsForAssemblyForDeckPlanLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AllLocationsForAssemblyForDeckPlanQuery, AllLocationsForAssemblyForDeckPlanQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AllLocationsForAssemblyForDeckPlanQuery, AllLocationsForAssemblyForDeckPlanQueryVariables>(AllLocationsForAssemblyForDeckPlanDocument, options);
        }
// @ts-ignore
export function useAllLocationsForAssemblyForDeckPlanSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<AllLocationsForAssemblyForDeckPlanQuery, AllLocationsForAssemblyForDeckPlanQueryVariables>): Apollo.UseSuspenseQueryResult<AllLocationsForAssemblyForDeckPlanQuery, AllLocationsForAssemblyForDeckPlanQueryVariables>;
export function useAllLocationsForAssemblyForDeckPlanSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AllLocationsForAssemblyForDeckPlanQuery, AllLocationsForAssemblyForDeckPlanQueryVariables>): Apollo.UseSuspenseQueryResult<AllLocationsForAssemblyForDeckPlanQuery | undefined, AllLocationsForAssemblyForDeckPlanQueryVariables>;
export function useAllLocationsForAssemblyForDeckPlanSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AllLocationsForAssemblyForDeckPlanQuery, AllLocationsForAssemblyForDeckPlanQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AllLocationsForAssemblyForDeckPlanQuery, AllLocationsForAssemblyForDeckPlanQueryVariables>(AllLocationsForAssemblyForDeckPlanDocument, options);
        }
export type AllLocationsForAssemblyForDeckPlanQueryHookResult = ReturnType<typeof useAllLocationsForAssemblyForDeckPlanQuery>;
export type AllLocationsForAssemblyForDeckPlanLazyQueryHookResult = ReturnType<typeof useAllLocationsForAssemblyForDeckPlanLazyQuery>;
export type AllLocationsForAssemblyForDeckPlanSuspenseQueryHookResult = ReturnType<typeof useAllLocationsForAssemblyForDeckPlanSuspenseQuery>;
export type AllLocationsForAssemblyForDeckPlanQueryResult = Apollo.QueryResult<AllLocationsForAssemblyForDeckPlanQuery, AllLocationsForAssemblyForDeckPlanQueryVariables>;
export const AllPaintRegionsForDeckPlanDocument = gql`
    query AllPaintRegionsForDeckPlan($input: FindAllPaintRegionsInput!) {
  allPaintRegions(input: $input) {
    id
    name
    polygons {
      area
      points
      type
    }
  }
}
    `;

/**
 * __useAllPaintRegionsForDeckPlanQuery__
 *
 * To run a query within a React component, call `useAllPaintRegionsForDeckPlanQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllPaintRegionsForDeckPlanQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllPaintRegionsForDeckPlanQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAllPaintRegionsForDeckPlanQuery(baseOptions: Apollo.QueryHookOptions<AllPaintRegionsForDeckPlanQuery, AllPaintRegionsForDeckPlanQueryVariables> & ({ variables: AllPaintRegionsForDeckPlanQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AllPaintRegionsForDeckPlanQuery, AllPaintRegionsForDeckPlanQueryVariables>(AllPaintRegionsForDeckPlanDocument, options);
      }
export function useAllPaintRegionsForDeckPlanLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AllPaintRegionsForDeckPlanQuery, AllPaintRegionsForDeckPlanQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AllPaintRegionsForDeckPlanQuery, AllPaintRegionsForDeckPlanQueryVariables>(AllPaintRegionsForDeckPlanDocument, options);
        }
// @ts-ignore
export function useAllPaintRegionsForDeckPlanSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<AllPaintRegionsForDeckPlanQuery, AllPaintRegionsForDeckPlanQueryVariables>): Apollo.UseSuspenseQueryResult<AllPaintRegionsForDeckPlanQuery, AllPaintRegionsForDeckPlanQueryVariables>;
export function useAllPaintRegionsForDeckPlanSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AllPaintRegionsForDeckPlanQuery, AllPaintRegionsForDeckPlanQueryVariables>): Apollo.UseSuspenseQueryResult<AllPaintRegionsForDeckPlanQuery | undefined, AllPaintRegionsForDeckPlanQueryVariables>;
export function useAllPaintRegionsForDeckPlanSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AllPaintRegionsForDeckPlanQuery, AllPaintRegionsForDeckPlanQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AllPaintRegionsForDeckPlanQuery, AllPaintRegionsForDeckPlanQueryVariables>(AllPaintRegionsForDeckPlanDocument, options);
        }
export type AllPaintRegionsForDeckPlanQueryHookResult = ReturnType<typeof useAllPaintRegionsForDeckPlanQuery>;
export type AllPaintRegionsForDeckPlanLazyQueryHookResult = ReturnType<typeof useAllPaintRegionsForDeckPlanLazyQuery>;
export type AllPaintRegionsForDeckPlanSuspenseQueryHookResult = ReturnType<typeof useAllPaintRegionsForDeckPlanSuspenseQuery>;
export type AllPaintRegionsForDeckPlanQueryResult = Apollo.QueryResult<AllPaintRegionsForDeckPlanQuery, AllPaintRegionsForDeckPlanQueryVariables>;
export const DefectLegendsDeckSummaryDocument = gql`
    query DefectLegendsDeckSummary($structureId: String) {
  structure(structureId: $structureId) {
    defectLegends {
      id
      name
      color
      groupName
      groupKey
      octreeKey
      octreeValue
      legendText
    }
    id
    name
  }
}
    `;

/**
 * __useDefectLegendsDeckSummaryQuery__
 *
 * To run a query within a React component, call `useDefectLegendsDeckSummaryQuery` and pass it any options that fit your needs.
 * When your component renders, `useDefectLegendsDeckSummaryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDefectLegendsDeckSummaryQuery({
 *   variables: {
 *      structureId: // value for 'structureId'
 *   },
 * });
 */
export function useDefectLegendsDeckSummaryQuery(baseOptions?: Apollo.QueryHookOptions<DefectLegendsDeckSummaryQuery, DefectLegendsDeckSummaryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DefectLegendsDeckSummaryQuery, DefectLegendsDeckSummaryQueryVariables>(DefectLegendsDeckSummaryDocument, options);
      }
export function useDefectLegendsDeckSummaryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DefectLegendsDeckSummaryQuery, DefectLegendsDeckSummaryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DefectLegendsDeckSummaryQuery, DefectLegendsDeckSummaryQueryVariables>(DefectLegendsDeckSummaryDocument, options);
        }
// @ts-ignore
export function useDefectLegendsDeckSummarySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<DefectLegendsDeckSummaryQuery, DefectLegendsDeckSummaryQueryVariables>): Apollo.UseSuspenseQueryResult<DefectLegendsDeckSummaryQuery, DefectLegendsDeckSummaryQueryVariables>;
export function useDefectLegendsDeckSummarySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DefectLegendsDeckSummaryQuery, DefectLegendsDeckSummaryQueryVariables>): Apollo.UseSuspenseQueryResult<DefectLegendsDeckSummaryQuery | undefined, DefectLegendsDeckSummaryQueryVariables>;
export function useDefectLegendsDeckSummarySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DefectLegendsDeckSummaryQuery, DefectLegendsDeckSummaryQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DefectLegendsDeckSummaryQuery, DefectLegendsDeckSummaryQueryVariables>(DefectLegendsDeckSummaryDocument, options);
        }
export type DefectLegendsDeckSummaryQueryHookResult = ReturnType<typeof useDefectLegendsDeckSummaryQuery>;
export type DefectLegendsDeckSummaryLazyQueryHookResult = ReturnType<typeof useDefectLegendsDeckSummaryLazyQuery>;
export type DefectLegendsDeckSummarySuspenseQueryHookResult = ReturnType<typeof useDefectLegendsDeckSummarySuspenseQuery>;
export type DefectLegendsDeckSummaryQueryResult = Apollo.QueryResult<DefectLegendsDeckSummaryQuery, DefectLegendsDeckSummaryQueryVariables>;
export const AssembliesDecksSummaryDocument = gql`
    query AssembliesDecksSummary($input: AssembliesFilterInput) {
  getAssembliesDecksSummary(input: $input) {
    deckId
    totalArea
  }
}
    `;

/**
 * __useAssembliesDecksSummaryQuery__
 *
 * To run a query within a React component, call `useAssembliesDecksSummaryQuery` and pass it any options that fit your needs.
 * When your component renders, `useAssembliesDecksSummaryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAssembliesDecksSummaryQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAssembliesDecksSummaryQuery(baseOptions?: Apollo.QueryHookOptions<AssembliesDecksSummaryQuery, AssembliesDecksSummaryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AssembliesDecksSummaryQuery, AssembliesDecksSummaryQueryVariables>(AssembliesDecksSummaryDocument, options);
      }
export function useAssembliesDecksSummaryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AssembliesDecksSummaryQuery, AssembliesDecksSummaryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AssembliesDecksSummaryQuery, AssembliesDecksSummaryQueryVariables>(AssembliesDecksSummaryDocument, options);
        }
// @ts-ignore
export function useAssembliesDecksSummarySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<AssembliesDecksSummaryQuery, AssembliesDecksSummaryQueryVariables>): Apollo.UseSuspenseQueryResult<AssembliesDecksSummaryQuery, AssembliesDecksSummaryQueryVariables>;
export function useAssembliesDecksSummarySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AssembliesDecksSummaryQuery, AssembliesDecksSummaryQueryVariables>): Apollo.UseSuspenseQueryResult<AssembliesDecksSummaryQuery | undefined, AssembliesDecksSummaryQueryVariables>;
export function useAssembliesDecksSummarySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AssembliesDecksSummaryQuery, AssembliesDecksSummaryQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AssembliesDecksSummaryQuery, AssembliesDecksSummaryQueryVariables>(AssembliesDecksSummaryDocument, options);
        }
export type AssembliesDecksSummaryQueryHookResult = ReturnType<typeof useAssembliesDecksSummaryQuery>;
export type AssembliesDecksSummaryLazyQueryHookResult = ReturnType<typeof useAssembliesDecksSummaryLazyQuery>;
export type AssembliesDecksSummarySuspenseQueryHookResult = ReturnType<typeof useAssembliesDecksSummarySuspenseQuery>;
export type AssembliesDecksSummaryQueryResult = Apollo.QueryResult<AssembliesDecksSummaryQuery, AssembliesDecksSummaryQueryVariables>;
export const AllPointOfInterestsForDecksDocument = gql`
    query AllPointOfInterestsForDecks($structureId: ID, $assemblyTemplateId: ID!, $input: FindAllPointOfInterestsInput) {
  allPointOfInterestTemplate(
    structureId: $structureId
    assemblyTemplateId: $assemblyTemplateId
  ) {
    id
    name
    type
    key
  }
  allPointOfInterests(input: $input) {
    template {
      id
    }
    centerPoint3d {
      x
      y
    }
    paintRegion {
      deck {
        id
        cadTransform
      }
    }
  }
}
    `;

/**
 * __useAllPointOfInterestsForDecksQuery__
 *
 * To run a query within a React component, call `useAllPointOfInterestsForDecksQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllPointOfInterestsForDecksQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllPointOfInterestsForDecksQuery({
 *   variables: {
 *      structureId: // value for 'structureId'
 *      assemblyTemplateId: // value for 'assemblyTemplateId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAllPointOfInterestsForDecksQuery(baseOptions: Apollo.QueryHookOptions<AllPointOfInterestsForDecksQuery, AllPointOfInterestsForDecksQueryVariables> & ({ variables: AllPointOfInterestsForDecksQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AllPointOfInterestsForDecksQuery, AllPointOfInterestsForDecksQueryVariables>(AllPointOfInterestsForDecksDocument, options);
      }
export function useAllPointOfInterestsForDecksLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AllPointOfInterestsForDecksQuery, AllPointOfInterestsForDecksQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AllPointOfInterestsForDecksQuery, AllPointOfInterestsForDecksQueryVariables>(AllPointOfInterestsForDecksDocument, options);
        }
// @ts-ignore
export function useAllPointOfInterestsForDecksSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<AllPointOfInterestsForDecksQuery, AllPointOfInterestsForDecksQueryVariables>): Apollo.UseSuspenseQueryResult<AllPointOfInterestsForDecksQuery, AllPointOfInterestsForDecksQueryVariables>;
export function useAllPointOfInterestsForDecksSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AllPointOfInterestsForDecksQuery, AllPointOfInterestsForDecksQueryVariables>): Apollo.UseSuspenseQueryResult<AllPointOfInterestsForDecksQuery | undefined, AllPointOfInterestsForDecksQueryVariables>;
export function useAllPointOfInterestsForDecksSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AllPointOfInterestsForDecksQuery, AllPointOfInterestsForDecksQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AllPointOfInterestsForDecksQuery, AllPointOfInterestsForDecksQueryVariables>(AllPointOfInterestsForDecksDocument, options);
        }
export type AllPointOfInterestsForDecksQueryHookResult = ReturnType<typeof useAllPointOfInterestsForDecksQuery>;
export type AllPointOfInterestsForDecksLazyQueryHookResult = ReturnType<typeof useAllPointOfInterestsForDecksLazyQuery>;
export type AllPointOfInterestsForDecksSuspenseQueryHookResult = ReturnType<typeof useAllPointOfInterestsForDecksSuspenseQuery>;
export type AllPointOfInterestsForDecksQueryResult = Apollo.QueryResult<AllPointOfInterestsForDecksQuery, AllPointOfInterestsForDecksQueryVariables>;
export const ValidateIdmsFileDocument = gql`
    query ValidateIdmsFile($input: ValidateIdmsTemplateQueryInput!) {
  validateIdmsTemplate(input: $input)
}
    `;

/**
 * __useValidateIdmsFileQuery__
 *
 * To run a query within a React component, call `useValidateIdmsFileQuery` and pass it any options that fit your needs.
 * When your component renders, `useValidateIdmsFileQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useValidateIdmsFileQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useValidateIdmsFileQuery(baseOptions: Apollo.QueryHookOptions<ValidateIdmsFileQuery, ValidateIdmsFileQueryVariables> & ({ variables: ValidateIdmsFileQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ValidateIdmsFileQuery, ValidateIdmsFileQueryVariables>(ValidateIdmsFileDocument, options);
      }
export function useValidateIdmsFileLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ValidateIdmsFileQuery, ValidateIdmsFileQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ValidateIdmsFileQuery, ValidateIdmsFileQueryVariables>(ValidateIdmsFileDocument, options);
        }
// @ts-ignore
export function useValidateIdmsFileSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ValidateIdmsFileQuery, ValidateIdmsFileQueryVariables>): Apollo.UseSuspenseQueryResult<ValidateIdmsFileQuery, ValidateIdmsFileQueryVariables>;
export function useValidateIdmsFileSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ValidateIdmsFileQuery, ValidateIdmsFileQueryVariables>): Apollo.UseSuspenseQueryResult<ValidateIdmsFileQuery | undefined, ValidateIdmsFileQueryVariables>;
export function useValidateIdmsFileSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ValidateIdmsFileQuery, ValidateIdmsFileQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ValidateIdmsFileQuery, ValidateIdmsFileQueryVariables>(ValidateIdmsFileDocument, options);
        }
export type ValidateIdmsFileQueryHookResult = ReturnType<typeof useValidateIdmsFileQuery>;
export type ValidateIdmsFileLazyQueryHookResult = ReturnType<typeof useValidateIdmsFileLazyQuery>;
export type ValidateIdmsFileSuspenseQueryHookResult = ReturnType<typeof useValidateIdmsFileSuspenseQuery>;
export type ValidateIdmsFileQueryResult = Apollo.QueryResult<ValidateIdmsFileQuery, ValidateIdmsFileQueryVariables>;
export const IdmsFileUploadDocument = gql`
    mutation IdmsFileUpload($input: IdmsUploadMutationInput!) {
  idmsFileUpload(input: $input) {
    name
    filePath
  }
}
    `;
export type IdmsFileUploadMutationFn = Apollo.MutationFunction<IdmsFileUploadMutation, IdmsFileUploadMutationVariables>;

/**
 * __useIdmsFileUploadMutation__
 *
 * To run a mutation, you first call `useIdmsFileUploadMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useIdmsFileUploadMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [idmsFileUploadMutation, { data, loading, error }] = useIdmsFileUploadMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useIdmsFileUploadMutation(baseOptions?: Apollo.MutationHookOptions<IdmsFileUploadMutation, IdmsFileUploadMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<IdmsFileUploadMutation, IdmsFileUploadMutationVariables>(IdmsFileUploadDocument, options);
      }
export type IdmsFileUploadMutationHookResult = ReturnType<typeof useIdmsFileUploadMutation>;
export type IdmsFileUploadMutationResult = Apollo.MutationResult<IdmsFileUploadMutation>;
export type IdmsFileUploadMutationOptions = Apollo.BaseMutationOptions<IdmsFileUploadMutation, IdmsFileUploadMutationVariables>;
export const IdmsUploadsDocument = gql`
    query IdmsUploads($structureId: ID) {
  idmsUploads(structureId: $structureId) {
    id
    name
    templateType
    createdAt
    filePath
  }
}
    `;

/**
 * __useIdmsUploadsQuery__
 *
 * To run a query within a React component, call `useIdmsUploadsQuery` and pass it any options that fit your needs.
 * When your component renders, `useIdmsUploadsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIdmsUploadsQuery({
 *   variables: {
 *      structureId: // value for 'structureId'
 *   },
 * });
 */
export function useIdmsUploadsQuery(baseOptions?: Apollo.QueryHookOptions<IdmsUploadsQuery, IdmsUploadsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IdmsUploadsQuery, IdmsUploadsQueryVariables>(IdmsUploadsDocument, options);
      }
export function useIdmsUploadsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IdmsUploadsQuery, IdmsUploadsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IdmsUploadsQuery, IdmsUploadsQueryVariables>(IdmsUploadsDocument, options);
        }
// @ts-ignore
export function useIdmsUploadsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<IdmsUploadsQuery, IdmsUploadsQueryVariables>): Apollo.UseSuspenseQueryResult<IdmsUploadsQuery, IdmsUploadsQueryVariables>;
export function useIdmsUploadsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<IdmsUploadsQuery, IdmsUploadsQueryVariables>): Apollo.UseSuspenseQueryResult<IdmsUploadsQuery | undefined, IdmsUploadsQueryVariables>;
export function useIdmsUploadsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<IdmsUploadsQuery, IdmsUploadsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<IdmsUploadsQuery, IdmsUploadsQueryVariables>(IdmsUploadsDocument, options);
        }
export type IdmsUploadsQueryHookResult = ReturnType<typeof useIdmsUploadsQuery>;
export type IdmsUploadsLazyQueryHookResult = ReturnType<typeof useIdmsUploadsLazyQuery>;
export type IdmsUploadsSuspenseQueryHookResult = ReturnType<typeof useIdmsUploadsSuspenseQuery>;
export type IdmsUploadsQueryResult = Apollo.QueryResult<IdmsUploadsQuery, IdmsUploadsQueryVariables>;
export const IdmsTasksDocument = gql`
    query IdmsTasks($structureId: ID!, $pageInfo: PageInfo) {
  idmsTasks(structureId: $structureId, pageInfo: $pageInfo) {
    count
    tasks {
      id
      idmsTaskNumber
      taskDueDate
      createdAt
      lineNumber
      recommendations {
        id
        lineNumber
        recommendationNumber
        recommendationType
        status
        statusUpdatedAt
        workOrders {
          id
          lineNumber
          poiName
          recommendationNumber
          status
          statusUpdatedAt
          workOrderNumber
        }
      }
      status
      statusUpdatedAt
    }
  }
}
    `;

/**
 * __useIdmsTasksQuery__
 *
 * To run a query within a React component, call `useIdmsTasksQuery` and pass it any options that fit your needs.
 * When your component renders, `useIdmsTasksQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIdmsTasksQuery({
 *   variables: {
 *      structureId: // value for 'structureId'
 *      pageInfo: // value for 'pageInfo'
 *   },
 * });
 */
export function useIdmsTasksQuery(baseOptions: Apollo.QueryHookOptions<IdmsTasksQuery, IdmsTasksQueryVariables> & ({ variables: IdmsTasksQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IdmsTasksQuery, IdmsTasksQueryVariables>(IdmsTasksDocument, options);
      }
export function useIdmsTasksLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IdmsTasksQuery, IdmsTasksQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IdmsTasksQuery, IdmsTasksQueryVariables>(IdmsTasksDocument, options);
        }
// @ts-ignore
export function useIdmsTasksSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<IdmsTasksQuery, IdmsTasksQueryVariables>): Apollo.UseSuspenseQueryResult<IdmsTasksQuery, IdmsTasksQueryVariables>;
export function useIdmsTasksSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<IdmsTasksQuery, IdmsTasksQueryVariables>): Apollo.UseSuspenseQueryResult<IdmsTasksQuery | undefined, IdmsTasksQueryVariables>;
export function useIdmsTasksSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<IdmsTasksQuery, IdmsTasksQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<IdmsTasksQuery, IdmsTasksQueryVariables>(IdmsTasksDocument, options);
        }
export type IdmsTasksQueryHookResult = ReturnType<typeof useIdmsTasksQuery>;
export type IdmsTasksLazyQueryHookResult = ReturnType<typeof useIdmsTasksLazyQuery>;
export type IdmsTasksSuspenseQueryHookResult = ReturnType<typeof useIdmsTasksSuspenseQuery>;
export type IdmsTasksQueryResult = Apollo.QueryResult<IdmsTasksQuery, IdmsTasksQueryVariables>;
export const LatestIdmsUploadsByTypeDocument = gql`
    query LatestIdmsUploadsByType($structureId: ID) {
  latestIdmsUploadsByType(structureId: $structureId) {
    name
    createdAt
    templateType
    filePath
  }
}
    `;

/**
 * __useLatestIdmsUploadsByTypeQuery__
 *
 * To run a query within a React component, call `useLatestIdmsUploadsByTypeQuery` and pass it any options that fit your needs.
 * When your component renders, `useLatestIdmsUploadsByTypeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLatestIdmsUploadsByTypeQuery({
 *   variables: {
 *      structureId: // value for 'structureId'
 *   },
 * });
 */
export function useLatestIdmsUploadsByTypeQuery(baseOptions?: Apollo.QueryHookOptions<LatestIdmsUploadsByTypeQuery, LatestIdmsUploadsByTypeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LatestIdmsUploadsByTypeQuery, LatestIdmsUploadsByTypeQueryVariables>(LatestIdmsUploadsByTypeDocument, options);
      }
export function useLatestIdmsUploadsByTypeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LatestIdmsUploadsByTypeQuery, LatestIdmsUploadsByTypeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LatestIdmsUploadsByTypeQuery, LatestIdmsUploadsByTypeQueryVariables>(LatestIdmsUploadsByTypeDocument, options);
        }
// @ts-ignore
export function useLatestIdmsUploadsByTypeSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<LatestIdmsUploadsByTypeQuery, LatestIdmsUploadsByTypeQueryVariables>): Apollo.UseSuspenseQueryResult<LatestIdmsUploadsByTypeQuery, LatestIdmsUploadsByTypeQueryVariables>;
export function useLatestIdmsUploadsByTypeSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<LatestIdmsUploadsByTypeQuery, LatestIdmsUploadsByTypeQueryVariables>): Apollo.UseSuspenseQueryResult<LatestIdmsUploadsByTypeQuery | undefined, LatestIdmsUploadsByTypeQueryVariables>;
export function useLatestIdmsUploadsByTypeSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<LatestIdmsUploadsByTypeQuery, LatestIdmsUploadsByTypeQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<LatestIdmsUploadsByTypeQuery, LatestIdmsUploadsByTypeQueryVariables>(LatestIdmsUploadsByTypeDocument, options);
        }
export type LatestIdmsUploadsByTypeQueryHookResult = ReturnType<typeof useLatestIdmsUploadsByTypeQuery>;
export type LatestIdmsUploadsByTypeLazyQueryHookResult = ReturnType<typeof useLatestIdmsUploadsByTypeLazyQuery>;
export type LatestIdmsUploadsByTypeSuspenseQueryHookResult = ReturnType<typeof useLatestIdmsUploadsByTypeSuspenseQuery>;
export type LatestIdmsUploadsByTypeQueryResult = Apollo.QueryResult<LatestIdmsUploadsByTypeQuery, LatestIdmsUploadsByTypeQueryVariables>;
export const SaveAssemblyScreenshotDocument = gql`
    mutation SaveAssemblyScreenshot($input: ScreenshotInput) {
  saveAssemblyScreenshot(input: $input) {
    id
    tagName
  }
}
    `;
export type SaveAssemblyScreenshotMutationFn = Apollo.MutationFunction<SaveAssemblyScreenshotMutation, SaveAssemblyScreenshotMutationVariables>;

/**
 * __useSaveAssemblyScreenshotMutation__
 *
 * To run a mutation, you first call `useSaveAssemblyScreenshotMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveAssemblyScreenshotMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveAssemblyScreenshotMutation, { data, loading, error }] = useSaveAssemblyScreenshotMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSaveAssemblyScreenshotMutation(baseOptions?: Apollo.MutationHookOptions<SaveAssemblyScreenshotMutation, SaveAssemblyScreenshotMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveAssemblyScreenshotMutation, SaveAssemblyScreenshotMutationVariables>(SaveAssemblyScreenshotDocument, options);
      }
export type SaveAssemblyScreenshotMutationHookResult = ReturnType<typeof useSaveAssemblyScreenshotMutation>;
export type SaveAssemblyScreenshotMutationResult = Apollo.MutationResult<SaveAssemblyScreenshotMutation>;
export type SaveAssemblyScreenshotMutationOptions = Apollo.BaseMutationOptions<SaveAssemblyScreenshotMutation, SaveAssemblyScreenshotMutationVariables>;
export const BulkPipeSpecUploadDocument = gql`
    mutation BulkPipeSpecUpload($input: BulkPipeSpecUploadInput!) {
  bulkPipeSpecUpload(input: $input) {
    message
    onlyValidated
    updatedCount
  }
}
    `;
export type BulkPipeSpecUploadMutationFn = Apollo.MutationFunction<BulkPipeSpecUploadMutation, BulkPipeSpecUploadMutationVariables>;

/**
 * __useBulkPipeSpecUploadMutation__
 *
 * To run a mutation, you first call `useBulkPipeSpecUploadMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBulkPipeSpecUploadMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [bulkPipeSpecUploadMutation, { data, loading, error }] = useBulkPipeSpecUploadMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useBulkPipeSpecUploadMutation(baseOptions?: Apollo.MutationHookOptions<BulkPipeSpecUploadMutation, BulkPipeSpecUploadMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<BulkPipeSpecUploadMutation, BulkPipeSpecUploadMutationVariables>(BulkPipeSpecUploadDocument, options);
      }
export type BulkPipeSpecUploadMutationHookResult = ReturnType<typeof useBulkPipeSpecUploadMutation>;
export type BulkPipeSpecUploadMutationResult = Apollo.MutationResult<BulkPipeSpecUploadMutation>;
export type BulkPipeSpecUploadMutationOptions = Apollo.BaseMutationOptions<BulkPipeSpecUploadMutation, BulkPipeSpecUploadMutationVariables>;
export const BulkUploadServiceGroupsDocument = gql`
    mutation BulkUploadServiceGroups($input: BulkUploadServiceGroupsInput!) {
  bulkUploadServiceGroups(input: $input) {
    message
    updatedCount
  }
}
    `;
export type BulkUploadServiceGroupsMutationFn = Apollo.MutationFunction<BulkUploadServiceGroupsMutation, BulkUploadServiceGroupsMutationVariables>;

/**
 * __useBulkUploadServiceGroupsMutation__
 *
 * To run a mutation, you first call `useBulkUploadServiceGroupsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBulkUploadServiceGroupsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [bulkUploadServiceGroupsMutation, { data, loading, error }] = useBulkUploadServiceGroupsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useBulkUploadServiceGroupsMutation(baseOptions?: Apollo.MutationHookOptions<BulkUploadServiceGroupsMutation, BulkUploadServiceGroupsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<BulkUploadServiceGroupsMutation, BulkUploadServiceGroupsMutationVariables>(BulkUploadServiceGroupsDocument, options);
      }
export type BulkUploadServiceGroupsMutationHookResult = ReturnType<typeof useBulkUploadServiceGroupsMutation>;
export type BulkUploadServiceGroupsMutationResult = Apollo.MutationResult<BulkUploadServiceGroupsMutation>;
export type BulkUploadServiceGroupsMutationOptions = Apollo.BaseMutationOptions<BulkUploadServiceGroupsMutation, BulkUploadServiceGroupsMutationVariables>;
export const UpdateAssemblyTableDocument = gql`
    mutation updateAssemblyTable($input: UpdateAssemblyTableValuesInput!) {
  updateAssemblyTable(input: $input)
}
    `;
export type UpdateAssemblyTableMutationFn = Apollo.MutationFunction<UpdateAssemblyTableMutation, UpdateAssemblyTableMutationVariables>;

/**
 * __useUpdateAssemblyTableMutation__
 *
 * To run a mutation, you first call `useUpdateAssemblyTableMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAssemblyTableMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAssemblyTableMutation, { data, loading, error }] = useUpdateAssemblyTableMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateAssemblyTableMutation(baseOptions?: Apollo.MutationHookOptions<UpdateAssemblyTableMutation, UpdateAssemblyTableMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateAssemblyTableMutation, UpdateAssemblyTableMutationVariables>(UpdateAssemblyTableDocument, options);
      }
export type UpdateAssemblyTableMutationHookResult = ReturnType<typeof useUpdateAssemblyTableMutation>;
export type UpdateAssemblyTableMutationResult = Apollo.MutationResult<UpdateAssemblyTableMutation>;
export type UpdateAssemblyTableMutationOptions = Apollo.BaseMutationOptions<UpdateAssemblyTableMutation, UpdateAssemblyTableMutationVariables>;
export const GetAssembliesByTemplateFieldsFiltersForEquipmentExportDocument = gql`
    query GetAssembliesByTemplateFieldsFiltersForEquipmentExport($input: AssembliesFilterInput, $pageInfo: PageInfo) {
  getAssembliesByTemplateFieldsFilters(input: $input, pageInfo: $pageInfo) {
    id
    tagName
    templateFieldData
    poiCounts {
      poiType
      count
    }
  }
}
    `;

/**
 * __useGetAssembliesByTemplateFieldsFiltersForEquipmentExportQuery__
 *
 * To run a query within a React component, call `useGetAssembliesByTemplateFieldsFiltersForEquipmentExportQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAssembliesByTemplateFieldsFiltersForEquipmentExportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAssembliesByTemplateFieldsFiltersForEquipmentExportQuery({
 *   variables: {
 *      input: // value for 'input'
 *      pageInfo: // value for 'pageInfo'
 *   },
 * });
 */
export function useGetAssembliesByTemplateFieldsFiltersForEquipmentExportQuery(baseOptions?: Apollo.QueryHookOptions<GetAssembliesByTemplateFieldsFiltersForEquipmentExportQuery, GetAssembliesByTemplateFieldsFiltersForEquipmentExportQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAssembliesByTemplateFieldsFiltersForEquipmentExportQuery, GetAssembliesByTemplateFieldsFiltersForEquipmentExportQueryVariables>(GetAssembliesByTemplateFieldsFiltersForEquipmentExportDocument, options);
      }
export function useGetAssembliesByTemplateFieldsFiltersForEquipmentExportLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAssembliesByTemplateFieldsFiltersForEquipmentExportQuery, GetAssembliesByTemplateFieldsFiltersForEquipmentExportQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAssembliesByTemplateFieldsFiltersForEquipmentExportQuery, GetAssembliesByTemplateFieldsFiltersForEquipmentExportQueryVariables>(GetAssembliesByTemplateFieldsFiltersForEquipmentExportDocument, options);
        }
// @ts-ignore
export function useGetAssembliesByTemplateFieldsFiltersForEquipmentExportSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetAssembliesByTemplateFieldsFiltersForEquipmentExportQuery, GetAssembliesByTemplateFieldsFiltersForEquipmentExportQueryVariables>): Apollo.UseSuspenseQueryResult<GetAssembliesByTemplateFieldsFiltersForEquipmentExportQuery, GetAssembliesByTemplateFieldsFiltersForEquipmentExportQueryVariables>;
export function useGetAssembliesByTemplateFieldsFiltersForEquipmentExportSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAssembliesByTemplateFieldsFiltersForEquipmentExportQuery, GetAssembliesByTemplateFieldsFiltersForEquipmentExportQueryVariables>): Apollo.UseSuspenseQueryResult<GetAssembliesByTemplateFieldsFiltersForEquipmentExportQuery | undefined, GetAssembliesByTemplateFieldsFiltersForEquipmentExportQueryVariables>;
export function useGetAssembliesByTemplateFieldsFiltersForEquipmentExportSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAssembliesByTemplateFieldsFiltersForEquipmentExportQuery, GetAssembliesByTemplateFieldsFiltersForEquipmentExportQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAssembliesByTemplateFieldsFiltersForEquipmentExportQuery, GetAssembliesByTemplateFieldsFiltersForEquipmentExportQueryVariables>(GetAssembliesByTemplateFieldsFiltersForEquipmentExportDocument, options);
        }
export type GetAssembliesByTemplateFieldsFiltersForEquipmentExportQueryHookResult = ReturnType<typeof useGetAssembliesByTemplateFieldsFiltersForEquipmentExportQuery>;
export type GetAssembliesByTemplateFieldsFiltersForEquipmentExportLazyQueryHookResult = ReturnType<typeof useGetAssembliesByTemplateFieldsFiltersForEquipmentExportLazyQuery>;
export type GetAssembliesByTemplateFieldsFiltersForEquipmentExportSuspenseQueryHookResult = ReturnType<typeof useGetAssembliesByTemplateFieldsFiltersForEquipmentExportSuspenseQuery>;
export type GetAssembliesByTemplateFieldsFiltersForEquipmentExportQueryResult = Apollo.QueryResult<GetAssembliesByTemplateFieldsFiltersForEquipmentExportQuery, GetAssembliesByTemplateFieldsFiltersForEquipmentExportQueryVariables>;
export const AllDecksDocument = gql`
    query AllDecks($structureId: ID) {
  allDecks(structureId: $structureId) {
    id
    name
  }
}
    `;

/**
 * __useAllDecksQuery__
 *
 * To run a query within a React component, call `useAllDecksQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllDecksQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllDecksQuery({
 *   variables: {
 *      structureId: // value for 'structureId'
 *   },
 * });
 */
export function useAllDecksQuery(baseOptions?: Apollo.QueryHookOptions<AllDecksQuery, AllDecksQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AllDecksQuery, AllDecksQueryVariables>(AllDecksDocument, options);
      }
export function useAllDecksLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AllDecksQuery, AllDecksQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AllDecksQuery, AllDecksQueryVariables>(AllDecksDocument, options);
        }
// @ts-ignore
export function useAllDecksSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<AllDecksQuery, AllDecksQueryVariables>): Apollo.UseSuspenseQueryResult<AllDecksQuery, AllDecksQueryVariables>;
export function useAllDecksSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AllDecksQuery, AllDecksQueryVariables>): Apollo.UseSuspenseQueryResult<AllDecksQuery | undefined, AllDecksQueryVariables>;
export function useAllDecksSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AllDecksQuery, AllDecksQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AllDecksQuery, AllDecksQueryVariables>(AllDecksDocument, options);
        }
export type AllDecksQueryHookResult = ReturnType<typeof useAllDecksQuery>;
export type AllDecksLazyQueryHookResult = ReturnType<typeof useAllDecksLazyQuery>;
export type AllDecksSuspenseQueryHookResult = ReturnType<typeof useAllDecksSuspenseQuery>;
export type AllDecksQueryResult = Apollo.QueryResult<AllDecksQuery, AllDecksQueryVariables>;
export const DecksWithDefectsDocument = gql`
    query DecksWithDefects($structureId: ID) {
  allDefects(structureId: $structureId) {
    key
    name
  }
  decksWithDefects(structureId: $structureId) {
    id
    name
    defectArea {
      key
      area
    }
  }
}
    `;

/**
 * __useDecksWithDefectsQuery__
 *
 * To run a query within a React component, call `useDecksWithDefectsQuery` and pass it any options that fit your needs.
 * When your component renders, `useDecksWithDefectsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDecksWithDefectsQuery({
 *   variables: {
 *      structureId: // value for 'structureId'
 *   },
 * });
 */
export function useDecksWithDefectsQuery(baseOptions?: Apollo.QueryHookOptions<DecksWithDefectsQuery, DecksWithDefectsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DecksWithDefectsQuery, DecksWithDefectsQueryVariables>(DecksWithDefectsDocument, options);
      }
export function useDecksWithDefectsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DecksWithDefectsQuery, DecksWithDefectsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DecksWithDefectsQuery, DecksWithDefectsQueryVariables>(DecksWithDefectsDocument, options);
        }
// @ts-ignore
export function useDecksWithDefectsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<DecksWithDefectsQuery, DecksWithDefectsQueryVariables>): Apollo.UseSuspenseQueryResult<DecksWithDefectsQuery, DecksWithDefectsQueryVariables>;
export function useDecksWithDefectsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DecksWithDefectsQuery, DecksWithDefectsQueryVariables>): Apollo.UseSuspenseQueryResult<DecksWithDefectsQuery | undefined, DecksWithDefectsQueryVariables>;
export function useDecksWithDefectsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DecksWithDefectsQuery, DecksWithDefectsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DecksWithDefectsQuery, DecksWithDefectsQueryVariables>(DecksWithDefectsDocument, options);
        }
export type DecksWithDefectsQueryHookResult = ReturnType<typeof useDecksWithDefectsQuery>;
export type DecksWithDefectsLazyQueryHookResult = ReturnType<typeof useDecksWithDefectsLazyQuery>;
export type DecksWithDefectsSuspenseQueryHookResult = ReturnType<typeof useDecksWithDefectsSuspenseQuery>;
export type DecksWithDefectsQueryResult = Apollo.QueryResult<DecksWithDefectsQuery, DecksWithDefectsQueryVariables>;
export const UpdatePaintRegionStatusDocument = gql`
    mutation UpdatePaintRegionStatus($input: UpdatePaintRegionStatusInput) {
  updatePaintRegionStatus(input: $input) {
    status
    remediationDate
  }
}
    `;
export type UpdatePaintRegionStatusMutationFn = Apollo.MutationFunction<UpdatePaintRegionStatusMutation, UpdatePaintRegionStatusMutationVariables>;

/**
 * __useUpdatePaintRegionStatusMutation__
 *
 * To run a mutation, you first call `useUpdatePaintRegionStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePaintRegionStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePaintRegionStatusMutation, { data, loading, error }] = useUpdatePaintRegionStatusMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdatePaintRegionStatusMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePaintRegionStatusMutation, UpdatePaintRegionStatusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePaintRegionStatusMutation, UpdatePaintRegionStatusMutationVariables>(UpdatePaintRegionStatusDocument, options);
      }
export type UpdatePaintRegionStatusMutationHookResult = ReturnType<typeof useUpdatePaintRegionStatusMutation>;
export type UpdatePaintRegionStatusMutationResult = Apollo.MutationResult<UpdatePaintRegionStatusMutation>;
export type UpdatePaintRegionStatusMutationOptions = Apollo.BaseMutationOptions<UpdatePaintRegionStatusMutation, UpdatePaintRegionStatusMutationVariables>;
export const UpdatePointOfInterestsStatusDocument = gql`
    mutation UpdatePointOfInterestsStatus($input: UpdatePointOfInterestsStatusInput!) {
  updatePointOfInterestsStatus(input: $input)
}
    `;
export type UpdatePointOfInterestsStatusMutationFn = Apollo.MutationFunction<UpdatePointOfInterestsStatusMutation, UpdatePointOfInterestsStatusMutationVariables>;

/**
 * __useUpdatePointOfInterestsStatusMutation__
 *
 * To run a mutation, you first call `useUpdatePointOfInterestsStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePointOfInterestsStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePointOfInterestsStatusMutation, { data, loading, error }] = useUpdatePointOfInterestsStatusMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdatePointOfInterestsStatusMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePointOfInterestsStatusMutation, UpdatePointOfInterestsStatusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePointOfInterestsStatusMutation, UpdatePointOfInterestsStatusMutationVariables>(UpdatePointOfInterestsStatusDocument, options);
      }
export type UpdatePointOfInterestsStatusMutationHookResult = ReturnType<typeof useUpdatePointOfInterestsStatusMutation>;
export type UpdatePointOfInterestsStatusMutationResult = Apollo.MutationResult<UpdatePointOfInterestsStatusMutation>;
export type UpdatePointOfInterestsStatusMutationOptions = Apollo.BaseMutationOptions<UpdatePointOfInterestsStatusMutation, UpdatePointOfInterestsStatusMutationVariables>;
export const AllPaintRegionsForPaintBlockTableDocument = gql`
    query AllPaintRegionsForPaintBlockTable($input: FindAllPaintRegionsInput!) {
  allPaintRegions(input: $input) {
    id
    name
    status
    remediationDate
    paintRegionGroup {
      id
      name
    }
  }
}
    `;

/**
 * __useAllPaintRegionsForPaintBlockTableQuery__
 *
 * To run a query within a React component, call `useAllPaintRegionsForPaintBlockTableQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllPaintRegionsForPaintBlockTableQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllPaintRegionsForPaintBlockTableQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAllPaintRegionsForPaintBlockTableQuery(baseOptions: Apollo.QueryHookOptions<AllPaintRegionsForPaintBlockTableQuery, AllPaintRegionsForPaintBlockTableQueryVariables> & ({ variables: AllPaintRegionsForPaintBlockTableQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AllPaintRegionsForPaintBlockTableQuery, AllPaintRegionsForPaintBlockTableQueryVariables>(AllPaintRegionsForPaintBlockTableDocument, options);
      }
export function useAllPaintRegionsForPaintBlockTableLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AllPaintRegionsForPaintBlockTableQuery, AllPaintRegionsForPaintBlockTableQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AllPaintRegionsForPaintBlockTableQuery, AllPaintRegionsForPaintBlockTableQueryVariables>(AllPaintRegionsForPaintBlockTableDocument, options);
        }
// @ts-ignore
export function useAllPaintRegionsForPaintBlockTableSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<AllPaintRegionsForPaintBlockTableQuery, AllPaintRegionsForPaintBlockTableQueryVariables>): Apollo.UseSuspenseQueryResult<AllPaintRegionsForPaintBlockTableQuery, AllPaintRegionsForPaintBlockTableQueryVariables>;
export function useAllPaintRegionsForPaintBlockTableSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AllPaintRegionsForPaintBlockTableQuery, AllPaintRegionsForPaintBlockTableQueryVariables>): Apollo.UseSuspenseQueryResult<AllPaintRegionsForPaintBlockTableQuery | undefined, AllPaintRegionsForPaintBlockTableQueryVariables>;
export function useAllPaintRegionsForPaintBlockTableSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AllPaintRegionsForPaintBlockTableQuery, AllPaintRegionsForPaintBlockTableQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AllPaintRegionsForPaintBlockTableQuery, AllPaintRegionsForPaintBlockTableQueryVariables>(AllPaintRegionsForPaintBlockTableDocument, options);
        }
export type AllPaintRegionsForPaintBlockTableQueryHookResult = ReturnType<typeof useAllPaintRegionsForPaintBlockTableQuery>;
export type AllPaintRegionsForPaintBlockTableLazyQueryHookResult = ReturnType<typeof useAllPaintRegionsForPaintBlockTableLazyQuery>;
export type AllPaintRegionsForPaintBlockTableSuspenseQueryHookResult = ReturnType<typeof useAllPaintRegionsForPaintBlockTableSuspenseQuery>;
export type AllPaintRegionsForPaintBlockTableQueryResult = Apollo.QueryResult<AllPaintRegionsForPaintBlockTableQuery, AllPaintRegionsForPaintBlockTableQueryVariables>;
export const DefectsAreaAndPointOfInterestCountByPaintRegionsDocument = gql`
    query DefectsAreaAndPointOfInterestCountByPaintRegions($input: PaintBlockFiltersInput!) {
  defectsAreaForAssemblyPaintRegions(input: $input) {
    structureIds
    defectsByDeck {
      name
      deckIds
      totalArea {
        type
        value
      }
    }
    defectsByPaintBlock {
      name
      paintRegionIds
      totalArea {
        type
        value
      }
    }
  }
  pointOfInterestCountByPaintRegions(input: $input) {
    structureIds
    findingsByDeck {
      name
      pointOfInterestFindings {
        type
        count
        poiTemplateName
      }
      totalCount
    }
    findingsByPaintBlock {
      name
      pointOfInterestFindings {
        type
        count
        poiTemplateName
      }
      totalCount
    }
  }
}
    `;

/**
 * __useDefectsAreaAndPointOfInterestCountByPaintRegionsQuery__
 *
 * To run a query within a React component, call `useDefectsAreaAndPointOfInterestCountByPaintRegionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useDefectsAreaAndPointOfInterestCountByPaintRegionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDefectsAreaAndPointOfInterestCountByPaintRegionsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDefectsAreaAndPointOfInterestCountByPaintRegionsQuery(baseOptions: Apollo.QueryHookOptions<DefectsAreaAndPointOfInterestCountByPaintRegionsQuery, DefectsAreaAndPointOfInterestCountByPaintRegionsQueryVariables> & ({ variables: DefectsAreaAndPointOfInterestCountByPaintRegionsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DefectsAreaAndPointOfInterestCountByPaintRegionsQuery, DefectsAreaAndPointOfInterestCountByPaintRegionsQueryVariables>(DefectsAreaAndPointOfInterestCountByPaintRegionsDocument, options);
      }
export function useDefectsAreaAndPointOfInterestCountByPaintRegionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DefectsAreaAndPointOfInterestCountByPaintRegionsQuery, DefectsAreaAndPointOfInterestCountByPaintRegionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DefectsAreaAndPointOfInterestCountByPaintRegionsQuery, DefectsAreaAndPointOfInterestCountByPaintRegionsQueryVariables>(DefectsAreaAndPointOfInterestCountByPaintRegionsDocument, options);
        }
// @ts-ignore
export function useDefectsAreaAndPointOfInterestCountByPaintRegionsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<DefectsAreaAndPointOfInterestCountByPaintRegionsQuery, DefectsAreaAndPointOfInterestCountByPaintRegionsQueryVariables>): Apollo.UseSuspenseQueryResult<DefectsAreaAndPointOfInterestCountByPaintRegionsQuery, DefectsAreaAndPointOfInterestCountByPaintRegionsQueryVariables>;
export function useDefectsAreaAndPointOfInterestCountByPaintRegionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DefectsAreaAndPointOfInterestCountByPaintRegionsQuery, DefectsAreaAndPointOfInterestCountByPaintRegionsQueryVariables>): Apollo.UseSuspenseQueryResult<DefectsAreaAndPointOfInterestCountByPaintRegionsQuery | undefined, DefectsAreaAndPointOfInterestCountByPaintRegionsQueryVariables>;
export function useDefectsAreaAndPointOfInterestCountByPaintRegionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DefectsAreaAndPointOfInterestCountByPaintRegionsQuery, DefectsAreaAndPointOfInterestCountByPaintRegionsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DefectsAreaAndPointOfInterestCountByPaintRegionsQuery, DefectsAreaAndPointOfInterestCountByPaintRegionsQueryVariables>(DefectsAreaAndPointOfInterestCountByPaintRegionsDocument, options);
        }
export type DefectsAreaAndPointOfInterestCountByPaintRegionsQueryHookResult = ReturnType<typeof useDefectsAreaAndPointOfInterestCountByPaintRegionsQuery>;
export type DefectsAreaAndPointOfInterestCountByPaintRegionsLazyQueryHookResult = ReturnType<typeof useDefectsAreaAndPointOfInterestCountByPaintRegionsLazyQuery>;
export type DefectsAreaAndPointOfInterestCountByPaintRegionsSuspenseQueryHookResult = ReturnType<typeof useDefectsAreaAndPointOfInterestCountByPaintRegionsSuspenseQuery>;
export type DefectsAreaAndPointOfInterestCountByPaintRegionsQueryResult = Apollo.QueryResult<DefectsAreaAndPointOfInterestCountByPaintRegionsQuery, DefectsAreaAndPointOfInterestCountByPaintRegionsQueryVariables>;
export const DefectsAreaForCustomBlocksDocument = gql`
    query DefectsAreaForCustomBlocks($input: PaintBlockFiltersInput!, $pageInfo: PageInfo) {
  defectsAreaForAssemblyPaintRegionsByGroup(input: $input, pageInfo: $pageInfo) {
    structureId
    defectsByPaintBlock {
      name
      paintRegionId
      totalArea {
        value
        type
      }
      totalCountByPoiType {
        type
        value
      }
    }
    totalCount
  }
}
    `;

/**
 * __useDefectsAreaForCustomBlocksQuery__
 *
 * To run a query within a React component, call `useDefectsAreaForCustomBlocksQuery` and pass it any options that fit your needs.
 * When your component renders, `useDefectsAreaForCustomBlocksQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDefectsAreaForCustomBlocksQuery({
 *   variables: {
 *      input: // value for 'input'
 *      pageInfo: // value for 'pageInfo'
 *   },
 * });
 */
export function useDefectsAreaForCustomBlocksQuery(baseOptions: Apollo.QueryHookOptions<DefectsAreaForCustomBlocksQuery, DefectsAreaForCustomBlocksQueryVariables> & ({ variables: DefectsAreaForCustomBlocksQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DefectsAreaForCustomBlocksQuery, DefectsAreaForCustomBlocksQueryVariables>(DefectsAreaForCustomBlocksDocument, options);
      }
export function useDefectsAreaForCustomBlocksLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DefectsAreaForCustomBlocksQuery, DefectsAreaForCustomBlocksQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DefectsAreaForCustomBlocksQuery, DefectsAreaForCustomBlocksQueryVariables>(DefectsAreaForCustomBlocksDocument, options);
        }
// @ts-ignore
export function useDefectsAreaForCustomBlocksSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<DefectsAreaForCustomBlocksQuery, DefectsAreaForCustomBlocksQueryVariables>): Apollo.UseSuspenseQueryResult<DefectsAreaForCustomBlocksQuery, DefectsAreaForCustomBlocksQueryVariables>;
export function useDefectsAreaForCustomBlocksSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DefectsAreaForCustomBlocksQuery, DefectsAreaForCustomBlocksQueryVariables>): Apollo.UseSuspenseQueryResult<DefectsAreaForCustomBlocksQuery | undefined, DefectsAreaForCustomBlocksQueryVariables>;
export function useDefectsAreaForCustomBlocksSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DefectsAreaForCustomBlocksQuery, DefectsAreaForCustomBlocksQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DefectsAreaForCustomBlocksQuery, DefectsAreaForCustomBlocksQueryVariables>(DefectsAreaForCustomBlocksDocument, options);
        }
export type DefectsAreaForCustomBlocksQueryHookResult = ReturnType<typeof useDefectsAreaForCustomBlocksQuery>;
export type DefectsAreaForCustomBlocksLazyQueryHookResult = ReturnType<typeof useDefectsAreaForCustomBlocksLazyQuery>;
export type DefectsAreaForCustomBlocksSuspenseQueryHookResult = ReturnType<typeof useDefectsAreaForCustomBlocksSuspenseQuery>;
export type DefectsAreaForCustomBlocksQueryResult = Apollo.QueryResult<DefectsAreaForCustomBlocksQuery, DefectsAreaForCustomBlocksQueryVariables>;
export const RiskRemediationTrendAnalyticsDocument = gql`
    query RiskRemediationTrendAnalytics($input: AnalyticsFiltersInput) {
  analytics(input: $input) {
    data
    id
    structureIds
    displayConfig
  }
}
    `;

/**
 * __useRiskRemediationTrendAnalyticsQuery__
 *
 * To run a query within a React component, call `useRiskRemediationTrendAnalyticsQuery` and pass it any options that fit your needs.
 * When your component renders, `useRiskRemediationTrendAnalyticsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRiskRemediationTrendAnalyticsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRiskRemediationTrendAnalyticsQuery(baseOptions?: Apollo.QueryHookOptions<RiskRemediationTrendAnalyticsQuery, RiskRemediationTrendAnalyticsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RiskRemediationTrendAnalyticsQuery, RiskRemediationTrendAnalyticsQueryVariables>(RiskRemediationTrendAnalyticsDocument, options);
      }
export function useRiskRemediationTrendAnalyticsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RiskRemediationTrendAnalyticsQuery, RiskRemediationTrendAnalyticsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RiskRemediationTrendAnalyticsQuery, RiskRemediationTrendAnalyticsQueryVariables>(RiskRemediationTrendAnalyticsDocument, options);
        }
// @ts-ignore
export function useRiskRemediationTrendAnalyticsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<RiskRemediationTrendAnalyticsQuery, RiskRemediationTrendAnalyticsQueryVariables>): Apollo.UseSuspenseQueryResult<RiskRemediationTrendAnalyticsQuery, RiskRemediationTrendAnalyticsQueryVariables>;
export function useRiskRemediationTrendAnalyticsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<RiskRemediationTrendAnalyticsQuery, RiskRemediationTrendAnalyticsQueryVariables>): Apollo.UseSuspenseQueryResult<RiskRemediationTrendAnalyticsQuery | undefined, RiskRemediationTrendAnalyticsQueryVariables>;
export function useRiskRemediationTrendAnalyticsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<RiskRemediationTrendAnalyticsQuery, RiskRemediationTrendAnalyticsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<RiskRemediationTrendAnalyticsQuery, RiskRemediationTrendAnalyticsQueryVariables>(RiskRemediationTrendAnalyticsDocument, options);
        }
export type RiskRemediationTrendAnalyticsQueryHookResult = ReturnType<typeof useRiskRemediationTrendAnalyticsQuery>;
export type RiskRemediationTrendAnalyticsLazyQueryHookResult = ReturnType<typeof useRiskRemediationTrendAnalyticsLazyQuery>;
export type RiskRemediationTrendAnalyticsSuspenseQueryHookResult = ReturnType<typeof useRiskRemediationTrendAnalyticsSuspenseQuery>;
export type RiskRemediationTrendAnalyticsQueryResult = Apollo.QueryResult<RiskRemediationTrendAnalyticsQuery, RiskRemediationTrendAnalyticsQueryVariables>;
export const UpdateAssemblyRemediationDocument = gql`
    mutation UpdateAssemblyRemediation($input: UpdateAssemblyRemediationInput) {
  updateAssemblyRemediation(input: $input)
}
    `;
export type UpdateAssemblyRemediationMutationFn = Apollo.MutationFunction<UpdateAssemblyRemediationMutation, UpdateAssemblyRemediationMutationVariables>;

/**
 * __useUpdateAssemblyRemediationMutation__
 *
 * To run a mutation, you first call `useUpdateAssemblyRemediationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAssemblyRemediationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAssemblyRemediationMutation, { data, loading, error }] = useUpdateAssemblyRemediationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateAssemblyRemediationMutation(baseOptions?: Apollo.MutationHookOptions<UpdateAssemblyRemediationMutation, UpdateAssemblyRemediationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateAssemblyRemediationMutation, UpdateAssemblyRemediationMutationVariables>(UpdateAssemblyRemediationDocument, options);
      }
export type UpdateAssemblyRemediationMutationHookResult = ReturnType<typeof useUpdateAssemblyRemediationMutation>;
export type UpdateAssemblyRemediationMutationResult = Apollo.MutationResult<UpdateAssemblyRemediationMutation>;
export type UpdateAssemblyRemediationMutationOptions = Apollo.BaseMutationOptions<UpdateAssemblyRemediationMutation, UpdateAssemblyRemediationMutationVariables>;
export const AddPartialRemediationDocument = gql`
    mutation AddPartialRemediation($input: AddPartialRemediationInput!) {
  addPartialRemediation(input: $input) {
    id
    status
    remediationByRi
    remediationAt
  }
}
    `;
export type AddPartialRemediationMutationFn = Apollo.MutationFunction<AddPartialRemediationMutation, AddPartialRemediationMutationVariables>;

/**
 * __useAddPartialRemediationMutation__
 *
 * To run a mutation, you first call `useAddPartialRemediationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddPartialRemediationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addPartialRemediationMutation, { data, loading, error }] = useAddPartialRemediationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddPartialRemediationMutation(baseOptions?: Apollo.MutationHookOptions<AddPartialRemediationMutation, AddPartialRemediationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddPartialRemediationMutation, AddPartialRemediationMutationVariables>(AddPartialRemediationDocument, options);
      }
export type AddPartialRemediationMutationHookResult = ReturnType<typeof useAddPartialRemediationMutation>;
export type AddPartialRemediationMutationResult = Apollo.MutationResult<AddPartialRemediationMutation>;
export type AddPartialRemediationMutationOptions = Apollo.BaseMutationOptions<AddPartialRemediationMutation, AddPartialRemediationMutationVariables>;
export const GetAssemblyPaintRegionsByPaintRegionIdDocument = gql`
    query GetAssemblyPaintRegionsByPaintRegionId($input: PaintBlockFiltersInput!) {
  allAssemblyPaintRegions(input: $input) {
    id
    status
    remediationAt
    templateFieldData
    remediationByRi
  }
}
    `;

/**
 * __useGetAssemblyPaintRegionsByPaintRegionIdQuery__
 *
 * To run a query within a React component, call `useGetAssemblyPaintRegionsByPaintRegionIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAssemblyPaintRegionsByPaintRegionIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAssemblyPaintRegionsByPaintRegionIdQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetAssemblyPaintRegionsByPaintRegionIdQuery(baseOptions: Apollo.QueryHookOptions<GetAssemblyPaintRegionsByPaintRegionIdQuery, GetAssemblyPaintRegionsByPaintRegionIdQueryVariables> & ({ variables: GetAssemblyPaintRegionsByPaintRegionIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAssemblyPaintRegionsByPaintRegionIdQuery, GetAssemblyPaintRegionsByPaintRegionIdQueryVariables>(GetAssemblyPaintRegionsByPaintRegionIdDocument, options);
      }
export function useGetAssemblyPaintRegionsByPaintRegionIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAssemblyPaintRegionsByPaintRegionIdQuery, GetAssemblyPaintRegionsByPaintRegionIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAssemblyPaintRegionsByPaintRegionIdQuery, GetAssemblyPaintRegionsByPaintRegionIdQueryVariables>(GetAssemblyPaintRegionsByPaintRegionIdDocument, options);
        }
// @ts-ignore
export function useGetAssemblyPaintRegionsByPaintRegionIdSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetAssemblyPaintRegionsByPaintRegionIdQuery, GetAssemblyPaintRegionsByPaintRegionIdQueryVariables>): Apollo.UseSuspenseQueryResult<GetAssemblyPaintRegionsByPaintRegionIdQuery, GetAssemblyPaintRegionsByPaintRegionIdQueryVariables>;
export function useGetAssemblyPaintRegionsByPaintRegionIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAssemblyPaintRegionsByPaintRegionIdQuery, GetAssemblyPaintRegionsByPaintRegionIdQueryVariables>): Apollo.UseSuspenseQueryResult<GetAssemblyPaintRegionsByPaintRegionIdQuery | undefined, GetAssemblyPaintRegionsByPaintRegionIdQueryVariables>;
export function useGetAssemblyPaintRegionsByPaintRegionIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAssemblyPaintRegionsByPaintRegionIdQuery, GetAssemblyPaintRegionsByPaintRegionIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAssemblyPaintRegionsByPaintRegionIdQuery, GetAssemblyPaintRegionsByPaintRegionIdQueryVariables>(GetAssemblyPaintRegionsByPaintRegionIdDocument, options);
        }
export type GetAssemblyPaintRegionsByPaintRegionIdQueryHookResult = ReturnType<typeof useGetAssemblyPaintRegionsByPaintRegionIdQuery>;
export type GetAssemblyPaintRegionsByPaintRegionIdLazyQueryHookResult = ReturnType<typeof useGetAssemblyPaintRegionsByPaintRegionIdLazyQuery>;
export type GetAssemblyPaintRegionsByPaintRegionIdSuspenseQueryHookResult = ReturnType<typeof useGetAssemblyPaintRegionsByPaintRegionIdSuspenseQuery>;
export type GetAssemblyPaintRegionsByPaintRegionIdQueryResult = Apollo.QueryResult<GetAssemblyPaintRegionsByPaintRegionIdQuery, GetAssemblyPaintRegionsByPaintRegionIdQueryVariables>;
export const RemediatedPoiVersionsByPaintRegionDocument = gql`
    query RemediatedPOIVersionsByPaintRegion($input: RemediatedPoiVersionsByPaintRegionInput!) {
  remediatedPOIVersionsByPaintRegion(input: $input) {
    id
    createdAt
    name
    poiId
    updatedData
    lastModifiedByUser {
      id
      name
    }
    lastModifiedFor
  }
}
    `;

/**
 * __useRemediatedPoiVersionsByPaintRegionQuery__
 *
 * To run a query within a React component, call `useRemediatedPoiVersionsByPaintRegionQuery` and pass it any options that fit your needs.
 * When your component renders, `useRemediatedPoiVersionsByPaintRegionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRemediatedPoiVersionsByPaintRegionQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRemediatedPoiVersionsByPaintRegionQuery(baseOptions: Apollo.QueryHookOptions<RemediatedPoiVersionsByPaintRegionQuery, RemediatedPoiVersionsByPaintRegionQueryVariables> & ({ variables: RemediatedPoiVersionsByPaintRegionQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RemediatedPoiVersionsByPaintRegionQuery, RemediatedPoiVersionsByPaintRegionQueryVariables>(RemediatedPoiVersionsByPaintRegionDocument, options);
      }
export function useRemediatedPoiVersionsByPaintRegionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RemediatedPoiVersionsByPaintRegionQuery, RemediatedPoiVersionsByPaintRegionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RemediatedPoiVersionsByPaintRegionQuery, RemediatedPoiVersionsByPaintRegionQueryVariables>(RemediatedPoiVersionsByPaintRegionDocument, options);
        }
// @ts-ignore
export function useRemediatedPoiVersionsByPaintRegionSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<RemediatedPoiVersionsByPaintRegionQuery, RemediatedPoiVersionsByPaintRegionQueryVariables>): Apollo.UseSuspenseQueryResult<RemediatedPoiVersionsByPaintRegionQuery, RemediatedPoiVersionsByPaintRegionQueryVariables>;
export function useRemediatedPoiVersionsByPaintRegionSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<RemediatedPoiVersionsByPaintRegionQuery, RemediatedPoiVersionsByPaintRegionQueryVariables>): Apollo.UseSuspenseQueryResult<RemediatedPoiVersionsByPaintRegionQuery | undefined, RemediatedPoiVersionsByPaintRegionQueryVariables>;
export function useRemediatedPoiVersionsByPaintRegionSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<RemediatedPoiVersionsByPaintRegionQuery, RemediatedPoiVersionsByPaintRegionQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<RemediatedPoiVersionsByPaintRegionQuery, RemediatedPoiVersionsByPaintRegionQueryVariables>(RemediatedPoiVersionsByPaintRegionDocument, options);
        }
export type RemediatedPoiVersionsByPaintRegionQueryHookResult = ReturnType<typeof useRemediatedPoiVersionsByPaintRegionQuery>;
export type RemediatedPoiVersionsByPaintRegionLazyQueryHookResult = ReturnType<typeof useRemediatedPoiVersionsByPaintRegionLazyQuery>;
export type RemediatedPoiVersionsByPaintRegionSuspenseQueryHookResult = ReturnType<typeof useRemediatedPoiVersionsByPaintRegionSuspenseQuery>;
export type RemediatedPoiVersionsByPaintRegionQueryResult = Apollo.QueryResult<RemediatedPoiVersionsByPaintRegionQuery, RemediatedPoiVersionsByPaintRegionQueryVariables>;
export const RemediatedAssemblyPaintRegionVersionsByPaintRegionDocument = gql`
    query RemediatedAssemblyPaintRegionVersionsByPaintRegion($input: RemediatedAssemblyPaintRegionVersionsByPaintRegionInput) {
  remediatedAssemblyPaintRegionVersionsByPaintRegion(input: $input) {
    id
    createdAt
    name
    updatedData
    lastModifiedByUser {
      id
      name
    }
    lastModifiedFor
  }
}
    `;

/**
 * __useRemediatedAssemblyPaintRegionVersionsByPaintRegionQuery__
 *
 * To run a query within a React component, call `useRemediatedAssemblyPaintRegionVersionsByPaintRegionQuery` and pass it any options that fit your needs.
 * When your component renders, `useRemediatedAssemblyPaintRegionVersionsByPaintRegionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRemediatedAssemblyPaintRegionVersionsByPaintRegionQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRemediatedAssemblyPaintRegionVersionsByPaintRegionQuery(baseOptions?: Apollo.QueryHookOptions<RemediatedAssemblyPaintRegionVersionsByPaintRegionQuery, RemediatedAssemblyPaintRegionVersionsByPaintRegionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RemediatedAssemblyPaintRegionVersionsByPaintRegionQuery, RemediatedAssemblyPaintRegionVersionsByPaintRegionQueryVariables>(RemediatedAssemblyPaintRegionVersionsByPaintRegionDocument, options);
      }
export function useRemediatedAssemblyPaintRegionVersionsByPaintRegionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RemediatedAssemblyPaintRegionVersionsByPaintRegionQuery, RemediatedAssemblyPaintRegionVersionsByPaintRegionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RemediatedAssemblyPaintRegionVersionsByPaintRegionQuery, RemediatedAssemblyPaintRegionVersionsByPaintRegionQueryVariables>(RemediatedAssemblyPaintRegionVersionsByPaintRegionDocument, options);
        }
// @ts-ignore
export function useRemediatedAssemblyPaintRegionVersionsByPaintRegionSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<RemediatedAssemblyPaintRegionVersionsByPaintRegionQuery, RemediatedAssemblyPaintRegionVersionsByPaintRegionQueryVariables>): Apollo.UseSuspenseQueryResult<RemediatedAssemblyPaintRegionVersionsByPaintRegionQuery, RemediatedAssemblyPaintRegionVersionsByPaintRegionQueryVariables>;
export function useRemediatedAssemblyPaintRegionVersionsByPaintRegionSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<RemediatedAssemblyPaintRegionVersionsByPaintRegionQuery, RemediatedAssemblyPaintRegionVersionsByPaintRegionQueryVariables>): Apollo.UseSuspenseQueryResult<RemediatedAssemblyPaintRegionVersionsByPaintRegionQuery | undefined, RemediatedAssemblyPaintRegionVersionsByPaintRegionQueryVariables>;
export function useRemediatedAssemblyPaintRegionVersionsByPaintRegionSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<RemediatedAssemblyPaintRegionVersionsByPaintRegionQuery, RemediatedAssemblyPaintRegionVersionsByPaintRegionQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<RemediatedAssemblyPaintRegionVersionsByPaintRegionQuery, RemediatedAssemblyPaintRegionVersionsByPaintRegionQueryVariables>(RemediatedAssemblyPaintRegionVersionsByPaintRegionDocument, options);
        }
export type RemediatedAssemblyPaintRegionVersionsByPaintRegionQueryHookResult = ReturnType<typeof useRemediatedAssemblyPaintRegionVersionsByPaintRegionQuery>;
export type RemediatedAssemblyPaintRegionVersionsByPaintRegionLazyQueryHookResult = ReturnType<typeof useRemediatedAssemblyPaintRegionVersionsByPaintRegionLazyQuery>;
export type RemediatedAssemblyPaintRegionVersionsByPaintRegionSuspenseQueryHookResult = ReturnType<typeof useRemediatedAssemblyPaintRegionVersionsByPaintRegionSuspenseQuery>;
export type RemediatedAssemblyPaintRegionVersionsByPaintRegionQueryResult = Apollo.QueryResult<RemediatedAssemblyPaintRegionVersionsByPaintRegionQuery, RemediatedAssemblyPaintRegionVersionsByPaintRegionQueryVariables>;
export const GetAssembliesByPaintRegionIdsDocument = gql`
    query GetAssembliesByPaintRegionIds($input: GetAssembliesByPaintRegionIdsInput!) {
  getAssembliesByPaintRegionIds(input: $input) {
    id
    tagName
    templateFieldData
    poiCounts {
      poiType
      count
    }
    isUncontextualized
    decks {
      deckId {
        id
      }
    }
  }
}
    `;

/**
 * __useGetAssembliesByPaintRegionIdsQuery__
 *
 * To run a query within a React component, call `useGetAssembliesByPaintRegionIdsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAssembliesByPaintRegionIdsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAssembliesByPaintRegionIdsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetAssembliesByPaintRegionIdsQuery(baseOptions: Apollo.QueryHookOptions<GetAssembliesByPaintRegionIdsQuery, GetAssembliesByPaintRegionIdsQueryVariables> & ({ variables: GetAssembliesByPaintRegionIdsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAssembliesByPaintRegionIdsQuery, GetAssembliesByPaintRegionIdsQueryVariables>(GetAssembliesByPaintRegionIdsDocument, options);
      }
export function useGetAssembliesByPaintRegionIdsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAssembliesByPaintRegionIdsQuery, GetAssembliesByPaintRegionIdsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAssembliesByPaintRegionIdsQuery, GetAssembliesByPaintRegionIdsQueryVariables>(GetAssembliesByPaintRegionIdsDocument, options);
        }
// @ts-ignore
export function useGetAssembliesByPaintRegionIdsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetAssembliesByPaintRegionIdsQuery, GetAssembliesByPaintRegionIdsQueryVariables>): Apollo.UseSuspenseQueryResult<GetAssembliesByPaintRegionIdsQuery, GetAssembliesByPaintRegionIdsQueryVariables>;
export function useGetAssembliesByPaintRegionIdsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAssembliesByPaintRegionIdsQuery, GetAssembliesByPaintRegionIdsQueryVariables>): Apollo.UseSuspenseQueryResult<GetAssembliesByPaintRegionIdsQuery | undefined, GetAssembliesByPaintRegionIdsQueryVariables>;
export function useGetAssembliesByPaintRegionIdsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAssembliesByPaintRegionIdsQuery, GetAssembliesByPaintRegionIdsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAssembliesByPaintRegionIdsQuery, GetAssembliesByPaintRegionIdsQueryVariables>(GetAssembliesByPaintRegionIdsDocument, options);
        }
export type GetAssembliesByPaintRegionIdsQueryHookResult = ReturnType<typeof useGetAssembliesByPaintRegionIdsQuery>;
export type GetAssembliesByPaintRegionIdsLazyQueryHookResult = ReturnType<typeof useGetAssembliesByPaintRegionIdsLazyQuery>;
export type GetAssembliesByPaintRegionIdsSuspenseQueryHookResult = ReturnType<typeof useGetAssembliesByPaintRegionIdsSuspenseQuery>;
export type GetAssembliesByPaintRegionIdsQueryResult = Apollo.QueryResult<GetAssembliesByPaintRegionIdsQuery, GetAssembliesByPaintRegionIdsQueryVariables>;
export const PointOfInterestsCountByDueDateDocument = gql`
    query PointOfInterestsCountByDueDate($input: PointOfInterestMultiStructureInput) {
  pointOfInterestsCountByDueDate(input: $input) {
    count
    key
  }
}
    `;

/**
 * __usePointOfInterestsCountByDueDateQuery__
 *
 * To run a query within a React component, call `usePointOfInterestsCountByDueDateQuery` and pass it any options that fit your needs.
 * When your component renders, `usePointOfInterestsCountByDueDateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePointOfInterestsCountByDueDateQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePointOfInterestsCountByDueDateQuery(baseOptions?: Apollo.QueryHookOptions<PointOfInterestsCountByDueDateQuery, PointOfInterestsCountByDueDateQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PointOfInterestsCountByDueDateQuery, PointOfInterestsCountByDueDateQueryVariables>(PointOfInterestsCountByDueDateDocument, options);
      }
export function usePointOfInterestsCountByDueDateLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PointOfInterestsCountByDueDateQuery, PointOfInterestsCountByDueDateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PointOfInterestsCountByDueDateQuery, PointOfInterestsCountByDueDateQueryVariables>(PointOfInterestsCountByDueDateDocument, options);
        }
// @ts-ignore
export function usePointOfInterestsCountByDueDateSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<PointOfInterestsCountByDueDateQuery, PointOfInterestsCountByDueDateQueryVariables>): Apollo.UseSuspenseQueryResult<PointOfInterestsCountByDueDateQuery, PointOfInterestsCountByDueDateQueryVariables>;
export function usePointOfInterestsCountByDueDateSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PointOfInterestsCountByDueDateQuery, PointOfInterestsCountByDueDateQueryVariables>): Apollo.UseSuspenseQueryResult<PointOfInterestsCountByDueDateQuery | undefined, PointOfInterestsCountByDueDateQueryVariables>;
export function usePointOfInterestsCountByDueDateSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PointOfInterestsCountByDueDateQuery, PointOfInterestsCountByDueDateQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PointOfInterestsCountByDueDateQuery, PointOfInterestsCountByDueDateQueryVariables>(PointOfInterestsCountByDueDateDocument, options);
        }
export type PointOfInterestsCountByDueDateQueryHookResult = ReturnType<typeof usePointOfInterestsCountByDueDateQuery>;
export type PointOfInterestsCountByDueDateLazyQueryHookResult = ReturnType<typeof usePointOfInterestsCountByDueDateLazyQuery>;
export type PointOfInterestsCountByDueDateSuspenseQueryHookResult = ReturnType<typeof usePointOfInterestsCountByDueDateSuspenseQuery>;
export type PointOfInterestsCountByDueDateQueryResult = Apollo.QueryResult<PointOfInterestsCountByDueDateQuery, PointOfInterestsCountByDueDateQueryVariables>;
export const PaintDamageCountByAlarmLevelDocument = gql`
    query PaintDamageCountByAlarmLevel($input: PointOfInterestMultiStructureInput) {
  paintDamageCountByAlarmLevel(input: $input) {
    key
    count
  }
}
    `;

/**
 * __usePaintDamageCountByAlarmLevelQuery__
 *
 * To run a query within a React component, call `usePaintDamageCountByAlarmLevelQuery` and pass it any options that fit your needs.
 * When your component renders, `usePaintDamageCountByAlarmLevelQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePaintDamageCountByAlarmLevelQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePaintDamageCountByAlarmLevelQuery(baseOptions?: Apollo.QueryHookOptions<PaintDamageCountByAlarmLevelQuery, PaintDamageCountByAlarmLevelQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PaintDamageCountByAlarmLevelQuery, PaintDamageCountByAlarmLevelQueryVariables>(PaintDamageCountByAlarmLevelDocument, options);
      }
export function usePaintDamageCountByAlarmLevelLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PaintDamageCountByAlarmLevelQuery, PaintDamageCountByAlarmLevelQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PaintDamageCountByAlarmLevelQuery, PaintDamageCountByAlarmLevelQueryVariables>(PaintDamageCountByAlarmLevelDocument, options);
        }
// @ts-ignore
export function usePaintDamageCountByAlarmLevelSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<PaintDamageCountByAlarmLevelQuery, PaintDamageCountByAlarmLevelQueryVariables>): Apollo.UseSuspenseQueryResult<PaintDamageCountByAlarmLevelQuery, PaintDamageCountByAlarmLevelQueryVariables>;
export function usePaintDamageCountByAlarmLevelSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PaintDamageCountByAlarmLevelQuery, PaintDamageCountByAlarmLevelQueryVariables>): Apollo.UseSuspenseQueryResult<PaintDamageCountByAlarmLevelQuery | undefined, PaintDamageCountByAlarmLevelQueryVariables>;
export function usePaintDamageCountByAlarmLevelSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PaintDamageCountByAlarmLevelQuery, PaintDamageCountByAlarmLevelQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PaintDamageCountByAlarmLevelQuery, PaintDamageCountByAlarmLevelQueryVariables>(PaintDamageCountByAlarmLevelDocument, options);
        }
export type PaintDamageCountByAlarmLevelQueryHookResult = ReturnType<typeof usePaintDamageCountByAlarmLevelQuery>;
export type PaintDamageCountByAlarmLevelLazyQueryHookResult = ReturnType<typeof usePaintDamageCountByAlarmLevelLazyQuery>;
export type PaintDamageCountByAlarmLevelSuspenseQueryHookResult = ReturnType<typeof usePaintDamageCountByAlarmLevelSuspenseQuery>;
export type PaintDamageCountByAlarmLevelQueryResult = Apollo.QueryResult<PaintDamageCountByAlarmLevelQuery, PaintDamageCountByAlarmLevelQueryVariables>;
export const PointOfInterestsCountByInspectionPriorityDocument = gql`
    query PointOfInterestsCountByInspectionPriority($input: PointOfInterestInput) {
  pointOfInterestsCountByInspectionPriority(input: $input) {
    count
    key
  }
}
    `;

/**
 * __usePointOfInterestsCountByInspectionPriorityQuery__
 *
 * To run a query within a React component, call `usePointOfInterestsCountByInspectionPriorityQuery` and pass it any options that fit your needs.
 * When your component renders, `usePointOfInterestsCountByInspectionPriorityQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePointOfInterestsCountByInspectionPriorityQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePointOfInterestsCountByInspectionPriorityQuery(baseOptions?: Apollo.QueryHookOptions<PointOfInterestsCountByInspectionPriorityQuery, PointOfInterestsCountByInspectionPriorityQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PointOfInterestsCountByInspectionPriorityQuery, PointOfInterestsCountByInspectionPriorityQueryVariables>(PointOfInterestsCountByInspectionPriorityDocument, options);
      }
export function usePointOfInterestsCountByInspectionPriorityLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PointOfInterestsCountByInspectionPriorityQuery, PointOfInterestsCountByInspectionPriorityQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PointOfInterestsCountByInspectionPriorityQuery, PointOfInterestsCountByInspectionPriorityQueryVariables>(PointOfInterestsCountByInspectionPriorityDocument, options);
        }
// @ts-ignore
export function usePointOfInterestsCountByInspectionPrioritySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<PointOfInterestsCountByInspectionPriorityQuery, PointOfInterestsCountByInspectionPriorityQueryVariables>): Apollo.UseSuspenseQueryResult<PointOfInterestsCountByInspectionPriorityQuery, PointOfInterestsCountByInspectionPriorityQueryVariables>;
export function usePointOfInterestsCountByInspectionPrioritySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PointOfInterestsCountByInspectionPriorityQuery, PointOfInterestsCountByInspectionPriorityQueryVariables>): Apollo.UseSuspenseQueryResult<PointOfInterestsCountByInspectionPriorityQuery | undefined, PointOfInterestsCountByInspectionPriorityQueryVariables>;
export function usePointOfInterestsCountByInspectionPrioritySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PointOfInterestsCountByInspectionPriorityQuery, PointOfInterestsCountByInspectionPriorityQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PointOfInterestsCountByInspectionPriorityQuery, PointOfInterestsCountByInspectionPriorityQueryVariables>(PointOfInterestsCountByInspectionPriorityDocument, options);
        }
export type PointOfInterestsCountByInspectionPriorityQueryHookResult = ReturnType<typeof usePointOfInterestsCountByInspectionPriorityQuery>;
export type PointOfInterestsCountByInspectionPriorityLazyQueryHookResult = ReturnType<typeof usePointOfInterestsCountByInspectionPriorityLazyQuery>;
export type PointOfInterestsCountByInspectionPrioritySuspenseQueryHookResult = ReturnType<typeof usePointOfInterestsCountByInspectionPrioritySuspenseQuery>;
export type PointOfInterestsCountByInspectionPriorityQueryResult = Apollo.QueryResult<PointOfInterestsCountByInspectionPriorityQuery, PointOfInterestsCountByInspectionPriorityQueryVariables>;
export const PointOfInterestsCountByStatusDocument = gql`
    query PointOfInterestsCountByStatus($input: PointOfInterestMultiStructureInput) {
  pointOfInterestsCountByStatus(input: $input) {
    key
    count
  }
}
    `;

/**
 * __usePointOfInterestsCountByStatusQuery__
 *
 * To run a query within a React component, call `usePointOfInterestsCountByStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `usePointOfInterestsCountByStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePointOfInterestsCountByStatusQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePointOfInterestsCountByStatusQuery(baseOptions?: Apollo.QueryHookOptions<PointOfInterestsCountByStatusQuery, PointOfInterestsCountByStatusQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PointOfInterestsCountByStatusQuery, PointOfInterestsCountByStatusQueryVariables>(PointOfInterestsCountByStatusDocument, options);
      }
export function usePointOfInterestsCountByStatusLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PointOfInterestsCountByStatusQuery, PointOfInterestsCountByStatusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PointOfInterestsCountByStatusQuery, PointOfInterestsCountByStatusQueryVariables>(PointOfInterestsCountByStatusDocument, options);
        }
// @ts-ignore
export function usePointOfInterestsCountByStatusSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<PointOfInterestsCountByStatusQuery, PointOfInterestsCountByStatusQueryVariables>): Apollo.UseSuspenseQueryResult<PointOfInterestsCountByStatusQuery, PointOfInterestsCountByStatusQueryVariables>;
export function usePointOfInterestsCountByStatusSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PointOfInterestsCountByStatusQuery, PointOfInterestsCountByStatusQueryVariables>): Apollo.UseSuspenseQueryResult<PointOfInterestsCountByStatusQuery | undefined, PointOfInterestsCountByStatusQueryVariables>;
export function usePointOfInterestsCountByStatusSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PointOfInterestsCountByStatusQuery, PointOfInterestsCountByStatusQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PointOfInterestsCountByStatusQuery, PointOfInterestsCountByStatusQueryVariables>(PointOfInterestsCountByStatusDocument, options);
        }
export type PointOfInterestsCountByStatusQueryHookResult = ReturnType<typeof usePointOfInterestsCountByStatusQuery>;
export type PointOfInterestsCountByStatusLazyQueryHookResult = ReturnType<typeof usePointOfInterestsCountByStatusLazyQuery>;
export type PointOfInterestsCountByStatusSuspenseQueryHookResult = ReturnType<typeof usePointOfInterestsCountByStatusSuspenseQuery>;
export type PointOfInterestsCountByStatusQueryResult = Apollo.QueryResult<PointOfInterestsCountByStatusQuery, PointOfInterestsCountByStatusQueryVariables>;
export const PoiWorkflowDocument = gql`
    query POIWorkflow($input: PointOfInterestInput, $pageInfo: PageInfo) {
  pointOfInterests(input: $input, pageInfo: $pageInfo) {
    id
    name
    status
    assignee
    dueDate
    visibility
    accessibility
    comment
    isAutoGenerated
    linkedPointOfInterestIds
    accessibility
    poiId
    workpackNumber
  }
  pointOfInterestsCount(input: $input) {
    count
  }
}
    `;

/**
 * __usePoiWorkflowQuery__
 *
 * To run a query within a React component, call `usePoiWorkflowQuery` and pass it any options that fit your needs.
 * When your component renders, `usePoiWorkflowQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePoiWorkflowQuery({
 *   variables: {
 *      input: // value for 'input'
 *      pageInfo: // value for 'pageInfo'
 *   },
 * });
 */
export function usePoiWorkflowQuery(baseOptions?: Apollo.QueryHookOptions<PoiWorkflowQuery, PoiWorkflowQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PoiWorkflowQuery, PoiWorkflowQueryVariables>(PoiWorkflowDocument, options);
      }
export function usePoiWorkflowLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PoiWorkflowQuery, PoiWorkflowQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PoiWorkflowQuery, PoiWorkflowQueryVariables>(PoiWorkflowDocument, options);
        }
// @ts-ignore
export function usePoiWorkflowSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<PoiWorkflowQuery, PoiWorkflowQueryVariables>): Apollo.UseSuspenseQueryResult<PoiWorkflowQuery, PoiWorkflowQueryVariables>;
export function usePoiWorkflowSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PoiWorkflowQuery, PoiWorkflowQueryVariables>): Apollo.UseSuspenseQueryResult<PoiWorkflowQuery | undefined, PoiWorkflowQueryVariables>;
export function usePoiWorkflowSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PoiWorkflowQuery, PoiWorkflowQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PoiWorkflowQuery, PoiWorkflowQueryVariables>(PoiWorkflowDocument, options);
        }
export type PoiWorkflowQueryHookResult = ReturnType<typeof usePoiWorkflowQuery>;
export type PoiWorkflowLazyQueryHookResult = ReturnType<typeof usePoiWorkflowLazyQuery>;
export type PoiWorkflowSuspenseQueryHookResult = ReturnType<typeof usePoiWorkflowSuspenseQuery>;
export type PoiWorkflowQueryResult = Apollo.QueryResult<PoiWorkflowQuery, PoiWorkflowQueryVariables>;
export const AllWorkpacksDocument = gql`
    query AllWorkpacks($structureId: String, $hasPois: Boolean) {
  allWorkpacks(structureId: $structureId, hasPois: $hasPois) {
    id
    name
  }
}
    `;

/**
 * __useAllWorkpacksQuery__
 *
 * To run a query within a React component, call `useAllWorkpacksQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllWorkpacksQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllWorkpacksQuery({
 *   variables: {
 *      structureId: // value for 'structureId'
 *      hasPois: // value for 'hasPois'
 *   },
 * });
 */
export function useAllWorkpacksQuery(baseOptions?: Apollo.QueryHookOptions<AllWorkpacksQuery, AllWorkpacksQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AllWorkpacksQuery, AllWorkpacksQueryVariables>(AllWorkpacksDocument, options);
      }
export function useAllWorkpacksLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AllWorkpacksQuery, AllWorkpacksQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AllWorkpacksQuery, AllWorkpacksQueryVariables>(AllWorkpacksDocument, options);
        }
// @ts-ignore
export function useAllWorkpacksSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<AllWorkpacksQuery, AllWorkpacksQueryVariables>): Apollo.UseSuspenseQueryResult<AllWorkpacksQuery, AllWorkpacksQueryVariables>;
export function useAllWorkpacksSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AllWorkpacksQuery, AllWorkpacksQueryVariables>): Apollo.UseSuspenseQueryResult<AllWorkpacksQuery | undefined, AllWorkpacksQueryVariables>;
export function useAllWorkpacksSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AllWorkpacksQuery, AllWorkpacksQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AllWorkpacksQuery, AllWorkpacksQueryVariables>(AllWorkpacksDocument, options);
        }
export type AllWorkpacksQueryHookResult = ReturnType<typeof useAllWorkpacksQuery>;
export type AllWorkpacksLazyQueryHookResult = ReturnType<typeof useAllWorkpacksLazyQuery>;
export type AllWorkpacksSuspenseQueryHookResult = ReturnType<typeof useAllWorkpacksSuspenseQuery>;
export type AllWorkpacksQueryResult = Apollo.QueryResult<AllWorkpacksQuery, AllWorkpacksQueryVariables>;
export const DeleteWorkpackDocument = gql`
    mutation DeleteWorkpack($input: DeleteWorkpackInput) {
  deleteWorkpack(input: $input) {
    id
    name
  }
}
    `;
export type DeleteWorkpackMutationFn = Apollo.MutationFunction<DeleteWorkpackMutation, DeleteWorkpackMutationVariables>;

/**
 * __useDeleteWorkpackMutation__
 *
 * To run a mutation, you first call `useDeleteWorkpackMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteWorkpackMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteWorkpackMutation, { data, loading, error }] = useDeleteWorkpackMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteWorkpackMutation(baseOptions?: Apollo.MutationHookOptions<DeleteWorkpackMutation, DeleteWorkpackMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteWorkpackMutation, DeleteWorkpackMutationVariables>(DeleteWorkpackDocument, options);
      }
export type DeleteWorkpackMutationHookResult = ReturnType<typeof useDeleteWorkpackMutation>;
export type DeleteWorkpackMutationResult = Apollo.MutationResult<DeleteWorkpackMutation>;
export type DeleteWorkpackMutationOptions = Apollo.BaseMutationOptions<DeleteWorkpackMutation, DeleteWorkpackMutationVariables>;
export const RemoveWorkpackIdFromPointOfInterestsDocument = gql`
    mutation RemoveWorkpackIdFromPointOfInterests($input: InputGroupByWorkpackId) {
  RemoveWorkpackIdFromPointOfInterests(input: $input) {
    name
  }
}
    `;
export type RemoveWorkpackIdFromPointOfInterestsMutationFn = Apollo.MutationFunction<RemoveWorkpackIdFromPointOfInterestsMutation, RemoveWorkpackIdFromPointOfInterestsMutationVariables>;

/**
 * __useRemoveWorkpackIdFromPointOfInterestsMutation__
 *
 * To run a mutation, you first call `useRemoveWorkpackIdFromPointOfInterestsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveWorkpackIdFromPointOfInterestsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeWorkpackIdFromPointOfInterestsMutation, { data, loading, error }] = useRemoveWorkpackIdFromPointOfInterestsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRemoveWorkpackIdFromPointOfInterestsMutation(baseOptions?: Apollo.MutationHookOptions<RemoveWorkpackIdFromPointOfInterestsMutation, RemoveWorkpackIdFromPointOfInterestsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveWorkpackIdFromPointOfInterestsMutation, RemoveWorkpackIdFromPointOfInterestsMutationVariables>(RemoveWorkpackIdFromPointOfInterestsDocument, options);
      }
export type RemoveWorkpackIdFromPointOfInterestsMutationHookResult = ReturnType<typeof useRemoveWorkpackIdFromPointOfInterestsMutation>;
export type RemoveWorkpackIdFromPointOfInterestsMutationResult = Apollo.MutationResult<RemoveWorkpackIdFromPointOfInterestsMutation>;
export type RemoveWorkpackIdFromPointOfInterestsMutationOptions = Apollo.BaseMutationOptions<RemoveWorkpackIdFromPointOfInterestsMutation, RemoveWorkpackIdFromPointOfInterestsMutationVariables>;
export const CreateWorkpackDocument = gql`
    mutation CreateWorkpack($input: CreateWorkpackInput) {
  createWorkpack(input: $input) {
    name
    id
    type
  }
}
    `;
export type CreateWorkpackMutationFn = Apollo.MutationFunction<CreateWorkpackMutation, CreateWorkpackMutationVariables>;

/**
 * __useCreateWorkpackMutation__
 *
 * To run a mutation, you first call `useCreateWorkpackMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateWorkpackMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createWorkpackMutation, { data, loading, error }] = useCreateWorkpackMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateWorkpackMutation(baseOptions?: Apollo.MutationHookOptions<CreateWorkpackMutation, CreateWorkpackMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateWorkpackMutation, CreateWorkpackMutationVariables>(CreateWorkpackDocument, options);
      }
export type CreateWorkpackMutationHookResult = ReturnType<typeof useCreateWorkpackMutation>;
export type CreateWorkpackMutationResult = Apollo.MutationResult<CreateWorkpackMutation>;
export type CreateWorkpackMutationOptions = Apollo.BaseMutationOptions<CreateWorkpackMutation, CreateWorkpackMutationVariables>;
export const UpdateWorkpackDocument = gql`
    mutation UpdateWorkpack($input: UpdateWorkpackInput) {
  updateWorkpack(input: $input) {
    id
    name
    wbs
    type
  }
}
    `;
export type UpdateWorkpackMutationFn = Apollo.MutationFunction<UpdateWorkpackMutation, UpdateWorkpackMutationVariables>;

/**
 * __useUpdateWorkpackMutation__
 *
 * To run a mutation, you first call `useUpdateWorkpackMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateWorkpackMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateWorkpackMutation, { data, loading, error }] = useUpdateWorkpackMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateWorkpackMutation(baseOptions?: Apollo.MutationHookOptions<UpdateWorkpackMutation, UpdateWorkpackMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateWorkpackMutation, UpdateWorkpackMutationVariables>(UpdateWorkpackDocument, options);
      }
export type UpdateWorkpackMutationHookResult = ReturnType<typeof useUpdateWorkpackMutation>;
export type UpdateWorkpackMutationResult = Apollo.MutationResult<UpdateWorkpackMutation>;
export type UpdateWorkpackMutationOptions = Apollo.BaseMutationOptions<UpdateWorkpackMutation, UpdateWorkpackMutationVariables>;
export const UpdateWorkpackStatusDocument = gql`
    mutation UpdateWorkpackStatus($workpackId: ID!, $status: String!) {
  updateWorkpackStatus(workpackId: $workpackId, status: $status) {
    status
  }
}
    `;
export type UpdateWorkpackStatusMutationFn = Apollo.MutationFunction<UpdateWorkpackStatusMutation, UpdateWorkpackStatusMutationVariables>;

/**
 * __useUpdateWorkpackStatusMutation__
 *
 * To run a mutation, you first call `useUpdateWorkpackStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateWorkpackStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateWorkpackStatusMutation, { data, loading, error }] = useUpdateWorkpackStatusMutation({
 *   variables: {
 *      workpackId: // value for 'workpackId'
 *      status: // value for 'status'
 *   },
 * });
 */
export function useUpdateWorkpackStatusMutation(baseOptions?: Apollo.MutationHookOptions<UpdateWorkpackStatusMutation, UpdateWorkpackStatusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateWorkpackStatusMutation, UpdateWorkpackStatusMutationVariables>(UpdateWorkpackStatusDocument, options);
      }
export type UpdateWorkpackStatusMutationHookResult = ReturnType<typeof useUpdateWorkpackStatusMutation>;
export type UpdateWorkpackStatusMutationResult = Apollo.MutationResult<UpdateWorkpackStatusMutation>;
export type UpdateWorkpackStatusMutationOptions = Apollo.BaseMutationOptions<UpdateWorkpackStatusMutation, UpdateWorkpackStatusMutationVariables>;
export const GroupPointOfInterestsByWorkpackIdDocument = gql`
    mutation GroupPointOfInterestsByWorkpackId($input: InputGroupByWorkpackId) {
  GroupPointOfInterestsByWorkpackId(input: $input) {
    poiId
  }
}
    `;
export type GroupPointOfInterestsByWorkpackIdMutationFn = Apollo.MutationFunction<GroupPointOfInterestsByWorkpackIdMutation, GroupPointOfInterestsByWorkpackIdMutationVariables>;

/**
 * __useGroupPointOfInterestsByWorkpackIdMutation__
 *
 * To run a mutation, you first call `useGroupPointOfInterestsByWorkpackIdMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGroupPointOfInterestsByWorkpackIdMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [groupPointOfInterestsByWorkpackIdMutation, { data, loading, error }] = useGroupPointOfInterestsByWorkpackIdMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGroupPointOfInterestsByWorkpackIdMutation(baseOptions?: Apollo.MutationHookOptions<GroupPointOfInterestsByWorkpackIdMutation, GroupPointOfInterestsByWorkpackIdMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GroupPointOfInterestsByWorkpackIdMutation, GroupPointOfInterestsByWorkpackIdMutationVariables>(GroupPointOfInterestsByWorkpackIdDocument, options);
      }
export type GroupPointOfInterestsByWorkpackIdMutationHookResult = ReturnType<typeof useGroupPointOfInterestsByWorkpackIdMutation>;
export type GroupPointOfInterestsByWorkpackIdMutationResult = Apollo.MutationResult<GroupPointOfInterestsByWorkpackIdMutation>;
export type GroupPointOfInterestsByWorkpackIdMutationOptions = Apollo.BaseMutationOptions<GroupPointOfInterestsByWorkpackIdMutation, GroupPointOfInterestsByWorkpackIdMutationVariables>;
export const GetPointOfInterestGroupedByWorkpackDocument = gql`
    query GetPointOfInterestGroupedByWorkpack($input: PointOfInterestInput, $pageInfo: PageInfo) {
  allWorkpacks: GetPointOfInterestGroupedByWorkpack(
    input: $input
    pageInfo: $pageInfo
  ) {
    _id
    workpack {
      name
      status
      type
      wbs
    }
    verifiedPointOfInterestsCount
    pointOfInterestsCount
    assembliesCount
  }
  workpacksCount: GetPointOfInterestGroupedByWorkpackCount(input: $input) {
    count
  }
}
    `;

/**
 * __useGetPointOfInterestGroupedByWorkpackQuery__
 *
 * To run a query within a React component, call `useGetPointOfInterestGroupedByWorkpackQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPointOfInterestGroupedByWorkpackQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPointOfInterestGroupedByWorkpackQuery({
 *   variables: {
 *      input: // value for 'input'
 *      pageInfo: // value for 'pageInfo'
 *   },
 * });
 */
export function useGetPointOfInterestGroupedByWorkpackQuery(baseOptions?: Apollo.QueryHookOptions<GetPointOfInterestGroupedByWorkpackQuery, GetPointOfInterestGroupedByWorkpackQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPointOfInterestGroupedByWorkpackQuery, GetPointOfInterestGroupedByWorkpackQueryVariables>(GetPointOfInterestGroupedByWorkpackDocument, options);
      }
export function useGetPointOfInterestGroupedByWorkpackLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPointOfInterestGroupedByWorkpackQuery, GetPointOfInterestGroupedByWorkpackQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPointOfInterestGroupedByWorkpackQuery, GetPointOfInterestGroupedByWorkpackQueryVariables>(GetPointOfInterestGroupedByWorkpackDocument, options);
        }
// @ts-ignore
export function useGetPointOfInterestGroupedByWorkpackSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetPointOfInterestGroupedByWorkpackQuery, GetPointOfInterestGroupedByWorkpackQueryVariables>): Apollo.UseSuspenseQueryResult<GetPointOfInterestGroupedByWorkpackQuery, GetPointOfInterestGroupedByWorkpackQueryVariables>;
export function useGetPointOfInterestGroupedByWorkpackSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPointOfInterestGroupedByWorkpackQuery, GetPointOfInterestGroupedByWorkpackQueryVariables>): Apollo.UseSuspenseQueryResult<GetPointOfInterestGroupedByWorkpackQuery | undefined, GetPointOfInterestGroupedByWorkpackQueryVariables>;
export function useGetPointOfInterestGroupedByWorkpackSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPointOfInterestGroupedByWorkpackQuery, GetPointOfInterestGroupedByWorkpackQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetPointOfInterestGroupedByWorkpackQuery, GetPointOfInterestGroupedByWorkpackQueryVariables>(GetPointOfInterestGroupedByWorkpackDocument, options);
        }
export type GetPointOfInterestGroupedByWorkpackQueryHookResult = ReturnType<typeof useGetPointOfInterestGroupedByWorkpackQuery>;
export type GetPointOfInterestGroupedByWorkpackLazyQueryHookResult = ReturnType<typeof useGetPointOfInterestGroupedByWorkpackLazyQuery>;
export type GetPointOfInterestGroupedByWorkpackSuspenseQueryHookResult = ReturnType<typeof useGetPointOfInterestGroupedByWorkpackSuspenseQuery>;
export type GetPointOfInterestGroupedByWorkpackQueryResult = Apollo.QueryResult<GetPointOfInterestGroupedByWorkpackQuery, GetPointOfInterestGroupedByWorkpackQueryVariables>;
export const AllWorkpackTemplatesForPoiContainerDocument = gql`
    query AllWorkpackTemplatesForPoiContainer($input: WorkpackTemplateInput!) {
  allWorkpackTemplates(input: $input) {
    id
    name
  }
}
    `;

/**
 * __useAllWorkpackTemplatesForPoiContainerQuery__
 *
 * To run a query within a React component, call `useAllWorkpackTemplatesForPoiContainerQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllWorkpackTemplatesForPoiContainerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllWorkpackTemplatesForPoiContainerQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAllWorkpackTemplatesForPoiContainerQuery(baseOptions: Apollo.QueryHookOptions<AllWorkpackTemplatesForPoiContainerQuery, AllWorkpackTemplatesForPoiContainerQueryVariables> & ({ variables: AllWorkpackTemplatesForPoiContainerQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AllWorkpackTemplatesForPoiContainerQuery, AllWorkpackTemplatesForPoiContainerQueryVariables>(AllWorkpackTemplatesForPoiContainerDocument, options);
      }
export function useAllWorkpackTemplatesForPoiContainerLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AllWorkpackTemplatesForPoiContainerQuery, AllWorkpackTemplatesForPoiContainerQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AllWorkpackTemplatesForPoiContainerQuery, AllWorkpackTemplatesForPoiContainerQueryVariables>(AllWorkpackTemplatesForPoiContainerDocument, options);
        }
// @ts-ignore
export function useAllWorkpackTemplatesForPoiContainerSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<AllWorkpackTemplatesForPoiContainerQuery, AllWorkpackTemplatesForPoiContainerQueryVariables>): Apollo.UseSuspenseQueryResult<AllWorkpackTemplatesForPoiContainerQuery, AllWorkpackTemplatesForPoiContainerQueryVariables>;
export function useAllWorkpackTemplatesForPoiContainerSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AllWorkpackTemplatesForPoiContainerQuery, AllWorkpackTemplatesForPoiContainerQueryVariables>): Apollo.UseSuspenseQueryResult<AllWorkpackTemplatesForPoiContainerQuery | undefined, AllWorkpackTemplatesForPoiContainerQueryVariables>;
export function useAllWorkpackTemplatesForPoiContainerSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AllWorkpackTemplatesForPoiContainerQuery, AllWorkpackTemplatesForPoiContainerQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AllWorkpackTemplatesForPoiContainerQuery, AllWorkpackTemplatesForPoiContainerQueryVariables>(AllWorkpackTemplatesForPoiContainerDocument, options);
        }
export type AllWorkpackTemplatesForPoiContainerQueryHookResult = ReturnType<typeof useAllWorkpackTemplatesForPoiContainerQuery>;
export type AllWorkpackTemplatesForPoiContainerLazyQueryHookResult = ReturnType<typeof useAllWorkpackTemplatesForPoiContainerLazyQuery>;
export type AllWorkpackTemplatesForPoiContainerSuspenseQueryHookResult = ReturnType<typeof useAllWorkpackTemplatesForPoiContainerSuspenseQuery>;
export type AllWorkpackTemplatesForPoiContainerQueryResult = Apollo.QueryResult<AllWorkpackTemplatesForPoiContainerQuery, AllWorkpackTemplatesForPoiContainerQueryVariables>;
export const AllPointOfInterestsDocument = gql`
    query AllPointOfInterests($input: FindAllPointOfInterestsInput) {
  allPointOfInterests(input: $input) {
    id
    name
    assembly {
      tagName
      id
    }
    template {
      id
    }
    templateFieldData
    workpack {
      id
      name
      status
    }
  }
}
    `;

/**
 * __useAllPointOfInterestsQuery__
 *
 * To run a query within a React component, call `useAllPointOfInterestsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllPointOfInterestsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllPointOfInterestsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAllPointOfInterestsQuery(baseOptions?: Apollo.QueryHookOptions<AllPointOfInterestsQuery, AllPointOfInterestsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AllPointOfInterestsQuery, AllPointOfInterestsQueryVariables>(AllPointOfInterestsDocument, options);
      }
export function useAllPointOfInterestsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AllPointOfInterestsQuery, AllPointOfInterestsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AllPointOfInterestsQuery, AllPointOfInterestsQueryVariables>(AllPointOfInterestsDocument, options);
        }
// @ts-ignore
export function useAllPointOfInterestsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<AllPointOfInterestsQuery, AllPointOfInterestsQueryVariables>): Apollo.UseSuspenseQueryResult<AllPointOfInterestsQuery, AllPointOfInterestsQueryVariables>;
export function useAllPointOfInterestsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AllPointOfInterestsQuery, AllPointOfInterestsQueryVariables>): Apollo.UseSuspenseQueryResult<AllPointOfInterestsQuery | undefined, AllPointOfInterestsQueryVariables>;
export function useAllPointOfInterestsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AllPointOfInterestsQuery, AllPointOfInterestsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AllPointOfInterestsQuery, AllPointOfInterestsQueryVariables>(AllPointOfInterestsDocument, options);
        }
export type AllPointOfInterestsQueryHookResult = ReturnType<typeof useAllPointOfInterestsQuery>;
export type AllPointOfInterestsLazyQueryHookResult = ReturnType<typeof useAllPointOfInterestsLazyQuery>;
export type AllPointOfInterestsSuspenseQueryHookResult = ReturnType<typeof useAllPointOfInterestsSuspenseQuery>;
export type AllPointOfInterestsQueryResult = Apollo.QueryResult<AllPointOfInterestsQuery, AllPointOfInterestsQueryVariables>;
export const UpdateReportByPointOfInterestsDocument = gql`
    mutation updateReportByPointOfInterests($input: updateReportByPointOfInterestsInput) {
  updateReportByPointOfInterests(input: $input) {
    createdAt
    id
    name
    status
  }
}
    `;
export type UpdateReportByPointOfInterestsMutationFn = Apollo.MutationFunction<UpdateReportByPointOfInterestsMutation, UpdateReportByPointOfInterestsMutationVariables>;

/**
 * __useUpdateReportByPointOfInterestsMutation__
 *
 * To run a mutation, you first call `useUpdateReportByPointOfInterestsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateReportByPointOfInterestsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateReportByPointOfInterestsMutation, { data, loading, error }] = useUpdateReportByPointOfInterestsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateReportByPointOfInterestsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateReportByPointOfInterestsMutation, UpdateReportByPointOfInterestsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateReportByPointOfInterestsMutation, UpdateReportByPointOfInterestsMutationVariables>(UpdateReportByPointOfInterestsDocument, options);
      }
export type UpdateReportByPointOfInterestsMutationHookResult = ReturnType<typeof useUpdateReportByPointOfInterestsMutation>;
export type UpdateReportByPointOfInterestsMutationResult = Apollo.MutationResult<UpdateReportByPointOfInterestsMutation>;
export type UpdateReportByPointOfInterestsMutationOptions = Apollo.BaseMutationOptions<UpdateReportByPointOfInterestsMutation, UpdateReportByPointOfInterestsMutationVariables>;
export const UpdatePointOfInterestVisibilityDocument = gql`
    mutation UpdatePointOfInterestVisibility($input: UpdatePointOfInterestVisibilityInput, $filters: PointOfInterestInput) {
  updatePointOfInterestVisibility(input: $input, filters: $filters) {
    id
  }
}
    `;
export type UpdatePointOfInterestVisibilityMutationFn = Apollo.MutationFunction<UpdatePointOfInterestVisibilityMutation, UpdatePointOfInterestVisibilityMutationVariables>;

/**
 * __useUpdatePointOfInterestVisibilityMutation__
 *
 * To run a mutation, you first call `useUpdatePointOfInterestVisibilityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePointOfInterestVisibilityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePointOfInterestVisibilityMutation, { data, loading, error }] = useUpdatePointOfInterestVisibilityMutation({
 *   variables: {
 *      input: // value for 'input'
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useUpdatePointOfInterestVisibilityMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePointOfInterestVisibilityMutation, UpdatePointOfInterestVisibilityMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePointOfInterestVisibilityMutation, UpdatePointOfInterestVisibilityMutationVariables>(UpdatePointOfInterestVisibilityDocument, options);
      }
export type UpdatePointOfInterestVisibilityMutationHookResult = ReturnType<typeof useUpdatePointOfInterestVisibilityMutation>;
export type UpdatePointOfInterestVisibilityMutationResult = Apollo.MutationResult<UpdatePointOfInterestVisibilityMutation>;
export type UpdatePointOfInterestVisibilityMutationOptions = Apollo.BaseMutationOptions<UpdatePointOfInterestVisibilityMutation, UpdatePointOfInterestVisibilityMutationVariables>;
export const GetUserPreferencesDocument = gql`
    query GetUserPreferences {
  getUserPreferences {
    structure
    platform
  }
}
    `;

/**
 * __useGetUserPreferencesQuery__
 *
 * To run a query within a React component, call `useGetUserPreferencesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserPreferencesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserPreferencesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetUserPreferencesQuery(baseOptions?: Apollo.QueryHookOptions<GetUserPreferencesQuery, GetUserPreferencesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUserPreferencesQuery, GetUserPreferencesQueryVariables>(GetUserPreferencesDocument, options);
      }
export function useGetUserPreferencesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUserPreferencesQuery, GetUserPreferencesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUserPreferencesQuery, GetUserPreferencesQueryVariables>(GetUserPreferencesDocument, options);
        }
// @ts-ignore
export function useGetUserPreferencesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetUserPreferencesQuery, GetUserPreferencesQueryVariables>): Apollo.UseSuspenseQueryResult<GetUserPreferencesQuery, GetUserPreferencesQueryVariables>;
export function useGetUserPreferencesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetUserPreferencesQuery, GetUserPreferencesQueryVariables>): Apollo.UseSuspenseQueryResult<GetUserPreferencesQuery | undefined, GetUserPreferencesQueryVariables>;
export function useGetUserPreferencesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetUserPreferencesQuery, GetUserPreferencesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetUserPreferencesQuery, GetUserPreferencesQueryVariables>(GetUserPreferencesDocument, options);
        }
export type GetUserPreferencesQueryHookResult = ReturnType<typeof useGetUserPreferencesQuery>;
export type GetUserPreferencesLazyQueryHookResult = ReturnType<typeof useGetUserPreferencesLazyQuery>;
export type GetUserPreferencesSuspenseQueryHookResult = ReturnType<typeof useGetUserPreferencesSuspenseQuery>;
export type GetUserPreferencesQueryResult = Apollo.QueryResult<GetUserPreferencesQuery, GetUserPreferencesQueryVariables>;
export const PointOfInterestsCountByTypeDocument = gql`
    query PointOfInterestsCountByType($input: PointOfInterestInput) {
  pointOfInterestsCountByType(input: $input) {
    count
    type
  }
}
    `;

/**
 * __usePointOfInterestsCountByTypeQuery__
 *
 * To run a query within a React component, call `usePointOfInterestsCountByTypeQuery` and pass it any options that fit your needs.
 * When your component renders, `usePointOfInterestsCountByTypeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePointOfInterestsCountByTypeQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePointOfInterestsCountByTypeQuery(baseOptions?: Apollo.QueryHookOptions<PointOfInterestsCountByTypeQuery, PointOfInterestsCountByTypeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PointOfInterestsCountByTypeQuery, PointOfInterestsCountByTypeQueryVariables>(PointOfInterestsCountByTypeDocument, options);
      }
export function usePointOfInterestsCountByTypeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PointOfInterestsCountByTypeQuery, PointOfInterestsCountByTypeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PointOfInterestsCountByTypeQuery, PointOfInterestsCountByTypeQueryVariables>(PointOfInterestsCountByTypeDocument, options);
        }
// @ts-ignore
export function usePointOfInterestsCountByTypeSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<PointOfInterestsCountByTypeQuery, PointOfInterestsCountByTypeQueryVariables>): Apollo.UseSuspenseQueryResult<PointOfInterestsCountByTypeQuery, PointOfInterestsCountByTypeQueryVariables>;
export function usePointOfInterestsCountByTypeSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PointOfInterestsCountByTypeQuery, PointOfInterestsCountByTypeQueryVariables>): Apollo.UseSuspenseQueryResult<PointOfInterestsCountByTypeQuery | undefined, PointOfInterestsCountByTypeQueryVariables>;
export function usePointOfInterestsCountByTypeSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PointOfInterestsCountByTypeQuery, PointOfInterestsCountByTypeQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PointOfInterestsCountByTypeQuery, PointOfInterestsCountByTypeQueryVariables>(PointOfInterestsCountByTypeDocument, options);
        }
export type PointOfInterestsCountByTypeQueryHookResult = ReturnType<typeof usePointOfInterestsCountByTypeQuery>;
export type PointOfInterestsCountByTypeLazyQueryHookResult = ReturnType<typeof usePointOfInterestsCountByTypeLazyQuery>;
export type PointOfInterestsCountByTypeSuspenseQueryHookResult = ReturnType<typeof usePointOfInterestsCountByTypeSuspenseQuery>;
export type PointOfInterestsCountByTypeQueryResult = Apollo.QueryResult<PointOfInterestsCountByTypeQuery, PointOfInterestsCountByTypeQueryVariables>;
export const UpdateUserColumnPreferencesDocument = gql`
    mutation UpdateUserColumnPreferences($input: UpdateUserColumnPreferencesInput) {
  updateUserColumnPreferences(input: $input) {
    preferences {
      structure
    }
  }
}
    `;
export type UpdateUserColumnPreferencesMutationFn = Apollo.MutationFunction<UpdateUserColumnPreferencesMutation, UpdateUserColumnPreferencesMutationVariables>;

/**
 * __useUpdateUserColumnPreferencesMutation__
 *
 * To run a mutation, you first call `useUpdateUserColumnPreferencesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserColumnPreferencesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserColumnPreferencesMutation, { data, loading, error }] = useUpdateUserColumnPreferencesMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateUserColumnPreferencesMutation(baseOptions?: Apollo.MutationHookOptions<UpdateUserColumnPreferencesMutation, UpdateUserColumnPreferencesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateUserColumnPreferencesMutation, UpdateUserColumnPreferencesMutationVariables>(UpdateUserColumnPreferencesDocument, options);
      }
export type UpdateUserColumnPreferencesMutationHookResult = ReturnType<typeof useUpdateUserColumnPreferencesMutation>;
export type UpdateUserColumnPreferencesMutationResult = Apollo.MutationResult<UpdateUserColumnPreferencesMutation>;
export type UpdateUserColumnPreferencesMutationOptions = Apollo.BaseMutationOptions<UpdateUserColumnPreferencesMutation, UpdateUserColumnPreferencesMutationVariables>;
export const UpdateUserStructurePreferencesDocument = gql`
    mutation UpdateUserStructurePreferences($input: UpdateUserStructurePreferencesInput) {
  updateUserStructurePreferences(input: $input) {
    structure
  }
}
    `;
export type UpdateUserStructurePreferencesMutationFn = Apollo.MutationFunction<UpdateUserStructurePreferencesMutation, UpdateUserStructurePreferencesMutationVariables>;

/**
 * __useUpdateUserStructurePreferencesMutation__
 *
 * To run a mutation, you first call `useUpdateUserStructurePreferencesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserStructurePreferencesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserStructurePreferencesMutation, { data, loading, error }] = useUpdateUserStructurePreferencesMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateUserStructurePreferencesMutation(baseOptions?: Apollo.MutationHookOptions<UpdateUserStructurePreferencesMutation, UpdateUserStructurePreferencesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateUserStructurePreferencesMutation, UpdateUserStructurePreferencesMutationVariables>(UpdateUserStructurePreferencesDocument, options);
      }
export type UpdateUserStructurePreferencesMutationHookResult = ReturnType<typeof useUpdateUserStructurePreferencesMutation>;
export type UpdateUserStructurePreferencesMutationResult = Apollo.MutationResult<UpdateUserStructurePreferencesMutation>;
export type UpdateUserStructurePreferencesMutationOptions = Apollo.BaseMutationOptions<UpdateUserStructurePreferencesMutation, UpdateUserStructurePreferencesMutationVariables>;
export const GetInspectionPlansDocument = gql`
    query GetInspectionPlans($structureId: String!) {
  getInspectionPlans(structureId: $structureId) {
    id
    name
    filters {
      deckIds
      workpackIds
      paintRegionIds
      templateFilters {
        id
        value
      }
    }
    isPlanPinned
  }
}
    `;

/**
 * __useGetInspectionPlansQuery__
 *
 * To run a query within a React component, call `useGetInspectionPlansQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetInspectionPlansQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetInspectionPlansQuery({
 *   variables: {
 *      structureId: // value for 'structureId'
 *   },
 * });
 */
export function useGetInspectionPlansQuery(baseOptions: Apollo.QueryHookOptions<GetInspectionPlansQuery, GetInspectionPlansQueryVariables> & ({ variables: GetInspectionPlansQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetInspectionPlansQuery, GetInspectionPlansQueryVariables>(GetInspectionPlansDocument, options);
      }
export function useGetInspectionPlansLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetInspectionPlansQuery, GetInspectionPlansQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetInspectionPlansQuery, GetInspectionPlansQueryVariables>(GetInspectionPlansDocument, options);
        }
// @ts-ignore
export function useGetInspectionPlansSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetInspectionPlansQuery, GetInspectionPlansQueryVariables>): Apollo.UseSuspenseQueryResult<GetInspectionPlansQuery, GetInspectionPlansQueryVariables>;
export function useGetInspectionPlansSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetInspectionPlansQuery, GetInspectionPlansQueryVariables>): Apollo.UseSuspenseQueryResult<GetInspectionPlansQuery | undefined, GetInspectionPlansQueryVariables>;
export function useGetInspectionPlansSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetInspectionPlansQuery, GetInspectionPlansQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetInspectionPlansQuery, GetInspectionPlansQueryVariables>(GetInspectionPlansDocument, options);
        }
export type GetInspectionPlansQueryHookResult = ReturnType<typeof useGetInspectionPlansQuery>;
export type GetInspectionPlansLazyQueryHookResult = ReturnType<typeof useGetInspectionPlansLazyQuery>;
export type GetInspectionPlansSuspenseQueryHookResult = ReturnType<typeof useGetInspectionPlansSuspenseQuery>;
export type GetInspectionPlansQueryResult = Apollo.QueryResult<GetInspectionPlansQuery, GetInspectionPlansQueryVariables>;
export const CreateInspectionPlanDocument = gql`
    mutation CreateInspectionPlan($input: CreateInspectionPlanInput!) {
  createInspectionPlan(input: $input) {
    id
    name
    filters {
      deckIds
      workpackIds
      paintRegionIds
      templateFilters {
        id
        value
      }
    }
    isPlanPinned
  }
}
    `;
export type CreateInspectionPlanMutationFn = Apollo.MutationFunction<CreateInspectionPlanMutation, CreateInspectionPlanMutationVariables>;

/**
 * __useCreateInspectionPlanMutation__
 *
 * To run a mutation, you first call `useCreateInspectionPlanMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateInspectionPlanMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createInspectionPlanMutation, { data, loading, error }] = useCreateInspectionPlanMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateInspectionPlanMutation(baseOptions?: Apollo.MutationHookOptions<CreateInspectionPlanMutation, CreateInspectionPlanMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateInspectionPlanMutation, CreateInspectionPlanMutationVariables>(CreateInspectionPlanDocument, options);
      }
export type CreateInspectionPlanMutationHookResult = ReturnType<typeof useCreateInspectionPlanMutation>;
export type CreateInspectionPlanMutationResult = Apollo.MutationResult<CreateInspectionPlanMutation>;
export type CreateInspectionPlanMutationOptions = Apollo.BaseMutationOptions<CreateInspectionPlanMutation, CreateInspectionPlanMutationVariables>;
export const UpdateInspectionPlanDocument = gql`
    mutation UpdateInspectionPlan($input: UpdateInspectionPlanInput!) {
  updateInspectionPlan(input: $input) {
    id
    name
    filters {
      deckIds
      workpackIds
      paintRegionIds
      templateFilters {
        id
        value
      }
    }
    isPlanPinned
  }
}
    `;
export type UpdateInspectionPlanMutationFn = Apollo.MutationFunction<UpdateInspectionPlanMutation, UpdateInspectionPlanMutationVariables>;

/**
 * __useUpdateInspectionPlanMutation__
 *
 * To run a mutation, you first call `useUpdateInspectionPlanMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateInspectionPlanMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateInspectionPlanMutation, { data, loading, error }] = useUpdateInspectionPlanMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateInspectionPlanMutation(baseOptions?: Apollo.MutationHookOptions<UpdateInspectionPlanMutation, UpdateInspectionPlanMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateInspectionPlanMutation, UpdateInspectionPlanMutationVariables>(UpdateInspectionPlanDocument, options);
      }
export type UpdateInspectionPlanMutationHookResult = ReturnType<typeof useUpdateInspectionPlanMutation>;
export type UpdateInspectionPlanMutationResult = Apollo.MutationResult<UpdateInspectionPlanMutation>;
export type UpdateInspectionPlanMutationOptions = Apollo.BaseMutationOptions<UpdateInspectionPlanMutation, UpdateInspectionPlanMutationVariables>;
export const DeleteInspectionPlanDocument = gql`
    mutation DeleteInspectionPlan($input: DeleteInspectionPlanInput!) {
  deleteInspectionPlan(input: $input) {
    id
    name
    filters {
      deckIds
      workpackIds
      paintRegionIds
      templateFilters {
        id
        value
      }
    }
    isPlanPinned
  }
}
    `;
export type DeleteInspectionPlanMutationFn = Apollo.MutationFunction<DeleteInspectionPlanMutation, DeleteInspectionPlanMutationVariables>;

/**
 * __useDeleteInspectionPlanMutation__
 *
 * To run a mutation, you first call `useDeleteInspectionPlanMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteInspectionPlanMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteInspectionPlanMutation, { data, loading, error }] = useDeleteInspectionPlanMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteInspectionPlanMutation(baseOptions?: Apollo.MutationHookOptions<DeleteInspectionPlanMutation, DeleteInspectionPlanMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteInspectionPlanMutation, DeleteInspectionPlanMutationVariables>(DeleteInspectionPlanDocument, options);
      }
export type DeleteInspectionPlanMutationHookResult = ReturnType<typeof useDeleteInspectionPlanMutation>;
export type DeleteInspectionPlanMutationResult = Apollo.MutationResult<DeleteInspectionPlanMutation>;
export type DeleteInspectionPlanMutationOptions = Apollo.BaseMutationOptions<DeleteInspectionPlanMutation, DeleteInspectionPlanMutationVariables>;
export const DeletePlannerColumnDocument = gql`
    mutation DeletePlannerColumn($input: DeletePlannerColumnInput!) {
  deletePlannerColumn(input: $input) {
    id
  }
}
    `;
export type DeletePlannerColumnMutationFn = Apollo.MutationFunction<DeletePlannerColumnMutation, DeletePlannerColumnMutationVariables>;

/**
 * __useDeletePlannerColumnMutation__
 *
 * To run a mutation, you first call `useDeletePlannerColumnMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeletePlannerColumnMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deletePlannerColumnMutation, { data, loading, error }] = useDeletePlannerColumnMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeletePlannerColumnMutation(baseOptions?: Apollo.MutationHookOptions<DeletePlannerColumnMutation, DeletePlannerColumnMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeletePlannerColumnMutation, DeletePlannerColumnMutationVariables>(DeletePlannerColumnDocument, options);
      }
export type DeletePlannerColumnMutationHookResult = ReturnType<typeof useDeletePlannerColumnMutation>;
export type DeletePlannerColumnMutationResult = Apollo.MutationResult<DeletePlannerColumnMutation>;
export type DeletePlannerColumnMutationOptions = Apollo.BaseMutationOptions<DeletePlannerColumnMutation, DeletePlannerColumnMutationVariables>;
export const CreateAssemblyDocument = gql`
    mutation createAssembly($input: CreateAssemblyInput) {
  createAssembly(input: $input) {
    name
    id
    defectsArray
    recommendation {
      header
      details {
        id
        fieldKey
      }
    }
    equipmentCard {
      id
      name
      type
      position
      fieldKey
      location
    }
    equipmentDetails {
      id
      name
      subType
      type
      fieldKey
      options {
        id
        name
        type
        fieldKey
      }
    }
    querySummary {
      name
      key
      operation
    }
    fields {
      isEditable
      editRoles
      options
      displayConfig {
        id
        type
        color {
          key
          value
        }
        isSortable
        sortType
      }
      id
      name
      key
      type
      serverSide
      permission
      displayInQuery
      displayInRisk
      roundToDecimal
      unit
      displayUnit
    }
  }
}
    `;
export type CreateAssemblyMutationFn = Apollo.MutationFunction<CreateAssemblyMutation, CreateAssemblyMutationVariables>;

/**
 * __useCreateAssemblyMutation__
 *
 * To run a mutation, you first call `useCreateAssemblyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAssemblyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAssemblyMutation, { data, loading, error }] = useCreateAssemblyMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateAssemblyMutation(baseOptions?: Apollo.MutationHookOptions<CreateAssemblyMutation, CreateAssemblyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateAssemblyMutation, CreateAssemblyMutationVariables>(CreateAssemblyDocument, options);
      }
export type CreateAssemblyMutationHookResult = ReturnType<typeof useCreateAssemblyMutation>;
export type CreateAssemblyMutationResult = Apollo.MutationResult<CreateAssemblyMutation>;
export type CreateAssemblyMutationOptions = Apollo.BaseMutationOptions<CreateAssemblyMutation, CreateAssemblyMutationVariables>;
export const GetAllTemplatesByTypeDocument = gql`
    query getAllTemplatesByType($structureId: ID!, $type: TemplateTypeEnum!) {
  allTemplates(structureId: $structureId, type: $type) {
    id
    name
    fields {
      options
      name
      type
      id
    }
    permissions
  }
}
    `;

/**
 * __useGetAllTemplatesByTypeQuery__
 *
 * To run a query within a React component, call `useGetAllTemplatesByTypeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllTemplatesByTypeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllTemplatesByTypeQuery({
 *   variables: {
 *      structureId: // value for 'structureId'
 *      type: // value for 'type'
 *   },
 * });
 */
export function useGetAllTemplatesByTypeQuery(baseOptions: Apollo.QueryHookOptions<GetAllTemplatesByTypeQuery, GetAllTemplatesByTypeQueryVariables> & ({ variables: GetAllTemplatesByTypeQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllTemplatesByTypeQuery, GetAllTemplatesByTypeQueryVariables>(GetAllTemplatesByTypeDocument, options);
      }
export function useGetAllTemplatesByTypeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllTemplatesByTypeQuery, GetAllTemplatesByTypeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllTemplatesByTypeQuery, GetAllTemplatesByTypeQueryVariables>(GetAllTemplatesByTypeDocument, options);
        }
// @ts-ignore
export function useGetAllTemplatesByTypeSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetAllTemplatesByTypeQuery, GetAllTemplatesByTypeQueryVariables>): Apollo.UseSuspenseQueryResult<GetAllTemplatesByTypeQuery, GetAllTemplatesByTypeQueryVariables>;
export function useGetAllTemplatesByTypeSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAllTemplatesByTypeQuery, GetAllTemplatesByTypeQueryVariables>): Apollo.UseSuspenseQueryResult<GetAllTemplatesByTypeQuery | undefined, GetAllTemplatesByTypeQueryVariables>;
export function useGetAllTemplatesByTypeSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAllTemplatesByTypeQuery, GetAllTemplatesByTypeQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAllTemplatesByTypeQuery, GetAllTemplatesByTypeQueryVariables>(GetAllTemplatesByTypeDocument, options);
        }
export type GetAllTemplatesByTypeQueryHookResult = ReturnType<typeof useGetAllTemplatesByTypeQuery>;
export type GetAllTemplatesByTypeLazyQueryHookResult = ReturnType<typeof useGetAllTemplatesByTypeLazyQuery>;
export type GetAllTemplatesByTypeSuspenseQueryHookResult = ReturnType<typeof useGetAllTemplatesByTypeSuspenseQuery>;
export type GetAllTemplatesByTypeQueryResult = Apollo.QueryResult<GetAllTemplatesByTypeQuery, GetAllTemplatesByTypeQueryVariables>;
export const GetStructureDeploymentLevelDocument = gql`
    query getStructureDeploymentLevel($structureId: String) {
  structure(structureId: $structureId) {
    deploymentLevel
  }
}
    `;

/**
 * __useGetStructureDeploymentLevelQuery__
 *
 * To run a query within a React component, call `useGetStructureDeploymentLevelQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetStructureDeploymentLevelQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetStructureDeploymentLevelQuery({
 *   variables: {
 *      structureId: // value for 'structureId'
 *   },
 * });
 */
export function useGetStructureDeploymentLevelQuery(baseOptions?: Apollo.QueryHookOptions<GetStructureDeploymentLevelQuery, GetStructureDeploymentLevelQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetStructureDeploymentLevelQuery, GetStructureDeploymentLevelQueryVariables>(GetStructureDeploymentLevelDocument, options);
      }
export function useGetStructureDeploymentLevelLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetStructureDeploymentLevelQuery, GetStructureDeploymentLevelQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetStructureDeploymentLevelQuery, GetStructureDeploymentLevelQueryVariables>(GetStructureDeploymentLevelDocument, options);
        }
// @ts-ignore
export function useGetStructureDeploymentLevelSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetStructureDeploymentLevelQuery, GetStructureDeploymentLevelQueryVariables>): Apollo.UseSuspenseQueryResult<GetStructureDeploymentLevelQuery, GetStructureDeploymentLevelQueryVariables>;
export function useGetStructureDeploymentLevelSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetStructureDeploymentLevelQuery, GetStructureDeploymentLevelQueryVariables>): Apollo.UseSuspenseQueryResult<GetStructureDeploymentLevelQuery | undefined, GetStructureDeploymentLevelQueryVariables>;
export function useGetStructureDeploymentLevelSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetStructureDeploymentLevelQuery, GetStructureDeploymentLevelQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetStructureDeploymentLevelQuery, GetStructureDeploymentLevelQueryVariables>(GetStructureDeploymentLevelDocument, options);
        }
export type GetStructureDeploymentLevelQueryHookResult = ReturnType<typeof useGetStructureDeploymentLevelQuery>;
export type GetStructureDeploymentLevelLazyQueryHookResult = ReturnType<typeof useGetStructureDeploymentLevelLazyQuery>;
export type GetStructureDeploymentLevelSuspenseQueryHookResult = ReturnType<typeof useGetStructureDeploymentLevelSuspenseQuery>;
export type GetStructureDeploymentLevelQueryResult = Apollo.QueryResult<GetStructureDeploymentLevelQuery, GetStructureDeploymentLevelQueryVariables>;
export const GetAssembliesSummaryDocument = gql`
    query getAssembliesSummary($input: AssembliesFilterInput) {
  getAssembliesSummary(input: $input) {
    id
    name
    key
    operation
    displayType
    rowOrder
    displayConfig {
      fieldValue
      color
    }
    data
  }
}
    `;

/**
 * __useGetAssembliesSummaryQuery__
 *
 * To run a query within a React component, call `useGetAssembliesSummaryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAssembliesSummaryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAssembliesSummaryQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetAssembliesSummaryQuery(baseOptions?: Apollo.QueryHookOptions<GetAssembliesSummaryQuery, GetAssembliesSummaryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAssembliesSummaryQuery, GetAssembliesSummaryQueryVariables>(GetAssembliesSummaryDocument, options);
      }
export function useGetAssembliesSummaryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAssembliesSummaryQuery, GetAssembliesSummaryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAssembliesSummaryQuery, GetAssembliesSummaryQueryVariables>(GetAssembliesSummaryDocument, options);
        }
// @ts-ignore
export function useGetAssembliesSummarySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetAssembliesSummaryQuery, GetAssembliesSummaryQueryVariables>): Apollo.UseSuspenseQueryResult<GetAssembliesSummaryQuery, GetAssembliesSummaryQueryVariables>;
export function useGetAssembliesSummarySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAssembliesSummaryQuery, GetAssembliesSummaryQueryVariables>): Apollo.UseSuspenseQueryResult<GetAssembliesSummaryQuery | undefined, GetAssembliesSummaryQueryVariables>;
export function useGetAssembliesSummarySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAssembliesSummaryQuery, GetAssembliesSummaryQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAssembliesSummaryQuery, GetAssembliesSummaryQueryVariables>(GetAssembliesSummaryDocument, options);
        }
export type GetAssembliesSummaryQueryHookResult = ReturnType<typeof useGetAssembliesSummaryQuery>;
export type GetAssembliesSummaryLazyQueryHookResult = ReturnType<typeof useGetAssembliesSummaryLazyQuery>;
export type GetAssembliesSummarySuspenseQueryHookResult = ReturnType<typeof useGetAssembliesSummarySuspenseQuery>;
export type GetAssembliesSummaryQueryResult = Apollo.QueryResult<GetAssembliesSummaryQuery, GetAssembliesSummaryQueryVariables>;
export const GetPaintblockTemplateDocument = gql`
    query getPaintblockTemplate($structureId: ID!, $type: TemplateTypeEnum!) {
  allTemplates(structureId: $structureId, type: $type) {
    id
    name
    fields {
      options
      name
      type
      id
      isHidden
      isReadOnly
      defaultVisible
    }
  }
}
    `;

/**
 * __useGetPaintblockTemplateQuery__
 *
 * To run a query within a React component, call `useGetPaintblockTemplateQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPaintblockTemplateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPaintblockTemplateQuery({
 *   variables: {
 *      structureId: // value for 'structureId'
 *      type: // value for 'type'
 *   },
 * });
 */
export function useGetPaintblockTemplateQuery(baseOptions: Apollo.QueryHookOptions<GetPaintblockTemplateQuery, GetPaintblockTemplateQueryVariables> & ({ variables: GetPaintblockTemplateQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPaintblockTemplateQuery, GetPaintblockTemplateQueryVariables>(GetPaintblockTemplateDocument, options);
      }
export function useGetPaintblockTemplateLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPaintblockTemplateQuery, GetPaintblockTemplateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPaintblockTemplateQuery, GetPaintblockTemplateQueryVariables>(GetPaintblockTemplateDocument, options);
        }
// @ts-ignore
export function useGetPaintblockTemplateSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetPaintblockTemplateQuery, GetPaintblockTemplateQueryVariables>): Apollo.UseSuspenseQueryResult<GetPaintblockTemplateQuery, GetPaintblockTemplateQueryVariables>;
export function useGetPaintblockTemplateSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPaintblockTemplateQuery, GetPaintblockTemplateQueryVariables>): Apollo.UseSuspenseQueryResult<GetPaintblockTemplateQuery | undefined, GetPaintblockTemplateQueryVariables>;
export function useGetPaintblockTemplateSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPaintblockTemplateQuery, GetPaintblockTemplateQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetPaintblockTemplateQuery, GetPaintblockTemplateQueryVariables>(GetPaintblockTemplateDocument, options);
        }
export type GetPaintblockTemplateQueryHookResult = ReturnType<typeof useGetPaintblockTemplateQuery>;
export type GetPaintblockTemplateLazyQueryHookResult = ReturnType<typeof useGetPaintblockTemplateLazyQuery>;
export type GetPaintblockTemplateSuspenseQueryHookResult = ReturnType<typeof useGetPaintblockTemplateSuspenseQuery>;
export type GetPaintblockTemplateQueryResult = Apollo.QueryResult<GetPaintblockTemplateQuery, GetPaintblockTemplateQueryVariables>;
export const DefectLegendsForPaintBlockTableDocument = gql`
    query defectLegendsForPaintBlockTable($structureId: String) {
  structure(structureId: $structureId) {
    defectLegends {
      id
      name
      groupKey
      groupName
      color
    }
  }
}
    `;

/**
 * __useDefectLegendsForPaintBlockTableQuery__
 *
 * To run a query within a React component, call `useDefectLegendsForPaintBlockTableQuery` and pass it any options that fit your needs.
 * When your component renders, `useDefectLegendsForPaintBlockTableQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDefectLegendsForPaintBlockTableQuery({
 *   variables: {
 *      structureId: // value for 'structureId'
 *   },
 * });
 */
export function useDefectLegendsForPaintBlockTableQuery(baseOptions?: Apollo.QueryHookOptions<DefectLegendsForPaintBlockTableQuery, DefectLegendsForPaintBlockTableQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DefectLegendsForPaintBlockTableQuery, DefectLegendsForPaintBlockTableQueryVariables>(DefectLegendsForPaintBlockTableDocument, options);
      }
export function useDefectLegendsForPaintBlockTableLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DefectLegendsForPaintBlockTableQuery, DefectLegendsForPaintBlockTableQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DefectLegendsForPaintBlockTableQuery, DefectLegendsForPaintBlockTableQueryVariables>(DefectLegendsForPaintBlockTableDocument, options);
        }
// @ts-ignore
export function useDefectLegendsForPaintBlockTableSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<DefectLegendsForPaintBlockTableQuery, DefectLegendsForPaintBlockTableQueryVariables>): Apollo.UseSuspenseQueryResult<DefectLegendsForPaintBlockTableQuery, DefectLegendsForPaintBlockTableQueryVariables>;
export function useDefectLegendsForPaintBlockTableSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DefectLegendsForPaintBlockTableQuery, DefectLegendsForPaintBlockTableQueryVariables>): Apollo.UseSuspenseQueryResult<DefectLegendsForPaintBlockTableQuery | undefined, DefectLegendsForPaintBlockTableQueryVariables>;
export function useDefectLegendsForPaintBlockTableSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DefectLegendsForPaintBlockTableQuery, DefectLegendsForPaintBlockTableQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DefectLegendsForPaintBlockTableQuery, DefectLegendsForPaintBlockTableQueryVariables>(DefectLegendsForPaintBlockTableDocument, options);
        }
export type DefectLegendsForPaintBlockTableQueryHookResult = ReturnType<typeof useDefectLegendsForPaintBlockTableQuery>;
export type DefectLegendsForPaintBlockTableLazyQueryHookResult = ReturnType<typeof useDefectLegendsForPaintBlockTableLazyQuery>;
export type DefectLegendsForPaintBlockTableSuspenseQueryHookResult = ReturnType<typeof useDefectLegendsForPaintBlockTableSuspenseQuery>;
export type DefectLegendsForPaintBlockTableQueryResult = Apollo.QueryResult<DefectLegendsForPaintBlockTableQuery, DefectLegendsForPaintBlockTableQueryVariables>;
export const GetAnalysisStructureLocationsDocument = gql`
    query getAnalysisStructureLocations($structureId: ID!) {
  allLocations(structureId: $structureId) {
    id
    name
    resourcePath
    pose {
      yaw
      pitch
      roll
      z
      y
      x
      yawOffset
    }
    baseResourcePath
    scanKey
    layers {
      fileExt
      type
      displayName
    }
    videoResourcePath
    videoTimestamp
    imageSensor {
      width
      height
      cx
      cy
      focalLength
    }
    deck {
      name
    }
  }
}
    `;

/**
 * __useGetAnalysisStructureLocationsQuery__
 *
 * To run a query within a React component, call `useGetAnalysisStructureLocationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAnalysisStructureLocationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAnalysisStructureLocationsQuery({
 *   variables: {
 *      structureId: // value for 'structureId'
 *   },
 * });
 */
export function useGetAnalysisStructureLocationsQuery(baseOptions: Apollo.QueryHookOptions<GetAnalysisStructureLocationsQuery, GetAnalysisStructureLocationsQueryVariables> & ({ variables: GetAnalysisStructureLocationsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAnalysisStructureLocationsQuery, GetAnalysisStructureLocationsQueryVariables>(GetAnalysisStructureLocationsDocument, options);
      }
export function useGetAnalysisStructureLocationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAnalysisStructureLocationsQuery, GetAnalysisStructureLocationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAnalysisStructureLocationsQuery, GetAnalysisStructureLocationsQueryVariables>(GetAnalysisStructureLocationsDocument, options);
        }
// @ts-ignore
export function useGetAnalysisStructureLocationsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetAnalysisStructureLocationsQuery, GetAnalysisStructureLocationsQueryVariables>): Apollo.UseSuspenseQueryResult<GetAnalysisStructureLocationsQuery, GetAnalysisStructureLocationsQueryVariables>;
export function useGetAnalysisStructureLocationsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAnalysisStructureLocationsQuery, GetAnalysisStructureLocationsQueryVariables>): Apollo.UseSuspenseQueryResult<GetAnalysisStructureLocationsQuery | undefined, GetAnalysisStructureLocationsQueryVariables>;
export function useGetAnalysisStructureLocationsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAnalysisStructureLocationsQuery, GetAnalysisStructureLocationsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAnalysisStructureLocationsQuery, GetAnalysisStructureLocationsQueryVariables>(GetAnalysisStructureLocationsDocument, options);
        }
export type GetAnalysisStructureLocationsQueryHookResult = ReturnType<typeof useGetAnalysisStructureLocationsQuery>;
export type GetAnalysisStructureLocationsLazyQueryHookResult = ReturnType<typeof useGetAnalysisStructureLocationsLazyQuery>;
export type GetAnalysisStructureLocationsSuspenseQueryHookResult = ReturnType<typeof useGetAnalysisStructureLocationsSuspenseQuery>;
export type GetAnalysisStructureLocationsQueryResult = Apollo.QueryResult<GetAnalysisStructureLocationsQuery, GetAnalysisStructureLocationsQueryVariables>;
export const GetStructureDataDocument = gql`
    query getStructureData($structureId: String!) {
  structure(structureId: $structureId) {
    hasRiskAssessment
    blisterHeightType
    isActive
    id
    name
    category
    structurePipesConfig {
      imperialSteelPipes
    }
    platform {
      id
    }
    reportConfig {
      poiSummaryChartsConfig
    }
  }
}
    `;

/**
 * __useGetStructureDataQuery__
 *
 * To run a query within a React component, call `useGetStructureDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetStructureDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetStructureDataQuery({
 *   variables: {
 *      structureId: // value for 'structureId'
 *   },
 * });
 */
export function useGetStructureDataQuery(baseOptions: Apollo.QueryHookOptions<GetStructureDataQuery, GetStructureDataQueryVariables> & ({ variables: GetStructureDataQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetStructureDataQuery, GetStructureDataQueryVariables>(GetStructureDataDocument, options);
      }
export function useGetStructureDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetStructureDataQuery, GetStructureDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetStructureDataQuery, GetStructureDataQueryVariables>(GetStructureDataDocument, options);
        }
// @ts-ignore
export function useGetStructureDataSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetStructureDataQuery, GetStructureDataQueryVariables>): Apollo.UseSuspenseQueryResult<GetStructureDataQuery, GetStructureDataQueryVariables>;
export function useGetStructureDataSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetStructureDataQuery, GetStructureDataQueryVariables>): Apollo.UseSuspenseQueryResult<GetStructureDataQuery | undefined, GetStructureDataQueryVariables>;
export function useGetStructureDataSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetStructureDataQuery, GetStructureDataQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetStructureDataQuery, GetStructureDataQueryVariables>(GetStructureDataDocument, options);
        }
export type GetStructureDataQueryHookResult = ReturnType<typeof useGetStructureDataQuery>;
export type GetStructureDataLazyQueryHookResult = ReturnType<typeof useGetStructureDataLazyQuery>;
export type GetStructureDataSuspenseQueryHookResult = ReturnType<typeof useGetStructureDataSuspenseQuery>;
export type GetStructureDataQueryResult = Apollo.QueryResult<GetStructureDataQuery, GetStructureDataQueryVariables>;
export const GetPaintRegionStatusLabelsDocument = gql`
    query getPaintRegionStatusLabels {
  setting(type: PAINT_REGION_STATUS_LABELS) {
    id
    name
    type
    revision
    meta {
      __typename
      ... on StringMeta {
        key
        value
      }
    }
  }
}
    `;

/**
 * __useGetPaintRegionStatusLabelsQuery__
 *
 * To run a query within a React component, call `useGetPaintRegionStatusLabelsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPaintRegionStatusLabelsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPaintRegionStatusLabelsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetPaintRegionStatusLabelsQuery(baseOptions?: Apollo.QueryHookOptions<GetPaintRegionStatusLabelsQuery, GetPaintRegionStatusLabelsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPaintRegionStatusLabelsQuery, GetPaintRegionStatusLabelsQueryVariables>(GetPaintRegionStatusLabelsDocument, options);
      }
export function useGetPaintRegionStatusLabelsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPaintRegionStatusLabelsQuery, GetPaintRegionStatusLabelsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPaintRegionStatusLabelsQuery, GetPaintRegionStatusLabelsQueryVariables>(GetPaintRegionStatusLabelsDocument, options);
        }
// @ts-ignore
export function useGetPaintRegionStatusLabelsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetPaintRegionStatusLabelsQuery, GetPaintRegionStatusLabelsQueryVariables>): Apollo.UseSuspenseQueryResult<GetPaintRegionStatusLabelsQuery, GetPaintRegionStatusLabelsQueryVariables>;
export function useGetPaintRegionStatusLabelsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPaintRegionStatusLabelsQuery, GetPaintRegionStatusLabelsQueryVariables>): Apollo.UseSuspenseQueryResult<GetPaintRegionStatusLabelsQuery | undefined, GetPaintRegionStatusLabelsQueryVariables>;
export function useGetPaintRegionStatusLabelsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPaintRegionStatusLabelsQuery, GetPaintRegionStatusLabelsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetPaintRegionStatusLabelsQuery, GetPaintRegionStatusLabelsQueryVariables>(GetPaintRegionStatusLabelsDocument, options);
        }
export type GetPaintRegionStatusLabelsQueryHookResult = ReturnType<typeof useGetPaintRegionStatusLabelsQuery>;
export type GetPaintRegionStatusLabelsLazyQueryHookResult = ReturnType<typeof useGetPaintRegionStatusLabelsLazyQuery>;
export type GetPaintRegionStatusLabelsSuspenseQueryHookResult = ReturnType<typeof useGetPaintRegionStatusLabelsSuspenseQuery>;
export type GetPaintRegionStatusLabelsQueryResult = Apollo.QueryResult<GetPaintRegionStatusLabelsQuery, GetPaintRegionStatusLabelsQueryVariables>;
export const GetPoiStatusLabelsDocument = gql`
    query getPoiStatusLabels {
  setting(type: POI_STATUS_LABELS) {
    id
    name
    type
    revision
    meta {
      __typename
      ... on StringMeta {
        key
        value
      }
    }
  }
}
    `;

/**
 * __useGetPoiStatusLabelsQuery__
 *
 * To run a query within a React component, call `useGetPoiStatusLabelsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPoiStatusLabelsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPoiStatusLabelsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetPoiStatusLabelsQuery(baseOptions?: Apollo.QueryHookOptions<GetPoiStatusLabelsQuery, GetPoiStatusLabelsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPoiStatusLabelsQuery, GetPoiStatusLabelsQueryVariables>(GetPoiStatusLabelsDocument, options);
      }
export function useGetPoiStatusLabelsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPoiStatusLabelsQuery, GetPoiStatusLabelsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPoiStatusLabelsQuery, GetPoiStatusLabelsQueryVariables>(GetPoiStatusLabelsDocument, options);
        }
// @ts-ignore
export function useGetPoiStatusLabelsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetPoiStatusLabelsQuery, GetPoiStatusLabelsQueryVariables>): Apollo.UseSuspenseQueryResult<GetPoiStatusLabelsQuery, GetPoiStatusLabelsQueryVariables>;
export function useGetPoiStatusLabelsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPoiStatusLabelsQuery, GetPoiStatusLabelsQueryVariables>): Apollo.UseSuspenseQueryResult<GetPoiStatusLabelsQuery | undefined, GetPoiStatusLabelsQueryVariables>;
export function useGetPoiStatusLabelsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPoiStatusLabelsQuery, GetPoiStatusLabelsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetPoiStatusLabelsQuery, GetPoiStatusLabelsQueryVariables>(GetPoiStatusLabelsDocument, options);
        }
export type GetPoiStatusLabelsQueryHookResult = ReturnType<typeof useGetPoiStatusLabelsQuery>;
export type GetPoiStatusLabelsLazyQueryHookResult = ReturnType<typeof useGetPoiStatusLabelsLazyQuery>;
export type GetPoiStatusLabelsSuspenseQueryHookResult = ReturnType<typeof useGetPoiStatusLabelsSuspenseQuery>;
export type GetPoiStatusLabelsQueryResult = Apollo.QueryResult<GetPoiStatusLabelsQuery, GetPoiStatusLabelsQueryVariables>;
export const GetWorkpackStatusLabelsDocument = gql`
    query getWorkpackStatusLabels {
  setting(type: WORKPACK_STATUS_LABELS) {
    id
    name
    type
    revision
    meta {
      __typename
      ... on StringMeta {
        key
        value
      }
    }
  }
}
    `;

/**
 * __useGetWorkpackStatusLabelsQuery__
 *
 * To run a query within a React component, call `useGetWorkpackStatusLabelsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWorkpackStatusLabelsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWorkpackStatusLabelsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetWorkpackStatusLabelsQuery(baseOptions?: Apollo.QueryHookOptions<GetWorkpackStatusLabelsQuery, GetWorkpackStatusLabelsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetWorkpackStatusLabelsQuery, GetWorkpackStatusLabelsQueryVariables>(GetWorkpackStatusLabelsDocument, options);
      }
export function useGetWorkpackStatusLabelsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetWorkpackStatusLabelsQuery, GetWorkpackStatusLabelsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetWorkpackStatusLabelsQuery, GetWorkpackStatusLabelsQueryVariables>(GetWorkpackStatusLabelsDocument, options);
        }
// @ts-ignore
export function useGetWorkpackStatusLabelsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetWorkpackStatusLabelsQuery, GetWorkpackStatusLabelsQueryVariables>): Apollo.UseSuspenseQueryResult<GetWorkpackStatusLabelsQuery, GetWorkpackStatusLabelsQueryVariables>;
export function useGetWorkpackStatusLabelsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetWorkpackStatusLabelsQuery, GetWorkpackStatusLabelsQueryVariables>): Apollo.UseSuspenseQueryResult<GetWorkpackStatusLabelsQuery | undefined, GetWorkpackStatusLabelsQueryVariables>;
export function useGetWorkpackStatusLabelsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetWorkpackStatusLabelsQuery, GetWorkpackStatusLabelsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetWorkpackStatusLabelsQuery, GetWorkpackStatusLabelsQueryVariables>(GetWorkpackStatusLabelsDocument, options);
        }
export type GetWorkpackStatusLabelsQueryHookResult = ReturnType<typeof useGetWorkpackStatusLabelsQuery>;
export type GetWorkpackStatusLabelsLazyQueryHookResult = ReturnType<typeof useGetWorkpackStatusLabelsLazyQuery>;
export type GetWorkpackStatusLabelsSuspenseQueryHookResult = ReturnType<typeof useGetWorkpackStatusLabelsSuspenseQuery>;
export type GetWorkpackStatusLabelsQueryResult = Apollo.QueryResult<GetWorkpackStatusLabelsQuery, GetWorkpackStatusLabelsQueryVariables>;
export const GetAssemblyByTagNameDocument = gql`
    query GetAssemblyByTagName($tagName: String!, $structureId: ID!) {
  assemblyByTagName(tagName: $tagName, structureId: $structureId) {
    id
  }
}
    `;

/**
 * __useGetAssemblyByTagNameQuery__
 *
 * To run a query within a React component, call `useGetAssemblyByTagNameQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAssemblyByTagNameQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAssemblyByTagNameQuery({
 *   variables: {
 *      tagName: // value for 'tagName'
 *      structureId: // value for 'structureId'
 *   },
 * });
 */
export function useGetAssemblyByTagNameQuery(baseOptions: Apollo.QueryHookOptions<GetAssemblyByTagNameQuery, GetAssemblyByTagNameQueryVariables> & ({ variables: GetAssemblyByTagNameQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAssemblyByTagNameQuery, GetAssemblyByTagNameQueryVariables>(GetAssemblyByTagNameDocument, options);
      }
export function useGetAssemblyByTagNameLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAssemblyByTagNameQuery, GetAssemblyByTagNameQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAssemblyByTagNameQuery, GetAssemblyByTagNameQueryVariables>(GetAssemblyByTagNameDocument, options);
        }
// @ts-ignore
export function useGetAssemblyByTagNameSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetAssemblyByTagNameQuery, GetAssemblyByTagNameQueryVariables>): Apollo.UseSuspenseQueryResult<GetAssemblyByTagNameQuery, GetAssemblyByTagNameQueryVariables>;
export function useGetAssemblyByTagNameSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAssemblyByTagNameQuery, GetAssemblyByTagNameQueryVariables>): Apollo.UseSuspenseQueryResult<GetAssemblyByTagNameQuery | undefined, GetAssemblyByTagNameQueryVariables>;
export function useGetAssemblyByTagNameSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAssemblyByTagNameQuery, GetAssemblyByTagNameQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAssemblyByTagNameQuery, GetAssemblyByTagNameQueryVariables>(GetAssemblyByTagNameDocument, options);
        }
export type GetAssemblyByTagNameQueryHookResult = ReturnType<typeof useGetAssemblyByTagNameQuery>;
export type GetAssemblyByTagNameLazyQueryHookResult = ReturnType<typeof useGetAssemblyByTagNameLazyQuery>;
export type GetAssemblyByTagNameSuspenseQueryHookResult = ReturnType<typeof useGetAssemblyByTagNameSuspenseQuery>;
export type GetAssemblyByTagNameQueryResult = Apollo.QueryResult<GetAssemblyByTagNameQuery, GetAssemblyByTagNameQueryVariables>;
export const UpdateWallLossFactorDocument = gql`
    mutation UpdateWallLossFactor($structureId: ID, $wallLossFactor: Int) {
  updateWallLossFactor(structureId: $structureId, wallLossFactor: $wallLossFactor)
}
    `;
export type UpdateWallLossFactorMutationFn = Apollo.MutationFunction<UpdateWallLossFactorMutation, UpdateWallLossFactorMutationVariables>;

/**
 * __useUpdateWallLossFactorMutation__
 *
 * To run a mutation, you first call `useUpdateWallLossFactorMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateWallLossFactorMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateWallLossFactorMutation, { data, loading, error }] = useUpdateWallLossFactorMutation({
 *   variables: {
 *      structureId: // value for 'structureId'
 *      wallLossFactor: // value for 'wallLossFactor'
 *   },
 * });
 */
export function useUpdateWallLossFactorMutation(baseOptions?: Apollo.MutationHookOptions<UpdateWallLossFactorMutation, UpdateWallLossFactorMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateWallLossFactorMutation, UpdateWallLossFactorMutationVariables>(UpdateWallLossFactorDocument, options);
      }
export type UpdateWallLossFactorMutationHookResult = ReturnType<typeof useUpdateWallLossFactorMutation>;
export type UpdateWallLossFactorMutationResult = Apollo.MutationResult<UpdateWallLossFactorMutation>;
export type UpdateWallLossFactorMutationOptions = Apollo.BaseMutationOptions<UpdateWallLossFactorMutation, UpdateWallLossFactorMutationVariables>;
export const AllReportsListDocument = gql`
    query AllReportsList($input: reportsInput) {
  allReports(input: $input) {
    internalType
    createdAt
    createdByUser {
      name
      email
    }
    id
    name
    status
    actionStatus
    dueDate
    startDate
    workpackNumber
    type
    pointOfInterests {
      id
      assembly {
        id
      }
    }
  }
}
    `;

/**
 * __useAllReportsListQuery__
 *
 * To run a query within a React component, call `useAllReportsListQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllReportsListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllReportsListQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAllReportsListQuery(baseOptions?: Apollo.QueryHookOptions<AllReportsListQuery, AllReportsListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AllReportsListQuery, AllReportsListQueryVariables>(AllReportsListDocument, options);
      }
export function useAllReportsListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AllReportsListQuery, AllReportsListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AllReportsListQuery, AllReportsListQueryVariables>(AllReportsListDocument, options);
        }
// @ts-ignore
export function useAllReportsListSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<AllReportsListQuery, AllReportsListQueryVariables>): Apollo.UseSuspenseQueryResult<AllReportsListQuery, AllReportsListQueryVariables>;
export function useAllReportsListSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AllReportsListQuery, AllReportsListQueryVariables>): Apollo.UseSuspenseQueryResult<AllReportsListQuery | undefined, AllReportsListQueryVariables>;
export function useAllReportsListSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AllReportsListQuery, AllReportsListQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AllReportsListQuery, AllReportsListQueryVariables>(AllReportsListDocument, options);
        }
export type AllReportsListQueryHookResult = ReturnType<typeof useAllReportsListQuery>;
export type AllReportsListLazyQueryHookResult = ReturnType<typeof useAllReportsListLazyQuery>;
export type AllReportsListSuspenseQueryHookResult = ReturnType<typeof useAllReportsListSuspenseQuery>;
export type AllReportsListQueryResult = Apollo.QueryResult<AllReportsListQuery, AllReportsListQueryVariables>;
export const UpdateReportDueDateDocument = gql`
    mutation UpdateReportDueDate($input: updateReportInput) {
  updateReport(input: $input) {
    id
    dueDate
    startDate
  }
}
    `;
export type UpdateReportDueDateMutationFn = Apollo.MutationFunction<UpdateReportDueDateMutation, UpdateReportDueDateMutationVariables>;

/**
 * __useUpdateReportDueDateMutation__
 *
 * To run a mutation, you first call `useUpdateReportDueDateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateReportDueDateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateReportDueDateMutation, { data, loading, error }] = useUpdateReportDueDateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateReportDueDateMutation(baseOptions?: Apollo.MutationHookOptions<UpdateReportDueDateMutation, UpdateReportDueDateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateReportDueDateMutation, UpdateReportDueDateMutationVariables>(UpdateReportDueDateDocument, options);
      }
export type UpdateReportDueDateMutationHookResult = ReturnType<typeof useUpdateReportDueDateMutation>;
export type UpdateReportDueDateMutationResult = Apollo.MutationResult<UpdateReportDueDateMutation>;
export type UpdateReportDueDateMutationOptions = Apollo.BaseMutationOptions<UpdateReportDueDateMutation, UpdateReportDueDateMutationVariables>;
export const UpdateReportActionStatusDocument = gql`
    mutation UpdateReportActionStatus($input: updateReportInput) {
  updateReport(input: $input) {
    id
    actionStatus
  }
}
    `;
export type UpdateReportActionStatusMutationFn = Apollo.MutationFunction<UpdateReportActionStatusMutation, UpdateReportActionStatusMutationVariables>;

/**
 * __useUpdateReportActionStatusMutation__
 *
 * To run a mutation, you first call `useUpdateReportActionStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateReportActionStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateReportActionStatusMutation, { data, loading, error }] = useUpdateReportActionStatusMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateReportActionStatusMutation(baseOptions?: Apollo.MutationHookOptions<UpdateReportActionStatusMutation, UpdateReportActionStatusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateReportActionStatusMutation, UpdateReportActionStatusMutationVariables>(UpdateReportActionStatusDocument, options);
      }
export type UpdateReportActionStatusMutationHookResult = ReturnType<typeof useUpdateReportActionStatusMutation>;
export type UpdateReportActionStatusMutationResult = Apollo.MutationResult<UpdateReportActionStatusMutation>;
export type UpdateReportActionStatusMutationOptions = Apollo.BaseMutationOptions<UpdateReportActionStatusMutation, UpdateReportActionStatusMutationVariables>;
export const AllReportImagesDocument = gql`
    query AllReportImages($reportId: ID!) {
  allReportImages(reportId: $reportId) {
    pointOfInterestId
    selectedImages {
      name
      resourcePath
      type
      fileName
      id
      imageType
      uuid
    }
  }
}
    `;

/**
 * __useAllReportImagesQuery__
 *
 * To run a query within a React component, call `useAllReportImagesQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllReportImagesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllReportImagesQuery({
 *   variables: {
 *      reportId: // value for 'reportId'
 *   },
 * });
 */
export function useAllReportImagesQuery(baseOptions: Apollo.QueryHookOptions<AllReportImagesQuery, AllReportImagesQueryVariables> & ({ variables: AllReportImagesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AllReportImagesQuery, AllReportImagesQueryVariables>(AllReportImagesDocument, options);
      }
export function useAllReportImagesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AllReportImagesQuery, AllReportImagesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AllReportImagesQuery, AllReportImagesQueryVariables>(AllReportImagesDocument, options);
        }
// @ts-ignore
export function useAllReportImagesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<AllReportImagesQuery, AllReportImagesQueryVariables>): Apollo.UseSuspenseQueryResult<AllReportImagesQuery, AllReportImagesQueryVariables>;
export function useAllReportImagesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AllReportImagesQuery, AllReportImagesQueryVariables>): Apollo.UseSuspenseQueryResult<AllReportImagesQuery | undefined, AllReportImagesQueryVariables>;
export function useAllReportImagesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AllReportImagesQuery, AllReportImagesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AllReportImagesQuery, AllReportImagesQueryVariables>(AllReportImagesDocument, options);
        }
export type AllReportImagesQueryHookResult = ReturnType<typeof useAllReportImagesQuery>;
export type AllReportImagesLazyQueryHookResult = ReturnType<typeof useAllReportImagesLazyQuery>;
export type AllReportImagesSuspenseQueryHookResult = ReturnType<typeof useAllReportImagesSuspenseQuery>;
export type AllReportImagesQueryResult = Apollo.QueryResult<AllReportImagesQuery, AllReportImagesQueryVariables>;
export const ReportDetailsDocument = gql`
    query ReportDetails($input: reportInput) {
  report(input: $input) {
    createdAt
    createdByUser {
      name
      picture
    }
    id
    name
    status
    templateFieldData
    actionStatus
    dueDate
    startDate
    internalType
    type
    paintRegion {
      name
      id
    }
    pointOfInterests {
      ...pointOfInterests
    }
    selectedPointOfInterestImages {
      pointOfInterestId
      selectedImages {
        name
        resourcePath
        type
        fileName
        id
        imageType
        uuid
        caption
      }
    }
    allPointOfInterestPdfs {
      pointOfInterestId
      selectedPdfs {
        file {
          name
          resourcePath
          fileName
          type
          uploadStatus
          id
        }
        selectedStatus
      }
    }
    files {
      fileName
      id
      name
      resourcePath
      size
      type
      uploadStatus
      imageType
      uuid
    }
    reportOrder {
      assemblyOrder
      poiOrder
    }
    components {
      ...assemblies
    }
    reviewActionPois
  }
}
    ${PointOfInterestsFragmentDoc}
${AssembliesFragmentDoc}`;

/**
 * __useReportDetailsQuery__
 *
 * To run a query within a React component, call `useReportDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useReportDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReportDetailsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useReportDetailsQuery(baseOptions?: Apollo.QueryHookOptions<ReportDetailsQuery, ReportDetailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ReportDetailsQuery, ReportDetailsQueryVariables>(ReportDetailsDocument, options);
      }
export function useReportDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ReportDetailsQuery, ReportDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ReportDetailsQuery, ReportDetailsQueryVariables>(ReportDetailsDocument, options);
        }
// @ts-ignore
export function useReportDetailsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ReportDetailsQuery, ReportDetailsQueryVariables>): Apollo.UseSuspenseQueryResult<ReportDetailsQuery, ReportDetailsQueryVariables>;
export function useReportDetailsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ReportDetailsQuery, ReportDetailsQueryVariables>): Apollo.UseSuspenseQueryResult<ReportDetailsQuery | undefined, ReportDetailsQueryVariables>;
export function useReportDetailsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ReportDetailsQuery, ReportDetailsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ReportDetailsQuery, ReportDetailsQueryVariables>(ReportDetailsDocument, options);
        }
export type ReportDetailsQueryHookResult = ReturnType<typeof useReportDetailsQuery>;
export type ReportDetailsLazyQueryHookResult = ReturnType<typeof useReportDetailsLazyQuery>;
export type ReportDetailsSuspenseQueryHookResult = ReturnType<typeof useReportDetailsSuspenseQuery>;
export type ReportDetailsQueryResult = Apollo.QueryResult<ReportDetailsQuery, ReportDetailsQueryVariables>;
export const ReportPointOfInterestVerifiedDocument = gql`
    subscription ReportPointOfInterestVerified($reportId: ID) {
  reportPointOfInterestVerified(reportId: $reportId) {
    reportId
    pointOfInterest {
      id
      isVerified
      templateFieldData
      templateData {
        templateFieldId
        value
        verifiedValue
        id
      }
    }
  }
}
    `;

/**
 * __useReportPointOfInterestVerifiedSubscription__
 *
 * To run a query within a React component, call `useReportPointOfInterestVerifiedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useReportPointOfInterestVerifiedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReportPointOfInterestVerifiedSubscription({
 *   variables: {
 *      reportId: // value for 'reportId'
 *   },
 * });
 */
export function useReportPointOfInterestVerifiedSubscription(baseOptions?: Apollo.SubscriptionHookOptions<ReportPointOfInterestVerifiedSubscription, ReportPointOfInterestVerifiedSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<ReportPointOfInterestVerifiedSubscription, ReportPointOfInterestVerifiedSubscriptionVariables>(ReportPointOfInterestVerifiedDocument, options);
      }
export type ReportPointOfInterestVerifiedSubscriptionHookResult = ReturnType<typeof useReportPointOfInterestVerifiedSubscription>;
export type ReportPointOfInterestVerifiedSubscriptionResult = Apollo.SubscriptionResult<ReportPointOfInterestVerifiedSubscription>;
export const UpdateReportStatusDocument = gql`
    mutation UpdateReportStatus($input: updateReportStatusInput) {
  updateReportStatus(input: $input) {
    id
    status
  }
}
    `;
export type UpdateReportStatusMutationFn = Apollo.MutationFunction<UpdateReportStatusMutation, UpdateReportStatusMutationVariables>;

/**
 * __useUpdateReportStatusMutation__
 *
 * To run a mutation, you first call `useUpdateReportStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateReportStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateReportStatusMutation, { data, loading, error }] = useUpdateReportStatusMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateReportStatusMutation(baseOptions?: Apollo.MutationHookOptions<UpdateReportStatusMutation, UpdateReportStatusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateReportStatusMutation, UpdateReportStatusMutationVariables>(UpdateReportStatusDocument, options);
      }
export type UpdateReportStatusMutationHookResult = ReturnType<typeof useUpdateReportStatusMutation>;
export type UpdateReportStatusMutationResult = Apollo.MutationResult<UpdateReportStatusMutation>;
export type UpdateReportStatusMutationOptions = Apollo.BaseMutationOptions<UpdateReportStatusMutation, UpdateReportStatusMutationVariables>;
export const UpdateReportOrderDocument = gql`
    mutation UpdateReportOrder($input: updateReportInput) {
  updateReport(input: $input) {
    id
    reportOrder {
      assemblyOrder
      poiOrder
    }
  }
}
    `;
export type UpdateReportOrderMutationFn = Apollo.MutationFunction<UpdateReportOrderMutation, UpdateReportOrderMutationVariables>;

/**
 * __useUpdateReportOrderMutation__
 *
 * To run a mutation, you first call `useUpdateReportOrderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateReportOrderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateReportOrderMutation, { data, loading, error }] = useUpdateReportOrderMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateReportOrderMutation(baseOptions?: Apollo.MutationHookOptions<UpdateReportOrderMutation, UpdateReportOrderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateReportOrderMutation, UpdateReportOrderMutationVariables>(UpdateReportOrderDocument, options);
      }
export type UpdateReportOrderMutationHookResult = ReturnType<typeof useUpdateReportOrderMutation>;
export type UpdateReportOrderMutationResult = Apollo.MutationResult<UpdateReportOrderMutation>;
export type UpdateReportOrderMutationOptions = Apollo.BaseMutationOptions<UpdateReportOrderMutation, UpdateReportOrderMutationVariables>;
export const DeleteReportDocument = gql`
    mutation DeleteReport($reportId: ID!) {
  deleteReport(reportId: $reportId)
}
    `;
export type DeleteReportMutationFn = Apollo.MutationFunction<DeleteReportMutation, DeleteReportMutationVariables>;

/**
 * __useDeleteReportMutation__
 *
 * To run a mutation, you first call `useDeleteReportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteReportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteReportMutation, { data, loading, error }] = useDeleteReportMutation({
 *   variables: {
 *      reportId: // value for 'reportId'
 *   },
 * });
 */
export function useDeleteReportMutation(baseOptions?: Apollo.MutationHookOptions<DeleteReportMutation, DeleteReportMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteReportMutation, DeleteReportMutationVariables>(DeleteReportDocument, options);
      }
export type DeleteReportMutationHookResult = ReturnType<typeof useDeleteReportMutation>;
export type DeleteReportMutationResult = Apollo.MutationResult<DeleteReportMutation>;
export type DeleteReportMutationOptions = Apollo.BaseMutationOptions<DeleteReportMutation, DeleteReportMutationVariables>;
export const UpdatePoiImagesDocument = gql`
    mutation UpdatePOIImages($input: updateReportPointOfInterestImagesInput) {
  updateReportPointOfInterestImages(input: $input) {
    id
    selectedPointOfInterestImages {
      pointOfInterestId
      selectedImages {
        name
        fileName
        type
        resourcePath
        id
        uuid
        imageType
      }
    }
    allPointOfInterestPdfs {
      pointOfInterestId
      selectedPdfs {
        file {
          name
          resourcePath
          fileName
          type
          uploadStatus
          id
        }
        selectedStatus
      }
    }
  }
}
    `;
export type UpdatePoiImagesMutationFn = Apollo.MutationFunction<UpdatePoiImagesMutation, UpdatePoiImagesMutationVariables>;

/**
 * __useUpdatePoiImagesMutation__
 *
 * To run a mutation, you first call `useUpdatePoiImagesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePoiImagesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePoiImagesMutation, { data, loading, error }] = useUpdatePoiImagesMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdatePoiImagesMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePoiImagesMutation, UpdatePoiImagesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePoiImagesMutation, UpdatePoiImagesMutationVariables>(UpdatePoiImagesDocument, options);
      }
export type UpdatePoiImagesMutationHookResult = ReturnType<typeof useUpdatePoiImagesMutation>;
export type UpdatePoiImagesMutationResult = Apollo.MutationResult<UpdatePoiImagesMutation>;
export type UpdatePoiImagesMutationOptions = Apollo.BaseMutationOptions<UpdatePoiImagesMutation, UpdatePoiImagesMutationVariables>;
export const PreSignedUrlToUploadFilesDocument = gql`
    mutation PreSignedUrlToUploadFiles($input: UploadFileInput!) {
  preSignedUrlToUploadFiles(input: $input) {
    url
    id
    resourcePath
    uuid
  }
}
    `;
export type PreSignedUrlToUploadFilesMutationFn = Apollo.MutationFunction<PreSignedUrlToUploadFilesMutation, PreSignedUrlToUploadFilesMutationVariables>;

/**
 * __usePreSignedUrlToUploadFilesMutation__
 *
 * To run a mutation, you first call `usePreSignedUrlToUploadFilesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePreSignedUrlToUploadFilesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [preSignedUrlToUploadFilesMutation, { data, loading, error }] = usePreSignedUrlToUploadFilesMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePreSignedUrlToUploadFilesMutation(baseOptions?: Apollo.MutationHookOptions<PreSignedUrlToUploadFilesMutation, PreSignedUrlToUploadFilesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PreSignedUrlToUploadFilesMutation, PreSignedUrlToUploadFilesMutationVariables>(PreSignedUrlToUploadFilesDocument, options);
      }
export type PreSignedUrlToUploadFilesMutationHookResult = ReturnType<typeof usePreSignedUrlToUploadFilesMutation>;
export type PreSignedUrlToUploadFilesMutationResult = Apollo.MutationResult<PreSignedUrlToUploadFilesMutation>;
export type PreSignedUrlToUploadFilesMutationOptions = Apollo.BaseMutationOptions<PreSignedUrlToUploadFilesMutation, PreSignedUrlToUploadFilesMutationVariables>;
export const UpdateFileStatusForPaintBlockReportManualUploadsDocument = gql`
    mutation UpdateFileStatusForPaintBlockReportManualUploads($input: UpdateFilesStatusInput!) {
  updateFilesStatus(input: $input)
}
    `;
export type UpdateFileStatusForPaintBlockReportManualUploadsMutationFn = Apollo.MutationFunction<UpdateFileStatusForPaintBlockReportManualUploadsMutation, UpdateFileStatusForPaintBlockReportManualUploadsMutationVariables>;

/**
 * __useUpdateFileStatusForPaintBlockReportManualUploadsMutation__
 *
 * To run a mutation, you first call `useUpdateFileStatusForPaintBlockReportManualUploadsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateFileStatusForPaintBlockReportManualUploadsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateFileStatusForPaintBlockReportManualUploadsMutation, { data, loading, error }] = useUpdateFileStatusForPaintBlockReportManualUploadsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateFileStatusForPaintBlockReportManualUploadsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateFileStatusForPaintBlockReportManualUploadsMutation, UpdateFileStatusForPaintBlockReportManualUploadsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateFileStatusForPaintBlockReportManualUploadsMutation, UpdateFileStatusForPaintBlockReportManualUploadsMutationVariables>(UpdateFileStatusForPaintBlockReportManualUploadsDocument, options);
      }
export type UpdateFileStatusForPaintBlockReportManualUploadsMutationHookResult = ReturnType<typeof useUpdateFileStatusForPaintBlockReportManualUploadsMutation>;
export type UpdateFileStatusForPaintBlockReportManualUploadsMutationResult = Apollo.MutationResult<UpdateFileStatusForPaintBlockReportManualUploadsMutation>;
export type UpdateFileStatusForPaintBlockReportManualUploadsMutationOptions = Apollo.BaseMutationOptions<UpdateFileStatusForPaintBlockReportManualUploadsMutation, UpdateFileStatusForPaintBlockReportManualUploadsMutationVariables>;
export const AddAndRemoveFilesDocument = gql`
    mutation AddAndRemoveFiles($input: UpdateFilesInput!) {
  addAndRemoveFiles(input: $input)
}
    `;
export type AddAndRemoveFilesMutationFn = Apollo.MutationFunction<AddAndRemoveFilesMutation, AddAndRemoveFilesMutationVariables>;

/**
 * __useAddAndRemoveFilesMutation__
 *
 * To run a mutation, you first call `useAddAndRemoveFilesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddAndRemoveFilesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addAndRemoveFilesMutation, { data, loading, error }] = useAddAndRemoveFilesMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddAndRemoveFilesMutation(baseOptions?: Apollo.MutationHookOptions<AddAndRemoveFilesMutation, AddAndRemoveFilesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddAndRemoveFilesMutation, AddAndRemoveFilesMutationVariables>(AddAndRemoveFilesDocument, options);
      }
export type AddAndRemoveFilesMutationHookResult = ReturnType<typeof useAddAndRemoveFilesMutation>;
export type AddAndRemoveFilesMutationResult = Apollo.MutationResult<AddAndRemoveFilesMutation>;
export type AddAndRemoveFilesMutationOptions = Apollo.BaseMutationOptions<AddAndRemoveFilesMutation, AddAndRemoveFilesMutationVariables>;
export const UpdateReportDocument = gql`
    mutation UpdateReport($input: updateReportInput) {
  updateReport(input: $input) {
    templateFieldData
    id
    startDate
    selectedPointOfInterestImages {
      pointOfInterestId
      selectedImages {
        name
        fileName
        type
        resourcePath
        id
        uuid
        imageType
      }
    }
    allPointOfInterestPdfs {
      pointOfInterestId
      selectedPdfs {
        file {
          name
          resourcePath
          fileName
          type
          uploadStatus
          id
        }
        selectedStatus
      }
    }
    files {
      id
      name
      type
      resourcePath
      fileName
      uploadStatus
      imageType
      uuid
    }
  }
}
    `;
export type UpdateReportMutationFn = Apollo.MutationFunction<UpdateReportMutation, UpdateReportMutationVariables>;

/**
 * __useUpdateReportMutation__
 *
 * To run a mutation, you first call `useUpdateReportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateReportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateReportMutation, { data, loading, error }] = useUpdateReportMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateReportMutation(baseOptions?: Apollo.MutationHookOptions<UpdateReportMutation, UpdateReportMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateReportMutation, UpdateReportMutationVariables>(UpdateReportDocument, options);
      }
export type UpdateReportMutationHookResult = ReturnType<typeof useUpdateReportMutation>;
export type UpdateReportMutationResult = Apollo.MutationResult<UpdateReportMutation>;
export type UpdateReportMutationOptions = Apollo.BaseMutationOptions<UpdateReportMutation, UpdateReportMutationVariables>;
export const DefectsAreaForAssemblyPaintRegionsDocument = gql`
    query DefectsAreaForAssemblyPaintRegions($input: PaintBlockFiltersInput!) {
  defectsAreaForAssemblyPaintRegions(input: $input) {
    defectsByPaintBlock {
      totalArea {
        type
        value
      }
    }
  }
}
    `;

/**
 * __useDefectsAreaForAssemblyPaintRegionsQuery__
 *
 * To run a query within a React component, call `useDefectsAreaForAssemblyPaintRegionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useDefectsAreaForAssemblyPaintRegionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDefectsAreaForAssemblyPaintRegionsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDefectsAreaForAssemblyPaintRegionsQuery(baseOptions: Apollo.QueryHookOptions<DefectsAreaForAssemblyPaintRegionsQuery, DefectsAreaForAssemblyPaintRegionsQueryVariables> & ({ variables: DefectsAreaForAssemblyPaintRegionsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DefectsAreaForAssemblyPaintRegionsQuery, DefectsAreaForAssemblyPaintRegionsQueryVariables>(DefectsAreaForAssemblyPaintRegionsDocument, options);
      }
export function useDefectsAreaForAssemblyPaintRegionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DefectsAreaForAssemblyPaintRegionsQuery, DefectsAreaForAssemblyPaintRegionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DefectsAreaForAssemblyPaintRegionsQuery, DefectsAreaForAssemblyPaintRegionsQueryVariables>(DefectsAreaForAssemblyPaintRegionsDocument, options);
        }
// @ts-ignore
export function useDefectsAreaForAssemblyPaintRegionsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<DefectsAreaForAssemblyPaintRegionsQuery, DefectsAreaForAssemblyPaintRegionsQueryVariables>): Apollo.UseSuspenseQueryResult<DefectsAreaForAssemblyPaintRegionsQuery, DefectsAreaForAssemblyPaintRegionsQueryVariables>;
export function useDefectsAreaForAssemblyPaintRegionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DefectsAreaForAssemblyPaintRegionsQuery, DefectsAreaForAssemblyPaintRegionsQueryVariables>): Apollo.UseSuspenseQueryResult<DefectsAreaForAssemblyPaintRegionsQuery | undefined, DefectsAreaForAssemblyPaintRegionsQueryVariables>;
export function useDefectsAreaForAssemblyPaintRegionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DefectsAreaForAssemblyPaintRegionsQuery, DefectsAreaForAssemblyPaintRegionsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DefectsAreaForAssemblyPaintRegionsQuery, DefectsAreaForAssemblyPaintRegionsQueryVariables>(DefectsAreaForAssemblyPaintRegionsDocument, options);
        }
export type DefectsAreaForAssemblyPaintRegionsQueryHookResult = ReturnType<typeof useDefectsAreaForAssemblyPaintRegionsQuery>;
export type DefectsAreaForAssemblyPaintRegionsLazyQueryHookResult = ReturnType<typeof useDefectsAreaForAssemblyPaintRegionsLazyQuery>;
export type DefectsAreaForAssemblyPaintRegionsSuspenseQueryHookResult = ReturnType<typeof useDefectsAreaForAssemblyPaintRegionsSuspenseQuery>;
export type DefectsAreaForAssemblyPaintRegionsQueryResult = Apollo.QueryResult<DefectsAreaForAssemblyPaintRegionsQuery, DefectsAreaForAssemblyPaintRegionsQueryVariables>;
export const ValidateReportScopeDocument = gql`
    query ValidateReportScope($input: ValidateReportScopeInput) {
  validateReportScope(input: $input) {
    isValid
  }
}
    `;

/**
 * __useValidateReportScopeQuery__
 *
 * To run a query within a React component, call `useValidateReportScopeQuery` and pass it any options that fit your needs.
 * When your component renders, `useValidateReportScopeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useValidateReportScopeQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useValidateReportScopeQuery(baseOptions?: Apollo.QueryHookOptions<ValidateReportScopeQuery, ValidateReportScopeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ValidateReportScopeQuery, ValidateReportScopeQueryVariables>(ValidateReportScopeDocument, options);
      }
export function useValidateReportScopeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ValidateReportScopeQuery, ValidateReportScopeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ValidateReportScopeQuery, ValidateReportScopeQueryVariables>(ValidateReportScopeDocument, options);
        }
// @ts-ignore
export function useValidateReportScopeSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ValidateReportScopeQuery, ValidateReportScopeQueryVariables>): Apollo.UseSuspenseQueryResult<ValidateReportScopeQuery, ValidateReportScopeQueryVariables>;
export function useValidateReportScopeSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ValidateReportScopeQuery, ValidateReportScopeQueryVariables>): Apollo.UseSuspenseQueryResult<ValidateReportScopeQuery | undefined, ValidateReportScopeQueryVariables>;
export function useValidateReportScopeSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ValidateReportScopeQuery, ValidateReportScopeQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ValidateReportScopeQuery, ValidateReportScopeQueryVariables>(ValidateReportScopeDocument, options);
        }
export type ValidateReportScopeQueryHookResult = ReturnType<typeof useValidateReportScopeQuery>;
export type ValidateReportScopeLazyQueryHookResult = ReturnType<typeof useValidateReportScopeLazyQuery>;
export type ValidateReportScopeSuspenseQueryHookResult = ReturnType<typeof useValidateReportScopeSuspenseQuery>;
export type ValidateReportScopeQueryResult = Apollo.QueryResult<ValidateReportScopeQuery, ValidateReportScopeQueryVariables>;
export const StructureForReportDocument = gql`
    query StructureForReport($structureId: String) {
  structure(structureId: $structureId) {
    reportConfig {
      title
      id
      configurations {
        id
        title
        key
      }
      reviewActionTableConfigs
      paintBlockReportPoiTemplateTypes
    }
  }
}
    `;

/**
 * __useStructureForReportQuery__
 *
 * To run a query within a React component, call `useStructureForReportQuery` and pass it any options that fit your needs.
 * When your component renders, `useStructureForReportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStructureForReportQuery({
 *   variables: {
 *      structureId: // value for 'structureId'
 *   },
 * });
 */
export function useStructureForReportQuery(baseOptions?: Apollo.QueryHookOptions<StructureForReportQuery, StructureForReportQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<StructureForReportQuery, StructureForReportQueryVariables>(StructureForReportDocument, options);
      }
export function useStructureForReportLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<StructureForReportQuery, StructureForReportQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<StructureForReportQuery, StructureForReportQueryVariables>(StructureForReportDocument, options);
        }
// @ts-ignore
export function useStructureForReportSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<StructureForReportQuery, StructureForReportQueryVariables>): Apollo.UseSuspenseQueryResult<StructureForReportQuery, StructureForReportQueryVariables>;
export function useStructureForReportSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<StructureForReportQuery, StructureForReportQueryVariables>): Apollo.UseSuspenseQueryResult<StructureForReportQuery | undefined, StructureForReportQueryVariables>;
export function useStructureForReportSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<StructureForReportQuery, StructureForReportQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<StructureForReportQuery, StructureForReportQueryVariables>(StructureForReportDocument, options);
        }
export type StructureForReportQueryHookResult = ReturnType<typeof useStructureForReportQuery>;
export type StructureForReportLazyQueryHookResult = ReturnType<typeof useStructureForReportLazyQuery>;
export type StructureForReportSuspenseQueryHookResult = ReturnType<typeof useStructureForReportSuspenseQuery>;
export type StructureForReportQueryResult = Apollo.QueryResult<StructureForReportQuery, StructureForReportQueryVariables>;
export const StructureDeploymentLevelDocument = gql`
    query StructureDeploymentLevel($structureId: String) {
  structure(structureId: $structureId) {
    deploymentLevel
  }
}
    `;

/**
 * __useStructureDeploymentLevelQuery__
 *
 * To run a query within a React component, call `useStructureDeploymentLevelQuery` and pass it any options that fit your needs.
 * When your component renders, `useStructureDeploymentLevelQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStructureDeploymentLevelQuery({
 *   variables: {
 *      structureId: // value for 'structureId'
 *   },
 * });
 */
export function useStructureDeploymentLevelQuery(baseOptions?: Apollo.QueryHookOptions<StructureDeploymentLevelQuery, StructureDeploymentLevelQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<StructureDeploymentLevelQuery, StructureDeploymentLevelQueryVariables>(StructureDeploymentLevelDocument, options);
      }
export function useStructureDeploymentLevelLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<StructureDeploymentLevelQuery, StructureDeploymentLevelQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<StructureDeploymentLevelQuery, StructureDeploymentLevelQueryVariables>(StructureDeploymentLevelDocument, options);
        }
// @ts-ignore
export function useStructureDeploymentLevelSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<StructureDeploymentLevelQuery, StructureDeploymentLevelQueryVariables>): Apollo.UseSuspenseQueryResult<StructureDeploymentLevelQuery, StructureDeploymentLevelQueryVariables>;
export function useStructureDeploymentLevelSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<StructureDeploymentLevelQuery, StructureDeploymentLevelQueryVariables>): Apollo.UseSuspenseQueryResult<StructureDeploymentLevelQuery | undefined, StructureDeploymentLevelQueryVariables>;
export function useStructureDeploymentLevelSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<StructureDeploymentLevelQuery, StructureDeploymentLevelQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<StructureDeploymentLevelQuery, StructureDeploymentLevelQueryVariables>(StructureDeploymentLevelDocument, options);
        }
export type StructureDeploymentLevelQueryHookResult = ReturnType<typeof useStructureDeploymentLevelQuery>;
export type StructureDeploymentLevelLazyQueryHookResult = ReturnType<typeof useStructureDeploymentLevelLazyQuery>;
export type StructureDeploymentLevelSuspenseQueryHookResult = ReturnType<typeof useStructureDeploymentLevelSuspenseQuery>;
export type StructureDeploymentLevelQueryResult = Apollo.QueryResult<StructureDeploymentLevelQuery, StructureDeploymentLevelQueryVariables>;
export const GetAssemblyAttachmentsDocument = gql`
    query GetAssemblyAttachments($assemblyId: String) {
  assembly(assemblyId: $assemblyId) {
    generalAttachmentsNote
    files {
      id
      name
      resourcePath
      type
      caption
      fileName
      imagePosition
      uploadStatus
      imageType
      uuid
    }
  }
}
    `;

/**
 * __useGetAssemblyAttachmentsQuery__
 *
 * To run a query within a React component, call `useGetAssemblyAttachmentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAssemblyAttachmentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAssemblyAttachmentsQuery({
 *   variables: {
 *      assemblyId: // value for 'assemblyId'
 *   },
 * });
 */
export function useGetAssemblyAttachmentsQuery(baseOptions?: Apollo.QueryHookOptions<GetAssemblyAttachmentsQuery, GetAssemblyAttachmentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAssemblyAttachmentsQuery, GetAssemblyAttachmentsQueryVariables>(GetAssemblyAttachmentsDocument, options);
      }
export function useGetAssemblyAttachmentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAssemblyAttachmentsQuery, GetAssemblyAttachmentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAssemblyAttachmentsQuery, GetAssemblyAttachmentsQueryVariables>(GetAssemblyAttachmentsDocument, options);
        }
// @ts-ignore
export function useGetAssemblyAttachmentsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetAssemblyAttachmentsQuery, GetAssemblyAttachmentsQueryVariables>): Apollo.UseSuspenseQueryResult<GetAssemblyAttachmentsQuery, GetAssemblyAttachmentsQueryVariables>;
export function useGetAssemblyAttachmentsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAssemblyAttachmentsQuery, GetAssemblyAttachmentsQueryVariables>): Apollo.UseSuspenseQueryResult<GetAssemblyAttachmentsQuery | undefined, GetAssemblyAttachmentsQueryVariables>;
export function useGetAssemblyAttachmentsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAssemblyAttachmentsQuery, GetAssemblyAttachmentsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAssemblyAttachmentsQuery, GetAssemblyAttachmentsQueryVariables>(GetAssemblyAttachmentsDocument, options);
        }
export type GetAssemblyAttachmentsQueryHookResult = ReturnType<typeof useGetAssemblyAttachmentsQuery>;
export type GetAssemblyAttachmentsLazyQueryHookResult = ReturnType<typeof useGetAssemblyAttachmentsLazyQuery>;
export type GetAssemblyAttachmentsSuspenseQueryHookResult = ReturnType<typeof useGetAssemblyAttachmentsSuspenseQuery>;
export type GetAssemblyAttachmentsQueryResult = Apollo.QueryResult<GetAssemblyAttachmentsQuery, GetAssemblyAttachmentsQueryVariables>;
export const ReOrderAssemblyImagesDocument = gql`
    mutation ReOrderAssemblyImages($input: ReOrderImagesInput) {
  reOrderAssemblyImages(input: $input) {
    fileName
    caption
    imagePosition
  }
}
    `;
export type ReOrderAssemblyImagesMutationFn = Apollo.MutationFunction<ReOrderAssemblyImagesMutation, ReOrderAssemblyImagesMutationVariables>;

/**
 * __useReOrderAssemblyImagesMutation__
 *
 * To run a mutation, you first call `useReOrderAssemblyImagesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReOrderAssemblyImagesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [reOrderAssemblyImagesMutation, { data, loading, error }] = useReOrderAssemblyImagesMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useReOrderAssemblyImagesMutation(baseOptions?: Apollo.MutationHookOptions<ReOrderAssemblyImagesMutation, ReOrderAssemblyImagesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ReOrderAssemblyImagesMutation, ReOrderAssemblyImagesMutationVariables>(ReOrderAssemblyImagesDocument, options);
      }
export type ReOrderAssemblyImagesMutationHookResult = ReturnType<typeof useReOrderAssemblyImagesMutation>;
export type ReOrderAssemblyImagesMutationResult = Apollo.MutationResult<ReOrderAssemblyImagesMutation>;
export type ReOrderAssemblyImagesMutationOptions = Apollo.BaseMutationOptions<ReOrderAssemblyImagesMutation, ReOrderAssemblyImagesMutationVariables>;
export const UpdatePointOfInterestImageTypeDocument = gql`
    mutation UpdatePointOfInterestImageType($input: UpdatePointOfInterestImageTypeInput!) {
  updatePointOfInterestImageType(input: $input) {
    files {
      id
      imageType
    }
  }
}
    `;
export type UpdatePointOfInterestImageTypeMutationFn = Apollo.MutationFunction<UpdatePointOfInterestImageTypeMutation, UpdatePointOfInterestImageTypeMutationVariables>;

/**
 * __useUpdatePointOfInterestImageTypeMutation__
 *
 * To run a mutation, you first call `useUpdatePointOfInterestImageTypeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePointOfInterestImageTypeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePointOfInterestImageTypeMutation, { data, loading, error }] = useUpdatePointOfInterestImageTypeMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdatePointOfInterestImageTypeMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePointOfInterestImageTypeMutation, UpdatePointOfInterestImageTypeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePointOfInterestImageTypeMutation, UpdatePointOfInterestImageTypeMutationVariables>(UpdatePointOfInterestImageTypeDocument, options);
      }
export type UpdatePointOfInterestImageTypeMutationHookResult = ReturnType<typeof useUpdatePointOfInterestImageTypeMutation>;
export type UpdatePointOfInterestImageTypeMutationResult = Apollo.MutationResult<UpdatePointOfInterestImageTypeMutation>;
export type UpdatePointOfInterestImageTypeMutationOptions = Apollo.BaseMutationOptions<UpdatePointOfInterestImageTypeMutation, UpdatePointOfInterestImageTypeMutationVariables>;
export const GetAssemblyForEvaluationDocument = gql`
    query GetAssemblyForEvaluation($assemblyId: String) {
  assembly(assemblyId: $assemblyId) {
    templateFieldData
    area
  }
}
    `;

/**
 * __useGetAssemblyForEvaluationQuery__
 *
 * To run a query within a React component, call `useGetAssemblyForEvaluationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAssemblyForEvaluationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAssemblyForEvaluationQuery({
 *   variables: {
 *      assemblyId: // value for 'assemblyId'
 *   },
 * });
 */
export function useGetAssemblyForEvaluationQuery(baseOptions?: Apollo.QueryHookOptions<GetAssemblyForEvaluationQuery, GetAssemblyForEvaluationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAssemblyForEvaluationQuery, GetAssemblyForEvaluationQueryVariables>(GetAssemblyForEvaluationDocument, options);
      }
export function useGetAssemblyForEvaluationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAssemblyForEvaluationQuery, GetAssemblyForEvaluationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAssemblyForEvaluationQuery, GetAssemblyForEvaluationQueryVariables>(GetAssemblyForEvaluationDocument, options);
        }
// @ts-ignore
export function useGetAssemblyForEvaluationSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetAssemblyForEvaluationQuery, GetAssemblyForEvaluationQueryVariables>): Apollo.UseSuspenseQueryResult<GetAssemblyForEvaluationQuery, GetAssemblyForEvaluationQueryVariables>;
export function useGetAssemblyForEvaluationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAssemblyForEvaluationQuery, GetAssemblyForEvaluationQueryVariables>): Apollo.UseSuspenseQueryResult<GetAssemblyForEvaluationQuery | undefined, GetAssemblyForEvaluationQueryVariables>;
export function useGetAssemblyForEvaluationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAssemblyForEvaluationQuery, GetAssemblyForEvaluationQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAssemblyForEvaluationQuery, GetAssemblyForEvaluationQueryVariables>(GetAssemblyForEvaluationDocument, options);
        }
export type GetAssemblyForEvaluationQueryHookResult = ReturnType<typeof useGetAssemblyForEvaluationQuery>;
export type GetAssemblyForEvaluationLazyQueryHookResult = ReturnType<typeof useGetAssemblyForEvaluationLazyQuery>;
export type GetAssemblyForEvaluationSuspenseQueryHookResult = ReturnType<typeof useGetAssemblyForEvaluationSuspenseQuery>;
export type GetAssemblyForEvaluationQueryResult = Apollo.QueryResult<GetAssemblyForEvaluationQuery, GetAssemblyForEvaluationQueryVariables>;
export const GetAssembliesForEvaluationDocument = gql`
    query GetAssembliesForEvaluation($input: AssembliesFilterInput, $pageInfo: PageInfo) {
  getAssembliesByTemplateFieldsFilters(input: $input, pageInfo: $pageInfo) {
    id
    templateFieldData
    area
  }
}
    `;

/**
 * __useGetAssembliesForEvaluationQuery__
 *
 * To run a query within a React component, call `useGetAssembliesForEvaluationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAssembliesForEvaluationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAssembliesForEvaluationQuery({
 *   variables: {
 *      input: // value for 'input'
 *      pageInfo: // value for 'pageInfo'
 *   },
 * });
 */
export function useGetAssembliesForEvaluationQuery(baseOptions?: Apollo.QueryHookOptions<GetAssembliesForEvaluationQuery, GetAssembliesForEvaluationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAssembliesForEvaluationQuery, GetAssembliesForEvaluationQueryVariables>(GetAssembliesForEvaluationDocument, options);
      }
export function useGetAssembliesForEvaluationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAssembliesForEvaluationQuery, GetAssembliesForEvaluationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAssembliesForEvaluationQuery, GetAssembliesForEvaluationQueryVariables>(GetAssembliesForEvaluationDocument, options);
        }
// @ts-ignore
export function useGetAssembliesForEvaluationSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetAssembliesForEvaluationQuery, GetAssembliesForEvaluationQueryVariables>): Apollo.UseSuspenseQueryResult<GetAssembliesForEvaluationQuery, GetAssembliesForEvaluationQueryVariables>;
export function useGetAssembliesForEvaluationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAssembliesForEvaluationQuery, GetAssembliesForEvaluationQueryVariables>): Apollo.UseSuspenseQueryResult<GetAssembliesForEvaluationQuery | undefined, GetAssembliesForEvaluationQueryVariables>;
export function useGetAssembliesForEvaluationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAssembliesForEvaluationQuery, GetAssembliesForEvaluationQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAssembliesForEvaluationQuery, GetAssembliesForEvaluationQueryVariables>(GetAssembliesForEvaluationDocument, options);
        }
export type GetAssembliesForEvaluationQueryHookResult = ReturnType<typeof useGetAssembliesForEvaluationQuery>;
export type GetAssembliesForEvaluationLazyQueryHookResult = ReturnType<typeof useGetAssembliesForEvaluationLazyQuery>;
export type GetAssembliesForEvaluationSuspenseQueryHookResult = ReturnType<typeof useGetAssembliesForEvaluationSuspenseQuery>;
export type GetAssembliesForEvaluationQueryResult = Apollo.QueryResult<GetAssembliesForEvaluationQuery, GetAssembliesForEvaluationQueryVariables>;
export const GetAllAssembliesForEvaluationDocument = gql`
    query GetAllAssembliesForEvaluation($input: AssembliesFilterInput, $pageInfo: PageInfo) {
  getAssembliesByTemplateFieldsFilters(input: $input, pageInfo: $pageInfo) {
    id
    tagName
    templateFieldData
  }
}
    `;

/**
 * __useGetAllAssembliesForEvaluationQuery__
 *
 * To run a query within a React component, call `useGetAllAssembliesForEvaluationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllAssembliesForEvaluationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllAssembliesForEvaluationQuery({
 *   variables: {
 *      input: // value for 'input'
 *      pageInfo: // value for 'pageInfo'
 *   },
 * });
 */
export function useGetAllAssembliesForEvaluationQuery(baseOptions?: Apollo.QueryHookOptions<GetAllAssembliesForEvaluationQuery, GetAllAssembliesForEvaluationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllAssembliesForEvaluationQuery, GetAllAssembliesForEvaluationQueryVariables>(GetAllAssembliesForEvaluationDocument, options);
      }
export function useGetAllAssembliesForEvaluationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllAssembliesForEvaluationQuery, GetAllAssembliesForEvaluationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllAssembliesForEvaluationQuery, GetAllAssembliesForEvaluationQueryVariables>(GetAllAssembliesForEvaluationDocument, options);
        }
// @ts-ignore
export function useGetAllAssembliesForEvaluationSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetAllAssembliesForEvaluationQuery, GetAllAssembliesForEvaluationQueryVariables>): Apollo.UseSuspenseQueryResult<GetAllAssembliesForEvaluationQuery, GetAllAssembliesForEvaluationQueryVariables>;
export function useGetAllAssembliesForEvaluationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAllAssembliesForEvaluationQuery, GetAllAssembliesForEvaluationQueryVariables>): Apollo.UseSuspenseQueryResult<GetAllAssembliesForEvaluationQuery | undefined, GetAllAssembliesForEvaluationQueryVariables>;
export function useGetAllAssembliesForEvaluationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAllAssembliesForEvaluationQuery, GetAllAssembliesForEvaluationQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAllAssembliesForEvaluationQuery, GetAllAssembliesForEvaluationQueryVariables>(GetAllAssembliesForEvaluationDocument, options);
        }
export type GetAllAssembliesForEvaluationQueryHookResult = ReturnType<typeof useGetAllAssembliesForEvaluationQuery>;
export type GetAllAssembliesForEvaluationLazyQueryHookResult = ReturnType<typeof useGetAllAssembliesForEvaluationLazyQuery>;
export type GetAllAssembliesForEvaluationSuspenseQueryHookResult = ReturnType<typeof useGetAllAssembliesForEvaluationSuspenseQuery>;
export type GetAllAssembliesForEvaluationQueryResult = Apollo.QueryResult<GetAllAssembliesForEvaluationQuery, GetAllAssembliesForEvaluationQueryVariables>;
export const StructureDefectLegendsDocument = gql`
    query StructureDefectLegends($structureId: String) {
  structure(structureId: $structureId) {
    defectLegends {
      id
      groupName
      groupKey
      name
      color
      octreeKey
      octreeValue
      legendText
    }
  }
}
    `;

/**
 * __useStructureDefectLegendsQuery__
 *
 * To run a query within a React component, call `useStructureDefectLegendsQuery` and pass it any options that fit your needs.
 * When your component renders, `useStructureDefectLegendsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStructureDefectLegendsQuery({
 *   variables: {
 *      structureId: // value for 'structureId'
 *   },
 * });
 */
export function useStructureDefectLegendsQuery(baseOptions?: Apollo.QueryHookOptions<StructureDefectLegendsQuery, StructureDefectLegendsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<StructureDefectLegendsQuery, StructureDefectLegendsQueryVariables>(StructureDefectLegendsDocument, options);
      }
export function useStructureDefectLegendsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<StructureDefectLegendsQuery, StructureDefectLegendsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<StructureDefectLegendsQuery, StructureDefectLegendsQueryVariables>(StructureDefectLegendsDocument, options);
        }
// @ts-ignore
export function useStructureDefectLegendsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<StructureDefectLegendsQuery, StructureDefectLegendsQueryVariables>): Apollo.UseSuspenseQueryResult<StructureDefectLegendsQuery, StructureDefectLegendsQueryVariables>;
export function useStructureDefectLegendsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<StructureDefectLegendsQuery, StructureDefectLegendsQueryVariables>): Apollo.UseSuspenseQueryResult<StructureDefectLegendsQuery | undefined, StructureDefectLegendsQueryVariables>;
export function useStructureDefectLegendsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<StructureDefectLegendsQuery, StructureDefectLegendsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<StructureDefectLegendsQuery, StructureDefectLegendsQueryVariables>(StructureDefectLegendsDocument, options);
        }
export type StructureDefectLegendsQueryHookResult = ReturnType<typeof useStructureDefectLegendsQuery>;
export type StructureDefectLegendsLazyQueryHookResult = ReturnType<typeof useStructureDefectLegendsLazyQuery>;
export type StructureDefectLegendsSuspenseQueryHookResult = ReturnType<typeof useStructureDefectLegendsSuspenseQuery>;
export type StructureDefectLegendsQueryResult = Apollo.QueryResult<StructureDefectLegendsQuery, StructureDefectLegendsQueryVariables>;
export const UpdateReportDataDocument = gql`
    mutation UpdateReportData($input: UpdateSingleTemplateFieldDataInput) {
  updateSingleTemplateFieldData(input: $input) {
    templateFieldData
  }
}
    `;
export type UpdateReportDataMutationFn = Apollo.MutationFunction<UpdateReportDataMutation, UpdateReportDataMutationVariables>;

/**
 * __useUpdateReportDataMutation__
 *
 * To run a mutation, you first call `useUpdateReportDataMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateReportDataMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateReportDataMutation, { data, loading, error }] = useUpdateReportDataMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateReportDataMutation(baseOptions?: Apollo.MutationHookOptions<UpdateReportDataMutation, UpdateReportDataMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateReportDataMutation, UpdateReportDataMutationVariables>(UpdateReportDataDocument, options);
      }
export type UpdateReportDataMutationHookResult = ReturnType<typeof useUpdateReportDataMutation>;
export type UpdateReportDataMutationResult = Apollo.MutationResult<UpdateReportDataMutation>;
export type UpdateReportDataMutationOptions = Apollo.BaseMutationOptions<UpdateReportDataMutation, UpdateReportDataMutationVariables>;
export const PointOfInterestActivityDocument = gql`
    subscription PointOfInterestActivity($structureId: ID!, $assemblyId: ID) {
  pointOfInterestActivity(structureId: $structureId, assemblyId: $assemblyId) {
    name
  }
}
    `;

/**
 * __usePointOfInterestActivitySubscription__
 *
 * To run a query within a React component, call `usePointOfInterestActivitySubscription` and pass it any options that fit your needs.
 * When your component renders, `usePointOfInterestActivitySubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePointOfInterestActivitySubscription({
 *   variables: {
 *      structureId: // value for 'structureId'
 *      assemblyId: // value for 'assemblyId'
 *   },
 * });
 */
export function usePointOfInterestActivitySubscription(baseOptions: Apollo.SubscriptionHookOptions<PointOfInterestActivitySubscription, PointOfInterestActivitySubscriptionVariables> & ({ variables: PointOfInterestActivitySubscriptionVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<PointOfInterestActivitySubscription, PointOfInterestActivitySubscriptionVariables>(PointOfInterestActivityDocument, options);
      }
export type PointOfInterestActivitySubscriptionHookResult = ReturnType<typeof usePointOfInterestActivitySubscription>;
export type PointOfInterestActivitySubscriptionResult = Apollo.SubscriptionResult<PointOfInterestActivitySubscription>;
export const BulkUpdateReviewActionDocument = gql`
    mutation BulkUpdateReviewAction($input: BulkUpdateReviewActionInput) {
  bulkUpdateReviewAction(input: $input) {
    count
  }
}
    `;
export type BulkUpdateReviewActionMutationFn = Apollo.MutationFunction<BulkUpdateReviewActionMutation, BulkUpdateReviewActionMutationVariables>;

/**
 * __useBulkUpdateReviewActionMutation__
 *
 * To run a mutation, you first call `useBulkUpdateReviewActionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBulkUpdateReviewActionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [bulkUpdateReviewActionMutation, { data, loading, error }] = useBulkUpdateReviewActionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useBulkUpdateReviewActionMutation(baseOptions?: Apollo.MutationHookOptions<BulkUpdateReviewActionMutation, BulkUpdateReviewActionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<BulkUpdateReviewActionMutation, BulkUpdateReviewActionMutationVariables>(BulkUpdateReviewActionDocument, options);
      }
export type BulkUpdateReviewActionMutationHookResult = ReturnType<typeof useBulkUpdateReviewActionMutation>;
export type BulkUpdateReviewActionMutationResult = Apollo.MutationResult<BulkUpdateReviewActionMutation>;
export type BulkUpdateReviewActionMutationOptions = Apollo.BaseMutationOptions<BulkUpdateReviewActionMutation, BulkUpdateReviewActionMutationVariables>;
export const AllCommentsForRiskAssessmentDocument = gql`
    query AllCommentsForRiskAssessment($input: AllCommentsInput) {
  allComments(input: $input) {
    id
    text
    structureId
    text
    title
    updatedAt
    collectionName
    createdByUser {
      picture
      name
    }
    key
  }
}
    `;

/**
 * __useAllCommentsForRiskAssessmentQuery__
 *
 * To run a query within a React component, call `useAllCommentsForRiskAssessmentQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllCommentsForRiskAssessmentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllCommentsForRiskAssessmentQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAllCommentsForRiskAssessmentQuery(baseOptions?: Apollo.QueryHookOptions<AllCommentsForRiskAssessmentQuery, AllCommentsForRiskAssessmentQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AllCommentsForRiskAssessmentQuery, AllCommentsForRiskAssessmentQueryVariables>(AllCommentsForRiskAssessmentDocument, options);
      }
export function useAllCommentsForRiskAssessmentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AllCommentsForRiskAssessmentQuery, AllCommentsForRiskAssessmentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AllCommentsForRiskAssessmentQuery, AllCommentsForRiskAssessmentQueryVariables>(AllCommentsForRiskAssessmentDocument, options);
        }
// @ts-ignore
export function useAllCommentsForRiskAssessmentSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<AllCommentsForRiskAssessmentQuery, AllCommentsForRiskAssessmentQueryVariables>): Apollo.UseSuspenseQueryResult<AllCommentsForRiskAssessmentQuery, AllCommentsForRiskAssessmentQueryVariables>;
export function useAllCommentsForRiskAssessmentSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AllCommentsForRiskAssessmentQuery, AllCommentsForRiskAssessmentQueryVariables>): Apollo.UseSuspenseQueryResult<AllCommentsForRiskAssessmentQuery | undefined, AllCommentsForRiskAssessmentQueryVariables>;
export function useAllCommentsForRiskAssessmentSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AllCommentsForRiskAssessmentQuery, AllCommentsForRiskAssessmentQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AllCommentsForRiskAssessmentQuery, AllCommentsForRiskAssessmentQueryVariables>(AllCommentsForRiskAssessmentDocument, options);
        }
export type AllCommentsForRiskAssessmentQueryHookResult = ReturnType<typeof useAllCommentsForRiskAssessmentQuery>;
export type AllCommentsForRiskAssessmentLazyQueryHookResult = ReturnType<typeof useAllCommentsForRiskAssessmentLazyQuery>;
export type AllCommentsForRiskAssessmentSuspenseQueryHookResult = ReturnType<typeof useAllCommentsForRiskAssessmentSuspenseQuery>;
export type AllCommentsForRiskAssessmentQueryResult = Apollo.QueryResult<AllCommentsForRiskAssessmentQuery, AllCommentsForRiskAssessmentQueryVariables>;
export const UpdateCommentDocument = gql`
    mutation UpdateComment($input: UpdateCommentInput!) {
  updateComment(input: $input) {
    id
    text
    title
    updatedAt
  }
}
    `;
export type UpdateCommentMutationFn = Apollo.MutationFunction<UpdateCommentMutation, UpdateCommentMutationVariables>;

/**
 * __useUpdateCommentMutation__
 *
 * To run a mutation, you first call `useUpdateCommentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCommentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCommentMutation, { data, loading, error }] = useUpdateCommentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateCommentMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCommentMutation, UpdateCommentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCommentMutation, UpdateCommentMutationVariables>(UpdateCommentDocument, options);
      }
export type UpdateCommentMutationHookResult = ReturnType<typeof useUpdateCommentMutation>;
export type UpdateCommentMutationResult = Apollo.MutationResult<UpdateCommentMutation>;
export type UpdateCommentMutationOptions = Apollo.BaseMutationOptions<UpdateCommentMutation, UpdateCommentMutationVariables>;
export const UpdateRiskAssessmentTemplateFieldDataForAssembliesDocument = gql`
    mutation updateRiskAssessmentTemplateFieldDataForAssemblies($input: UpdateRiskAssessmentTemplateFieldDataForAssembliesInput!) {
  updateRiskAssessmentTemplateFieldDataForAssemblies(input: $input) {
    id
    tagName
    templateFieldData
  }
}
    `;
export type UpdateRiskAssessmentTemplateFieldDataForAssembliesMutationFn = Apollo.MutationFunction<UpdateRiskAssessmentTemplateFieldDataForAssembliesMutation, UpdateRiskAssessmentTemplateFieldDataForAssembliesMutationVariables>;

/**
 * __useUpdateRiskAssessmentTemplateFieldDataForAssembliesMutation__
 *
 * To run a mutation, you first call `useUpdateRiskAssessmentTemplateFieldDataForAssembliesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateRiskAssessmentTemplateFieldDataForAssembliesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateRiskAssessmentTemplateFieldDataForAssembliesMutation, { data, loading, error }] = useUpdateRiskAssessmentTemplateFieldDataForAssembliesMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateRiskAssessmentTemplateFieldDataForAssembliesMutation(baseOptions?: Apollo.MutationHookOptions<UpdateRiskAssessmentTemplateFieldDataForAssembliesMutation, UpdateRiskAssessmentTemplateFieldDataForAssembliesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateRiskAssessmentTemplateFieldDataForAssembliesMutation, UpdateRiskAssessmentTemplateFieldDataForAssembliesMutationVariables>(UpdateRiskAssessmentTemplateFieldDataForAssembliesDocument, options);
      }
export type UpdateRiskAssessmentTemplateFieldDataForAssembliesMutationHookResult = ReturnType<typeof useUpdateRiskAssessmentTemplateFieldDataForAssembliesMutation>;
export type UpdateRiskAssessmentTemplateFieldDataForAssembliesMutationResult = Apollo.MutationResult<UpdateRiskAssessmentTemplateFieldDataForAssembliesMutation>;
export type UpdateRiskAssessmentTemplateFieldDataForAssembliesMutationOptions = Apollo.BaseMutationOptions<UpdateRiskAssessmentTemplateFieldDataForAssembliesMutation, UpdateRiskAssessmentTemplateFieldDataForAssembliesMutationVariables>;
export const UpdateAssembliesProbabilityOfFailureRiskFactorsDocument = gql`
    mutation UpdateAssembliesProbabilityOfFailureRiskFactors($input: UpdateTemplateFieldDataPofInput!) {
  updateAssembliesProbabilityOfFailureRiskFactors(input: $input) {
    id
    tagName
    templateFieldData
  }
}
    `;
export type UpdateAssembliesProbabilityOfFailureRiskFactorsMutationFn = Apollo.MutationFunction<UpdateAssembliesProbabilityOfFailureRiskFactorsMutation, UpdateAssembliesProbabilityOfFailureRiskFactorsMutationVariables>;

/**
 * __useUpdateAssembliesProbabilityOfFailureRiskFactorsMutation__
 *
 * To run a mutation, you first call `useUpdateAssembliesProbabilityOfFailureRiskFactorsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAssembliesProbabilityOfFailureRiskFactorsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAssembliesProbabilityOfFailureRiskFactorsMutation, { data, loading, error }] = useUpdateAssembliesProbabilityOfFailureRiskFactorsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateAssembliesProbabilityOfFailureRiskFactorsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateAssembliesProbabilityOfFailureRiskFactorsMutation, UpdateAssembliesProbabilityOfFailureRiskFactorsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateAssembliesProbabilityOfFailureRiskFactorsMutation, UpdateAssembliesProbabilityOfFailureRiskFactorsMutationVariables>(UpdateAssembliesProbabilityOfFailureRiskFactorsDocument, options);
      }
export type UpdateAssembliesProbabilityOfFailureRiskFactorsMutationHookResult = ReturnType<typeof useUpdateAssembliesProbabilityOfFailureRiskFactorsMutation>;
export type UpdateAssembliesProbabilityOfFailureRiskFactorsMutationResult = Apollo.MutationResult<UpdateAssembliesProbabilityOfFailureRiskFactorsMutation>;
export type UpdateAssembliesProbabilityOfFailureRiskFactorsMutationOptions = Apollo.BaseMutationOptions<UpdateAssembliesProbabilityOfFailureRiskFactorsMutation, UpdateAssembliesProbabilityOfFailureRiskFactorsMutationVariables>;
export const GetAssembliesRiskAssessmentSummaryDocument = gql`
    query GetAssembliesRiskAssessmentSummary($input: RiskAssessmentSummaryInput) {
  getAssembliesRiskAssessmentSummary(input: $input) {
    key
    values {
      count
      value
    }
  }
}
    `;

/**
 * __useGetAssembliesRiskAssessmentSummaryQuery__
 *
 * To run a query within a React component, call `useGetAssembliesRiskAssessmentSummaryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAssembliesRiskAssessmentSummaryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAssembliesRiskAssessmentSummaryQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetAssembliesRiskAssessmentSummaryQuery(baseOptions?: Apollo.QueryHookOptions<GetAssembliesRiskAssessmentSummaryQuery, GetAssembliesRiskAssessmentSummaryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAssembliesRiskAssessmentSummaryQuery, GetAssembliesRiskAssessmentSummaryQueryVariables>(GetAssembliesRiskAssessmentSummaryDocument, options);
      }
export function useGetAssembliesRiskAssessmentSummaryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAssembliesRiskAssessmentSummaryQuery, GetAssembliesRiskAssessmentSummaryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAssembliesRiskAssessmentSummaryQuery, GetAssembliesRiskAssessmentSummaryQueryVariables>(GetAssembliesRiskAssessmentSummaryDocument, options);
        }
// @ts-ignore
export function useGetAssembliesRiskAssessmentSummarySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetAssembliesRiskAssessmentSummaryQuery, GetAssembliesRiskAssessmentSummaryQueryVariables>): Apollo.UseSuspenseQueryResult<GetAssembliesRiskAssessmentSummaryQuery, GetAssembliesRiskAssessmentSummaryQueryVariables>;
export function useGetAssembliesRiskAssessmentSummarySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAssembliesRiskAssessmentSummaryQuery, GetAssembliesRiskAssessmentSummaryQueryVariables>): Apollo.UseSuspenseQueryResult<GetAssembliesRiskAssessmentSummaryQuery | undefined, GetAssembliesRiskAssessmentSummaryQueryVariables>;
export function useGetAssembliesRiskAssessmentSummarySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAssembliesRiskAssessmentSummaryQuery, GetAssembliesRiskAssessmentSummaryQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAssembliesRiskAssessmentSummaryQuery, GetAssembliesRiskAssessmentSummaryQueryVariables>(GetAssembliesRiskAssessmentSummaryDocument, options);
        }
export type GetAssembliesRiskAssessmentSummaryQueryHookResult = ReturnType<typeof useGetAssembliesRiskAssessmentSummaryQuery>;
export type GetAssembliesRiskAssessmentSummaryLazyQueryHookResult = ReturnType<typeof useGetAssembliesRiskAssessmentSummaryLazyQuery>;
export type GetAssembliesRiskAssessmentSummarySuspenseQueryHookResult = ReturnType<typeof useGetAssembliesRiskAssessmentSummarySuspenseQuery>;
export type GetAssembliesRiskAssessmentSummaryQueryResult = Apollo.QueryResult<GetAssembliesRiskAssessmentSummaryQuery, GetAssembliesRiskAssessmentSummaryQueryVariables>;
export const StructureForRiskAssessmentDocument = gql`
    query StructureForRiskAssessment($structureId: String) {
  structure(structureId: $structureId) {
    id
    name
    type
    hasRiskAssessment
    template {
      id
    }
    templateData {
      id
      value
      templateFieldId
    }
    esSheetStatus
    isLegacyEquipmentStrategy
  }
}
    `;

/**
 * __useStructureForRiskAssessmentQuery__
 *
 * To run a query within a React component, call `useStructureForRiskAssessmentQuery` and pass it any options that fit your needs.
 * When your component renders, `useStructureForRiskAssessmentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStructureForRiskAssessmentQuery({
 *   variables: {
 *      structureId: // value for 'structureId'
 *   },
 * });
 */
export function useStructureForRiskAssessmentQuery(baseOptions?: Apollo.QueryHookOptions<StructureForRiskAssessmentQuery, StructureForRiskAssessmentQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<StructureForRiskAssessmentQuery, StructureForRiskAssessmentQueryVariables>(StructureForRiskAssessmentDocument, options);
      }
export function useStructureForRiskAssessmentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<StructureForRiskAssessmentQuery, StructureForRiskAssessmentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<StructureForRiskAssessmentQuery, StructureForRiskAssessmentQueryVariables>(StructureForRiskAssessmentDocument, options);
        }
// @ts-ignore
export function useStructureForRiskAssessmentSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<StructureForRiskAssessmentQuery, StructureForRiskAssessmentQueryVariables>): Apollo.UseSuspenseQueryResult<StructureForRiskAssessmentQuery, StructureForRiskAssessmentQueryVariables>;
export function useStructureForRiskAssessmentSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<StructureForRiskAssessmentQuery, StructureForRiskAssessmentQueryVariables>): Apollo.UseSuspenseQueryResult<StructureForRiskAssessmentQuery | undefined, StructureForRiskAssessmentQueryVariables>;
export function useStructureForRiskAssessmentSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<StructureForRiskAssessmentQuery, StructureForRiskAssessmentQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<StructureForRiskAssessmentQuery, StructureForRiskAssessmentQueryVariables>(StructureForRiskAssessmentDocument, options);
        }
export type StructureForRiskAssessmentQueryHookResult = ReturnType<typeof useStructureForRiskAssessmentQuery>;
export type StructureForRiskAssessmentLazyQueryHookResult = ReturnType<typeof useStructureForRiskAssessmentLazyQuery>;
export type StructureForRiskAssessmentSuspenseQueryHookResult = ReturnType<typeof useStructureForRiskAssessmentSuspenseQuery>;
export type StructureForRiskAssessmentQueryResult = Apollo.QueryResult<StructureForRiskAssessmentQuery, StructureForRiskAssessmentQueryVariables>;
export const AllAssemblyTemplatesForRiskAssessmentDocument = gql`
    query AllAssemblyTemplatesForRiskAssessment($structureId: ID, $type: TemplateTypeEnum) {
  allTemplates(structureId: $structureId, type: $type) {
    name
    id
    fields {
      displayConfig {
        id
        type
        color {
          key
          value
        }
        isSortable
        sortType
        textFormat
      }
      id
      name
      key
      type
      metaData
      enableInlineEdit
      options
      permission
      displayInQuery
      displayInTable
      displayInRisk
      displayInReview
      displayInReports
      roundToDecimal
      unit
      displayUnit
      optionsData {
        value
        min
        max
      }
      isExportable
    }
    riskFields {
      type
      isHiddenColumn
      id
      fieldKey
    }
  }
}
    `;

/**
 * __useAllAssemblyTemplatesForRiskAssessmentQuery__
 *
 * To run a query within a React component, call `useAllAssemblyTemplatesForRiskAssessmentQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllAssemblyTemplatesForRiskAssessmentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllAssemblyTemplatesForRiskAssessmentQuery({
 *   variables: {
 *      structureId: // value for 'structureId'
 *      type: // value for 'type'
 *   },
 * });
 */
export function useAllAssemblyTemplatesForRiskAssessmentQuery(baseOptions?: Apollo.QueryHookOptions<AllAssemblyTemplatesForRiskAssessmentQuery, AllAssemblyTemplatesForRiskAssessmentQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AllAssemblyTemplatesForRiskAssessmentQuery, AllAssemblyTemplatesForRiskAssessmentQueryVariables>(AllAssemblyTemplatesForRiskAssessmentDocument, options);
      }
export function useAllAssemblyTemplatesForRiskAssessmentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AllAssemblyTemplatesForRiskAssessmentQuery, AllAssemblyTemplatesForRiskAssessmentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AllAssemblyTemplatesForRiskAssessmentQuery, AllAssemblyTemplatesForRiskAssessmentQueryVariables>(AllAssemblyTemplatesForRiskAssessmentDocument, options);
        }
// @ts-ignore
export function useAllAssemblyTemplatesForRiskAssessmentSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<AllAssemblyTemplatesForRiskAssessmentQuery, AllAssemblyTemplatesForRiskAssessmentQueryVariables>): Apollo.UseSuspenseQueryResult<AllAssemblyTemplatesForRiskAssessmentQuery, AllAssemblyTemplatesForRiskAssessmentQueryVariables>;
export function useAllAssemblyTemplatesForRiskAssessmentSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AllAssemblyTemplatesForRiskAssessmentQuery, AllAssemblyTemplatesForRiskAssessmentQueryVariables>): Apollo.UseSuspenseQueryResult<AllAssemblyTemplatesForRiskAssessmentQuery | undefined, AllAssemblyTemplatesForRiskAssessmentQueryVariables>;
export function useAllAssemblyTemplatesForRiskAssessmentSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AllAssemblyTemplatesForRiskAssessmentQuery, AllAssemblyTemplatesForRiskAssessmentQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AllAssemblyTemplatesForRiskAssessmentQuery, AllAssemblyTemplatesForRiskAssessmentQueryVariables>(AllAssemblyTemplatesForRiskAssessmentDocument, options);
        }
export type AllAssemblyTemplatesForRiskAssessmentQueryHookResult = ReturnType<typeof useAllAssemblyTemplatesForRiskAssessmentQuery>;
export type AllAssemblyTemplatesForRiskAssessmentLazyQueryHookResult = ReturnType<typeof useAllAssemblyTemplatesForRiskAssessmentLazyQuery>;
export type AllAssemblyTemplatesForRiskAssessmentSuspenseQueryHookResult = ReturnType<typeof useAllAssemblyTemplatesForRiskAssessmentSuspenseQuery>;
export type AllAssemblyTemplatesForRiskAssessmentQueryResult = Apollo.QueryResult<AllAssemblyTemplatesForRiskAssessmentQuery, AllAssemblyTemplatesForRiskAssessmentQueryVariables>;
export const GetTemplateByTypeDocument = gql`
    query getTemplateByType($structureId: ID!, $type: TemplateTypeEnum!) {
  allTemplates(structureId: $structureId, type: $type) {
    id
    name
    fields {
      options
      name
      type
      id
      key
      isHidden
      isReadOnly
    }
  }
}
    `;

/**
 * __useGetTemplateByTypeQuery__
 *
 * To run a query within a React component, call `useGetTemplateByTypeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTemplateByTypeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTemplateByTypeQuery({
 *   variables: {
 *      structureId: // value for 'structureId'
 *      type: // value for 'type'
 *   },
 * });
 */
export function useGetTemplateByTypeQuery(baseOptions: Apollo.QueryHookOptions<GetTemplateByTypeQuery, GetTemplateByTypeQueryVariables> & ({ variables: GetTemplateByTypeQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTemplateByTypeQuery, GetTemplateByTypeQueryVariables>(GetTemplateByTypeDocument, options);
      }
export function useGetTemplateByTypeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTemplateByTypeQuery, GetTemplateByTypeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTemplateByTypeQuery, GetTemplateByTypeQueryVariables>(GetTemplateByTypeDocument, options);
        }
// @ts-ignore
export function useGetTemplateByTypeSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetTemplateByTypeQuery, GetTemplateByTypeQueryVariables>): Apollo.UseSuspenseQueryResult<GetTemplateByTypeQuery, GetTemplateByTypeQueryVariables>;
export function useGetTemplateByTypeSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetTemplateByTypeQuery, GetTemplateByTypeQueryVariables>): Apollo.UseSuspenseQueryResult<GetTemplateByTypeQuery | undefined, GetTemplateByTypeQueryVariables>;
export function useGetTemplateByTypeSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetTemplateByTypeQuery, GetTemplateByTypeQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetTemplateByTypeQuery, GetTemplateByTypeQueryVariables>(GetTemplateByTypeDocument, options);
        }
export type GetTemplateByTypeQueryHookResult = ReturnType<typeof useGetTemplateByTypeQuery>;
export type GetTemplateByTypeLazyQueryHookResult = ReturnType<typeof useGetTemplateByTypeLazyQuery>;
export type GetTemplateByTypeSuspenseQueryHookResult = ReturnType<typeof useGetTemplateByTypeSuspenseQuery>;
export type GetTemplateByTypeQueryResult = Apollo.QueryResult<GetTemplateByTypeQuery, GetTemplateByTypeQueryVariables>;
export const GetAssembliesByRiskAssessmentFiltersDocument = gql`
    query getAssembliesByRiskAssessmentFilters($input: RiskAssessmentFiltersInput!, $pageInfo: PageInfo) {
  getAssembliesByRiskAssessmentFilters(input: $input, pageInfo: $pageInfo) {
    id
    tagName
    templateFieldData
    isUncontextualized
    decks {
      deckId {
        id
      }
    }
  }
  getRiskAssembliesCount(input: $input) {
    count
  }
}
    `;

/**
 * __useGetAssembliesByRiskAssessmentFiltersQuery__
 *
 * To run a query within a React component, call `useGetAssembliesByRiskAssessmentFiltersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAssembliesByRiskAssessmentFiltersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAssembliesByRiskAssessmentFiltersQuery({
 *   variables: {
 *      input: // value for 'input'
 *      pageInfo: // value for 'pageInfo'
 *   },
 * });
 */
export function useGetAssembliesByRiskAssessmentFiltersQuery(baseOptions: Apollo.QueryHookOptions<GetAssembliesByRiskAssessmentFiltersQuery, GetAssembliesByRiskAssessmentFiltersQueryVariables> & ({ variables: GetAssembliesByRiskAssessmentFiltersQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAssembliesByRiskAssessmentFiltersQuery, GetAssembliesByRiskAssessmentFiltersQueryVariables>(GetAssembliesByRiskAssessmentFiltersDocument, options);
      }
export function useGetAssembliesByRiskAssessmentFiltersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAssembliesByRiskAssessmentFiltersQuery, GetAssembliesByRiskAssessmentFiltersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAssembliesByRiskAssessmentFiltersQuery, GetAssembliesByRiskAssessmentFiltersQueryVariables>(GetAssembliesByRiskAssessmentFiltersDocument, options);
        }
// @ts-ignore
export function useGetAssembliesByRiskAssessmentFiltersSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetAssembliesByRiskAssessmentFiltersQuery, GetAssembliesByRiskAssessmentFiltersQueryVariables>): Apollo.UseSuspenseQueryResult<GetAssembliesByRiskAssessmentFiltersQuery, GetAssembliesByRiskAssessmentFiltersQueryVariables>;
export function useGetAssembliesByRiskAssessmentFiltersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAssembliesByRiskAssessmentFiltersQuery, GetAssembliesByRiskAssessmentFiltersQueryVariables>): Apollo.UseSuspenseQueryResult<GetAssembliesByRiskAssessmentFiltersQuery | undefined, GetAssembliesByRiskAssessmentFiltersQueryVariables>;
export function useGetAssembliesByRiskAssessmentFiltersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAssembliesByRiskAssessmentFiltersQuery, GetAssembliesByRiskAssessmentFiltersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAssembliesByRiskAssessmentFiltersQuery, GetAssembliesByRiskAssessmentFiltersQueryVariables>(GetAssembliesByRiskAssessmentFiltersDocument, options);
        }
export type GetAssembliesByRiskAssessmentFiltersQueryHookResult = ReturnType<typeof useGetAssembliesByRiskAssessmentFiltersQuery>;
export type GetAssembliesByRiskAssessmentFiltersLazyQueryHookResult = ReturnType<typeof useGetAssembliesByRiskAssessmentFiltersLazyQuery>;
export type GetAssembliesByRiskAssessmentFiltersSuspenseQueryHookResult = ReturnType<typeof useGetAssembliesByRiskAssessmentFiltersSuspenseQuery>;
export type GetAssembliesByRiskAssessmentFiltersQueryResult = Apollo.QueryResult<GetAssembliesByRiskAssessmentFiltersQuery, GetAssembliesByRiskAssessmentFiltersQueryVariables>;
export const GetDependentRiskAssessmentOptionsDocument = gql`
    query GetDependentRiskAssessmentOptions($input: RiskAssessmentFiltersInput) {
  getDependentRiskAssessmentOptions(input: $input) {
    key
    options
  }
}
    `;

/**
 * __useGetDependentRiskAssessmentOptionsQuery__
 *
 * To run a query within a React component, call `useGetDependentRiskAssessmentOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDependentRiskAssessmentOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDependentRiskAssessmentOptionsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetDependentRiskAssessmentOptionsQuery(baseOptions?: Apollo.QueryHookOptions<GetDependentRiskAssessmentOptionsQuery, GetDependentRiskAssessmentOptionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDependentRiskAssessmentOptionsQuery, GetDependentRiskAssessmentOptionsQueryVariables>(GetDependentRiskAssessmentOptionsDocument, options);
      }
export function useGetDependentRiskAssessmentOptionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDependentRiskAssessmentOptionsQuery, GetDependentRiskAssessmentOptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDependentRiskAssessmentOptionsQuery, GetDependentRiskAssessmentOptionsQueryVariables>(GetDependentRiskAssessmentOptionsDocument, options);
        }
// @ts-ignore
export function useGetDependentRiskAssessmentOptionsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetDependentRiskAssessmentOptionsQuery, GetDependentRiskAssessmentOptionsQueryVariables>): Apollo.UseSuspenseQueryResult<GetDependentRiskAssessmentOptionsQuery, GetDependentRiskAssessmentOptionsQueryVariables>;
export function useGetDependentRiskAssessmentOptionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetDependentRiskAssessmentOptionsQuery, GetDependentRiskAssessmentOptionsQueryVariables>): Apollo.UseSuspenseQueryResult<GetDependentRiskAssessmentOptionsQuery | undefined, GetDependentRiskAssessmentOptionsQueryVariables>;
export function useGetDependentRiskAssessmentOptionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetDependentRiskAssessmentOptionsQuery, GetDependentRiskAssessmentOptionsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetDependentRiskAssessmentOptionsQuery, GetDependentRiskAssessmentOptionsQueryVariables>(GetDependentRiskAssessmentOptionsDocument, options);
        }
export type GetDependentRiskAssessmentOptionsQueryHookResult = ReturnType<typeof useGetDependentRiskAssessmentOptionsQuery>;
export type GetDependentRiskAssessmentOptionsLazyQueryHookResult = ReturnType<typeof useGetDependentRiskAssessmentOptionsLazyQuery>;
export type GetDependentRiskAssessmentOptionsSuspenseQueryHookResult = ReturnType<typeof useGetDependentRiskAssessmentOptionsSuspenseQuery>;
export type GetDependentRiskAssessmentOptionsQueryResult = Apollo.QueryResult<GetDependentRiskAssessmentOptionsQuery, GetDependentRiskAssessmentOptionsQueryVariables>;
export const CreateRiskAssessmentDetailsDocument = gql`
    mutation createRiskAssessmentDetails($input: CreateRiskAssessmentDetailsInput) {
  createRiskAssessmentDetails(input: $input) {
    id
    name
    type
    hasRiskAssessment
    template {
      id
    }
    templateData {
      id
      value
      templateFieldId
    }
  }
}
    `;
export type CreateRiskAssessmentDetailsMutationFn = Apollo.MutationFunction<CreateRiskAssessmentDetailsMutation, CreateRiskAssessmentDetailsMutationVariables>;

/**
 * __useCreateRiskAssessmentDetailsMutation__
 *
 * To run a mutation, you first call `useCreateRiskAssessmentDetailsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateRiskAssessmentDetailsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createRiskAssessmentDetailsMutation, { data, loading, error }] = useCreateRiskAssessmentDetailsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateRiskAssessmentDetailsMutation(baseOptions?: Apollo.MutationHookOptions<CreateRiskAssessmentDetailsMutation, CreateRiskAssessmentDetailsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateRiskAssessmentDetailsMutation, CreateRiskAssessmentDetailsMutationVariables>(CreateRiskAssessmentDetailsDocument, options);
      }
export type CreateRiskAssessmentDetailsMutationHookResult = ReturnType<typeof useCreateRiskAssessmentDetailsMutation>;
export type CreateRiskAssessmentDetailsMutationResult = Apollo.MutationResult<CreateRiskAssessmentDetailsMutation>;
export type CreateRiskAssessmentDetailsMutationOptions = Apollo.BaseMutationOptions<CreateRiskAssessmentDetailsMutation, CreateRiskAssessmentDetailsMutationVariables>;
export const GetAssemblyForTaskModalDocument = gql`
    query GetAssemblyForTaskModal($assemblyId: String) {
  assembly(assemblyId: $assemblyId) {
    templateFieldData
  }
}
    `;

/**
 * __useGetAssemblyForTaskModalQuery__
 *
 * To run a query within a React component, call `useGetAssemblyForTaskModalQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAssemblyForTaskModalQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAssemblyForTaskModalQuery({
 *   variables: {
 *      assemblyId: // value for 'assemblyId'
 *   },
 * });
 */
export function useGetAssemblyForTaskModalQuery(baseOptions?: Apollo.QueryHookOptions<GetAssemblyForTaskModalQuery, GetAssemblyForTaskModalQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAssemblyForTaskModalQuery, GetAssemblyForTaskModalQueryVariables>(GetAssemblyForTaskModalDocument, options);
      }
export function useGetAssemblyForTaskModalLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAssemblyForTaskModalQuery, GetAssemblyForTaskModalQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAssemblyForTaskModalQuery, GetAssemblyForTaskModalQueryVariables>(GetAssemblyForTaskModalDocument, options);
        }
// @ts-ignore
export function useGetAssemblyForTaskModalSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetAssemblyForTaskModalQuery, GetAssemblyForTaskModalQueryVariables>): Apollo.UseSuspenseQueryResult<GetAssemblyForTaskModalQuery, GetAssemblyForTaskModalQueryVariables>;
export function useGetAssemblyForTaskModalSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAssemblyForTaskModalQuery, GetAssemblyForTaskModalQueryVariables>): Apollo.UseSuspenseQueryResult<GetAssemblyForTaskModalQuery | undefined, GetAssemblyForTaskModalQueryVariables>;
export function useGetAssemblyForTaskModalSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAssemblyForTaskModalQuery, GetAssemblyForTaskModalQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAssemblyForTaskModalQuery, GetAssemblyForTaskModalQueryVariables>(GetAssemblyForTaskModalDocument, options);
        }
export type GetAssemblyForTaskModalQueryHookResult = ReturnType<typeof useGetAssemblyForTaskModalQuery>;
export type GetAssemblyForTaskModalLazyQueryHookResult = ReturnType<typeof useGetAssemblyForTaskModalLazyQuery>;
export type GetAssemblyForTaskModalSuspenseQueryHookResult = ReturnType<typeof useGetAssemblyForTaskModalSuspenseQuery>;
export type GetAssemblyForTaskModalQueryResult = Apollo.QueryResult<GetAssemblyForTaskModalQuery, GetAssemblyForTaskModalQueryVariables>;
export const UpdateRiskAssessmentTemplateFieldDataAndTransitionPeriodDocument = gql`
    mutation updateRiskAssessmentTemplateFieldDataAndTransitionPeriod($input: UpdateRiskAssessmentTemplateFieldDataForAssembliesInput!) {
  updateRiskAssessmentTemplateFieldDataAndTransitionPeriod(input: $input) {
    calculatedTransitionPeriod {
      transitionPeriod
      nextDate
      futureDate
    }
    invalidDamageClassCount
  }
}
    `;
export type UpdateRiskAssessmentTemplateFieldDataAndTransitionPeriodMutationFn = Apollo.MutationFunction<UpdateRiskAssessmentTemplateFieldDataAndTransitionPeriodMutation, UpdateRiskAssessmentTemplateFieldDataAndTransitionPeriodMutationVariables>;

/**
 * __useUpdateRiskAssessmentTemplateFieldDataAndTransitionPeriodMutation__
 *
 * To run a mutation, you first call `useUpdateRiskAssessmentTemplateFieldDataAndTransitionPeriodMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateRiskAssessmentTemplateFieldDataAndTransitionPeriodMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateRiskAssessmentTemplateFieldDataAndTransitionPeriodMutation, { data, loading, error }] = useUpdateRiskAssessmentTemplateFieldDataAndTransitionPeriodMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateRiskAssessmentTemplateFieldDataAndTransitionPeriodMutation(baseOptions?: Apollo.MutationHookOptions<UpdateRiskAssessmentTemplateFieldDataAndTransitionPeriodMutation, UpdateRiskAssessmentTemplateFieldDataAndTransitionPeriodMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateRiskAssessmentTemplateFieldDataAndTransitionPeriodMutation, UpdateRiskAssessmentTemplateFieldDataAndTransitionPeriodMutationVariables>(UpdateRiskAssessmentTemplateFieldDataAndTransitionPeriodDocument, options);
      }
export type UpdateRiskAssessmentTemplateFieldDataAndTransitionPeriodMutationHookResult = ReturnType<typeof useUpdateRiskAssessmentTemplateFieldDataAndTransitionPeriodMutation>;
export type UpdateRiskAssessmentTemplateFieldDataAndTransitionPeriodMutationResult = Apollo.MutationResult<UpdateRiskAssessmentTemplateFieldDataAndTransitionPeriodMutation>;
export type UpdateRiskAssessmentTemplateFieldDataAndTransitionPeriodMutationOptions = Apollo.BaseMutationOptions<UpdateRiskAssessmentTemplateFieldDataAndTransitionPeriodMutation, UpdateRiskAssessmentTemplateFieldDataAndTransitionPeriodMutationVariables>;
export const GetMaterialTemplateByTypeDocument = gql`
    query getMaterialTemplateByType($structureId: ID!, $type: TemplateTypeEnum!) {
  allTemplates(structureId: $structureId, type: $type) {
    materialType {
      type
      thickness
      corrosivityCategory {
        name
        values
      }
      environmentalClassification {
        name
        values
      }
      environmentalExposure {
        name
        code
        timeToVisibility
      }
    }
  }
}
    `;

/**
 * __useGetMaterialTemplateByTypeQuery__
 *
 * To run a query within a React component, call `useGetMaterialTemplateByTypeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMaterialTemplateByTypeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMaterialTemplateByTypeQuery({
 *   variables: {
 *      structureId: // value for 'structureId'
 *      type: // value for 'type'
 *   },
 * });
 */
export function useGetMaterialTemplateByTypeQuery(baseOptions: Apollo.QueryHookOptions<GetMaterialTemplateByTypeQuery, GetMaterialTemplateByTypeQueryVariables> & ({ variables: GetMaterialTemplateByTypeQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMaterialTemplateByTypeQuery, GetMaterialTemplateByTypeQueryVariables>(GetMaterialTemplateByTypeDocument, options);
      }
export function useGetMaterialTemplateByTypeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMaterialTemplateByTypeQuery, GetMaterialTemplateByTypeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMaterialTemplateByTypeQuery, GetMaterialTemplateByTypeQueryVariables>(GetMaterialTemplateByTypeDocument, options);
        }
// @ts-ignore
export function useGetMaterialTemplateByTypeSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetMaterialTemplateByTypeQuery, GetMaterialTemplateByTypeQueryVariables>): Apollo.UseSuspenseQueryResult<GetMaterialTemplateByTypeQuery, GetMaterialTemplateByTypeQueryVariables>;
export function useGetMaterialTemplateByTypeSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetMaterialTemplateByTypeQuery, GetMaterialTemplateByTypeQueryVariables>): Apollo.UseSuspenseQueryResult<GetMaterialTemplateByTypeQuery | undefined, GetMaterialTemplateByTypeQueryVariables>;
export function useGetMaterialTemplateByTypeSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetMaterialTemplateByTypeQuery, GetMaterialTemplateByTypeQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetMaterialTemplateByTypeQuery, GetMaterialTemplateByTypeQueryVariables>(GetMaterialTemplateByTypeDocument, options);
        }
export type GetMaterialTemplateByTypeQueryHookResult = ReturnType<typeof useGetMaterialTemplateByTypeQuery>;
export type GetMaterialTemplateByTypeLazyQueryHookResult = ReturnType<typeof useGetMaterialTemplateByTypeLazyQuery>;
export type GetMaterialTemplateByTypeSuspenseQueryHookResult = ReturnType<typeof useGetMaterialTemplateByTypeSuspenseQuery>;
export type GetMaterialTemplateByTypeQueryResult = Apollo.QueryResult<GetMaterialTemplateByTypeQuery, GetMaterialTemplateByTypeQueryVariables>;
export const BulkCreateCommentsForAssembliesDocument = gql`
    mutation BulkCreateCommentsForAssemblies($input: BulkCreateForAssembliesInput) {
  bulkCreateCommentsForAssemblies(input: $input) {
    modifiedCount
    insertedCount
    upsertedCount
  }
}
    `;
export type BulkCreateCommentsForAssembliesMutationFn = Apollo.MutationFunction<BulkCreateCommentsForAssembliesMutation, BulkCreateCommentsForAssembliesMutationVariables>;

/**
 * __useBulkCreateCommentsForAssembliesMutation__
 *
 * To run a mutation, you first call `useBulkCreateCommentsForAssembliesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBulkCreateCommentsForAssembliesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [bulkCreateCommentsForAssembliesMutation, { data, loading, error }] = useBulkCreateCommentsForAssembliesMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useBulkCreateCommentsForAssembliesMutation(baseOptions?: Apollo.MutationHookOptions<BulkCreateCommentsForAssembliesMutation, BulkCreateCommentsForAssembliesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<BulkCreateCommentsForAssembliesMutation, BulkCreateCommentsForAssembliesMutationVariables>(BulkCreateCommentsForAssembliesDocument, options);
      }
export type BulkCreateCommentsForAssembliesMutationHookResult = ReturnType<typeof useBulkCreateCommentsForAssembliesMutation>;
export type BulkCreateCommentsForAssembliesMutationResult = Apollo.MutationResult<BulkCreateCommentsForAssembliesMutation>;
export type BulkCreateCommentsForAssembliesMutationOptions = Apollo.BaseMutationOptions<BulkCreateCommentsForAssembliesMutation, BulkCreateCommentsForAssembliesMutationVariables>;
export const GetUnpublishedSummarySheetCountsDocument = gql`
    query GetUnpublishedSummarySheetCounts($input: SummarySheetGraphsCountInput, $structureId: String) {
  getSummarySheetGraphsCount(input: $input) {
    count
    key
  }
  getRiskAssessmentSummaryCounts(structureId: $structureId) {
    cofCalculated
    pofCalculated
    totalAssemblies
    transitionPeriodCalculated
  }
}
    `;

/**
 * __useGetUnpublishedSummarySheetCountsQuery__
 *
 * To run a query within a React component, call `useGetUnpublishedSummarySheetCountsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUnpublishedSummarySheetCountsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUnpublishedSummarySheetCountsQuery({
 *   variables: {
 *      input: // value for 'input'
 *      structureId: // value for 'structureId'
 *   },
 * });
 */
export function useGetUnpublishedSummarySheetCountsQuery(baseOptions?: Apollo.QueryHookOptions<GetUnpublishedSummarySheetCountsQuery, GetUnpublishedSummarySheetCountsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUnpublishedSummarySheetCountsQuery, GetUnpublishedSummarySheetCountsQueryVariables>(GetUnpublishedSummarySheetCountsDocument, options);
      }
export function useGetUnpublishedSummarySheetCountsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUnpublishedSummarySheetCountsQuery, GetUnpublishedSummarySheetCountsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUnpublishedSummarySheetCountsQuery, GetUnpublishedSummarySheetCountsQueryVariables>(GetUnpublishedSummarySheetCountsDocument, options);
        }
// @ts-ignore
export function useGetUnpublishedSummarySheetCountsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetUnpublishedSummarySheetCountsQuery, GetUnpublishedSummarySheetCountsQueryVariables>): Apollo.UseSuspenseQueryResult<GetUnpublishedSummarySheetCountsQuery, GetUnpublishedSummarySheetCountsQueryVariables>;
export function useGetUnpublishedSummarySheetCountsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetUnpublishedSummarySheetCountsQuery, GetUnpublishedSummarySheetCountsQueryVariables>): Apollo.UseSuspenseQueryResult<GetUnpublishedSummarySheetCountsQuery | undefined, GetUnpublishedSummarySheetCountsQueryVariables>;
export function useGetUnpublishedSummarySheetCountsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetUnpublishedSummarySheetCountsQuery, GetUnpublishedSummarySheetCountsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetUnpublishedSummarySheetCountsQuery, GetUnpublishedSummarySheetCountsQueryVariables>(GetUnpublishedSummarySheetCountsDocument, options);
        }
export type GetUnpublishedSummarySheetCountsQueryHookResult = ReturnType<typeof useGetUnpublishedSummarySheetCountsQuery>;
export type GetUnpublishedSummarySheetCountsLazyQueryHookResult = ReturnType<typeof useGetUnpublishedSummarySheetCountsLazyQuery>;
export type GetUnpublishedSummarySheetCountsSuspenseQueryHookResult = ReturnType<typeof useGetUnpublishedSummarySheetCountsSuspenseQuery>;
export type GetUnpublishedSummarySheetCountsQueryResult = Apollo.QueryResult<GetUnpublishedSummarySheetCountsQuery, GetUnpublishedSummarySheetCountsQueryVariables>;
export const GetPublishedSummarySheetCountsDocument = gql`
    query GetPublishedSummarySheetCounts($SHEInput: SummarySheetGraphsCountInput, $financialsInput: SummarySheetGraphsCountInput, $structureId: String) {
  governingSHEData: getSummarySheetGraphsCount(input: $SHEInput) {
    count
    key
  }
  governingFinancialData: getSummarySheetGraphsCount(input: $financialsInput) {
    count
    key
  }
  calculationCounts: getRiskAssessmentSummaryCounts(structureId: $structureId) {
    cofCalculated
    pofCalculated
    totalAssemblies
    transitionPeriodCalculated
  }
}
    `;

/**
 * __useGetPublishedSummarySheetCountsQuery__
 *
 * To run a query within a React component, call `useGetPublishedSummarySheetCountsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPublishedSummarySheetCountsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPublishedSummarySheetCountsQuery({
 *   variables: {
 *      SHEInput: // value for 'SHEInput'
 *      financialsInput: // value for 'financialsInput'
 *      structureId: // value for 'structureId'
 *   },
 * });
 */
export function useGetPublishedSummarySheetCountsQuery(baseOptions?: Apollo.QueryHookOptions<GetPublishedSummarySheetCountsQuery, GetPublishedSummarySheetCountsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPublishedSummarySheetCountsQuery, GetPublishedSummarySheetCountsQueryVariables>(GetPublishedSummarySheetCountsDocument, options);
      }
export function useGetPublishedSummarySheetCountsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPublishedSummarySheetCountsQuery, GetPublishedSummarySheetCountsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPublishedSummarySheetCountsQuery, GetPublishedSummarySheetCountsQueryVariables>(GetPublishedSummarySheetCountsDocument, options);
        }
// @ts-ignore
export function useGetPublishedSummarySheetCountsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetPublishedSummarySheetCountsQuery, GetPublishedSummarySheetCountsQueryVariables>): Apollo.UseSuspenseQueryResult<GetPublishedSummarySheetCountsQuery, GetPublishedSummarySheetCountsQueryVariables>;
export function useGetPublishedSummarySheetCountsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPublishedSummarySheetCountsQuery, GetPublishedSummarySheetCountsQueryVariables>): Apollo.UseSuspenseQueryResult<GetPublishedSummarySheetCountsQuery | undefined, GetPublishedSummarySheetCountsQueryVariables>;
export function useGetPublishedSummarySheetCountsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPublishedSummarySheetCountsQuery, GetPublishedSummarySheetCountsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetPublishedSummarySheetCountsQuery, GetPublishedSummarySheetCountsQueryVariables>(GetPublishedSummarySheetCountsDocument, options);
        }
export type GetPublishedSummarySheetCountsQueryHookResult = ReturnType<typeof useGetPublishedSummarySheetCountsQuery>;
export type GetPublishedSummarySheetCountsLazyQueryHookResult = ReturnType<typeof useGetPublishedSummarySheetCountsLazyQuery>;
export type GetPublishedSummarySheetCountsSuspenseQueryHookResult = ReturnType<typeof useGetPublishedSummarySheetCountsSuspenseQuery>;
export type GetPublishedSummarySheetCountsQueryResult = Apollo.QueryResult<GetPublishedSummarySheetCountsQuery, GetPublishedSummarySheetCountsQueryVariables>;
export const GetRiskAssessmentSummaryDataDocument = gql`
    query GetRiskAssessmentSummaryData($input: RiskAssessmentSummaryDataInput) {
  getRiskAssessmentSummaryData(input: $input) {
    _id
    completedCalculationsCount
    damageClassCount {
      count
      key
    }
    level1Component
    totalCalculationsCount
  }
}
    `;

/**
 * __useGetRiskAssessmentSummaryDataQuery__
 *
 * To run a query within a React component, call `useGetRiskAssessmentSummaryDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRiskAssessmentSummaryDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRiskAssessmentSummaryDataQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetRiskAssessmentSummaryDataQuery(baseOptions?: Apollo.QueryHookOptions<GetRiskAssessmentSummaryDataQuery, GetRiskAssessmentSummaryDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRiskAssessmentSummaryDataQuery, GetRiskAssessmentSummaryDataQueryVariables>(GetRiskAssessmentSummaryDataDocument, options);
      }
export function useGetRiskAssessmentSummaryDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRiskAssessmentSummaryDataQuery, GetRiskAssessmentSummaryDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRiskAssessmentSummaryDataQuery, GetRiskAssessmentSummaryDataQueryVariables>(GetRiskAssessmentSummaryDataDocument, options);
        }
// @ts-ignore
export function useGetRiskAssessmentSummaryDataSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetRiskAssessmentSummaryDataQuery, GetRiskAssessmentSummaryDataQueryVariables>): Apollo.UseSuspenseQueryResult<GetRiskAssessmentSummaryDataQuery, GetRiskAssessmentSummaryDataQueryVariables>;
export function useGetRiskAssessmentSummaryDataSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetRiskAssessmentSummaryDataQuery, GetRiskAssessmentSummaryDataQueryVariables>): Apollo.UseSuspenseQueryResult<GetRiskAssessmentSummaryDataQuery | undefined, GetRiskAssessmentSummaryDataQueryVariables>;
export function useGetRiskAssessmentSummaryDataSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetRiskAssessmentSummaryDataQuery, GetRiskAssessmentSummaryDataQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetRiskAssessmentSummaryDataQuery, GetRiskAssessmentSummaryDataQueryVariables>(GetRiskAssessmentSummaryDataDocument, options);
        }
export type GetRiskAssessmentSummaryDataQueryHookResult = ReturnType<typeof useGetRiskAssessmentSummaryDataQuery>;
export type GetRiskAssessmentSummaryDataLazyQueryHookResult = ReturnType<typeof useGetRiskAssessmentSummaryDataLazyQuery>;
export type GetRiskAssessmentSummaryDataSuspenseQueryHookResult = ReturnType<typeof useGetRiskAssessmentSummaryDataSuspenseQuery>;
export type GetRiskAssessmentSummaryDataQueryResult = Apollo.QueryResult<GetRiskAssessmentSummaryDataQuery, GetRiskAssessmentSummaryDataQueryVariables>;
export const GetRiskAssessmentSummaryTableDataDocument = gql`
    query GetRiskAssessmentSummaryTableData($input: RiskAssessmentSummaryTableDataInput) {
  getRiskAssessmentSummaryTableData(input: $input) {
    risk_level_1_component
    risk_level_2_component
    risk_structure
    risk_damage_class
    calculations {
      cof
      pof
      total
      transitionPeriod
    }
  }
}
    `;

/**
 * __useGetRiskAssessmentSummaryTableDataQuery__
 *
 * To run a query within a React component, call `useGetRiskAssessmentSummaryTableDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRiskAssessmentSummaryTableDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRiskAssessmentSummaryTableDataQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetRiskAssessmentSummaryTableDataQuery(baseOptions?: Apollo.QueryHookOptions<GetRiskAssessmentSummaryTableDataQuery, GetRiskAssessmentSummaryTableDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRiskAssessmentSummaryTableDataQuery, GetRiskAssessmentSummaryTableDataQueryVariables>(GetRiskAssessmentSummaryTableDataDocument, options);
      }
export function useGetRiskAssessmentSummaryTableDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRiskAssessmentSummaryTableDataQuery, GetRiskAssessmentSummaryTableDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRiskAssessmentSummaryTableDataQuery, GetRiskAssessmentSummaryTableDataQueryVariables>(GetRiskAssessmentSummaryTableDataDocument, options);
        }
// @ts-ignore
export function useGetRiskAssessmentSummaryTableDataSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetRiskAssessmentSummaryTableDataQuery, GetRiskAssessmentSummaryTableDataQueryVariables>): Apollo.UseSuspenseQueryResult<GetRiskAssessmentSummaryTableDataQuery, GetRiskAssessmentSummaryTableDataQueryVariables>;
export function useGetRiskAssessmentSummaryTableDataSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetRiskAssessmentSummaryTableDataQuery, GetRiskAssessmentSummaryTableDataQueryVariables>): Apollo.UseSuspenseQueryResult<GetRiskAssessmentSummaryTableDataQuery | undefined, GetRiskAssessmentSummaryTableDataQueryVariables>;
export function useGetRiskAssessmentSummaryTableDataSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetRiskAssessmentSummaryTableDataQuery, GetRiskAssessmentSummaryTableDataQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetRiskAssessmentSummaryTableDataQuery, GetRiskAssessmentSummaryTableDataQueryVariables>(GetRiskAssessmentSummaryTableDataDocument, options);
        }
export type GetRiskAssessmentSummaryTableDataQueryHookResult = ReturnType<typeof useGetRiskAssessmentSummaryTableDataQuery>;
export type GetRiskAssessmentSummaryTableDataLazyQueryHookResult = ReturnType<typeof useGetRiskAssessmentSummaryTableDataLazyQuery>;
export type GetRiskAssessmentSummaryTableDataSuspenseQueryHookResult = ReturnType<typeof useGetRiskAssessmentSummaryTableDataSuspenseQuery>;
export type GetRiskAssessmentSummaryTableDataQueryResult = Apollo.QueryResult<GetRiskAssessmentSummaryTableDataQuery, GetRiskAssessmentSummaryTableDataQueryVariables>;
export const UpdateEsSheetStatusDocument = gql`
    mutation UpdateEsSheetStatus($structureId: String!, $status: EsSheetStatus!) {
  updateEsSheetStatus(structureId: $structureId, status: $status) {
    id
    name
    esSheetStatus
  }
}
    `;
export type UpdateEsSheetStatusMutationFn = Apollo.MutationFunction<UpdateEsSheetStatusMutation, UpdateEsSheetStatusMutationVariables>;

/**
 * __useUpdateEsSheetStatusMutation__
 *
 * To run a mutation, you first call `useUpdateEsSheetStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateEsSheetStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateEsSheetStatusMutation, { data, loading, error }] = useUpdateEsSheetStatusMutation({
 *   variables: {
 *      structureId: // value for 'structureId'
 *      status: // value for 'status'
 *   },
 * });
 */
export function useUpdateEsSheetStatusMutation(baseOptions?: Apollo.MutationHookOptions<UpdateEsSheetStatusMutation, UpdateEsSheetStatusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateEsSheetStatusMutation, UpdateEsSheetStatusMutationVariables>(UpdateEsSheetStatusDocument, options);
      }
export type UpdateEsSheetStatusMutationHookResult = ReturnType<typeof useUpdateEsSheetStatusMutation>;
export type UpdateEsSheetStatusMutationResult = Apollo.MutationResult<UpdateEsSheetStatusMutation>;
export type UpdateEsSheetStatusMutationOptions = Apollo.BaseMutationOptions<UpdateEsSheetStatusMutation, UpdateEsSheetStatusMutationVariables>;
export const GetAssemblyDataForInsightsDocument = gql`
    query getAssemblyDataForInsights($assemblyId: String) {
  assembly(assemblyId: $assemblyId) {
    id
    focalPoint {
      x
      y
      z
    }
    seenByViewpoints {
      location {
        id
        name
      }
      corrosion {
        primaryCategory
      }
      distance
    }
    templateFieldData
  }
}
    `;

/**
 * __useGetAssemblyDataForInsightsQuery__
 *
 * To run a query within a React component, call `useGetAssemblyDataForInsightsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAssemblyDataForInsightsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAssemblyDataForInsightsQuery({
 *   variables: {
 *      assemblyId: // value for 'assemblyId'
 *   },
 * });
 */
export function useGetAssemblyDataForInsightsQuery(baseOptions?: Apollo.QueryHookOptions<GetAssemblyDataForInsightsQuery, GetAssemblyDataForInsightsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAssemblyDataForInsightsQuery, GetAssemblyDataForInsightsQueryVariables>(GetAssemblyDataForInsightsDocument, options);
      }
export function useGetAssemblyDataForInsightsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAssemblyDataForInsightsQuery, GetAssemblyDataForInsightsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAssemblyDataForInsightsQuery, GetAssemblyDataForInsightsQueryVariables>(GetAssemblyDataForInsightsDocument, options);
        }
// @ts-ignore
export function useGetAssemblyDataForInsightsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetAssemblyDataForInsightsQuery, GetAssemblyDataForInsightsQueryVariables>): Apollo.UseSuspenseQueryResult<GetAssemblyDataForInsightsQuery, GetAssemblyDataForInsightsQueryVariables>;
export function useGetAssemblyDataForInsightsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAssemblyDataForInsightsQuery, GetAssemblyDataForInsightsQueryVariables>): Apollo.UseSuspenseQueryResult<GetAssemblyDataForInsightsQuery | undefined, GetAssemblyDataForInsightsQueryVariables>;
export function useGetAssemblyDataForInsightsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAssemblyDataForInsightsQuery, GetAssemblyDataForInsightsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAssemblyDataForInsightsQuery, GetAssemblyDataForInsightsQueryVariables>(GetAssemblyDataForInsightsDocument, options);
        }
export type GetAssemblyDataForInsightsQueryHookResult = ReturnType<typeof useGetAssemblyDataForInsightsQuery>;
export type GetAssemblyDataForInsightsLazyQueryHookResult = ReturnType<typeof useGetAssemblyDataForInsightsLazyQuery>;
export type GetAssemblyDataForInsightsSuspenseQueryHookResult = ReturnType<typeof useGetAssemblyDataForInsightsSuspenseQuery>;
export type GetAssemblyDataForInsightsQueryResult = Apollo.QueryResult<GetAssemblyDataForInsightsQuery, GetAssemblyDataForInsightsQueryVariables>;
export const GetAssembliesByTemplateFieldsFiltersForAitInsightsDocument = gql`
    query GetAssembliesByTemplateFieldsFiltersForAitInsights($input: AssembliesFilterInput) {
  getAssembliesByTemplateFieldsFilters(input: $input) {
    id
    tagName
    recommendation {
      analysisStatus
      governingValue {
        calculations {
          residualCorrosionAllowancePercentage
          residualCorrosionAllowance
        }
      }
      analysisRecommendation {
        alarmLevel
        recommendationByUserName
        wasAnalysisAlarmLevelManuallySet
      }
    }
    corrosionLevel
    service {
      code
      group
    }
    isUncontextualized
  }
}
    `;

/**
 * __useGetAssembliesByTemplateFieldsFiltersForAitInsightsQuery__
 *
 * To run a query within a React component, call `useGetAssembliesByTemplateFieldsFiltersForAitInsightsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAssembliesByTemplateFieldsFiltersForAitInsightsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAssembliesByTemplateFieldsFiltersForAitInsightsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetAssembliesByTemplateFieldsFiltersForAitInsightsQuery(baseOptions?: Apollo.QueryHookOptions<GetAssembliesByTemplateFieldsFiltersForAitInsightsQuery, GetAssembliesByTemplateFieldsFiltersForAitInsightsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAssembliesByTemplateFieldsFiltersForAitInsightsQuery, GetAssembliesByTemplateFieldsFiltersForAitInsightsQueryVariables>(GetAssembliesByTemplateFieldsFiltersForAitInsightsDocument, options);
      }
export function useGetAssembliesByTemplateFieldsFiltersForAitInsightsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAssembliesByTemplateFieldsFiltersForAitInsightsQuery, GetAssembliesByTemplateFieldsFiltersForAitInsightsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAssembliesByTemplateFieldsFiltersForAitInsightsQuery, GetAssembliesByTemplateFieldsFiltersForAitInsightsQueryVariables>(GetAssembliesByTemplateFieldsFiltersForAitInsightsDocument, options);
        }
// @ts-ignore
export function useGetAssembliesByTemplateFieldsFiltersForAitInsightsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetAssembliesByTemplateFieldsFiltersForAitInsightsQuery, GetAssembliesByTemplateFieldsFiltersForAitInsightsQueryVariables>): Apollo.UseSuspenseQueryResult<GetAssembliesByTemplateFieldsFiltersForAitInsightsQuery, GetAssembliesByTemplateFieldsFiltersForAitInsightsQueryVariables>;
export function useGetAssembliesByTemplateFieldsFiltersForAitInsightsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAssembliesByTemplateFieldsFiltersForAitInsightsQuery, GetAssembliesByTemplateFieldsFiltersForAitInsightsQueryVariables>): Apollo.UseSuspenseQueryResult<GetAssembliesByTemplateFieldsFiltersForAitInsightsQuery | undefined, GetAssembliesByTemplateFieldsFiltersForAitInsightsQueryVariables>;
export function useGetAssembliesByTemplateFieldsFiltersForAitInsightsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAssembliesByTemplateFieldsFiltersForAitInsightsQuery, GetAssembliesByTemplateFieldsFiltersForAitInsightsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAssembliesByTemplateFieldsFiltersForAitInsightsQuery, GetAssembliesByTemplateFieldsFiltersForAitInsightsQueryVariables>(GetAssembliesByTemplateFieldsFiltersForAitInsightsDocument, options);
        }
export type GetAssembliesByTemplateFieldsFiltersForAitInsightsQueryHookResult = ReturnType<typeof useGetAssembliesByTemplateFieldsFiltersForAitInsightsQuery>;
export type GetAssembliesByTemplateFieldsFiltersForAitInsightsLazyQueryHookResult = ReturnType<typeof useGetAssembliesByTemplateFieldsFiltersForAitInsightsLazyQuery>;
export type GetAssembliesByTemplateFieldsFiltersForAitInsightsSuspenseQueryHookResult = ReturnType<typeof useGetAssembliesByTemplateFieldsFiltersForAitInsightsSuspenseQuery>;
export type GetAssembliesByTemplateFieldsFiltersForAitInsightsQueryResult = Apollo.QueryResult<GetAssembliesByTemplateFieldsFiltersForAitInsightsQuery, GetAssembliesByTemplateFieldsFiltersForAitInsightsQueryVariables>;
export const MarkViewPointAsAnalysedFromCurrentAssemblyDocument = gql`
    mutation MarkViewPointAsAnalysedFromCurrentAssembly($input: MarkViewPointAsAnalysedFromCurrentAssemblyInput) {
  markViewPointAsAnalysedFromCurrentAssembly(input: $input) {
    id
    seenByViewpoints {
      location {
        id
      }
      analysed {
        analysedBy
        updatedAt
      }
    }
  }
}
    `;
export type MarkViewPointAsAnalysedFromCurrentAssemblyMutationFn = Apollo.MutationFunction<MarkViewPointAsAnalysedFromCurrentAssemblyMutation, MarkViewPointAsAnalysedFromCurrentAssemblyMutationVariables>;

/**
 * __useMarkViewPointAsAnalysedFromCurrentAssemblyMutation__
 *
 * To run a mutation, you first call `useMarkViewPointAsAnalysedFromCurrentAssemblyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMarkViewPointAsAnalysedFromCurrentAssemblyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [markViewPointAsAnalysedFromCurrentAssemblyMutation, { data, loading, error }] = useMarkViewPointAsAnalysedFromCurrentAssemblyMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useMarkViewPointAsAnalysedFromCurrentAssemblyMutation(baseOptions?: Apollo.MutationHookOptions<MarkViewPointAsAnalysedFromCurrentAssemblyMutation, MarkViewPointAsAnalysedFromCurrentAssemblyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MarkViewPointAsAnalysedFromCurrentAssemblyMutation, MarkViewPointAsAnalysedFromCurrentAssemblyMutationVariables>(MarkViewPointAsAnalysedFromCurrentAssemblyDocument, options);
      }
export type MarkViewPointAsAnalysedFromCurrentAssemblyMutationHookResult = ReturnType<typeof useMarkViewPointAsAnalysedFromCurrentAssemblyMutation>;
export type MarkViewPointAsAnalysedFromCurrentAssemblyMutationResult = Apollo.MutationResult<MarkViewPointAsAnalysedFromCurrentAssemblyMutation>;
export type MarkViewPointAsAnalysedFromCurrentAssemblyMutationOptions = Apollo.BaseMutationOptions<MarkViewPointAsAnalysedFromCurrentAssemblyMutation, MarkViewPointAsAnalysedFromCurrentAssemblyMutationVariables>;
export const GetAllLocationInStructureDocument = gql`
    query getAllLocationInStructure($structureId: ID) {
  allLocations(structureId: $structureId) {
    id
    name
  }
}
    `;

/**
 * __useGetAllLocationInStructureQuery__
 *
 * To run a query within a React component, call `useGetAllLocationInStructureQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllLocationInStructureQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllLocationInStructureQuery({
 *   variables: {
 *      structureId: // value for 'structureId'
 *   },
 * });
 */
export function useGetAllLocationInStructureQuery(baseOptions?: Apollo.QueryHookOptions<GetAllLocationInStructureQuery, GetAllLocationInStructureQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllLocationInStructureQuery, GetAllLocationInStructureQueryVariables>(GetAllLocationInStructureDocument, options);
      }
export function useGetAllLocationInStructureLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllLocationInStructureQuery, GetAllLocationInStructureQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllLocationInStructureQuery, GetAllLocationInStructureQueryVariables>(GetAllLocationInStructureDocument, options);
        }
// @ts-ignore
export function useGetAllLocationInStructureSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetAllLocationInStructureQuery, GetAllLocationInStructureQueryVariables>): Apollo.UseSuspenseQueryResult<GetAllLocationInStructureQuery, GetAllLocationInStructureQueryVariables>;
export function useGetAllLocationInStructureSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAllLocationInStructureQuery, GetAllLocationInStructureQueryVariables>): Apollo.UseSuspenseQueryResult<GetAllLocationInStructureQuery | undefined, GetAllLocationInStructureQueryVariables>;
export function useGetAllLocationInStructureSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAllLocationInStructureQuery, GetAllLocationInStructureQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAllLocationInStructureQuery, GetAllLocationInStructureQueryVariables>(GetAllLocationInStructureDocument, options);
        }
export type GetAllLocationInStructureQueryHookResult = ReturnType<typeof useGetAllLocationInStructureQuery>;
export type GetAllLocationInStructureLazyQueryHookResult = ReturnType<typeof useGetAllLocationInStructureLazyQuery>;
export type GetAllLocationInStructureSuspenseQueryHookResult = ReturnType<typeof useGetAllLocationInStructureSuspenseQuery>;
export type GetAllLocationInStructureQueryResult = Apollo.QueryResult<GetAllLocationInStructureQuery, GetAllLocationInStructureQueryVariables>;
export const AssemblyDocument = gql`
    query Assembly($assemblyId: String) {
  assembly(assemblyId: $assemblyId) {
    id
    tagName
  }
}
    `;

/**
 * __useAssemblyQuery__
 *
 * To run a query within a React component, call `useAssemblyQuery` and pass it any options that fit your needs.
 * When your component renders, `useAssemblyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAssemblyQuery({
 *   variables: {
 *      assemblyId: // value for 'assemblyId'
 *   },
 * });
 */
export function useAssemblyQuery(baseOptions?: Apollo.QueryHookOptions<AssemblyQuery, AssemblyQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AssemblyQuery, AssemblyQueryVariables>(AssemblyDocument, options);
      }
export function useAssemblyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AssemblyQuery, AssemblyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AssemblyQuery, AssemblyQueryVariables>(AssemblyDocument, options);
        }
// @ts-ignore
export function useAssemblySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<AssemblyQuery, AssemblyQueryVariables>): Apollo.UseSuspenseQueryResult<AssemblyQuery, AssemblyQueryVariables>;
export function useAssemblySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AssemblyQuery, AssemblyQueryVariables>): Apollo.UseSuspenseQueryResult<AssemblyQuery | undefined, AssemblyQueryVariables>;
export function useAssemblySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AssemblyQuery, AssemblyQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AssemblyQuery, AssemblyQueryVariables>(AssemblyDocument, options);
        }
export type AssemblyQueryHookResult = ReturnType<typeof useAssemblyQuery>;
export type AssemblyLazyQueryHookResult = ReturnType<typeof useAssemblyLazyQuery>;
export type AssemblySuspenseQueryHookResult = ReturnType<typeof useAssemblySuspenseQuery>;
export type AssemblyQueryResult = Apollo.QueryResult<AssemblyQuery, AssemblyQueryVariables>;
export const PaintRegionDocument = gql`
    query PaintRegion($paintRegionId: String) {
  paintRegion(paintRegionId: $paintRegionId) {
    id
    volume {
      exclusions {
        z_range
        xy_polygon
      }
      inclusion {
        xy_polygon
        z_range
      }
    }
  }
}
    `;

/**
 * __usePaintRegionQuery__
 *
 * To run a query within a React component, call `usePaintRegionQuery` and pass it any options that fit your needs.
 * When your component renders, `usePaintRegionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePaintRegionQuery({
 *   variables: {
 *      paintRegionId: // value for 'paintRegionId'
 *   },
 * });
 */
export function usePaintRegionQuery(baseOptions?: Apollo.QueryHookOptions<PaintRegionQuery, PaintRegionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PaintRegionQuery, PaintRegionQueryVariables>(PaintRegionDocument, options);
      }
export function usePaintRegionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PaintRegionQuery, PaintRegionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PaintRegionQuery, PaintRegionQueryVariables>(PaintRegionDocument, options);
        }
// @ts-ignore
export function usePaintRegionSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<PaintRegionQuery, PaintRegionQueryVariables>): Apollo.UseSuspenseQueryResult<PaintRegionQuery, PaintRegionQueryVariables>;
export function usePaintRegionSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PaintRegionQuery, PaintRegionQueryVariables>): Apollo.UseSuspenseQueryResult<PaintRegionQuery | undefined, PaintRegionQueryVariables>;
export function usePaintRegionSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PaintRegionQuery, PaintRegionQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PaintRegionQuery, PaintRegionQueryVariables>(PaintRegionDocument, options);
        }
export type PaintRegionQueryHookResult = ReturnType<typeof usePaintRegionQuery>;
export type PaintRegionLazyQueryHookResult = ReturnType<typeof usePaintRegionLazyQuery>;
export type PaintRegionSuspenseQueryHookResult = ReturnType<typeof usePaintRegionSuspenseQuery>;
export type PaintRegionQueryResult = Apollo.QueryResult<PaintRegionQuery, PaintRegionQueryVariables>;
export const UpdatePointOfInterestLocationDocument = gql`
    mutation UpdatePointOfInterestLocation($input: UpdatePointOfInterestLocationInput!) {
  updatePointOfInterestLocation(input: $input) {
    id
    type
    status
    isVerified
    createdAt
    paintRegion {
      id
      name
    }
    template {
      id
      name
      fields {
        id
        unit
        name
        type
      }
    }
    centerPoint3d {
      x
      y
      z
    }
    name
    poiId
    isManuallyCreated
    isAutoGenerated
    assembly {
      id
      tagName
    }
    blister {
      borders3d {
        points {
          x
          y
          z
        }
      }
      maxHeight
      heightType
      pdrHeight
      estimatedHeight
      isManuallyOverridden
      verifiedMaxHeight
      verifiedResidualThickness
      wallLoss {
        percentage
        value
      }
      residualCorrosionAllowance {
        percentage
        value
      }
      residualThickness {
        percentage
        value
      }
    }
    templateFieldData
    visibility
    comment
    accessibility
  }
}
    `;
export type UpdatePointOfInterestLocationMutationFn = Apollo.MutationFunction<UpdatePointOfInterestLocationMutation, UpdatePointOfInterestLocationMutationVariables>;

/**
 * __useUpdatePointOfInterestLocationMutation__
 *
 * To run a mutation, you first call `useUpdatePointOfInterestLocationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePointOfInterestLocationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePointOfInterestLocationMutation, { data, loading, error }] = useUpdatePointOfInterestLocationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdatePointOfInterestLocationMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePointOfInterestLocationMutation, UpdatePointOfInterestLocationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePointOfInterestLocationMutation, UpdatePointOfInterestLocationMutationVariables>(UpdatePointOfInterestLocationDocument, options);
      }
export type UpdatePointOfInterestLocationMutationHookResult = ReturnType<typeof useUpdatePointOfInterestLocationMutation>;
export type UpdatePointOfInterestLocationMutationResult = Apollo.MutationResult<UpdatePointOfInterestLocationMutation>;
export type UpdatePointOfInterestLocationMutationOptions = Apollo.BaseMutationOptions<UpdatePointOfInterestLocationMutation, UpdatePointOfInterestLocationMutationVariables>;
export const GetStructureForInspectionDataLoaderDocument = gql`
    query getStructureForInspectionDataLoader($structureId: String!) {
  structure(structureId: $structureId) {
    id
    octreeResourcesPath
    nodesPerAssemblyPath
    defectLegends {
      id
      groupName
      groupKey
      name
      color
      octreeKey
      octreeValue
      legendText
    }
    partLegends {
      name
      color
    }
    hasRiskAssessment
    hasRGB
    structureRelationshipPath
    assemblyCadModelsBasePath
    photogrammetryTilesPath
    voxelLocationsPath
    voxelSize
    blisterHeightType
    largeVoxelSize
    config {
      northRotation
      spatialHeatmapStep {
        x
        y
        z
      }
      neighbouringImagesOptions {
        showFrames
        showImages
        isEnabledByDefault
        maxImagesToShow
        defaultMeanDistance
      }
      disableClickOnHiddenPoints
    }
  }
}
    `;

/**
 * __useGetStructureForInspectionDataLoaderQuery__
 *
 * To run a query within a React component, call `useGetStructureForInspectionDataLoaderQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetStructureForInspectionDataLoaderQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetStructureForInspectionDataLoaderQuery({
 *   variables: {
 *      structureId: // value for 'structureId'
 *   },
 * });
 */
export function useGetStructureForInspectionDataLoaderQuery(baseOptions: Apollo.QueryHookOptions<GetStructureForInspectionDataLoaderQuery, GetStructureForInspectionDataLoaderQueryVariables> & ({ variables: GetStructureForInspectionDataLoaderQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetStructureForInspectionDataLoaderQuery, GetStructureForInspectionDataLoaderQueryVariables>(GetStructureForInspectionDataLoaderDocument, options);
      }
export function useGetStructureForInspectionDataLoaderLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetStructureForInspectionDataLoaderQuery, GetStructureForInspectionDataLoaderQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetStructureForInspectionDataLoaderQuery, GetStructureForInspectionDataLoaderQueryVariables>(GetStructureForInspectionDataLoaderDocument, options);
        }
// @ts-ignore
export function useGetStructureForInspectionDataLoaderSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetStructureForInspectionDataLoaderQuery, GetStructureForInspectionDataLoaderQueryVariables>): Apollo.UseSuspenseQueryResult<GetStructureForInspectionDataLoaderQuery, GetStructureForInspectionDataLoaderQueryVariables>;
export function useGetStructureForInspectionDataLoaderSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetStructureForInspectionDataLoaderQuery, GetStructureForInspectionDataLoaderQueryVariables>): Apollo.UseSuspenseQueryResult<GetStructureForInspectionDataLoaderQuery | undefined, GetStructureForInspectionDataLoaderQueryVariables>;
export function useGetStructureForInspectionDataLoaderSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetStructureForInspectionDataLoaderQuery, GetStructureForInspectionDataLoaderQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetStructureForInspectionDataLoaderQuery, GetStructureForInspectionDataLoaderQueryVariables>(GetStructureForInspectionDataLoaderDocument, options);
        }
export type GetStructureForInspectionDataLoaderQueryHookResult = ReturnType<typeof useGetStructureForInspectionDataLoaderQuery>;
export type GetStructureForInspectionDataLoaderLazyQueryHookResult = ReturnType<typeof useGetStructureForInspectionDataLoaderLazyQuery>;
export type GetStructureForInspectionDataLoaderSuspenseQueryHookResult = ReturnType<typeof useGetStructureForInspectionDataLoaderSuspenseQuery>;
export type GetStructureForInspectionDataLoaderQueryResult = Apollo.QueryResult<GetStructureForInspectionDataLoaderQuery, GetStructureForInspectionDataLoaderQueryVariables>;
export const GetStructureLocationsForInspectionDataLoaderDocument = gql`
    query getStructureLocationsForInspectionDataLoader($structureId: ID!) {
  allLocations(structureId: $structureId) {
    id
    name
    resourcePath
    baseResourcePath
    angleResourcePath
    scanKey
    layers {
      fileExt
      type
      displayName
    }
    paintRegion {
      name
    }
    pose {
      yaw
      pitch
      roll
      z
      y
      x
      yawOffset
    }
    distance
    videoResourcePath
    videoTimestamp
    imageSensor {
      width
      height
      cx
      cy
      focalLength
    }
    deck {
      name
    }
  }
}
    `;

/**
 * __useGetStructureLocationsForInspectionDataLoaderQuery__
 *
 * To run a query within a React component, call `useGetStructureLocationsForInspectionDataLoaderQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetStructureLocationsForInspectionDataLoaderQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetStructureLocationsForInspectionDataLoaderQuery({
 *   variables: {
 *      structureId: // value for 'structureId'
 *   },
 * });
 */
export function useGetStructureLocationsForInspectionDataLoaderQuery(baseOptions: Apollo.QueryHookOptions<GetStructureLocationsForInspectionDataLoaderQuery, GetStructureLocationsForInspectionDataLoaderQueryVariables> & ({ variables: GetStructureLocationsForInspectionDataLoaderQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetStructureLocationsForInspectionDataLoaderQuery, GetStructureLocationsForInspectionDataLoaderQueryVariables>(GetStructureLocationsForInspectionDataLoaderDocument, options);
      }
export function useGetStructureLocationsForInspectionDataLoaderLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetStructureLocationsForInspectionDataLoaderQuery, GetStructureLocationsForInspectionDataLoaderQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetStructureLocationsForInspectionDataLoaderQuery, GetStructureLocationsForInspectionDataLoaderQueryVariables>(GetStructureLocationsForInspectionDataLoaderDocument, options);
        }
// @ts-ignore
export function useGetStructureLocationsForInspectionDataLoaderSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetStructureLocationsForInspectionDataLoaderQuery, GetStructureLocationsForInspectionDataLoaderQueryVariables>): Apollo.UseSuspenseQueryResult<GetStructureLocationsForInspectionDataLoaderQuery, GetStructureLocationsForInspectionDataLoaderQueryVariables>;
export function useGetStructureLocationsForInspectionDataLoaderSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetStructureLocationsForInspectionDataLoaderQuery, GetStructureLocationsForInspectionDataLoaderQueryVariables>): Apollo.UseSuspenseQueryResult<GetStructureLocationsForInspectionDataLoaderQuery | undefined, GetStructureLocationsForInspectionDataLoaderQueryVariables>;
export function useGetStructureLocationsForInspectionDataLoaderSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetStructureLocationsForInspectionDataLoaderQuery, GetStructureLocationsForInspectionDataLoaderQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetStructureLocationsForInspectionDataLoaderQuery, GetStructureLocationsForInspectionDataLoaderQueryVariables>(GetStructureLocationsForInspectionDataLoaderDocument, options);
        }
export type GetStructureLocationsForInspectionDataLoaderQueryHookResult = ReturnType<typeof useGetStructureLocationsForInspectionDataLoaderQuery>;
export type GetStructureLocationsForInspectionDataLoaderLazyQueryHookResult = ReturnType<typeof useGetStructureLocationsForInspectionDataLoaderLazyQuery>;
export type GetStructureLocationsForInspectionDataLoaderSuspenseQueryHookResult = ReturnType<typeof useGetStructureLocationsForInspectionDataLoaderSuspenseQuery>;
export type GetStructureLocationsForInspectionDataLoaderQueryResult = Apollo.QueryResult<GetStructureLocationsForInspectionDataLoaderQuery, GetStructureLocationsForInspectionDataLoaderQueryVariables>;
export const GetAllDecksDocument = gql`
    query getAllDecks($structureId: ID) {
  allDecks(structureId: $structureId) {
    cadFloorHeight
    id
    name
  }
}
    `;

/**
 * __useGetAllDecksQuery__
 *
 * To run a query within a React component, call `useGetAllDecksQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllDecksQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllDecksQuery({
 *   variables: {
 *      structureId: // value for 'structureId'
 *   },
 * });
 */
export function useGetAllDecksQuery(baseOptions?: Apollo.QueryHookOptions<GetAllDecksQuery, GetAllDecksQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllDecksQuery, GetAllDecksQueryVariables>(GetAllDecksDocument, options);
      }
export function useGetAllDecksLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllDecksQuery, GetAllDecksQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllDecksQuery, GetAllDecksQueryVariables>(GetAllDecksDocument, options);
        }
// @ts-ignore
export function useGetAllDecksSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetAllDecksQuery, GetAllDecksQueryVariables>): Apollo.UseSuspenseQueryResult<GetAllDecksQuery, GetAllDecksQueryVariables>;
export function useGetAllDecksSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAllDecksQuery, GetAllDecksQueryVariables>): Apollo.UseSuspenseQueryResult<GetAllDecksQuery | undefined, GetAllDecksQueryVariables>;
export function useGetAllDecksSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAllDecksQuery, GetAllDecksQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAllDecksQuery, GetAllDecksQueryVariables>(GetAllDecksDocument, options);
        }
export type GetAllDecksQueryHookResult = ReturnType<typeof useGetAllDecksQuery>;
export type GetAllDecksLazyQueryHookResult = ReturnType<typeof useGetAllDecksLazyQuery>;
export type GetAllDecksSuspenseQueryHookResult = ReturnType<typeof useGetAllDecksSuspenseQuery>;
export type GetAllDecksQueryResult = Apollo.QueryResult<GetAllDecksQuery, GetAllDecksQueryVariables>;
export const GetAllPointOfInterestTemplatesDocument = gql`
    query getAllPointOfInterestTemplates($structureId: ID!, $assemblyTemplateId: ID!) {
  allPointOfInterestTemplate(
    structureId: $structureId
    assemblyTemplateId: $assemblyTemplateId
  ) {
    id
    name
    type
    key
    isCsvUploadable
    icon {
      name
      color
    }
    accentColor
    fields {
      options
      optionsData {
        value
        weight
        min
        max
        minIncluded
        maxIncluded
      }
      name
      type
      id
      isReadOnly
      isHidden
      defaultVisible
      displayInQuery
      displayInTable
      displayInReview
      displayInReports
      serverSide
      isRequired
      key
      detailFieldKey
      isMeasurementToolEnabled
      displayConfig {
        id
        type
        isSortable
        sortType
        inputAdorment {
          iconPath
          iconType
          position
        }
        textAreaRows
        textFormat
      }
      unit
    }
    permissions
    markerLabelConfig {
      type
      hideName
      fields {
        key
        type
      }
      headerField {
        key
        type
      }
    }
    blisterFieldsConfig {
      estimatedHeight {
        name
        hidden
      }
      manualSetHeight {
        name
        hidden
      }
      blisterHeightIndex {
        name
        hidden
      }
      maxHeight {
        name
        hidden
      }
      wallLoss {
        name
        hidden
      }
      residualThickness {
        name
        hidden
      }
      residualCorrosionAllowance {
        name
        hidden
      }
      pdrHeight {
        name
        hidden
      }
      verifiedMaxHeight {
        name
        hidden
      }
      verifiedResidualThickness {
        name
        hidden
      }
      verifiedResidualCorrosionAllowance {
        name
        hidden
      }
      measurementConfidence {
        name
        hidden
      }
      distanceConfidence {
        name
        hidden
      }
    }
  }
}
    `;

/**
 * __useGetAllPointOfInterestTemplatesQuery__
 *
 * To run a query within a React component, call `useGetAllPointOfInterestTemplatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllPointOfInterestTemplatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllPointOfInterestTemplatesQuery({
 *   variables: {
 *      structureId: // value for 'structureId'
 *      assemblyTemplateId: // value for 'assemblyTemplateId'
 *   },
 * });
 */
export function useGetAllPointOfInterestTemplatesQuery(baseOptions: Apollo.QueryHookOptions<GetAllPointOfInterestTemplatesQuery, GetAllPointOfInterestTemplatesQueryVariables> & ({ variables: GetAllPointOfInterestTemplatesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllPointOfInterestTemplatesQuery, GetAllPointOfInterestTemplatesQueryVariables>(GetAllPointOfInterestTemplatesDocument, options);
      }
export function useGetAllPointOfInterestTemplatesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllPointOfInterestTemplatesQuery, GetAllPointOfInterestTemplatesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllPointOfInterestTemplatesQuery, GetAllPointOfInterestTemplatesQueryVariables>(GetAllPointOfInterestTemplatesDocument, options);
        }
// @ts-ignore
export function useGetAllPointOfInterestTemplatesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetAllPointOfInterestTemplatesQuery, GetAllPointOfInterestTemplatesQueryVariables>): Apollo.UseSuspenseQueryResult<GetAllPointOfInterestTemplatesQuery, GetAllPointOfInterestTemplatesQueryVariables>;
export function useGetAllPointOfInterestTemplatesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAllPointOfInterestTemplatesQuery, GetAllPointOfInterestTemplatesQueryVariables>): Apollo.UseSuspenseQueryResult<GetAllPointOfInterestTemplatesQuery | undefined, GetAllPointOfInterestTemplatesQueryVariables>;
export function useGetAllPointOfInterestTemplatesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAllPointOfInterestTemplatesQuery, GetAllPointOfInterestTemplatesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAllPointOfInterestTemplatesQuery, GetAllPointOfInterestTemplatesQueryVariables>(GetAllPointOfInterestTemplatesDocument, options);
        }
export type GetAllPointOfInterestTemplatesQueryHookResult = ReturnType<typeof useGetAllPointOfInterestTemplatesQuery>;
export type GetAllPointOfInterestTemplatesLazyQueryHookResult = ReturnType<typeof useGetAllPointOfInterestTemplatesLazyQuery>;
export type GetAllPointOfInterestTemplatesSuspenseQueryHookResult = ReturnType<typeof useGetAllPointOfInterestTemplatesSuspenseQuery>;
export type GetAllPointOfInterestTemplatesQueryResult = Apollo.QueryResult<GetAllPointOfInterestTemplatesQuery, GetAllPointOfInterestTemplatesQueryVariables>;
export const GetAllTemplatesForReportDocumentDocument = gql`
    query getAllTemplatesForReportDocument($structureId: ID!, $type: TemplateTypeEnum!) {
  allTemplates(structureId: $structureId, type: $type) {
    id
    name
    fields {
      options
      name
      type
      id
      isReadOnly
      isHidden
      defaultVisible
      displayConfig {
        id
        type
        isSortable
        sortType
        inputAdorment {
          iconPath
          iconType
          position
        }
        textAreaRows
        textFormat
      }
      unit
    }
    permissions
  }
}
    `;

/**
 * __useGetAllTemplatesForReportDocumentQuery__
 *
 * To run a query within a React component, call `useGetAllTemplatesForReportDocumentQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllTemplatesForReportDocumentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllTemplatesForReportDocumentQuery({
 *   variables: {
 *      structureId: // value for 'structureId'
 *      type: // value for 'type'
 *   },
 * });
 */
export function useGetAllTemplatesForReportDocumentQuery(baseOptions: Apollo.QueryHookOptions<GetAllTemplatesForReportDocumentQuery, GetAllTemplatesForReportDocumentQueryVariables> & ({ variables: GetAllTemplatesForReportDocumentQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllTemplatesForReportDocumentQuery, GetAllTemplatesForReportDocumentQueryVariables>(GetAllTemplatesForReportDocumentDocument, options);
      }
export function useGetAllTemplatesForReportDocumentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllTemplatesForReportDocumentQuery, GetAllTemplatesForReportDocumentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllTemplatesForReportDocumentQuery, GetAllTemplatesForReportDocumentQueryVariables>(GetAllTemplatesForReportDocumentDocument, options);
        }
// @ts-ignore
export function useGetAllTemplatesForReportDocumentSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetAllTemplatesForReportDocumentQuery, GetAllTemplatesForReportDocumentQueryVariables>): Apollo.UseSuspenseQueryResult<GetAllTemplatesForReportDocumentQuery, GetAllTemplatesForReportDocumentQueryVariables>;
export function useGetAllTemplatesForReportDocumentSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAllTemplatesForReportDocumentQuery, GetAllTemplatesForReportDocumentQueryVariables>): Apollo.UseSuspenseQueryResult<GetAllTemplatesForReportDocumentQuery | undefined, GetAllTemplatesForReportDocumentQueryVariables>;
export function useGetAllTemplatesForReportDocumentSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAllTemplatesForReportDocumentQuery, GetAllTemplatesForReportDocumentQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAllTemplatesForReportDocumentQuery, GetAllTemplatesForReportDocumentQueryVariables>(GetAllTemplatesForReportDocumentDocument, options);
        }
export type GetAllTemplatesForReportDocumentQueryHookResult = ReturnType<typeof useGetAllTemplatesForReportDocumentQuery>;
export type GetAllTemplatesForReportDocumentLazyQueryHookResult = ReturnType<typeof useGetAllTemplatesForReportDocumentLazyQuery>;
export type GetAllTemplatesForReportDocumentSuspenseQueryHookResult = ReturnType<typeof useGetAllTemplatesForReportDocumentSuspenseQuery>;
export type GetAllTemplatesForReportDocumentQueryResult = Apollo.QueryResult<GetAllTemplatesForReportDocumentQuery, GetAllTemplatesForReportDocumentQueryVariables>;
export const AllPointsOfInterestForInspectionDataLoaderDocument = gql`
    query AllPointsOfInterestForInspectionDataLoader($input: FindAllPointOfInterestsInput) {
  allPointOfInterests(input: $input) {
    id
    poiId
    type
    assignee
    dueDate
    status
    isVerified
    deckRelativeHeight
    workpackNumber
    paintRegion {
      name
    }
    templateId
    template {
      id
      fields {
        id
        name
        type
      }
    }
    location {
      id
    }
    name
    centerPoint3d {
      x
      y
      z
    }
    cameraLocation {
      x
      y
      z
    }
    assembly {
      id
      tagName
    }
    blister {
      maxHeight
      distanceConfidence
      measurementConfidence
      wallLoss {
        percentage
        value
      }
      residualCorrosionAllowance {
        percentage
        value
      }
      residualThickness {
        percentage
        value
      }
      centerPoint {
        bearing
        elevation
      }
      radiusPoint {
        bearing
        elevation
      }
      borders3d {
        points {
          x
          y
          z
        }
      }
      pdrHeight
      heightType
      isManuallyOverridden
      estimatedHeight
      manualSetHeight
      radius
      fittingRadius
      scCategory
    }
    templateData {
      id
      value
      verifiedValue
      templateFieldId
    }
    templateFieldData
    createdByUser {
      id
      name
      picture
      email
      connection
      roleIds {
        name
      }
    }
    createdAt
    screenshotPaths {
      viewer
      viewpoint
    }
    visibility
    teams {
      id
      name
    }
    remediationNote
    files {
      id
      name
      resourcePath
      type
      fileName
      uploadStatus
      imageType
      uuid
    }
    comment
    accessibility
    viewpointRelativeHeight
    cuboids {
      id
      position
      rotation
      scale
    }
  }
}
    `;

/**
 * __useAllPointsOfInterestForInspectionDataLoaderQuery__
 *
 * To run a query within a React component, call `useAllPointsOfInterestForInspectionDataLoaderQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllPointsOfInterestForInspectionDataLoaderQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllPointsOfInterestForInspectionDataLoaderQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAllPointsOfInterestForInspectionDataLoaderQuery(baseOptions?: Apollo.QueryHookOptions<AllPointsOfInterestForInspectionDataLoaderQuery, AllPointsOfInterestForInspectionDataLoaderQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AllPointsOfInterestForInspectionDataLoaderQuery, AllPointsOfInterestForInspectionDataLoaderQueryVariables>(AllPointsOfInterestForInspectionDataLoaderDocument, options);
      }
export function useAllPointsOfInterestForInspectionDataLoaderLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AllPointsOfInterestForInspectionDataLoaderQuery, AllPointsOfInterestForInspectionDataLoaderQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AllPointsOfInterestForInspectionDataLoaderQuery, AllPointsOfInterestForInspectionDataLoaderQueryVariables>(AllPointsOfInterestForInspectionDataLoaderDocument, options);
        }
// @ts-ignore
export function useAllPointsOfInterestForInspectionDataLoaderSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<AllPointsOfInterestForInspectionDataLoaderQuery, AllPointsOfInterestForInspectionDataLoaderQueryVariables>): Apollo.UseSuspenseQueryResult<AllPointsOfInterestForInspectionDataLoaderQuery, AllPointsOfInterestForInspectionDataLoaderQueryVariables>;
export function useAllPointsOfInterestForInspectionDataLoaderSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AllPointsOfInterestForInspectionDataLoaderQuery, AllPointsOfInterestForInspectionDataLoaderQueryVariables>): Apollo.UseSuspenseQueryResult<AllPointsOfInterestForInspectionDataLoaderQuery | undefined, AllPointsOfInterestForInspectionDataLoaderQueryVariables>;
export function useAllPointsOfInterestForInspectionDataLoaderSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AllPointsOfInterestForInspectionDataLoaderQuery, AllPointsOfInterestForInspectionDataLoaderQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AllPointsOfInterestForInspectionDataLoaderQuery, AllPointsOfInterestForInspectionDataLoaderQueryVariables>(AllPointsOfInterestForInspectionDataLoaderDocument, options);
        }
export type AllPointsOfInterestForInspectionDataLoaderQueryHookResult = ReturnType<typeof useAllPointsOfInterestForInspectionDataLoaderQuery>;
export type AllPointsOfInterestForInspectionDataLoaderLazyQueryHookResult = ReturnType<typeof useAllPointsOfInterestForInspectionDataLoaderLazyQuery>;
export type AllPointsOfInterestForInspectionDataLoaderSuspenseQueryHookResult = ReturnType<typeof useAllPointsOfInterestForInspectionDataLoaderSuspenseQuery>;
export type AllPointsOfInterestForInspectionDataLoaderQueryResult = Apollo.QueryResult<AllPointsOfInterestForInspectionDataLoaderQuery, AllPointsOfInterestForInspectionDataLoaderQueryVariables>;
export const AllPointOfInterestsForDataLoaderDocument = gql`
    query allPointOfInterestsForDataLoader($input: PointOfInterestInput, $pageInfo: PageInfo) {
  pointOfInterests(input: $input, pageInfo: $pageInfo) {
    id
    type
    name
    poiId
    status
    isVerified
    isGoverning
    createdAt
    accessibility
    dueDate
    paintRegion {
      name
    }
    locationId
    paintRegion {
      id
    }
    paintRegions {
      id
      name
    }
    blister {
      maxHeight
      heightType
      estimatedHeight
      pdrHeight
      isManuallyOverridden
      wallLoss {
        percentage
        value
      }
      residualCorrosionAllowance {
        percentage
        value
      }
      residualThickness {
        percentage
        value
      }
      borders3d {
        points {
          x
          y
          z
        }
      }
    }
    assembly {
      id
      tagName
    }
    templateId
    deckRelativeHeight
    workpack {
      id
    }
    workpackNumber
    centerPoint3d {
      x
      y
      z
    }
    cuboids {
      id
      position
      rotation
      scale
    }
    templateFieldData
    visibility
    createdByUser {
      id
      name
      picture
      email
      connection
      roleIds {
        name
      }
    }
    location {
      id
      name
    }
    files {
      id
      name
      resourcePath
      type
      fileName
      uploadStatus
      caption
      imageType
      uuid
    }
    screenshotPaths {
      viewer
      viewpoint
    }
    accessibility
    viewpointRelativeHeight
  }
}
    `;

/**
 * __useAllPointOfInterestsForDataLoaderQuery__
 *
 * To run a query within a React component, call `useAllPointOfInterestsForDataLoaderQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllPointOfInterestsForDataLoaderQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllPointOfInterestsForDataLoaderQuery({
 *   variables: {
 *      input: // value for 'input'
 *      pageInfo: // value for 'pageInfo'
 *   },
 * });
 */
export function useAllPointOfInterestsForDataLoaderQuery(baseOptions?: Apollo.QueryHookOptions<AllPointOfInterestsForDataLoaderQuery, AllPointOfInterestsForDataLoaderQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AllPointOfInterestsForDataLoaderQuery, AllPointOfInterestsForDataLoaderQueryVariables>(AllPointOfInterestsForDataLoaderDocument, options);
      }
export function useAllPointOfInterestsForDataLoaderLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AllPointOfInterestsForDataLoaderQuery, AllPointOfInterestsForDataLoaderQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AllPointOfInterestsForDataLoaderQuery, AllPointOfInterestsForDataLoaderQueryVariables>(AllPointOfInterestsForDataLoaderDocument, options);
        }
// @ts-ignore
export function useAllPointOfInterestsForDataLoaderSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<AllPointOfInterestsForDataLoaderQuery, AllPointOfInterestsForDataLoaderQueryVariables>): Apollo.UseSuspenseQueryResult<AllPointOfInterestsForDataLoaderQuery, AllPointOfInterestsForDataLoaderQueryVariables>;
export function useAllPointOfInterestsForDataLoaderSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AllPointOfInterestsForDataLoaderQuery, AllPointOfInterestsForDataLoaderQueryVariables>): Apollo.UseSuspenseQueryResult<AllPointOfInterestsForDataLoaderQuery | undefined, AllPointOfInterestsForDataLoaderQueryVariables>;
export function useAllPointOfInterestsForDataLoaderSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AllPointOfInterestsForDataLoaderQuery, AllPointOfInterestsForDataLoaderQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AllPointOfInterestsForDataLoaderQuery, AllPointOfInterestsForDataLoaderQueryVariables>(AllPointOfInterestsForDataLoaderDocument, options);
        }
export type AllPointOfInterestsForDataLoaderQueryHookResult = ReturnType<typeof useAllPointOfInterestsForDataLoaderQuery>;
export type AllPointOfInterestsForDataLoaderLazyQueryHookResult = ReturnType<typeof useAllPointOfInterestsForDataLoaderLazyQuery>;
export type AllPointOfInterestsForDataLoaderSuspenseQueryHookResult = ReturnType<typeof useAllPointOfInterestsForDataLoaderSuspenseQuery>;
export type AllPointOfInterestsForDataLoaderQueryResult = Apollo.QueryResult<AllPointOfInterestsForDataLoaderQuery, AllPointOfInterestsForDataLoaderQueryVariables>;
export const GetStructureRelationshipsForAnalysisDataLoaderDocument = gql`
    query getStructureRelationshipsForAnalysisDataLoader($structureId: String!) {
  allAnnotations(structureId: $structureId) {
    id
    annotationId
    partId
    locationId
  }
  allParts(structureId: $structureId) {
    id
    assemblyId
    class
  }
  allAssemblies(structureId: $structureId) {
    id
    tagName
    integerId
  }
}
    `;

/**
 * __useGetStructureRelationshipsForAnalysisDataLoaderQuery__
 *
 * To run a query within a React component, call `useGetStructureRelationshipsForAnalysisDataLoaderQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetStructureRelationshipsForAnalysisDataLoaderQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetStructureRelationshipsForAnalysisDataLoaderQuery({
 *   variables: {
 *      structureId: // value for 'structureId'
 *   },
 * });
 */
export function useGetStructureRelationshipsForAnalysisDataLoaderQuery(baseOptions: Apollo.QueryHookOptions<GetStructureRelationshipsForAnalysisDataLoaderQuery, GetStructureRelationshipsForAnalysisDataLoaderQueryVariables> & ({ variables: GetStructureRelationshipsForAnalysisDataLoaderQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetStructureRelationshipsForAnalysisDataLoaderQuery, GetStructureRelationshipsForAnalysisDataLoaderQueryVariables>(GetStructureRelationshipsForAnalysisDataLoaderDocument, options);
      }
export function useGetStructureRelationshipsForAnalysisDataLoaderLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetStructureRelationshipsForAnalysisDataLoaderQuery, GetStructureRelationshipsForAnalysisDataLoaderQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetStructureRelationshipsForAnalysisDataLoaderQuery, GetStructureRelationshipsForAnalysisDataLoaderQueryVariables>(GetStructureRelationshipsForAnalysisDataLoaderDocument, options);
        }
// @ts-ignore
export function useGetStructureRelationshipsForAnalysisDataLoaderSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetStructureRelationshipsForAnalysisDataLoaderQuery, GetStructureRelationshipsForAnalysisDataLoaderQueryVariables>): Apollo.UseSuspenseQueryResult<GetStructureRelationshipsForAnalysisDataLoaderQuery, GetStructureRelationshipsForAnalysisDataLoaderQueryVariables>;
export function useGetStructureRelationshipsForAnalysisDataLoaderSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetStructureRelationshipsForAnalysisDataLoaderQuery, GetStructureRelationshipsForAnalysisDataLoaderQueryVariables>): Apollo.UseSuspenseQueryResult<GetStructureRelationshipsForAnalysisDataLoaderQuery | undefined, GetStructureRelationshipsForAnalysisDataLoaderQueryVariables>;
export function useGetStructureRelationshipsForAnalysisDataLoaderSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetStructureRelationshipsForAnalysisDataLoaderQuery, GetStructureRelationshipsForAnalysisDataLoaderQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetStructureRelationshipsForAnalysisDataLoaderQuery, GetStructureRelationshipsForAnalysisDataLoaderQueryVariables>(GetStructureRelationshipsForAnalysisDataLoaderDocument, options);
        }
export type GetStructureRelationshipsForAnalysisDataLoaderQueryHookResult = ReturnType<typeof useGetStructureRelationshipsForAnalysisDataLoaderQuery>;
export type GetStructureRelationshipsForAnalysisDataLoaderLazyQueryHookResult = ReturnType<typeof useGetStructureRelationshipsForAnalysisDataLoaderLazyQuery>;
export type GetStructureRelationshipsForAnalysisDataLoaderSuspenseQueryHookResult = ReturnType<typeof useGetStructureRelationshipsForAnalysisDataLoaderSuspenseQuery>;
export type GetStructureRelationshipsForAnalysisDataLoaderQueryResult = Apollo.QueryResult<GetStructureRelationshipsForAnalysisDataLoaderQuery, GetStructureRelationshipsForAnalysisDataLoaderQueryVariables>;
export const UpdateAssemblyDocument = gql`
    mutation updateAssembly($input: UpdateAssemblyInput) {
  updateAssembly(input: $input) {
    id
    templateFieldData
  }
}
    `;
export type UpdateAssemblyMutationFn = Apollo.MutationFunction<UpdateAssemblyMutation, UpdateAssemblyMutationVariables>;

/**
 * __useUpdateAssemblyMutation__
 *
 * To run a mutation, you first call `useUpdateAssemblyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAssemblyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAssemblyMutation, { data, loading, error }] = useUpdateAssemblyMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateAssemblyMutation(baseOptions?: Apollo.MutationHookOptions<UpdateAssemblyMutation, UpdateAssemblyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateAssemblyMutation, UpdateAssemblyMutationVariables>(UpdateAssemblyDocument, options);
      }
export type UpdateAssemblyMutationHookResult = ReturnType<typeof useUpdateAssemblyMutation>;
export type UpdateAssemblyMutationResult = Apollo.MutationResult<UpdateAssemblyMutation>;
export type UpdateAssemblyMutationOptions = Apollo.BaseMutationOptions<UpdateAssemblyMutation, UpdateAssemblyMutationVariables>;
export const GetAssemblyPipeSpecDocument = gql`
    query getAssemblyPipeSpec($assemblyId: String!) {
  assembly(assemblyId: $assemblyId) {
    id
    pipeSpec {
      size
      material
      spec
      nominalCorrosionAllowance
      schedule
      nominalThickness
    }
  }
}
    `;

/**
 * __useGetAssemblyPipeSpecQuery__
 *
 * To run a query within a React component, call `useGetAssemblyPipeSpecQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAssemblyPipeSpecQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAssemblyPipeSpecQuery({
 *   variables: {
 *      assemblyId: // value for 'assemblyId'
 *   },
 * });
 */
export function useGetAssemblyPipeSpecQuery(baseOptions: Apollo.QueryHookOptions<GetAssemblyPipeSpecQuery, GetAssemblyPipeSpecQueryVariables> & ({ variables: GetAssemblyPipeSpecQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAssemblyPipeSpecQuery, GetAssemblyPipeSpecQueryVariables>(GetAssemblyPipeSpecDocument, options);
      }
export function useGetAssemblyPipeSpecLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAssemblyPipeSpecQuery, GetAssemblyPipeSpecQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAssemblyPipeSpecQuery, GetAssemblyPipeSpecQueryVariables>(GetAssemblyPipeSpecDocument, options);
        }
// @ts-ignore
export function useGetAssemblyPipeSpecSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetAssemblyPipeSpecQuery, GetAssemblyPipeSpecQueryVariables>): Apollo.UseSuspenseQueryResult<GetAssemblyPipeSpecQuery, GetAssemblyPipeSpecQueryVariables>;
export function useGetAssemblyPipeSpecSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAssemblyPipeSpecQuery, GetAssemblyPipeSpecQueryVariables>): Apollo.UseSuspenseQueryResult<GetAssemblyPipeSpecQuery | undefined, GetAssemblyPipeSpecQueryVariables>;
export function useGetAssemblyPipeSpecSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAssemblyPipeSpecQuery, GetAssemblyPipeSpecQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAssemblyPipeSpecQuery, GetAssemblyPipeSpecQueryVariables>(GetAssemblyPipeSpecDocument, options);
        }
export type GetAssemblyPipeSpecQueryHookResult = ReturnType<typeof useGetAssemblyPipeSpecQuery>;
export type GetAssemblyPipeSpecLazyQueryHookResult = ReturnType<typeof useGetAssemblyPipeSpecLazyQuery>;
export type GetAssemblyPipeSpecSuspenseQueryHookResult = ReturnType<typeof useGetAssemblyPipeSpecSuspenseQuery>;
export type GetAssemblyPipeSpecQueryResult = Apollo.QueryResult<GetAssemblyPipeSpecQuery, GetAssemblyPipeSpecQueryVariables>;
export const GetAssemblyAlarmLevelDocument = gql`
    query getAssemblyAlarmLevel($assemblyId: String!) {
  assembly(assemblyId: $assemblyId) {
    id
    recommendation {
      analysisRecommendation {
        alarmLevel
        wasAnalysisAlarmLevelManuallySet
      }
    }
  }
}
    `;

/**
 * __useGetAssemblyAlarmLevelQuery__
 *
 * To run a query within a React component, call `useGetAssemblyAlarmLevelQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAssemblyAlarmLevelQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAssemblyAlarmLevelQuery({
 *   variables: {
 *      assemblyId: // value for 'assemblyId'
 *   },
 * });
 */
export function useGetAssemblyAlarmLevelQuery(baseOptions: Apollo.QueryHookOptions<GetAssemblyAlarmLevelQuery, GetAssemblyAlarmLevelQueryVariables> & ({ variables: GetAssemblyAlarmLevelQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAssemblyAlarmLevelQuery, GetAssemblyAlarmLevelQueryVariables>(GetAssemblyAlarmLevelDocument, options);
      }
export function useGetAssemblyAlarmLevelLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAssemblyAlarmLevelQuery, GetAssemblyAlarmLevelQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAssemblyAlarmLevelQuery, GetAssemblyAlarmLevelQueryVariables>(GetAssemblyAlarmLevelDocument, options);
        }
// @ts-ignore
export function useGetAssemblyAlarmLevelSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetAssemblyAlarmLevelQuery, GetAssemblyAlarmLevelQueryVariables>): Apollo.UseSuspenseQueryResult<GetAssemblyAlarmLevelQuery, GetAssemblyAlarmLevelQueryVariables>;
export function useGetAssemblyAlarmLevelSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAssemblyAlarmLevelQuery, GetAssemblyAlarmLevelQueryVariables>): Apollo.UseSuspenseQueryResult<GetAssemblyAlarmLevelQuery | undefined, GetAssemblyAlarmLevelQueryVariables>;
export function useGetAssemblyAlarmLevelSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAssemblyAlarmLevelQuery, GetAssemblyAlarmLevelQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAssemblyAlarmLevelQuery, GetAssemblyAlarmLevelQueryVariables>(GetAssemblyAlarmLevelDocument, options);
        }
export type GetAssemblyAlarmLevelQueryHookResult = ReturnType<typeof useGetAssemblyAlarmLevelQuery>;
export type GetAssemblyAlarmLevelLazyQueryHookResult = ReturnType<typeof useGetAssemblyAlarmLevelLazyQuery>;
export type GetAssemblyAlarmLevelSuspenseQueryHookResult = ReturnType<typeof useGetAssemblyAlarmLevelSuspenseQuery>;
export type GetAssemblyAlarmLevelQueryResult = Apollo.QueryResult<GetAssemblyAlarmLevelQuery, GetAssemblyAlarmLevelQueryVariables>;
export const FindAssemblyForViewPointsDocument = gql`
    query FindAssemblyForViewPoints($assemblyId: String) {
  assembly(assemblyId: $assemblyId) {
    id
    seenByViewpoints {
      analysed {
        analysedBy
      }
      location {
        id
      }
      focalPoint {
        x
        y
        z
      }
    }
  }
}
    `;

/**
 * __useFindAssemblyForViewPointsQuery__
 *
 * To run a query within a React component, call `useFindAssemblyForViewPointsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindAssemblyForViewPointsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindAssemblyForViewPointsQuery({
 *   variables: {
 *      assemblyId: // value for 'assemblyId'
 *   },
 * });
 */
export function useFindAssemblyForViewPointsQuery(baseOptions?: Apollo.QueryHookOptions<FindAssemblyForViewPointsQuery, FindAssemblyForViewPointsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FindAssemblyForViewPointsQuery, FindAssemblyForViewPointsQueryVariables>(FindAssemblyForViewPointsDocument, options);
      }
export function useFindAssemblyForViewPointsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FindAssemblyForViewPointsQuery, FindAssemblyForViewPointsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FindAssemblyForViewPointsQuery, FindAssemblyForViewPointsQueryVariables>(FindAssemblyForViewPointsDocument, options);
        }
// @ts-ignore
export function useFindAssemblyForViewPointsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<FindAssemblyForViewPointsQuery, FindAssemblyForViewPointsQueryVariables>): Apollo.UseSuspenseQueryResult<FindAssemblyForViewPointsQuery, FindAssemblyForViewPointsQueryVariables>;
export function useFindAssemblyForViewPointsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FindAssemblyForViewPointsQuery, FindAssemblyForViewPointsQueryVariables>): Apollo.UseSuspenseQueryResult<FindAssemblyForViewPointsQuery | undefined, FindAssemblyForViewPointsQueryVariables>;
export function useFindAssemblyForViewPointsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FindAssemblyForViewPointsQuery, FindAssemblyForViewPointsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FindAssemblyForViewPointsQuery, FindAssemblyForViewPointsQueryVariables>(FindAssemblyForViewPointsDocument, options);
        }
export type FindAssemblyForViewPointsQueryHookResult = ReturnType<typeof useFindAssemblyForViewPointsQuery>;
export type FindAssemblyForViewPointsLazyQueryHookResult = ReturnType<typeof useFindAssemblyForViewPointsLazyQuery>;
export type FindAssemblyForViewPointsSuspenseQueryHookResult = ReturnType<typeof useFindAssemblyForViewPointsSuspenseQuery>;
export type FindAssemblyForViewPointsQueryResult = Apollo.QueryResult<FindAssemblyForViewPointsQuery, FindAssemblyForViewPointsQueryVariables>;
export const PaintBlockTemplateDocument = gql`
    query PaintBlockTemplate($structureId: ID, $type: TemplateTypeEnum) {
  allTemplates(structureId: $structureId, type: $type) {
    id
    fields {
      id
      name
      key
    }
  }
}
    `;

/**
 * __usePaintBlockTemplateQuery__
 *
 * To run a query within a React component, call `usePaintBlockTemplateQuery` and pass it any options that fit your needs.
 * When your component renders, `usePaintBlockTemplateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePaintBlockTemplateQuery({
 *   variables: {
 *      structureId: // value for 'structureId'
 *      type: // value for 'type'
 *   },
 * });
 */
export function usePaintBlockTemplateQuery(baseOptions?: Apollo.QueryHookOptions<PaintBlockTemplateQuery, PaintBlockTemplateQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PaintBlockTemplateQuery, PaintBlockTemplateQueryVariables>(PaintBlockTemplateDocument, options);
      }
export function usePaintBlockTemplateLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PaintBlockTemplateQuery, PaintBlockTemplateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PaintBlockTemplateQuery, PaintBlockTemplateQueryVariables>(PaintBlockTemplateDocument, options);
        }
// @ts-ignore
export function usePaintBlockTemplateSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<PaintBlockTemplateQuery, PaintBlockTemplateQueryVariables>): Apollo.UseSuspenseQueryResult<PaintBlockTemplateQuery, PaintBlockTemplateQueryVariables>;
export function usePaintBlockTemplateSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PaintBlockTemplateQuery, PaintBlockTemplateQueryVariables>): Apollo.UseSuspenseQueryResult<PaintBlockTemplateQuery | undefined, PaintBlockTemplateQueryVariables>;
export function usePaintBlockTemplateSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PaintBlockTemplateQuery, PaintBlockTemplateQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PaintBlockTemplateQuery, PaintBlockTemplateQueryVariables>(PaintBlockTemplateDocument, options);
        }
export type PaintBlockTemplateQueryHookResult = ReturnType<typeof usePaintBlockTemplateQuery>;
export type PaintBlockTemplateLazyQueryHookResult = ReturnType<typeof usePaintBlockTemplateLazyQuery>;
export type PaintBlockTemplateSuspenseQueryHookResult = ReturnType<typeof usePaintBlockTemplateSuspenseQuery>;
export type PaintBlockTemplateQueryResult = Apollo.QueryResult<PaintBlockTemplateQuery, PaintBlockTemplateQueryVariables>;
export const PaintBlockPointsDocument = gql`
    query PaintBlockPoints($paintRegionId: String) {
  paintRegion(paintRegionId: $paintRegionId) {
    volume {
      exclusions {
        xy_polygon
        z_range
      }
      inclusion {
        z_range
        xy_polygon
      }
    }
    files {
      id
      name
      resourcePath
      type
      fileName
      uploadStatus
      imageType
      uuid
    }
  }
}
    `;

/**
 * __usePaintBlockPointsQuery__
 *
 * To run a query within a React component, call `usePaintBlockPointsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePaintBlockPointsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePaintBlockPointsQuery({
 *   variables: {
 *      paintRegionId: // value for 'paintRegionId'
 *   },
 * });
 */
export function usePaintBlockPointsQuery(baseOptions?: Apollo.QueryHookOptions<PaintBlockPointsQuery, PaintBlockPointsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PaintBlockPointsQuery, PaintBlockPointsQueryVariables>(PaintBlockPointsDocument, options);
      }
export function usePaintBlockPointsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PaintBlockPointsQuery, PaintBlockPointsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PaintBlockPointsQuery, PaintBlockPointsQueryVariables>(PaintBlockPointsDocument, options);
        }
// @ts-ignore
export function usePaintBlockPointsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<PaintBlockPointsQuery, PaintBlockPointsQueryVariables>): Apollo.UseSuspenseQueryResult<PaintBlockPointsQuery, PaintBlockPointsQueryVariables>;
export function usePaintBlockPointsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PaintBlockPointsQuery, PaintBlockPointsQueryVariables>): Apollo.UseSuspenseQueryResult<PaintBlockPointsQuery | undefined, PaintBlockPointsQueryVariables>;
export function usePaintBlockPointsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PaintBlockPointsQuery, PaintBlockPointsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PaintBlockPointsQuery, PaintBlockPointsQueryVariables>(PaintBlockPointsDocument, options);
        }
export type PaintBlockPointsQueryHookResult = ReturnType<typeof usePaintBlockPointsQuery>;
export type PaintBlockPointsLazyQueryHookResult = ReturnType<typeof usePaintBlockPointsLazyQuery>;
export type PaintBlockPointsSuspenseQueryHookResult = ReturnType<typeof usePaintBlockPointsSuspenseQuery>;
export type PaintBlockPointsQueryResult = Apollo.QueryResult<PaintBlockPointsQuery, PaintBlockPointsQueryVariables>;
export const PaintRegionGroupsDocument = gql`
    query PaintRegionGroups($input: PaintRegionGroupFiltersInput!) {
  paintRegionGroups(input: $input) {
    name
    id
    isDefault
  }
}
    `;

/**
 * __usePaintRegionGroupsQuery__
 *
 * To run a query within a React component, call `usePaintRegionGroupsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePaintRegionGroupsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePaintRegionGroupsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePaintRegionGroupsQuery(baseOptions: Apollo.QueryHookOptions<PaintRegionGroupsQuery, PaintRegionGroupsQueryVariables> & ({ variables: PaintRegionGroupsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PaintRegionGroupsQuery, PaintRegionGroupsQueryVariables>(PaintRegionGroupsDocument, options);
      }
export function usePaintRegionGroupsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PaintRegionGroupsQuery, PaintRegionGroupsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PaintRegionGroupsQuery, PaintRegionGroupsQueryVariables>(PaintRegionGroupsDocument, options);
        }
// @ts-ignore
export function usePaintRegionGroupsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<PaintRegionGroupsQuery, PaintRegionGroupsQueryVariables>): Apollo.UseSuspenseQueryResult<PaintRegionGroupsQuery, PaintRegionGroupsQueryVariables>;
export function usePaintRegionGroupsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PaintRegionGroupsQuery, PaintRegionGroupsQueryVariables>): Apollo.UseSuspenseQueryResult<PaintRegionGroupsQuery | undefined, PaintRegionGroupsQueryVariables>;
export function usePaintRegionGroupsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PaintRegionGroupsQuery, PaintRegionGroupsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PaintRegionGroupsQuery, PaintRegionGroupsQueryVariables>(PaintRegionGroupsDocument, options);
        }
export type PaintRegionGroupsQueryHookResult = ReturnType<typeof usePaintRegionGroupsQuery>;
export type PaintRegionGroupsLazyQueryHookResult = ReturnType<typeof usePaintRegionGroupsLazyQuery>;
export type PaintRegionGroupsSuspenseQueryHookResult = ReturnType<typeof usePaintRegionGroupsSuspenseQuery>;
export type PaintRegionGroupsQueryResult = Apollo.QueryResult<PaintRegionGroupsQuery, PaintRegionGroupsQueryVariables>;
export const SavedBlockPoIsDocument = gql`
    query SavedBlockPOIs($input: PointOfInterestInput, $pageInfo: PageInfo) {
  pointOfInterests(input: $input, pageInfo: $pageInfo) {
    id
    poiId
    type
    name
    paintRegion {
      id
      deck {
        id
        cadTransform
      }
    }
    template {
      id
      fields {
        id
        name
        key
        type
        unit
      }
    }
    templateFieldData
    workpackNumber
  }
  pointOfInterestsCount(input: $input) {
    count
  }
}
    `;

/**
 * __useSavedBlockPoIsQuery__
 *
 * To run a query within a React component, call `useSavedBlockPoIsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSavedBlockPoIsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSavedBlockPoIsQuery({
 *   variables: {
 *      input: // value for 'input'
 *      pageInfo: // value for 'pageInfo'
 *   },
 * });
 */
export function useSavedBlockPoIsQuery(baseOptions?: Apollo.QueryHookOptions<SavedBlockPoIsQuery, SavedBlockPoIsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SavedBlockPoIsQuery, SavedBlockPoIsQueryVariables>(SavedBlockPoIsDocument, options);
      }
export function useSavedBlockPoIsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SavedBlockPoIsQuery, SavedBlockPoIsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SavedBlockPoIsQuery, SavedBlockPoIsQueryVariables>(SavedBlockPoIsDocument, options);
        }
// @ts-ignore
export function useSavedBlockPoIsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<SavedBlockPoIsQuery, SavedBlockPoIsQueryVariables>): Apollo.UseSuspenseQueryResult<SavedBlockPoIsQuery, SavedBlockPoIsQueryVariables>;
export function useSavedBlockPoIsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SavedBlockPoIsQuery, SavedBlockPoIsQueryVariables>): Apollo.UseSuspenseQueryResult<SavedBlockPoIsQuery | undefined, SavedBlockPoIsQueryVariables>;
export function useSavedBlockPoIsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SavedBlockPoIsQuery, SavedBlockPoIsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SavedBlockPoIsQuery, SavedBlockPoIsQueryVariables>(SavedBlockPoIsDocument, options);
        }
export type SavedBlockPoIsQueryHookResult = ReturnType<typeof useSavedBlockPoIsQuery>;
export type SavedBlockPoIsLazyQueryHookResult = ReturnType<typeof useSavedBlockPoIsLazyQuery>;
export type SavedBlockPoIsSuspenseQueryHookResult = ReturnType<typeof useSavedBlockPoIsSuspenseQuery>;
export type SavedBlockPoIsQueryResult = Apollo.QueryResult<SavedBlockPoIsQuery, SavedBlockPoIsQueryVariables>;
export const PointOfInterestCuboidsDocument = gql`
    query PointOfInterestCuboids($pointOfInterestId: ID!) {
  pointOfInterest(pointOfInterestId: $pointOfInterestId) {
    id
    status
    cuboids {
      id
      position
      rotation
      scale
    }
  }
}
    `;

/**
 * __usePointOfInterestCuboidsQuery__
 *
 * To run a query within a React component, call `usePointOfInterestCuboidsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePointOfInterestCuboidsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePointOfInterestCuboidsQuery({
 *   variables: {
 *      pointOfInterestId: // value for 'pointOfInterestId'
 *   },
 * });
 */
export function usePointOfInterestCuboidsQuery(baseOptions: Apollo.QueryHookOptions<PointOfInterestCuboidsQuery, PointOfInterestCuboidsQueryVariables> & ({ variables: PointOfInterestCuboidsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PointOfInterestCuboidsQuery, PointOfInterestCuboidsQueryVariables>(PointOfInterestCuboidsDocument, options);
      }
export function usePointOfInterestCuboidsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PointOfInterestCuboidsQuery, PointOfInterestCuboidsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PointOfInterestCuboidsQuery, PointOfInterestCuboidsQueryVariables>(PointOfInterestCuboidsDocument, options);
        }
// @ts-ignore
export function usePointOfInterestCuboidsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<PointOfInterestCuboidsQuery, PointOfInterestCuboidsQueryVariables>): Apollo.UseSuspenseQueryResult<PointOfInterestCuboidsQuery, PointOfInterestCuboidsQueryVariables>;
export function usePointOfInterestCuboidsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PointOfInterestCuboidsQuery, PointOfInterestCuboidsQueryVariables>): Apollo.UseSuspenseQueryResult<PointOfInterestCuboidsQuery | undefined, PointOfInterestCuboidsQueryVariables>;
export function usePointOfInterestCuboidsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PointOfInterestCuboidsQuery, PointOfInterestCuboidsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PointOfInterestCuboidsQuery, PointOfInterestCuboidsQueryVariables>(PointOfInterestCuboidsDocument, options);
        }
export type PointOfInterestCuboidsQueryHookResult = ReturnType<typeof usePointOfInterestCuboidsQuery>;
export type PointOfInterestCuboidsLazyQueryHookResult = ReturnType<typeof usePointOfInterestCuboidsLazyQuery>;
export type PointOfInterestCuboidsSuspenseQueryHookResult = ReturnType<typeof usePointOfInterestCuboidsSuspenseQuery>;
export type PointOfInterestCuboidsQueryResult = Apollo.QueryResult<PointOfInterestCuboidsQuery, PointOfInterestCuboidsQueryVariables>;
export const GetAllAnnotationInLocationDocument = gql`
    query getAllAnnotationInLocation($locationId: String, $structureId: String) {
  allAnnotations(locationId: $locationId, structureId: $structureId) {
    annotationId
    id
  }
}
    `;

/**
 * __useGetAllAnnotationInLocationQuery__
 *
 * To run a query within a React component, call `useGetAllAnnotationInLocationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllAnnotationInLocationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllAnnotationInLocationQuery({
 *   variables: {
 *      locationId: // value for 'locationId'
 *      structureId: // value for 'structureId'
 *   },
 * });
 */
export function useGetAllAnnotationInLocationQuery(baseOptions?: Apollo.QueryHookOptions<GetAllAnnotationInLocationQuery, GetAllAnnotationInLocationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllAnnotationInLocationQuery, GetAllAnnotationInLocationQueryVariables>(GetAllAnnotationInLocationDocument, options);
      }
export function useGetAllAnnotationInLocationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllAnnotationInLocationQuery, GetAllAnnotationInLocationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllAnnotationInLocationQuery, GetAllAnnotationInLocationQueryVariables>(GetAllAnnotationInLocationDocument, options);
        }
// @ts-ignore
export function useGetAllAnnotationInLocationSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetAllAnnotationInLocationQuery, GetAllAnnotationInLocationQueryVariables>): Apollo.UseSuspenseQueryResult<GetAllAnnotationInLocationQuery, GetAllAnnotationInLocationQueryVariables>;
export function useGetAllAnnotationInLocationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAllAnnotationInLocationQuery, GetAllAnnotationInLocationQueryVariables>): Apollo.UseSuspenseQueryResult<GetAllAnnotationInLocationQuery | undefined, GetAllAnnotationInLocationQueryVariables>;
export function useGetAllAnnotationInLocationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAllAnnotationInLocationQuery, GetAllAnnotationInLocationQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAllAnnotationInLocationQuery, GetAllAnnotationInLocationQueryVariables>(GetAllAnnotationInLocationDocument, options);
        }
export type GetAllAnnotationInLocationQueryHookResult = ReturnType<typeof useGetAllAnnotationInLocationQuery>;
export type GetAllAnnotationInLocationLazyQueryHookResult = ReturnType<typeof useGetAllAnnotationInLocationLazyQuery>;
export type GetAllAnnotationInLocationSuspenseQueryHookResult = ReturnType<typeof useGetAllAnnotationInLocationSuspenseQuery>;
export type GetAllAnnotationInLocationQueryResult = Apollo.QueryResult<GetAllAnnotationInLocationQuery, GetAllAnnotationInLocationQueryVariables>;
export const GetAbyssViewerColoursForAnalysisDocument = gql`
    query getAbyssViewerColoursForAnalysis($type: SettingTypesEnum!) {
  setting(type: $type) {
    id
    name
    type
    revision
    meta {
      __typename
      ... on StringMeta {
        key
        colour: value
      }
      ... on StringArrayMeta {
        key
        value
      }
    }
  }
}
    `;

/**
 * __useGetAbyssViewerColoursForAnalysisQuery__
 *
 * To run a query within a React component, call `useGetAbyssViewerColoursForAnalysisQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAbyssViewerColoursForAnalysisQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAbyssViewerColoursForAnalysisQuery({
 *   variables: {
 *      type: // value for 'type'
 *   },
 * });
 */
export function useGetAbyssViewerColoursForAnalysisQuery(baseOptions: Apollo.QueryHookOptions<GetAbyssViewerColoursForAnalysisQuery, GetAbyssViewerColoursForAnalysisQueryVariables> & ({ variables: GetAbyssViewerColoursForAnalysisQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAbyssViewerColoursForAnalysisQuery, GetAbyssViewerColoursForAnalysisQueryVariables>(GetAbyssViewerColoursForAnalysisDocument, options);
      }
export function useGetAbyssViewerColoursForAnalysisLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAbyssViewerColoursForAnalysisQuery, GetAbyssViewerColoursForAnalysisQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAbyssViewerColoursForAnalysisQuery, GetAbyssViewerColoursForAnalysisQueryVariables>(GetAbyssViewerColoursForAnalysisDocument, options);
        }
// @ts-ignore
export function useGetAbyssViewerColoursForAnalysisSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetAbyssViewerColoursForAnalysisQuery, GetAbyssViewerColoursForAnalysisQueryVariables>): Apollo.UseSuspenseQueryResult<GetAbyssViewerColoursForAnalysisQuery, GetAbyssViewerColoursForAnalysisQueryVariables>;
export function useGetAbyssViewerColoursForAnalysisSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAbyssViewerColoursForAnalysisQuery, GetAbyssViewerColoursForAnalysisQueryVariables>): Apollo.UseSuspenseQueryResult<GetAbyssViewerColoursForAnalysisQuery | undefined, GetAbyssViewerColoursForAnalysisQueryVariables>;
export function useGetAbyssViewerColoursForAnalysisSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAbyssViewerColoursForAnalysisQuery, GetAbyssViewerColoursForAnalysisQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAbyssViewerColoursForAnalysisQuery, GetAbyssViewerColoursForAnalysisQueryVariables>(GetAbyssViewerColoursForAnalysisDocument, options);
        }
export type GetAbyssViewerColoursForAnalysisQueryHookResult = ReturnType<typeof useGetAbyssViewerColoursForAnalysisQuery>;
export type GetAbyssViewerColoursForAnalysisLazyQueryHookResult = ReturnType<typeof useGetAbyssViewerColoursForAnalysisLazyQuery>;
export type GetAbyssViewerColoursForAnalysisSuspenseQueryHookResult = ReturnType<typeof useGetAbyssViewerColoursForAnalysisSuspenseQuery>;
export type GetAbyssViewerColoursForAnalysisQueryResult = Apollo.QueryResult<GetAbyssViewerColoursForAnalysisQuery, GetAbyssViewerColoursForAnalysisQueryVariables>;
export const GetDefectColoursDocument = gql`
    query getDefectColours($type: SettingTypesEnum!) {
  setting(type: $type) {
    id
    name
    type
    revision
    meta {
      __typename
      ... on DefectColorMeta {
        key
        value {
          octreeIndex
          name
          colour
        }
      }
    }
  }
}
    `;

/**
 * __useGetDefectColoursQuery__
 *
 * To run a query within a React component, call `useGetDefectColoursQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDefectColoursQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDefectColoursQuery({
 *   variables: {
 *      type: // value for 'type'
 *   },
 * });
 */
export function useGetDefectColoursQuery(baseOptions: Apollo.QueryHookOptions<GetDefectColoursQuery, GetDefectColoursQueryVariables> & ({ variables: GetDefectColoursQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDefectColoursQuery, GetDefectColoursQueryVariables>(GetDefectColoursDocument, options);
      }
export function useGetDefectColoursLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDefectColoursQuery, GetDefectColoursQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDefectColoursQuery, GetDefectColoursQueryVariables>(GetDefectColoursDocument, options);
        }
// @ts-ignore
export function useGetDefectColoursSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetDefectColoursQuery, GetDefectColoursQueryVariables>): Apollo.UseSuspenseQueryResult<GetDefectColoursQuery, GetDefectColoursQueryVariables>;
export function useGetDefectColoursSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetDefectColoursQuery, GetDefectColoursQueryVariables>): Apollo.UseSuspenseQueryResult<GetDefectColoursQuery | undefined, GetDefectColoursQueryVariables>;
export function useGetDefectColoursSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetDefectColoursQuery, GetDefectColoursQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetDefectColoursQuery, GetDefectColoursQueryVariables>(GetDefectColoursDocument, options);
        }
export type GetDefectColoursQueryHookResult = ReturnType<typeof useGetDefectColoursQuery>;
export type GetDefectColoursLazyQueryHookResult = ReturnType<typeof useGetDefectColoursLazyQuery>;
export type GetDefectColoursSuspenseQueryHookResult = ReturnType<typeof useGetDefectColoursSuspenseQuery>;
export type GetDefectColoursQueryResult = Apollo.QueryResult<GetDefectColoursQuery, GetDefectColoursQueryVariables>;
export const GetAssemblyContextualizedStatusDocument = gql`
    query getAssemblyContextualizedStatus($assemblyId: String!) {
  assembly(assemblyId: $assemblyId) {
    id
    isUncontextualized
  }
}
    `;

/**
 * __useGetAssemblyContextualizedStatusQuery__
 *
 * To run a query within a React component, call `useGetAssemblyContextualizedStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAssemblyContextualizedStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAssemblyContextualizedStatusQuery({
 *   variables: {
 *      assemblyId: // value for 'assemblyId'
 *   },
 * });
 */
export function useGetAssemblyContextualizedStatusQuery(baseOptions: Apollo.QueryHookOptions<GetAssemblyContextualizedStatusQuery, GetAssemblyContextualizedStatusQueryVariables> & ({ variables: GetAssemblyContextualizedStatusQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAssemblyContextualizedStatusQuery, GetAssemblyContextualizedStatusQueryVariables>(GetAssemblyContextualizedStatusDocument, options);
      }
export function useGetAssemblyContextualizedStatusLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAssemblyContextualizedStatusQuery, GetAssemblyContextualizedStatusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAssemblyContextualizedStatusQuery, GetAssemblyContextualizedStatusQueryVariables>(GetAssemblyContextualizedStatusDocument, options);
        }
// @ts-ignore
export function useGetAssemblyContextualizedStatusSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetAssemblyContextualizedStatusQuery, GetAssemblyContextualizedStatusQueryVariables>): Apollo.UseSuspenseQueryResult<GetAssemblyContextualizedStatusQuery, GetAssemblyContextualizedStatusQueryVariables>;
export function useGetAssemblyContextualizedStatusSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAssemblyContextualizedStatusQuery, GetAssemblyContextualizedStatusQueryVariables>): Apollo.UseSuspenseQueryResult<GetAssemblyContextualizedStatusQuery | undefined, GetAssemblyContextualizedStatusQueryVariables>;
export function useGetAssemblyContextualizedStatusSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAssemblyContextualizedStatusQuery, GetAssemblyContextualizedStatusQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAssemblyContextualizedStatusQuery, GetAssemblyContextualizedStatusQueryVariables>(GetAssemblyContextualizedStatusDocument, options);
        }
export type GetAssemblyContextualizedStatusQueryHookResult = ReturnType<typeof useGetAssemblyContextualizedStatusQuery>;
export type GetAssemblyContextualizedStatusLazyQueryHookResult = ReturnType<typeof useGetAssemblyContextualizedStatusLazyQuery>;
export type GetAssemblyContextualizedStatusSuspenseQueryHookResult = ReturnType<typeof useGetAssemblyContextualizedStatusSuspenseQuery>;
export type GetAssemblyContextualizedStatusQueryResult = Apollo.QueryResult<GetAssemblyContextualizedStatusQuery, GetAssemblyContextualizedStatusQueryVariables>;
export const ProcessPdfForPoiDocument = gql`
    mutation ProcessPdfForPoi($input: ProcessPdfForPoiInput!) {
  processPdfForPoi(input: $input) {
    pointOfInterests {
      id
      name
      type
      status
      accessibility
      priority
      dueDate
      assignee
      comment
      templateFieldData
      createdAt
    }
    errors {
      fileName
      message
      code
    }
    totalProcessed
    successCount
    errorCount
  }
}
    `;
export type ProcessPdfForPoiMutationFn = Apollo.MutationFunction<ProcessPdfForPoiMutation, ProcessPdfForPoiMutationVariables>;

/**
 * __useProcessPdfForPoiMutation__
 *
 * To run a mutation, you first call `useProcessPdfForPoiMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProcessPdfForPoiMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [processPdfForPoiMutation, { data, loading, error }] = useProcessPdfForPoiMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useProcessPdfForPoiMutation(baseOptions?: Apollo.MutationHookOptions<ProcessPdfForPoiMutation, ProcessPdfForPoiMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ProcessPdfForPoiMutation, ProcessPdfForPoiMutationVariables>(ProcessPdfForPoiDocument, options);
      }
export type ProcessPdfForPoiMutationHookResult = ReturnType<typeof useProcessPdfForPoiMutation>;
export type ProcessPdfForPoiMutationResult = Apollo.MutationResult<ProcessPdfForPoiMutation>;
export type ProcessPdfForPoiMutationOptions = Apollo.BaseMutationOptions<ProcessPdfForPoiMutation, ProcessPdfForPoiMutationVariables>;
export const BulkUploadPoisDocument = gql`
    mutation BulkUploadPois($input: BulkUploadPoisInput!) {
  bulkUploadPois(input: $input) {
    poiId
  }
}
    `;
export type BulkUploadPoisMutationFn = Apollo.MutationFunction<BulkUploadPoisMutation, BulkUploadPoisMutationVariables>;

/**
 * __useBulkUploadPoisMutation__
 *
 * To run a mutation, you first call `useBulkUploadPoisMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBulkUploadPoisMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [bulkUploadPoisMutation, { data, loading, error }] = useBulkUploadPoisMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useBulkUploadPoisMutation(baseOptions?: Apollo.MutationHookOptions<BulkUploadPoisMutation, BulkUploadPoisMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<BulkUploadPoisMutation, BulkUploadPoisMutationVariables>(BulkUploadPoisDocument, options);
      }
export type BulkUploadPoisMutationHookResult = ReturnType<typeof useBulkUploadPoisMutation>;
export type BulkUploadPoisMutationResult = Apollo.MutationResult<BulkUploadPoisMutation>;
export type BulkUploadPoisMutationOptions = Apollo.BaseMutationOptions<BulkUploadPoisMutation, BulkUploadPoisMutationVariables>;
export const ValidateBulkPoiUploadDocument = gql`
    query ValidateBulkPoiUpload($input: BulkUploadPoisInput!) {
  validateBulkPoiUpload(input: $input)
}
    `;

/**
 * __useValidateBulkPoiUploadQuery__
 *
 * To run a query within a React component, call `useValidateBulkPoiUploadQuery` and pass it any options that fit your needs.
 * When your component renders, `useValidateBulkPoiUploadQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useValidateBulkPoiUploadQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useValidateBulkPoiUploadQuery(baseOptions: Apollo.QueryHookOptions<ValidateBulkPoiUploadQuery, ValidateBulkPoiUploadQueryVariables> & ({ variables: ValidateBulkPoiUploadQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ValidateBulkPoiUploadQuery, ValidateBulkPoiUploadQueryVariables>(ValidateBulkPoiUploadDocument, options);
      }
export function useValidateBulkPoiUploadLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ValidateBulkPoiUploadQuery, ValidateBulkPoiUploadQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ValidateBulkPoiUploadQuery, ValidateBulkPoiUploadQueryVariables>(ValidateBulkPoiUploadDocument, options);
        }
// @ts-ignore
export function useValidateBulkPoiUploadSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ValidateBulkPoiUploadQuery, ValidateBulkPoiUploadQueryVariables>): Apollo.UseSuspenseQueryResult<ValidateBulkPoiUploadQuery, ValidateBulkPoiUploadQueryVariables>;
export function useValidateBulkPoiUploadSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ValidateBulkPoiUploadQuery, ValidateBulkPoiUploadQueryVariables>): Apollo.UseSuspenseQueryResult<ValidateBulkPoiUploadQuery | undefined, ValidateBulkPoiUploadQueryVariables>;
export function useValidateBulkPoiUploadSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ValidateBulkPoiUploadQuery, ValidateBulkPoiUploadQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ValidateBulkPoiUploadQuery, ValidateBulkPoiUploadQueryVariables>(ValidateBulkPoiUploadDocument, options);
        }
export type ValidateBulkPoiUploadQueryHookResult = ReturnType<typeof useValidateBulkPoiUploadQuery>;
export type ValidateBulkPoiUploadLazyQueryHookResult = ReturnType<typeof useValidateBulkPoiUploadLazyQuery>;
export type ValidateBulkPoiUploadSuspenseQueryHookResult = ReturnType<typeof useValidateBulkPoiUploadSuspenseQuery>;
export type ValidateBulkPoiUploadQueryResult = Apollo.QueryResult<ValidateBulkPoiUploadQuery, ValidateBulkPoiUploadQueryVariables>;
export const GetAllDraftReportsDocument = gql`
    query getAllDraftReports($input: reportsInput) {
  allReports(input: $input) {
    id
    name
  }
}
    `;

/**
 * __useGetAllDraftReportsQuery__
 *
 * To run a query within a React component, call `useGetAllDraftReportsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllDraftReportsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllDraftReportsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetAllDraftReportsQuery(baseOptions?: Apollo.QueryHookOptions<GetAllDraftReportsQuery, GetAllDraftReportsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllDraftReportsQuery, GetAllDraftReportsQueryVariables>(GetAllDraftReportsDocument, options);
      }
export function useGetAllDraftReportsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllDraftReportsQuery, GetAllDraftReportsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllDraftReportsQuery, GetAllDraftReportsQueryVariables>(GetAllDraftReportsDocument, options);
        }
// @ts-ignore
export function useGetAllDraftReportsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetAllDraftReportsQuery, GetAllDraftReportsQueryVariables>): Apollo.UseSuspenseQueryResult<GetAllDraftReportsQuery, GetAllDraftReportsQueryVariables>;
export function useGetAllDraftReportsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAllDraftReportsQuery, GetAllDraftReportsQueryVariables>): Apollo.UseSuspenseQueryResult<GetAllDraftReportsQuery | undefined, GetAllDraftReportsQueryVariables>;
export function useGetAllDraftReportsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAllDraftReportsQuery, GetAllDraftReportsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAllDraftReportsQuery, GetAllDraftReportsQueryVariables>(GetAllDraftReportsDocument, options);
        }
export type GetAllDraftReportsQueryHookResult = ReturnType<typeof useGetAllDraftReportsQuery>;
export type GetAllDraftReportsLazyQueryHookResult = ReturnType<typeof useGetAllDraftReportsLazyQuery>;
export type GetAllDraftReportsSuspenseQueryHookResult = ReturnType<typeof useGetAllDraftReportsSuspenseQuery>;
export type GetAllDraftReportsQueryResult = Apollo.QueryResult<GetAllDraftReportsQuery, GetAllDraftReportsQueryVariables>;
export const CreatePointOfInterestDocument = gql`
    mutation CreatePointOfInterest($input: CreatePointOfInterestInput) {
  createPointOfInterest(input: $input) {
    id
    poiId
    type
    name
    templateId
    locationId
    createdAt
    assembly {
      id
      tagName
    }
    centerPoint3d {
      x
      y
      z
    }
    blister {
      maxHeight
      estimatedHeight
      pdrHeight
      heightType
      isManuallyOverridden
      borders3d {
        points {
          x
          y
          z
        }
      }
    }
    cuboids {
      id
      position
      rotation
      scale
    }
  }
}
    `;
export type CreatePointOfInterestMutationFn = Apollo.MutationFunction<CreatePointOfInterestMutation, CreatePointOfInterestMutationVariables>;

/**
 * __useCreatePointOfInterestMutation__
 *
 * To run a mutation, you first call `useCreatePointOfInterestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePointOfInterestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPointOfInterestMutation, { data, loading, error }] = useCreatePointOfInterestMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreatePointOfInterestMutation(baseOptions?: Apollo.MutationHookOptions<CreatePointOfInterestMutation, CreatePointOfInterestMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreatePointOfInterestMutation, CreatePointOfInterestMutationVariables>(CreatePointOfInterestDocument, options);
      }
export type CreatePointOfInterestMutationHookResult = ReturnType<typeof useCreatePointOfInterestMutation>;
export type CreatePointOfInterestMutationResult = Apollo.MutationResult<CreatePointOfInterestMutation>;
export type CreatePointOfInterestMutationOptions = Apollo.BaseMutationOptions<CreatePointOfInterestMutation, CreatePointOfInterestMutationVariables>;
export const AllAssembliesForCreatePoiDocument = gql`
    query AllAssembliesForCreatePoi($structureId: String!, $templateId: String!) {
  allAssemblies(structureId: $structureId, templateId: $templateId) {
    id
    tagName
  }
}
    `;

/**
 * __useAllAssembliesForCreatePoiQuery__
 *
 * To run a query within a React component, call `useAllAssembliesForCreatePoiQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllAssembliesForCreatePoiQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllAssembliesForCreatePoiQuery({
 *   variables: {
 *      structureId: // value for 'structureId'
 *      templateId: // value for 'templateId'
 *   },
 * });
 */
export function useAllAssembliesForCreatePoiQuery(baseOptions: Apollo.QueryHookOptions<AllAssembliesForCreatePoiQuery, AllAssembliesForCreatePoiQueryVariables> & ({ variables: AllAssembliesForCreatePoiQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AllAssembliesForCreatePoiQuery, AllAssembliesForCreatePoiQueryVariables>(AllAssembliesForCreatePoiDocument, options);
      }
export function useAllAssembliesForCreatePoiLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AllAssembliesForCreatePoiQuery, AllAssembliesForCreatePoiQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AllAssembliesForCreatePoiQuery, AllAssembliesForCreatePoiQueryVariables>(AllAssembliesForCreatePoiDocument, options);
        }
// @ts-ignore
export function useAllAssembliesForCreatePoiSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<AllAssembliesForCreatePoiQuery, AllAssembliesForCreatePoiQueryVariables>): Apollo.UseSuspenseQueryResult<AllAssembliesForCreatePoiQuery, AllAssembliesForCreatePoiQueryVariables>;
export function useAllAssembliesForCreatePoiSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AllAssembliesForCreatePoiQuery, AllAssembliesForCreatePoiQueryVariables>): Apollo.UseSuspenseQueryResult<AllAssembliesForCreatePoiQuery | undefined, AllAssembliesForCreatePoiQueryVariables>;
export function useAllAssembliesForCreatePoiSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AllAssembliesForCreatePoiQuery, AllAssembliesForCreatePoiQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AllAssembliesForCreatePoiQuery, AllAssembliesForCreatePoiQueryVariables>(AllAssembliesForCreatePoiDocument, options);
        }
export type AllAssembliesForCreatePoiQueryHookResult = ReturnType<typeof useAllAssembliesForCreatePoiQuery>;
export type AllAssembliesForCreatePoiLazyQueryHookResult = ReturnType<typeof useAllAssembliesForCreatePoiLazyQuery>;
export type AllAssembliesForCreatePoiSuspenseQueryHookResult = ReturnType<typeof useAllAssembliesForCreatePoiSuspenseQuery>;
export type AllAssembliesForCreatePoiQueryResult = Apollo.QueryResult<AllAssembliesForCreatePoiQuery, AllAssembliesForCreatePoiQueryVariables>;
export const GetStructureDefaultAssemblyDocument = gql`
    query getStructureDefaultAssembly($structureId: String!) {
  structure(structureId: $structureId) {
    id
    name
    defaultAssemblyId
  }
}
    `;

/**
 * __useGetStructureDefaultAssemblyQuery__
 *
 * To run a query within a React component, call `useGetStructureDefaultAssemblyQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetStructureDefaultAssemblyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetStructureDefaultAssemblyQuery({
 *   variables: {
 *      structureId: // value for 'structureId'
 *   },
 * });
 */
export function useGetStructureDefaultAssemblyQuery(baseOptions: Apollo.QueryHookOptions<GetStructureDefaultAssemblyQuery, GetStructureDefaultAssemblyQueryVariables> & ({ variables: GetStructureDefaultAssemblyQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetStructureDefaultAssemblyQuery, GetStructureDefaultAssemblyQueryVariables>(GetStructureDefaultAssemblyDocument, options);
      }
export function useGetStructureDefaultAssemblyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetStructureDefaultAssemblyQuery, GetStructureDefaultAssemblyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetStructureDefaultAssemblyQuery, GetStructureDefaultAssemblyQueryVariables>(GetStructureDefaultAssemblyDocument, options);
        }
// @ts-ignore
export function useGetStructureDefaultAssemblySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetStructureDefaultAssemblyQuery, GetStructureDefaultAssemblyQueryVariables>): Apollo.UseSuspenseQueryResult<GetStructureDefaultAssemblyQuery, GetStructureDefaultAssemblyQueryVariables>;
export function useGetStructureDefaultAssemblySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetStructureDefaultAssemblyQuery, GetStructureDefaultAssemblyQueryVariables>): Apollo.UseSuspenseQueryResult<GetStructureDefaultAssemblyQuery | undefined, GetStructureDefaultAssemblyQueryVariables>;
export function useGetStructureDefaultAssemblySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetStructureDefaultAssemblyQuery, GetStructureDefaultAssemblyQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetStructureDefaultAssemblyQuery, GetStructureDefaultAssemblyQueryVariables>(GetStructureDefaultAssemblyDocument, options);
        }
export type GetStructureDefaultAssemblyQueryHookResult = ReturnType<typeof useGetStructureDefaultAssemblyQuery>;
export type GetStructureDefaultAssemblyLazyQueryHookResult = ReturnType<typeof useGetStructureDefaultAssemblyLazyQuery>;
export type GetStructureDefaultAssemblySuspenseQueryHookResult = ReturnType<typeof useGetStructureDefaultAssemblySuspenseQuery>;
export type GetStructureDefaultAssemblyQueryResult = Apollo.QueryResult<GetStructureDefaultAssemblyQuery, GetStructureDefaultAssemblyQueryVariables>;
export const UpdatePoiGeneralFieldsDocument = gql`
    mutation UpdatePoiGeneralFields($input: UpdatePointOfInterestInput) {
  updatePointOfInterest(input: $input) {
    id
    cuboids {
      id
      position
      rotation
      scale
    }
  }
}
    `;
export type UpdatePoiGeneralFieldsMutationFn = Apollo.MutationFunction<UpdatePoiGeneralFieldsMutation, UpdatePoiGeneralFieldsMutationVariables>;

/**
 * __useUpdatePoiGeneralFieldsMutation__
 *
 * To run a mutation, you first call `useUpdatePoiGeneralFieldsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePoiGeneralFieldsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePoiGeneralFieldsMutation, { data, loading, error }] = useUpdatePoiGeneralFieldsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdatePoiGeneralFieldsMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePoiGeneralFieldsMutation, UpdatePoiGeneralFieldsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePoiGeneralFieldsMutation, UpdatePoiGeneralFieldsMutationVariables>(UpdatePoiGeneralFieldsDocument, options);
      }
export type UpdatePoiGeneralFieldsMutationHookResult = ReturnType<typeof useUpdatePoiGeneralFieldsMutation>;
export type UpdatePoiGeneralFieldsMutationResult = Apollo.MutationResult<UpdatePoiGeneralFieldsMutation>;
export type UpdatePoiGeneralFieldsMutationOptions = Apollo.BaseMutationOptions<UpdatePoiGeneralFieldsMutation, UpdatePoiGeneralFieldsMutationVariables>;
export const UpdatePoiTemplateFieldsDocument = gql`
    mutation UpdatePoiTemplateFields($input: UpdatePointOfInterestInput) {
  updatePointOfInterest(input: $input) {
    id
  }
}
    `;
export type UpdatePoiTemplateFieldsMutationFn = Apollo.MutationFunction<UpdatePoiTemplateFieldsMutation, UpdatePoiTemplateFieldsMutationVariables>;

/**
 * __useUpdatePoiTemplateFieldsMutation__
 *
 * To run a mutation, you first call `useUpdatePoiTemplateFieldsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePoiTemplateFieldsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePoiTemplateFieldsMutation, { data, loading, error }] = useUpdatePoiTemplateFieldsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdatePoiTemplateFieldsMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePoiTemplateFieldsMutation, UpdatePoiTemplateFieldsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePoiTemplateFieldsMutation, UpdatePoiTemplateFieldsMutationVariables>(UpdatePoiTemplateFieldsDocument, options);
      }
export type UpdatePoiTemplateFieldsMutationHookResult = ReturnType<typeof useUpdatePoiTemplateFieldsMutation>;
export type UpdatePoiTemplateFieldsMutationResult = Apollo.MutationResult<UpdatePoiTemplateFieldsMutation>;
export type UpdatePoiTemplateFieldsMutationOptions = Apollo.BaseMutationOptions<UpdatePoiTemplateFieldsMutation, UpdatePoiTemplateFieldsMutationVariables>;
export const VerifyPointOfInterestDocument = gql`
    mutation VerifyPointOfInterest($input: VerifyPointOfInterestInput) {
  verifyPointOfInterest(input: $input) {
    templateData {
      verifiedValue
      value
      id
    }
    templateFieldData
  }
}
    `;
export type VerifyPointOfInterestMutationFn = Apollo.MutationFunction<VerifyPointOfInterestMutation, VerifyPointOfInterestMutationVariables>;

/**
 * __useVerifyPointOfInterestMutation__
 *
 * To run a mutation, you first call `useVerifyPointOfInterestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useVerifyPointOfInterestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [verifyPointOfInterestMutation, { data, loading, error }] = useVerifyPointOfInterestMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useVerifyPointOfInterestMutation(baseOptions?: Apollo.MutationHookOptions<VerifyPointOfInterestMutation, VerifyPointOfInterestMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<VerifyPointOfInterestMutation, VerifyPointOfInterestMutationVariables>(VerifyPointOfInterestDocument, options);
      }
export type VerifyPointOfInterestMutationHookResult = ReturnType<typeof useVerifyPointOfInterestMutation>;
export type VerifyPointOfInterestMutationResult = Apollo.MutationResult<VerifyPointOfInterestMutation>;
export type VerifyPointOfInterestMutationOptions = Apollo.BaseMutationOptions<VerifyPointOfInterestMutation, VerifyPointOfInterestMutationVariables>;
export const ScCategoryOptionsDocument = gql`
    query ScCategoryOptions($structureId: ID!) {
  scCategoryOptions(structureId: $structureId)
}
    `;

/**
 * __useScCategoryOptionsQuery__
 *
 * To run a query within a React component, call `useScCategoryOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useScCategoryOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useScCategoryOptionsQuery({
 *   variables: {
 *      structureId: // value for 'structureId'
 *   },
 * });
 */
export function useScCategoryOptionsQuery(baseOptions: Apollo.QueryHookOptions<ScCategoryOptionsQuery, ScCategoryOptionsQueryVariables> & ({ variables: ScCategoryOptionsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ScCategoryOptionsQuery, ScCategoryOptionsQueryVariables>(ScCategoryOptionsDocument, options);
      }
export function useScCategoryOptionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ScCategoryOptionsQuery, ScCategoryOptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ScCategoryOptionsQuery, ScCategoryOptionsQueryVariables>(ScCategoryOptionsDocument, options);
        }
// @ts-ignore
export function useScCategoryOptionsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ScCategoryOptionsQuery, ScCategoryOptionsQueryVariables>): Apollo.UseSuspenseQueryResult<ScCategoryOptionsQuery, ScCategoryOptionsQueryVariables>;
export function useScCategoryOptionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ScCategoryOptionsQuery, ScCategoryOptionsQueryVariables>): Apollo.UseSuspenseQueryResult<ScCategoryOptionsQuery | undefined, ScCategoryOptionsQueryVariables>;
export function useScCategoryOptionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ScCategoryOptionsQuery, ScCategoryOptionsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ScCategoryOptionsQuery, ScCategoryOptionsQueryVariables>(ScCategoryOptionsDocument, options);
        }
export type ScCategoryOptionsQueryHookResult = ReturnType<typeof useScCategoryOptionsQuery>;
export type ScCategoryOptionsLazyQueryHookResult = ReturnType<typeof useScCategoryOptionsLazyQuery>;
export type ScCategoryOptionsSuspenseQueryHookResult = ReturnType<typeof useScCategoryOptionsSuspenseQuery>;
export type ScCategoryOptionsQueryResult = Apollo.QueryResult<ScCategoryOptionsQuery, ScCategoryOptionsQueryVariables>;
export const UpdateBlisterHeightTypeDocument = gql`
    mutation updateBlisterHeightType($input: PerformMechanicalIntegrityServicesInput) {
  performMechanicalIntegrityServices(input: $input) {
    status
    message
  }
}
    `;
export type UpdateBlisterHeightTypeMutationFn = Apollo.MutationFunction<UpdateBlisterHeightTypeMutation, UpdateBlisterHeightTypeMutationVariables>;

/**
 * __useUpdateBlisterHeightTypeMutation__
 *
 * To run a mutation, you first call `useUpdateBlisterHeightTypeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateBlisterHeightTypeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateBlisterHeightTypeMutation, { data, loading, error }] = useUpdateBlisterHeightTypeMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateBlisterHeightTypeMutation(baseOptions?: Apollo.MutationHookOptions<UpdateBlisterHeightTypeMutation, UpdateBlisterHeightTypeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateBlisterHeightTypeMutation, UpdateBlisterHeightTypeMutationVariables>(UpdateBlisterHeightTypeDocument, options);
      }
export type UpdateBlisterHeightTypeMutationHookResult = ReturnType<typeof useUpdateBlisterHeightTypeMutation>;
export type UpdateBlisterHeightTypeMutationResult = Apollo.MutationResult<UpdateBlisterHeightTypeMutation>;
export type UpdateBlisterHeightTypeMutationOptions = Apollo.BaseMutationOptions<UpdateBlisterHeightTypeMutation, UpdateBlisterHeightTypeMutationVariables>;
export const UpdateCalculationMethodDocument = gql`
    mutation updateCalculationMethod($input: UpdateCalculationMethodInput) {
  updateCalculationMethod(input: $input) {
    id
  }
}
    `;
export type UpdateCalculationMethodMutationFn = Apollo.MutationFunction<UpdateCalculationMethodMutation, UpdateCalculationMethodMutationVariables>;

/**
 * __useUpdateCalculationMethodMutation__
 *
 * To run a mutation, you first call `useUpdateCalculationMethodMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCalculationMethodMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCalculationMethodMutation, { data, loading, error }] = useUpdateCalculationMethodMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateCalculationMethodMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCalculationMethodMutation, UpdateCalculationMethodMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCalculationMethodMutation, UpdateCalculationMethodMutationVariables>(UpdateCalculationMethodDocument, options);
      }
export type UpdateCalculationMethodMutationHookResult = ReturnType<typeof useUpdateCalculationMethodMutation>;
export type UpdateCalculationMethodMutationResult = Apollo.MutationResult<UpdateCalculationMethodMutation>;
export type UpdateCalculationMethodMutationOptions = Apollo.BaseMutationOptions<UpdateCalculationMethodMutation, UpdateCalculationMethodMutationVariables>;
export const PoiImageCaptionDocument = gql`
    mutation PoiImageCaption($input: PoiImageCaptionInput) {
  poiImageCaption(input: $input)
}
    `;
export type PoiImageCaptionMutationFn = Apollo.MutationFunction<PoiImageCaptionMutation, PoiImageCaptionMutationVariables>;

/**
 * __usePoiImageCaptionMutation__
 *
 * To run a mutation, you first call `usePoiImageCaptionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePoiImageCaptionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [poiImageCaptionMutation, { data, loading, error }] = usePoiImageCaptionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePoiImageCaptionMutation(baseOptions?: Apollo.MutationHookOptions<PoiImageCaptionMutation, PoiImageCaptionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PoiImageCaptionMutation, PoiImageCaptionMutationVariables>(PoiImageCaptionDocument, options);
      }
export type PoiImageCaptionMutationHookResult = ReturnType<typeof usePoiImageCaptionMutation>;
export type PoiImageCaptionMutationResult = Apollo.MutationResult<PoiImageCaptionMutation>;
export type PoiImageCaptionMutationOptions = Apollo.BaseMutationOptions<PoiImageCaptionMutation, PoiImageCaptionMutationVariables>;
export const DeletePointOfInterestDocument = gql`
    mutation DeletePointOfInterest($pointOfInterestId: ID!) {
  archivePointOfInterest(pointOfInterestId: $pointOfInterestId) {
    id
    type
  }
}
    `;
export type DeletePointOfInterestMutationFn = Apollo.MutationFunction<DeletePointOfInterestMutation, DeletePointOfInterestMutationVariables>;

/**
 * __useDeletePointOfInterestMutation__
 *
 * To run a mutation, you first call `useDeletePointOfInterestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeletePointOfInterestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deletePointOfInterestMutation, { data, loading, error }] = useDeletePointOfInterestMutation({
 *   variables: {
 *      pointOfInterestId: // value for 'pointOfInterestId'
 *   },
 * });
 */
export function useDeletePointOfInterestMutation(baseOptions?: Apollo.MutationHookOptions<DeletePointOfInterestMutation, DeletePointOfInterestMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeletePointOfInterestMutation, DeletePointOfInterestMutationVariables>(DeletePointOfInterestDocument, options);
      }
export type DeletePointOfInterestMutationHookResult = ReturnType<typeof useDeletePointOfInterestMutation>;
export type DeletePointOfInterestMutationResult = Apollo.MutationResult<DeletePointOfInterestMutation>;
export type DeletePointOfInterestMutationOptions = Apollo.BaseMutationOptions<DeletePointOfInterestMutation, DeletePointOfInterestMutationVariables>;
export const UpdatePointOfInterestDocument = gql`
    mutation UpdatePointOfInterest($input: UpdatePointOfInterestInput) {
  updatePointOfInterest(input: $input) {
    id
  }
}
    `;
export type UpdatePointOfInterestMutationFn = Apollo.MutationFunction<UpdatePointOfInterestMutation, UpdatePointOfInterestMutationVariables>;

/**
 * __useUpdatePointOfInterestMutation__
 *
 * To run a mutation, you first call `useUpdatePointOfInterestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePointOfInterestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePointOfInterestMutation, { data, loading, error }] = useUpdatePointOfInterestMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdatePointOfInterestMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePointOfInterestMutation, UpdatePointOfInterestMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePointOfInterestMutation, UpdatePointOfInterestMutationVariables>(UpdatePointOfInterestDocument, options);
      }
export type UpdatePointOfInterestMutationHookResult = ReturnType<typeof useUpdatePointOfInterestMutation>;
export type UpdatePointOfInterestMutationResult = Apollo.MutationResult<UpdatePointOfInterestMutation>;
export type UpdatePointOfInterestMutationOptions = Apollo.BaseMutationOptions<UpdatePointOfInterestMutation, UpdatePointOfInterestMutationVariables>;
export const StructureForBlisterDocument = gql`
    query StructureForBlister($structureId: String) {
  structure(structureId: $structureId) {
    id
    wallLossFactor
    scCategoryMapping
  }
}
    `;

/**
 * __useStructureForBlisterQuery__
 *
 * To run a query within a React component, call `useStructureForBlisterQuery` and pass it any options that fit your needs.
 * When your component renders, `useStructureForBlisterQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStructureForBlisterQuery({
 *   variables: {
 *      structureId: // value for 'structureId'
 *   },
 * });
 */
export function useStructureForBlisterQuery(baseOptions?: Apollo.QueryHookOptions<StructureForBlisterQuery, StructureForBlisterQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<StructureForBlisterQuery, StructureForBlisterQueryVariables>(StructureForBlisterDocument, options);
      }
export function useStructureForBlisterLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<StructureForBlisterQuery, StructureForBlisterQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<StructureForBlisterQuery, StructureForBlisterQueryVariables>(StructureForBlisterDocument, options);
        }
// @ts-ignore
export function useStructureForBlisterSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<StructureForBlisterQuery, StructureForBlisterQueryVariables>): Apollo.UseSuspenseQueryResult<StructureForBlisterQuery, StructureForBlisterQueryVariables>;
export function useStructureForBlisterSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<StructureForBlisterQuery, StructureForBlisterQueryVariables>): Apollo.UseSuspenseQueryResult<StructureForBlisterQuery | undefined, StructureForBlisterQueryVariables>;
export function useStructureForBlisterSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<StructureForBlisterQuery, StructureForBlisterQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<StructureForBlisterQuery, StructureForBlisterQueryVariables>(StructureForBlisterDocument, options);
        }
export type StructureForBlisterQueryHookResult = ReturnType<typeof useStructureForBlisterQuery>;
export type StructureForBlisterLazyQueryHookResult = ReturnType<typeof useStructureForBlisterLazyQuery>;
export type StructureForBlisterSuspenseQueryHookResult = ReturnType<typeof useStructureForBlisterSuspenseQuery>;
export type StructureForBlisterQueryResult = Apollo.QueryResult<StructureForBlisterQuery, StructureForBlisterQueryVariables>;
export const UploadAttachmentsToPoiDocument = gql`
    mutation UploadAttachmentsToPOI($input: UploadAttachmentsInput) {
  uploadAttachmentsToPoi(input: $input) {
    id
    url
    resourcePath
    uuid
  }
}
    `;
export type UploadAttachmentsToPoiMutationFn = Apollo.MutationFunction<UploadAttachmentsToPoiMutation, UploadAttachmentsToPoiMutationVariables>;

/**
 * __useUploadAttachmentsToPoiMutation__
 *
 * To run a mutation, you first call `useUploadAttachmentsToPoiMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUploadAttachmentsToPoiMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [uploadAttachmentsToPoiMutation, { data, loading, error }] = useUploadAttachmentsToPoiMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUploadAttachmentsToPoiMutation(baseOptions?: Apollo.MutationHookOptions<UploadAttachmentsToPoiMutation, UploadAttachmentsToPoiMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UploadAttachmentsToPoiMutation, UploadAttachmentsToPoiMutationVariables>(UploadAttachmentsToPoiDocument, options);
      }
export type UploadAttachmentsToPoiMutationHookResult = ReturnType<typeof useUploadAttachmentsToPoiMutation>;
export type UploadAttachmentsToPoiMutationResult = Apollo.MutationResult<UploadAttachmentsToPoiMutation>;
export type UploadAttachmentsToPoiMutationOptions = Apollo.BaseMutationOptions<UploadAttachmentsToPoiMutation, UploadAttachmentsToPoiMutationVariables>;
export const RemoveAttachmentsFromPoiDocument = gql`
    mutation RemoveAttachmentsFromPoi($input: RemoveAttachmentsInput) {
  removeAttachmentsFromPoi(input: $input) {
    id
  }
}
    `;
export type RemoveAttachmentsFromPoiMutationFn = Apollo.MutationFunction<RemoveAttachmentsFromPoiMutation, RemoveAttachmentsFromPoiMutationVariables>;

/**
 * __useRemoveAttachmentsFromPoiMutation__
 *
 * To run a mutation, you first call `useRemoveAttachmentsFromPoiMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveAttachmentsFromPoiMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeAttachmentsFromPoiMutation, { data, loading, error }] = useRemoveAttachmentsFromPoiMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRemoveAttachmentsFromPoiMutation(baseOptions?: Apollo.MutationHookOptions<RemoveAttachmentsFromPoiMutation, RemoveAttachmentsFromPoiMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveAttachmentsFromPoiMutation, RemoveAttachmentsFromPoiMutationVariables>(RemoveAttachmentsFromPoiDocument, options);
      }
export type RemoveAttachmentsFromPoiMutationHookResult = ReturnType<typeof useRemoveAttachmentsFromPoiMutation>;
export type RemoveAttachmentsFromPoiMutationResult = Apollo.MutationResult<RemoveAttachmentsFromPoiMutation>;
export type RemoveAttachmentsFromPoiMutationOptions = Apollo.BaseMutationOptions<RemoveAttachmentsFromPoiMutation, RemoveAttachmentsFromPoiMutationVariables>;
export const UpdatePaintRegionIdDocument = gql`
    mutation UpdatePaintRegionId($input: UpdatePaintRegionIdInput) {
  updatePaintRegionId(input: $input) {
    paintRegion {
      id
      name
      volume {
        inclusion {
          xy_polygon
          z_range
        }
        exclusions {
          xy_polygon
          z_range
        }
      }
    }
  }
}
    `;
export type UpdatePaintRegionIdMutationFn = Apollo.MutationFunction<UpdatePaintRegionIdMutation, UpdatePaintRegionIdMutationVariables>;

/**
 * __useUpdatePaintRegionIdMutation__
 *
 * To run a mutation, you first call `useUpdatePaintRegionIdMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePaintRegionIdMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePaintRegionIdMutation, { data, loading, error }] = useUpdatePaintRegionIdMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdatePaintRegionIdMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePaintRegionIdMutation, UpdatePaintRegionIdMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePaintRegionIdMutation, UpdatePaintRegionIdMutationVariables>(UpdatePaintRegionIdDocument, options);
      }
export type UpdatePaintRegionIdMutationHookResult = ReturnType<typeof useUpdatePaintRegionIdMutation>;
export type UpdatePaintRegionIdMutationResult = Apollo.MutationResult<UpdatePaintRegionIdMutation>;
export type UpdatePaintRegionIdMutationOptions = Apollo.BaseMutationOptions<UpdatePaintRegionIdMutation, UpdatePaintRegionIdMutationVariables>;
export const FindClosestPaintRegionDocument = gql`
    query FindClosestPaintRegion($input: FindClosestPaintRegionInput!) {
  findClosestPaintRegion(input: $input) {
    distance
    paintRegion {
      id
    }
  }
}
    `;

/**
 * __useFindClosestPaintRegionQuery__
 *
 * To run a query within a React component, call `useFindClosestPaintRegionQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindClosestPaintRegionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindClosestPaintRegionQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useFindClosestPaintRegionQuery(baseOptions: Apollo.QueryHookOptions<FindClosestPaintRegionQuery, FindClosestPaintRegionQueryVariables> & ({ variables: FindClosestPaintRegionQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FindClosestPaintRegionQuery, FindClosestPaintRegionQueryVariables>(FindClosestPaintRegionDocument, options);
      }
export function useFindClosestPaintRegionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FindClosestPaintRegionQuery, FindClosestPaintRegionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FindClosestPaintRegionQuery, FindClosestPaintRegionQueryVariables>(FindClosestPaintRegionDocument, options);
        }
// @ts-ignore
export function useFindClosestPaintRegionSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<FindClosestPaintRegionQuery, FindClosestPaintRegionQueryVariables>): Apollo.UseSuspenseQueryResult<FindClosestPaintRegionQuery, FindClosestPaintRegionQueryVariables>;
export function useFindClosestPaintRegionSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FindClosestPaintRegionQuery, FindClosestPaintRegionQueryVariables>): Apollo.UseSuspenseQueryResult<FindClosestPaintRegionQuery | undefined, FindClosestPaintRegionQueryVariables>;
export function useFindClosestPaintRegionSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FindClosestPaintRegionQuery, FindClosestPaintRegionQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FindClosestPaintRegionQuery, FindClosestPaintRegionQueryVariables>(FindClosestPaintRegionDocument, options);
        }
export type FindClosestPaintRegionQueryHookResult = ReturnType<typeof useFindClosestPaintRegionQuery>;
export type FindClosestPaintRegionLazyQueryHookResult = ReturnType<typeof useFindClosestPaintRegionLazyQuery>;
export type FindClosestPaintRegionSuspenseQueryHookResult = ReturnType<typeof useFindClosestPaintRegionSuspenseQuery>;
export type FindClosestPaintRegionQueryResult = Apollo.QueryResult<FindClosestPaintRegionQuery, FindClosestPaintRegionQueryVariables>;
export const SelectedPoiUpdatedDocument = gql`
    subscription SelectedPOIUpdated($poiID: ID) {
  selectedPointOfInterestUpdated(poiId: $poiID) {
    id
    paintRegion {
      id
      name
    }
    screenshotPaths {
      viewer
      viewpoint
    }
  }
}
    `;

/**
 * __useSelectedPoiUpdatedSubscription__
 *
 * To run a query within a React component, call `useSelectedPoiUpdatedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useSelectedPoiUpdatedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSelectedPoiUpdatedSubscription({
 *   variables: {
 *      poiID: // value for 'poiID'
 *   },
 * });
 */
export function useSelectedPoiUpdatedSubscription(baseOptions?: Apollo.SubscriptionHookOptions<SelectedPoiUpdatedSubscription, SelectedPoiUpdatedSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<SelectedPoiUpdatedSubscription, SelectedPoiUpdatedSubscriptionVariables>(SelectedPoiUpdatedDocument, options);
      }
export type SelectedPoiUpdatedSubscriptionHookResult = ReturnType<typeof useSelectedPoiUpdatedSubscription>;
export type SelectedPoiUpdatedSubscriptionResult = Apollo.SubscriptionResult<SelectedPoiUpdatedSubscription>;
export const StructureWallLossFactorDocument = gql`
    query StructureWallLossFactor($structureId: String) {
  structure(structureId: $structureId) {
    wallLossFactor
  }
}
    `;

/**
 * __useStructureWallLossFactorQuery__
 *
 * To run a query within a React component, call `useStructureWallLossFactorQuery` and pass it any options that fit your needs.
 * When your component renders, `useStructureWallLossFactorQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStructureWallLossFactorQuery({
 *   variables: {
 *      structureId: // value for 'structureId'
 *   },
 * });
 */
export function useStructureWallLossFactorQuery(baseOptions?: Apollo.QueryHookOptions<StructureWallLossFactorQuery, StructureWallLossFactorQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<StructureWallLossFactorQuery, StructureWallLossFactorQueryVariables>(StructureWallLossFactorDocument, options);
      }
export function useStructureWallLossFactorLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<StructureWallLossFactorQuery, StructureWallLossFactorQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<StructureWallLossFactorQuery, StructureWallLossFactorQueryVariables>(StructureWallLossFactorDocument, options);
        }
// @ts-ignore
export function useStructureWallLossFactorSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<StructureWallLossFactorQuery, StructureWallLossFactorQueryVariables>): Apollo.UseSuspenseQueryResult<StructureWallLossFactorQuery, StructureWallLossFactorQueryVariables>;
export function useStructureWallLossFactorSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<StructureWallLossFactorQuery, StructureWallLossFactorQueryVariables>): Apollo.UseSuspenseQueryResult<StructureWallLossFactorQuery | undefined, StructureWallLossFactorQueryVariables>;
export function useStructureWallLossFactorSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<StructureWallLossFactorQuery, StructureWallLossFactorQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<StructureWallLossFactorQuery, StructureWallLossFactorQueryVariables>(StructureWallLossFactorDocument, options);
        }
export type StructureWallLossFactorQueryHookResult = ReturnType<typeof useStructureWallLossFactorQuery>;
export type StructureWallLossFactorLazyQueryHookResult = ReturnType<typeof useStructureWallLossFactorLazyQuery>;
export type StructureWallLossFactorSuspenseQueryHookResult = ReturnType<typeof useStructureWallLossFactorSuspenseQuery>;
export type StructureWallLossFactorQueryResult = Apollo.QueryResult<StructureWallLossFactorQuery, StructureWallLossFactorQueryVariables>;
export const EvaluateTemplateFieldLogicRuleDocument = gql`
    mutation EvaluateTemplateFieldLogicRule($input: EvaluateTemplateFieldLogicRuleInput!) {
  evaluateTemplateFieldLogicRule(input: $input) {
    result
  }
}
    `;
export type EvaluateTemplateFieldLogicRuleMutationFn = Apollo.MutationFunction<EvaluateTemplateFieldLogicRuleMutation, EvaluateTemplateFieldLogicRuleMutationVariables>;

/**
 * __useEvaluateTemplateFieldLogicRuleMutation__
 *
 * To run a mutation, you first call `useEvaluateTemplateFieldLogicRuleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEvaluateTemplateFieldLogicRuleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [evaluateTemplateFieldLogicRuleMutation, { data, loading, error }] = useEvaluateTemplateFieldLogicRuleMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEvaluateTemplateFieldLogicRuleMutation(baseOptions?: Apollo.MutationHookOptions<EvaluateTemplateFieldLogicRuleMutation, EvaluateTemplateFieldLogicRuleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EvaluateTemplateFieldLogicRuleMutation, EvaluateTemplateFieldLogicRuleMutationVariables>(EvaluateTemplateFieldLogicRuleDocument, options);
      }
export type EvaluateTemplateFieldLogicRuleMutationHookResult = ReturnType<typeof useEvaluateTemplateFieldLogicRuleMutation>;
export type EvaluateTemplateFieldLogicRuleMutationResult = Apollo.MutationResult<EvaluateTemplateFieldLogicRuleMutation>;
export type EvaluateTemplateFieldLogicRuleMutationOptions = Apollo.BaseMutationOptions<EvaluateTemplateFieldLogicRuleMutation, EvaluateTemplateFieldLogicRuleMutationVariables>;
export const WorkscopeDynamicBlockCalculationDocument = gql`
    query WorkscopeDynamicBlockCalculation($input: DynamicBlockCalculationInput!) {
  dynamicBlockCalculation(input: $input)
}
    `;

/**
 * __useWorkscopeDynamicBlockCalculationQuery__
 *
 * To run a query within a React component, call `useWorkscopeDynamicBlockCalculationQuery` and pass it any options that fit your needs.
 * When your component renders, `useWorkscopeDynamicBlockCalculationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWorkscopeDynamicBlockCalculationQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useWorkscopeDynamicBlockCalculationQuery(baseOptions: Apollo.QueryHookOptions<WorkscopeDynamicBlockCalculationQuery, WorkscopeDynamicBlockCalculationQueryVariables> & ({ variables: WorkscopeDynamicBlockCalculationQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<WorkscopeDynamicBlockCalculationQuery, WorkscopeDynamicBlockCalculationQueryVariables>(WorkscopeDynamicBlockCalculationDocument, options);
      }
export function useWorkscopeDynamicBlockCalculationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<WorkscopeDynamicBlockCalculationQuery, WorkscopeDynamicBlockCalculationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<WorkscopeDynamicBlockCalculationQuery, WorkscopeDynamicBlockCalculationQueryVariables>(WorkscopeDynamicBlockCalculationDocument, options);
        }
// @ts-ignore
export function useWorkscopeDynamicBlockCalculationSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<WorkscopeDynamicBlockCalculationQuery, WorkscopeDynamicBlockCalculationQueryVariables>): Apollo.UseSuspenseQueryResult<WorkscopeDynamicBlockCalculationQuery, WorkscopeDynamicBlockCalculationQueryVariables>;
export function useWorkscopeDynamicBlockCalculationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<WorkscopeDynamicBlockCalculationQuery, WorkscopeDynamicBlockCalculationQueryVariables>): Apollo.UseSuspenseQueryResult<WorkscopeDynamicBlockCalculationQuery | undefined, WorkscopeDynamicBlockCalculationQueryVariables>;
export function useWorkscopeDynamicBlockCalculationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<WorkscopeDynamicBlockCalculationQuery, WorkscopeDynamicBlockCalculationQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<WorkscopeDynamicBlockCalculationQuery, WorkscopeDynamicBlockCalculationQueryVariables>(WorkscopeDynamicBlockCalculationDocument, options);
        }
export type WorkscopeDynamicBlockCalculationQueryHookResult = ReturnType<typeof useWorkscopeDynamicBlockCalculationQuery>;
export type WorkscopeDynamicBlockCalculationLazyQueryHookResult = ReturnType<typeof useWorkscopeDynamicBlockCalculationLazyQuery>;
export type WorkscopeDynamicBlockCalculationSuspenseQueryHookResult = ReturnType<typeof useWorkscopeDynamicBlockCalculationSuspenseQuery>;
export type WorkscopeDynamicBlockCalculationQueryResult = Apollo.QueryResult<WorkscopeDynamicBlockCalculationQuery, WorkscopeDynamicBlockCalculationQueryVariables>;
export const DeletePointOfInterestFromTabDocument = gql`
    mutation DeletePointOfInterestFromTab($pointOfInterestId: ID!) {
  archivePointOfInterest(pointOfInterestId: $pointOfInterestId) {
    id
    type
  }
}
    `;
export type DeletePointOfInterestFromTabMutationFn = Apollo.MutationFunction<DeletePointOfInterestFromTabMutation, DeletePointOfInterestFromTabMutationVariables>;

/**
 * __useDeletePointOfInterestFromTabMutation__
 *
 * To run a mutation, you first call `useDeletePointOfInterestFromTabMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeletePointOfInterestFromTabMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deletePointOfInterestFromTabMutation, { data, loading, error }] = useDeletePointOfInterestFromTabMutation({
 *   variables: {
 *      pointOfInterestId: // value for 'pointOfInterestId'
 *   },
 * });
 */
export function useDeletePointOfInterestFromTabMutation(baseOptions?: Apollo.MutationHookOptions<DeletePointOfInterestFromTabMutation, DeletePointOfInterestFromTabMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeletePointOfInterestFromTabMutation, DeletePointOfInterestFromTabMutationVariables>(DeletePointOfInterestFromTabDocument, options);
      }
export type DeletePointOfInterestFromTabMutationHookResult = ReturnType<typeof useDeletePointOfInterestFromTabMutation>;
export type DeletePointOfInterestFromTabMutationResult = Apollo.MutationResult<DeletePointOfInterestFromTabMutation>;
export type DeletePointOfInterestFromTabMutationOptions = Apollo.BaseMutationOptions<DeletePointOfInterestFromTabMutation, DeletePointOfInterestFromTabMutationVariables>;
export const SelectedPointOfInterestDocument = gql`
    query SelectedPointOfInterest($pointOfInterestId: ID!) {
  pointOfInterest(pointOfInterestId: $pointOfInterestId) {
    id
    templateId
    type
    linkedPointOfInterestIds
    assignee
    dueDate
    status
    isVerified
    deckRelativeHeight
    workpackNumber
    workpack {
      id
      name
      status
    }
    paintRegion {
      id
      name
    }
    parentPaintRegionId {
      id
      name
    }
    template {
      id
      fields {
        id
        name
        type
      }
    }
    location {
      id
      name
    }
    name
    lineMeasurement {
      points {
        coordinates
        templateFieldId
      }
    }
    poiId
    centerPoint3d {
      x
      y
      z
    }
    cameraLocation {
      x
      y
      z
    }
    assembly {
      id
      tagName
      pipeSpec {
        spec
        size
        material
        nominalCorrosionAllowance
        nominalThickness
      }
      structure {
        id
      }
    }
    blister {
      maxHeight
      estimatedHeight
      blisterHeightIndex
      pdrHeight
      heightType
      isManuallyOverridden
      verifiedMaxHeight
      distanceConfidence
      measurementConfidence
      wallLoss {
        percentage
        value
      }
      residualCorrosionAllowance {
        percentage
        value
      }
      residualThickness {
        percentage
        value
      }
      verifiedResidualThickness
      centerPoint {
        bearing
        elevation
      }
      radiusPoint {
        bearing
        elevation
      }
      borders3d {
        points {
          x
          y
          z
        }
      }
      estimatedHeight
      manualSetHeight
      radius
      fittingRadius
      scCategory
    }
    templateData {
      id
      value
      verifiedValue
      templateFieldId
    }
    templateFieldData
    createdByUser {
      id
      name
      picture
      email
      connection
      roleIds {
        name
      }
    }
    createdAt
    screenshotPaths {
      viewer
      viewpoint
    }
    visibility
    deckRelativeHeight
    teams {
      id
      name
    }
    remediationNote
    files {
      id
      name
      caption
      resourcePath
      type
      fileName
      uploadStatus
      imageType
      uuid
    }
    comment
    accessibility
    viewpointRelativeHeight
    remediationNote
    files {
      id
      name
      resourcePath
      type
      fileName
      uploadStatus
      imageType
      uuid
    }
    cuboids {
      id
      position
      rotation
      scale
    }
    isAutoGenerated
    verifiedByUser {
      email
    }
  }
}
    `;

/**
 * __useSelectedPointOfInterestQuery__
 *
 * To run a query within a React component, call `useSelectedPointOfInterestQuery` and pass it any options that fit your needs.
 * When your component renders, `useSelectedPointOfInterestQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSelectedPointOfInterestQuery({
 *   variables: {
 *      pointOfInterestId: // value for 'pointOfInterestId'
 *   },
 * });
 */
export function useSelectedPointOfInterestQuery(baseOptions: Apollo.QueryHookOptions<SelectedPointOfInterestQuery, SelectedPointOfInterestQueryVariables> & ({ variables: SelectedPointOfInterestQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SelectedPointOfInterestQuery, SelectedPointOfInterestQueryVariables>(SelectedPointOfInterestDocument, options);
      }
export function useSelectedPointOfInterestLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SelectedPointOfInterestQuery, SelectedPointOfInterestQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SelectedPointOfInterestQuery, SelectedPointOfInterestQueryVariables>(SelectedPointOfInterestDocument, options);
        }
// @ts-ignore
export function useSelectedPointOfInterestSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<SelectedPointOfInterestQuery, SelectedPointOfInterestQueryVariables>): Apollo.UseSuspenseQueryResult<SelectedPointOfInterestQuery, SelectedPointOfInterestQueryVariables>;
export function useSelectedPointOfInterestSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SelectedPointOfInterestQuery, SelectedPointOfInterestQueryVariables>): Apollo.UseSuspenseQueryResult<SelectedPointOfInterestQuery | undefined, SelectedPointOfInterestQueryVariables>;
export function useSelectedPointOfInterestSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SelectedPointOfInterestQuery, SelectedPointOfInterestQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SelectedPointOfInterestQuery, SelectedPointOfInterestQueryVariables>(SelectedPointOfInterestDocument, options);
        }
export type SelectedPointOfInterestQueryHookResult = ReturnType<typeof useSelectedPointOfInterestQuery>;
export type SelectedPointOfInterestLazyQueryHookResult = ReturnType<typeof useSelectedPointOfInterestLazyQuery>;
export type SelectedPointOfInterestSuspenseQueryHookResult = ReturnType<typeof useSelectedPointOfInterestSuspenseQuery>;
export type SelectedPointOfInterestQueryResult = Apollo.QueryResult<SelectedPointOfInterestQuery, SelectedPointOfInterestQueryVariables>;
export const PointOfInterestsDocument = gql`
    query PointOfInterests($input: PointOfInterestInput, $pageInfo: PageInfo) {
  pointOfInterests(input: $input, pageInfo: $pageInfo) {
    isGoverning
    id
    type
    status
    isVerified
    templateFieldData
    createdByUser {
      name
      picture
      roleIds {
        name
      }
    }
    paintRegion {
      id
      name
      deck {
        name
      }
    }
    paintRegions {
      id
      name
      paintRegionGroup {
        id
        name
        isDefault
      }
    }
    parentPaintRegionId {
      id
      name
    }
    template {
      id
      name
      key
      fields {
        id
        unit
        name
        type
        key
        defaultVisible
      }
    }
    centerPoint3d {
      x
      y
      z
    }
    name
    poiId
    isManuallyCreated
    isAutoGenerated
    assembly {
      id
      tagName
      structure {
        id
      }
    }
    location {
      id
      name
    }
    blister {
      maxHeight
      estimatedHeight
      pdrHeight
      heightType
      isManuallyOverridden
      verifiedMaxHeight
      verifiedResidualThickness
      distanceConfidence
      measurementConfidence
      centerPoint {
        bearing
        elevation
      }
      radiusPoint {
        bearing
        elevation
      }
      wallLoss {
        percentage
        value
      }
      residualCorrosionAllowance {
        percentage
        value
      }
      residualThickness {
        percentage
        value
      }
    }
    templateFieldData
    screenshotPaths {
      viewer
      viewpoint
    }
    files {
      id
      name
      resourcePath
      type
      fileName
      uploadStatus
      caption
      imageType
      uuid
    }
    visibility
    comment
    accessibility
    createdAt
    dueDate
    deckRelativeHeight
    workpackNumber
    workpack {
      id
      name
      status
    }
    cuboids {
      id
      position
      rotation
      scale
    }
  }
  pointOfInterestsCount(input: $input) {
    count
  }
}
    `;

/**
 * __usePointOfInterestsQuery__
 *
 * To run a query within a React component, call `usePointOfInterestsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePointOfInterestsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePointOfInterestsQuery({
 *   variables: {
 *      input: // value for 'input'
 *      pageInfo: // value for 'pageInfo'
 *   },
 * });
 */
export function usePointOfInterestsQuery(baseOptions?: Apollo.QueryHookOptions<PointOfInterestsQuery, PointOfInterestsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PointOfInterestsQuery, PointOfInterestsQueryVariables>(PointOfInterestsDocument, options);
      }
export function usePointOfInterestsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PointOfInterestsQuery, PointOfInterestsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PointOfInterestsQuery, PointOfInterestsQueryVariables>(PointOfInterestsDocument, options);
        }
// @ts-ignore
export function usePointOfInterestsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<PointOfInterestsQuery, PointOfInterestsQueryVariables>): Apollo.UseSuspenseQueryResult<PointOfInterestsQuery, PointOfInterestsQueryVariables>;
export function usePointOfInterestsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PointOfInterestsQuery, PointOfInterestsQueryVariables>): Apollo.UseSuspenseQueryResult<PointOfInterestsQuery | undefined, PointOfInterestsQueryVariables>;
export function usePointOfInterestsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PointOfInterestsQuery, PointOfInterestsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PointOfInterestsQuery, PointOfInterestsQueryVariables>(PointOfInterestsDocument, options);
        }
export type PointOfInterestsQueryHookResult = ReturnType<typeof usePointOfInterestsQuery>;
export type PointOfInterestsLazyQueryHookResult = ReturnType<typeof usePointOfInterestsLazyQuery>;
export type PointOfInterestsSuspenseQueryHookResult = ReturnType<typeof usePointOfInterestsSuspenseQuery>;
export type PointOfInterestsQueryResult = Apollo.QueryResult<PointOfInterestsQuery, PointOfInterestsQueryVariables>;
export const PointOfInterestsCountDocument = gql`
    query pointOfInterestsCount($input: PointOfInterestInput) {
  pointOfInterestsCount(input: $input) {
    count
  }
}
    `;

/**
 * __usePointOfInterestsCountQuery__
 *
 * To run a query within a React component, call `usePointOfInterestsCountQuery` and pass it any options that fit your needs.
 * When your component renders, `usePointOfInterestsCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePointOfInterestsCountQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePointOfInterestsCountQuery(baseOptions?: Apollo.QueryHookOptions<PointOfInterestsCountQuery, PointOfInterestsCountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PointOfInterestsCountQuery, PointOfInterestsCountQueryVariables>(PointOfInterestsCountDocument, options);
      }
export function usePointOfInterestsCountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PointOfInterestsCountQuery, PointOfInterestsCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PointOfInterestsCountQuery, PointOfInterestsCountQueryVariables>(PointOfInterestsCountDocument, options);
        }
// @ts-ignore
export function usePointOfInterestsCountSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<PointOfInterestsCountQuery, PointOfInterestsCountQueryVariables>): Apollo.UseSuspenseQueryResult<PointOfInterestsCountQuery, PointOfInterestsCountQueryVariables>;
export function usePointOfInterestsCountSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PointOfInterestsCountQuery, PointOfInterestsCountQueryVariables>): Apollo.UseSuspenseQueryResult<PointOfInterestsCountQuery | undefined, PointOfInterestsCountQueryVariables>;
export function usePointOfInterestsCountSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PointOfInterestsCountQuery, PointOfInterestsCountQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PointOfInterestsCountQuery, PointOfInterestsCountQueryVariables>(PointOfInterestsCountDocument, options);
        }
export type PointOfInterestsCountQueryHookResult = ReturnType<typeof usePointOfInterestsCountQuery>;
export type PointOfInterestsCountLazyQueryHookResult = ReturnType<typeof usePointOfInterestsCountLazyQuery>;
export type PointOfInterestsCountSuspenseQueryHookResult = ReturnType<typeof usePointOfInterestsCountSuspenseQuery>;
export type PointOfInterestsCountQueryResult = Apollo.QueryResult<PointOfInterestsCountQuery, PointOfInterestsCountQueryVariables>;
export const GetNominationCalculationsDocument = gql`
    query getNominationCalculations($input: NominationCalculationsInput) {
  getNominationCalculations(input: $input) {
    governingValue {
      height
      estimatedWallLoss
      estimatedWallLossPercentage
      residualCorrosionAllowance
      residualCorrosionAllowancePercentage
      residualThickness
      residualThicknessPercentage
    }
    alarmLevel
  }
}
    `;

/**
 * __useGetNominationCalculationsQuery__
 *
 * To run a query within a React component, call `useGetNominationCalculationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetNominationCalculationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetNominationCalculationsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetNominationCalculationsQuery(baseOptions?: Apollo.QueryHookOptions<GetNominationCalculationsQuery, GetNominationCalculationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetNominationCalculationsQuery, GetNominationCalculationsQueryVariables>(GetNominationCalculationsDocument, options);
      }
export function useGetNominationCalculationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetNominationCalculationsQuery, GetNominationCalculationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetNominationCalculationsQuery, GetNominationCalculationsQueryVariables>(GetNominationCalculationsDocument, options);
        }
// @ts-ignore
export function useGetNominationCalculationsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetNominationCalculationsQuery, GetNominationCalculationsQueryVariables>): Apollo.UseSuspenseQueryResult<GetNominationCalculationsQuery, GetNominationCalculationsQueryVariables>;
export function useGetNominationCalculationsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetNominationCalculationsQuery, GetNominationCalculationsQueryVariables>): Apollo.UseSuspenseQueryResult<GetNominationCalculationsQuery | undefined, GetNominationCalculationsQueryVariables>;
export function useGetNominationCalculationsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetNominationCalculationsQuery, GetNominationCalculationsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetNominationCalculationsQuery, GetNominationCalculationsQueryVariables>(GetNominationCalculationsDocument, options);
        }
export type GetNominationCalculationsQueryHookResult = ReturnType<typeof useGetNominationCalculationsQuery>;
export type GetNominationCalculationsLazyQueryHookResult = ReturnType<typeof useGetNominationCalculationsLazyQuery>;
export type GetNominationCalculationsSuspenseQueryHookResult = ReturnType<typeof useGetNominationCalculationsSuspenseQuery>;
export type GetNominationCalculationsQueryResult = Apollo.QueryResult<GetNominationCalculationsQuery, GetNominationCalculationsQueryVariables>;
export const NominateGoverningPointOfInterestDocument = gql`
    mutation NominateGoverningPointOfInterest($input: NominateGoverningPointOfInterestInput) {
  nominateGoverningPointOfInterest(input: $input)
}
    `;
export type NominateGoverningPointOfInterestMutationFn = Apollo.MutationFunction<NominateGoverningPointOfInterestMutation, NominateGoverningPointOfInterestMutationVariables>;

/**
 * __useNominateGoverningPointOfInterestMutation__
 *
 * To run a mutation, you first call `useNominateGoverningPointOfInterestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useNominateGoverningPointOfInterestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [nominateGoverningPointOfInterestMutation, { data, loading, error }] = useNominateGoverningPointOfInterestMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useNominateGoverningPointOfInterestMutation(baseOptions?: Apollo.MutationHookOptions<NominateGoverningPointOfInterestMutation, NominateGoverningPointOfInterestMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<NominateGoverningPointOfInterestMutation, NominateGoverningPointOfInterestMutationVariables>(NominateGoverningPointOfInterestDocument, options);
      }
export type NominateGoverningPointOfInterestMutationHookResult = ReturnType<typeof useNominateGoverningPointOfInterestMutation>;
export type NominateGoverningPointOfInterestMutationResult = Apollo.MutationResult<NominateGoverningPointOfInterestMutation>;
export type NominateGoverningPointOfInterestMutationOptions = Apollo.BaseMutationOptions<NominateGoverningPointOfInterestMutation, NominateGoverningPointOfInterestMutationVariables>;
export const GetRecommendationsForAssemblyDocument = gql`
    query getRecommendationsForAssembly($assemblyId: String!) {
  assembly(assemblyId: $assemblyId) {
    id
    tagName
    recommendation {
      governingValue {
        pointOfInterest {
          id
        }
        blister {
          id
          name
        }
        calculations {
          estimatedWallLoss
          estimatedWallLossPercentage
          height
          residualCorrosionAllowance
          residualCorrosionAllowancePercentage
          residualThickness
          residualThicknessPercentage
        }
      }
    }
    pipeSpec {
      size
      material
      spec
      nominalCorrosionAllowance
      schedule
      nominalThickness
    }
  }
}
    `;

/**
 * __useGetRecommendationsForAssemblyQuery__
 *
 * To run a query within a React component, call `useGetRecommendationsForAssemblyQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRecommendationsForAssemblyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRecommendationsForAssemblyQuery({
 *   variables: {
 *      assemblyId: // value for 'assemblyId'
 *   },
 * });
 */
export function useGetRecommendationsForAssemblyQuery(baseOptions: Apollo.QueryHookOptions<GetRecommendationsForAssemblyQuery, GetRecommendationsForAssemblyQueryVariables> & ({ variables: GetRecommendationsForAssemblyQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRecommendationsForAssemblyQuery, GetRecommendationsForAssemblyQueryVariables>(GetRecommendationsForAssemblyDocument, options);
      }
export function useGetRecommendationsForAssemblyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRecommendationsForAssemblyQuery, GetRecommendationsForAssemblyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRecommendationsForAssemblyQuery, GetRecommendationsForAssemblyQueryVariables>(GetRecommendationsForAssemblyDocument, options);
        }
// @ts-ignore
export function useGetRecommendationsForAssemblySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetRecommendationsForAssemblyQuery, GetRecommendationsForAssemblyQueryVariables>): Apollo.UseSuspenseQueryResult<GetRecommendationsForAssemblyQuery, GetRecommendationsForAssemblyQueryVariables>;
export function useGetRecommendationsForAssemblySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetRecommendationsForAssemblyQuery, GetRecommendationsForAssemblyQueryVariables>): Apollo.UseSuspenseQueryResult<GetRecommendationsForAssemblyQuery | undefined, GetRecommendationsForAssemblyQueryVariables>;
export function useGetRecommendationsForAssemblySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetRecommendationsForAssemblyQuery, GetRecommendationsForAssemblyQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetRecommendationsForAssemblyQuery, GetRecommendationsForAssemblyQueryVariables>(GetRecommendationsForAssemblyDocument, options);
        }
export type GetRecommendationsForAssemblyQueryHookResult = ReturnType<typeof useGetRecommendationsForAssemblyQuery>;
export type GetRecommendationsForAssemblyLazyQueryHookResult = ReturnType<typeof useGetRecommendationsForAssemblyLazyQuery>;
export type GetRecommendationsForAssemblySuspenseQueryHookResult = ReturnType<typeof useGetRecommendationsForAssemblySuspenseQuery>;
export type GetRecommendationsForAssemblyQueryResult = Apollo.QueryResult<GetRecommendationsForAssemblyQuery, GetRecommendationsForAssemblyQueryVariables>;
export const GetOneAssemblyForBlistersDocument = gql`
    query GetOneAssemblyForBlisters($assemblyId: String) {
  assembly(assemblyId: $assemblyId) {
    id
    recommendation {
      governingValue {
        pointOfInterest {
          id
        }
      }
    }
  }
}
    `;

/**
 * __useGetOneAssemblyForBlistersQuery__
 *
 * To run a query within a React component, call `useGetOneAssemblyForBlistersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOneAssemblyForBlistersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOneAssemblyForBlistersQuery({
 *   variables: {
 *      assemblyId: // value for 'assemblyId'
 *   },
 * });
 */
export function useGetOneAssemblyForBlistersQuery(baseOptions?: Apollo.QueryHookOptions<GetOneAssemblyForBlistersQuery, GetOneAssemblyForBlistersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOneAssemblyForBlistersQuery, GetOneAssemblyForBlistersQueryVariables>(GetOneAssemblyForBlistersDocument, options);
      }
export function useGetOneAssemblyForBlistersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOneAssemblyForBlistersQuery, GetOneAssemblyForBlistersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOneAssemblyForBlistersQuery, GetOneAssemblyForBlistersQueryVariables>(GetOneAssemblyForBlistersDocument, options);
        }
// @ts-ignore
export function useGetOneAssemblyForBlistersSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetOneAssemblyForBlistersQuery, GetOneAssemblyForBlistersQueryVariables>): Apollo.UseSuspenseQueryResult<GetOneAssemblyForBlistersQuery, GetOneAssemblyForBlistersQueryVariables>;
export function useGetOneAssemblyForBlistersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetOneAssemblyForBlistersQuery, GetOneAssemblyForBlistersQueryVariables>): Apollo.UseSuspenseQueryResult<GetOneAssemblyForBlistersQuery | undefined, GetOneAssemblyForBlistersQueryVariables>;
export function useGetOneAssemblyForBlistersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetOneAssemblyForBlistersQuery, GetOneAssemblyForBlistersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetOneAssemblyForBlistersQuery, GetOneAssemblyForBlistersQueryVariables>(GetOneAssemblyForBlistersDocument, options);
        }
export type GetOneAssemblyForBlistersQueryHookResult = ReturnType<typeof useGetOneAssemblyForBlistersQuery>;
export type GetOneAssemblyForBlistersLazyQueryHookResult = ReturnType<typeof useGetOneAssemblyForBlistersLazyQuery>;
export type GetOneAssemblyForBlistersSuspenseQueryHookResult = ReturnType<typeof useGetOneAssemblyForBlistersSuspenseQuery>;
export type GetOneAssemblyForBlistersQueryResult = Apollo.QueryResult<GetOneAssemblyForBlistersQuery, GetOneAssemblyForBlistersQueryVariables>;
export const GetOneAssemblyForDefectsDocument = gql`
    query GetOneAssemblyForDefects($assemblyId: String) {
  assembly(assemblyId: $assemblyId) {
    id
    tagName
    recommendation {
      governingValue {
        pointOfInterest {
          id
        }
      }
    }
  }
}
    `;

/**
 * __useGetOneAssemblyForDefectsQuery__
 *
 * To run a query within a React component, call `useGetOneAssemblyForDefectsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOneAssemblyForDefectsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOneAssemblyForDefectsQuery({
 *   variables: {
 *      assemblyId: // value for 'assemblyId'
 *   },
 * });
 */
export function useGetOneAssemblyForDefectsQuery(baseOptions?: Apollo.QueryHookOptions<GetOneAssemblyForDefectsQuery, GetOneAssemblyForDefectsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOneAssemblyForDefectsQuery, GetOneAssemblyForDefectsQueryVariables>(GetOneAssemblyForDefectsDocument, options);
      }
export function useGetOneAssemblyForDefectsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOneAssemblyForDefectsQuery, GetOneAssemblyForDefectsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOneAssemblyForDefectsQuery, GetOneAssemblyForDefectsQueryVariables>(GetOneAssemblyForDefectsDocument, options);
        }
// @ts-ignore
export function useGetOneAssemblyForDefectsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetOneAssemblyForDefectsQuery, GetOneAssemblyForDefectsQueryVariables>): Apollo.UseSuspenseQueryResult<GetOneAssemblyForDefectsQuery, GetOneAssemblyForDefectsQueryVariables>;
export function useGetOneAssemblyForDefectsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetOneAssemblyForDefectsQuery, GetOneAssemblyForDefectsQueryVariables>): Apollo.UseSuspenseQueryResult<GetOneAssemblyForDefectsQuery | undefined, GetOneAssemblyForDefectsQueryVariables>;
export function useGetOneAssemblyForDefectsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetOneAssemblyForDefectsQuery, GetOneAssemblyForDefectsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetOneAssemblyForDefectsQuery, GetOneAssemblyForDefectsQueryVariables>(GetOneAssemblyForDefectsDocument, options);
        }
export type GetOneAssemblyForDefectsQueryHookResult = ReturnType<typeof useGetOneAssemblyForDefectsQuery>;
export type GetOneAssemblyForDefectsLazyQueryHookResult = ReturnType<typeof useGetOneAssemblyForDefectsLazyQuery>;
export type GetOneAssemblyForDefectsSuspenseQueryHookResult = ReturnType<typeof useGetOneAssemblyForDefectsSuspenseQuery>;
export type GetOneAssemblyForDefectsQueryResult = Apollo.QueryResult<GetOneAssemblyForDefectsQuery, GetOneAssemblyForDefectsQueryVariables>;
export const MeasureBlisterDocument = gql`
    query MeasureBlister($locationId: String, $blisterMeasurementPoints: BlisterMeasurementInput) {
  fetchBlisterHeightMeasurement(
    locationId: $locationId
    blisterMeasurementPoints: $blisterMeasurementPoints
  ) {
    blister {
      blisterProfilePlotPoints {
        x
        y
        z
        height
      }
      fittedSurfacePoints {
        x
        y
        z
      }
      maxHeight
      borders3d {
        points {
          x
          y
          z
        }
      }
      centerPoint3d {
        x
        y
        z
      }
    }
    status {
      cacheStatus
      fittingRadius
      targetRadius
      windowSize
    }
  }
}
    `;

/**
 * __useMeasureBlisterQuery__
 *
 * To run a query within a React component, call `useMeasureBlisterQuery` and pass it any options that fit your needs.
 * When your component renders, `useMeasureBlisterQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMeasureBlisterQuery({
 *   variables: {
 *      locationId: // value for 'locationId'
 *      blisterMeasurementPoints: // value for 'blisterMeasurementPoints'
 *   },
 * });
 */
export function useMeasureBlisterQuery(baseOptions?: Apollo.QueryHookOptions<MeasureBlisterQuery, MeasureBlisterQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MeasureBlisterQuery, MeasureBlisterQueryVariables>(MeasureBlisterDocument, options);
      }
export function useMeasureBlisterLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MeasureBlisterQuery, MeasureBlisterQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MeasureBlisterQuery, MeasureBlisterQueryVariables>(MeasureBlisterDocument, options);
        }
// @ts-ignore
export function useMeasureBlisterSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<MeasureBlisterQuery, MeasureBlisterQueryVariables>): Apollo.UseSuspenseQueryResult<MeasureBlisterQuery, MeasureBlisterQueryVariables>;
export function useMeasureBlisterSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MeasureBlisterQuery, MeasureBlisterQueryVariables>): Apollo.UseSuspenseQueryResult<MeasureBlisterQuery | undefined, MeasureBlisterQueryVariables>;
export function useMeasureBlisterSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MeasureBlisterQuery, MeasureBlisterQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MeasureBlisterQuery, MeasureBlisterQueryVariables>(MeasureBlisterDocument, options);
        }
export type MeasureBlisterQueryHookResult = ReturnType<typeof useMeasureBlisterQuery>;
export type MeasureBlisterLazyQueryHookResult = ReturnType<typeof useMeasureBlisterLazyQuery>;
export type MeasureBlisterSuspenseQueryHookResult = ReturnType<typeof useMeasureBlisterSuspenseQuery>;
export type MeasureBlisterQueryResult = Apollo.QueryResult<MeasureBlisterQuery, MeasureBlisterQueryVariables>;
export const GetAssemblyPipeSpecByIdDocument = gql`
    query getAssemblyPipeSpecByID($assemblyId: String) {
  assembly(assemblyId: $assemblyId) {
    id
    pipeSpec {
      material
      nominalCorrosionAllowance
      nominalThickness
      schedule
      size
      spec
    }
  }
}
    `;

/**
 * __useGetAssemblyPipeSpecByIdQuery__
 *
 * To run a query within a React component, call `useGetAssemblyPipeSpecByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAssemblyPipeSpecByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAssemblyPipeSpecByIdQuery({
 *   variables: {
 *      assemblyId: // value for 'assemblyId'
 *   },
 * });
 */
export function useGetAssemblyPipeSpecByIdQuery(baseOptions?: Apollo.QueryHookOptions<GetAssemblyPipeSpecByIdQuery, GetAssemblyPipeSpecByIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAssemblyPipeSpecByIdQuery, GetAssemblyPipeSpecByIdQueryVariables>(GetAssemblyPipeSpecByIdDocument, options);
      }
export function useGetAssemblyPipeSpecByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAssemblyPipeSpecByIdQuery, GetAssemblyPipeSpecByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAssemblyPipeSpecByIdQuery, GetAssemblyPipeSpecByIdQueryVariables>(GetAssemblyPipeSpecByIdDocument, options);
        }
// @ts-ignore
export function useGetAssemblyPipeSpecByIdSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetAssemblyPipeSpecByIdQuery, GetAssemblyPipeSpecByIdQueryVariables>): Apollo.UseSuspenseQueryResult<GetAssemblyPipeSpecByIdQuery, GetAssemblyPipeSpecByIdQueryVariables>;
export function useGetAssemblyPipeSpecByIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAssemblyPipeSpecByIdQuery, GetAssemblyPipeSpecByIdQueryVariables>): Apollo.UseSuspenseQueryResult<GetAssemblyPipeSpecByIdQuery | undefined, GetAssemblyPipeSpecByIdQueryVariables>;
export function useGetAssemblyPipeSpecByIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAssemblyPipeSpecByIdQuery, GetAssemblyPipeSpecByIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAssemblyPipeSpecByIdQuery, GetAssemblyPipeSpecByIdQueryVariables>(GetAssemblyPipeSpecByIdDocument, options);
        }
export type GetAssemblyPipeSpecByIdQueryHookResult = ReturnType<typeof useGetAssemblyPipeSpecByIdQuery>;
export type GetAssemblyPipeSpecByIdLazyQueryHookResult = ReturnType<typeof useGetAssemblyPipeSpecByIdLazyQuery>;
export type GetAssemblyPipeSpecByIdSuspenseQueryHookResult = ReturnType<typeof useGetAssemblyPipeSpecByIdSuspenseQuery>;
export type GetAssemblyPipeSpecByIdQueryResult = Apollo.QueryResult<GetAssemblyPipeSpecByIdQuery, GetAssemblyPipeSpecByIdQueryVariables>;
export const GetAllTeamsForCreateOrEditPoiDocument = gql`
    query GetAllTeamsForCreateOrEditPoi {
  allTeams {
    id
    name
  }
}
    `;

/**
 * __useGetAllTeamsForCreateOrEditPoiQuery__
 *
 * To run a query within a React component, call `useGetAllTeamsForCreateOrEditPoiQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllTeamsForCreateOrEditPoiQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllTeamsForCreateOrEditPoiQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAllTeamsForCreateOrEditPoiQuery(baseOptions?: Apollo.QueryHookOptions<GetAllTeamsForCreateOrEditPoiQuery, GetAllTeamsForCreateOrEditPoiQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllTeamsForCreateOrEditPoiQuery, GetAllTeamsForCreateOrEditPoiQueryVariables>(GetAllTeamsForCreateOrEditPoiDocument, options);
      }
export function useGetAllTeamsForCreateOrEditPoiLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllTeamsForCreateOrEditPoiQuery, GetAllTeamsForCreateOrEditPoiQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllTeamsForCreateOrEditPoiQuery, GetAllTeamsForCreateOrEditPoiQueryVariables>(GetAllTeamsForCreateOrEditPoiDocument, options);
        }
// @ts-ignore
export function useGetAllTeamsForCreateOrEditPoiSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetAllTeamsForCreateOrEditPoiQuery, GetAllTeamsForCreateOrEditPoiQueryVariables>): Apollo.UseSuspenseQueryResult<GetAllTeamsForCreateOrEditPoiQuery, GetAllTeamsForCreateOrEditPoiQueryVariables>;
export function useGetAllTeamsForCreateOrEditPoiSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAllTeamsForCreateOrEditPoiQuery, GetAllTeamsForCreateOrEditPoiQueryVariables>): Apollo.UseSuspenseQueryResult<GetAllTeamsForCreateOrEditPoiQuery | undefined, GetAllTeamsForCreateOrEditPoiQueryVariables>;
export function useGetAllTeamsForCreateOrEditPoiSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAllTeamsForCreateOrEditPoiQuery, GetAllTeamsForCreateOrEditPoiQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAllTeamsForCreateOrEditPoiQuery, GetAllTeamsForCreateOrEditPoiQueryVariables>(GetAllTeamsForCreateOrEditPoiDocument, options);
        }
export type GetAllTeamsForCreateOrEditPoiQueryHookResult = ReturnType<typeof useGetAllTeamsForCreateOrEditPoiQuery>;
export type GetAllTeamsForCreateOrEditPoiLazyQueryHookResult = ReturnType<typeof useGetAllTeamsForCreateOrEditPoiLazyQuery>;
export type GetAllTeamsForCreateOrEditPoiSuspenseQueryHookResult = ReturnType<typeof useGetAllTeamsForCreateOrEditPoiSuspenseQuery>;
export type GetAllTeamsForCreateOrEditPoiQueryResult = Apollo.QueryResult<GetAllTeamsForCreateOrEditPoiQuery, GetAllTeamsForCreateOrEditPoiQueryVariables>;
export const DeletePointOfInterestFromCreateOrEditDocument = gql`
    mutation DeletePointOfInterestFromCreateOrEdit($pointOfInterestId: ID!) {
  archivePointOfInterest(pointOfInterestId: $pointOfInterestId) {
    id
    type
  }
}
    `;
export type DeletePointOfInterestFromCreateOrEditMutationFn = Apollo.MutationFunction<DeletePointOfInterestFromCreateOrEditMutation, DeletePointOfInterestFromCreateOrEditMutationVariables>;

/**
 * __useDeletePointOfInterestFromCreateOrEditMutation__
 *
 * To run a mutation, you first call `useDeletePointOfInterestFromCreateOrEditMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeletePointOfInterestFromCreateOrEditMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deletePointOfInterestFromCreateOrEditMutation, { data, loading, error }] = useDeletePointOfInterestFromCreateOrEditMutation({
 *   variables: {
 *      pointOfInterestId: // value for 'pointOfInterestId'
 *   },
 * });
 */
export function useDeletePointOfInterestFromCreateOrEditMutation(baseOptions?: Apollo.MutationHookOptions<DeletePointOfInterestFromCreateOrEditMutation, DeletePointOfInterestFromCreateOrEditMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeletePointOfInterestFromCreateOrEditMutation, DeletePointOfInterestFromCreateOrEditMutationVariables>(DeletePointOfInterestFromCreateOrEditDocument, options);
      }
export type DeletePointOfInterestFromCreateOrEditMutationHookResult = ReturnType<typeof useDeletePointOfInterestFromCreateOrEditMutation>;
export type DeletePointOfInterestFromCreateOrEditMutationResult = Apollo.MutationResult<DeletePointOfInterestFromCreateOrEditMutation>;
export type DeletePointOfInterestFromCreateOrEditMutationOptions = Apollo.BaseMutationOptions<DeletePointOfInterestFromCreateOrEditMutation, DeletePointOfInterestFromCreateOrEditMutationVariables>;
export const SavePointOfInterestScreenshotDocument = gql`
    mutation SavePointOfInterestScreenshot($input: SavePointOfInterestScreenshotInput) {
  savePointOfInterestScreenshot(input: $input) {
    id
  }
}
    `;
export type SavePointOfInterestScreenshotMutationFn = Apollo.MutationFunction<SavePointOfInterestScreenshotMutation, SavePointOfInterestScreenshotMutationVariables>;

/**
 * __useSavePointOfInterestScreenshotMutation__
 *
 * To run a mutation, you first call `useSavePointOfInterestScreenshotMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSavePointOfInterestScreenshotMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [savePointOfInterestScreenshotMutation, { data, loading, error }] = useSavePointOfInterestScreenshotMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSavePointOfInterestScreenshotMutation(baseOptions?: Apollo.MutationHookOptions<SavePointOfInterestScreenshotMutation, SavePointOfInterestScreenshotMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SavePointOfInterestScreenshotMutation, SavePointOfInterestScreenshotMutationVariables>(SavePointOfInterestScreenshotDocument, options);
      }
export type SavePointOfInterestScreenshotMutationHookResult = ReturnType<typeof useSavePointOfInterestScreenshotMutation>;
export type SavePointOfInterestScreenshotMutationResult = Apollo.MutationResult<SavePointOfInterestScreenshotMutation>;
export type SavePointOfInterestScreenshotMutationOptions = Apollo.BaseMutationOptions<SavePointOfInterestScreenshotMutation, SavePointOfInterestScreenshotMutationVariables>;
export const UpdatePointOfInterestFileDocument = gql`
    mutation UpdatePointOfInterestFile($input: InputUpdateFileForPointOfInterest) {
  updatePointOfInterestFile(input: $input) {
    id
  }
}
    `;
export type UpdatePointOfInterestFileMutationFn = Apollo.MutationFunction<UpdatePointOfInterestFileMutation, UpdatePointOfInterestFileMutationVariables>;

/**
 * __useUpdatePointOfInterestFileMutation__
 *
 * To run a mutation, you first call `useUpdatePointOfInterestFileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePointOfInterestFileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePointOfInterestFileMutation, { data, loading, error }] = useUpdatePointOfInterestFileMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdatePointOfInterestFileMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePointOfInterestFileMutation, UpdatePointOfInterestFileMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePointOfInterestFileMutation, UpdatePointOfInterestFileMutationVariables>(UpdatePointOfInterestFileDocument, options);
      }
export type UpdatePointOfInterestFileMutationHookResult = ReturnType<typeof useUpdatePointOfInterestFileMutation>;
export type UpdatePointOfInterestFileMutationResult = Apollo.MutationResult<UpdatePointOfInterestFileMutation>;
export type UpdatePointOfInterestFileMutationOptions = Apollo.BaseMutationOptions<UpdatePointOfInterestFileMutation, UpdatePointOfInterestFileMutationVariables>;
export const FetchGenerateImageDocument = gql`
    query FetchGenerateImage($input: GenerateImageInput) {
  fetchGenerateImage(input: $input) {
    imageData
  }
}
    `;

/**
 * __useFetchGenerateImageQuery__
 *
 * To run a query within a React component, call `useFetchGenerateImageQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchGenerateImageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchGenerateImageQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useFetchGenerateImageQuery(baseOptions?: Apollo.QueryHookOptions<FetchGenerateImageQuery, FetchGenerateImageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchGenerateImageQuery, FetchGenerateImageQueryVariables>(FetchGenerateImageDocument, options);
      }
export function useFetchGenerateImageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchGenerateImageQuery, FetchGenerateImageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchGenerateImageQuery, FetchGenerateImageQueryVariables>(FetchGenerateImageDocument, options);
        }
// @ts-ignore
export function useFetchGenerateImageSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<FetchGenerateImageQuery, FetchGenerateImageQueryVariables>): Apollo.UseSuspenseQueryResult<FetchGenerateImageQuery, FetchGenerateImageQueryVariables>;
export function useFetchGenerateImageSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FetchGenerateImageQuery, FetchGenerateImageQueryVariables>): Apollo.UseSuspenseQueryResult<FetchGenerateImageQuery | undefined, FetchGenerateImageQueryVariables>;
export function useFetchGenerateImageSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FetchGenerateImageQuery, FetchGenerateImageQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FetchGenerateImageQuery, FetchGenerateImageQueryVariables>(FetchGenerateImageDocument, options);
        }
export type FetchGenerateImageQueryHookResult = ReturnType<typeof useFetchGenerateImageQuery>;
export type FetchGenerateImageLazyQueryHookResult = ReturnType<typeof useFetchGenerateImageLazyQuery>;
export type FetchGenerateImageSuspenseQueryHookResult = ReturnType<typeof useFetchGenerateImageSuspenseQuery>;
export type FetchGenerateImageQueryResult = Apollo.QueryResult<FetchGenerateImageQuery, FetchGenerateImageQueryVariables>;
export const FetchCropFromRectilinearDocument = gql`
    query FetchCropFromRectilinear($input: GenerateCropFromRectilinearInput) {
  fetchCropFromRectilinear(input: $input) {
    imageData
  }
}
    `;

/**
 * __useFetchCropFromRectilinearQuery__
 *
 * To run a query within a React component, call `useFetchCropFromRectilinearQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchCropFromRectilinearQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchCropFromRectilinearQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useFetchCropFromRectilinearQuery(baseOptions?: Apollo.QueryHookOptions<FetchCropFromRectilinearQuery, FetchCropFromRectilinearQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchCropFromRectilinearQuery, FetchCropFromRectilinearQueryVariables>(FetchCropFromRectilinearDocument, options);
      }
export function useFetchCropFromRectilinearLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchCropFromRectilinearQuery, FetchCropFromRectilinearQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchCropFromRectilinearQuery, FetchCropFromRectilinearQueryVariables>(FetchCropFromRectilinearDocument, options);
        }
// @ts-ignore
export function useFetchCropFromRectilinearSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<FetchCropFromRectilinearQuery, FetchCropFromRectilinearQueryVariables>): Apollo.UseSuspenseQueryResult<FetchCropFromRectilinearQuery, FetchCropFromRectilinearQueryVariables>;
export function useFetchCropFromRectilinearSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FetchCropFromRectilinearQuery, FetchCropFromRectilinearQueryVariables>): Apollo.UseSuspenseQueryResult<FetchCropFromRectilinearQuery | undefined, FetchCropFromRectilinearQueryVariables>;
export function useFetchCropFromRectilinearSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FetchCropFromRectilinearQuery, FetchCropFromRectilinearQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FetchCropFromRectilinearQuery, FetchCropFromRectilinearQueryVariables>(FetchCropFromRectilinearDocument, options);
        }
export type FetchCropFromRectilinearQueryHookResult = ReturnType<typeof useFetchCropFromRectilinearQuery>;
export type FetchCropFromRectilinearLazyQueryHookResult = ReturnType<typeof useFetchCropFromRectilinearLazyQuery>;
export type FetchCropFromRectilinearSuspenseQueryHookResult = ReturnType<typeof useFetchCropFromRectilinearSuspenseQuery>;
export type FetchCropFromRectilinearQueryResult = Apollo.QueryResult<FetchCropFromRectilinearQuery, FetchCropFromRectilinearQueryVariables>;
export const GetStructureFeaturesDocument = gql`
    query getStructureFeatures($structureId: String!) {
  structure(structureId: $structureId) {
    id
    features
  }
}
    `;

/**
 * __useGetStructureFeaturesQuery__
 *
 * To run a query within a React component, call `useGetStructureFeaturesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetStructureFeaturesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetStructureFeaturesQuery({
 *   variables: {
 *      structureId: // value for 'structureId'
 *   },
 * });
 */
export function useGetStructureFeaturesQuery(baseOptions: Apollo.QueryHookOptions<GetStructureFeaturesQuery, GetStructureFeaturesQueryVariables> & ({ variables: GetStructureFeaturesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetStructureFeaturesQuery, GetStructureFeaturesQueryVariables>(GetStructureFeaturesDocument, options);
      }
export function useGetStructureFeaturesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetStructureFeaturesQuery, GetStructureFeaturesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetStructureFeaturesQuery, GetStructureFeaturesQueryVariables>(GetStructureFeaturesDocument, options);
        }
// @ts-ignore
export function useGetStructureFeaturesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetStructureFeaturesQuery, GetStructureFeaturesQueryVariables>): Apollo.UseSuspenseQueryResult<GetStructureFeaturesQuery, GetStructureFeaturesQueryVariables>;
export function useGetStructureFeaturesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetStructureFeaturesQuery, GetStructureFeaturesQueryVariables>): Apollo.UseSuspenseQueryResult<GetStructureFeaturesQuery | undefined, GetStructureFeaturesQueryVariables>;
export function useGetStructureFeaturesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetStructureFeaturesQuery, GetStructureFeaturesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetStructureFeaturesQuery, GetStructureFeaturesQueryVariables>(GetStructureFeaturesDocument, options);
        }
export type GetStructureFeaturesQueryHookResult = ReturnType<typeof useGetStructureFeaturesQuery>;
export type GetStructureFeaturesLazyQueryHookResult = ReturnType<typeof useGetStructureFeaturesLazyQuery>;
export type GetStructureFeaturesSuspenseQueryHookResult = ReturnType<typeof useGetStructureFeaturesSuspenseQuery>;
export type GetStructureFeaturesQueryResult = Apollo.QueryResult<GetStructureFeaturesQuery, GetStructureFeaturesQueryVariables>;
export const GetAllAssembliesDocument = gql`
    query getAllAssemblies($structureId: String!) {
  allAssemblies(structureId: $structureId) {
    id
    service {
      code
    }
    tagName
    recommendation {
      analysisStatus
      analysisRecommendation {
        recommendationByUserName
        alarmLevel
        supportingComment
        additionalComments
        internalTeamComments
      }
      governingValue {
        calculations {
          height
          estimatedWallLoss
          estimatedWallLossPercentage
          residualCorrosionAllowance
          residualCorrosionAllowancePercentage
          residualThickness
          residualThicknessPercentage
        }
      }
    }
    pipeSpec {
      size
      spec
      material
      nominalCorrosionAllowance
      schedule
      nominalThickness
    }
  }
  structure(structureId: $structureId) {
    name
  }
}
    `;

/**
 * __useGetAllAssembliesQuery__
 *
 * To run a query within a React component, call `useGetAllAssembliesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllAssembliesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllAssembliesQuery({
 *   variables: {
 *      structureId: // value for 'structureId'
 *   },
 * });
 */
export function useGetAllAssembliesQuery(baseOptions: Apollo.QueryHookOptions<GetAllAssembliesQuery, GetAllAssembliesQueryVariables> & ({ variables: GetAllAssembliesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllAssembliesQuery, GetAllAssembliesQueryVariables>(GetAllAssembliesDocument, options);
      }
export function useGetAllAssembliesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllAssembliesQuery, GetAllAssembliesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllAssembliesQuery, GetAllAssembliesQueryVariables>(GetAllAssembliesDocument, options);
        }
// @ts-ignore
export function useGetAllAssembliesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetAllAssembliesQuery, GetAllAssembliesQueryVariables>): Apollo.UseSuspenseQueryResult<GetAllAssembliesQuery, GetAllAssembliesQueryVariables>;
export function useGetAllAssembliesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAllAssembliesQuery, GetAllAssembliesQueryVariables>): Apollo.UseSuspenseQueryResult<GetAllAssembliesQuery | undefined, GetAllAssembliesQueryVariables>;
export function useGetAllAssembliesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAllAssembliesQuery, GetAllAssembliesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAllAssembliesQuery, GetAllAssembliesQueryVariables>(GetAllAssembliesDocument, options);
        }
export type GetAllAssembliesQueryHookResult = ReturnType<typeof useGetAllAssembliesQuery>;
export type GetAllAssembliesLazyQueryHookResult = ReturnType<typeof useGetAllAssembliesLazyQuery>;
export type GetAllAssembliesSuspenseQueryHookResult = ReturnType<typeof useGetAllAssembliesSuspenseQuery>;
export type GetAllAssembliesQueryResult = Apollo.QueryResult<GetAllAssembliesQuery, GetAllAssembliesQueryVariables>;
export const AllPointOfInterestsForStructureDocument = gql`
    query allPointOfInterestsForStructure($input: FindAllPointOfInterestsInput) {
  allPointOfInterests(input: $input) {
    type
    assembly {
      id
    }
  }
}
    `;

/**
 * __useAllPointOfInterestsForStructureQuery__
 *
 * To run a query within a React component, call `useAllPointOfInterestsForStructureQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllPointOfInterestsForStructureQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllPointOfInterestsForStructureQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAllPointOfInterestsForStructureQuery(baseOptions?: Apollo.QueryHookOptions<AllPointOfInterestsForStructureQuery, AllPointOfInterestsForStructureQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AllPointOfInterestsForStructureQuery, AllPointOfInterestsForStructureQueryVariables>(AllPointOfInterestsForStructureDocument, options);
      }
export function useAllPointOfInterestsForStructureLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AllPointOfInterestsForStructureQuery, AllPointOfInterestsForStructureQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AllPointOfInterestsForStructureQuery, AllPointOfInterestsForStructureQueryVariables>(AllPointOfInterestsForStructureDocument, options);
        }
// @ts-ignore
export function useAllPointOfInterestsForStructureSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<AllPointOfInterestsForStructureQuery, AllPointOfInterestsForStructureQueryVariables>): Apollo.UseSuspenseQueryResult<AllPointOfInterestsForStructureQuery, AllPointOfInterestsForStructureQueryVariables>;
export function useAllPointOfInterestsForStructureSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AllPointOfInterestsForStructureQuery, AllPointOfInterestsForStructureQueryVariables>): Apollo.UseSuspenseQueryResult<AllPointOfInterestsForStructureQuery | undefined, AllPointOfInterestsForStructureQueryVariables>;
export function useAllPointOfInterestsForStructureSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AllPointOfInterestsForStructureQuery, AllPointOfInterestsForStructureQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AllPointOfInterestsForStructureQuery, AllPointOfInterestsForStructureQueryVariables>(AllPointOfInterestsForStructureDocument, options);
        }
export type AllPointOfInterestsForStructureQueryHookResult = ReturnType<typeof useAllPointOfInterestsForStructureQuery>;
export type AllPointOfInterestsForStructureLazyQueryHookResult = ReturnType<typeof useAllPointOfInterestsForStructureLazyQuery>;
export type AllPointOfInterestsForStructureSuspenseQueryHookResult = ReturnType<typeof useAllPointOfInterestsForStructureSuspenseQuery>;
export type AllPointOfInterestsForStructureQueryResult = Apollo.QueryResult<AllPointOfInterestsForStructureQuery, AllPointOfInterestsForStructureQueryVariables>;
export const GetAssemblyDetailsDocument = gql`
    query getAssemblyDetails($assemblyId: String) {
  assembly(assemblyId: $assemblyId) {
    id
    tagName
    area
    generalAttachmentsNote
    seenByViewpoints {
      location {
        id
        name
      }
      corrosion {
        primaryCategory
      }
      distance
    }
    recommendation {
      analysisRecommendation {
        alarmLevel
      }
    }
    corrosionLevel
    template {
      id
      name
      type
      fields {
        id
        name
        type
        detailFieldKey
      }
      equipmentDetails {
        id
        name
        subType
        type
        options {
          id
          name
          type
          fieldKey
        }
        fieldKey
      }
    }
    templateFieldData
    box {
      min {
        x
        y
        z
      }
      max {
        x
        y
        z
      }
    }
    focalPoint {
      x
      y
      z
    }
    cameraPose {
      position {
        x
        y
        z
      }
      lookAt {
        x
        y
        z
      }
    }
    cadModelPath
    files {
      id
      name
      resourcePath
      type
      caption
      fileName
      uploadStatus
      imageType
      uuid
    }
    isUncontextualized
    pipeSpec {
      size
      material
      spec
      nominalCorrosionAllowance
      schedule
      nominalThickness
    }
  }
}
    `;

/**
 * __useGetAssemblyDetailsQuery__
 *
 * To run a query within a React component, call `useGetAssemblyDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAssemblyDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAssemblyDetailsQuery({
 *   variables: {
 *      assemblyId: // value for 'assemblyId'
 *   },
 * });
 */
export function useGetAssemblyDetailsQuery(baseOptions?: Apollo.QueryHookOptions<GetAssemblyDetailsQuery, GetAssemblyDetailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAssemblyDetailsQuery, GetAssemblyDetailsQueryVariables>(GetAssemblyDetailsDocument, options);
      }
export function useGetAssemblyDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAssemblyDetailsQuery, GetAssemblyDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAssemblyDetailsQuery, GetAssemblyDetailsQueryVariables>(GetAssemblyDetailsDocument, options);
        }
// @ts-ignore
export function useGetAssemblyDetailsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetAssemblyDetailsQuery, GetAssemblyDetailsQueryVariables>): Apollo.UseSuspenseQueryResult<GetAssemblyDetailsQuery, GetAssemblyDetailsQueryVariables>;
export function useGetAssemblyDetailsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAssemblyDetailsQuery, GetAssemblyDetailsQueryVariables>): Apollo.UseSuspenseQueryResult<GetAssemblyDetailsQuery | undefined, GetAssemblyDetailsQueryVariables>;
export function useGetAssemblyDetailsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAssemblyDetailsQuery, GetAssemblyDetailsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAssemblyDetailsQuery, GetAssemblyDetailsQueryVariables>(GetAssemblyDetailsDocument, options);
        }
export type GetAssemblyDetailsQueryHookResult = ReturnType<typeof useGetAssemblyDetailsQuery>;
export type GetAssemblyDetailsLazyQueryHookResult = ReturnType<typeof useGetAssemblyDetailsLazyQuery>;
export type GetAssemblyDetailsSuspenseQueryHookResult = ReturnType<typeof useGetAssemblyDetailsSuspenseQuery>;
export type GetAssemblyDetailsQueryResult = Apollo.QueryResult<GetAssemblyDetailsQuery, GetAssemblyDetailsQueryVariables>;
export const GetAssemblyViewpointsDocument = gql`
    query getAssemblyViewpoints($assemblyId: String!) {
  assembly(assemblyId: $assemblyId) {
    id
    seenByViewpoints {
      location {
        id
        name
      }
    }
  }
}
    `;

/**
 * __useGetAssemblyViewpointsQuery__
 *
 * To run a query within a React component, call `useGetAssemblyViewpointsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAssemblyViewpointsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAssemblyViewpointsQuery({
 *   variables: {
 *      assemblyId: // value for 'assemblyId'
 *   },
 * });
 */
export function useGetAssemblyViewpointsQuery(baseOptions: Apollo.QueryHookOptions<GetAssemblyViewpointsQuery, GetAssemblyViewpointsQueryVariables> & ({ variables: GetAssemblyViewpointsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAssemblyViewpointsQuery, GetAssemblyViewpointsQueryVariables>(GetAssemblyViewpointsDocument, options);
      }
export function useGetAssemblyViewpointsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAssemblyViewpointsQuery, GetAssemblyViewpointsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAssemblyViewpointsQuery, GetAssemblyViewpointsQueryVariables>(GetAssemblyViewpointsDocument, options);
        }
// @ts-ignore
export function useGetAssemblyViewpointsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetAssemblyViewpointsQuery, GetAssemblyViewpointsQueryVariables>): Apollo.UseSuspenseQueryResult<GetAssemblyViewpointsQuery, GetAssemblyViewpointsQueryVariables>;
export function useGetAssemblyViewpointsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAssemblyViewpointsQuery, GetAssemblyViewpointsQueryVariables>): Apollo.UseSuspenseQueryResult<GetAssemblyViewpointsQuery | undefined, GetAssemblyViewpointsQueryVariables>;
export function useGetAssemblyViewpointsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAssemblyViewpointsQuery, GetAssemblyViewpointsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAssemblyViewpointsQuery, GetAssemblyViewpointsQueryVariables>(GetAssemblyViewpointsDocument, options);
        }
export type GetAssemblyViewpointsQueryHookResult = ReturnType<typeof useGetAssemblyViewpointsQuery>;
export type GetAssemblyViewpointsLazyQueryHookResult = ReturnType<typeof useGetAssemblyViewpointsLazyQuery>;
export type GetAssemblyViewpointsSuspenseQueryHookResult = ReturnType<typeof useGetAssemblyViewpointsSuspenseQuery>;
export type GetAssemblyViewpointsQueryResult = Apollo.QueryResult<GetAssemblyViewpointsQuery, GetAssemblyViewpointsQueryVariables>;
export const InlineUpdateSingleAssemblyTemplateFieldDataDocument = gql`
    mutation InlineUpdateSingleAssemblyTemplateFieldData($input: UpdateSingleTemplateFieldDataInput) {
  updateSingleTemplateFieldData(input: $input) {
    templateFieldData
  }
}
    `;
export type InlineUpdateSingleAssemblyTemplateFieldDataMutationFn = Apollo.MutationFunction<InlineUpdateSingleAssemblyTemplateFieldDataMutation, InlineUpdateSingleAssemblyTemplateFieldDataMutationVariables>;

/**
 * __useInlineUpdateSingleAssemblyTemplateFieldDataMutation__
 *
 * To run a mutation, you first call `useInlineUpdateSingleAssemblyTemplateFieldDataMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInlineUpdateSingleAssemblyTemplateFieldDataMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [inlineUpdateSingleAssemblyTemplateFieldDataMutation, { data, loading, error }] = useInlineUpdateSingleAssemblyTemplateFieldDataMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useInlineUpdateSingleAssemblyTemplateFieldDataMutation(baseOptions?: Apollo.MutationHookOptions<InlineUpdateSingleAssemblyTemplateFieldDataMutation, InlineUpdateSingleAssemblyTemplateFieldDataMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InlineUpdateSingleAssemblyTemplateFieldDataMutation, InlineUpdateSingleAssemblyTemplateFieldDataMutationVariables>(InlineUpdateSingleAssemblyTemplateFieldDataDocument, options);
      }
export type InlineUpdateSingleAssemblyTemplateFieldDataMutationHookResult = ReturnType<typeof useInlineUpdateSingleAssemblyTemplateFieldDataMutation>;
export type InlineUpdateSingleAssemblyTemplateFieldDataMutationResult = Apollo.MutationResult<InlineUpdateSingleAssemblyTemplateFieldDataMutation>;
export type InlineUpdateSingleAssemblyTemplateFieldDataMutationOptions = Apollo.BaseMutationOptions<InlineUpdateSingleAssemblyTemplateFieldDataMutation, InlineUpdateSingleAssemblyTemplateFieldDataMutationVariables>;
export const DefectLegendsForEquipmentDocument = gql`
    query DefectLegendsForEquipment($structureId: String) {
  structure(structureId: $structureId) {
    id
    defectLegends {
      id
      name
      groupKey
      groupName
      color
    }
  }
}
    `;

/**
 * __useDefectLegendsForEquipmentQuery__
 *
 * To run a query within a React component, call `useDefectLegendsForEquipmentQuery` and pass it any options that fit your needs.
 * When your component renders, `useDefectLegendsForEquipmentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDefectLegendsForEquipmentQuery({
 *   variables: {
 *      structureId: // value for 'structureId'
 *   },
 * });
 */
export function useDefectLegendsForEquipmentQuery(baseOptions?: Apollo.QueryHookOptions<DefectLegendsForEquipmentQuery, DefectLegendsForEquipmentQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DefectLegendsForEquipmentQuery, DefectLegendsForEquipmentQueryVariables>(DefectLegendsForEquipmentDocument, options);
      }
export function useDefectLegendsForEquipmentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DefectLegendsForEquipmentQuery, DefectLegendsForEquipmentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DefectLegendsForEquipmentQuery, DefectLegendsForEquipmentQueryVariables>(DefectLegendsForEquipmentDocument, options);
        }
// @ts-ignore
export function useDefectLegendsForEquipmentSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<DefectLegendsForEquipmentQuery, DefectLegendsForEquipmentQueryVariables>): Apollo.UseSuspenseQueryResult<DefectLegendsForEquipmentQuery, DefectLegendsForEquipmentQueryVariables>;
export function useDefectLegendsForEquipmentSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DefectLegendsForEquipmentQuery, DefectLegendsForEquipmentQueryVariables>): Apollo.UseSuspenseQueryResult<DefectLegendsForEquipmentQuery | undefined, DefectLegendsForEquipmentQueryVariables>;
export function useDefectLegendsForEquipmentSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DefectLegendsForEquipmentQuery, DefectLegendsForEquipmentQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DefectLegendsForEquipmentQuery, DefectLegendsForEquipmentQueryVariables>(DefectLegendsForEquipmentDocument, options);
        }
export type DefectLegendsForEquipmentQueryHookResult = ReturnType<typeof useDefectLegendsForEquipmentQuery>;
export type DefectLegendsForEquipmentLazyQueryHookResult = ReturnType<typeof useDefectLegendsForEquipmentLazyQuery>;
export type DefectLegendsForEquipmentSuspenseQueryHookResult = ReturnType<typeof useDefectLegendsForEquipmentSuspenseQuery>;
export type DefectLegendsForEquipmentQueryResult = Apollo.QueryResult<DefectLegendsForEquipmentQuery, DefectLegendsForEquipmentQueryVariables>;
export const StructureTemplateByTypeDocument = gql`
    query StructureTemplateByType($structureId: ID, $type: TemplateTypeEnum) {
  allTemplates(structureId: $structureId, type: $type) {
    id
    name
    type
    fields {
      id
      name
      key
    }
  }
}
    `;

/**
 * __useStructureTemplateByTypeQuery__
 *
 * To run a query within a React component, call `useStructureTemplateByTypeQuery` and pass it any options that fit your needs.
 * When your component renders, `useStructureTemplateByTypeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStructureTemplateByTypeQuery({
 *   variables: {
 *      structureId: // value for 'structureId'
 *      type: // value for 'type'
 *   },
 * });
 */
export function useStructureTemplateByTypeQuery(baseOptions?: Apollo.QueryHookOptions<StructureTemplateByTypeQuery, StructureTemplateByTypeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<StructureTemplateByTypeQuery, StructureTemplateByTypeQueryVariables>(StructureTemplateByTypeDocument, options);
      }
export function useStructureTemplateByTypeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<StructureTemplateByTypeQuery, StructureTemplateByTypeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<StructureTemplateByTypeQuery, StructureTemplateByTypeQueryVariables>(StructureTemplateByTypeDocument, options);
        }
// @ts-ignore
export function useStructureTemplateByTypeSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<StructureTemplateByTypeQuery, StructureTemplateByTypeQueryVariables>): Apollo.UseSuspenseQueryResult<StructureTemplateByTypeQuery, StructureTemplateByTypeQueryVariables>;
export function useStructureTemplateByTypeSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<StructureTemplateByTypeQuery, StructureTemplateByTypeQueryVariables>): Apollo.UseSuspenseQueryResult<StructureTemplateByTypeQuery | undefined, StructureTemplateByTypeQueryVariables>;
export function useStructureTemplateByTypeSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<StructureTemplateByTypeQuery, StructureTemplateByTypeQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<StructureTemplateByTypeQuery, StructureTemplateByTypeQueryVariables>(StructureTemplateByTypeDocument, options);
        }
export type StructureTemplateByTypeQueryHookResult = ReturnType<typeof useStructureTemplateByTypeQuery>;
export type StructureTemplateByTypeLazyQueryHookResult = ReturnType<typeof useStructureTemplateByTypeLazyQuery>;
export type StructureTemplateByTypeSuspenseQueryHookResult = ReturnType<typeof useStructureTemplateByTypeSuspenseQuery>;
export type StructureTemplateByTypeQueryResult = Apollo.QueryResult<StructureTemplateByTypeQuery, StructureTemplateByTypeQueryVariables>;
export const ScCategoryMappingDocument = gql`
    query ScCategoryMapping($structureId: String) {
  structure(structureId: $structureId) {
    id
    scCategoryMapping
  }
}
    `;

/**
 * __useScCategoryMappingQuery__
 *
 * To run a query within a React component, call `useScCategoryMappingQuery` and pass it any options that fit your needs.
 * When your component renders, `useScCategoryMappingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useScCategoryMappingQuery({
 *   variables: {
 *      structureId: // value for 'structureId'
 *   },
 * });
 */
export function useScCategoryMappingQuery(baseOptions?: Apollo.QueryHookOptions<ScCategoryMappingQuery, ScCategoryMappingQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ScCategoryMappingQuery, ScCategoryMappingQueryVariables>(ScCategoryMappingDocument, options);
      }
export function useScCategoryMappingLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ScCategoryMappingQuery, ScCategoryMappingQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ScCategoryMappingQuery, ScCategoryMappingQueryVariables>(ScCategoryMappingDocument, options);
        }
// @ts-ignore
export function useScCategoryMappingSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ScCategoryMappingQuery, ScCategoryMappingQueryVariables>): Apollo.UseSuspenseQueryResult<ScCategoryMappingQuery, ScCategoryMappingQueryVariables>;
export function useScCategoryMappingSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ScCategoryMappingQuery, ScCategoryMappingQueryVariables>): Apollo.UseSuspenseQueryResult<ScCategoryMappingQuery | undefined, ScCategoryMappingQueryVariables>;
export function useScCategoryMappingSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ScCategoryMappingQuery, ScCategoryMappingQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ScCategoryMappingQuery, ScCategoryMappingQueryVariables>(ScCategoryMappingDocument, options);
        }
export type ScCategoryMappingQueryHookResult = ReturnType<typeof useScCategoryMappingQuery>;
export type ScCategoryMappingLazyQueryHookResult = ReturnType<typeof useScCategoryMappingLazyQuery>;
export type ScCategoryMappingSuspenseQueryHookResult = ReturnType<typeof useScCategoryMappingSuspenseQuery>;
export type ScCategoryMappingQueryResult = Apollo.QueryResult<ScCategoryMappingQuery, ScCategoryMappingQueryVariables>;
export const GetStructurePipesDocument = gql`
    query GetStructurePipes($structureId: String) {
  structure(structureId: $structureId) {
    structurePipesConfig {
      imperialSteelPipes
    }
  }
}
    `;

/**
 * __useGetStructurePipesQuery__
 *
 * To run a query within a React component, call `useGetStructurePipesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetStructurePipesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetStructurePipesQuery({
 *   variables: {
 *      structureId: // value for 'structureId'
 *   },
 * });
 */
export function useGetStructurePipesQuery(baseOptions?: Apollo.QueryHookOptions<GetStructurePipesQuery, GetStructurePipesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetStructurePipesQuery, GetStructurePipesQueryVariables>(GetStructurePipesDocument, options);
      }
export function useGetStructurePipesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetStructurePipesQuery, GetStructurePipesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetStructurePipesQuery, GetStructurePipesQueryVariables>(GetStructurePipesDocument, options);
        }
// @ts-ignore
export function useGetStructurePipesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetStructurePipesQuery, GetStructurePipesQueryVariables>): Apollo.UseSuspenseQueryResult<GetStructurePipesQuery, GetStructurePipesQueryVariables>;
export function useGetStructurePipesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetStructurePipesQuery, GetStructurePipesQueryVariables>): Apollo.UseSuspenseQueryResult<GetStructurePipesQuery | undefined, GetStructurePipesQueryVariables>;
export function useGetStructurePipesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetStructurePipesQuery, GetStructurePipesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetStructurePipesQuery, GetStructurePipesQueryVariables>(GetStructurePipesDocument, options);
        }
export type GetStructurePipesQueryHookResult = ReturnType<typeof useGetStructurePipesQuery>;
export type GetStructurePipesLazyQueryHookResult = ReturnType<typeof useGetStructurePipesLazyQuery>;
export type GetStructurePipesSuspenseQueryHookResult = ReturnType<typeof useGetStructurePipesSuspenseQuery>;
export type GetStructurePipesQueryResult = Apollo.QueryResult<GetStructurePipesQuery, GetStructurePipesQueryVariables>;
export const AssemblyTemplateFieldDataDocument = gql`
    query AssemblyTemplateFieldData($assemblyId: String!) {
  assembly(assemblyId: $assemblyId) {
    id
    templateFieldData
  }
}
    `;

/**
 * __useAssemblyTemplateFieldDataQuery__
 *
 * To run a query within a React component, call `useAssemblyTemplateFieldDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useAssemblyTemplateFieldDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAssemblyTemplateFieldDataQuery({
 *   variables: {
 *      assemblyId: // value for 'assemblyId'
 *   },
 * });
 */
export function useAssemblyTemplateFieldDataQuery(baseOptions: Apollo.QueryHookOptions<AssemblyTemplateFieldDataQuery, AssemblyTemplateFieldDataQueryVariables> & ({ variables: AssemblyTemplateFieldDataQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AssemblyTemplateFieldDataQuery, AssemblyTemplateFieldDataQueryVariables>(AssemblyTemplateFieldDataDocument, options);
      }
export function useAssemblyTemplateFieldDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AssemblyTemplateFieldDataQuery, AssemblyTemplateFieldDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AssemblyTemplateFieldDataQuery, AssemblyTemplateFieldDataQueryVariables>(AssemblyTemplateFieldDataDocument, options);
        }
// @ts-ignore
export function useAssemblyTemplateFieldDataSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<AssemblyTemplateFieldDataQuery, AssemblyTemplateFieldDataQueryVariables>): Apollo.UseSuspenseQueryResult<AssemblyTemplateFieldDataQuery, AssemblyTemplateFieldDataQueryVariables>;
export function useAssemblyTemplateFieldDataSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AssemblyTemplateFieldDataQuery, AssemblyTemplateFieldDataQueryVariables>): Apollo.UseSuspenseQueryResult<AssemblyTemplateFieldDataQuery | undefined, AssemblyTemplateFieldDataQueryVariables>;
export function useAssemblyTemplateFieldDataSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AssemblyTemplateFieldDataQuery, AssemblyTemplateFieldDataQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AssemblyTemplateFieldDataQuery, AssemblyTemplateFieldDataQueryVariables>(AssemblyTemplateFieldDataDocument, options);
        }
export type AssemblyTemplateFieldDataQueryHookResult = ReturnType<typeof useAssemblyTemplateFieldDataQuery>;
export type AssemblyTemplateFieldDataLazyQueryHookResult = ReturnType<typeof useAssemblyTemplateFieldDataLazyQuery>;
export type AssemblyTemplateFieldDataSuspenseQueryHookResult = ReturnType<typeof useAssemblyTemplateFieldDataSuspenseQuery>;
export type AssemblyTemplateFieldDataQueryResult = Apollo.QueryResult<AssemblyTemplateFieldDataQuery, AssemblyTemplateFieldDataQueryVariables>;
export const UpdateScCategoryDocument = gql`
    mutation UpdateScCategory($input: UpdateScCategoryInput!) {
  updateScCategory(input: $input) {
    templateFieldData
  }
}
    `;
export type UpdateScCategoryMutationFn = Apollo.MutationFunction<UpdateScCategoryMutation, UpdateScCategoryMutationVariables>;

/**
 * __useUpdateScCategoryMutation__
 *
 * To run a mutation, you first call `useUpdateScCategoryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateScCategoryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateScCategoryMutation, { data, loading, error }] = useUpdateScCategoryMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateScCategoryMutation(baseOptions?: Apollo.MutationHookOptions<UpdateScCategoryMutation, UpdateScCategoryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateScCategoryMutation, UpdateScCategoryMutationVariables>(UpdateScCategoryDocument, options);
      }
export type UpdateScCategoryMutationHookResult = ReturnType<typeof useUpdateScCategoryMutation>;
export type UpdateScCategoryMutationResult = Apollo.MutationResult<UpdateScCategoryMutation>;
export type UpdateScCategoryMutationOptions = Apollo.BaseMutationOptions<UpdateScCategoryMutation, UpdateScCategoryMutationVariables>;
export const DefectPointOfInterestsDocument = gql`
    query DefectPointOfInterests($input: FindAllPointOfInterestsInput) {
  allPointOfInterests(input: $input) {
    id
    poiId
    type
    name
    templateFieldData
  }
}
    `;

/**
 * __useDefectPointOfInterestsQuery__
 *
 * To run a query within a React component, call `useDefectPointOfInterestsQuery` and pass it any options that fit your needs.
 * When your component renders, `useDefectPointOfInterestsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDefectPointOfInterestsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDefectPointOfInterestsQuery(baseOptions?: Apollo.QueryHookOptions<DefectPointOfInterestsQuery, DefectPointOfInterestsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DefectPointOfInterestsQuery, DefectPointOfInterestsQueryVariables>(DefectPointOfInterestsDocument, options);
      }
export function useDefectPointOfInterestsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DefectPointOfInterestsQuery, DefectPointOfInterestsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DefectPointOfInterestsQuery, DefectPointOfInterestsQueryVariables>(DefectPointOfInterestsDocument, options);
        }
// @ts-ignore
export function useDefectPointOfInterestsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<DefectPointOfInterestsQuery, DefectPointOfInterestsQueryVariables>): Apollo.UseSuspenseQueryResult<DefectPointOfInterestsQuery, DefectPointOfInterestsQueryVariables>;
export function useDefectPointOfInterestsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DefectPointOfInterestsQuery, DefectPointOfInterestsQueryVariables>): Apollo.UseSuspenseQueryResult<DefectPointOfInterestsQuery | undefined, DefectPointOfInterestsQueryVariables>;
export function useDefectPointOfInterestsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DefectPointOfInterestsQuery, DefectPointOfInterestsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DefectPointOfInterestsQuery, DefectPointOfInterestsQueryVariables>(DefectPointOfInterestsDocument, options);
        }
export type DefectPointOfInterestsQueryHookResult = ReturnType<typeof useDefectPointOfInterestsQuery>;
export type DefectPointOfInterestsLazyQueryHookResult = ReturnType<typeof useDefectPointOfInterestsLazyQuery>;
export type DefectPointOfInterestsSuspenseQueryHookResult = ReturnType<typeof useDefectPointOfInterestsSuspenseQuery>;
export type DefectPointOfInterestsQueryResult = Apollo.QueryResult<DefectPointOfInterestsQuery, DefectPointOfInterestsQueryVariables>;
export const AssemblyGoverningValueDocument = gql`
    query AssemblyGoverningValue($assemblyId: String) {
  assembly(assemblyId: $assemblyId) {
    id
    tagName
    recommendation {
      governingValue {
        pointOfInterest {
          id
        }
      }
    }
  }
}
    `;

/**
 * __useAssemblyGoverningValueQuery__
 *
 * To run a query within a React component, call `useAssemblyGoverningValueQuery` and pass it any options that fit your needs.
 * When your component renders, `useAssemblyGoverningValueQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAssemblyGoverningValueQuery({
 *   variables: {
 *      assemblyId: // value for 'assemblyId'
 *   },
 * });
 */
export function useAssemblyGoverningValueQuery(baseOptions?: Apollo.QueryHookOptions<AssemblyGoverningValueQuery, AssemblyGoverningValueQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AssemblyGoverningValueQuery, AssemblyGoverningValueQueryVariables>(AssemblyGoverningValueDocument, options);
      }
export function useAssemblyGoverningValueLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AssemblyGoverningValueQuery, AssemblyGoverningValueQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AssemblyGoverningValueQuery, AssemblyGoverningValueQueryVariables>(AssemblyGoverningValueDocument, options);
        }
// @ts-ignore
export function useAssemblyGoverningValueSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<AssemblyGoverningValueQuery, AssemblyGoverningValueQueryVariables>): Apollo.UseSuspenseQueryResult<AssemblyGoverningValueQuery, AssemblyGoverningValueQueryVariables>;
export function useAssemblyGoverningValueSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AssemblyGoverningValueQuery, AssemblyGoverningValueQueryVariables>): Apollo.UseSuspenseQueryResult<AssemblyGoverningValueQuery | undefined, AssemblyGoverningValueQueryVariables>;
export function useAssemblyGoverningValueSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AssemblyGoverningValueQuery, AssemblyGoverningValueQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AssemblyGoverningValueQuery, AssemblyGoverningValueQueryVariables>(AssemblyGoverningValueDocument, options);
        }
export type AssemblyGoverningValueQueryHookResult = ReturnType<typeof useAssemblyGoverningValueQuery>;
export type AssemblyGoverningValueLazyQueryHookResult = ReturnType<typeof useAssemblyGoverningValueLazyQuery>;
export type AssemblyGoverningValueSuspenseQueryHookResult = ReturnType<typeof useAssemblyGoverningValueSuspenseQuery>;
export type AssemblyGoverningValueQueryResult = Apollo.QueryResult<AssemblyGoverningValueQuery, AssemblyGoverningValueQueryVariables>;
export const GetAssemblyTemplateFieldDataDocument = gql`
    query getAssemblyTemplateFieldData($assemblyId: String!) {
  assembly(assemblyId: $assemblyId) {
    id
    tagName
    templateFieldData
  }
}
    `;

/**
 * __useGetAssemblyTemplateFieldDataQuery__
 *
 * To run a query within a React component, call `useGetAssemblyTemplateFieldDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAssemblyTemplateFieldDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAssemblyTemplateFieldDataQuery({
 *   variables: {
 *      assemblyId: // value for 'assemblyId'
 *   },
 * });
 */
export function useGetAssemblyTemplateFieldDataQuery(baseOptions: Apollo.QueryHookOptions<GetAssemblyTemplateFieldDataQuery, GetAssemblyTemplateFieldDataQueryVariables> & ({ variables: GetAssemblyTemplateFieldDataQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAssemblyTemplateFieldDataQuery, GetAssemblyTemplateFieldDataQueryVariables>(GetAssemblyTemplateFieldDataDocument, options);
      }
export function useGetAssemblyTemplateFieldDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAssemblyTemplateFieldDataQuery, GetAssemblyTemplateFieldDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAssemblyTemplateFieldDataQuery, GetAssemblyTemplateFieldDataQueryVariables>(GetAssemblyTemplateFieldDataDocument, options);
        }
// @ts-ignore
export function useGetAssemblyTemplateFieldDataSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetAssemblyTemplateFieldDataQuery, GetAssemblyTemplateFieldDataQueryVariables>): Apollo.UseSuspenseQueryResult<GetAssemblyTemplateFieldDataQuery, GetAssemblyTemplateFieldDataQueryVariables>;
export function useGetAssemblyTemplateFieldDataSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAssemblyTemplateFieldDataQuery, GetAssemblyTemplateFieldDataQueryVariables>): Apollo.UseSuspenseQueryResult<GetAssemblyTemplateFieldDataQuery | undefined, GetAssemblyTemplateFieldDataQueryVariables>;
export function useGetAssemblyTemplateFieldDataSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAssemblyTemplateFieldDataQuery, GetAssemblyTemplateFieldDataQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAssemblyTemplateFieldDataQuery, GetAssemblyTemplateFieldDataQueryVariables>(GetAssemblyTemplateFieldDataDocument, options);
        }
export type GetAssemblyTemplateFieldDataQueryHookResult = ReturnType<typeof useGetAssemblyTemplateFieldDataQuery>;
export type GetAssemblyTemplateFieldDataLazyQueryHookResult = ReturnType<typeof useGetAssemblyTemplateFieldDataLazyQuery>;
export type GetAssemblyTemplateFieldDataSuspenseQueryHookResult = ReturnType<typeof useGetAssemblyTemplateFieldDataSuspenseQuery>;
export type GetAssemblyTemplateFieldDataQueryResult = Apollo.QueryResult<GetAssemblyTemplateFieldDataQuery, GetAssemblyTemplateFieldDataQueryVariables>;
export const GetAssemblyPointOfInterestsDocument = gql`
    query getAssemblyPointOfInterests($input: FindAllPointOfInterestsInput) {
  allPointOfInterests(input: $input) {
    id
    poiId
    type
    location {
      id
    }
    name
    centerPoint3d {
      x
      y
      z
    }
    cameraLocation {
      x
      y
      z
    }
    assembly {
      id
    }
    blister {
      centerPoint {
        bearing
        elevation
      }
      radiusPoint {
        bearing
        elevation
      }
      borders3d {
        points {
          x
          y
          z
        }
      }
      scCategory
      estimatedHeight
      manualSetHeight
      pdrHeight
      heightType
      isManuallyOverridden
      maxHeight
      radius
      fittingRadius
      distanceConfidence
      measurementConfidence
      wallLoss {
        value
      }
    }
    templateFieldData
    remediationNote
    files {
      id
      name
      resourcePath
      type
      fileName
      uploadStatus
      imageType
      uuid
    }
    comment
    deckRelativeHeight
    accessibility
    viewpointRelativeHeight
  }
}
    `;

/**
 * __useGetAssemblyPointOfInterestsQuery__
 *
 * To run a query within a React component, call `useGetAssemblyPointOfInterestsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAssemblyPointOfInterestsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAssemblyPointOfInterestsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetAssemblyPointOfInterestsQuery(baseOptions?: Apollo.QueryHookOptions<GetAssemblyPointOfInterestsQuery, GetAssemblyPointOfInterestsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAssemblyPointOfInterestsQuery, GetAssemblyPointOfInterestsQueryVariables>(GetAssemblyPointOfInterestsDocument, options);
      }
export function useGetAssemblyPointOfInterestsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAssemblyPointOfInterestsQuery, GetAssemblyPointOfInterestsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAssemblyPointOfInterestsQuery, GetAssemblyPointOfInterestsQueryVariables>(GetAssemblyPointOfInterestsDocument, options);
        }
// @ts-ignore
export function useGetAssemblyPointOfInterestsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetAssemblyPointOfInterestsQuery, GetAssemblyPointOfInterestsQueryVariables>): Apollo.UseSuspenseQueryResult<GetAssemblyPointOfInterestsQuery, GetAssemblyPointOfInterestsQueryVariables>;
export function useGetAssemblyPointOfInterestsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAssemblyPointOfInterestsQuery, GetAssemblyPointOfInterestsQueryVariables>): Apollo.UseSuspenseQueryResult<GetAssemblyPointOfInterestsQuery | undefined, GetAssemblyPointOfInterestsQueryVariables>;
export function useGetAssemblyPointOfInterestsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAssemblyPointOfInterestsQuery, GetAssemblyPointOfInterestsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAssemblyPointOfInterestsQuery, GetAssemblyPointOfInterestsQueryVariables>(GetAssemblyPointOfInterestsDocument, options);
        }
export type GetAssemblyPointOfInterestsQueryHookResult = ReturnType<typeof useGetAssemblyPointOfInterestsQuery>;
export type GetAssemblyPointOfInterestsLazyQueryHookResult = ReturnType<typeof useGetAssemblyPointOfInterestsLazyQuery>;
export type GetAssemblyPointOfInterestsSuspenseQueryHookResult = ReturnType<typeof useGetAssemblyPointOfInterestsSuspenseQuery>;
export type GetAssemblyPointOfInterestsQueryResult = Apollo.QueryResult<GetAssemblyPointOfInterestsQuery, GetAssemblyPointOfInterestsQueryVariables>;
export const UpdateCuiPriorityDocument = gql`
    mutation UpdateCuiPriority($input: UpdateCuiPriorityInput!) {
  updateCuiPriority(input: $input) {
    templateFieldData
  }
}
    `;
export type UpdateCuiPriorityMutationFn = Apollo.MutationFunction<UpdateCuiPriorityMutation, UpdateCuiPriorityMutationVariables>;

/**
 * __useUpdateCuiPriorityMutation__
 *
 * To run a mutation, you first call `useUpdateCuiPriorityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCuiPriorityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCuiPriorityMutation, { data, loading, error }] = useUpdateCuiPriorityMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateCuiPriorityMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCuiPriorityMutation, UpdateCuiPriorityMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCuiPriorityMutation, UpdateCuiPriorityMutationVariables>(UpdateCuiPriorityDocument, options);
      }
export type UpdateCuiPriorityMutationHookResult = ReturnType<typeof useUpdateCuiPriorityMutation>;
export type UpdateCuiPriorityMutationResult = Apollo.MutationResult<UpdateCuiPriorityMutation>;
export type UpdateCuiPriorityMutationOptions = Apollo.BaseMutationOptions<UpdateCuiPriorityMutation, UpdateCuiPriorityMutationVariables>;
export const GetAssembliesByTemplateFieldsFiltersForEquipmentsTabDocument = gql`
    query GetAssembliesByTemplateFieldsFiltersForEquipmentsTab($input: AssembliesFilterInput) {
  getAssembliesByTemplateFieldsFilters(input: $input) {
    id
    tagName
    templateFieldData
    isUncontextualized
    box {
      max {
        x
        y
        z
      }
      min {
        x
        y
        z
      }
    }
  }
  getAssembliesCount(input: $input) {
    count
  }
}
    `;

/**
 * __useGetAssembliesByTemplateFieldsFiltersForEquipmentsTabQuery__
 *
 * To run a query within a React component, call `useGetAssembliesByTemplateFieldsFiltersForEquipmentsTabQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAssembliesByTemplateFieldsFiltersForEquipmentsTabQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAssembliesByTemplateFieldsFiltersForEquipmentsTabQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetAssembliesByTemplateFieldsFiltersForEquipmentsTabQuery(baseOptions?: Apollo.QueryHookOptions<GetAssembliesByTemplateFieldsFiltersForEquipmentsTabQuery, GetAssembliesByTemplateFieldsFiltersForEquipmentsTabQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAssembliesByTemplateFieldsFiltersForEquipmentsTabQuery, GetAssembliesByTemplateFieldsFiltersForEquipmentsTabQueryVariables>(GetAssembliesByTemplateFieldsFiltersForEquipmentsTabDocument, options);
      }
export function useGetAssembliesByTemplateFieldsFiltersForEquipmentsTabLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAssembliesByTemplateFieldsFiltersForEquipmentsTabQuery, GetAssembliesByTemplateFieldsFiltersForEquipmentsTabQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAssembliesByTemplateFieldsFiltersForEquipmentsTabQuery, GetAssembliesByTemplateFieldsFiltersForEquipmentsTabQueryVariables>(GetAssembliesByTemplateFieldsFiltersForEquipmentsTabDocument, options);
        }
// @ts-ignore
export function useGetAssembliesByTemplateFieldsFiltersForEquipmentsTabSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetAssembliesByTemplateFieldsFiltersForEquipmentsTabQuery, GetAssembliesByTemplateFieldsFiltersForEquipmentsTabQueryVariables>): Apollo.UseSuspenseQueryResult<GetAssembliesByTemplateFieldsFiltersForEquipmentsTabQuery, GetAssembliesByTemplateFieldsFiltersForEquipmentsTabQueryVariables>;
export function useGetAssembliesByTemplateFieldsFiltersForEquipmentsTabSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAssembliesByTemplateFieldsFiltersForEquipmentsTabQuery, GetAssembliesByTemplateFieldsFiltersForEquipmentsTabQueryVariables>): Apollo.UseSuspenseQueryResult<GetAssembliesByTemplateFieldsFiltersForEquipmentsTabQuery | undefined, GetAssembliesByTemplateFieldsFiltersForEquipmentsTabQueryVariables>;
export function useGetAssembliesByTemplateFieldsFiltersForEquipmentsTabSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAssembliesByTemplateFieldsFiltersForEquipmentsTabQuery, GetAssembliesByTemplateFieldsFiltersForEquipmentsTabQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAssembliesByTemplateFieldsFiltersForEquipmentsTabQuery, GetAssembliesByTemplateFieldsFiltersForEquipmentsTabQueryVariables>(GetAssembliesByTemplateFieldsFiltersForEquipmentsTabDocument, options);
        }
export type GetAssembliesByTemplateFieldsFiltersForEquipmentsTabQueryHookResult = ReturnType<typeof useGetAssembliesByTemplateFieldsFiltersForEquipmentsTabQuery>;
export type GetAssembliesByTemplateFieldsFiltersForEquipmentsTabLazyQueryHookResult = ReturnType<typeof useGetAssembliesByTemplateFieldsFiltersForEquipmentsTabLazyQuery>;
export type GetAssembliesByTemplateFieldsFiltersForEquipmentsTabSuspenseQueryHookResult = ReturnType<typeof useGetAssembliesByTemplateFieldsFiltersForEquipmentsTabSuspenseQuery>;
export type GetAssembliesByTemplateFieldsFiltersForEquipmentsTabQueryResult = Apollo.QueryResult<GetAssembliesByTemplateFieldsFiltersForEquipmentsTabQuery, GetAssembliesByTemplateFieldsFiltersForEquipmentsTabQueryVariables>;
export const GetAssembliesWithTemplateFieldDataDocument = gql`
    query GetAssembliesWithTemplateFieldData($input: AssembliesFilterInput, $pageInfo: PageInfo) {
  getAssembliesByTemplateFieldsFilters(input: $input, pageInfo: $pageInfo) {
    id
    tagName
    templateFieldData
    isUncontextualized
  }
  getAssembliesCount(input: $input) {
    count
  }
}
    `;

/**
 * __useGetAssembliesWithTemplateFieldDataQuery__
 *
 * To run a query within a React component, call `useGetAssembliesWithTemplateFieldDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAssembliesWithTemplateFieldDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAssembliesWithTemplateFieldDataQuery({
 *   variables: {
 *      input: // value for 'input'
 *      pageInfo: // value for 'pageInfo'
 *   },
 * });
 */
export function useGetAssembliesWithTemplateFieldDataQuery(baseOptions?: Apollo.QueryHookOptions<GetAssembliesWithTemplateFieldDataQuery, GetAssembliesWithTemplateFieldDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAssembliesWithTemplateFieldDataQuery, GetAssembliesWithTemplateFieldDataQueryVariables>(GetAssembliesWithTemplateFieldDataDocument, options);
      }
export function useGetAssembliesWithTemplateFieldDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAssembliesWithTemplateFieldDataQuery, GetAssembliesWithTemplateFieldDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAssembliesWithTemplateFieldDataQuery, GetAssembliesWithTemplateFieldDataQueryVariables>(GetAssembliesWithTemplateFieldDataDocument, options);
        }
// @ts-ignore
export function useGetAssembliesWithTemplateFieldDataSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetAssembliesWithTemplateFieldDataQuery, GetAssembliesWithTemplateFieldDataQueryVariables>): Apollo.UseSuspenseQueryResult<GetAssembliesWithTemplateFieldDataQuery, GetAssembliesWithTemplateFieldDataQueryVariables>;
export function useGetAssembliesWithTemplateFieldDataSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAssembliesWithTemplateFieldDataQuery, GetAssembliesWithTemplateFieldDataQueryVariables>): Apollo.UseSuspenseQueryResult<GetAssembliesWithTemplateFieldDataQuery | undefined, GetAssembliesWithTemplateFieldDataQueryVariables>;
export function useGetAssembliesWithTemplateFieldDataSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAssembliesWithTemplateFieldDataQuery, GetAssembliesWithTemplateFieldDataQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAssembliesWithTemplateFieldDataQuery, GetAssembliesWithTemplateFieldDataQueryVariables>(GetAssembliesWithTemplateFieldDataDocument, options);
        }
export type GetAssembliesWithTemplateFieldDataQueryHookResult = ReturnType<typeof useGetAssembliesWithTemplateFieldDataQuery>;
export type GetAssembliesWithTemplateFieldDataLazyQueryHookResult = ReturnType<typeof useGetAssembliesWithTemplateFieldDataLazyQuery>;
export type GetAssembliesWithTemplateFieldDataSuspenseQueryHookResult = ReturnType<typeof useGetAssembliesWithTemplateFieldDataSuspenseQuery>;
export type GetAssembliesWithTemplateFieldDataQueryResult = Apollo.QueryResult<GetAssembliesWithTemplateFieldDataQuery, GetAssembliesWithTemplateFieldDataQueryVariables>;
export const AllDecksForFilterSideBarDocument = gql`
    query AllDecksForFilterSideBar($structureId: ID) {
  allDecks(structureId: $structureId) {
    id
    name
  }
}
    `;

/**
 * __useAllDecksForFilterSideBarQuery__
 *
 * To run a query within a React component, call `useAllDecksForFilterSideBarQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllDecksForFilterSideBarQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllDecksForFilterSideBarQuery({
 *   variables: {
 *      structureId: // value for 'structureId'
 *   },
 * });
 */
export function useAllDecksForFilterSideBarQuery(baseOptions?: Apollo.QueryHookOptions<AllDecksForFilterSideBarQuery, AllDecksForFilterSideBarQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AllDecksForFilterSideBarQuery, AllDecksForFilterSideBarQueryVariables>(AllDecksForFilterSideBarDocument, options);
      }
export function useAllDecksForFilterSideBarLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AllDecksForFilterSideBarQuery, AllDecksForFilterSideBarQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AllDecksForFilterSideBarQuery, AllDecksForFilterSideBarQueryVariables>(AllDecksForFilterSideBarDocument, options);
        }
// @ts-ignore
export function useAllDecksForFilterSideBarSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<AllDecksForFilterSideBarQuery, AllDecksForFilterSideBarQueryVariables>): Apollo.UseSuspenseQueryResult<AllDecksForFilterSideBarQuery, AllDecksForFilterSideBarQueryVariables>;
export function useAllDecksForFilterSideBarSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AllDecksForFilterSideBarQuery, AllDecksForFilterSideBarQueryVariables>): Apollo.UseSuspenseQueryResult<AllDecksForFilterSideBarQuery | undefined, AllDecksForFilterSideBarQueryVariables>;
export function useAllDecksForFilterSideBarSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AllDecksForFilterSideBarQuery, AllDecksForFilterSideBarQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AllDecksForFilterSideBarQuery, AllDecksForFilterSideBarQueryVariables>(AllDecksForFilterSideBarDocument, options);
        }
export type AllDecksForFilterSideBarQueryHookResult = ReturnType<typeof useAllDecksForFilterSideBarQuery>;
export type AllDecksForFilterSideBarLazyQueryHookResult = ReturnType<typeof useAllDecksForFilterSideBarLazyQuery>;
export type AllDecksForFilterSideBarSuspenseQueryHookResult = ReturnType<typeof useAllDecksForFilterSideBarSuspenseQuery>;
export type AllDecksForFilterSideBarQueryResult = Apollo.QueryResult<AllDecksForFilterSideBarQuery, AllDecksForFilterSideBarQueryVariables>;
export const AllPaintRegionsDocument = gql`
    query AllPaintRegions($input: FindAllPaintRegionsInput) {
  allPaintRegions(input: $input) {
    id
    name
    deck {
      id
    }
  }
}
    `;

/**
 * __useAllPaintRegionsQuery__
 *
 * To run a query within a React component, call `useAllPaintRegionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllPaintRegionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllPaintRegionsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAllPaintRegionsQuery(baseOptions?: Apollo.QueryHookOptions<AllPaintRegionsQuery, AllPaintRegionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AllPaintRegionsQuery, AllPaintRegionsQueryVariables>(AllPaintRegionsDocument, options);
      }
export function useAllPaintRegionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AllPaintRegionsQuery, AllPaintRegionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AllPaintRegionsQuery, AllPaintRegionsQueryVariables>(AllPaintRegionsDocument, options);
        }
// @ts-ignore
export function useAllPaintRegionsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<AllPaintRegionsQuery, AllPaintRegionsQueryVariables>): Apollo.UseSuspenseQueryResult<AllPaintRegionsQuery, AllPaintRegionsQueryVariables>;
export function useAllPaintRegionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AllPaintRegionsQuery, AllPaintRegionsQueryVariables>): Apollo.UseSuspenseQueryResult<AllPaintRegionsQuery | undefined, AllPaintRegionsQueryVariables>;
export function useAllPaintRegionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AllPaintRegionsQuery, AllPaintRegionsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AllPaintRegionsQuery, AllPaintRegionsQueryVariables>(AllPaintRegionsDocument, options);
        }
export type AllPaintRegionsQueryHookResult = ReturnType<typeof useAllPaintRegionsQuery>;
export type AllPaintRegionsLazyQueryHookResult = ReturnType<typeof useAllPaintRegionsLazyQuery>;
export type AllPaintRegionsSuspenseQueryHookResult = ReturnType<typeof useAllPaintRegionsSuspenseQuery>;
export type AllPaintRegionsQueryResult = Apollo.QueryResult<AllPaintRegionsQuery, AllPaintRegionsQueryVariables>;
export const AllAssemblyTemplatesForFilterSideBarDocument = gql`
    query AllAssemblyTemplatesForFilterSideBar($structureId: ID, $type: TemplateTypeEnum) {
  allTemplates(structureId: $structureId, type: $type) {
    name
    octreeResourcesPath
    includedTemplateIds
    structureRelationshipPath
    id
    defectsArray
    recommendation {
      header
      details {
        id
        fieldKey
      }
    }
    equipmentCard {
      id
      name
      type
      position
      fieldKey
      location
    }
    equipmentDetails {
      id
      name
      subType
      type
      fieldKey
      options {
        id
        name
        type
        fieldKey
      }
    }
    assessmentDetails {
      id
      name
      type
      position
      isVisible
      options {
        id
        name
        type
        fieldKey
        isEditable
        editRoles
      }
    }
    reviewPanelConfig {
      groupKey
      groupName
      id
      groupSection {
        id
        title
        sectionKey
        fieldKeys
      }
    }
    querySummary {
      name
      key
      operation
    }
    fields {
      isEditable
      editRoles
      options
      metaData
      displayConfig {
        id
        type
        color {
          key
          value
        }
        isSortable
        sortType
        textFormat
      }
      id
      name
      key
      type
      serverSide
      permission
      displayInQuery
      isHidden
      displayInTable
      enableInlineEdit
      displayInRisk
      displayInReview
      displayInReports
      displayInReportFilters
      roundToDecimal
      unit
      displayUnit
      isReadOnly
      isRequired
      detailFieldKey
      optionsData {
        value
        min
        max
      }
    }
  }
}
    `;

/**
 * __useAllAssemblyTemplatesForFilterSideBarQuery__
 *
 * To run a query within a React component, call `useAllAssemblyTemplatesForFilterSideBarQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllAssemblyTemplatesForFilterSideBarQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllAssemblyTemplatesForFilterSideBarQuery({
 *   variables: {
 *      structureId: // value for 'structureId'
 *      type: // value for 'type'
 *   },
 * });
 */
export function useAllAssemblyTemplatesForFilterSideBarQuery(baseOptions?: Apollo.QueryHookOptions<AllAssemblyTemplatesForFilterSideBarQuery, AllAssemblyTemplatesForFilterSideBarQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AllAssemblyTemplatesForFilterSideBarQuery, AllAssemblyTemplatesForFilterSideBarQueryVariables>(AllAssemblyTemplatesForFilterSideBarDocument, options);
      }
export function useAllAssemblyTemplatesForFilterSideBarLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AllAssemblyTemplatesForFilterSideBarQuery, AllAssemblyTemplatesForFilterSideBarQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AllAssemblyTemplatesForFilterSideBarQuery, AllAssemblyTemplatesForFilterSideBarQueryVariables>(AllAssemblyTemplatesForFilterSideBarDocument, options);
        }
// @ts-ignore
export function useAllAssemblyTemplatesForFilterSideBarSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<AllAssemblyTemplatesForFilterSideBarQuery, AllAssemblyTemplatesForFilterSideBarQueryVariables>): Apollo.UseSuspenseQueryResult<AllAssemblyTemplatesForFilterSideBarQuery, AllAssemblyTemplatesForFilterSideBarQueryVariables>;
export function useAllAssemblyTemplatesForFilterSideBarSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AllAssemblyTemplatesForFilterSideBarQuery, AllAssemblyTemplatesForFilterSideBarQueryVariables>): Apollo.UseSuspenseQueryResult<AllAssemblyTemplatesForFilterSideBarQuery | undefined, AllAssemblyTemplatesForFilterSideBarQueryVariables>;
export function useAllAssemblyTemplatesForFilterSideBarSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AllAssemblyTemplatesForFilterSideBarQuery, AllAssemblyTemplatesForFilterSideBarQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AllAssemblyTemplatesForFilterSideBarQuery, AllAssemblyTemplatesForFilterSideBarQueryVariables>(AllAssemblyTemplatesForFilterSideBarDocument, options);
        }
export type AllAssemblyTemplatesForFilterSideBarQueryHookResult = ReturnType<typeof useAllAssemblyTemplatesForFilterSideBarQuery>;
export type AllAssemblyTemplatesForFilterSideBarLazyQueryHookResult = ReturnType<typeof useAllAssemblyTemplatesForFilterSideBarLazyQuery>;
export type AllAssemblyTemplatesForFilterSideBarSuspenseQueryHookResult = ReturnType<typeof useAllAssemblyTemplatesForFilterSideBarSuspenseQuery>;
export type AllAssemblyTemplatesForFilterSideBarQueryResult = Apollo.QueryResult<AllAssemblyTemplatesForFilterSideBarQuery, AllAssemblyTemplatesForFilterSideBarQueryVariables>;
export const GetAssembliesByTemplateFieldsFiltersForFilterSideBarDocument = gql`
    query GetAssembliesByTemplateFieldsFiltersForFilterSideBar($input: AssembliesFilterInput, $pageInfo: PageInfo) {
  getAssembliesByTemplateFieldsFilters(input: $input, pageInfo: $pageInfo) {
    id
    tagName
    templateFieldData
    poiCounts {
      poiType
      count
    }
    isUncontextualized
    decks {
      deckId {
        id
      }
    }
  }
  getAssembliesCount(input: $input) {
    count
  }
}
    `;

/**
 * __useGetAssembliesByTemplateFieldsFiltersForFilterSideBarQuery__
 *
 * To run a query within a React component, call `useGetAssembliesByTemplateFieldsFiltersForFilterSideBarQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAssembliesByTemplateFieldsFiltersForFilterSideBarQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAssembliesByTemplateFieldsFiltersForFilterSideBarQuery({
 *   variables: {
 *      input: // value for 'input'
 *      pageInfo: // value for 'pageInfo'
 *   },
 * });
 */
export function useGetAssembliesByTemplateFieldsFiltersForFilterSideBarQuery(baseOptions?: Apollo.QueryHookOptions<GetAssembliesByTemplateFieldsFiltersForFilterSideBarQuery, GetAssembliesByTemplateFieldsFiltersForFilterSideBarQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAssembliesByTemplateFieldsFiltersForFilterSideBarQuery, GetAssembliesByTemplateFieldsFiltersForFilterSideBarQueryVariables>(GetAssembliesByTemplateFieldsFiltersForFilterSideBarDocument, options);
      }
export function useGetAssembliesByTemplateFieldsFiltersForFilterSideBarLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAssembliesByTemplateFieldsFiltersForFilterSideBarQuery, GetAssembliesByTemplateFieldsFiltersForFilterSideBarQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAssembliesByTemplateFieldsFiltersForFilterSideBarQuery, GetAssembliesByTemplateFieldsFiltersForFilterSideBarQueryVariables>(GetAssembliesByTemplateFieldsFiltersForFilterSideBarDocument, options);
        }
// @ts-ignore
export function useGetAssembliesByTemplateFieldsFiltersForFilterSideBarSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetAssembliesByTemplateFieldsFiltersForFilterSideBarQuery, GetAssembliesByTemplateFieldsFiltersForFilterSideBarQueryVariables>): Apollo.UseSuspenseQueryResult<GetAssembliesByTemplateFieldsFiltersForFilterSideBarQuery, GetAssembliesByTemplateFieldsFiltersForFilterSideBarQueryVariables>;
export function useGetAssembliesByTemplateFieldsFiltersForFilterSideBarSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAssembliesByTemplateFieldsFiltersForFilterSideBarQuery, GetAssembliesByTemplateFieldsFiltersForFilterSideBarQueryVariables>): Apollo.UseSuspenseQueryResult<GetAssembliesByTemplateFieldsFiltersForFilterSideBarQuery | undefined, GetAssembliesByTemplateFieldsFiltersForFilterSideBarQueryVariables>;
export function useGetAssembliesByTemplateFieldsFiltersForFilterSideBarSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAssembliesByTemplateFieldsFiltersForFilterSideBarQuery, GetAssembliesByTemplateFieldsFiltersForFilterSideBarQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAssembliesByTemplateFieldsFiltersForFilterSideBarQuery, GetAssembliesByTemplateFieldsFiltersForFilterSideBarQueryVariables>(GetAssembliesByTemplateFieldsFiltersForFilterSideBarDocument, options);
        }
export type GetAssembliesByTemplateFieldsFiltersForFilterSideBarQueryHookResult = ReturnType<typeof useGetAssembliesByTemplateFieldsFiltersForFilterSideBarQuery>;
export type GetAssembliesByTemplateFieldsFiltersForFilterSideBarLazyQueryHookResult = ReturnType<typeof useGetAssembliesByTemplateFieldsFiltersForFilterSideBarLazyQuery>;
export type GetAssembliesByTemplateFieldsFiltersForFilterSideBarSuspenseQueryHookResult = ReturnType<typeof useGetAssembliesByTemplateFieldsFiltersForFilterSideBarSuspenseQuery>;
export type GetAssembliesByTemplateFieldsFiltersForFilterSideBarQueryResult = Apollo.QueryResult<GetAssembliesByTemplateFieldsFiltersForFilterSideBarQuery, GetAssembliesByTemplateFieldsFiltersForFilterSideBarQueryVariables>;
export const AllWorkpacksForFilterSideBarDocument = gql`
    query AllWorkpacksForFilterSideBar($structureId: String, $hasPois: Boolean) {
  allWorkpacks(structureId: $structureId, hasPois: $hasPois) {
    id
    name
  }
}
    `;

/**
 * __useAllWorkpacksForFilterSideBarQuery__
 *
 * To run a query within a React component, call `useAllWorkpacksForFilterSideBarQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllWorkpacksForFilterSideBarQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllWorkpacksForFilterSideBarQuery({
 *   variables: {
 *      structureId: // value for 'structureId'
 *      hasPois: // value for 'hasPois'
 *   },
 * });
 */
export function useAllWorkpacksForFilterSideBarQuery(baseOptions?: Apollo.QueryHookOptions<AllWorkpacksForFilterSideBarQuery, AllWorkpacksForFilterSideBarQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AllWorkpacksForFilterSideBarQuery, AllWorkpacksForFilterSideBarQueryVariables>(AllWorkpacksForFilterSideBarDocument, options);
      }
export function useAllWorkpacksForFilterSideBarLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AllWorkpacksForFilterSideBarQuery, AllWorkpacksForFilterSideBarQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AllWorkpacksForFilterSideBarQuery, AllWorkpacksForFilterSideBarQueryVariables>(AllWorkpacksForFilterSideBarDocument, options);
        }
// @ts-ignore
export function useAllWorkpacksForFilterSideBarSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<AllWorkpacksForFilterSideBarQuery, AllWorkpacksForFilterSideBarQueryVariables>): Apollo.UseSuspenseQueryResult<AllWorkpacksForFilterSideBarQuery, AllWorkpacksForFilterSideBarQueryVariables>;
export function useAllWorkpacksForFilterSideBarSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AllWorkpacksForFilterSideBarQuery, AllWorkpacksForFilterSideBarQueryVariables>): Apollo.UseSuspenseQueryResult<AllWorkpacksForFilterSideBarQuery | undefined, AllWorkpacksForFilterSideBarQueryVariables>;
export function useAllWorkpacksForFilterSideBarSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AllWorkpacksForFilterSideBarQuery, AllWorkpacksForFilterSideBarQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AllWorkpacksForFilterSideBarQuery, AllWorkpacksForFilterSideBarQueryVariables>(AllWorkpacksForFilterSideBarDocument, options);
        }
export type AllWorkpacksForFilterSideBarQueryHookResult = ReturnType<typeof useAllWorkpacksForFilterSideBarQuery>;
export type AllWorkpacksForFilterSideBarLazyQueryHookResult = ReturnType<typeof useAllWorkpacksForFilterSideBarLazyQuery>;
export type AllWorkpacksForFilterSideBarSuspenseQueryHookResult = ReturnType<typeof useAllWorkpacksForFilterSideBarSuspenseQuery>;
export type AllWorkpacksForFilterSideBarQueryResult = Apollo.QueryResult<AllWorkpacksForFilterSideBarQuery, AllWorkpacksForFilterSideBarQueryVariables>;
export const UpdateFileStatusDocument = gql`
    mutation UpdateFileStatus($input: UpdateFilesStatusInput!) {
  updateFilesStatus(input: $input)
}
    `;
export type UpdateFileStatusMutationFn = Apollo.MutationFunction<UpdateFileStatusMutation, UpdateFileStatusMutationVariables>;

/**
 * __useUpdateFileStatusMutation__
 *
 * To run a mutation, you first call `useUpdateFileStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateFileStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateFileStatusMutation, { data, loading, error }] = useUpdateFileStatusMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateFileStatusMutation(baseOptions?: Apollo.MutationHookOptions<UpdateFileStatusMutation, UpdateFileStatusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateFileStatusMutation, UpdateFileStatusMutationVariables>(UpdateFileStatusDocument, options);
      }
export type UpdateFileStatusMutationHookResult = ReturnType<typeof useUpdateFileStatusMutation>;
export type UpdateFileStatusMutationResult = Apollo.MutationResult<UpdateFileStatusMutation>;
export type UpdateFileStatusMutationOptions = Apollo.BaseMutationOptions<UpdateFileStatusMutation, UpdateFileStatusMutationVariables>;
export const UploadFilesDocument = gql`
    mutation UploadFiles($input: UploadFileInput!) {
  preSignedUrlToUploadFiles(input: $input) {
    url
    id
    resourcePath
    uuid
  }
}
    `;
export type UploadFilesMutationFn = Apollo.MutationFunction<UploadFilesMutation, UploadFilesMutationVariables>;

/**
 * __useUploadFilesMutation__
 *
 * To run a mutation, you first call `useUploadFilesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUploadFilesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [uploadFilesMutation, { data, loading, error }] = useUploadFilesMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUploadFilesMutation(baseOptions?: Apollo.MutationHookOptions<UploadFilesMutation, UploadFilesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UploadFilesMutation, UploadFilesMutationVariables>(UploadFilesDocument, options);
      }
export type UploadFilesMutationHookResult = ReturnType<typeof useUploadFilesMutation>;
export type UploadFilesMutationResult = Apollo.MutationResult<UploadFilesMutation>;
export type UploadFilesMutationOptions = Apollo.BaseMutationOptions<UploadFilesMutation, UploadFilesMutationVariables>;
export const DeleteFilesDocument = gql`
    mutation DeleteFiles($input: DeleteFilesInput!) {
  deleteFiles(input: $input) {
    message
    deletedFiles
  }
}
    `;
export type DeleteFilesMutationFn = Apollo.MutationFunction<DeleteFilesMutation, DeleteFilesMutationVariables>;

/**
 * __useDeleteFilesMutation__
 *
 * To run a mutation, you first call `useDeleteFilesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteFilesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteFilesMutation, { data, loading, error }] = useDeleteFilesMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteFilesMutation(baseOptions?: Apollo.MutationHookOptions<DeleteFilesMutation, DeleteFilesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteFilesMutation, DeleteFilesMutationVariables>(DeleteFilesDocument, options);
      }
export type DeleteFilesMutationHookResult = ReturnType<typeof useDeleteFilesMutation>;
export type DeleteFilesMutationResult = Apollo.MutationResult<DeleteFilesMutation>;
export type DeleteFilesMutationOptions = Apollo.BaseMutationOptions<DeleteFilesMutation, DeleteFilesMutationVariables>;
export const AssemblyImageCaptionDocument = gql`
    mutation AssemblyImageCaption($input: AssemblyImageCaptionInput!) {
  addAssemblyImageCaption(input: $input)
}
    `;
export type AssemblyImageCaptionMutationFn = Apollo.MutationFunction<AssemblyImageCaptionMutation, AssemblyImageCaptionMutationVariables>;

/**
 * __useAssemblyImageCaptionMutation__
 *
 * To run a mutation, you first call `useAssemblyImageCaptionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAssemblyImageCaptionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [assemblyImageCaptionMutation, { data, loading, error }] = useAssemblyImageCaptionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAssemblyImageCaptionMutation(baseOptions?: Apollo.MutationHookOptions<AssemblyImageCaptionMutation, AssemblyImageCaptionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AssemblyImageCaptionMutation, AssemblyImageCaptionMutationVariables>(AssemblyImageCaptionDocument, options);
      }
export type AssemblyImageCaptionMutationHookResult = ReturnType<typeof useAssemblyImageCaptionMutation>;
export type AssemblyImageCaptionMutationResult = Apollo.MutationResult<AssemblyImageCaptionMutation>;
export type AssemblyImageCaptionMutationOptions = Apollo.BaseMutationOptions<AssemblyImageCaptionMutation, AssemblyImageCaptionMutationVariables>;
export const AssemblyAttachmentsGeneralNoteDocument = gql`
    mutation AssemblyAttachmentsGeneralNote($input: UpdateAssemblyInput) {
  updateAssembly(input: $input) {
    id
    generalAttachmentsNote
  }
}
    `;
export type AssemblyAttachmentsGeneralNoteMutationFn = Apollo.MutationFunction<AssemblyAttachmentsGeneralNoteMutation, AssemblyAttachmentsGeneralNoteMutationVariables>;

/**
 * __useAssemblyAttachmentsGeneralNoteMutation__
 *
 * To run a mutation, you first call `useAssemblyAttachmentsGeneralNoteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAssemblyAttachmentsGeneralNoteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [assemblyAttachmentsGeneralNoteMutation, { data, loading, error }] = useAssemblyAttachmentsGeneralNoteMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAssemblyAttachmentsGeneralNoteMutation(baseOptions?: Apollo.MutationHookOptions<AssemblyAttachmentsGeneralNoteMutation, AssemblyAttachmentsGeneralNoteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AssemblyAttachmentsGeneralNoteMutation, AssemblyAttachmentsGeneralNoteMutationVariables>(AssemblyAttachmentsGeneralNoteDocument, options);
      }
export type AssemblyAttachmentsGeneralNoteMutationHookResult = ReturnType<typeof useAssemblyAttachmentsGeneralNoteMutation>;
export type AssemblyAttachmentsGeneralNoteMutationResult = Apollo.MutationResult<AssemblyAttachmentsGeneralNoteMutation>;
export type AssemblyAttachmentsGeneralNoteMutationOptions = Apollo.BaseMutationOptions<AssemblyAttachmentsGeneralNoteMutation, AssemblyAttachmentsGeneralNoteMutationVariables>;
export const AddUpdateCuboidDocument = gql`
    mutation AddUpdateCuboid($input: AddUpdateCuboidInput) {
  addUpdateCuboid(input: $input) {
    id
    structureId
    cuboidClassId
    zoneId
    position
    scale
    rotation
  }
}
    `;
export type AddUpdateCuboidMutationFn = Apollo.MutationFunction<AddUpdateCuboidMutation, AddUpdateCuboidMutationVariables>;

/**
 * __useAddUpdateCuboidMutation__
 *
 * To run a mutation, you first call `useAddUpdateCuboidMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddUpdateCuboidMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addUpdateCuboidMutation, { data, loading, error }] = useAddUpdateCuboidMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddUpdateCuboidMutation(baseOptions?: Apollo.MutationHookOptions<AddUpdateCuboidMutation, AddUpdateCuboidMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddUpdateCuboidMutation, AddUpdateCuboidMutationVariables>(AddUpdateCuboidDocument, options);
      }
export type AddUpdateCuboidMutationHookResult = ReturnType<typeof useAddUpdateCuboidMutation>;
export type AddUpdateCuboidMutationResult = Apollo.MutationResult<AddUpdateCuboidMutation>;
export type AddUpdateCuboidMutationOptions = Apollo.BaseMutationOptions<AddUpdateCuboidMutation, AddUpdateCuboidMutationVariables>;
export const DeleteCuboidDocument = gql`
    mutation DeleteCuboid($input: DeleteCuboidInput) {
  deleteCuboid(input: $input)
}
    `;
export type DeleteCuboidMutationFn = Apollo.MutationFunction<DeleteCuboidMutation, DeleteCuboidMutationVariables>;

/**
 * __useDeleteCuboidMutation__
 *
 * To run a mutation, you first call `useDeleteCuboidMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCuboidMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteCuboidMutation, { data, loading, error }] = useDeleteCuboidMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteCuboidMutation(baseOptions?: Apollo.MutationHookOptions<DeleteCuboidMutation, DeleteCuboidMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteCuboidMutation, DeleteCuboidMutationVariables>(DeleteCuboidDocument, options);
      }
export type DeleteCuboidMutationHookResult = ReturnType<typeof useDeleteCuboidMutation>;
export type DeleteCuboidMutationResult = Apollo.MutationResult<DeleteCuboidMutation>;
export type DeleteCuboidMutationOptions = Apollo.BaseMutationOptions<DeleteCuboidMutation, DeleteCuboidMutationVariables>;
export const GetStructureLocationsForAssetLabellingDataLoaderDocument = gql`
    query getStructureLocationsForAssetLabellingDataLoader($structureId: ID!) {
  allLocations(structureId: $structureId) {
    id
    name
    resourcePath
    pose {
      yaw
      pitch
      roll
      z
      y
      x
      yawOffset
    }
    videoResourcePath
    videoTimestamp
    imageSensor {
      width
      height
      cx
      cy
      focalLength
    }
  }
}
    `;

/**
 * __useGetStructureLocationsForAssetLabellingDataLoaderQuery__
 *
 * To run a query within a React component, call `useGetStructureLocationsForAssetLabellingDataLoaderQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetStructureLocationsForAssetLabellingDataLoaderQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetStructureLocationsForAssetLabellingDataLoaderQuery({
 *   variables: {
 *      structureId: // value for 'structureId'
 *   },
 * });
 */
export function useGetStructureLocationsForAssetLabellingDataLoaderQuery(baseOptions: Apollo.QueryHookOptions<GetStructureLocationsForAssetLabellingDataLoaderQuery, GetStructureLocationsForAssetLabellingDataLoaderQueryVariables> & ({ variables: GetStructureLocationsForAssetLabellingDataLoaderQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetStructureLocationsForAssetLabellingDataLoaderQuery, GetStructureLocationsForAssetLabellingDataLoaderQueryVariables>(GetStructureLocationsForAssetLabellingDataLoaderDocument, options);
      }
export function useGetStructureLocationsForAssetLabellingDataLoaderLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetStructureLocationsForAssetLabellingDataLoaderQuery, GetStructureLocationsForAssetLabellingDataLoaderQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetStructureLocationsForAssetLabellingDataLoaderQuery, GetStructureLocationsForAssetLabellingDataLoaderQueryVariables>(GetStructureLocationsForAssetLabellingDataLoaderDocument, options);
        }
// @ts-ignore
export function useGetStructureLocationsForAssetLabellingDataLoaderSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetStructureLocationsForAssetLabellingDataLoaderQuery, GetStructureLocationsForAssetLabellingDataLoaderQueryVariables>): Apollo.UseSuspenseQueryResult<GetStructureLocationsForAssetLabellingDataLoaderQuery, GetStructureLocationsForAssetLabellingDataLoaderQueryVariables>;
export function useGetStructureLocationsForAssetLabellingDataLoaderSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetStructureLocationsForAssetLabellingDataLoaderQuery, GetStructureLocationsForAssetLabellingDataLoaderQueryVariables>): Apollo.UseSuspenseQueryResult<GetStructureLocationsForAssetLabellingDataLoaderQuery | undefined, GetStructureLocationsForAssetLabellingDataLoaderQueryVariables>;
export function useGetStructureLocationsForAssetLabellingDataLoaderSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetStructureLocationsForAssetLabellingDataLoaderQuery, GetStructureLocationsForAssetLabellingDataLoaderQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetStructureLocationsForAssetLabellingDataLoaderQuery, GetStructureLocationsForAssetLabellingDataLoaderQueryVariables>(GetStructureLocationsForAssetLabellingDataLoaderDocument, options);
        }
export type GetStructureLocationsForAssetLabellingDataLoaderQueryHookResult = ReturnType<typeof useGetStructureLocationsForAssetLabellingDataLoaderQuery>;
export type GetStructureLocationsForAssetLabellingDataLoaderLazyQueryHookResult = ReturnType<typeof useGetStructureLocationsForAssetLabellingDataLoaderLazyQuery>;
export type GetStructureLocationsForAssetLabellingDataLoaderSuspenseQueryHookResult = ReturnType<typeof useGetStructureLocationsForAssetLabellingDataLoaderSuspenseQuery>;
export type GetStructureLocationsForAssetLabellingDataLoaderQueryResult = Apollo.QueryResult<GetStructureLocationsForAssetLabellingDataLoaderQuery, GetStructureLocationsForAssetLabellingDataLoaderQueryVariables>;
export const GetAllLabelAnnotationsDocument = gql`
    query getAllLabelAnnotations($structureId: String!) {
  allLabelAnnotations(structureId: $structureId) {
    id
    labelClassId
    octreeId
  }
}
    `;

/**
 * __useGetAllLabelAnnotationsQuery__
 *
 * To run a query within a React component, call `useGetAllLabelAnnotationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllLabelAnnotationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllLabelAnnotationsQuery({
 *   variables: {
 *      structureId: // value for 'structureId'
 *   },
 * });
 */
export function useGetAllLabelAnnotationsQuery(baseOptions: Apollo.QueryHookOptions<GetAllLabelAnnotationsQuery, GetAllLabelAnnotationsQueryVariables> & ({ variables: GetAllLabelAnnotationsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllLabelAnnotationsQuery, GetAllLabelAnnotationsQueryVariables>(GetAllLabelAnnotationsDocument, options);
      }
export function useGetAllLabelAnnotationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllLabelAnnotationsQuery, GetAllLabelAnnotationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllLabelAnnotationsQuery, GetAllLabelAnnotationsQueryVariables>(GetAllLabelAnnotationsDocument, options);
        }
// @ts-ignore
export function useGetAllLabelAnnotationsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetAllLabelAnnotationsQuery, GetAllLabelAnnotationsQueryVariables>): Apollo.UseSuspenseQueryResult<GetAllLabelAnnotationsQuery, GetAllLabelAnnotationsQueryVariables>;
export function useGetAllLabelAnnotationsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAllLabelAnnotationsQuery, GetAllLabelAnnotationsQueryVariables>): Apollo.UseSuspenseQueryResult<GetAllLabelAnnotationsQuery | undefined, GetAllLabelAnnotationsQueryVariables>;
export function useGetAllLabelAnnotationsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAllLabelAnnotationsQuery, GetAllLabelAnnotationsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAllLabelAnnotationsQuery, GetAllLabelAnnotationsQueryVariables>(GetAllLabelAnnotationsDocument, options);
        }
export type GetAllLabelAnnotationsQueryHookResult = ReturnType<typeof useGetAllLabelAnnotationsQuery>;
export type GetAllLabelAnnotationsLazyQueryHookResult = ReturnType<typeof useGetAllLabelAnnotationsLazyQuery>;
export type GetAllLabelAnnotationsSuspenseQueryHookResult = ReturnType<typeof useGetAllLabelAnnotationsSuspenseQuery>;
export type GetAllLabelAnnotationsQueryResult = Apollo.QueryResult<GetAllLabelAnnotationsQuery, GetAllLabelAnnotationsQueryVariables>;
export const GetStructureForAssetLabellingDocument = gql`
    query getStructureForAssetLabelling($structureId: String!) {
  structure(structureId: $structureId) {
    id
    name
    octreeResourcesPath
    hasRGB
    labelClasses {
      id
      name
      color
    }
    cuboidClasses {
      id
      name
      color
    }
  }
}
    `;

/**
 * __useGetStructureForAssetLabellingQuery__
 *
 * To run a query within a React component, call `useGetStructureForAssetLabellingQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetStructureForAssetLabellingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetStructureForAssetLabellingQuery({
 *   variables: {
 *      structureId: // value for 'structureId'
 *   },
 * });
 */
export function useGetStructureForAssetLabellingQuery(baseOptions: Apollo.QueryHookOptions<GetStructureForAssetLabellingQuery, GetStructureForAssetLabellingQueryVariables> & ({ variables: GetStructureForAssetLabellingQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetStructureForAssetLabellingQuery, GetStructureForAssetLabellingQueryVariables>(GetStructureForAssetLabellingDocument, options);
      }
export function useGetStructureForAssetLabellingLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetStructureForAssetLabellingQuery, GetStructureForAssetLabellingQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetStructureForAssetLabellingQuery, GetStructureForAssetLabellingQueryVariables>(GetStructureForAssetLabellingDocument, options);
        }
// @ts-ignore
export function useGetStructureForAssetLabellingSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetStructureForAssetLabellingQuery, GetStructureForAssetLabellingQueryVariables>): Apollo.UseSuspenseQueryResult<GetStructureForAssetLabellingQuery, GetStructureForAssetLabellingQueryVariables>;
export function useGetStructureForAssetLabellingSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetStructureForAssetLabellingQuery, GetStructureForAssetLabellingQueryVariables>): Apollo.UseSuspenseQueryResult<GetStructureForAssetLabellingQuery | undefined, GetStructureForAssetLabellingQueryVariables>;
export function useGetStructureForAssetLabellingSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetStructureForAssetLabellingQuery, GetStructureForAssetLabellingQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetStructureForAssetLabellingQuery, GetStructureForAssetLabellingQueryVariables>(GetStructureForAssetLabellingDocument, options);
        }
export type GetStructureForAssetLabellingQueryHookResult = ReturnType<typeof useGetStructureForAssetLabellingQuery>;
export type GetStructureForAssetLabellingLazyQueryHookResult = ReturnType<typeof useGetStructureForAssetLabellingLazyQuery>;
export type GetStructureForAssetLabellingSuspenseQueryHookResult = ReturnType<typeof useGetStructureForAssetLabellingSuspenseQuery>;
export type GetStructureForAssetLabellingQueryResult = Apollo.QueryResult<GetStructureForAssetLabellingQuery, GetStructureForAssetLabellingQueryVariables>;
export const GetAllZonesForAssetLabellingDocument = gql`
    query GetAllZonesForAssetLabelling($structureId: String!) {
  zonesForStructure(structureId: $structureId) {
    id
    name
    box {
      min {
        x
        y
        z
      }
      max {
        x
        y
        z
      }
    }
    status
    structureId
    workflowStatus {
      workflowStageId
      state
      pausedBy
      assignedToUser {
        id
        name
        email
        picture
        roleIds {
          name
          auth0Id
          id
        }
      }
    }
  }
}
    `;

/**
 * __useGetAllZonesForAssetLabellingQuery__
 *
 * To run a query within a React component, call `useGetAllZonesForAssetLabellingQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllZonesForAssetLabellingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllZonesForAssetLabellingQuery({
 *   variables: {
 *      structureId: // value for 'structureId'
 *   },
 * });
 */
export function useGetAllZonesForAssetLabellingQuery(baseOptions: Apollo.QueryHookOptions<GetAllZonesForAssetLabellingQuery, GetAllZonesForAssetLabellingQueryVariables> & ({ variables: GetAllZonesForAssetLabellingQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllZonesForAssetLabellingQuery, GetAllZonesForAssetLabellingQueryVariables>(GetAllZonesForAssetLabellingDocument, options);
      }
export function useGetAllZonesForAssetLabellingLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllZonesForAssetLabellingQuery, GetAllZonesForAssetLabellingQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllZonesForAssetLabellingQuery, GetAllZonesForAssetLabellingQueryVariables>(GetAllZonesForAssetLabellingDocument, options);
        }
// @ts-ignore
export function useGetAllZonesForAssetLabellingSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetAllZonesForAssetLabellingQuery, GetAllZonesForAssetLabellingQueryVariables>): Apollo.UseSuspenseQueryResult<GetAllZonesForAssetLabellingQuery, GetAllZonesForAssetLabellingQueryVariables>;
export function useGetAllZonesForAssetLabellingSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAllZonesForAssetLabellingQuery, GetAllZonesForAssetLabellingQueryVariables>): Apollo.UseSuspenseQueryResult<GetAllZonesForAssetLabellingQuery | undefined, GetAllZonesForAssetLabellingQueryVariables>;
export function useGetAllZonesForAssetLabellingSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAllZonesForAssetLabellingQuery, GetAllZonesForAssetLabellingQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAllZonesForAssetLabellingQuery, GetAllZonesForAssetLabellingQueryVariables>(GetAllZonesForAssetLabellingDocument, options);
        }
export type GetAllZonesForAssetLabellingQueryHookResult = ReturnType<typeof useGetAllZonesForAssetLabellingQuery>;
export type GetAllZonesForAssetLabellingLazyQueryHookResult = ReturnType<typeof useGetAllZonesForAssetLabellingLazyQuery>;
export type GetAllZonesForAssetLabellingSuspenseQueryHookResult = ReturnType<typeof useGetAllZonesForAssetLabellingSuspenseQuery>;
export type GetAllZonesForAssetLabellingQueryResult = Apollo.QueryResult<GetAllZonesForAssetLabellingQuery, GetAllZonesForAssetLabellingQueryVariables>;
export const GetCuboidsByZoneIdDocument = gql`
    query getCuboidsByZoneId($zoneId: String!) {
  cuboidsByZoneId(zoneId: $zoneId) {
    id
    structureId
    cuboidClassId
    zoneId
    position
    scale
    rotation
  }
}
    `;

/**
 * __useGetCuboidsByZoneIdQuery__
 *
 * To run a query within a React component, call `useGetCuboidsByZoneIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCuboidsByZoneIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCuboidsByZoneIdQuery({
 *   variables: {
 *      zoneId: // value for 'zoneId'
 *   },
 * });
 */
export function useGetCuboidsByZoneIdQuery(baseOptions: Apollo.QueryHookOptions<GetCuboidsByZoneIdQuery, GetCuboidsByZoneIdQueryVariables> & ({ variables: GetCuboidsByZoneIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCuboidsByZoneIdQuery, GetCuboidsByZoneIdQueryVariables>(GetCuboidsByZoneIdDocument, options);
      }
export function useGetCuboidsByZoneIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCuboidsByZoneIdQuery, GetCuboidsByZoneIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCuboidsByZoneIdQuery, GetCuboidsByZoneIdQueryVariables>(GetCuboidsByZoneIdDocument, options);
        }
// @ts-ignore
export function useGetCuboidsByZoneIdSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetCuboidsByZoneIdQuery, GetCuboidsByZoneIdQueryVariables>): Apollo.UseSuspenseQueryResult<GetCuboidsByZoneIdQuery, GetCuboidsByZoneIdQueryVariables>;
export function useGetCuboidsByZoneIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCuboidsByZoneIdQuery, GetCuboidsByZoneIdQueryVariables>): Apollo.UseSuspenseQueryResult<GetCuboidsByZoneIdQuery | undefined, GetCuboidsByZoneIdQueryVariables>;
export function useGetCuboidsByZoneIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCuboidsByZoneIdQuery, GetCuboidsByZoneIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCuboidsByZoneIdQuery, GetCuboidsByZoneIdQueryVariables>(GetCuboidsByZoneIdDocument, options);
        }
export type GetCuboidsByZoneIdQueryHookResult = ReturnType<typeof useGetCuboidsByZoneIdQuery>;
export type GetCuboidsByZoneIdLazyQueryHookResult = ReturnType<typeof useGetCuboidsByZoneIdLazyQuery>;
export type GetCuboidsByZoneIdSuspenseQueryHookResult = ReturnType<typeof useGetCuboidsByZoneIdSuspenseQuery>;
export type GetCuboidsByZoneIdQueryResult = Apollo.QueryResult<GetCuboidsByZoneIdQuery, GetCuboidsByZoneIdQueryVariables>;
export const BenchmarkUploadDocument = gql`
    mutation benchmarkUpload($input: BenchmarkUploadInput) {
  benchmarkUpload(input: $input) {
    size
  }
}
    `;
export type BenchmarkUploadMutationFn = Apollo.MutationFunction<BenchmarkUploadMutation, BenchmarkUploadMutationVariables>;

/**
 * __useBenchmarkUploadMutation__
 *
 * To run a mutation, you first call `useBenchmarkUploadMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBenchmarkUploadMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [benchmarkUploadMutation, { data, loading, error }] = useBenchmarkUploadMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useBenchmarkUploadMutation(baseOptions?: Apollo.MutationHookOptions<BenchmarkUploadMutation, BenchmarkUploadMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<BenchmarkUploadMutation, BenchmarkUploadMutationVariables>(BenchmarkUploadDocument, options);
      }
export type BenchmarkUploadMutationHookResult = ReturnType<typeof useBenchmarkUploadMutation>;
export type BenchmarkUploadMutationResult = Apollo.MutationResult<BenchmarkUploadMutation>;
export type BenchmarkUploadMutationOptions = Apollo.BaseMutationOptions<BenchmarkUploadMutation, BenchmarkUploadMutationVariables>;
export const BenchmarkDownloadDocument = gql`
    mutation benchmarkDownload($input: BenchmarkDownloadInput) {
  benchmarkDownload(input: $input) {
    data
  }
}
    `;
export type BenchmarkDownloadMutationFn = Apollo.MutationFunction<BenchmarkDownloadMutation, BenchmarkDownloadMutationVariables>;

/**
 * __useBenchmarkDownloadMutation__
 *
 * To run a mutation, you first call `useBenchmarkDownloadMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBenchmarkDownloadMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [benchmarkDownloadMutation, { data, loading, error }] = useBenchmarkDownloadMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useBenchmarkDownloadMutation(baseOptions?: Apollo.MutationHookOptions<BenchmarkDownloadMutation, BenchmarkDownloadMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<BenchmarkDownloadMutation, BenchmarkDownloadMutationVariables>(BenchmarkDownloadDocument, options);
      }
export type BenchmarkDownloadMutationHookResult = ReturnType<typeof useBenchmarkDownloadMutation>;
export type BenchmarkDownloadMutationResult = Apollo.MutationResult<BenchmarkDownloadMutation>;
export type BenchmarkDownloadMutationOptions = Apollo.BaseMutationOptions<BenchmarkDownloadMutation, BenchmarkDownloadMutationVariables>;
export const ValidateEsSheetDocument = gql`
    mutation ValidateEsSheet($headers: [String!]!, $isLegacy: Boolean!) {
  validateEsSheet(headers: $headers, isLegacy: $isLegacy)
}
    `;
export type ValidateEsSheetMutationFn = Apollo.MutationFunction<ValidateEsSheetMutation, ValidateEsSheetMutationVariables>;

/**
 * __useValidateEsSheetMutation__
 *
 * To run a mutation, you first call `useValidateEsSheetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useValidateEsSheetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [validateEsSheetMutation, { data, loading, error }] = useValidateEsSheetMutation({
 *   variables: {
 *      headers: // value for 'headers'
 *      isLegacy: // value for 'isLegacy'
 *   },
 * });
 */
export function useValidateEsSheetMutation(baseOptions?: Apollo.MutationHookOptions<ValidateEsSheetMutation, ValidateEsSheetMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ValidateEsSheetMutation, ValidateEsSheetMutationVariables>(ValidateEsSheetDocument, options);
      }
export type ValidateEsSheetMutationHookResult = ReturnType<typeof useValidateEsSheetMutation>;
export type ValidateEsSheetMutationResult = Apollo.MutationResult<ValidateEsSheetMutation>;
export type ValidateEsSheetMutationOptions = Apollo.BaseMutationOptions<ValidateEsSheetMutation, ValidateEsSheetMutationVariables>;
export const UploadEsSheetDocument = gql`
    mutation UploadEsSheet($input: UploadEsSheetInput!) {
  uploadEsSheet(input: $input)
}
    `;
export type UploadEsSheetMutationFn = Apollo.MutationFunction<UploadEsSheetMutation, UploadEsSheetMutationVariables>;

/**
 * __useUploadEsSheetMutation__
 *
 * To run a mutation, you first call `useUploadEsSheetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUploadEsSheetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [uploadEsSheetMutation, { data, loading, error }] = useUploadEsSheetMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUploadEsSheetMutation(baseOptions?: Apollo.MutationHookOptions<UploadEsSheetMutation, UploadEsSheetMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UploadEsSheetMutation, UploadEsSheetMutationVariables>(UploadEsSheetDocument, options);
      }
export type UploadEsSheetMutationHookResult = ReturnType<typeof useUploadEsSheetMutation>;
export type UploadEsSheetMutationResult = Apollo.MutationResult<UploadEsSheetMutation>;
export type UploadEsSheetMutationOptions = Apollo.BaseMutationOptions<UploadEsSheetMutation, UploadEsSheetMutationVariables>;
export const GetStructureDocument = gql`
    query GetStructure($structureId: String) {
  structure(structureId: $structureId) {
    name
    templateData {
      id
      value
    }
  }
}
    `;

/**
 * __useGetStructureQuery__
 *
 * To run a query within a React component, call `useGetStructureQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetStructureQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetStructureQuery({
 *   variables: {
 *      structureId: // value for 'structureId'
 *   },
 * });
 */
export function useGetStructureQuery(baseOptions?: Apollo.QueryHookOptions<GetStructureQuery, GetStructureQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetStructureQuery, GetStructureQueryVariables>(GetStructureDocument, options);
      }
export function useGetStructureLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetStructureQuery, GetStructureQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetStructureQuery, GetStructureQueryVariables>(GetStructureDocument, options);
        }
// @ts-ignore
export function useGetStructureSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetStructureQuery, GetStructureQueryVariables>): Apollo.UseSuspenseQueryResult<GetStructureQuery, GetStructureQueryVariables>;
export function useGetStructureSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetStructureQuery, GetStructureQueryVariables>): Apollo.UseSuspenseQueryResult<GetStructureQuery | undefined, GetStructureQueryVariables>;
export function useGetStructureSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetStructureQuery, GetStructureQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetStructureQuery, GetStructureQueryVariables>(GetStructureDocument, options);
        }
export type GetStructureQueryHookResult = ReturnType<typeof useGetStructureQuery>;
export type GetStructureLazyQueryHookResult = ReturnType<typeof useGetStructureLazyQuery>;
export type GetStructureSuspenseQueryHookResult = ReturnType<typeof useGetStructureSuspenseQuery>;
export type GetStructureQueryResult = Apollo.QueryResult<GetStructureQuery, GetStructureQueryVariables>;
export const UploadLegacyEsSheetDocument = gql`
    mutation UploadLegacyEsSheet($input: UploadLegacyEsSheetInput!) {
  uploadLegacyEsSheet(input: $input)
}
    `;
export type UploadLegacyEsSheetMutationFn = Apollo.MutationFunction<UploadLegacyEsSheetMutation, UploadLegacyEsSheetMutationVariables>;

/**
 * __useUploadLegacyEsSheetMutation__
 *
 * To run a mutation, you first call `useUploadLegacyEsSheetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUploadLegacyEsSheetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [uploadLegacyEsSheetMutation, { data, loading, error }] = useUploadLegacyEsSheetMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUploadLegacyEsSheetMutation(baseOptions?: Apollo.MutationHookOptions<UploadLegacyEsSheetMutation, UploadLegacyEsSheetMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UploadLegacyEsSheetMutation, UploadLegacyEsSheetMutationVariables>(UploadLegacyEsSheetDocument, options);
      }
export type UploadLegacyEsSheetMutationHookResult = ReturnType<typeof useUploadLegacyEsSheetMutation>;
export type UploadLegacyEsSheetMutationResult = Apollo.MutationResult<UploadLegacyEsSheetMutation>;
export type UploadLegacyEsSheetMutationOptions = Apollo.BaseMutationOptions<UploadLegacyEsSheetMutation, UploadLegacyEsSheetMutationVariables>;
export const GetStructureRelationshipsForLabellingInspectionDataLoaderDocument = gql`
    query getStructureRelationshipsForLabellingInspectionDataLoader($structureId: String!, $supervoxelsForStructureInput: supervoxelsForStructureInput) {
  supervoxelsClassesForStructure(structureId: $structureId) {
    color
    id
    name
    structureId
  }
  supervoxelsForStructure(
    supervoxelsForStructureInput: $supervoxelsForStructureInput
  ) {
    id
    zoneId
    structureId
    supervoxel3DReference
    supervoxelClassId
  }
  structure(structureId: $structureId) {
    octreeResourcesPath
  }
}
    `;

/**
 * __useGetStructureRelationshipsForLabellingInspectionDataLoaderQuery__
 *
 * To run a query within a React component, call `useGetStructureRelationshipsForLabellingInspectionDataLoaderQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetStructureRelationshipsForLabellingInspectionDataLoaderQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetStructureRelationshipsForLabellingInspectionDataLoaderQuery({
 *   variables: {
 *      structureId: // value for 'structureId'
 *      supervoxelsForStructureInput: // value for 'supervoxelsForStructureInput'
 *   },
 * });
 */
export function useGetStructureRelationshipsForLabellingInspectionDataLoaderQuery(baseOptions: Apollo.QueryHookOptions<GetStructureRelationshipsForLabellingInspectionDataLoaderQuery, GetStructureRelationshipsForLabellingInspectionDataLoaderQueryVariables> & ({ variables: GetStructureRelationshipsForLabellingInspectionDataLoaderQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetStructureRelationshipsForLabellingInspectionDataLoaderQuery, GetStructureRelationshipsForLabellingInspectionDataLoaderQueryVariables>(GetStructureRelationshipsForLabellingInspectionDataLoaderDocument, options);
      }
export function useGetStructureRelationshipsForLabellingInspectionDataLoaderLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetStructureRelationshipsForLabellingInspectionDataLoaderQuery, GetStructureRelationshipsForLabellingInspectionDataLoaderQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetStructureRelationshipsForLabellingInspectionDataLoaderQuery, GetStructureRelationshipsForLabellingInspectionDataLoaderQueryVariables>(GetStructureRelationshipsForLabellingInspectionDataLoaderDocument, options);
        }
// @ts-ignore
export function useGetStructureRelationshipsForLabellingInspectionDataLoaderSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetStructureRelationshipsForLabellingInspectionDataLoaderQuery, GetStructureRelationshipsForLabellingInspectionDataLoaderQueryVariables>): Apollo.UseSuspenseQueryResult<GetStructureRelationshipsForLabellingInspectionDataLoaderQuery, GetStructureRelationshipsForLabellingInspectionDataLoaderQueryVariables>;
export function useGetStructureRelationshipsForLabellingInspectionDataLoaderSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetStructureRelationshipsForLabellingInspectionDataLoaderQuery, GetStructureRelationshipsForLabellingInspectionDataLoaderQueryVariables>): Apollo.UseSuspenseQueryResult<GetStructureRelationshipsForLabellingInspectionDataLoaderQuery | undefined, GetStructureRelationshipsForLabellingInspectionDataLoaderQueryVariables>;
export function useGetStructureRelationshipsForLabellingInspectionDataLoaderSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetStructureRelationshipsForLabellingInspectionDataLoaderQuery, GetStructureRelationshipsForLabellingInspectionDataLoaderQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetStructureRelationshipsForLabellingInspectionDataLoaderQuery, GetStructureRelationshipsForLabellingInspectionDataLoaderQueryVariables>(GetStructureRelationshipsForLabellingInspectionDataLoaderDocument, options);
        }
export type GetStructureRelationshipsForLabellingInspectionDataLoaderQueryHookResult = ReturnType<typeof useGetStructureRelationshipsForLabellingInspectionDataLoaderQuery>;
export type GetStructureRelationshipsForLabellingInspectionDataLoaderLazyQueryHookResult = ReturnType<typeof useGetStructureRelationshipsForLabellingInspectionDataLoaderLazyQuery>;
export type GetStructureRelationshipsForLabellingInspectionDataLoaderSuspenseQueryHookResult = ReturnType<typeof useGetStructureRelationshipsForLabellingInspectionDataLoaderSuspenseQuery>;
export type GetStructureRelationshipsForLabellingInspectionDataLoaderQueryResult = Apollo.QueryResult<GetStructureRelationshipsForLabellingInspectionDataLoaderQuery, GetStructureRelationshipsForLabellingInspectionDataLoaderQueryVariables>;
export const GetStructureLocationsForLabellingInspectionDataLoaderDocument = gql`
    query getStructureLocationsForLabellingInspectionDataLoader($structureId: ID!) {
  allLocations(structureId: $structureId) {
    id
    name
    resourcePath
    videoResourcePath
    videoTimestamp
    pose {
      yaw
      pitch
      roll
      z
      y
      x
      yawOffset
    }
  }
}
    `;

/**
 * __useGetStructureLocationsForLabellingInspectionDataLoaderQuery__
 *
 * To run a query within a React component, call `useGetStructureLocationsForLabellingInspectionDataLoaderQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetStructureLocationsForLabellingInspectionDataLoaderQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetStructureLocationsForLabellingInspectionDataLoaderQuery({
 *   variables: {
 *      structureId: // value for 'structureId'
 *   },
 * });
 */
export function useGetStructureLocationsForLabellingInspectionDataLoaderQuery(baseOptions: Apollo.QueryHookOptions<GetStructureLocationsForLabellingInspectionDataLoaderQuery, GetStructureLocationsForLabellingInspectionDataLoaderQueryVariables> & ({ variables: GetStructureLocationsForLabellingInspectionDataLoaderQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetStructureLocationsForLabellingInspectionDataLoaderQuery, GetStructureLocationsForLabellingInspectionDataLoaderQueryVariables>(GetStructureLocationsForLabellingInspectionDataLoaderDocument, options);
      }
export function useGetStructureLocationsForLabellingInspectionDataLoaderLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetStructureLocationsForLabellingInspectionDataLoaderQuery, GetStructureLocationsForLabellingInspectionDataLoaderQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetStructureLocationsForLabellingInspectionDataLoaderQuery, GetStructureLocationsForLabellingInspectionDataLoaderQueryVariables>(GetStructureLocationsForLabellingInspectionDataLoaderDocument, options);
        }
// @ts-ignore
export function useGetStructureLocationsForLabellingInspectionDataLoaderSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetStructureLocationsForLabellingInspectionDataLoaderQuery, GetStructureLocationsForLabellingInspectionDataLoaderQueryVariables>): Apollo.UseSuspenseQueryResult<GetStructureLocationsForLabellingInspectionDataLoaderQuery, GetStructureLocationsForLabellingInspectionDataLoaderQueryVariables>;
export function useGetStructureLocationsForLabellingInspectionDataLoaderSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetStructureLocationsForLabellingInspectionDataLoaderQuery, GetStructureLocationsForLabellingInspectionDataLoaderQueryVariables>): Apollo.UseSuspenseQueryResult<GetStructureLocationsForLabellingInspectionDataLoaderQuery | undefined, GetStructureLocationsForLabellingInspectionDataLoaderQueryVariables>;
export function useGetStructureLocationsForLabellingInspectionDataLoaderSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetStructureLocationsForLabellingInspectionDataLoaderQuery, GetStructureLocationsForLabellingInspectionDataLoaderQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetStructureLocationsForLabellingInspectionDataLoaderQuery, GetStructureLocationsForLabellingInspectionDataLoaderQueryVariables>(GetStructureLocationsForLabellingInspectionDataLoaderDocument, options);
        }
export type GetStructureLocationsForLabellingInspectionDataLoaderQueryHookResult = ReturnType<typeof useGetStructureLocationsForLabellingInspectionDataLoaderQuery>;
export type GetStructureLocationsForLabellingInspectionDataLoaderLazyQueryHookResult = ReturnType<typeof useGetStructureLocationsForLabellingInspectionDataLoaderLazyQuery>;
export type GetStructureLocationsForLabellingInspectionDataLoaderSuspenseQueryHookResult = ReturnType<typeof useGetStructureLocationsForLabellingInspectionDataLoaderSuspenseQuery>;
export type GetStructureLocationsForLabellingInspectionDataLoaderQueryResult = Apollo.QueryResult<GetStructureLocationsForLabellingInspectionDataLoaderQuery, GetStructureLocationsForLabellingInspectionDataLoaderQueryVariables>;
export const ZonesForStructureForLabellingDocument = gql`
    query zonesForStructureForLabelling($structureId: String) {
  zonesForStructure(structureId: $structureId) {
    id
    name
    box {
      min {
        x
        y
        z
      }
      max {
        x
        y
        z
      }
    }
    structureId
    status
    workflowStatus {
      workflowStageId
      state
      pausedBy
      assignedToUser {
        id
        name
        email
        picture
        roleIds {
          name
          auth0Id
          id
        }
      }
    }
  }
}
    `;

/**
 * __useZonesForStructureForLabellingQuery__
 *
 * To run a query within a React component, call `useZonesForStructureForLabellingQuery` and pass it any options that fit your needs.
 * When your component renders, `useZonesForStructureForLabellingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useZonesForStructureForLabellingQuery({
 *   variables: {
 *      structureId: // value for 'structureId'
 *   },
 * });
 */
export function useZonesForStructureForLabellingQuery(baseOptions?: Apollo.QueryHookOptions<ZonesForStructureForLabellingQuery, ZonesForStructureForLabellingQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ZonesForStructureForLabellingQuery, ZonesForStructureForLabellingQueryVariables>(ZonesForStructureForLabellingDocument, options);
      }
export function useZonesForStructureForLabellingLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ZonesForStructureForLabellingQuery, ZonesForStructureForLabellingQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ZonesForStructureForLabellingQuery, ZonesForStructureForLabellingQueryVariables>(ZonesForStructureForLabellingDocument, options);
        }
// @ts-ignore
export function useZonesForStructureForLabellingSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ZonesForStructureForLabellingQuery, ZonesForStructureForLabellingQueryVariables>): Apollo.UseSuspenseQueryResult<ZonesForStructureForLabellingQuery, ZonesForStructureForLabellingQueryVariables>;
export function useZonesForStructureForLabellingSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ZonesForStructureForLabellingQuery, ZonesForStructureForLabellingQueryVariables>): Apollo.UseSuspenseQueryResult<ZonesForStructureForLabellingQuery | undefined, ZonesForStructureForLabellingQueryVariables>;
export function useZonesForStructureForLabellingSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ZonesForStructureForLabellingQuery, ZonesForStructureForLabellingQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ZonesForStructureForLabellingQuery, ZonesForStructureForLabellingQueryVariables>(ZonesForStructureForLabellingDocument, options);
        }
export type ZonesForStructureForLabellingQueryHookResult = ReturnType<typeof useZonesForStructureForLabellingQuery>;
export type ZonesForStructureForLabellingLazyQueryHookResult = ReturnType<typeof useZonesForStructureForLabellingLazyQuery>;
export type ZonesForStructureForLabellingSuspenseQueryHookResult = ReturnType<typeof useZonesForStructureForLabellingSuspenseQuery>;
export type ZonesForStructureForLabellingQueryResult = Apollo.QueryResult<ZonesForStructureForLabellingQuery, ZonesForStructureForLabellingQueryVariables>;
export const UpdateSupervoxelsDocument = gql`
    mutation UpdateSupervoxels($input: updateSupervoxel) {
  updateSupervoxels(input: $input) {
    id
    structureId
    supervoxel3DReference
    supervoxelClassId
    zoneId
  }
}
    `;
export type UpdateSupervoxelsMutationFn = Apollo.MutationFunction<UpdateSupervoxelsMutation, UpdateSupervoxelsMutationVariables>;

/**
 * __useUpdateSupervoxelsMutation__
 *
 * To run a mutation, you first call `useUpdateSupervoxelsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSupervoxelsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSupervoxelsMutation, { data, loading, error }] = useUpdateSupervoxelsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateSupervoxelsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateSupervoxelsMutation, UpdateSupervoxelsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateSupervoxelsMutation, UpdateSupervoxelsMutationVariables>(UpdateSupervoxelsDocument, options);
      }
export type UpdateSupervoxelsMutationHookResult = ReturnType<typeof useUpdateSupervoxelsMutation>;
export type UpdateSupervoxelsMutationResult = Apollo.MutationResult<UpdateSupervoxelsMutation>;
export type UpdateSupervoxelsMutationOptions = Apollo.BaseMutationOptions<UpdateSupervoxelsMutation, UpdateSupervoxelsMutationVariables>;
export const GetStructureRelationshipsForTaggingInspectionDataLoaderDocument = gql`
    query getStructureRelationshipsForTaggingInspectionDataLoader($structureId: String!) {
  allAnnotations(structureId: $structureId) {
    id
    annotationId
    locationId
    partId
  }
  allParts(structureId: $structureId) {
    id
    assemblyId
    class
    isReviewed
    isHidden
    splitCuboids {
      id
      assemblyId
      position
      scale
      rotation
      color
    }
  }
  allAssemblies(structureId: $structureId) {
    id
    tagName
    originalTagname
    superCategory
    isNewlyAdded
  }
  structure(structureId: $structureId) {
    octreeResourcesPath
    nodesPerAssemblyPath
  }
}
    `;

/**
 * __useGetStructureRelationshipsForTaggingInspectionDataLoaderQuery__
 *
 * To run a query within a React component, call `useGetStructureRelationshipsForTaggingInspectionDataLoaderQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetStructureRelationshipsForTaggingInspectionDataLoaderQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetStructureRelationshipsForTaggingInspectionDataLoaderQuery({
 *   variables: {
 *      structureId: // value for 'structureId'
 *   },
 * });
 */
export function useGetStructureRelationshipsForTaggingInspectionDataLoaderQuery(baseOptions: Apollo.QueryHookOptions<GetStructureRelationshipsForTaggingInspectionDataLoaderQuery, GetStructureRelationshipsForTaggingInspectionDataLoaderQueryVariables> & ({ variables: GetStructureRelationshipsForTaggingInspectionDataLoaderQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetStructureRelationshipsForTaggingInspectionDataLoaderQuery, GetStructureRelationshipsForTaggingInspectionDataLoaderQueryVariables>(GetStructureRelationshipsForTaggingInspectionDataLoaderDocument, options);
      }
export function useGetStructureRelationshipsForTaggingInspectionDataLoaderLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetStructureRelationshipsForTaggingInspectionDataLoaderQuery, GetStructureRelationshipsForTaggingInspectionDataLoaderQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetStructureRelationshipsForTaggingInspectionDataLoaderQuery, GetStructureRelationshipsForTaggingInspectionDataLoaderQueryVariables>(GetStructureRelationshipsForTaggingInspectionDataLoaderDocument, options);
        }
// @ts-ignore
export function useGetStructureRelationshipsForTaggingInspectionDataLoaderSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetStructureRelationshipsForTaggingInspectionDataLoaderQuery, GetStructureRelationshipsForTaggingInspectionDataLoaderQueryVariables>): Apollo.UseSuspenseQueryResult<GetStructureRelationshipsForTaggingInspectionDataLoaderQuery, GetStructureRelationshipsForTaggingInspectionDataLoaderQueryVariables>;
export function useGetStructureRelationshipsForTaggingInspectionDataLoaderSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetStructureRelationshipsForTaggingInspectionDataLoaderQuery, GetStructureRelationshipsForTaggingInspectionDataLoaderQueryVariables>): Apollo.UseSuspenseQueryResult<GetStructureRelationshipsForTaggingInspectionDataLoaderQuery | undefined, GetStructureRelationshipsForTaggingInspectionDataLoaderQueryVariables>;
export function useGetStructureRelationshipsForTaggingInspectionDataLoaderSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetStructureRelationshipsForTaggingInspectionDataLoaderQuery, GetStructureRelationshipsForTaggingInspectionDataLoaderQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetStructureRelationshipsForTaggingInspectionDataLoaderQuery, GetStructureRelationshipsForTaggingInspectionDataLoaderQueryVariables>(GetStructureRelationshipsForTaggingInspectionDataLoaderDocument, options);
        }
export type GetStructureRelationshipsForTaggingInspectionDataLoaderQueryHookResult = ReturnType<typeof useGetStructureRelationshipsForTaggingInspectionDataLoaderQuery>;
export type GetStructureRelationshipsForTaggingInspectionDataLoaderLazyQueryHookResult = ReturnType<typeof useGetStructureRelationshipsForTaggingInspectionDataLoaderLazyQuery>;
export type GetStructureRelationshipsForTaggingInspectionDataLoaderSuspenseQueryHookResult = ReturnType<typeof useGetStructureRelationshipsForTaggingInspectionDataLoaderSuspenseQuery>;
export type GetStructureRelationshipsForTaggingInspectionDataLoaderQueryResult = Apollo.QueryResult<GetStructureRelationshipsForTaggingInspectionDataLoaderQuery, GetStructureRelationshipsForTaggingInspectionDataLoaderQueryVariables>;
export const GetStructureLocationsForTaggingDataLoaderDocument = gql`
    query getStructureLocationsForTaggingDataLoader($structureId: ID!) {
  allLocations(structureId: $structureId) {
    id
    name
    resourcePath
    imageSensor {
      width
      height
      cx
      cy
      focalLength
    }
    paintRegion {
      name
    }
    distance
    videoResourcePath
    videoTimestamp
    pose {
      yaw
      pitch
      roll
      z
      y
      x
      yawOffset
    }
  }
}
    `;

/**
 * __useGetStructureLocationsForTaggingDataLoaderQuery__
 *
 * To run a query within a React component, call `useGetStructureLocationsForTaggingDataLoaderQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetStructureLocationsForTaggingDataLoaderQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetStructureLocationsForTaggingDataLoaderQuery({
 *   variables: {
 *      structureId: // value for 'structureId'
 *   },
 * });
 */
export function useGetStructureLocationsForTaggingDataLoaderQuery(baseOptions: Apollo.QueryHookOptions<GetStructureLocationsForTaggingDataLoaderQuery, GetStructureLocationsForTaggingDataLoaderQueryVariables> & ({ variables: GetStructureLocationsForTaggingDataLoaderQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetStructureLocationsForTaggingDataLoaderQuery, GetStructureLocationsForTaggingDataLoaderQueryVariables>(GetStructureLocationsForTaggingDataLoaderDocument, options);
      }
export function useGetStructureLocationsForTaggingDataLoaderLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetStructureLocationsForTaggingDataLoaderQuery, GetStructureLocationsForTaggingDataLoaderQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetStructureLocationsForTaggingDataLoaderQuery, GetStructureLocationsForTaggingDataLoaderQueryVariables>(GetStructureLocationsForTaggingDataLoaderDocument, options);
        }
// @ts-ignore
export function useGetStructureLocationsForTaggingDataLoaderSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetStructureLocationsForTaggingDataLoaderQuery, GetStructureLocationsForTaggingDataLoaderQueryVariables>): Apollo.UseSuspenseQueryResult<GetStructureLocationsForTaggingDataLoaderQuery, GetStructureLocationsForTaggingDataLoaderQueryVariables>;
export function useGetStructureLocationsForTaggingDataLoaderSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetStructureLocationsForTaggingDataLoaderQuery, GetStructureLocationsForTaggingDataLoaderQueryVariables>): Apollo.UseSuspenseQueryResult<GetStructureLocationsForTaggingDataLoaderQuery | undefined, GetStructureLocationsForTaggingDataLoaderQueryVariables>;
export function useGetStructureLocationsForTaggingDataLoaderSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetStructureLocationsForTaggingDataLoaderQuery, GetStructureLocationsForTaggingDataLoaderQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetStructureLocationsForTaggingDataLoaderQuery, GetStructureLocationsForTaggingDataLoaderQueryVariables>(GetStructureLocationsForTaggingDataLoaderDocument, options);
        }
export type GetStructureLocationsForTaggingDataLoaderQueryHookResult = ReturnType<typeof useGetStructureLocationsForTaggingDataLoaderQuery>;
export type GetStructureLocationsForTaggingDataLoaderLazyQueryHookResult = ReturnType<typeof useGetStructureLocationsForTaggingDataLoaderLazyQuery>;
export type GetStructureLocationsForTaggingDataLoaderSuspenseQueryHookResult = ReturnType<typeof useGetStructureLocationsForTaggingDataLoaderSuspenseQuery>;
export type GetStructureLocationsForTaggingDataLoaderQueryResult = Apollo.QueryResult<GetStructureLocationsForTaggingDataLoaderQuery, GetStructureLocationsForTaggingDataLoaderQueryVariables>;
export const PartsAddedToAssemblyDocument = gql`
    subscription PartsAddedToAssembly($structureId: String!, $userId: String!) {
  partsAddedToAssembly(structureId: $structureId, userId: $userId) {
    partId
    assemblyId
    assemblyName
    isReviewed
    zoneId
    userId
  }
}
    `;

/**
 * __usePartsAddedToAssemblySubscription__
 *
 * To run a query within a React component, call `usePartsAddedToAssemblySubscription` and pass it any options that fit your needs.
 * When your component renders, `usePartsAddedToAssemblySubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePartsAddedToAssemblySubscription({
 *   variables: {
 *      structureId: // value for 'structureId'
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function usePartsAddedToAssemblySubscription(baseOptions: Apollo.SubscriptionHookOptions<PartsAddedToAssemblySubscription, PartsAddedToAssemblySubscriptionVariables> & ({ variables: PartsAddedToAssemblySubscriptionVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<PartsAddedToAssemblySubscription, PartsAddedToAssemblySubscriptionVariables>(PartsAddedToAssemblyDocument, options);
      }
export type PartsAddedToAssemblySubscriptionHookResult = ReturnType<typeof usePartsAddedToAssemblySubscription>;
export type PartsAddedToAssemblySubscriptionResult = Apollo.SubscriptionResult<PartsAddedToAssemblySubscription>;
export const PartsHiddenFlagUpdatedDocument = gql`
    subscription partsHiddenFlagUpdated($structureId: String!, $userId: String!) {
  partsHiddenFlagUpdated(structureId: $structureId, userId: $userId) {
    id
    isHidden
    isReviewed
    zoneId
    userId
  }
}
    `;

/**
 * __usePartsHiddenFlagUpdatedSubscription__
 *
 * To run a query within a React component, call `usePartsHiddenFlagUpdatedSubscription` and pass it any options that fit your needs.
 * When your component renders, `usePartsHiddenFlagUpdatedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePartsHiddenFlagUpdatedSubscription({
 *   variables: {
 *      structureId: // value for 'structureId'
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function usePartsHiddenFlagUpdatedSubscription(baseOptions: Apollo.SubscriptionHookOptions<PartsHiddenFlagUpdatedSubscription, PartsHiddenFlagUpdatedSubscriptionVariables> & ({ variables: PartsHiddenFlagUpdatedSubscriptionVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<PartsHiddenFlagUpdatedSubscription, PartsHiddenFlagUpdatedSubscriptionVariables>(PartsHiddenFlagUpdatedDocument, options);
      }
export type PartsHiddenFlagUpdatedSubscriptionHookResult = ReturnType<typeof usePartsHiddenFlagUpdatedSubscription>;
export type PartsHiddenFlagUpdatedSubscriptionResult = Apollo.SubscriptionResult<PartsHiddenFlagUpdatedSubscription>;
export const PartsReviewedFlagUpdatedDocument = gql`
    subscription partsReviewedFlagUpdated($structureId: String!, $userId: String!) {
  partsReviewedFlagUpdated(structureId: $structureId, userId: $userId) {
    id
    isReviewed
    assemblyName
    zoneId
    userId
  }
}
    `;

/**
 * __usePartsReviewedFlagUpdatedSubscription__
 *
 * To run a query within a React component, call `usePartsReviewedFlagUpdatedSubscription` and pass it any options that fit your needs.
 * When your component renders, `usePartsReviewedFlagUpdatedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePartsReviewedFlagUpdatedSubscription({
 *   variables: {
 *      structureId: // value for 'structureId'
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function usePartsReviewedFlagUpdatedSubscription(baseOptions: Apollo.SubscriptionHookOptions<PartsReviewedFlagUpdatedSubscription, PartsReviewedFlagUpdatedSubscriptionVariables> & ({ variables: PartsReviewedFlagUpdatedSubscriptionVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<PartsReviewedFlagUpdatedSubscription, PartsReviewedFlagUpdatedSubscriptionVariables>(PartsReviewedFlagUpdatedDocument, options);
      }
export type PartsReviewedFlagUpdatedSubscriptionHookResult = ReturnType<typeof usePartsReviewedFlagUpdatedSubscription>;
export type PartsReviewedFlagUpdatedSubscriptionResult = Apollo.SubscriptionResult<PartsReviewedFlagUpdatedSubscription>;
export const PartSplitDocument = gql`
    subscription partSplit($structureId: String!, $userId: String!) {
  partSplit(structureId: $structureId, userId: $userId) {
    originalPartId
    newPartId
    updatedAnnotationIds
    zoneId
  }
}
    `;

/**
 * __usePartSplitSubscription__
 *
 * To run a query within a React component, call `usePartSplitSubscription` and pass it any options that fit your needs.
 * When your component renders, `usePartSplitSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePartSplitSubscription({
 *   variables: {
 *      structureId: // value for 'structureId'
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function usePartSplitSubscription(baseOptions: Apollo.SubscriptionHookOptions<PartSplitSubscription, PartSplitSubscriptionVariables> & ({ variables: PartSplitSubscriptionVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<PartSplitSubscription, PartSplitSubscriptionVariables>(PartSplitDocument, options);
      }
export type PartSplitSubscriptionHookResult = ReturnType<typeof usePartSplitSubscription>;
export type PartSplitSubscriptionResult = Apollo.SubscriptionResult<PartSplitSubscription>;
export const AssemblyTagNameAddedDocument = gql`
    subscription AssemblyTagNameAdded($structureId: String) {
  assemblyTagNameAdded(structureId: $structureId) {
    id
    structureId
    tagName
    isNewlyAdded
  }
}
    `;

/**
 * __useAssemblyTagNameAddedSubscription__
 *
 * To run a query within a React component, call `useAssemblyTagNameAddedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useAssemblyTagNameAddedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAssemblyTagNameAddedSubscription({
 *   variables: {
 *      structureId: // value for 'structureId'
 *   },
 * });
 */
export function useAssemblyTagNameAddedSubscription(baseOptions?: Apollo.SubscriptionHookOptions<AssemblyTagNameAddedSubscription, AssemblyTagNameAddedSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<AssemblyTagNameAddedSubscription, AssemblyTagNameAddedSubscriptionVariables>(AssemblyTagNameAddedDocument, options);
      }
export type AssemblyTagNameAddedSubscriptionHookResult = ReturnType<typeof useAssemblyTagNameAddedSubscription>;
export type AssemblyTagNameAddedSubscriptionResult = Apollo.SubscriptionResult<AssemblyTagNameAddedSubscription>;
export const SplitCuboidOnPartUpdatedDocument = gql`
    subscription SplitCuboidOnPartUpdated($structureId: String, $userId: String!) {
  splitCuboidOnPartUpdated(structureId: $structureId, userId: $userId) {
    partId
    splitCuboid {
      id
      assemblyId
      position
      scale
      rotation
      color
    }
    structureId
    zoneId
  }
}
    `;

/**
 * __useSplitCuboidOnPartUpdatedSubscription__
 *
 * To run a query within a React component, call `useSplitCuboidOnPartUpdatedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useSplitCuboidOnPartUpdatedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSplitCuboidOnPartUpdatedSubscription({
 *   variables: {
 *      structureId: // value for 'structureId'
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useSplitCuboidOnPartUpdatedSubscription(baseOptions: Apollo.SubscriptionHookOptions<SplitCuboidOnPartUpdatedSubscription, SplitCuboidOnPartUpdatedSubscriptionVariables> & ({ variables: SplitCuboidOnPartUpdatedSubscriptionVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<SplitCuboidOnPartUpdatedSubscription, SplitCuboidOnPartUpdatedSubscriptionVariables>(SplitCuboidOnPartUpdatedDocument, options);
      }
export type SplitCuboidOnPartUpdatedSubscriptionHookResult = ReturnType<typeof useSplitCuboidOnPartUpdatedSubscription>;
export type SplitCuboidOnPartUpdatedSubscriptionResult = Apollo.SubscriptionResult<SplitCuboidOnPartUpdatedSubscription>;
export const SplitCuboidOnPartRemovedDocument = gql`
    subscription SplitCuboidOnPartRemoved($structureId: String, $userId: String!) {
  splitCuboidOnPartRemoved(structureId: $structureId, userId: $userId) {
    partId
    splitCuboidId
    structureId
    zoneId
  }
}
    `;

/**
 * __useSplitCuboidOnPartRemovedSubscription__
 *
 * To run a query within a React component, call `useSplitCuboidOnPartRemovedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useSplitCuboidOnPartRemovedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSplitCuboidOnPartRemovedSubscription({
 *   variables: {
 *      structureId: // value for 'structureId'
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useSplitCuboidOnPartRemovedSubscription(baseOptions: Apollo.SubscriptionHookOptions<SplitCuboidOnPartRemovedSubscription, SplitCuboidOnPartRemovedSubscriptionVariables> & ({ variables: SplitCuboidOnPartRemovedSubscriptionVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<SplitCuboidOnPartRemovedSubscription, SplitCuboidOnPartRemovedSubscriptionVariables>(SplitCuboidOnPartRemovedDocument, options);
      }
export type SplitCuboidOnPartRemovedSubscriptionHookResult = ReturnType<typeof useSplitCuboidOnPartRemovedSubscription>;
export type SplitCuboidOnPartRemovedSubscriptionResult = Apollo.SubscriptionResult<SplitCuboidOnPartRemovedSubscription>;
export const BulkLineFixingDocument = gql`
    mutation BulkLineFixing($input: BulkLineFixingInput!) {
  bulkLineFixing(input: $input) {
    message
    updatedCount
  }
}
    `;
export type BulkLineFixingMutationFn = Apollo.MutationFunction<BulkLineFixingMutation, BulkLineFixingMutationVariables>;

/**
 * __useBulkLineFixingMutation__
 *
 * To run a mutation, you first call `useBulkLineFixingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBulkLineFixingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [bulkLineFixingMutation, { data, loading, error }] = useBulkLineFixingMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useBulkLineFixingMutation(baseOptions?: Apollo.MutationHookOptions<BulkLineFixingMutation, BulkLineFixingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<BulkLineFixingMutation, BulkLineFixingMutationVariables>(BulkLineFixingDocument, options);
      }
export type BulkLineFixingMutationHookResult = ReturnType<typeof useBulkLineFixingMutation>;
export type BulkLineFixingMutationResult = Apollo.MutationResult<BulkLineFixingMutation>;
export type BulkLineFixingMutationOptions = Apollo.BaseMutationOptions<BulkLineFixingMutation, BulkLineFixingMutationVariables>;
export const RevertBulkLineFixingDocument = gql`
    mutation RevertBulkLineFixing($input: RevertBulkLineFixingInput!) {
  revertBulkLineFixing(input: $input) {
    message
    updatedCount
  }
}
    `;
export type RevertBulkLineFixingMutationFn = Apollo.MutationFunction<RevertBulkLineFixingMutation, RevertBulkLineFixingMutationVariables>;

/**
 * __useRevertBulkLineFixingMutation__
 *
 * To run a mutation, you first call `useRevertBulkLineFixingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRevertBulkLineFixingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [revertBulkLineFixingMutation, { data, loading, error }] = useRevertBulkLineFixingMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRevertBulkLineFixingMutation(baseOptions?: Apollo.MutationHookOptions<RevertBulkLineFixingMutation, RevertBulkLineFixingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RevertBulkLineFixingMutation, RevertBulkLineFixingMutationVariables>(RevertBulkLineFixingDocument, options);
      }
export type RevertBulkLineFixingMutationHookResult = ReturnType<typeof useRevertBulkLineFixingMutation>;
export type RevertBulkLineFixingMutationResult = Apollo.MutationResult<RevertBulkLineFixingMutation>;
export type RevertBulkLineFixingMutationOptions = Apollo.BaseMutationOptions<RevertBulkLineFixingMutation, RevertBulkLineFixingMutationVariables>;
export const AllPartsDocument = gql`
    query AllParts($structureId: String!) {
  allParts(structureId: $structureId) {
    id
    assembly {
      id
      tagName
    }
  }
  structure(structureId: $structureId) {
    name
  }
}
    `;

/**
 * __useAllPartsQuery__
 *
 * To run a query within a React component, call `useAllPartsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllPartsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllPartsQuery({
 *   variables: {
 *      structureId: // value for 'structureId'
 *   },
 * });
 */
export function useAllPartsQuery(baseOptions: Apollo.QueryHookOptions<AllPartsQuery, AllPartsQueryVariables> & ({ variables: AllPartsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AllPartsQuery, AllPartsQueryVariables>(AllPartsDocument, options);
      }
export function useAllPartsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AllPartsQuery, AllPartsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AllPartsQuery, AllPartsQueryVariables>(AllPartsDocument, options);
        }
// @ts-ignore
export function useAllPartsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<AllPartsQuery, AllPartsQueryVariables>): Apollo.UseSuspenseQueryResult<AllPartsQuery, AllPartsQueryVariables>;
export function useAllPartsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AllPartsQuery, AllPartsQueryVariables>): Apollo.UseSuspenseQueryResult<AllPartsQuery | undefined, AllPartsQueryVariables>;
export function useAllPartsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AllPartsQuery, AllPartsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AllPartsQuery, AllPartsQueryVariables>(AllPartsDocument, options);
        }
export type AllPartsQueryHookResult = ReturnType<typeof useAllPartsQuery>;
export type AllPartsLazyQueryHookResult = ReturnType<typeof useAllPartsLazyQuery>;
export type AllPartsSuspenseQueryHookResult = ReturnType<typeof useAllPartsSuspenseQuery>;
export type AllPartsQueryResult = Apollo.QueryResult<AllPartsQuery, AllPartsQueryVariables>;
export const GetAbyssViewerColoursForTaggingDocument = gql`
    query getAbyssViewerColoursForTagging {
  setting(type: COLOUR_MAP_FOR_ABYSS_VIEWER_PARTS) {
    id
    name
    type
    revision
    meta {
      __typename
      ... on StringMeta {
        key
        colour: value
      }
      ... on StringArrayMeta {
        key
        value
      }
    }
  }
}
    `;

/**
 * __useGetAbyssViewerColoursForTaggingQuery__
 *
 * To run a query within a React component, call `useGetAbyssViewerColoursForTaggingQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAbyssViewerColoursForTaggingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAbyssViewerColoursForTaggingQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAbyssViewerColoursForTaggingQuery(baseOptions?: Apollo.QueryHookOptions<GetAbyssViewerColoursForTaggingQuery, GetAbyssViewerColoursForTaggingQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAbyssViewerColoursForTaggingQuery, GetAbyssViewerColoursForTaggingQueryVariables>(GetAbyssViewerColoursForTaggingDocument, options);
      }
export function useGetAbyssViewerColoursForTaggingLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAbyssViewerColoursForTaggingQuery, GetAbyssViewerColoursForTaggingQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAbyssViewerColoursForTaggingQuery, GetAbyssViewerColoursForTaggingQueryVariables>(GetAbyssViewerColoursForTaggingDocument, options);
        }
// @ts-ignore
export function useGetAbyssViewerColoursForTaggingSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetAbyssViewerColoursForTaggingQuery, GetAbyssViewerColoursForTaggingQueryVariables>): Apollo.UseSuspenseQueryResult<GetAbyssViewerColoursForTaggingQuery, GetAbyssViewerColoursForTaggingQueryVariables>;
export function useGetAbyssViewerColoursForTaggingSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAbyssViewerColoursForTaggingQuery, GetAbyssViewerColoursForTaggingQueryVariables>): Apollo.UseSuspenseQueryResult<GetAbyssViewerColoursForTaggingQuery | undefined, GetAbyssViewerColoursForTaggingQueryVariables>;
export function useGetAbyssViewerColoursForTaggingSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAbyssViewerColoursForTaggingQuery, GetAbyssViewerColoursForTaggingQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAbyssViewerColoursForTaggingQuery, GetAbyssViewerColoursForTaggingQueryVariables>(GetAbyssViewerColoursForTaggingDocument, options);
        }
export type GetAbyssViewerColoursForTaggingQueryHookResult = ReturnType<typeof useGetAbyssViewerColoursForTaggingQuery>;
export type GetAbyssViewerColoursForTaggingLazyQueryHookResult = ReturnType<typeof useGetAbyssViewerColoursForTaggingLazyQuery>;
export type GetAbyssViewerColoursForTaggingSuspenseQueryHookResult = ReturnType<typeof useGetAbyssViewerColoursForTaggingSuspenseQuery>;
export type GetAbyssViewerColoursForTaggingQueryResult = Apollo.QueryResult<GetAbyssViewerColoursForTaggingQuery, GetAbyssViewerColoursForTaggingQueryVariables>;
export const AddUpdateSplitCuboidOnPartDocument = gql`
    mutation AddUpdateSplitCuboidOnPart($input: AddUpdateSplitCuboidOnPartInput) {
  addUpdateSplitCuboidOnPart(input: $input) {
    partId
    splitCuboid {
      id
      assemblyId
      position
      scale
      rotation
      color
    }
  }
}
    `;
export type AddUpdateSplitCuboidOnPartMutationFn = Apollo.MutationFunction<AddUpdateSplitCuboidOnPartMutation, AddUpdateSplitCuboidOnPartMutationVariables>;

/**
 * __useAddUpdateSplitCuboidOnPartMutation__
 *
 * To run a mutation, you first call `useAddUpdateSplitCuboidOnPartMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddUpdateSplitCuboidOnPartMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addUpdateSplitCuboidOnPartMutation, { data, loading, error }] = useAddUpdateSplitCuboidOnPartMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddUpdateSplitCuboidOnPartMutation(baseOptions?: Apollo.MutationHookOptions<AddUpdateSplitCuboidOnPartMutation, AddUpdateSplitCuboidOnPartMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddUpdateSplitCuboidOnPartMutation, AddUpdateSplitCuboidOnPartMutationVariables>(AddUpdateSplitCuboidOnPartDocument, options);
      }
export type AddUpdateSplitCuboidOnPartMutationHookResult = ReturnType<typeof useAddUpdateSplitCuboidOnPartMutation>;
export type AddUpdateSplitCuboidOnPartMutationResult = Apollo.MutationResult<AddUpdateSplitCuboidOnPartMutation>;
export type AddUpdateSplitCuboidOnPartMutationOptions = Apollo.BaseMutationOptions<AddUpdateSplitCuboidOnPartMutation, AddUpdateSplitCuboidOnPartMutationVariables>;
export const RemoveSplitCuboidOnPartDocument = gql`
    mutation RemoveSplitCuboidOnPart($input: RemoveSplitCuboidOnPartInput) {
  removeSplitCuboidOnPart(input: $input) {
    partId
    splitCuboidId
  }
}
    `;
export type RemoveSplitCuboidOnPartMutationFn = Apollo.MutationFunction<RemoveSplitCuboidOnPartMutation, RemoveSplitCuboidOnPartMutationVariables>;

/**
 * __useRemoveSplitCuboidOnPartMutation__
 *
 * To run a mutation, you first call `useRemoveSplitCuboidOnPartMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveSplitCuboidOnPartMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeSplitCuboidOnPartMutation, { data, loading, error }] = useRemoveSplitCuboidOnPartMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRemoveSplitCuboidOnPartMutation(baseOptions?: Apollo.MutationHookOptions<RemoveSplitCuboidOnPartMutation, RemoveSplitCuboidOnPartMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveSplitCuboidOnPartMutation, RemoveSplitCuboidOnPartMutationVariables>(RemoveSplitCuboidOnPartDocument, options);
      }
export type RemoveSplitCuboidOnPartMutationHookResult = ReturnType<typeof useRemoveSplitCuboidOnPartMutation>;
export type RemoveSplitCuboidOnPartMutationResult = Apollo.MutationResult<RemoveSplitCuboidOnPartMutation>;
export type RemoveSplitCuboidOnPartMutationOptions = Apollo.BaseMutationOptions<RemoveSplitCuboidOnPartMutation, RemoveSplitCuboidOnPartMutationVariables>;
export const SplitAnnotationFromPartDocument = gql`
    mutation SplitAnnotationFromPart($input: SplitPartInput) {
  splitPart(input: $input) {
    id
    updatedBy
    assemblyId
  }
}
    `;
export type SplitAnnotationFromPartMutationFn = Apollo.MutationFunction<SplitAnnotationFromPartMutation, SplitAnnotationFromPartMutationVariables>;

/**
 * __useSplitAnnotationFromPartMutation__
 *
 * To run a mutation, you first call `useSplitAnnotationFromPartMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSplitAnnotationFromPartMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [splitAnnotationFromPartMutation, { data, loading, error }] = useSplitAnnotationFromPartMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSplitAnnotationFromPartMutation(baseOptions?: Apollo.MutationHookOptions<SplitAnnotationFromPartMutation, SplitAnnotationFromPartMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SplitAnnotationFromPartMutation, SplitAnnotationFromPartMutationVariables>(SplitAnnotationFromPartDocument, options);
      }
export type SplitAnnotationFromPartMutationHookResult = ReturnType<typeof useSplitAnnotationFromPartMutation>;
export type SplitAnnotationFromPartMutationResult = Apollo.MutationResult<SplitAnnotationFromPartMutation>;
export type SplitAnnotationFromPartMutationOptions = Apollo.BaseMutationOptions<SplitAnnotationFromPartMutation, SplitAnnotationFromPartMutationVariables>;
export const GetLocalAnnotationIdDocument = gql`
    query getLocalAnnotationId($annotationId: String!) {
  annotation(annotationId: $annotationId) {
    processingReferences {
      localAnnotationId
    }
  }
}
    `;

/**
 * __useGetLocalAnnotationIdQuery__
 *
 * To run a query within a React component, call `useGetLocalAnnotationIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLocalAnnotationIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLocalAnnotationIdQuery({
 *   variables: {
 *      annotationId: // value for 'annotationId'
 *   },
 * });
 */
export function useGetLocalAnnotationIdQuery(baseOptions: Apollo.QueryHookOptions<GetLocalAnnotationIdQuery, GetLocalAnnotationIdQueryVariables> & ({ variables: GetLocalAnnotationIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLocalAnnotationIdQuery, GetLocalAnnotationIdQueryVariables>(GetLocalAnnotationIdDocument, options);
      }
export function useGetLocalAnnotationIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetLocalAnnotationIdQuery, GetLocalAnnotationIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLocalAnnotationIdQuery, GetLocalAnnotationIdQueryVariables>(GetLocalAnnotationIdDocument, options);
        }
// @ts-ignore
export function useGetLocalAnnotationIdSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetLocalAnnotationIdQuery, GetLocalAnnotationIdQueryVariables>): Apollo.UseSuspenseQueryResult<GetLocalAnnotationIdQuery, GetLocalAnnotationIdQueryVariables>;
export function useGetLocalAnnotationIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetLocalAnnotationIdQuery, GetLocalAnnotationIdQueryVariables>): Apollo.UseSuspenseQueryResult<GetLocalAnnotationIdQuery | undefined, GetLocalAnnotationIdQueryVariables>;
export function useGetLocalAnnotationIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetLocalAnnotationIdQuery, GetLocalAnnotationIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetLocalAnnotationIdQuery, GetLocalAnnotationIdQueryVariables>(GetLocalAnnotationIdDocument, options);
        }
export type GetLocalAnnotationIdQueryHookResult = ReturnType<typeof useGetLocalAnnotationIdQuery>;
export type GetLocalAnnotationIdLazyQueryHookResult = ReturnType<typeof useGetLocalAnnotationIdLazyQuery>;
export type GetLocalAnnotationIdSuspenseQueryHookResult = ReturnType<typeof useGetLocalAnnotationIdSuspenseQuery>;
export type GetLocalAnnotationIdQueryResult = Apollo.QueryResult<GetLocalAnnotationIdQuery, GetLocalAnnotationIdQueryVariables>;
export const ZonesForStructureForTaggingDocument = gql`
    query zonesForStructureForTagging($structureId: String) {
  zonesForStructure(structureId: $structureId) {
    id
    name
    box {
      min {
        x
        y
        z
      }
      max {
        x
        y
        z
      }
    }
    status
    structureId
  }
}
    `;

/**
 * __useZonesForStructureForTaggingQuery__
 *
 * To run a query within a React component, call `useZonesForStructureForTaggingQuery` and pass it any options that fit your needs.
 * When your component renders, `useZonesForStructureForTaggingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useZonesForStructureForTaggingQuery({
 *   variables: {
 *      structureId: // value for 'structureId'
 *   },
 * });
 */
export function useZonesForStructureForTaggingQuery(baseOptions?: Apollo.QueryHookOptions<ZonesForStructureForTaggingQuery, ZonesForStructureForTaggingQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ZonesForStructureForTaggingQuery, ZonesForStructureForTaggingQueryVariables>(ZonesForStructureForTaggingDocument, options);
      }
export function useZonesForStructureForTaggingLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ZonesForStructureForTaggingQuery, ZonesForStructureForTaggingQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ZonesForStructureForTaggingQuery, ZonesForStructureForTaggingQueryVariables>(ZonesForStructureForTaggingDocument, options);
        }
// @ts-ignore
export function useZonesForStructureForTaggingSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ZonesForStructureForTaggingQuery, ZonesForStructureForTaggingQueryVariables>): Apollo.UseSuspenseQueryResult<ZonesForStructureForTaggingQuery, ZonesForStructureForTaggingQueryVariables>;
export function useZonesForStructureForTaggingSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ZonesForStructureForTaggingQuery, ZonesForStructureForTaggingQueryVariables>): Apollo.UseSuspenseQueryResult<ZonesForStructureForTaggingQuery | undefined, ZonesForStructureForTaggingQueryVariables>;
export function useZonesForStructureForTaggingSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ZonesForStructureForTaggingQuery, ZonesForStructureForTaggingQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ZonesForStructureForTaggingQuery, ZonesForStructureForTaggingQueryVariables>(ZonesForStructureForTaggingDocument, options);
        }
export type ZonesForStructureForTaggingQueryHookResult = ReturnType<typeof useZonesForStructureForTaggingQuery>;
export type ZonesForStructureForTaggingLazyQueryHookResult = ReturnType<typeof useZonesForStructureForTaggingLazyQuery>;
export type ZonesForStructureForTaggingSuspenseQueryHookResult = ReturnType<typeof useZonesForStructureForTaggingSuspenseQuery>;
export type ZonesForStructureForTaggingQueryResult = Apollo.QueryResult<ZonesForStructureForTaggingQuery, ZonesForStructureForTaggingQueryVariables>;
export const ZoneAndHistoriesForDocument = gql`
    query zoneAndHistoriesFor($structureId: String) {
  zonesAndHistoriesFor(structureId: $structureId) {
    _id
    histories {
      id
      createdBy
      eventName
      document
      createdByDetails {
        name
        profilePicture
      }
    }
  }
}
    `;

/**
 * __useZoneAndHistoriesForQuery__
 *
 * To run a query within a React component, call `useZoneAndHistoriesForQuery` and pass it any options that fit your needs.
 * When your component renders, `useZoneAndHistoriesForQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useZoneAndHistoriesForQuery({
 *   variables: {
 *      structureId: // value for 'structureId'
 *   },
 * });
 */
export function useZoneAndHistoriesForQuery(baseOptions?: Apollo.QueryHookOptions<ZoneAndHistoriesForQuery, ZoneAndHistoriesForQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ZoneAndHistoriesForQuery, ZoneAndHistoriesForQueryVariables>(ZoneAndHistoriesForDocument, options);
      }
export function useZoneAndHistoriesForLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ZoneAndHistoriesForQuery, ZoneAndHistoriesForQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ZoneAndHistoriesForQuery, ZoneAndHistoriesForQueryVariables>(ZoneAndHistoriesForDocument, options);
        }
// @ts-ignore
export function useZoneAndHistoriesForSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ZoneAndHistoriesForQuery, ZoneAndHistoriesForQueryVariables>): Apollo.UseSuspenseQueryResult<ZoneAndHistoriesForQuery, ZoneAndHistoriesForQueryVariables>;
export function useZoneAndHistoriesForSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ZoneAndHistoriesForQuery, ZoneAndHistoriesForQueryVariables>): Apollo.UseSuspenseQueryResult<ZoneAndHistoriesForQuery | undefined, ZoneAndHistoriesForQueryVariables>;
export function useZoneAndHistoriesForSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ZoneAndHistoriesForQuery, ZoneAndHistoriesForQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ZoneAndHistoriesForQuery, ZoneAndHistoriesForQueryVariables>(ZoneAndHistoriesForDocument, options);
        }
export type ZoneAndHistoriesForQueryHookResult = ReturnType<typeof useZoneAndHistoriesForQuery>;
export type ZoneAndHistoriesForLazyQueryHookResult = ReturnType<typeof useZoneAndHistoriesForLazyQuery>;
export type ZoneAndHistoriesForSuspenseQueryHookResult = ReturnType<typeof useZoneAndHistoriesForSuspenseQuery>;
export type ZoneAndHistoriesForQueryResult = Apollo.QueryResult<ZoneAndHistoriesForQuery, ZoneAndHistoriesForQueryVariables>;
export const GetGroupsByPartIdsDocument = gql`
    query getGroupsByPartIds($input: GroupsByPartIdsInput) {
  groupsByPartIds(input: $input) {
    groupedParts
  }
}
    `;

/**
 * __useGetGroupsByPartIdsQuery__
 *
 * To run a query within a React component, call `useGetGroupsByPartIdsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetGroupsByPartIdsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetGroupsByPartIdsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetGroupsByPartIdsQuery(baseOptions?: Apollo.QueryHookOptions<GetGroupsByPartIdsQuery, GetGroupsByPartIdsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetGroupsByPartIdsQuery, GetGroupsByPartIdsQueryVariables>(GetGroupsByPartIdsDocument, options);
      }
export function useGetGroupsByPartIdsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetGroupsByPartIdsQuery, GetGroupsByPartIdsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetGroupsByPartIdsQuery, GetGroupsByPartIdsQueryVariables>(GetGroupsByPartIdsDocument, options);
        }
// @ts-ignore
export function useGetGroupsByPartIdsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetGroupsByPartIdsQuery, GetGroupsByPartIdsQueryVariables>): Apollo.UseSuspenseQueryResult<GetGroupsByPartIdsQuery, GetGroupsByPartIdsQueryVariables>;
export function useGetGroupsByPartIdsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetGroupsByPartIdsQuery, GetGroupsByPartIdsQueryVariables>): Apollo.UseSuspenseQueryResult<GetGroupsByPartIdsQuery | undefined, GetGroupsByPartIdsQueryVariables>;
export function useGetGroupsByPartIdsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetGroupsByPartIdsQuery, GetGroupsByPartIdsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetGroupsByPartIdsQuery, GetGroupsByPartIdsQueryVariables>(GetGroupsByPartIdsDocument, options);
        }
export type GetGroupsByPartIdsQueryHookResult = ReturnType<typeof useGetGroupsByPartIdsQuery>;
export type GetGroupsByPartIdsLazyQueryHookResult = ReturnType<typeof useGetGroupsByPartIdsLazyQuery>;
export type GetGroupsByPartIdsSuspenseQueryHookResult = ReturnType<typeof useGetGroupsByPartIdsSuspenseQuery>;
export type GetGroupsByPartIdsQueryResult = Apollo.QueryResult<GetGroupsByPartIdsQuery, GetGroupsByPartIdsQueryVariables>;
export const SetHiddenFlagForPartsDocument = gql`
    mutation SetHiddenFlagForParts($parts: UpdatePartsHiddenFlagInput) {
  setHiddenForParts(input: $parts)
}
    `;
export type SetHiddenFlagForPartsMutationFn = Apollo.MutationFunction<SetHiddenFlagForPartsMutation, SetHiddenFlagForPartsMutationVariables>;

/**
 * __useSetHiddenFlagForPartsMutation__
 *
 * To run a mutation, you first call `useSetHiddenFlagForPartsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetHiddenFlagForPartsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setHiddenFlagForPartsMutation, { data, loading, error }] = useSetHiddenFlagForPartsMutation({
 *   variables: {
 *      parts: // value for 'parts'
 *   },
 * });
 */
export function useSetHiddenFlagForPartsMutation(baseOptions?: Apollo.MutationHookOptions<SetHiddenFlagForPartsMutation, SetHiddenFlagForPartsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetHiddenFlagForPartsMutation, SetHiddenFlagForPartsMutationVariables>(SetHiddenFlagForPartsDocument, options);
      }
export type SetHiddenFlagForPartsMutationHookResult = ReturnType<typeof useSetHiddenFlagForPartsMutation>;
export type SetHiddenFlagForPartsMutationResult = Apollo.MutationResult<SetHiddenFlagForPartsMutation>;
export type SetHiddenFlagForPartsMutationOptions = Apollo.BaseMutationOptions<SetHiddenFlagForPartsMutation, SetHiddenFlagForPartsMutationVariables>;
export const SetReviewedFlagForPartsDocument = gql`
    mutation SetReviewedFlagForParts($parts: UpdatePartsReviewedFlagInput) {
  setReviewedForParts(input: $parts)
}
    `;
export type SetReviewedFlagForPartsMutationFn = Apollo.MutationFunction<SetReviewedFlagForPartsMutation, SetReviewedFlagForPartsMutationVariables>;

/**
 * __useSetReviewedFlagForPartsMutation__
 *
 * To run a mutation, you first call `useSetReviewedFlagForPartsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetReviewedFlagForPartsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setReviewedFlagForPartsMutation, { data, loading, error }] = useSetReviewedFlagForPartsMutation({
 *   variables: {
 *      parts: // value for 'parts'
 *   },
 * });
 */
export function useSetReviewedFlagForPartsMutation(baseOptions?: Apollo.MutationHookOptions<SetReviewedFlagForPartsMutation, SetReviewedFlagForPartsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetReviewedFlagForPartsMutation, SetReviewedFlagForPartsMutationVariables>(SetReviewedFlagForPartsDocument, options);
      }
export type SetReviewedFlagForPartsMutationHookResult = ReturnType<typeof useSetReviewedFlagForPartsMutation>;
export type SetReviewedFlagForPartsMutationResult = Apollo.MutationResult<SetReviewedFlagForPartsMutation>;
export type SetReviewedFlagForPartsMutationOptions = Apollo.BaseMutationOptions<SetReviewedFlagForPartsMutation, SetReviewedFlagForPartsMutationVariables>;
export const AddPartsToAssemblyInputForDeletePartDocument = gql`
    mutation AddPartsToAssemblyInputForDeletePart($input: AddPartsToAssemblyInput) {
  addPartsToAssembly(input: $input) {
    id
    class
    updatedBy
    updatedAt
    createdAt
    assembly {
      id
      tagName
    }
  }
}
    `;
export type AddPartsToAssemblyInputForDeletePartMutationFn = Apollo.MutationFunction<AddPartsToAssemblyInputForDeletePartMutation, AddPartsToAssemblyInputForDeletePartMutationVariables>;

/**
 * __useAddPartsToAssemblyInputForDeletePartMutation__
 *
 * To run a mutation, you first call `useAddPartsToAssemblyInputForDeletePartMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddPartsToAssemblyInputForDeletePartMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addPartsToAssemblyInputForDeletePartMutation, { data, loading, error }] = useAddPartsToAssemblyInputForDeletePartMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddPartsToAssemblyInputForDeletePartMutation(baseOptions?: Apollo.MutationHookOptions<AddPartsToAssemblyInputForDeletePartMutation, AddPartsToAssemblyInputForDeletePartMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddPartsToAssemblyInputForDeletePartMutation, AddPartsToAssemblyInputForDeletePartMutationVariables>(AddPartsToAssemblyInputForDeletePartDocument, options);
      }
export type AddPartsToAssemblyInputForDeletePartMutationHookResult = ReturnType<typeof useAddPartsToAssemblyInputForDeletePartMutation>;
export type AddPartsToAssemblyInputForDeletePartMutationResult = Apollo.MutationResult<AddPartsToAssemblyInputForDeletePartMutation>;
export type AddPartsToAssemblyInputForDeletePartMutationOptions = Apollo.BaseMutationOptions<AddPartsToAssemblyInputForDeletePartMutation, AddPartsToAssemblyInputForDeletePartMutationVariables>;
export const AllHistoriesDocument = gql`
    query AllHistories($referenceId: String, $eventNames: [String]) {
  allHistories(referenceId: $referenceId, eventNames: $eventNames) {
    id
    collectionName
    eventName
    document
    createdAt
    createdBy
    createdByName
  }
}
    `;

/**
 * __useAllHistoriesQuery__
 *
 * To run a query within a React component, call `useAllHistoriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllHistoriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllHistoriesQuery({
 *   variables: {
 *      referenceId: // value for 'referenceId'
 *      eventNames: // value for 'eventNames'
 *   },
 * });
 */
export function useAllHistoriesQuery(baseOptions?: Apollo.QueryHookOptions<AllHistoriesQuery, AllHistoriesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AllHistoriesQuery, AllHistoriesQueryVariables>(AllHistoriesDocument, options);
      }
export function useAllHistoriesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AllHistoriesQuery, AllHistoriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AllHistoriesQuery, AllHistoriesQueryVariables>(AllHistoriesDocument, options);
        }
// @ts-ignore
export function useAllHistoriesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<AllHistoriesQuery, AllHistoriesQueryVariables>): Apollo.UseSuspenseQueryResult<AllHistoriesQuery, AllHistoriesQueryVariables>;
export function useAllHistoriesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AllHistoriesQuery, AllHistoriesQueryVariables>): Apollo.UseSuspenseQueryResult<AllHistoriesQuery | undefined, AllHistoriesQueryVariables>;
export function useAllHistoriesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AllHistoriesQuery, AllHistoriesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AllHistoriesQuery, AllHistoriesQueryVariables>(AllHistoriesDocument, options);
        }
export type AllHistoriesQueryHookResult = ReturnType<typeof useAllHistoriesQuery>;
export type AllHistoriesLazyQueryHookResult = ReturnType<typeof useAllHistoriesLazyQuery>;
export type AllHistoriesSuspenseQueryHookResult = ReturnType<typeof useAllHistoriesSuspenseQuery>;
export type AllHistoriesQueryResult = Apollo.QueryResult<AllHistoriesQuery, AllHistoriesQueryVariables>;
export const PartDocument = gql`
    query Part($partId: String) {
  part(partId: $partId) {
    id
    class
    assembly {
      id
      tagName
    }
  }
}
    `;

/**
 * __usePartQuery__
 *
 * To run a query within a React component, call `usePartQuery` and pass it any options that fit your needs.
 * When your component renders, `usePartQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePartQuery({
 *   variables: {
 *      partId: // value for 'partId'
 *   },
 * });
 */
export function usePartQuery(baseOptions?: Apollo.QueryHookOptions<PartQuery, PartQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PartQuery, PartQueryVariables>(PartDocument, options);
      }
export function usePartLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PartQuery, PartQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PartQuery, PartQueryVariables>(PartDocument, options);
        }
// @ts-ignore
export function usePartSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<PartQuery, PartQueryVariables>): Apollo.UseSuspenseQueryResult<PartQuery, PartQueryVariables>;
export function usePartSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PartQuery, PartQueryVariables>): Apollo.UseSuspenseQueryResult<PartQuery | undefined, PartQueryVariables>;
export function usePartSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PartQuery, PartQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PartQuery, PartQueryVariables>(PartDocument, options);
        }
export type PartQueryHookResult = ReturnType<typeof usePartQuery>;
export type PartLazyQueryHookResult = ReturnType<typeof usePartLazyQuery>;
export type PartSuspenseQueryHookResult = ReturnType<typeof usePartSuspenseQuery>;
export type PartQueryResult = Apollo.QueryResult<PartQuery, PartQueryVariables>;
export const AddNewAssemblyTagNameDocument = gql`
    mutation AddNewAssemblyTagName($input: AddNewAssemblyTagNameInput) {
  addNewAssemblyTagName(input: $input) {
    id
    tagName
  }
}
    `;
export type AddNewAssemblyTagNameMutationFn = Apollo.MutationFunction<AddNewAssemblyTagNameMutation, AddNewAssemblyTagNameMutationVariables>;

/**
 * __useAddNewAssemblyTagNameMutation__
 *
 * To run a mutation, you first call `useAddNewAssemblyTagNameMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddNewAssemblyTagNameMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addNewAssemblyTagNameMutation, { data, loading, error }] = useAddNewAssemblyTagNameMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddNewAssemblyTagNameMutation(baseOptions?: Apollo.MutationHookOptions<AddNewAssemblyTagNameMutation, AddNewAssemblyTagNameMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddNewAssemblyTagNameMutation, AddNewAssemblyTagNameMutationVariables>(AddNewAssemblyTagNameDocument, options);
      }
export type AddNewAssemblyTagNameMutationHookResult = ReturnType<typeof useAddNewAssemblyTagNameMutation>;
export type AddNewAssemblyTagNameMutationResult = Apollo.MutationResult<AddNewAssemblyTagNameMutation>;
export type AddNewAssemblyTagNameMutationOptions = Apollo.BaseMutationOptions<AddNewAssemblyTagNameMutation, AddNewAssemblyTagNameMutationVariables>;
export const EquipmentClassesForStrunctureDocument = gql`
    query equipmentClassesForStruncture($structureId: String) {
  structure(structureId: $structureId) {
    equipmentClasses {
      classes {
        name
        code
      }
      name
    }
  }
}
    `;

/**
 * __useEquipmentClassesForStrunctureQuery__
 *
 * To run a query within a React component, call `useEquipmentClassesForStrunctureQuery` and pass it any options that fit your needs.
 * When your component renders, `useEquipmentClassesForStrunctureQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEquipmentClassesForStrunctureQuery({
 *   variables: {
 *      structureId: // value for 'structureId'
 *   },
 * });
 */
export function useEquipmentClassesForStrunctureQuery(baseOptions?: Apollo.QueryHookOptions<EquipmentClassesForStrunctureQuery, EquipmentClassesForStrunctureQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EquipmentClassesForStrunctureQuery, EquipmentClassesForStrunctureQueryVariables>(EquipmentClassesForStrunctureDocument, options);
      }
export function useEquipmentClassesForStrunctureLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EquipmentClassesForStrunctureQuery, EquipmentClassesForStrunctureQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EquipmentClassesForStrunctureQuery, EquipmentClassesForStrunctureQueryVariables>(EquipmentClassesForStrunctureDocument, options);
        }
// @ts-ignore
export function useEquipmentClassesForStrunctureSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<EquipmentClassesForStrunctureQuery, EquipmentClassesForStrunctureQueryVariables>): Apollo.UseSuspenseQueryResult<EquipmentClassesForStrunctureQuery, EquipmentClassesForStrunctureQueryVariables>;
export function useEquipmentClassesForStrunctureSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<EquipmentClassesForStrunctureQuery, EquipmentClassesForStrunctureQueryVariables>): Apollo.UseSuspenseQueryResult<EquipmentClassesForStrunctureQuery | undefined, EquipmentClassesForStrunctureQueryVariables>;
export function useEquipmentClassesForStrunctureSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<EquipmentClassesForStrunctureQuery, EquipmentClassesForStrunctureQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<EquipmentClassesForStrunctureQuery, EquipmentClassesForStrunctureQueryVariables>(EquipmentClassesForStrunctureDocument, options);
        }
export type EquipmentClassesForStrunctureQueryHookResult = ReturnType<typeof useEquipmentClassesForStrunctureQuery>;
export type EquipmentClassesForStrunctureLazyQueryHookResult = ReturnType<typeof useEquipmentClassesForStrunctureLazyQuery>;
export type EquipmentClassesForStrunctureSuspenseQueryHookResult = ReturnType<typeof useEquipmentClassesForStrunctureSuspenseQuery>;
export type EquipmentClassesForStrunctureQueryResult = Apollo.QueryResult<EquipmentClassesForStrunctureQuery, EquipmentClassesForStrunctureQueryVariables>;
export const GetStructureStatusDocument = gql`
    query GetStructureStatus($structureId: String) {
  structure(structureId: $structureId) {
    status
  }
}
    `;

/**
 * __useGetStructureStatusQuery__
 *
 * To run a query within a React component, call `useGetStructureStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetStructureStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetStructureStatusQuery({
 *   variables: {
 *      structureId: // value for 'structureId'
 *   },
 * });
 */
export function useGetStructureStatusQuery(baseOptions?: Apollo.QueryHookOptions<GetStructureStatusQuery, GetStructureStatusQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetStructureStatusQuery, GetStructureStatusQueryVariables>(GetStructureStatusDocument, options);
      }
export function useGetStructureStatusLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetStructureStatusQuery, GetStructureStatusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetStructureStatusQuery, GetStructureStatusQueryVariables>(GetStructureStatusDocument, options);
        }
// @ts-ignore
export function useGetStructureStatusSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetStructureStatusQuery, GetStructureStatusQueryVariables>): Apollo.UseSuspenseQueryResult<GetStructureStatusQuery, GetStructureStatusQueryVariables>;
export function useGetStructureStatusSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetStructureStatusQuery, GetStructureStatusQueryVariables>): Apollo.UseSuspenseQueryResult<GetStructureStatusQuery | undefined, GetStructureStatusQueryVariables>;
export function useGetStructureStatusSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetStructureStatusQuery, GetStructureStatusQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetStructureStatusQuery, GetStructureStatusQueryVariables>(GetStructureStatusDocument, options);
        }
export type GetStructureStatusQueryHookResult = ReturnType<typeof useGetStructureStatusQuery>;
export type GetStructureStatusLazyQueryHookResult = ReturnType<typeof useGetStructureStatusLazyQuery>;
export type GetStructureStatusSuspenseQueryHookResult = ReturnType<typeof useGetStructureStatusSuspenseQuery>;
export type GetStructureStatusQueryResult = Apollo.QueryResult<GetStructureStatusQuery, GetStructureStatusQueryVariables>;
export const AllStructuresForPlatformsDocument = gql`
    query AllStructuresForPlatforms($input: StructureFilters) {
  allStructures(input: $input) {
    id
    name
    status
    coverImagePath
    deploymentLevel
    description
    octreeResourcesPath
    category
    cardInsights {
      color
      name
      value
      type
      visible
    }
  }
}
    `;

/**
 * __useAllStructuresForPlatformsQuery__
 *
 * To run a query within a React component, call `useAllStructuresForPlatformsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllStructuresForPlatformsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllStructuresForPlatformsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAllStructuresForPlatformsQuery(baseOptions?: Apollo.QueryHookOptions<AllStructuresForPlatformsQuery, AllStructuresForPlatformsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AllStructuresForPlatformsQuery, AllStructuresForPlatformsQueryVariables>(AllStructuresForPlatformsDocument, options);
      }
export function useAllStructuresForPlatformsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AllStructuresForPlatformsQuery, AllStructuresForPlatformsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AllStructuresForPlatformsQuery, AllStructuresForPlatformsQueryVariables>(AllStructuresForPlatformsDocument, options);
        }
// @ts-ignore
export function useAllStructuresForPlatformsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<AllStructuresForPlatformsQuery, AllStructuresForPlatformsQueryVariables>): Apollo.UseSuspenseQueryResult<AllStructuresForPlatformsQuery, AllStructuresForPlatformsQueryVariables>;
export function useAllStructuresForPlatformsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AllStructuresForPlatformsQuery, AllStructuresForPlatformsQueryVariables>): Apollo.UseSuspenseQueryResult<AllStructuresForPlatformsQuery | undefined, AllStructuresForPlatformsQueryVariables>;
export function useAllStructuresForPlatformsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AllStructuresForPlatformsQuery, AllStructuresForPlatformsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AllStructuresForPlatformsQuery, AllStructuresForPlatformsQueryVariables>(AllStructuresForPlatformsDocument, options);
        }
export type AllStructuresForPlatformsQueryHookResult = ReturnType<typeof useAllStructuresForPlatformsQuery>;
export type AllStructuresForPlatformsLazyQueryHookResult = ReturnType<typeof useAllStructuresForPlatformsLazyQuery>;
export type AllStructuresForPlatformsSuspenseQueryHookResult = ReturnType<typeof useAllStructuresForPlatformsSuspenseQuery>;
export type AllStructuresForPlatformsQueryResult = Apollo.QueryResult<AllStructuresForPlatformsQuery, AllStructuresForPlatformsQueryVariables>;
export const AllRegionsDocument = gql`
    query AllRegions {
  allRegions {
    id
    name
  }
}
    `;

/**
 * __useAllRegionsQuery__
 *
 * To run a query within a React component, call `useAllRegionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllRegionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllRegionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useAllRegionsQuery(baseOptions?: Apollo.QueryHookOptions<AllRegionsQuery, AllRegionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AllRegionsQuery, AllRegionsQueryVariables>(AllRegionsDocument, options);
      }
export function useAllRegionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AllRegionsQuery, AllRegionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AllRegionsQuery, AllRegionsQueryVariables>(AllRegionsDocument, options);
        }
// @ts-ignore
export function useAllRegionsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<AllRegionsQuery, AllRegionsQueryVariables>): Apollo.UseSuspenseQueryResult<AllRegionsQuery, AllRegionsQueryVariables>;
export function useAllRegionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AllRegionsQuery, AllRegionsQueryVariables>): Apollo.UseSuspenseQueryResult<AllRegionsQuery | undefined, AllRegionsQueryVariables>;
export function useAllRegionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AllRegionsQuery, AllRegionsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AllRegionsQuery, AllRegionsQueryVariables>(AllRegionsDocument, options);
        }
export type AllRegionsQueryHookResult = ReturnType<typeof useAllRegionsQuery>;
export type AllRegionsLazyQueryHookResult = ReturnType<typeof useAllRegionsLazyQuery>;
export type AllRegionsSuspenseQueryHookResult = ReturnType<typeof useAllRegionsSuspenseQuery>;
export type AllRegionsQueryResult = Apollo.QueryResult<AllRegionsQuery, AllRegionsQueryVariables>;
export const AllStructuresByRegionDocument = gql`
    query AllStructuresByRegion {
  allStructuresByRegion {
    id
    name
    structures {
      id
      name
      status
      defectArea {
        key
        area
      }
    }
    defectArea {
      key
      area
    }
  }
  allDefects {
    key
    name
  }
}
    `;

/**
 * __useAllStructuresByRegionQuery__
 *
 * To run a query within a React component, call `useAllStructuresByRegionQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllStructuresByRegionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllStructuresByRegionQuery({
 *   variables: {
 *   },
 * });
 */
export function useAllStructuresByRegionQuery(baseOptions?: Apollo.QueryHookOptions<AllStructuresByRegionQuery, AllStructuresByRegionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AllStructuresByRegionQuery, AllStructuresByRegionQueryVariables>(AllStructuresByRegionDocument, options);
      }
export function useAllStructuresByRegionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AllStructuresByRegionQuery, AllStructuresByRegionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AllStructuresByRegionQuery, AllStructuresByRegionQueryVariables>(AllStructuresByRegionDocument, options);
        }
// @ts-ignore
export function useAllStructuresByRegionSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<AllStructuresByRegionQuery, AllStructuresByRegionQueryVariables>): Apollo.UseSuspenseQueryResult<AllStructuresByRegionQuery, AllStructuresByRegionQueryVariables>;
export function useAllStructuresByRegionSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AllStructuresByRegionQuery, AllStructuresByRegionQueryVariables>): Apollo.UseSuspenseQueryResult<AllStructuresByRegionQuery | undefined, AllStructuresByRegionQueryVariables>;
export function useAllStructuresByRegionSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AllStructuresByRegionQuery, AllStructuresByRegionQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AllStructuresByRegionQuery, AllStructuresByRegionQueryVariables>(AllStructuresByRegionDocument, options);
        }
export type AllStructuresByRegionQueryHookResult = ReturnType<typeof useAllStructuresByRegionQuery>;
export type AllStructuresByRegionLazyQueryHookResult = ReturnType<typeof useAllStructuresByRegionLazyQuery>;
export type AllStructuresByRegionSuspenseQueryHookResult = ReturnType<typeof useAllStructuresByRegionSuspenseQuery>;
export type AllStructuresByRegionQueryResult = Apollo.QueryResult<AllStructuresByRegionQuery, AllStructuresByRegionQueryVariables>;
export const StructureDecksWithDefectsDocument = gql`
    query StructureDecksWithDefects($structureId: ID) {
  decksWithDefects(structureId: $structureId) {
    id
    name
    defectArea {
      key
      area
    }
  }
}
    `;

/**
 * __useStructureDecksWithDefectsQuery__
 *
 * To run a query within a React component, call `useStructureDecksWithDefectsQuery` and pass it any options that fit your needs.
 * When your component renders, `useStructureDecksWithDefectsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStructureDecksWithDefectsQuery({
 *   variables: {
 *      structureId: // value for 'structureId'
 *   },
 * });
 */
export function useStructureDecksWithDefectsQuery(baseOptions?: Apollo.QueryHookOptions<StructureDecksWithDefectsQuery, StructureDecksWithDefectsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<StructureDecksWithDefectsQuery, StructureDecksWithDefectsQueryVariables>(StructureDecksWithDefectsDocument, options);
      }
export function useStructureDecksWithDefectsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<StructureDecksWithDefectsQuery, StructureDecksWithDefectsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<StructureDecksWithDefectsQuery, StructureDecksWithDefectsQueryVariables>(StructureDecksWithDefectsDocument, options);
        }
// @ts-ignore
export function useStructureDecksWithDefectsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<StructureDecksWithDefectsQuery, StructureDecksWithDefectsQueryVariables>): Apollo.UseSuspenseQueryResult<StructureDecksWithDefectsQuery, StructureDecksWithDefectsQueryVariables>;
export function useStructureDecksWithDefectsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<StructureDecksWithDefectsQuery, StructureDecksWithDefectsQueryVariables>): Apollo.UseSuspenseQueryResult<StructureDecksWithDefectsQuery | undefined, StructureDecksWithDefectsQueryVariables>;
export function useStructureDecksWithDefectsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<StructureDecksWithDefectsQuery, StructureDecksWithDefectsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<StructureDecksWithDefectsQuery, StructureDecksWithDefectsQueryVariables>(StructureDecksWithDefectsDocument, options);
        }
export type StructureDecksWithDefectsQueryHookResult = ReturnType<typeof useStructureDecksWithDefectsQuery>;
export type StructureDecksWithDefectsLazyQueryHookResult = ReturnType<typeof useStructureDecksWithDefectsLazyQuery>;
export type StructureDecksWithDefectsSuspenseQueryHookResult = ReturnType<typeof useStructureDecksWithDefectsSuspenseQuery>;
export type StructureDecksWithDefectsQueryResult = Apollo.QueryResult<StructureDecksWithDefectsQuery, StructureDecksWithDefectsQueryVariables>;
export const AllUserGroupsForPlatformsDocument = gql`
    query AllUserGroupsForPlatforms {
  allUserGroups {
    id
    name
    userIds
    createdBy
    updatedBy
    createdAt
    updatedAt
  }
}
    `;

/**
 * __useAllUserGroupsForPlatformsQuery__
 *
 * To run a query within a React component, call `useAllUserGroupsForPlatformsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllUserGroupsForPlatformsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllUserGroupsForPlatformsQuery({
 *   variables: {
 *   },
 * });
 */
export function useAllUserGroupsForPlatformsQuery(baseOptions?: Apollo.QueryHookOptions<AllUserGroupsForPlatformsQuery, AllUserGroupsForPlatformsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AllUserGroupsForPlatformsQuery, AllUserGroupsForPlatformsQueryVariables>(AllUserGroupsForPlatformsDocument, options);
      }
export function useAllUserGroupsForPlatformsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AllUserGroupsForPlatformsQuery, AllUserGroupsForPlatformsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AllUserGroupsForPlatformsQuery, AllUserGroupsForPlatformsQueryVariables>(AllUserGroupsForPlatformsDocument, options);
        }
// @ts-ignore
export function useAllUserGroupsForPlatformsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<AllUserGroupsForPlatformsQuery, AllUserGroupsForPlatformsQueryVariables>): Apollo.UseSuspenseQueryResult<AllUserGroupsForPlatformsQuery, AllUserGroupsForPlatformsQueryVariables>;
export function useAllUserGroupsForPlatformsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AllUserGroupsForPlatformsQuery, AllUserGroupsForPlatformsQueryVariables>): Apollo.UseSuspenseQueryResult<AllUserGroupsForPlatformsQuery | undefined, AllUserGroupsForPlatformsQueryVariables>;
export function useAllUserGroupsForPlatformsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AllUserGroupsForPlatformsQuery, AllUserGroupsForPlatformsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AllUserGroupsForPlatformsQuery, AllUserGroupsForPlatformsQueryVariables>(AllUserGroupsForPlatformsDocument, options);
        }
export type AllUserGroupsForPlatformsQueryHookResult = ReturnType<typeof useAllUserGroupsForPlatformsQuery>;
export type AllUserGroupsForPlatformsLazyQueryHookResult = ReturnType<typeof useAllUserGroupsForPlatformsLazyQuery>;
export type AllUserGroupsForPlatformsSuspenseQueryHookResult = ReturnType<typeof useAllUserGroupsForPlatformsSuspenseQuery>;
export type AllUserGroupsForPlatformsQueryResult = Apollo.QueryResult<AllUserGroupsForPlatformsQuery, AllUserGroupsForPlatformsQueryVariables>;
export const CreateStructureDocument = gql`
    mutation CreateStructure($input: CreateStructureInput!) {
  createStructure(input: $input) {
    id
  }
}
    `;
export type CreateStructureMutationFn = Apollo.MutationFunction<CreateStructureMutation, CreateStructureMutationVariables>;

/**
 * __useCreateStructureMutation__
 *
 * To run a mutation, you first call `useCreateStructureMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateStructureMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createStructureMutation, { data, loading, error }] = useCreateStructureMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateStructureMutation(baseOptions?: Apollo.MutationHookOptions<CreateStructureMutation, CreateStructureMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateStructureMutation, CreateStructureMutationVariables>(CreateStructureDocument, options);
      }
export type CreateStructureMutationHookResult = ReturnType<typeof useCreateStructureMutation>;
export type CreateStructureMutationResult = Apollo.MutationResult<CreateStructureMutation>;
export type CreateStructureMutationOptions = Apollo.BaseMutationOptions<CreateStructureMutation, CreateStructureMutationVariables>;
export const AnalyticsDocument = gql`
    query Analytics($input: AnalyticsFiltersInput) {
  analytics(input: $input) {
    data
    id
    structureIds
    type
    displayConfig
  }
}
    `;

/**
 * __useAnalyticsQuery__
 *
 * To run a query within a React component, call `useAnalyticsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAnalyticsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAnalyticsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAnalyticsQuery(baseOptions?: Apollo.QueryHookOptions<AnalyticsQuery, AnalyticsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AnalyticsQuery, AnalyticsQueryVariables>(AnalyticsDocument, options);
      }
export function useAnalyticsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AnalyticsQuery, AnalyticsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AnalyticsQuery, AnalyticsQueryVariables>(AnalyticsDocument, options);
        }
// @ts-ignore
export function useAnalyticsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<AnalyticsQuery, AnalyticsQueryVariables>): Apollo.UseSuspenseQueryResult<AnalyticsQuery, AnalyticsQueryVariables>;
export function useAnalyticsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AnalyticsQuery, AnalyticsQueryVariables>): Apollo.UseSuspenseQueryResult<AnalyticsQuery | undefined, AnalyticsQueryVariables>;
export function useAnalyticsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AnalyticsQuery, AnalyticsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AnalyticsQuery, AnalyticsQueryVariables>(AnalyticsDocument, options);
        }
export type AnalyticsQueryHookResult = ReturnType<typeof useAnalyticsQuery>;
export type AnalyticsLazyQueryHookResult = ReturnType<typeof useAnalyticsLazyQuery>;
export type AnalyticsSuspenseQueryHookResult = ReturnType<typeof useAnalyticsSuspenseQuery>;
export type AnalyticsQueryResult = Apollo.QueryResult<AnalyticsQuery, AnalyticsQueryVariables>;
export const AllPlatformsDocument = gql`
    query AllPlatforms($regionId: ID) {
  allPlatforms(regionId: $regionId) {
    id
    name
    platformCardInsights {
      name
      value
      group
      filterOptions
      displayConfig {
        color
        divider
        listIndex
        barIndex
      }
    }
    platformSummary {
      name
      value
      group
      displayConfig {
        color
        divider
        listIndex
        barIndex
      }
    }
    region {
      id
      name
    }
    coverImagePath
    fleetHealthFilters
  }
}
    `;

/**
 * __useAllPlatformsQuery__
 *
 * To run a query within a React component, call `useAllPlatformsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllPlatformsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllPlatformsQuery({
 *   variables: {
 *      regionId: // value for 'regionId'
 *   },
 * });
 */
export function useAllPlatformsQuery(baseOptions?: Apollo.QueryHookOptions<AllPlatformsQuery, AllPlatformsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AllPlatformsQuery, AllPlatformsQueryVariables>(AllPlatformsDocument, options);
      }
export function useAllPlatformsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AllPlatformsQuery, AllPlatformsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AllPlatformsQuery, AllPlatformsQueryVariables>(AllPlatformsDocument, options);
        }
// @ts-ignore
export function useAllPlatformsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<AllPlatformsQuery, AllPlatformsQueryVariables>): Apollo.UseSuspenseQueryResult<AllPlatformsQuery, AllPlatformsQueryVariables>;
export function useAllPlatformsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AllPlatformsQuery, AllPlatformsQueryVariables>): Apollo.UseSuspenseQueryResult<AllPlatformsQuery | undefined, AllPlatformsQueryVariables>;
export function useAllPlatformsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AllPlatformsQuery, AllPlatformsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AllPlatformsQuery, AllPlatformsQueryVariables>(AllPlatformsDocument, options);
        }
export type AllPlatformsQueryHookResult = ReturnType<typeof useAllPlatformsQuery>;
export type AllPlatformsLazyQueryHookResult = ReturnType<typeof useAllPlatformsLazyQuery>;
export type AllPlatformsSuspenseQueryHookResult = ReturnType<typeof useAllPlatformsSuspenseQuery>;
export type AllPlatformsQueryResult = Apollo.QueryResult<AllPlatformsQuery, AllPlatformsQueryVariables>;
export const PlatformDocument = gql`
    query Platform($platformId: ID!) {
  platform(platformId: $platformId) {
    id
    name
    platformCardInsights {
      name
      value
      group
      displayConfig {
        color
      }
    }
    region {
      id
      name
    }
  }
}
    `;

/**
 * __usePlatformQuery__
 *
 * To run a query within a React component, call `usePlatformQuery` and pass it any options that fit your needs.
 * When your component renders, `usePlatformQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePlatformQuery({
 *   variables: {
 *      platformId: // value for 'platformId'
 *   },
 * });
 */
export function usePlatformQuery(baseOptions: Apollo.QueryHookOptions<PlatformQuery, PlatformQueryVariables> & ({ variables: PlatformQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PlatformQuery, PlatformQueryVariables>(PlatformDocument, options);
      }
export function usePlatformLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PlatformQuery, PlatformQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PlatformQuery, PlatformQueryVariables>(PlatformDocument, options);
        }
// @ts-ignore
export function usePlatformSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<PlatformQuery, PlatformQueryVariables>): Apollo.UseSuspenseQueryResult<PlatformQuery, PlatformQueryVariables>;
export function usePlatformSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PlatformQuery, PlatformQueryVariables>): Apollo.UseSuspenseQueryResult<PlatformQuery | undefined, PlatformQueryVariables>;
export function usePlatformSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PlatformQuery, PlatformQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PlatformQuery, PlatformQueryVariables>(PlatformDocument, options);
        }
export type PlatformQueryHookResult = ReturnType<typeof usePlatformQuery>;
export type PlatformLazyQueryHookResult = ReturnType<typeof usePlatformLazyQuery>;
export type PlatformSuspenseQueryHookResult = ReturnType<typeof usePlatformSuspenseQuery>;
export type PlatformQueryResult = Apollo.QueryResult<PlatformQuery, PlatformQueryVariables>;
export const AllStructuresForHomePageDocument = gql`
    query AllStructuresForHomePage($input: StructureFilters) {
  allStructures(input: $input) {
    id
    name
    isActive
    deploymentLevel
    octreeResourcesPath
    coverImagePath
    updatedAt
    status
    scanDate
    defectLegends {
      id
      name
      groupKey
      groupName
      color
      octreeKey
      octreeValue
    }
  }
}
    `;

/**
 * __useAllStructuresForHomePageQuery__
 *
 * To run a query within a React component, call `useAllStructuresForHomePageQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllStructuresForHomePageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllStructuresForHomePageQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAllStructuresForHomePageQuery(baseOptions?: Apollo.QueryHookOptions<AllStructuresForHomePageQuery, AllStructuresForHomePageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AllStructuresForHomePageQuery, AllStructuresForHomePageQueryVariables>(AllStructuresForHomePageDocument, options);
      }
export function useAllStructuresForHomePageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AllStructuresForHomePageQuery, AllStructuresForHomePageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AllStructuresForHomePageQuery, AllStructuresForHomePageQueryVariables>(AllStructuresForHomePageDocument, options);
        }
// @ts-ignore
export function useAllStructuresForHomePageSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<AllStructuresForHomePageQuery, AllStructuresForHomePageQueryVariables>): Apollo.UseSuspenseQueryResult<AllStructuresForHomePageQuery, AllStructuresForHomePageQueryVariables>;
export function useAllStructuresForHomePageSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AllStructuresForHomePageQuery, AllStructuresForHomePageQueryVariables>): Apollo.UseSuspenseQueryResult<AllStructuresForHomePageQuery | undefined, AllStructuresForHomePageQueryVariables>;
export function useAllStructuresForHomePageSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AllStructuresForHomePageQuery, AllStructuresForHomePageQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AllStructuresForHomePageQuery, AllStructuresForHomePageQueryVariables>(AllStructuresForHomePageDocument, options);
        }
export type AllStructuresForHomePageQueryHookResult = ReturnType<typeof useAllStructuresForHomePageQuery>;
export type AllStructuresForHomePageLazyQueryHookResult = ReturnType<typeof useAllStructuresForHomePageLazyQuery>;
export type AllStructuresForHomePageSuspenseQueryHookResult = ReturnType<typeof useAllStructuresForHomePageSuspenseQuery>;
export type AllStructuresForHomePageQueryResult = Apollo.QueryResult<AllStructuresForHomePageQuery, AllStructuresForHomePageQueryVariables>;
export const DefectsAreaByPlatformDocument = gql`
    query defectsAreaByPlatform($platformId: ID!) {
  defectsAreaByStructures(platformId: $platformId) {
    structureId
    structureName
    totalArea {
      type
      value
    }
  }
}
    `;

/**
 * __useDefectsAreaByPlatformQuery__
 *
 * To run a query within a React component, call `useDefectsAreaByPlatformQuery` and pass it any options that fit your needs.
 * When your component renders, `useDefectsAreaByPlatformQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDefectsAreaByPlatformQuery({
 *   variables: {
 *      platformId: // value for 'platformId'
 *   },
 * });
 */
export function useDefectsAreaByPlatformQuery(baseOptions: Apollo.QueryHookOptions<DefectsAreaByPlatformQuery, DefectsAreaByPlatformQueryVariables> & ({ variables: DefectsAreaByPlatformQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DefectsAreaByPlatformQuery, DefectsAreaByPlatformQueryVariables>(DefectsAreaByPlatformDocument, options);
      }
export function useDefectsAreaByPlatformLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DefectsAreaByPlatformQuery, DefectsAreaByPlatformQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DefectsAreaByPlatformQuery, DefectsAreaByPlatformQueryVariables>(DefectsAreaByPlatformDocument, options);
        }
// @ts-ignore
export function useDefectsAreaByPlatformSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<DefectsAreaByPlatformQuery, DefectsAreaByPlatformQueryVariables>): Apollo.UseSuspenseQueryResult<DefectsAreaByPlatformQuery, DefectsAreaByPlatformQueryVariables>;
export function useDefectsAreaByPlatformSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DefectsAreaByPlatformQuery, DefectsAreaByPlatformQueryVariables>): Apollo.UseSuspenseQueryResult<DefectsAreaByPlatformQuery | undefined, DefectsAreaByPlatformQueryVariables>;
export function useDefectsAreaByPlatformSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DefectsAreaByPlatformQuery, DefectsAreaByPlatformQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DefectsAreaByPlatformQuery, DefectsAreaByPlatformQueryVariables>(DefectsAreaByPlatformDocument, options);
        }
export type DefectsAreaByPlatformQueryHookResult = ReturnType<typeof useDefectsAreaByPlatformQuery>;
export type DefectsAreaByPlatformLazyQueryHookResult = ReturnType<typeof useDefectsAreaByPlatformLazyQuery>;
export type DefectsAreaByPlatformSuspenseQueryHookResult = ReturnType<typeof useDefectsAreaByPlatformSuspenseQuery>;
export type DefectsAreaByPlatformQueryResult = Apollo.QueryResult<DefectsAreaByPlatformQuery, DefectsAreaByPlatformQueryVariables>;
export const GetAlarmLevelSummaryDocument = gql`
    query GetAlarmLevelSummary($input: AlarmLevelSummaryInput) {
  getAlarmLevelSummary(input: $input) {
    total {
      type
      count
    }
    structureId
    structureName
  }
}
    `;

/**
 * __useGetAlarmLevelSummaryQuery__
 *
 * To run a query within a React component, call `useGetAlarmLevelSummaryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAlarmLevelSummaryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAlarmLevelSummaryQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetAlarmLevelSummaryQuery(baseOptions?: Apollo.QueryHookOptions<GetAlarmLevelSummaryQuery, GetAlarmLevelSummaryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAlarmLevelSummaryQuery, GetAlarmLevelSummaryQueryVariables>(GetAlarmLevelSummaryDocument, options);
      }
export function useGetAlarmLevelSummaryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAlarmLevelSummaryQuery, GetAlarmLevelSummaryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAlarmLevelSummaryQuery, GetAlarmLevelSummaryQueryVariables>(GetAlarmLevelSummaryDocument, options);
        }
// @ts-ignore
export function useGetAlarmLevelSummarySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetAlarmLevelSummaryQuery, GetAlarmLevelSummaryQueryVariables>): Apollo.UseSuspenseQueryResult<GetAlarmLevelSummaryQuery, GetAlarmLevelSummaryQueryVariables>;
export function useGetAlarmLevelSummarySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAlarmLevelSummaryQuery, GetAlarmLevelSummaryQueryVariables>): Apollo.UseSuspenseQueryResult<GetAlarmLevelSummaryQuery | undefined, GetAlarmLevelSummaryQueryVariables>;
export function useGetAlarmLevelSummarySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAlarmLevelSummaryQuery, GetAlarmLevelSummaryQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAlarmLevelSummaryQuery, GetAlarmLevelSummaryQueryVariables>(GetAlarmLevelSummaryDocument, options);
        }
export type GetAlarmLevelSummaryQueryHookResult = ReturnType<typeof useGetAlarmLevelSummaryQuery>;
export type GetAlarmLevelSummaryLazyQueryHookResult = ReturnType<typeof useGetAlarmLevelSummaryLazyQuery>;
export type GetAlarmLevelSummarySuspenseQueryHookResult = ReturnType<typeof useGetAlarmLevelSummarySuspenseQuery>;
export type GetAlarmLevelSummaryQueryResult = Apollo.QueryResult<GetAlarmLevelSummaryQuery, GetAlarmLevelSummaryQueryVariables>;
export const PaintRegionAnalyticsByStructuresDocument = gql`
    query PaintRegionAnalyticsByStructures($input: PaintRegionAnalyticsInput!) {
  paintRegionAnalyticsByStructures(input: $input) {
    paintRegionName
    cm {
      uncalibrated_ri0_area
      uncalibrated_ri1_area
      uncalibrated_ri2_area
      uncalibrated_ri3_area
      uncalibrated_ri4_area
      uncalibrated_ri5_area
      uncalibrated_coating_breakdown_area
      uncalibrated_total_area
      calibrated_ri0_area
      calibrated_ri1_area
      calibrated_ri2_area
      calibrated_ri3_area
      calibrated_ri4_area
      calibrated_ri5_area
      calibrated_coating_breakdown_area
      calibrated_coating_breakdown_score
      calibrated_total_area
      total_risk_score
      remediated_ri0
      remediated_ri1
      remediated_ri2
      remediated_ri3
      remediated_ri4
      remediated_ri5
      total_already_completed
      actual_total_remediated_area
    }
    psim {
      baseline {
        cofCategory
        area
        totalArea
        ri0
        ri1
        ri2
        ri3
        ri4
        ri5
        light
        moderate
        heavy
        riskAreaRemediationScore
        remediatedArea
      }
      remediation {
        cofCategory
        area
        totalArea
        ri0
        ri1
        ri2
        ri3
        ri4
        ri5
        light
        moderate
        heavy
        riskAreaRemediationScore
        remediatedArea
      }
    }
  }
}
    `;

/**
 * __usePaintRegionAnalyticsByStructuresQuery__
 *
 * To run a query within a React component, call `usePaintRegionAnalyticsByStructuresQuery` and pass it any options that fit your needs.
 * When your component renders, `usePaintRegionAnalyticsByStructuresQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePaintRegionAnalyticsByStructuresQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePaintRegionAnalyticsByStructuresQuery(baseOptions: Apollo.QueryHookOptions<PaintRegionAnalyticsByStructuresQuery, PaintRegionAnalyticsByStructuresQueryVariables> & ({ variables: PaintRegionAnalyticsByStructuresQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PaintRegionAnalyticsByStructuresQuery, PaintRegionAnalyticsByStructuresQueryVariables>(PaintRegionAnalyticsByStructuresDocument, options);
      }
export function usePaintRegionAnalyticsByStructuresLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PaintRegionAnalyticsByStructuresQuery, PaintRegionAnalyticsByStructuresQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PaintRegionAnalyticsByStructuresQuery, PaintRegionAnalyticsByStructuresQueryVariables>(PaintRegionAnalyticsByStructuresDocument, options);
        }
// @ts-ignore
export function usePaintRegionAnalyticsByStructuresSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<PaintRegionAnalyticsByStructuresQuery, PaintRegionAnalyticsByStructuresQueryVariables>): Apollo.UseSuspenseQueryResult<PaintRegionAnalyticsByStructuresQuery, PaintRegionAnalyticsByStructuresQueryVariables>;
export function usePaintRegionAnalyticsByStructuresSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PaintRegionAnalyticsByStructuresQuery, PaintRegionAnalyticsByStructuresQueryVariables>): Apollo.UseSuspenseQueryResult<PaintRegionAnalyticsByStructuresQuery | undefined, PaintRegionAnalyticsByStructuresQueryVariables>;
export function usePaintRegionAnalyticsByStructuresSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PaintRegionAnalyticsByStructuresQuery, PaintRegionAnalyticsByStructuresQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PaintRegionAnalyticsByStructuresQuery, PaintRegionAnalyticsByStructuresQueryVariables>(PaintRegionAnalyticsByStructuresDocument, options);
        }
export type PaintRegionAnalyticsByStructuresQueryHookResult = ReturnType<typeof usePaintRegionAnalyticsByStructuresQuery>;
export type PaintRegionAnalyticsByStructuresLazyQueryHookResult = ReturnType<typeof usePaintRegionAnalyticsByStructuresLazyQuery>;
export type PaintRegionAnalyticsByStructuresSuspenseQueryHookResult = ReturnType<typeof usePaintRegionAnalyticsByStructuresSuspenseQuery>;
export type PaintRegionAnalyticsByStructuresQueryResult = Apollo.QueryResult<PaintRegionAnalyticsByStructuresQuery, PaintRegionAnalyticsByStructuresQueryVariables>;
export const SyncAnalyticsDataDocument = gql`
    mutation SyncAnalyticsData($structureIds: [ID!]!, $platformId: ID!) {
  syncAnalyticsData(structureIds: $structureIds, platformId: $platformId) {
    success
    message
  }
}
    `;
export type SyncAnalyticsDataMutationFn = Apollo.MutationFunction<SyncAnalyticsDataMutation, SyncAnalyticsDataMutationVariables>;

/**
 * __useSyncAnalyticsDataMutation__
 *
 * To run a mutation, you first call `useSyncAnalyticsDataMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSyncAnalyticsDataMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [syncAnalyticsDataMutation, { data, loading, error }] = useSyncAnalyticsDataMutation({
 *   variables: {
 *      structureIds: // value for 'structureIds'
 *      platformId: // value for 'platformId'
 *   },
 * });
 */
export function useSyncAnalyticsDataMutation(baseOptions?: Apollo.MutationHookOptions<SyncAnalyticsDataMutation, SyncAnalyticsDataMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SyncAnalyticsDataMutation, SyncAnalyticsDataMutationVariables>(SyncAnalyticsDataDocument, options);
      }
export type SyncAnalyticsDataMutationHookResult = ReturnType<typeof useSyncAnalyticsDataMutation>;
export type SyncAnalyticsDataMutationResult = Apollo.MutationResult<SyncAnalyticsDataMutation>;
export type SyncAnalyticsDataMutationOptions = Apollo.BaseMutationOptions<SyncAnalyticsDataMutation, SyncAnalyticsDataMutationVariables>;
export const GetAllStructuresForSystemRequirementDocument = gql`
    query GetAllStructuresForSystemRequirement {
  allStructures {
    id
    name
    octreeResourcesPath
  }
}
    `;

/**
 * __useGetAllStructuresForSystemRequirementQuery__
 *
 * To run a query within a React component, call `useGetAllStructuresForSystemRequirementQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllStructuresForSystemRequirementQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllStructuresForSystemRequirementQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAllStructuresForSystemRequirementQuery(baseOptions?: Apollo.QueryHookOptions<GetAllStructuresForSystemRequirementQuery, GetAllStructuresForSystemRequirementQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllStructuresForSystemRequirementQuery, GetAllStructuresForSystemRequirementQueryVariables>(GetAllStructuresForSystemRequirementDocument, options);
      }
export function useGetAllStructuresForSystemRequirementLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllStructuresForSystemRequirementQuery, GetAllStructuresForSystemRequirementQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllStructuresForSystemRequirementQuery, GetAllStructuresForSystemRequirementQueryVariables>(GetAllStructuresForSystemRequirementDocument, options);
        }
// @ts-ignore
export function useGetAllStructuresForSystemRequirementSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetAllStructuresForSystemRequirementQuery, GetAllStructuresForSystemRequirementQueryVariables>): Apollo.UseSuspenseQueryResult<GetAllStructuresForSystemRequirementQuery, GetAllStructuresForSystemRequirementQueryVariables>;
export function useGetAllStructuresForSystemRequirementSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAllStructuresForSystemRequirementQuery, GetAllStructuresForSystemRequirementQueryVariables>): Apollo.UseSuspenseQueryResult<GetAllStructuresForSystemRequirementQuery | undefined, GetAllStructuresForSystemRequirementQueryVariables>;
export function useGetAllStructuresForSystemRequirementSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAllStructuresForSystemRequirementQuery, GetAllStructuresForSystemRequirementQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAllStructuresForSystemRequirementQuery, GetAllStructuresForSystemRequirementQueryVariables>(GetAllStructuresForSystemRequirementDocument, options);
        }
export type GetAllStructuresForSystemRequirementQueryHookResult = ReturnType<typeof useGetAllStructuresForSystemRequirementQuery>;
export type GetAllStructuresForSystemRequirementLazyQueryHookResult = ReturnType<typeof useGetAllStructuresForSystemRequirementLazyQuery>;
export type GetAllStructuresForSystemRequirementSuspenseQueryHookResult = ReturnType<typeof useGetAllStructuresForSystemRequirementSuspenseQuery>;
export type GetAllStructuresForSystemRequirementQueryResult = Apollo.QueryResult<GetAllStructuresForSystemRequirementQuery, GetAllStructuresForSystemRequirementQueryVariables>;
export const AllPointOfInterestTemplateDocument = gql`
    query AllPointOfInterestTemplate($structureId: ID, $assemblyTemplateId: ID!) {
  allPointOfInterestTemplate(
    structureId: $structureId
    assemblyTemplateId: $assemblyTemplateId
  ) {
    id
    name
    type
    key
    icon {
      name
      color
    }
    accentColor
    fields {
      options
      optionsData {
        value
        weight
        min
        max
        minIncluded
        maxIncluded
      }
      name
      type
      id
      key
      detailFieldKey
      isReadOnly
      isHidden
      defaultVisible
      serverSide
      isRequired
      isMeasurementToolEnabled
      displayInReview
      displayInReports
      displayConfig {
        id
        type
        isSortable
        sortType
        inputAdorment {
          iconPath
          iconType
          position
        }
        textAreaRows
        textFormat
      }
      unit
      shouldEvaluateLogic
      shouldEvaluateMath
      shouldEvaluateLogicPostCalculation
      logicRule {
        description
        evaluationStrategy
        conditionalMappings {
          value
          conditionTree {
            nodeType
            inputVariable
            operator
            value
            logicOperator
            conditions {
              nodeType
              inputVariable
              operator
              value
              logicOperator
              conditions {
                nodeType
                inputVariable
                operator
                value
                logicOperator
                conditions {
                  nodeType
                  inputVariable
                  operator
                  value
                  logicOperator
                }
              }
            }
          }
          combineOperator
        }
        defaultValue
        variables {
          name
          fieldKey
          templateType
          isBlisterField
        }
      }
      calculatedBy {
        description
        evaluationStrategy
        conditionalMappings {
          value
          conditionTree {
            nodeType
            inputVariable
            operator
            value
            logicOperator
            conditions {
              nodeType
              inputVariable
              operator
              value
              logicOperator
              conditions {
                nodeType
                inputVariable
                operator
                value
                logicOperator
                conditions {
                  nodeType
                  inputVariable
                  operator
                  value
                  logicOperator
                }
              }
            }
          }
          combineOperator
        }
        defaultValue
        variables {
          name
          fieldKey
          templateType
          isBlisterField
        }
      }
    }
    permissions
    markerLabelConfig {
      type
      hideName
      fields {
        key
        type
      }
      headerField {
        key
        type
      }
    }
    blisterFieldsConfig {
      estimatedHeight {
        name
        hidden
      }
      manualSetHeight {
        name
        hidden
      }
      blisterHeightIndex {
        name
        hidden
      }
      maxHeight {
        name
        hidden
      }
      wallLoss {
        name
        hidden
      }
      residualThickness {
        name
        hidden
      }
      residualCorrosionAllowance {
        name
        hidden
      }
      pdrHeight {
        name
        hidden
      }
      heightType {
        name
        hidden
      }
      verifiedMaxHeight {
        name
        hidden
      }
      verifiedResidualThickness {
        name
        hidden
      }
      verifiedResidualCorrosionAllowance {
        name
        hidden
      }
      measurementConfidence {
        name
        hidden
      }
      distanceConfidence {
        name
        hidden
      }
    }
  }
}
    `;

/**
 * __useAllPointOfInterestTemplateQuery__
 *
 * To run a query within a React component, call `useAllPointOfInterestTemplateQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllPointOfInterestTemplateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllPointOfInterestTemplateQuery({
 *   variables: {
 *      structureId: // value for 'structureId'
 *      assemblyTemplateId: // value for 'assemblyTemplateId'
 *   },
 * });
 */
export function useAllPointOfInterestTemplateQuery(baseOptions: Apollo.QueryHookOptions<AllPointOfInterestTemplateQuery, AllPointOfInterestTemplateQueryVariables> & ({ variables: AllPointOfInterestTemplateQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AllPointOfInterestTemplateQuery, AllPointOfInterestTemplateQueryVariables>(AllPointOfInterestTemplateDocument, options);
      }
export function useAllPointOfInterestTemplateLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AllPointOfInterestTemplateQuery, AllPointOfInterestTemplateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AllPointOfInterestTemplateQuery, AllPointOfInterestTemplateQueryVariables>(AllPointOfInterestTemplateDocument, options);
        }
// @ts-ignore
export function useAllPointOfInterestTemplateSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<AllPointOfInterestTemplateQuery, AllPointOfInterestTemplateQueryVariables>): Apollo.UseSuspenseQueryResult<AllPointOfInterestTemplateQuery, AllPointOfInterestTemplateQueryVariables>;
export function useAllPointOfInterestTemplateSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AllPointOfInterestTemplateQuery, AllPointOfInterestTemplateQueryVariables>): Apollo.UseSuspenseQueryResult<AllPointOfInterestTemplateQuery | undefined, AllPointOfInterestTemplateQueryVariables>;
export function useAllPointOfInterestTemplateSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AllPointOfInterestTemplateQuery, AllPointOfInterestTemplateQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AllPointOfInterestTemplateQuery, AllPointOfInterestTemplateQueryVariables>(AllPointOfInterestTemplateDocument, options);
        }
export type AllPointOfInterestTemplateQueryHookResult = ReturnType<typeof useAllPointOfInterestTemplateQuery>;
export type AllPointOfInterestTemplateLazyQueryHookResult = ReturnType<typeof useAllPointOfInterestTemplateLazyQuery>;
export type AllPointOfInterestTemplateSuspenseQueryHookResult = ReturnType<typeof useAllPointOfInterestTemplateSuspenseQuery>;
export type AllPointOfInterestTemplateQueryResult = Apollo.QueryResult<AllPointOfInterestTemplateQuery, AllPointOfInterestTemplateQueryVariables>;
export const GetPaintBlockRemediationScoreDocument = gql`
    query getPaintBlockRemediationScore($structureId: ID!, $type: TemplateTypeEnum!) {
  allTemplates(structureId: $structureId, type: $type) {
    id
    remediationScoreConfig {
      area {
        fields {
          fieldKey
          score
          threshold
        }
      }
      cof {
        fields {
          fieldKey
          optionScores
        }
      }
      poi {
        fields {
          poiScore
          poiTemplateKey
          subcategory {
            fieldKey
            optionScores
          }
        }
      }
    }
  }
}
    `;

/**
 * __useGetPaintBlockRemediationScoreQuery__
 *
 * To run a query within a React component, call `useGetPaintBlockRemediationScoreQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPaintBlockRemediationScoreQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPaintBlockRemediationScoreQuery({
 *   variables: {
 *      structureId: // value for 'structureId'
 *      type: // value for 'type'
 *   },
 * });
 */
export function useGetPaintBlockRemediationScoreQuery(baseOptions: Apollo.QueryHookOptions<GetPaintBlockRemediationScoreQuery, GetPaintBlockRemediationScoreQueryVariables> & ({ variables: GetPaintBlockRemediationScoreQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPaintBlockRemediationScoreQuery, GetPaintBlockRemediationScoreQueryVariables>(GetPaintBlockRemediationScoreDocument, options);
      }
export function useGetPaintBlockRemediationScoreLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPaintBlockRemediationScoreQuery, GetPaintBlockRemediationScoreQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPaintBlockRemediationScoreQuery, GetPaintBlockRemediationScoreQueryVariables>(GetPaintBlockRemediationScoreDocument, options);
        }
// @ts-ignore
export function useGetPaintBlockRemediationScoreSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetPaintBlockRemediationScoreQuery, GetPaintBlockRemediationScoreQueryVariables>): Apollo.UseSuspenseQueryResult<GetPaintBlockRemediationScoreQuery, GetPaintBlockRemediationScoreQueryVariables>;
export function useGetPaintBlockRemediationScoreSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPaintBlockRemediationScoreQuery, GetPaintBlockRemediationScoreQueryVariables>): Apollo.UseSuspenseQueryResult<GetPaintBlockRemediationScoreQuery | undefined, GetPaintBlockRemediationScoreQueryVariables>;
export function useGetPaintBlockRemediationScoreSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPaintBlockRemediationScoreQuery, GetPaintBlockRemediationScoreQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetPaintBlockRemediationScoreQuery, GetPaintBlockRemediationScoreQueryVariables>(GetPaintBlockRemediationScoreDocument, options);
        }
export type GetPaintBlockRemediationScoreQueryHookResult = ReturnType<typeof useGetPaintBlockRemediationScoreQuery>;
export type GetPaintBlockRemediationScoreLazyQueryHookResult = ReturnType<typeof useGetPaintBlockRemediationScoreLazyQuery>;
export type GetPaintBlockRemediationScoreSuspenseQueryHookResult = ReturnType<typeof useGetPaintBlockRemediationScoreSuspenseQuery>;
export type GetPaintBlockRemediationScoreQueryResult = Apollo.QueryResult<GetPaintBlockRemediationScoreQuery, GetPaintBlockRemediationScoreQueryVariables>;
export const GetAllStructuresListForTemplateBuilderDocument = gql`
    query getAllStructuresListForTemplateBuilder {
  allStructures {
    id
    name
    coverImagePath
  }
}
    `;

/**
 * __useGetAllStructuresListForTemplateBuilderQuery__
 *
 * To run a query within a React component, call `useGetAllStructuresListForTemplateBuilderQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllStructuresListForTemplateBuilderQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllStructuresListForTemplateBuilderQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAllStructuresListForTemplateBuilderQuery(baseOptions?: Apollo.QueryHookOptions<GetAllStructuresListForTemplateBuilderQuery, GetAllStructuresListForTemplateBuilderQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllStructuresListForTemplateBuilderQuery, GetAllStructuresListForTemplateBuilderQueryVariables>(GetAllStructuresListForTemplateBuilderDocument, options);
      }
export function useGetAllStructuresListForTemplateBuilderLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllStructuresListForTemplateBuilderQuery, GetAllStructuresListForTemplateBuilderQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllStructuresListForTemplateBuilderQuery, GetAllStructuresListForTemplateBuilderQueryVariables>(GetAllStructuresListForTemplateBuilderDocument, options);
        }
// @ts-ignore
export function useGetAllStructuresListForTemplateBuilderSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetAllStructuresListForTemplateBuilderQuery, GetAllStructuresListForTemplateBuilderQueryVariables>): Apollo.UseSuspenseQueryResult<GetAllStructuresListForTemplateBuilderQuery, GetAllStructuresListForTemplateBuilderQueryVariables>;
export function useGetAllStructuresListForTemplateBuilderSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAllStructuresListForTemplateBuilderQuery, GetAllStructuresListForTemplateBuilderQueryVariables>): Apollo.UseSuspenseQueryResult<GetAllStructuresListForTemplateBuilderQuery | undefined, GetAllStructuresListForTemplateBuilderQueryVariables>;
export function useGetAllStructuresListForTemplateBuilderSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAllStructuresListForTemplateBuilderQuery, GetAllStructuresListForTemplateBuilderQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAllStructuresListForTemplateBuilderQuery, GetAllStructuresListForTemplateBuilderQueryVariables>(GetAllStructuresListForTemplateBuilderDocument, options);
        }
export type GetAllStructuresListForTemplateBuilderQueryHookResult = ReturnType<typeof useGetAllStructuresListForTemplateBuilderQuery>;
export type GetAllStructuresListForTemplateBuilderLazyQueryHookResult = ReturnType<typeof useGetAllStructuresListForTemplateBuilderLazyQuery>;
export type GetAllStructuresListForTemplateBuilderSuspenseQueryHookResult = ReturnType<typeof useGetAllStructuresListForTemplateBuilderSuspenseQuery>;
export type GetAllStructuresListForTemplateBuilderQueryResult = Apollo.QueryResult<GetAllStructuresListForTemplateBuilderQuery, GetAllStructuresListForTemplateBuilderQueryVariables>;
export const StructureForTemplateBuilderDocument = gql`
    query StructureForTemplateBuilder($structureId: String!) {
  structure(structureId: $structureId) {
    id
    name
    status
  }
}
    `;

/**
 * __useStructureForTemplateBuilderQuery__
 *
 * To run a query within a React component, call `useStructureForTemplateBuilderQuery` and pass it any options that fit your needs.
 * When your component renders, `useStructureForTemplateBuilderQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStructureForTemplateBuilderQuery({
 *   variables: {
 *      structureId: // value for 'structureId'
 *   },
 * });
 */
export function useStructureForTemplateBuilderQuery(baseOptions: Apollo.QueryHookOptions<StructureForTemplateBuilderQuery, StructureForTemplateBuilderQueryVariables> & ({ variables: StructureForTemplateBuilderQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<StructureForTemplateBuilderQuery, StructureForTemplateBuilderQueryVariables>(StructureForTemplateBuilderDocument, options);
      }
export function useStructureForTemplateBuilderLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<StructureForTemplateBuilderQuery, StructureForTemplateBuilderQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<StructureForTemplateBuilderQuery, StructureForTemplateBuilderQueryVariables>(StructureForTemplateBuilderDocument, options);
        }
// @ts-ignore
export function useStructureForTemplateBuilderSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<StructureForTemplateBuilderQuery, StructureForTemplateBuilderQueryVariables>): Apollo.UseSuspenseQueryResult<StructureForTemplateBuilderQuery, StructureForTemplateBuilderQueryVariables>;
export function useStructureForTemplateBuilderSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<StructureForTemplateBuilderQuery, StructureForTemplateBuilderQueryVariables>): Apollo.UseSuspenseQueryResult<StructureForTemplateBuilderQuery | undefined, StructureForTemplateBuilderQueryVariables>;
export function useStructureForTemplateBuilderSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<StructureForTemplateBuilderQuery, StructureForTemplateBuilderQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<StructureForTemplateBuilderQuery, StructureForTemplateBuilderQueryVariables>(StructureForTemplateBuilderDocument, options);
        }
export type StructureForTemplateBuilderQueryHookResult = ReturnType<typeof useStructureForTemplateBuilderQuery>;
export type StructureForTemplateBuilderLazyQueryHookResult = ReturnType<typeof useStructureForTemplateBuilderLazyQuery>;
export type StructureForTemplateBuilderSuspenseQueryHookResult = ReturnType<typeof useStructureForTemplateBuilderSuspenseQuery>;
export type StructureForTemplateBuilderQueryResult = Apollo.QueryResult<StructureForTemplateBuilderQuery, StructureForTemplateBuilderQueryVariables>;
export const GetStructureDefectsDocument = gql`
    query getStructureDefects($structureId: String!) {
  structure(structureId: $structureId) {
    id
    defectLegends {
      id
      groupName
      groupKey
      name
      color
      octreeKey
      octreeValue
      legendText
    }
  }
}
    `;

/**
 * __useGetStructureDefectsQuery__
 *
 * To run a query within a React component, call `useGetStructureDefectsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetStructureDefectsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetStructureDefectsQuery({
 *   variables: {
 *      structureId: // value for 'structureId'
 *   },
 * });
 */
export function useGetStructureDefectsQuery(baseOptions: Apollo.QueryHookOptions<GetStructureDefectsQuery, GetStructureDefectsQueryVariables> & ({ variables: GetStructureDefectsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetStructureDefectsQuery, GetStructureDefectsQueryVariables>(GetStructureDefectsDocument, options);
      }
export function useGetStructureDefectsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetStructureDefectsQuery, GetStructureDefectsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetStructureDefectsQuery, GetStructureDefectsQueryVariables>(GetStructureDefectsDocument, options);
        }
// @ts-ignore
export function useGetStructureDefectsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetStructureDefectsQuery, GetStructureDefectsQueryVariables>): Apollo.UseSuspenseQueryResult<GetStructureDefectsQuery, GetStructureDefectsQueryVariables>;
export function useGetStructureDefectsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetStructureDefectsQuery, GetStructureDefectsQueryVariables>): Apollo.UseSuspenseQueryResult<GetStructureDefectsQuery | undefined, GetStructureDefectsQueryVariables>;
export function useGetStructureDefectsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetStructureDefectsQuery, GetStructureDefectsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetStructureDefectsQuery, GetStructureDefectsQueryVariables>(GetStructureDefectsDocument, options);
        }
export type GetStructureDefectsQueryHookResult = ReturnType<typeof useGetStructureDefectsQuery>;
export type GetStructureDefectsLazyQueryHookResult = ReturnType<typeof useGetStructureDefectsLazyQuery>;
export type GetStructureDefectsSuspenseQueryHookResult = ReturnType<typeof useGetStructureDefectsSuspenseQuery>;
export type GetStructureDefectsQueryResult = Apollo.QueryResult<GetStructureDefectsQuery, GetStructureDefectsQueryVariables>;
export const GetStructureDetailsDocument = gql`
    query getStructureDetails($structureId: String!) {
  structure(structureId: $structureId) {
    id
    name
    scanDate
    coverImagePath
    isActive
    isWallLossEnabled
    platform {
      id
      name
    }
    features
    hasRiskAssessment
    category
    reportConfig {
      title
      id
      configurations {
        id
        title
        key
      }
      poiReportOperationalTable {
        title
        fields {
          key
          title
          visibility
        }
      }
      reviewActionTableConfigs
      poiSummaryChartsConfig
      imageOrientationConfig {
        poiImages
        deckPlanImages
        poiReportPoiImages
        poiReportDeckImages
        componentReportPoiImages
        componentReportDeckImages
      }
      paintBlockReportPoiTemplateTypes
    }
    structurePipesConfig {
      imperialSteelPipes
    }
    fleetHealthTemplateField
    nominationConfig {
      poiTemplateNominationTypes
      nominationTableConfig {
        title
        columns {
          key
          displayName
        }
      }
    }
  }
}
    `;

/**
 * __useGetStructureDetailsQuery__
 *
 * To run a query within a React component, call `useGetStructureDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetStructureDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetStructureDetailsQuery({
 *   variables: {
 *      structureId: // value for 'structureId'
 *   },
 * });
 */
export function useGetStructureDetailsQuery(baseOptions: Apollo.QueryHookOptions<GetStructureDetailsQuery, GetStructureDetailsQueryVariables> & ({ variables: GetStructureDetailsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetStructureDetailsQuery, GetStructureDetailsQueryVariables>(GetStructureDetailsDocument, options);
      }
export function useGetStructureDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetStructureDetailsQuery, GetStructureDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetStructureDetailsQuery, GetStructureDetailsQueryVariables>(GetStructureDetailsDocument, options);
        }
// @ts-ignore
export function useGetStructureDetailsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetStructureDetailsQuery, GetStructureDetailsQueryVariables>): Apollo.UseSuspenseQueryResult<GetStructureDetailsQuery, GetStructureDetailsQueryVariables>;
export function useGetStructureDetailsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetStructureDetailsQuery, GetStructureDetailsQueryVariables>): Apollo.UseSuspenseQueryResult<GetStructureDetailsQuery | undefined, GetStructureDetailsQueryVariables>;
export function useGetStructureDetailsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetStructureDetailsQuery, GetStructureDetailsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetStructureDetailsQuery, GetStructureDetailsQueryVariables>(GetStructureDetailsDocument, options);
        }
export type GetStructureDetailsQueryHookResult = ReturnType<typeof useGetStructureDetailsQuery>;
export type GetStructureDetailsLazyQueryHookResult = ReturnType<typeof useGetStructureDetailsLazyQuery>;
export type GetStructureDetailsSuspenseQueryHookResult = ReturnType<typeof useGetStructureDetailsSuspenseQuery>;
export type GetStructureDetailsQueryResult = Apollo.QueryResult<GetStructureDetailsQuery, GetStructureDetailsQueryVariables>;
export const AllTemplatesForBuilderDocument = gql`
    query AllTemplatesForBuilder($type: TemplateTypeEnum, $structureId: ID) {
  allTemplates(type: $type, structureId: $structureId) {
    id
    name
    type
    reviewPanelConfig {
      groupKey
      groupName
      id
      groupSection {
        id
        title
        sectionKey
        fieldKeys
      }
    }
    fields {
      id
      name
      type
      options
      metaData
      optionsData {
        value
        weight
        min
        max
        minIncluded
        maxIncluded
      }
      isRequired
      isReadOnly
      serverSide
      displayConfig {
        id
        type
        isSortable
        sortType
        color {
          key
          value
        }
        inputAdorment {
          iconPath
          iconType
          position
        }
        textAreaRows
        textFormat
      }
      isHidden
      permission
      isRiskAssessment
      key
      displayInQuery
      displayInTable
      enableInlineEdit
      metaData
      displayInReview
      displayInReports
      displayInReportFilters
      displayInRisk
      defaultVisible
      unit
      roundToDecimal
      isEditable
      editRoles
      dependencyMapping
      displayUnit
      shouldEvaluateLogic
      shouldEvaluateMath
      shouldEvaluateLogicPostCalculation
      logicRule {
        description
        evaluationStrategy
        conditionalMappings {
          value
          conditionTree {
            nodeType
            inputVariable
            operator
            value
            logicOperator
            conditions {
              nodeType
              inputVariable
              operator
              value
              logicOperator
              conditions {
                nodeType
                inputVariable
                operator
                value
                logicOperator
                conditions {
                  nodeType
                  inputVariable
                  operator
                  value
                  logicOperator
                }
              }
            }
          }
          combineOperator
        }
        defaultValue
        variables {
          name
          fieldKey
          templateType
          isBlisterField
        }
      }
      calculatedBy {
        description
        evaluationStrategy
        conditionalMappings {
          value
          conditionTree {
            nodeType
            inputVariable
            operator
            value
            logicOperator
            conditions {
              nodeType
              inputVariable
              operator
              value
              logicOperator
              conditions {
                nodeType
                inputVariable
                operator
                value
                logicOperator
                conditions {
                  nodeType
                  inputVariable
                  operator
                  value
                  logicOperator
                }
              }
            }
          }
          combineOperator
        }
        defaultValue
        variables {
          name
          fieldKey
          templateType
          isBlisterField
        }
      }
    }
    reviewActionChecklistConfig {
      id
      reviewActionValue
      displayName
      isEnabled
      position
    }
    equations {
      key
      name
      expression {
        type
        value
        variable
        operator
        args {
          type
          value
          variable
          operator
          args {
            type
            value
            variable
            operator
            args {
              type
              value
              variable
              operator
            }
          }
        }
      }
      variables {
        name
        fieldKey
        templateType
        isBlisterField
      }
    }
    equipmentDetails {
      id
      name
      type
      subType
      options {
        id
        name
        type
        fieldKey
      }
      isRequired
      isReadOnly
      serverSide
      displayConfig {
        id
        type
        isSortable
        sortType
        inputAdorment {
          iconPath
          iconType
          position
        }
        textAreaRows
        textFormat
        color {
          key
          value
        }
      }
      isHidden
      fieldKey
    }
    icon {
      name
      color
    }
    defectsArray
    equipmentCard {
      id
      name
      type
      fieldKey
      position
      location
    }
    permissions
    riskFields {
      id
      fieldKey
      type
      isHiddenColumn
    }
    recommendation {
      header
      details {
        id
        fieldKey
      }
    }
    querySummary {
      id
      name
      key
      operation
      matchCondition
      displayType
      rowOrder
      displayConfig {
        fieldValue
        color
      }
      collectionName
      sortType
      sortDirection
    }
    materialType {
      type
      thickness
      environmentalClassification {
        name
        values
      }
      corrosivityCategory {
        name
        values
      }
      environmentalExposure {
        name
        timeToVisibility
        code
      }
    }
  }
}
    `;

/**
 * __useAllTemplatesForBuilderQuery__
 *
 * To run a query within a React component, call `useAllTemplatesForBuilderQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllTemplatesForBuilderQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllTemplatesForBuilderQuery({
 *   variables: {
 *      type: // value for 'type'
 *      structureId: // value for 'structureId'
 *   },
 * });
 */
export function useAllTemplatesForBuilderQuery(baseOptions?: Apollo.QueryHookOptions<AllTemplatesForBuilderQuery, AllTemplatesForBuilderQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AllTemplatesForBuilderQuery, AllTemplatesForBuilderQueryVariables>(AllTemplatesForBuilderDocument, options);
      }
export function useAllTemplatesForBuilderLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AllTemplatesForBuilderQuery, AllTemplatesForBuilderQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AllTemplatesForBuilderQuery, AllTemplatesForBuilderQueryVariables>(AllTemplatesForBuilderDocument, options);
        }
// @ts-ignore
export function useAllTemplatesForBuilderSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<AllTemplatesForBuilderQuery, AllTemplatesForBuilderQueryVariables>): Apollo.UseSuspenseQueryResult<AllTemplatesForBuilderQuery, AllTemplatesForBuilderQueryVariables>;
export function useAllTemplatesForBuilderSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AllTemplatesForBuilderQuery, AllTemplatesForBuilderQueryVariables>): Apollo.UseSuspenseQueryResult<AllTemplatesForBuilderQuery | undefined, AllTemplatesForBuilderQueryVariables>;
export function useAllTemplatesForBuilderSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AllTemplatesForBuilderQuery, AllTemplatesForBuilderQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AllTemplatesForBuilderQuery, AllTemplatesForBuilderQueryVariables>(AllTemplatesForBuilderDocument, options);
        }
export type AllTemplatesForBuilderQueryHookResult = ReturnType<typeof useAllTemplatesForBuilderQuery>;
export type AllTemplatesForBuilderLazyQueryHookResult = ReturnType<typeof useAllTemplatesForBuilderLazyQuery>;
export type AllTemplatesForBuilderSuspenseQueryHookResult = ReturnType<typeof useAllTemplatesForBuilderSuspenseQuery>;
export type AllTemplatesForBuilderQueryResult = Apollo.QueryResult<AllTemplatesForBuilderQuery, AllTemplatesForBuilderQueryVariables>;
export const AllPlatformsForTemplateBuilderDocument = gql`
    query AllPlatformsForTemplateBuilder {
  allPlatforms {
    name
    id
  }
}
    `;

/**
 * __useAllPlatformsForTemplateBuilderQuery__
 *
 * To run a query within a React component, call `useAllPlatformsForTemplateBuilderQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllPlatformsForTemplateBuilderQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllPlatformsForTemplateBuilderQuery({
 *   variables: {
 *   },
 * });
 */
export function useAllPlatformsForTemplateBuilderQuery(baseOptions?: Apollo.QueryHookOptions<AllPlatformsForTemplateBuilderQuery, AllPlatformsForTemplateBuilderQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AllPlatformsForTemplateBuilderQuery, AllPlatformsForTemplateBuilderQueryVariables>(AllPlatformsForTemplateBuilderDocument, options);
      }
export function useAllPlatformsForTemplateBuilderLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AllPlatformsForTemplateBuilderQuery, AllPlatformsForTemplateBuilderQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AllPlatformsForTemplateBuilderQuery, AllPlatformsForTemplateBuilderQueryVariables>(AllPlatformsForTemplateBuilderDocument, options);
        }
// @ts-ignore
export function useAllPlatformsForTemplateBuilderSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<AllPlatformsForTemplateBuilderQuery, AllPlatformsForTemplateBuilderQueryVariables>): Apollo.UseSuspenseQueryResult<AllPlatformsForTemplateBuilderQuery, AllPlatformsForTemplateBuilderQueryVariables>;
export function useAllPlatformsForTemplateBuilderSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AllPlatformsForTemplateBuilderQuery, AllPlatformsForTemplateBuilderQueryVariables>): Apollo.UseSuspenseQueryResult<AllPlatformsForTemplateBuilderQuery | undefined, AllPlatformsForTemplateBuilderQueryVariables>;
export function useAllPlatformsForTemplateBuilderSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AllPlatformsForTemplateBuilderQuery, AllPlatformsForTemplateBuilderQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AllPlatformsForTemplateBuilderQuery, AllPlatformsForTemplateBuilderQueryVariables>(AllPlatformsForTemplateBuilderDocument, options);
        }
export type AllPlatformsForTemplateBuilderQueryHookResult = ReturnType<typeof useAllPlatformsForTemplateBuilderQuery>;
export type AllPlatformsForTemplateBuilderLazyQueryHookResult = ReturnType<typeof useAllPlatformsForTemplateBuilderLazyQuery>;
export type AllPlatformsForTemplateBuilderSuspenseQueryHookResult = ReturnType<typeof useAllPlatformsForTemplateBuilderSuspenseQuery>;
export type AllPlatformsForTemplateBuilderQueryResult = Apollo.QueryResult<AllPlatformsForTemplateBuilderQuery, AllPlatformsForTemplateBuilderQueryVariables>;
export const GetAllPoiIconsForTemplateBuilderDocument = gql`
    query GetAllPoiIconsForTemplateBuilder {
  getAllPoiIcons
}
    `;

/**
 * __useGetAllPoiIconsForTemplateBuilderQuery__
 *
 * To run a query within a React component, call `useGetAllPoiIconsForTemplateBuilderQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllPoiIconsForTemplateBuilderQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllPoiIconsForTemplateBuilderQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAllPoiIconsForTemplateBuilderQuery(baseOptions?: Apollo.QueryHookOptions<GetAllPoiIconsForTemplateBuilderQuery, GetAllPoiIconsForTemplateBuilderQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllPoiIconsForTemplateBuilderQuery, GetAllPoiIconsForTemplateBuilderQueryVariables>(GetAllPoiIconsForTemplateBuilderDocument, options);
      }
export function useGetAllPoiIconsForTemplateBuilderLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllPoiIconsForTemplateBuilderQuery, GetAllPoiIconsForTemplateBuilderQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllPoiIconsForTemplateBuilderQuery, GetAllPoiIconsForTemplateBuilderQueryVariables>(GetAllPoiIconsForTemplateBuilderDocument, options);
        }
// @ts-ignore
export function useGetAllPoiIconsForTemplateBuilderSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetAllPoiIconsForTemplateBuilderQuery, GetAllPoiIconsForTemplateBuilderQueryVariables>): Apollo.UseSuspenseQueryResult<GetAllPoiIconsForTemplateBuilderQuery, GetAllPoiIconsForTemplateBuilderQueryVariables>;
export function useGetAllPoiIconsForTemplateBuilderSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAllPoiIconsForTemplateBuilderQuery, GetAllPoiIconsForTemplateBuilderQueryVariables>): Apollo.UseSuspenseQueryResult<GetAllPoiIconsForTemplateBuilderQuery | undefined, GetAllPoiIconsForTemplateBuilderQueryVariables>;
export function useGetAllPoiIconsForTemplateBuilderSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAllPoiIconsForTemplateBuilderQuery, GetAllPoiIconsForTemplateBuilderQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAllPoiIconsForTemplateBuilderQuery, GetAllPoiIconsForTemplateBuilderQueryVariables>(GetAllPoiIconsForTemplateBuilderDocument, options);
        }
export type GetAllPoiIconsForTemplateBuilderQueryHookResult = ReturnType<typeof useGetAllPoiIconsForTemplateBuilderQuery>;
export type GetAllPoiIconsForTemplateBuilderLazyQueryHookResult = ReturnType<typeof useGetAllPoiIconsForTemplateBuilderLazyQuery>;
export type GetAllPoiIconsForTemplateBuilderSuspenseQueryHookResult = ReturnType<typeof useGetAllPoiIconsForTemplateBuilderSuspenseQuery>;
export type GetAllPoiIconsForTemplateBuilderQueryResult = Apollo.QueryResult<GetAllPoiIconsForTemplateBuilderQuery, GetAllPoiIconsForTemplateBuilderQueryVariables>;
export const UpdatePointOfInterestTemplateDocument = gql`
    mutation UpdatePointOfInterestTemplate($input: UpdatePointOfInterestTemplateInput) {
  updatePointOfInterestTemplate(input: $input) {
    id
    name
    fields {
      options
      name
      type
      id
      isReadOnly
      isHidden
      defaultVisible
      serverSide
      isRequired
      displayInReview
      displayInReports
      displayConfig {
        id
        type
        isSortable
        sortType
        inputAdorment {
          iconPath
          iconType
          position
        }
        textAreaRows
      }
      unit
      shouldEvaluateLogic
      shouldEvaluateMath
      shouldEvaluateLogicPostCalculation
      logicRule {
        description
        evaluationStrategy
        conditionalMappings {
          value
          conditionTree {
            nodeType
            inputVariable
            operator
            value
            logicOperator
            conditions {
              nodeType
              inputVariable
              operator
              value
              logicOperator
              conditions {
                nodeType
                inputVariable
                operator
                value
                logicOperator
                conditions {
                  nodeType
                  inputVariable
                  operator
                  value
                  logicOperator
                }
              }
            }
          }
          combineOperator
        }
        defaultValue
        variables {
          name
          fieldKey
          templateType
          isBlisterField
        }
      }
      calculatedBy {
        description
        evaluationStrategy
        conditionalMappings {
          value
          conditionTree {
            nodeType
            inputVariable
            operator
            value
            logicOperator
            conditions {
              nodeType
              inputVariable
              operator
              value
              logicOperator
              conditions {
                nodeType
                inputVariable
                operator
                value
                logicOperator
                conditions {
                  nodeType
                  inputVariable
                  operator
                  value
                  logicOperator
                }
              }
            }
          }
          combineOperator
        }
        defaultValue
        variables {
          name
          fieldKey
          templateType
          isBlisterField
        }
      }
    }
  }
}
    `;
export type UpdatePointOfInterestTemplateMutationFn = Apollo.MutationFunction<UpdatePointOfInterestTemplateMutation, UpdatePointOfInterestTemplateMutationVariables>;

/**
 * __useUpdatePointOfInterestTemplateMutation__
 *
 * To run a mutation, you first call `useUpdatePointOfInterestTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePointOfInterestTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePointOfInterestTemplateMutation, { data, loading, error }] = useUpdatePointOfInterestTemplateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdatePointOfInterestTemplateMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePointOfInterestTemplateMutation, UpdatePointOfInterestTemplateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePointOfInterestTemplateMutation, UpdatePointOfInterestTemplateMutationVariables>(UpdatePointOfInterestTemplateDocument, options);
      }
export type UpdatePointOfInterestTemplateMutationHookResult = ReturnType<typeof useUpdatePointOfInterestTemplateMutation>;
export type UpdatePointOfInterestTemplateMutationResult = Apollo.MutationResult<UpdatePointOfInterestTemplateMutation>;
export type UpdatePointOfInterestTemplateMutationOptions = Apollo.BaseMutationOptions<UpdatePointOfInterestTemplateMutation, UpdatePointOfInterestTemplateMutationVariables>;
export const CreatePointOfInterestTemplateDocument = gql`
    mutation CreatePointOfInterestTemplate($input: PointOfInterestTemplateInput) {
  createPointOfInterestTemplate(input: $input) {
    id
    name
    fields {
      options
      name
      type
      id
      key
      isReadOnly
      isHidden
      defaultVisible
      serverSide
      isRequired
      displayInReview
      displayInReports
      displayConfig {
        id
        type
        isSortable
        sortType
        inputAdorment {
          iconPath
          iconType
          position
        }
        textAreaRows
      }
      unit
      shouldEvaluateLogic
      shouldEvaluateMath
      shouldEvaluateLogicPostCalculation
      logicRule {
        description
        evaluationStrategy
        conditionalMappings {
          value
          conditionTree {
            nodeType
            inputVariable
            operator
            value
            logicOperator
            conditions {
              nodeType
              inputVariable
              operator
              value
              logicOperator
              conditions {
                nodeType
                inputVariable
                operator
                value
                logicOperator
                conditions {
                  nodeType
                  inputVariable
                  operator
                  value
                  logicOperator
                }
              }
            }
          }
          combineOperator
        }
        defaultValue
        variables {
          name
          fieldKey
          templateType
          isBlisterField
        }
      }
      calculatedBy {
        description
        evaluationStrategy
        conditionalMappings {
          value
          conditionTree {
            nodeType
            inputVariable
            operator
            value
            logicOperator
            conditions {
              nodeType
              inputVariable
              operator
              value
              logicOperator
              conditions {
                nodeType
                inputVariable
                operator
                value
                logicOperator
                conditions {
                  nodeType
                  inputVariable
                  operator
                  value
                  logicOperator
                }
              }
            }
          }
          combineOperator
        }
        defaultValue
        variables {
          name
          fieldKey
          templateType
          isBlisterField
        }
      }
    }
  }
}
    `;
export type CreatePointOfInterestTemplateMutationFn = Apollo.MutationFunction<CreatePointOfInterestTemplateMutation, CreatePointOfInterestTemplateMutationVariables>;

/**
 * __useCreatePointOfInterestTemplateMutation__
 *
 * To run a mutation, you first call `useCreatePointOfInterestTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePointOfInterestTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPointOfInterestTemplateMutation, { data, loading, error }] = useCreatePointOfInterestTemplateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreatePointOfInterestTemplateMutation(baseOptions?: Apollo.MutationHookOptions<CreatePointOfInterestTemplateMutation, CreatePointOfInterestTemplateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreatePointOfInterestTemplateMutation, CreatePointOfInterestTemplateMutationVariables>(CreatePointOfInterestTemplateDocument, options);
      }
export type CreatePointOfInterestTemplateMutationHookResult = ReturnType<typeof useCreatePointOfInterestTemplateMutation>;
export type CreatePointOfInterestTemplateMutationResult = Apollo.MutationResult<CreatePointOfInterestTemplateMutation>;
export type CreatePointOfInterestTemplateMutationOptions = Apollo.BaseMutationOptions<CreatePointOfInterestTemplateMutation, CreatePointOfInterestTemplateMutationVariables>;
export const PointOfInterestTemplateDocument = gql`
    query PointOfInterestTemplate($pointOfInterestTemplateId: ID) {
  pointOfInterestTemplate(pointOfInterestTemplateId: $pointOfInterestTemplateId) {
    id
    name
    accentColor
    createdBy
    icon {
      color
      name
    }
    fields {
      id
      name
      type
      options
      isRequired
      isReadOnly
      serverSide
      displayInReview
      displayInReports
      displayConfig {
        id
        type
        color {
          key
          value
        }
        inputAdorment {
          position
          iconPath
          iconType
        }
        textAreaRows
        isSortable
        sortType
      }
      isHidden
      permission
      defaultVisible
      unit
      key
      shouldEvaluateLogic
      shouldEvaluateMath
      shouldEvaluateLogicPostCalculation
      logicRule {
        description
        evaluationStrategy
        conditionalMappings {
          value
          conditionTree {
            nodeType
            inputVariable
            operator
            value
            logicOperator
            conditions {
              nodeType
              inputVariable
              operator
              value
              logicOperator
              conditions {
                nodeType
                inputVariable
                operator
                value
                logicOperator
                conditions {
                  nodeType
                  inputVariable
                  operator
                  value
                  logicOperator
                }
              }
            }
          }
          combineOperator
        }
        defaultValue
        variables {
          name
          fieldKey
          templateType
          isBlisterField
        }
      }
      calculatedBy {
        description
        evaluationStrategy
        conditionalMappings {
          value
          conditionTree {
            nodeType
            inputVariable
            operator
            value
            logicOperator
            conditions {
              nodeType
              inputVariable
              operator
              value
              logicOperator
              conditions {
                nodeType
                inputVariable
                operator
                value
                logicOperator
                conditions {
                  nodeType
                  inputVariable
                  operator
                  value
                  logicOperator
                }
              }
            }
          }
          combineOperator
        }
        defaultValue
        variables {
          name
          fieldKey
          templateType
          isBlisterField
        }
      }
    }
    permissions
    accentColor
    blisterFieldsConfig {
      estimatedHeight {
        name
        hidden
      }
      manualSetHeight {
        name
        hidden
      }
      blisterHeightIndex {
        name
        hidden
      }
      maxHeight {
        name
        hidden
      }
      wallLoss {
        name
        hidden
      }
      residualThickness {
        name
        hidden
      }
      residualCorrosionAllowance {
        name
        hidden
      }
      pdrHeight {
        name
        hidden
      }
      heightType {
        name
        hidden
      }
      verifiedMaxHeight {
        name
        hidden
      }
      verifiedResidualThickness {
        name
        hidden
      }
      verifiedResidualCorrosionAllowance {
        name
        hidden
      }
      measurementConfidence {
        name
        hidden
      }
      distanceConfidence {
        name
        hidden
      }
    }
  }
}
    `;

/**
 * __usePointOfInterestTemplateQuery__
 *
 * To run a query within a React component, call `usePointOfInterestTemplateQuery` and pass it any options that fit your needs.
 * When your component renders, `usePointOfInterestTemplateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePointOfInterestTemplateQuery({
 *   variables: {
 *      pointOfInterestTemplateId: // value for 'pointOfInterestTemplateId'
 *   },
 * });
 */
export function usePointOfInterestTemplateQuery(baseOptions?: Apollo.QueryHookOptions<PointOfInterestTemplateQuery, PointOfInterestTemplateQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PointOfInterestTemplateQuery, PointOfInterestTemplateQueryVariables>(PointOfInterestTemplateDocument, options);
      }
export function usePointOfInterestTemplateLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PointOfInterestTemplateQuery, PointOfInterestTemplateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PointOfInterestTemplateQuery, PointOfInterestTemplateQueryVariables>(PointOfInterestTemplateDocument, options);
        }
// @ts-ignore
export function usePointOfInterestTemplateSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<PointOfInterestTemplateQuery, PointOfInterestTemplateQueryVariables>): Apollo.UseSuspenseQueryResult<PointOfInterestTemplateQuery, PointOfInterestTemplateQueryVariables>;
export function usePointOfInterestTemplateSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PointOfInterestTemplateQuery, PointOfInterestTemplateQueryVariables>): Apollo.UseSuspenseQueryResult<PointOfInterestTemplateQuery | undefined, PointOfInterestTemplateQueryVariables>;
export function usePointOfInterestTemplateSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PointOfInterestTemplateQuery, PointOfInterestTemplateQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PointOfInterestTemplateQuery, PointOfInterestTemplateQueryVariables>(PointOfInterestTemplateDocument, options);
        }
export type PointOfInterestTemplateQueryHookResult = ReturnType<typeof usePointOfInterestTemplateQuery>;
export type PointOfInterestTemplateLazyQueryHookResult = ReturnType<typeof usePointOfInterestTemplateLazyQuery>;
export type PointOfInterestTemplateSuspenseQueryHookResult = ReturnType<typeof usePointOfInterestTemplateSuspenseQuery>;
export type PointOfInterestTemplateQueryResult = Apollo.QueryResult<PointOfInterestTemplateQuery, PointOfInterestTemplateQueryVariables>;
export const GetAllRolesDocument = gql`
    query GetAllRoles {
  allRoles {
    id
    name
  }
}
    `;

/**
 * __useGetAllRolesQuery__
 *
 * To run a query within a React component, call `useGetAllRolesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllRolesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllRolesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAllRolesQuery(baseOptions?: Apollo.QueryHookOptions<GetAllRolesQuery, GetAllRolesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllRolesQuery, GetAllRolesQueryVariables>(GetAllRolesDocument, options);
      }
export function useGetAllRolesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllRolesQuery, GetAllRolesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllRolesQuery, GetAllRolesQueryVariables>(GetAllRolesDocument, options);
        }
// @ts-ignore
export function useGetAllRolesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetAllRolesQuery, GetAllRolesQueryVariables>): Apollo.UseSuspenseQueryResult<GetAllRolesQuery, GetAllRolesQueryVariables>;
export function useGetAllRolesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAllRolesQuery, GetAllRolesQueryVariables>): Apollo.UseSuspenseQueryResult<GetAllRolesQuery | undefined, GetAllRolesQueryVariables>;
export function useGetAllRolesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAllRolesQuery, GetAllRolesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAllRolesQuery, GetAllRolesQueryVariables>(GetAllRolesDocument, options);
        }
export type GetAllRolesQueryHookResult = ReturnType<typeof useGetAllRolesQuery>;
export type GetAllRolesLazyQueryHookResult = ReturnType<typeof useGetAllRolesLazyQuery>;
export type GetAllRolesSuspenseQueryHookResult = ReturnType<typeof useGetAllRolesSuspenseQuery>;
export type GetAllRolesQueryResult = Apollo.QueryResult<GetAllRolesQuery, GetAllRolesQueryVariables>;
export const ClonePointOfInterestTemplateDocument = gql`
    mutation ClonePointOfInterestTemplate($input: PoiTemplateCloneInput) {
  clonePointOfInterestTemplate(input: $input) {
    id
    name
  }
}
    `;
export type ClonePointOfInterestTemplateMutationFn = Apollo.MutationFunction<ClonePointOfInterestTemplateMutation, ClonePointOfInterestTemplateMutationVariables>;

/**
 * __useClonePointOfInterestTemplateMutation__
 *
 * To run a mutation, you first call `useClonePointOfInterestTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useClonePointOfInterestTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [clonePointOfInterestTemplateMutation, { data, loading, error }] = useClonePointOfInterestTemplateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useClonePointOfInterestTemplateMutation(baseOptions?: Apollo.MutationHookOptions<ClonePointOfInterestTemplateMutation, ClonePointOfInterestTemplateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ClonePointOfInterestTemplateMutation, ClonePointOfInterestTemplateMutationVariables>(ClonePointOfInterestTemplateDocument, options);
      }
export type ClonePointOfInterestTemplateMutationHookResult = ReturnType<typeof useClonePointOfInterestTemplateMutation>;
export type ClonePointOfInterestTemplateMutationResult = Apollo.MutationResult<ClonePointOfInterestTemplateMutation>;
export type ClonePointOfInterestTemplateMutationOptions = Apollo.BaseMutationOptions<ClonePointOfInterestTemplateMutation, ClonePointOfInterestTemplateMutationVariables>;
export const UpdateStructureDocument = gql`
    mutation UpdateStructure($input: UpdateStructureInput) {
  updateStructure(input: $input) {
    id
    name
    status
    isActive
    deploymentLevel
    scanDate
    isWallLossEnabled
    category
    defectLegends {
      id
      groupName
      groupKey
      name
      color
      octreeKey
      octreeValue
      legendText
    }
    fleetHealthTemplateField
    nominationConfig {
      poiTemplateNominationTypes
      nominationTableConfig {
        title
        columns {
          key
          displayName
        }
      }
    }
  }
}
    `;
export type UpdateStructureMutationFn = Apollo.MutationFunction<UpdateStructureMutation, UpdateStructureMutationVariables>;

/**
 * __useUpdateStructureMutation__
 *
 * To run a mutation, you first call `useUpdateStructureMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateStructureMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateStructureMutation, { data, loading, error }] = useUpdateStructureMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateStructureMutation(baseOptions?: Apollo.MutationHookOptions<UpdateStructureMutation, UpdateStructureMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateStructureMutation, UpdateStructureMutationVariables>(UpdateStructureDocument, options);
      }
export type UpdateStructureMutationHookResult = ReturnType<typeof useUpdateStructureMutation>;
export type UpdateStructureMutationResult = Apollo.MutationResult<UpdateStructureMutation>;
export type UpdateStructureMutationOptions = Apollo.BaseMutationOptions<UpdateStructureMutation, UpdateStructureMutationVariables>;
export const DeletePointOfInterestTemplateDocument = gql`
    mutation DeletePointOfInterestTemplate($templateId: String!) {
  deletePointOfInterestTemplate(templateId: $templateId) {
    id
  }
}
    `;
export type DeletePointOfInterestTemplateMutationFn = Apollo.MutationFunction<DeletePointOfInterestTemplateMutation, DeletePointOfInterestTemplateMutationVariables>;

/**
 * __useDeletePointOfInterestTemplateMutation__
 *
 * To run a mutation, you first call `useDeletePointOfInterestTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeletePointOfInterestTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deletePointOfInterestTemplateMutation, { data, loading, error }] = useDeletePointOfInterestTemplateMutation({
 *   variables: {
 *      templateId: // value for 'templateId'
 *   },
 * });
 */
export function useDeletePointOfInterestTemplateMutation(baseOptions?: Apollo.MutationHookOptions<DeletePointOfInterestTemplateMutation, DeletePointOfInterestTemplateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeletePointOfInterestTemplateMutation, DeletePointOfInterestTemplateMutationVariables>(DeletePointOfInterestTemplateDocument, options);
      }
export type DeletePointOfInterestTemplateMutationHookResult = ReturnType<typeof useDeletePointOfInterestTemplateMutation>;
export type DeletePointOfInterestTemplateMutationResult = Apollo.MutationResult<DeletePointOfInterestTemplateMutation>;
export type DeletePointOfInterestTemplateMutationOptions = Apollo.BaseMutationOptions<DeletePointOfInterestTemplateMutation, DeletePointOfInterestTemplateMutationVariables>;
export const UpdateTemplateDocument = gql`
    mutation UpdateTemplate($input: TemplateInput) {
  updateTemplate(input: $input) {
    id
    fields {
      id
      name
      key
      type
      shouldEvaluateLogic
      shouldEvaluateMath
      shouldEvaluateLogicPostCalculation
      logicRule {
        description
        evaluationStrategy
        conditionalMappings {
          value
          conditionTree {
            nodeType
            inputVariable
            operator
            value
            logicOperator
            conditions {
              nodeType
              inputVariable
              operator
              value
              logicOperator
              conditions {
                nodeType
                inputVariable
                operator
                value
                logicOperator
                conditions {
                  nodeType
                  inputVariable
                  operator
                  value
                  logicOperator
                }
              }
            }
          }
          combineOperator
        }
        defaultValue
        variables {
          name
          fieldKey
          templateType
          isBlisterField
        }
      }
      calculatedBy {
        description
        evaluationStrategy
        conditionalMappings {
          value
          conditionTree {
            nodeType
            inputVariable
            operator
            value
            logicOperator
            conditions {
              nodeType
              inputVariable
              operator
              value
              logicOperator
              conditions {
                nodeType
                inputVariable
                operator
                value
                logicOperator
                conditions {
                  nodeType
                  inputVariable
                  operator
                  value
                  logicOperator
                }
              }
            }
          }
          combineOperator
        }
        defaultValue
        variables {
          name
          fieldKey
          templateType
          isBlisterField
        }
      }
    }
  }
}
    `;
export type UpdateTemplateMutationFn = Apollo.MutationFunction<UpdateTemplateMutation, UpdateTemplateMutationVariables>;

/**
 * __useUpdateTemplateMutation__
 *
 * To run a mutation, you first call `useUpdateTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTemplateMutation, { data, loading, error }] = useUpdateTemplateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateTemplateMutation(baseOptions?: Apollo.MutationHookOptions<UpdateTemplateMutation, UpdateTemplateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateTemplateMutation, UpdateTemplateMutationVariables>(UpdateTemplateDocument, options);
      }
export type UpdateTemplateMutationHookResult = ReturnType<typeof useUpdateTemplateMutation>;
export type UpdateTemplateMutationResult = Apollo.MutationResult<UpdateTemplateMutation>;
export type UpdateTemplateMutationOptions = Apollo.BaseMutationOptions<UpdateTemplateMutation, UpdateTemplateMutationVariables>;
export const CloneTemplateFieldsDocument = gql`
    mutation CloneTemplateFields($input: TemplateFieldsCloneInput) {
  cloneTemplateFields(input: $input) {
    fields {
      name
      id
    }
  }
}
    `;
export type CloneTemplateFieldsMutationFn = Apollo.MutationFunction<CloneTemplateFieldsMutation, CloneTemplateFieldsMutationVariables>;

/**
 * __useCloneTemplateFieldsMutation__
 *
 * To run a mutation, you first call `useCloneTemplateFieldsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCloneTemplateFieldsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cloneTemplateFieldsMutation, { data, loading, error }] = useCloneTemplateFieldsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCloneTemplateFieldsMutation(baseOptions?: Apollo.MutationHookOptions<CloneTemplateFieldsMutation, CloneTemplateFieldsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CloneTemplateFieldsMutation, CloneTemplateFieldsMutationVariables>(CloneTemplateFieldsDocument, options);
      }
export type CloneTemplateFieldsMutationHookResult = ReturnType<typeof useCloneTemplateFieldsMutation>;
export type CloneTemplateFieldsMutationResult = Apollo.MutationResult<CloneTemplateFieldsMutation>;
export type CloneTemplateFieldsMutationOptions = Apollo.BaseMutationOptions<CloneTemplateFieldsMutation, CloneTemplateFieldsMutationVariables>;
export const CloneQuerySummaryDocument = gql`
    mutation CloneQuerySummary($input: QuerySummaryCloneInput) {
  cloneQuerySummary(input: $input) {
    querySummary {
      id
      name
    }
  }
}
    `;
export type CloneQuerySummaryMutationFn = Apollo.MutationFunction<CloneQuerySummaryMutation, CloneQuerySummaryMutationVariables>;

/**
 * __useCloneQuerySummaryMutation__
 *
 * To run a mutation, you first call `useCloneQuerySummaryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCloneQuerySummaryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cloneQuerySummaryMutation, { data, loading, error }] = useCloneQuerySummaryMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCloneQuerySummaryMutation(baseOptions?: Apollo.MutationHookOptions<CloneQuerySummaryMutation, CloneQuerySummaryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CloneQuerySummaryMutation, CloneQuerySummaryMutationVariables>(CloneQuerySummaryDocument, options);
      }
export type CloneQuerySummaryMutationHookResult = ReturnType<typeof useCloneQuerySummaryMutation>;
export type CloneQuerySummaryMutationResult = Apollo.MutationResult<CloneQuerySummaryMutation>;
export type CloneQuerySummaryMutationOptions = Apollo.BaseMutationOptions<CloneQuerySummaryMutation, CloneQuerySummaryMutationVariables>;
export const AddMiServicesFieldsDocument = gql`
    mutation AddMiServicesFields($input: MiServicesInput) {
  addMiServicesFields(input: $input) {
    fields {
      id
      name
      key
    }
  }
}
    `;
export type AddMiServicesFieldsMutationFn = Apollo.MutationFunction<AddMiServicesFieldsMutation, AddMiServicesFieldsMutationVariables>;

/**
 * __useAddMiServicesFieldsMutation__
 *
 * To run a mutation, you first call `useAddMiServicesFieldsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddMiServicesFieldsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addMiServicesFieldsMutation, { data, loading, error }] = useAddMiServicesFieldsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddMiServicesFieldsMutation(baseOptions?: Apollo.MutationHookOptions<AddMiServicesFieldsMutation, AddMiServicesFieldsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddMiServicesFieldsMutation, AddMiServicesFieldsMutationVariables>(AddMiServicesFieldsDocument, options);
      }
export type AddMiServicesFieldsMutationHookResult = ReturnType<typeof useAddMiServicesFieldsMutation>;
export type AddMiServicesFieldsMutationResult = Apollo.MutationResult<AddMiServicesFieldsMutation>;
export type AddMiServicesFieldsMutationOptions = Apollo.BaseMutationOptions<AddMiServicesFieldsMutation, AddMiServicesFieldsMutationVariables>;
export const AddMiServicesOverhaulFieldsForAssemblyTemplateDocument = gql`
    mutation AddMiServicesOverhaulFieldsForAssemblyTemplate($input: MiServicesInput) {
  addMiServicesOverhaulFields(input: $input) {
    fields {
      id
      name
      key
    }
  }
}
    `;
export type AddMiServicesOverhaulFieldsForAssemblyTemplateMutationFn = Apollo.MutationFunction<AddMiServicesOverhaulFieldsForAssemblyTemplateMutation, AddMiServicesOverhaulFieldsForAssemblyTemplateMutationVariables>;

/**
 * __useAddMiServicesOverhaulFieldsForAssemblyTemplateMutation__
 *
 * To run a mutation, you first call `useAddMiServicesOverhaulFieldsForAssemblyTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddMiServicesOverhaulFieldsForAssemblyTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addMiServicesOverhaulFieldsForAssemblyTemplateMutation, { data, loading, error }] = useAddMiServicesOverhaulFieldsForAssemblyTemplateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddMiServicesOverhaulFieldsForAssemblyTemplateMutation(baseOptions?: Apollo.MutationHookOptions<AddMiServicesOverhaulFieldsForAssemblyTemplateMutation, AddMiServicesOverhaulFieldsForAssemblyTemplateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddMiServicesOverhaulFieldsForAssemblyTemplateMutation, AddMiServicesOverhaulFieldsForAssemblyTemplateMutationVariables>(AddMiServicesOverhaulFieldsForAssemblyTemplateDocument, options);
      }
export type AddMiServicesOverhaulFieldsForAssemblyTemplateMutationHookResult = ReturnType<typeof useAddMiServicesOverhaulFieldsForAssemblyTemplateMutation>;
export type AddMiServicesOverhaulFieldsForAssemblyTemplateMutationResult = Apollo.MutationResult<AddMiServicesOverhaulFieldsForAssemblyTemplateMutation>;
export type AddMiServicesOverhaulFieldsForAssemblyTemplateMutationOptions = Apollo.BaseMutationOptions<AddMiServicesOverhaulFieldsForAssemblyTemplateMutation, AddMiServicesOverhaulFieldsForAssemblyTemplateMutationVariables>;
export const AddViewpointCountFieldDocument = gql`
    mutation AddViewpointCountField($input: MiServicesInput) {
  addViewpointCountField(input: $input) {
    fields {
      id
      name
      key
    }
  }
}
    `;
export type AddViewpointCountFieldMutationFn = Apollo.MutationFunction<AddViewpointCountFieldMutation, AddViewpointCountFieldMutationVariables>;

/**
 * __useAddViewpointCountFieldMutation__
 *
 * To run a mutation, you first call `useAddViewpointCountFieldMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddViewpointCountFieldMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addViewpointCountFieldMutation, { data, loading, error }] = useAddViewpointCountFieldMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddViewpointCountFieldMutation(baseOptions?: Apollo.MutationHookOptions<AddViewpointCountFieldMutation, AddViewpointCountFieldMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddViewpointCountFieldMutation, AddViewpointCountFieldMutationVariables>(AddViewpointCountFieldDocument, options);
      }
export type AddViewpointCountFieldMutationHookResult = ReturnType<typeof useAddViewpointCountFieldMutation>;
export type AddViewpointCountFieldMutationResult = Apollo.MutationResult<AddViewpointCountFieldMutation>;
export type AddViewpointCountFieldMutationOptions = Apollo.BaseMutationOptions<AddViewpointCountFieldMutation, AddViewpointCountFieldMutationVariables>;
export const BackfillViewpointCountsDocument = gql`
    mutation BackfillViewpointCounts($structureId: String!) {
  backfillViewpointCounts(structureId: $structureId)
}
    `;
export type BackfillViewpointCountsMutationFn = Apollo.MutationFunction<BackfillViewpointCountsMutation, BackfillViewpointCountsMutationVariables>;

/**
 * __useBackfillViewpointCountsMutation__
 *
 * To run a mutation, you first call `useBackfillViewpointCountsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBackfillViewpointCountsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [backfillViewpointCountsMutation, { data, loading, error }] = useBackfillViewpointCountsMutation({
 *   variables: {
 *      structureId: // value for 'structureId'
 *   },
 * });
 */
export function useBackfillViewpointCountsMutation(baseOptions?: Apollo.MutationHookOptions<BackfillViewpointCountsMutation, BackfillViewpointCountsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<BackfillViewpointCountsMutation, BackfillViewpointCountsMutationVariables>(BackfillViewpointCountsDocument, options);
      }
export type BackfillViewpointCountsMutationHookResult = ReturnType<typeof useBackfillViewpointCountsMutation>;
export type BackfillViewpointCountsMutationResult = Apollo.MutationResult<BackfillViewpointCountsMutation>;
export type BackfillViewpointCountsMutationOptions = Apollo.BaseMutationOptions<BackfillViewpointCountsMutation, BackfillViewpointCountsMutationVariables>;
export const AddBspMiServicesOverhaulFieldsDocument = gql`
    mutation AddBspMiServicesOverhaulFields($input: MiServicesInput) {
  addBspMiServicesOverhaulFields(input: $input) {
    fields {
      id
      name
      key
    }
  }
}
    `;
export type AddBspMiServicesOverhaulFieldsMutationFn = Apollo.MutationFunction<AddBspMiServicesOverhaulFieldsMutation, AddBspMiServicesOverhaulFieldsMutationVariables>;

/**
 * __useAddBspMiServicesOverhaulFieldsMutation__
 *
 * To run a mutation, you first call `useAddBspMiServicesOverhaulFieldsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddBspMiServicesOverhaulFieldsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addBspMiServicesOverhaulFieldsMutation, { data, loading, error }] = useAddBspMiServicesOverhaulFieldsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddBspMiServicesOverhaulFieldsMutation(baseOptions?: Apollo.MutationHookOptions<AddBspMiServicesOverhaulFieldsMutation, AddBspMiServicesOverhaulFieldsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddBspMiServicesOverhaulFieldsMutation, AddBspMiServicesOverhaulFieldsMutationVariables>(AddBspMiServicesOverhaulFieldsDocument, options);
      }
export type AddBspMiServicesOverhaulFieldsMutationHookResult = ReturnType<typeof useAddBspMiServicesOverhaulFieldsMutation>;
export type AddBspMiServicesOverhaulFieldsMutationResult = Apollo.MutationResult<AddBspMiServicesOverhaulFieldsMutation>;
export type AddBspMiServicesOverhaulFieldsMutationOptions = Apollo.BaseMutationOptions<AddBspMiServicesOverhaulFieldsMutation, AddBspMiServicesOverhaulFieldsMutationVariables>;
export const AddMiServicesOverhaulFieldsToPoiTemplatesDocument = gql`
    mutation AddMiServicesOverhaulFieldsToPoiTemplates($input: MiServicesPoiTemplateInput) {
  addMiServicesOverhaulFieldsToPoiTemplates(input: $input) {
    fields {
      id
      name
      key
    }
  }
}
    `;
export type AddMiServicesOverhaulFieldsToPoiTemplatesMutationFn = Apollo.MutationFunction<AddMiServicesOverhaulFieldsToPoiTemplatesMutation, AddMiServicesOverhaulFieldsToPoiTemplatesMutationVariables>;

/**
 * __useAddMiServicesOverhaulFieldsToPoiTemplatesMutation__
 *
 * To run a mutation, you first call `useAddMiServicesOverhaulFieldsToPoiTemplatesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddMiServicesOverhaulFieldsToPoiTemplatesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addMiServicesOverhaulFieldsToPoiTemplatesMutation, { data, loading, error }] = useAddMiServicesOverhaulFieldsToPoiTemplatesMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddMiServicesOverhaulFieldsToPoiTemplatesMutation(baseOptions?: Apollo.MutationHookOptions<AddMiServicesOverhaulFieldsToPoiTemplatesMutation, AddMiServicesOverhaulFieldsToPoiTemplatesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddMiServicesOverhaulFieldsToPoiTemplatesMutation, AddMiServicesOverhaulFieldsToPoiTemplatesMutationVariables>(AddMiServicesOverhaulFieldsToPoiTemplatesDocument, options);
      }
export type AddMiServicesOverhaulFieldsToPoiTemplatesMutationHookResult = ReturnType<typeof useAddMiServicesOverhaulFieldsToPoiTemplatesMutation>;
export type AddMiServicesOverhaulFieldsToPoiTemplatesMutationResult = Apollo.MutationResult<AddMiServicesOverhaulFieldsToPoiTemplatesMutation>;
export type AddMiServicesOverhaulFieldsToPoiTemplatesMutationOptions = Apollo.BaseMutationOptions<AddMiServicesOverhaulFieldsToPoiTemplatesMutation, AddMiServicesOverhaulFieldsToPoiTemplatesMutationVariables>;
export const AddBspMiServicesOverhaulFieldsToPoiTemplatesDocument = gql`
    mutation AddBspMiServicesOverhaulFieldsToPoiTemplates($input: MiServicesPoiTemplateInput) {
  addBspMiServicesOverhaulFieldsToPoiTemplates(input: $input) {
    fields {
      id
      name
      key
    }
  }
}
    `;
export type AddBspMiServicesOverhaulFieldsToPoiTemplatesMutationFn = Apollo.MutationFunction<AddBspMiServicesOverhaulFieldsToPoiTemplatesMutation, AddBspMiServicesOverhaulFieldsToPoiTemplatesMutationVariables>;

/**
 * __useAddBspMiServicesOverhaulFieldsToPoiTemplatesMutation__
 *
 * To run a mutation, you first call `useAddBspMiServicesOverhaulFieldsToPoiTemplatesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddBspMiServicesOverhaulFieldsToPoiTemplatesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addBspMiServicesOverhaulFieldsToPoiTemplatesMutation, { data, loading, error }] = useAddBspMiServicesOverhaulFieldsToPoiTemplatesMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddBspMiServicesOverhaulFieldsToPoiTemplatesMutation(baseOptions?: Apollo.MutationHookOptions<AddBspMiServicesOverhaulFieldsToPoiTemplatesMutation, AddBspMiServicesOverhaulFieldsToPoiTemplatesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddBspMiServicesOverhaulFieldsToPoiTemplatesMutation, AddBspMiServicesOverhaulFieldsToPoiTemplatesMutationVariables>(AddBspMiServicesOverhaulFieldsToPoiTemplatesDocument, options);
      }
export type AddBspMiServicesOverhaulFieldsToPoiTemplatesMutationHookResult = ReturnType<typeof useAddBspMiServicesOverhaulFieldsToPoiTemplatesMutation>;
export type AddBspMiServicesOverhaulFieldsToPoiTemplatesMutationResult = Apollo.MutationResult<AddBspMiServicesOverhaulFieldsToPoiTemplatesMutation>;
export type AddBspMiServicesOverhaulFieldsToPoiTemplatesMutationOptions = Apollo.BaseMutationOptions<AddBspMiServicesOverhaulFieldsToPoiTemplatesMutation, AddBspMiServicesOverhaulFieldsToPoiTemplatesMutationVariables>;
export const AddAlarmLevelFieldToPoiTemplatesDocument = gql`
    mutation AddAlarmLevelFieldToPoiTemplates($input: MiServicesPoiTemplateInput) {
  addAlarmLevelFieldToPoiTemplates(input: $input) {
    fields {
      id
      name
      key
    }
  }
}
    `;
export type AddAlarmLevelFieldToPoiTemplatesMutationFn = Apollo.MutationFunction<AddAlarmLevelFieldToPoiTemplatesMutation, AddAlarmLevelFieldToPoiTemplatesMutationVariables>;

/**
 * __useAddAlarmLevelFieldToPoiTemplatesMutation__
 *
 * To run a mutation, you first call `useAddAlarmLevelFieldToPoiTemplatesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddAlarmLevelFieldToPoiTemplatesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addAlarmLevelFieldToPoiTemplatesMutation, { data, loading, error }] = useAddAlarmLevelFieldToPoiTemplatesMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddAlarmLevelFieldToPoiTemplatesMutation(baseOptions?: Apollo.MutationHookOptions<AddAlarmLevelFieldToPoiTemplatesMutation, AddAlarmLevelFieldToPoiTemplatesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddAlarmLevelFieldToPoiTemplatesMutation, AddAlarmLevelFieldToPoiTemplatesMutationVariables>(AddAlarmLevelFieldToPoiTemplatesDocument, options);
      }
export type AddAlarmLevelFieldToPoiTemplatesMutationHookResult = ReturnType<typeof useAddAlarmLevelFieldToPoiTemplatesMutation>;
export type AddAlarmLevelFieldToPoiTemplatesMutationResult = Apollo.MutationResult<AddAlarmLevelFieldToPoiTemplatesMutation>;
export type AddAlarmLevelFieldToPoiTemplatesMutationOptions = Apollo.BaseMutationOptions<AddAlarmLevelFieldToPoiTemplatesMutation, AddAlarmLevelFieldToPoiTemplatesMutationVariables>;
export const AddEditRolesToTemplateFieldDocument = gql`
    mutation AddEditRolesToTemplateField($input: EditRolesInput) {
  addEditRolesToTemplateField(input: $input) {
    fields {
      key
      isEditable
      editRoles
    }
  }
}
    `;
export type AddEditRolesToTemplateFieldMutationFn = Apollo.MutationFunction<AddEditRolesToTemplateFieldMutation, AddEditRolesToTemplateFieldMutationVariables>;

/**
 * __useAddEditRolesToTemplateFieldMutation__
 *
 * To run a mutation, you first call `useAddEditRolesToTemplateFieldMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddEditRolesToTemplateFieldMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addEditRolesToTemplateFieldMutation, { data, loading, error }] = useAddEditRolesToTemplateFieldMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddEditRolesToTemplateFieldMutation(baseOptions?: Apollo.MutationHookOptions<AddEditRolesToTemplateFieldMutation, AddEditRolesToTemplateFieldMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddEditRolesToTemplateFieldMutation, AddEditRolesToTemplateFieldMutationVariables>(AddEditRolesToTemplateFieldDocument, options);
      }
export type AddEditRolesToTemplateFieldMutationHookResult = ReturnType<typeof useAddEditRolesToTemplateFieldMutation>;
export type AddEditRolesToTemplateFieldMutationResult = Apollo.MutationResult<AddEditRolesToTemplateFieldMutation>;
export type AddEditRolesToTemplateFieldMutationOptions = Apollo.BaseMutationOptions<AddEditRolesToTemplateFieldMutation, AddEditRolesToTemplateFieldMutationVariables>;
export const EvaluateAllAssembliesForStructureDocument = gql`
    mutation EvaluateAllAssembliesForStructure($structureId: String!, $evaluateManuallyAddedFields: Boolean!) {
  evaluateAllAssembliesForStructure(
    structureId: $structureId
    evaluateManuallyAddedFields: $evaluateManuallyAddedFields
  ) {
    name
  }
}
    `;
export type EvaluateAllAssembliesForStructureMutationFn = Apollo.MutationFunction<EvaluateAllAssembliesForStructureMutation, EvaluateAllAssembliesForStructureMutationVariables>;

/**
 * __useEvaluateAllAssembliesForStructureMutation__
 *
 * To run a mutation, you first call `useEvaluateAllAssembliesForStructureMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEvaluateAllAssembliesForStructureMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [evaluateAllAssembliesForStructureMutation, { data, loading, error }] = useEvaluateAllAssembliesForStructureMutation({
 *   variables: {
 *      structureId: // value for 'structureId'
 *      evaluateManuallyAddedFields: // value for 'evaluateManuallyAddedFields'
 *   },
 * });
 */
export function useEvaluateAllAssembliesForStructureMutation(baseOptions?: Apollo.MutationHookOptions<EvaluateAllAssembliesForStructureMutation, EvaluateAllAssembliesForStructureMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EvaluateAllAssembliesForStructureMutation, EvaluateAllAssembliesForStructureMutationVariables>(EvaluateAllAssembliesForStructureDocument, options);
      }
export type EvaluateAllAssembliesForStructureMutationHookResult = ReturnType<typeof useEvaluateAllAssembliesForStructureMutation>;
export type EvaluateAllAssembliesForStructureMutationResult = Apollo.MutationResult<EvaluateAllAssembliesForStructureMutation>;
export type EvaluateAllAssembliesForStructureMutationOptions = Apollo.BaseMutationOptions<EvaluateAllAssembliesForStructureMutation, EvaluateAllAssembliesForStructureMutationVariables>;
export const EvaluateAllPoIsForStructureDocument = gql`
    mutation EvaluateAllPOIsForStructure($structureId: String!, $evaluateManuallyAddedFields: Boolean!) {
  evaluateAllPOIsForStructure(
    structureId: $structureId
    evaluateManuallyAddedFields: $evaluateManuallyAddedFields
  ) {
    name
  }
}
    `;
export type EvaluateAllPoIsForStructureMutationFn = Apollo.MutationFunction<EvaluateAllPoIsForStructureMutation, EvaluateAllPoIsForStructureMutationVariables>;

/**
 * __useEvaluateAllPoIsForStructureMutation__
 *
 * To run a mutation, you first call `useEvaluateAllPoIsForStructureMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEvaluateAllPoIsForStructureMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [evaluateAllPoIsForStructureMutation, { data, loading, error }] = useEvaluateAllPoIsForStructureMutation({
 *   variables: {
 *      structureId: // value for 'structureId'
 *      evaluateManuallyAddedFields: // value for 'evaluateManuallyAddedFields'
 *   },
 * });
 */
export function useEvaluateAllPoIsForStructureMutation(baseOptions?: Apollo.MutationHookOptions<EvaluateAllPoIsForStructureMutation, EvaluateAllPoIsForStructureMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EvaluateAllPoIsForStructureMutation, EvaluateAllPoIsForStructureMutationVariables>(EvaluateAllPoIsForStructureDocument, options);
      }
export type EvaluateAllPoIsForStructureMutationHookResult = ReturnType<typeof useEvaluateAllPoIsForStructureMutation>;
export type EvaluateAllPoIsForStructureMutationResult = Apollo.MutationResult<EvaluateAllPoIsForStructureMutation>;
export type EvaluateAllPoIsForStructureMutationOptions = Apollo.BaseMutationOptions<EvaluateAllPoIsForStructureMutation, EvaluateAllPoIsForStructureMutationVariables>;
export const AddAssessmentDetailsFieldsDocument = gql`
    mutation AddAssessmentDetailsFields($input: AssessmentDetailsInput) {
  addAssessmentDetailsFields(input: $input) {
    fields {
      id
      name
      key
    }
    assessmentDetails {
      id
      isVisible
      name
      position
      type
      options {
        fieldKey
        id
        name
        type
      }
    }
    reviewPanelConfig {
      groupKey
      groupName
      id
      groupSection {
        id
        title
        sectionKey
        fieldKeys
      }
    }
  }
}
    `;
export type AddAssessmentDetailsFieldsMutationFn = Apollo.MutationFunction<AddAssessmentDetailsFieldsMutation, AddAssessmentDetailsFieldsMutationVariables>;

/**
 * __useAddAssessmentDetailsFieldsMutation__
 *
 * To run a mutation, you first call `useAddAssessmentDetailsFieldsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddAssessmentDetailsFieldsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addAssessmentDetailsFieldsMutation, { data, loading, error }] = useAddAssessmentDetailsFieldsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddAssessmentDetailsFieldsMutation(baseOptions?: Apollo.MutationHookOptions<AddAssessmentDetailsFieldsMutation, AddAssessmentDetailsFieldsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddAssessmentDetailsFieldsMutation, AddAssessmentDetailsFieldsMutationVariables>(AddAssessmentDetailsFieldsDocument, options);
      }
export type AddAssessmentDetailsFieldsMutationHookResult = ReturnType<typeof useAddAssessmentDetailsFieldsMutation>;
export type AddAssessmentDetailsFieldsMutationResult = Apollo.MutationResult<AddAssessmentDetailsFieldsMutation>;
export type AddAssessmentDetailsFieldsMutationOptions = Apollo.BaseMutationOptions<AddAssessmentDetailsFieldsMutation, AddAssessmentDetailsFieldsMutationVariables>;
export const UploadCoverImageDocument = gql`
    mutation UploadCoverImage($input: UploadImageInput!) {
  uploadCoverImage(input: $input) {
    coverImagePath
  }
}
    `;
export type UploadCoverImageMutationFn = Apollo.MutationFunction<UploadCoverImageMutation, UploadCoverImageMutationVariables>;

/**
 * __useUploadCoverImageMutation__
 *
 * To run a mutation, you first call `useUploadCoverImageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUploadCoverImageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [uploadCoverImageMutation, { data, loading, error }] = useUploadCoverImageMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUploadCoverImageMutation(baseOptions?: Apollo.MutationHookOptions<UploadCoverImageMutation, UploadCoverImageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UploadCoverImageMutation, UploadCoverImageMutationVariables>(UploadCoverImageDocument, options);
      }
export type UploadCoverImageMutationHookResult = ReturnType<typeof useUploadCoverImageMutation>;
export type UploadCoverImageMutationResult = Apollo.MutationResult<UploadCoverImageMutation>;
export type UploadCoverImageMutationOptions = Apollo.BaseMutationOptions<UploadCoverImageMutation, UploadCoverImageMutationVariables>;
export const UpdateRemediationScoreConfigDocument = gql`
    mutation updateRemediationScoreConfig($input: UpdateRemediationScoreConfigInput!) {
  updateRemediationScoreConfig(input: $input) {
    remediationScoreConfig {
      area {
        fields {
          fieldKey
          score
          threshold
        }
      }
      cof {
        fields {
          fieldKey
          optionScores
        }
      }
      poi {
        fields {
          poiScore
          poiTemplateKey
          subcategory {
            fieldKey
            optionScores
          }
        }
      }
    }
  }
}
    `;
export type UpdateRemediationScoreConfigMutationFn = Apollo.MutationFunction<UpdateRemediationScoreConfigMutation, UpdateRemediationScoreConfigMutationVariables>;

/**
 * __useUpdateRemediationScoreConfigMutation__
 *
 * To run a mutation, you first call `useUpdateRemediationScoreConfigMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateRemediationScoreConfigMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateRemediationScoreConfigMutation, { data, loading, error }] = useUpdateRemediationScoreConfigMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateRemediationScoreConfigMutation(baseOptions?: Apollo.MutationHookOptions<UpdateRemediationScoreConfigMutation, UpdateRemediationScoreConfigMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateRemediationScoreConfigMutation, UpdateRemediationScoreConfigMutationVariables>(UpdateRemediationScoreConfigDocument, options);
      }
export type UpdateRemediationScoreConfigMutationHookResult = ReturnType<typeof useUpdateRemediationScoreConfigMutation>;
export type UpdateRemediationScoreConfigMutationResult = Apollo.MutationResult<UpdateRemediationScoreConfigMutation>;
export type UpdateRemediationScoreConfigMutationOptions = Apollo.BaseMutationOptions<UpdateRemediationScoreConfigMutation, UpdateRemediationScoreConfigMutationVariables>;
export const AddReportConfigurationDocument = gql`
    mutation AddReportConfiguration($structureId: ID!) {
  addReportConfiguration(structureId: $structureId) {
    reportConfig {
      title
      id
      configurations {
        id
        title
        key
      }
      paintBlockReportPoiTemplateTypes
    }
  }
}
    `;
export type AddReportConfigurationMutationFn = Apollo.MutationFunction<AddReportConfigurationMutation, AddReportConfigurationMutationVariables>;

/**
 * __useAddReportConfigurationMutation__
 *
 * To run a mutation, you first call `useAddReportConfigurationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddReportConfigurationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addReportConfigurationMutation, { data, loading, error }] = useAddReportConfigurationMutation({
 *   variables: {
 *      structureId: // value for 'structureId'
 *   },
 * });
 */
export function useAddReportConfigurationMutation(baseOptions?: Apollo.MutationHookOptions<AddReportConfigurationMutation, AddReportConfigurationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddReportConfigurationMutation, AddReportConfigurationMutationVariables>(AddReportConfigurationDocument, options);
      }
export type AddReportConfigurationMutationHookResult = ReturnType<typeof useAddReportConfigurationMutation>;
export type AddReportConfigurationMutationResult = Apollo.MutationResult<AddReportConfigurationMutation>;
export type AddReportConfigurationMutationOptions = Apollo.BaseMutationOptions<AddReportConfigurationMutation, AddReportConfigurationMutationVariables>;
export const RecalculateRiskRemediationAnalyticsDocument = gql`
    mutation RecalculateRiskRemediationAnalytics($input: RecalculateRiskRemediationAnalyticsInput!) {
  recalculateRiskRemediationAnalytics(input: $input) {
    success
    error
  }
}
    `;
export type RecalculateRiskRemediationAnalyticsMutationFn = Apollo.MutationFunction<RecalculateRiskRemediationAnalyticsMutation, RecalculateRiskRemediationAnalyticsMutationVariables>;

/**
 * __useRecalculateRiskRemediationAnalyticsMutation__
 *
 * To run a mutation, you first call `useRecalculateRiskRemediationAnalyticsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRecalculateRiskRemediationAnalyticsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [recalculateRiskRemediationAnalyticsMutation, { data, loading, error }] = useRecalculateRiskRemediationAnalyticsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRecalculateRiskRemediationAnalyticsMutation(baseOptions?: Apollo.MutationHookOptions<RecalculateRiskRemediationAnalyticsMutation, RecalculateRiskRemediationAnalyticsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RecalculateRiskRemediationAnalyticsMutation, RecalculateRiskRemediationAnalyticsMutationVariables>(RecalculateRiskRemediationAnalyticsDocument, options);
      }
export type RecalculateRiskRemediationAnalyticsMutationHookResult = ReturnType<typeof useRecalculateRiskRemediationAnalyticsMutation>;
export type RecalculateRiskRemediationAnalyticsMutationResult = Apollo.MutationResult<RecalculateRiskRemediationAnalyticsMutation>;
export type RecalculateRiskRemediationAnalyticsMutationOptions = Apollo.BaseMutationOptions<RecalculateRiskRemediationAnalyticsMutation, RecalculateRiskRemediationAnalyticsMutationVariables>;
export const AllLogsTemplatesDocument = gql`
    query AllLogsTemplates($input: LogsTemplateInput!) {
  allLogsTemplates(input: $input) {
    id
    name
    key
  }
}
    `;

/**
 * __useAllLogsTemplatesQuery__
 *
 * To run a query within a React component, call `useAllLogsTemplatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllLogsTemplatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllLogsTemplatesQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAllLogsTemplatesQuery(baseOptions: Apollo.QueryHookOptions<AllLogsTemplatesQuery, AllLogsTemplatesQueryVariables> & ({ variables: AllLogsTemplatesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AllLogsTemplatesQuery, AllLogsTemplatesQueryVariables>(AllLogsTemplatesDocument, options);
      }
export function useAllLogsTemplatesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AllLogsTemplatesQuery, AllLogsTemplatesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AllLogsTemplatesQuery, AllLogsTemplatesQueryVariables>(AllLogsTemplatesDocument, options);
        }
// @ts-ignore
export function useAllLogsTemplatesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<AllLogsTemplatesQuery, AllLogsTemplatesQueryVariables>): Apollo.UseSuspenseQueryResult<AllLogsTemplatesQuery, AllLogsTemplatesQueryVariables>;
export function useAllLogsTemplatesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AllLogsTemplatesQuery, AllLogsTemplatesQueryVariables>): Apollo.UseSuspenseQueryResult<AllLogsTemplatesQuery | undefined, AllLogsTemplatesQueryVariables>;
export function useAllLogsTemplatesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AllLogsTemplatesQuery, AllLogsTemplatesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AllLogsTemplatesQuery, AllLogsTemplatesQueryVariables>(AllLogsTemplatesDocument, options);
        }
export type AllLogsTemplatesQueryHookResult = ReturnType<typeof useAllLogsTemplatesQuery>;
export type AllLogsTemplatesLazyQueryHookResult = ReturnType<typeof useAllLogsTemplatesLazyQuery>;
export type AllLogsTemplatesSuspenseQueryHookResult = ReturnType<typeof useAllLogsTemplatesSuspenseQuery>;
export type AllLogsTemplatesQueryResult = Apollo.QueryResult<AllLogsTemplatesQuery, AllLogsTemplatesQueryVariables>;
export const LogsTemplateDocument = gql`
    query LogsTemplate($logsTemplateId: ID!) {
  logsTemplate(logsTemplateId: $logsTemplateId) {
    id
    name
    sections {
      id
      key
      title
      sectionUnit
      order
      defaultOpen
      fieldKeys
    }
    fields {
      id
      name
      type
      options
      optionsData {
        value
        weight
        min
        max
        minIncluded
        maxIncluded
      }
      isRequired
      isReadOnly
      serverSide
      displayConfig {
        id
        type
        color {
          key
          value
        }
        inputAdorment {
          position
          iconPath
          iconType
        }
        textAreaRows
        isSortable
        sortType
        textFormat
      }
      roundToDecimal
      key
      detailFieldKey
      shouldEvaluateLogic
      shouldEvaluateMath
      shouldEvaluateLogicPostCalculation
      displayInQuery
      displayInTable
      displayInReview
      displayInReports
      displayInReportFilters
      sectionKey
      displayInLogAggregation
      isDerived
      derivedEquationKey
      fieldDescription
      fieldUnit
    }
    cardsConfig {
      id
      key
      order
      title
      icon
      unit
      unitPosition
      roundToDecimal
      aggregation {
        source
        fieldKey
        operation
      }
      equationKey
      subtitleConfig {
        text
        unit
        unitPosition
        equationKey
        aggregation {
          source
          fieldKey
          operation
        }
        position
        icon
        iconPosition
        textFormat
        prefix
        suffix
        unit
        roundToDecimal
      }
    }
    equations {
      key
      name
      expression {
        type
        value
        variable
        operator
        args {
          type
          value
          variable
          operator
          args {
            type
            value
            variable
            operator
            args {
              type
              value
              variable
              operator
            }
          }
        }
      }
      variables {
        name
        fieldKey
        templateType
        isBlisterField
      }
      value
    }
  }
}
    `;

/**
 * __useLogsTemplateQuery__
 *
 * To run a query within a React component, call `useLogsTemplateQuery` and pass it any options that fit your needs.
 * When your component renders, `useLogsTemplateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLogsTemplateQuery({
 *   variables: {
 *      logsTemplateId: // value for 'logsTemplateId'
 *   },
 * });
 */
export function useLogsTemplateQuery(baseOptions: Apollo.QueryHookOptions<LogsTemplateQuery, LogsTemplateQueryVariables> & ({ variables: LogsTemplateQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LogsTemplateQuery, LogsTemplateQueryVariables>(LogsTemplateDocument, options);
      }
export function useLogsTemplateLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LogsTemplateQuery, LogsTemplateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LogsTemplateQuery, LogsTemplateQueryVariables>(LogsTemplateDocument, options);
        }
// @ts-ignore
export function useLogsTemplateSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<LogsTemplateQuery, LogsTemplateQueryVariables>): Apollo.UseSuspenseQueryResult<LogsTemplateQuery, LogsTemplateQueryVariables>;
export function useLogsTemplateSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<LogsTemplateQuery, LogsTemplateQueryVariables>): Apollo.UseSuspenseQueryResult<LogsTemplateQuery | undefined, LogsTemplateQueryVariables>;
export function useLogsTemplateSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<LogsTemplateQuery, LogsTemplateQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<LogsTemplateQuery, LogsTemplateQueryVariables>(LogsTemplateDocument, options);
        }
export type LogsTemplateQueryHookResult = ReturnType<typeof useLogsTemplateQuery>;
export type LogsTemplateLazyQueryHookResult = ReturnType<typeof useLogsTemplateLazyQuery>;
export type LogsTemplateSuspenseQueryHookResult = ReturnType<typeof useLogsTemplateSuspenseQuery>;
export type LogsTemplateQueryResult = Apollo.QueryResult<LogsTemplateQuery, LogsTemplateQueryVariables>;
export const CreateLogsTemplateDocument = gql`
    mutation CreateLogsTemplate($input: LogsTemplateInput!) {
  createLogsTemplate(input: $input) {
    id
    name
  }
}
    `;
export type CreateLogsTemplateMutationFn = Apollo.MutationFunction<CreateLogsTemplateMutation, CreateLogsTemplateMutationVariables>;

/**
 * __useCreateLogsTemplateMutation__
 *
 * To run a mutation, you first call `useCreateLogsTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateLogsTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createLogsTemplateMutation, { data, loading, error }] = useCreateLogsTemplateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateLogsTemplateMutation(baseOptions?: Apollo.MutationHookOptions<CreateLogsTemplateMutation, CreateLogsTemplateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateLogsTemplateMutation, CreateLogsTemplateMutationVariables>(CreateLogsTemplateDocument, options);
      }
export type CreateLogsTemplateMutationHookResult = ReturnType<typeof useCreateLogsTemplateMutation>;
export type CreateLogsTemplateMutationResult = Apollo.MutationResult<CreateLogsTemplateMutation>;
export type CreateLogsTemplateMutationOptions = Apollo.BaseMutationOptions<CreateLogsTemplateMutation, CreateLogsTemplateMutationVariables>;
export const AddLogsTemplateDocument = gql`
    mutation AddLogsTemplate($input: AddLogsTemplateInput!) {
  addLogsTemplate(input: $input) {
    id
    logsTemplate {
      id
      name
    }
  }
}
    `;
export type AddLogsTemplateMutationFn = Apollo.MutationFunction<AddLogsTemplateMutation, AddLogsTemplateMutationVariables>;

/**
 * __useAddLogsTemplateMutation__
 *
 * To run a mutation, you first call `useAddLogsTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddLogsTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addLogsTemplateMutation, { data, loading, error }] = useAddLogsTemplateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddLogsTemplateMutation(baseOptions?: Apollo.MutationHookOptions<AddLogsTemplateMutation, AddLogsTemplateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddLogsTemplateMutation, AddLogsTemplateMutationVariables>(AddLogsTemplateDocument, options);
      }
export type AddLogsTemplateMutationHookResult = ReturnType<typeof useAddLogsTemplateMutation>;
export type AddLogsTemplateMutationResult = Apollo.MutationResult<AddLogsTemplateMutation>;
export type AddLogsTemplateMutationOptions = Apollo.BaseMutationOptions<AddLogsTemplateMutation, AddLogsTemplateMutationVariables>;
export const UpdateLogsTemplateDocument = gql`
    mutation UpdateLogsTemplate($input: UpdateLogsTemplateInput!) {
  updateLogsTemplate(input: $input) {
    id
    name
  }
}
    `;
export type UpdateLogsTemplateMutationFn = Apollo.MutationFunction<UpdateLogsTemplateMutation, UpdateLogsTemplateMutationVariables>;

/**
 * __useUpdateLogsTemplateMutation__
 *
 * To run a mutation, you first call `useUpdateLogsTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateLogsTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateLogsTemplateMutation, { data, loading, error }] = useUpdateLogsTemplateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateLogsTemplateMutation(baseOptions?: Apollo.MutationHookOptions<UpdateLogsTemplateMutation, UpdateLogsTemplateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateLogsTemplateMutation, UpdateLogsTemplateMutationVariables>(UpdateLogsTemplateDocument, options);
      }
export type UpdateLogsTemplateMutationHookResult = ReturnType<typeof useUpdateLogsTemplateMutation>;
export type UpdateLogsTemplateMutationResult = Apollo.MutationResult<UpdateLogsTemplateMutation>;
export type UpdateLogsTemplateMutationOptions = Apollo.BaseMutationOptions<UpdateLogsTemplateMutation, UpdateLogsTemplateMutationVariables>;
export const AddStructurePipesDocument = gql`
    mutation AddStructurePipes($input: AddStructurePipesInput) {
  addStructurePipes(input: $input)
}
    `;
export type AddStructurePipesMutationFn = Apollo.MutationFunction<AddStructurePipesMutation, AddStructurePipesMutationVariables>;

/**
 * __useAddStructurePipesMutation__
 *
 * To run a mutation, you first call `useAddStructurePipesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddStructurePipesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addStructurePipesMutation, { data, loading, error }] = useAddStructurePipesMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddStructurePipesMutation(baseOptions?: Apollo.MutationHookOptions<AddStructurePipesMutation, AddStructurePipesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddStructurePipesMutation, AddStructurePipesMutationVariables>(AddStructurePipesDocument, options);
      }
export type AddStructurePipesMutationHookResult = ReturnType<typeof useAddStructurePipesMutation>;
export type AddStructurePipesMutationResult = Apollo.MutationResult<AddStructurePipesMutation>;
export type AddStructurePipesMutationOptions = Apollo.BaseMutationOptions<AddStructurePipesMutation, AddStructurePipesMutationVariables>;
export const DeleteStructurePipeDocument = gql`
    mutation DeleteStructurePipe($structureId: ID!, $pipeSize: String!) {
  deleteStructurePipe(structureId: $structureId, pipeSize: $pipeSize)
}
    `;
export type DeleteStructurePipeMutationFn = Apollo.MutationFunction<DeleteStructurePipeMutation, DeleteStructurePipeMutationVariables>;

/**
 * __useDeleteStructurePipeMutation__
 *
 * To run a mutation, you first call `useDeleteStructurePipeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteStructurePipeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteStructurePipeMutation, { data, loading, error }] = useDeleteStructurePipeMutation({
 *   variables: {
 *      structureId: // value for 'structureId'
 *      pipeSize: // value for 'pipeSize'
 *   },
 * });
 */
export function useDeleteStructurePipeMutation(baseOptions?: Apollo.MutationHookOptions<DeleteStructurePipeMutation, DeleteStructurePipeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteStructurePipeMutation, DeleteStructurePipeMutationVariables>(DeleteStructurePipeDocument, options);
      }
export type DeleteStructurePipeMutationHookResult = ReturnType<typeof useDeleteStructurePipeMutation>;
export type DeleteStructurePipeMutationResult = Apollo.MutationResult<DeleteStructurePipeMutation>;
export type DeleteStructurePipeMutationOptions = Apollo.BaseMutationOptions<DeleteStructurePipeMutation, DeleteStructurePipeMutationVariables>;
export const EditStructurePipeDocument = gql`
    mutation EditStructurePipe($structureId: ID!, $pipeSize: String!, $pipeValue: Float!) {
  editStructurePipe(
    structureId: $structureId
    pipeSize: $pipeSize
    pipeValue: $pipeValue
  )
}
    `;
export type EditStructurePipeMutationFn = Apollo.MutationFunction<EditStructurePipeMutation, EditStructurePipeMutationVariables>;

/**
 * __useEditStructurePipeMutation__
 *
 * To run a mutation, you first call `useEditStructurePipeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditStructurePipeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editStructurePipeMutation, { data, loading, error }] = useEditStructurePipeMutation({
 *   variables: {
 *      structureId: // value for 'structureId'
 *      pipeSize: // value for 'pipeSize'
 *      pipeValue: // value for 'pipeValue'
 *   },
 * });
 */
export function useEditStructurePipeMutation(baseOptions?: Apollo.MutationHookOptions<EditStructurePipeMutation, EditStructurePipeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EditStructurePipeMutation, EditStructurePipeMutationVariables>(EditStructurePipeDocument, options);
      }
export type EditStructurePipeMutationHookResult = ReturnType<typeof useEditStructurePipeMutation>;
export type EditStructurePipeMutationResult = Apollo.MutationResult<EditStructurePipeMutation>;
export type EditStructurePipeMutationOptions = Apollo.BaseMutationOptions<EditStructurePipeMutation, EditStructurePipeMutationVariables>;
export const UpdateFleetHealthDocument = gql`
    mutation UpdateFleetHealth($platformIds: [ID]) {
  updateFleetHealth(platformIds: $platformIds) {
    id
  }
}
    `;
export type UpdateFleetHealthMutationFn = Apollo.MutationFunction<UpdateFleetHealthMutation, UpdateFleetHealthMutationVariables>;

/**
 * __useUpdateFleetHealthMutation__
 *
 * To run a mutation, you first call `useUpdateFleetHealthMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateFleetHealthMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateFleetHealthMutation, { data, loading, error }] = useUpdateFleetHealthMutation({
 *   variables: {
 *      platformIds: // value for 'platformIds'
 *   },
 * });
 */
export function useUpdateFleetHealthMutation(baseOptions?: Apollo.MutationHookOptions<UpdateFleetHealthMutation, UpdateFleetHealthMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateFleetHealthMutation, UpdateFleetHealthMutationVariables>(UpdateFleetHealthDocument, options);
      }
export type UpdateFleetHealthMutationHookResult = ReturnType<typeof useUpdateFleetHealthMutation>;
export type UpdateFleetHealthMutationResult = Apollo.MutationResult<UpdateFleetHealthMutation>;
export type UpdateFleetHealthMutationOptions = Apollo.BaseMutationOptions<UpdateFleetHealthMutation, UpdateFleetHealthMutationVariables>;
export const SyncNestedFieldOptionsDocument = gql`
    mutation SyncNestedFieldOptions($templateId: ID!) {
  syncNestedFieldOptions(templateId: $templateId) {
    id
  }
}
    `;
export type SyncNestedFieldOptionsMutationFn = Apollo.MutationFunction<SyncNestedFieldOptionsMutation, SyncNestedFieldOptionsMutationVariables>;

/**
 * __useSyncNestedFieldOptionsMutation__
 *
 * To run a mutation, you first call `useSyncNestedFieldOptionsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSyncNestedFieldOptionsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [syncNestedFieldOptionsMutation, { data, loading, error }] = useSyncNestedFieldOptionsMutation({
 *   variables: {
 *      templateId: // value for 'templateId'
 *   },
 * });
 */
export function useSyncNestedFieldOptionsMutation(baseOptions?: Apollo.MutationHookOptions<SyncNestedFieldOptionsMutation, SyncNestedFieldOptionsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SyncNestedFieldOptionsMutation, SyncNestedFieldOptionsMutationVariables>(SyncNestedFieldOptionsDocument, options);
      }
export type SyncNestedFieldOptionsMutationHookResult = ReturnType<typeof useSyncNestedFieldOptionsMutation>;
export type SyncNestedFieldOptionsMutationResult = Apollo.MutationResult<SyncNestedFieldOptionsMutation>;
export type SyncNestedFieldOptionsMutationOptions = Apollo.BaseMutationOptions<SyncNestedFieldOptionsMutation, SyncNestedFieldOptionsMutationVariables>;
export const CopyLogsTemplateDocument = gql`
    mutation CopyLogsTemplate($input: CopyLogsTemplateInput!) {
  copyLogsTemplate(input: $input) {
    id
    name
  }
}
    `;
export type CopyLogsTemplateMutationFn = Apollo.MutationFunction<CopyLogsTemplateMutation, CopyLogsTemplateMutationVariables>;

/**
 * __useCopyLogsTemplateMutation__
 *
 * To run a mutation, you first call `useCopyLogsTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCopyLogsTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [copyLogsTemplateMutation, { data, loading, error }] = useCopyLogsTemplateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCopyLogsTemplateMutation(baseOptions?: Apollo.MutationHookOptions<CopyLogsTemplateMutation, CopyLogsTemplateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CopyLogsTemplateMutation, CopyLogsTemplateMutationVariables>(CopyLogsTemplateDocument, options);
      }
export type CopyLogsTemplateMutationHookResult = ReturnType<typeof useCopyLogsTemplateMutation>;
export type CopyLogsTemplateMutationResult = Apollo.MutationResult<CopyLogsTemplateMutation>;
export type CopyLogsTemplateMutationOptions = Apollo.BaseMutationOptions<CopyLogsTemplateMutation, CopyLogsTemplateMutationVariables>;
export const SyncLogsTemplatesDocument = gql`
    mutation SyncLogsTemplates($input: SyncLogsTemplatesInput!) {
  syncLogsTemplates(input: $input) {
    id
    name
  }
}
    `;
export type SyncLogsTemplatesMutationFn = Apollo.MutationFunction<SyncLogsTemplatesMutation, SyncLogsTemplatesMutationVariables>;

/**
 * __useSyncLogsTemplatesMutation__
 *
 * To run a mutation, you first call `useSyncLogsTemplatesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSyncLogsTemplatesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [syncLogsTemplatesMutation, { data, loading, error }] = useSyncLogsTemplatesMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSyncLogsTemplatesMutation(baseOptions?: Apollo.MutationHookOptions<SyncLogsTemplatesMutation, SyncLogsTemplatesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SyncLogsTemplatesMutation, SyncLogsTemplatesMutationVariables>(SyncLogsTemplatesDocument, options);
      }
export type SyncLogsTemplatesMutationHookResult = ReturnType<typeof useSyncLogsTemplatesMutation>;
export type SyncLogsTemplatesMutationResult = Apollo.MutationResult<SyncLogsTemplatesMutation>;
export type SyncLogsTemplatesMutationOptions = Apollo.BaseMutationOptions<SyncLogsTemplatesMutation, SyncLogsTemplatesMutationVariables>;
export const AllUsersForUserManagementDocument = gql`
    query AllUsersForUserManagement($pageInfo: PageInfo, $input: FilterForUsers, $usersCountInput: FiltersForUsersCount) {
  usersCount(input: $usersCountInput) {
    count
  }
  allUsers(pageInfo: $pageInfo, input: $input) {
    id
    email
    picture
    name
    roleIds {
      id
      name
      description
      auth0Id
    }
    connection
    status
    loginCount
    lastLogin
    loginType
  }
}
    `;

/**
 * __useAllUsersForUserManagementQuery__
 *
 * To run a query within a React component, call `useAllUsersForUserManagementQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllUsersForUserManagementQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllUsersForUserManagementQuery({
 *   variables: {
 *      pageInfo: // value for 'pageInfo'
 *      input: // value for 'input'
 *      usersCountInput: // value for 'usersCountInput'
 *   },
 * });
 */
export function useAllUsersForUserManagementQuery(baseOptions?: Apollo.QueryHookOptions<AllUsersForUserManagementQuery, AllUsersForUserManagementQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AllUsersForUserManagementQuery, AllUsersForUserManagementQueryVariables>(AllUsersForUserManagementDocument, options);
      }
export function useAllUsersForUserManagementLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AllUsersForUserManagementQuery, AllUsersForUserManagementQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AllUsersForUserManagementQuery, AllUsersForUserManagementQueryVariables>(AllUsersForUserManagementDocument, options);
        }
// @ts-ignore
export function useAllUsersForUserManagementSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<AllUsersForUserManagementQuery, AllUsersForUserManagementQueryVariables>): Apollo.UseSuspenseQueryResult<AllUsersForUserManagementQuery, AllUsersForUserManagementQueryVariables>;
export function useAllUsersForUserManagementSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AllUsersForUserManagementQuery, AllUsersForUserManagementQueryVariables>): Apollo.UseSuspenseQueryResult<AllUsersForUserManagementQuery | undefined, AllUsersForUserManagementQueryVariables>;
export function useAllUsersForUserManagementSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AllUsersForUserManagementQuery, AllUsersForUserManagementQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AllUsersForUserManagementQuery, AllUsersForUserManagementQueryVariables>(AllUsersForUserManagementDocument, options);
        }
export type AllUsersForUserManagementQueryHookResult = ReturnType<typeof useAllUsersForUserManagementQuery>;
export type AllUsersForUserManagementLazyQueryHookResult = ReturnType<typeof useAllUsersForUserManagementLazyQuery>;
export type AllUsersForUserManagementSuspenseQueryHookResult = ReturnType<typeof useAllUsersForUserManagementSuspenseQuery>;
export type AllUsersForUserManagementQueryResult = Apollo.QueryResult<AllUsersForUserManagementQuery, AllUsersForUserManagementQueryVariables>;
export const BlockOrUnblockUserDocument = gql`
    mutation BlockOrUnblockUser($userId: ID!) {
  blockOrUnblockUser(userId: $userId) {
    id
    status
  }
}
    `;
export type BlockOrUnblockUserMutationFn = Apollo.MutationFunction<BlockOrUnblockUserMutation, BlockOrUnblockUserMutationVariables>;

/**
 * __useBlockOrUnblockUserMutation__
 *
 * To run a mutation, you first call `useBlockOrUnblockUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBlockOrUnblockUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [blockOrUnblockUserMutation, { data, loading, error }] = useBlockOrUnblockUserMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useBlockOrUnblockUserMutation(baseOptions?: Apollo.MutationHookOptions<BlockOrUnblockUserMutation, BlockOrUnblockUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<BlockOrUnblockUserMutation, BlockOrUnblockUserMutationVariables>(BlockOrUnblockUserDocument, options);
      }
export type BlockOrUnblockUserMutationHookResult = ReturnType<typeof useBlockOrUnblockUserMutation>;
export type BlockOrUnblockUserMutationResult = Apollo.MutationResult<BlockOrUnblockUserMutation>;
export type BlockOrUnblockUserMutationOptions = Apollo.BaseMutationOptions<BlockOrUnblockUserMutation, BlockOrUnblockUserMutationVariables>;
export const ResetPasswordDocument = gql`
    mutation ResetPassword($input: ResetPasswordInput!) {
  resetPassword(input: $input)
}
    `;
export type ResetPasswordMutationFn = Apollo.MutationFunction<ResetPasswordMutation, ResetPasswordMutationVariables>;

/**
 * __useResetPasswordMutation__
 *
 * To run a mutation, you first call `useResetPasswordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResetPasswordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resetPasswordMutation, { data, loading, error }] = useResetPasswordMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useResetPasswordMutation(baseOptions?: Apollo.MutationHookOptions<ResetPasswordMutation, ResetPasswordMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ResetPasswordMutation, ResetPasswordMutationVariables>(ResetPasswordDocument, options);
      }
export type ResetPasswordMutationHookResult = ReturnType<typeof useResetPasswordMutation>;
export type ResetPasswordMutationResult = Apollo.MutationResult<ResetPasswordMutation>;
export type ResetPasswordMutationOptions = Apollo.BaseMutationOptions<ResetPasswordMutation, ResetPasswordMutationVariables>;
export const AllStructuresForAddPlatformDialogDocument = gql`
    query AllStructuresForAddPlatformDialog($input: StructureFilters) {
  allStructures(input: $input) {
    coverImagePath
    id
    name
    description
  }
}
    `;

/**
 * __useAllStructuresForAddPlatformDialogQuery__
 *
 * To run a query within a React component, call `useAllStructuresForAddPlatformDialogQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllStructuresForAddPlatformDialogQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllStructuresForAddPlatformDialogQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAllStructuresForAddPlatformDialogQuery(baseOptions?: Apollo.QueryHookOptions<AllStructuresForAddPlatformDialogQuery, AllStructuresForAddPlatformDialogQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AllStructuresForAddPlatformDialogQuery, AllStructuresForAddPlatformDialogQueryVariables>(AllStructuresForAddPlatformDialogDocument, options);
      }
export function useAllStructuresForAddPlatformDialogLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AllStructuresForAddPlatformDialogQuery, AllStructuresForAddPlatformDialogQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AllStructuresForAddPlatformDialogQuery, AllStructuresForAddPlatformDialogQueryVariables>(AllStructuresForAddPlatformDialogDocument, options);
        }
// @ts-ignore
export function useAllStructuresForAddPlatformDialogSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<AllStructuresForAddPlatformDialogQuery, AllStructuresForAddPlatformDialogQueryVariables>): Apollo.UseSuspenseQueryResult<AllStructuresForAddPlatformDialogQuery, AllStructuresForAddPlatformDialogQueryVariables>;
export function useAllStructuresForAddPlatformDialogSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AllStructuresForAddPlatformDialogQuery, AllStructuresForAddPlatformDialogQueryVariables>): Apollo.UseSuspenseQueryResult<AllStructuresForAddPlatformDialogQuery | undefined, AllStructuresForAddPlatformDialogQueryVariables>;
export function useAllStructuresForAddPlatformDialogSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AllStructuresForAddPlatformDialogQuery, AllStructuresForAddPlatformDialogQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AllStructuresForAddPlatformDialogQuery, AllStructuresForAddPlatformDialogQueryVariables>(AllStructuresForAddPlatformDialogDocument, options);
        }
export type AllStructuresForAddPlatformDialogQueryHookResult = ReturnType<typeof useAllStructuresForAddPlatformDialogQuery>;
export type AllStructuresForAddPlatformDialogLazyQueryHookResult = ReturnType<typeof useAllStructuresForAddPlatformDialogLazyQuery>;
export type AllStructuresForAddPlatformDialogSuspenseQueryHookResult = ReturnType<typeof useAllStructuresForAddPlatformDialogSuspenseQuery>;
export type AllStructuresForAddPlatformDialogQueryResult = Apollo.QueryResult<AllStructuresForAddPlatformDialogQuery, AllStructuresForAddPlatformDialogQueryVariables>;
export const AllUsersForAddUserDialogDocument = gql`
    query AllUsersForAddUserDialog($input: FilterForUsers) {
  allUsers(input: $input) {
    id
    email
    picture
    name
    roleIds {
      id
      name
      description
      auth0Id
    }
    connection
    status
    loginCount
    lastLogin
    loginType
  }
}
    `;

/**
 * __useAllUsersForAddUserDialogQuery__
 *
 * To run a query within a React component, call `useAllUsersForAddUserDialogQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllUsersForAddUserDialogQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllUsersForAddUserDialogQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAllUsersForAddUserDialogQuery(baseOptions?: Apollo.QueryHookOptions<AllUsersForAddUserDialogQuery, AllUsersForAddUserDialogQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AllUsersForAddUserDialogQuery, AllUsersForAddUserDialogQueryVariables>(AllUsersForAddUserDialogDocument, options);
      }
export function useAllUsersForAddUserDialogLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AllUsersForAddUserDialogQuery, AllUsersForAddUserDialogQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AllUsersForAddUserDialogQuery, AllUsersForAddUserDialogQueryVariables>(AllUsersForAddUserDialogDocument, options);
        }
// @ts-ignore
export function useAllUsersForAddUserDialogSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<AllUsersForAddUserDialogQuery, AllUsersForAddUserDialogQueryVariables>): Apollo.UseSuspenseQueryResult<AllUsersForAddUserDialogQuery, AllUsersForAddUserDialogQueryVariables>;
export function useAllUsersForAddUserDialogSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AllUsersForAddUserDialogQuery, AllUsersForAddUserDialogQueryVariables>): Apollo.UseSuspenseQueryResult<AllUsersForAddUserDialogQuery | undefined, AllUsersForAddUserDialogQueryVariables>;
export function useAllUsersForAddUserDialogSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AllUsersForAddUserDialogQuery, AllUsersForAddUserDialogQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AllUsersForAddUserDialogQuery, AllUsersForAddUserDialogQueryVariables>(AllUsersForAddUserDialogDocument, options);
        }
export type AllUsersForAddUserDialogQueryHookResult = ReturnType<typeof useAllUsersForAddUserDialogQuery>;
export type AllUsersForAddUserDialogLazyQueryHookResult = ReturnType<typeof useAllUsersForAddUserDialogLazyQuery>;
export type AllUsersForAddUserDialogSuspenseQueryHookResult = ReturnType<typeof useAllUsersForAddUserDialogSuspenseQuery>;
export type AllUsersForAddUserDialogQueryResult = Apollo.QueryResult<AllUsersForAddUserDialogQuery, AllUsersForAddUserDialogQueryVariables>;
export const PreRegisteredUsersDocument = gql`
    query PreRegisteredUsers($pageInfo: PageInfo, $input: FiltersForPreRegisteredUsers) {
  preRegisteredUsers(pageInfo: $pageInfo, input: $input) {
    id
    email
  }
  preRegisteredUsersCount(input: $input) {
    count
  }
}
    `;

/**
 * __usePreRegisteredUsersQuery__
 *
 * To run a query within a React component, call `usePreRegisteredUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `usePreRegisteredUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePreRegisteredUsersQuery({
 *   variables: {
 *      pageInfo: // value for 'pageInfo'
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePreRegisteredUsersQuery(baseOptions?: Apollo.QueryHookOptions<PreRegisteredUsersQuery, PreRegisteredUsersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PreRegisteredUsersQuery, PreRegisteredUsersQueryVariables>(PreRegisteredUsersDocument, options);
      }
export function usePreRegisteredUsersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PreRegisteredUsersQuery, PreRegisteredUsersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PreRegisteredUsersQuery, PreRegisteredUsersQueryVariables>(PreRegisteredUsersDocument, options);
        }
// @ts-ignore
export function usePreRegisteredUsersSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<PreRegisteredUsersQuery, PreRegisteredUsersQueryVariables>): Apollo.UseSuspenseQueryResult<PreRegisteredUsersQuery, PreRegisteredUsersQueryVariables>;
export function usePreRegisteredUsersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PreRegisteredUsersQuery, PreRegisteredUsersQueryVariables>): Apollo.UseSuspenseQueryResult<PreRegisteredUsersQuery | undefined, PreRegisteredUsersQueryVariables>;
export function usePreRegisteredUsersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PreRegisteredUsersQuery, PreRegisteredUsersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PreRegisteredUsersQuery, PreRegisteredUsersQueryVariables>(PreRegisteredUsersDocument, options);
        }
export type PreRegisteredUsersQueryHookResult = ReturnType<typeof usePreRegisteredUsersQuery>;
export type PreRegisteredUsersLazyQueryHookResult = ReturnType<typeof usePreRegisteredUsersLazyQuery>;
export type PreRegisteredUsersSuspenseQueryHookResult = ReturnType<typeof usePreRegisteredUsersSuspenseQuery>;
export type PreRegisteredUsersQueryResult = Apollo.QueryResult<PreRegisteredUsersQuery, PreRegisteredUsersQueryVariables>;
export const CreatePreRegisteredUsersDocument = gql`
    mutation CreatePreRegisteredUsers($input: PreRegisteredUserInput) {
  createPreRegisteredUsers(input: $input) {
    createdUsers {
      email
      status
      id
    }
    failedUsers {
      email
      errorMessage
    }
  }
}
    `;
export type CreatePreRegisteredUsersMutationFn = Apollo.MutationFunction<CreatePreRegisteredUsersMutation, CreatePreRegisteredUsersMutationVariables>;

/**
 * __useCreatePreRegisteredUsersMutation__
 *
 * To run a mutation, you first call `useCreatePreRegisteredUsersMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePreRegisteredUsersMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPreRegisteredUsersMutation, { data, loading, error }] = useCreatePreRegisteredUsersMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreatePreRegisteredUsersMutation(baseOptions?: Apollo.MutationHookOptions<CreatePreRegisteredUsersMutation, CreatePreRegisteredUsersMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreatePreRegisteredUsersMutation, CreatePreRegisteredUsersMutationVariables>(CreatePreRegisteredUsersDocument, options);
      }
export type CreatePreRegisteredUsersMutationHookResult = ReturnType<typeof useCreatePreRegisteredUsersMutation>;
export type CreatePreRegisteredUsersMutationResult = Apollo.MutationResult<CreatePreRegisteredUsersMutation>;
export type CreatePreRegisteredUsersMutationOptions = Apollo.BaseMutationOptions<CreatePreRegisteredUsersMutation, CreatePreRegisteredUsersMutationVariables>;
export const DeletePreRegisteredUserDocument = gql`
    mutation DeletePreRegisteredUser($userId: ID) {
  deletePreRegisteredUser(userId: $userId) {
    email
  }
}
    `;
export type DeletePreRegisteredUserMutationFn = Apollo.MutationFunction<DeletePreRegisteredUserMutation, DeletePreRegisteredUserMutationVariables>;

/**
 * __useDeletePreRegisteredUserMutation__
 *
 * To run a mutation, you first call `useDeletePreRegisteredUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeletePreRegisteredUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deletePreRegisteredUserMutation, { data, loading, error }] = useDeletePreRegisteredUserMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useDeletePreRegisteredUserMutation(baseOptions?: Apollo.MutationHookOptions<DeletePreRegisteredUserMutation, DeletePreRegisteredUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeletePreRegisteredUserMutation, DeletePreRegisteredUserMutationVariables>(DeletePreRegisteredUserDocument, options);
      }
export type DeletePreRegisteredUserMutationHookResult = ReturnType<typeof useDeletePreRegisteredUserMutation>;
export type DeletePreRegisteredUserMutationResult = Apollo.MutationResult<DeletePreRegisteredUserMutation>;
export type DeletePreRegisteredUserMutationOptions = Apollo.BaseMutationOptions<DeletePreRegisteredUserMutation, DeletePreRegisteredUserMutationVariables>;
export const AddUsersToUserGroupDocument = gql`
    mutation AddUsersToUserGroup($input: AddRemoveUsersToFromUserGroupInput) {
  addUsersToUserGroup(input: $input) {
    id
    name
    userIds
    createdBy
    updatedBy
    createdAt
    updatedAt
  }
}
    `;
export type AddUsersToUserGroupMutationFn = Apollo.MutationFunction<AddUsersToUserGroupMutation, AddUsersToUserGroupMutationVariables>;

/**
 * __useAddUsersToUserGroupMutation__
 *
 * To run a mutation, you first call `useAddUsersToUserGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddUsersToUserGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addUsersToUserGroupMutation, { data, loading, error }] = useAddUsersToUserGroupMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddUsersToUserGroupMutation(baseOptions?: Apollo.MutationHookOptions<AddUsersToUserGroupMutation, AddUsersToUserGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddUsersToUserGroupMutation, AddUsersToUserGroupMutationVariables>(AddUsersToUserGroupDocument, options);
      }
export type AddUsersToUserGroupMutationHookResult = ReturnType<typeof useAddUsersToUserGroupMutation>;
export type AddUsersToUserGroupMutationResult = Apollo.MutationResult<AddUsersToUserGroupMutation>;
export type AddUsersToUserGroupMutationOptions = Apollo.BaseMutationOptions<AddUsersToUserGroupMutation, AddUsersToUserGroupMutationVariables>;
export const GetAllTeamsForUserManagementDocument = gql`
    query GetAllTeamsForUserManagement {
  allTeams {
    id
    name
    users {
      id
    }
  }
}
    `;

/**
 * __useGetAllTeamsForUserManagementQuery__
 *
 * To run a query within a React component, call `useGetAllTeamsForUserManagementQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllTeamsForUserManagementQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllTeamsForUserManagementQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAllTeamsForUserManagementQuery(baseOptions?: Apollo.QueryHookOptions<GetAllTeamsForUserManagementQuery, GetAllTeamsForUserManagementQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllTeamsForUserManagementQuery, GetAllTeamsForUserManagementQueryVariables>(GetAllTeamsForUserManagementDocument, options);
      }
export function useGetAllTeamsForUserManagementLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllTeamsForUserManagementQuery, GetAllTeamsForUserManagementQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllTeamsForUserManagementQuery, GetAllTeamsForUserManagementQueryVariables>(GetAllTeamsForUserManagementDocument, options);
        }
// @ts-ignore
export function useGetAllTeamsForUserManagementSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetAllTeamsForUserManagementQuery, GetAllTeamsForUserManagementQueryVariables>): Apollo.UseSuspenseQueryResult<GetAllTeamsForUserManagementQuery, GetAllTeamsForUserManagementQueryVariables>;
export function useGetAllTeamsForUserManagementSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAllTeamsForUserManagementQuery, GetAllTeamsForUserManagementQueryVariables>): Apollo.UseSuspenseQueryResult<GetAllTeamsForUserManagementQuery | undefined, GetAllTeamsForUserManagementQueryVariables>;
export function useGetAllTeamsForUserManagementSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAllTeamsForUserManagementQuery, GetAllTeamsForUserManagementQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAllTeamsForUserManagementQuery, GetAllTeamsForUserManagementQueryVariables>(GetAllTeamsForUserManagementDocument, options);
        }
export type GetAllTeamsForUserManagementQueryHookResult = ReturnType<typeof useGetAllTeamsForUserManagementQuery>;
export type GetAllTeamsForUserManagementLazyQueryHookResult = ReturnType<typeof useGetAllTeamsForUserManagementLazyQuery>;
export type GetAllTeamsForUserManagementSuspenseQueryHookResult = ReturnType<typeof useGetAllTeamsForUserManagementSuspenseQuery>;
export type GetAllTeamsForUserManagementQueryResult = Apollo.QueryResult<GetAllTeamsForUserManagementQuery, GetAllTeamsForUserManagementQueryVariables>;
export const GetUsersByTeamDocument = gql`
    query GetUsersByTeam($teamId: ID!, $pageInfo: PageInfo) {
  usersByTeam(teamId: $teamId, pageInfo: $pageInfo) {
    id
    name
    email
    picture
  }
}
    `;

/**
 * __useGetUsersByTeamQuery__
 *
 * To run a query within a React component, call `useGetUsersByTeamQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUsersByTeamQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUsersByTeamQuery({
 *   variables: {
 *      teamId: // value for 'teamId'
 *      pageInfo: // value for 'pageInfo'
 *   },
 * });
 */
export function useGetUsersByTeamQuery(baseOptions: Apollo.QueryHookOptions<GetUsersByTeamQuery, GetUsersByTeamQueryVariables> & ({ variables: GetUsersByTeamQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUsersByTeamQuery, GetUsersByTeamQueryVariables>(GetUsersByTeamDocument, options);
      }
export function useGetUsersByTeamLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUsersByTeamQuery, GetUsersByTeamQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUsersByTeamQuery, GetUsersByTeamQueryVariables>(GetUsersByTeamDocument, options);
        }
// @ts-ignore
export function useGetUsersByTeamSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetUsersByTeamQuery, GetUsersByTeamQueryVariables>): Apollo.UseSuspenseQueryResult<GetUsersByTeamQuery, GetUsersByTeamQueryVariables>;
export function useGetUsersByTeamSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetUsersByTeamQuery, GetUsersByTeamQueryVariables>): Apollo.UseSuspenseQueryResult<GetUsersByTeamQuery | undefined, GetUsersByTeamQueryVariables>;
export function useGetUsersByTeamSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetUsersByTeamQuery, GetUsersByTeamQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetUsersByTeamQuery, GetUsersByTeamQueryVariables>(GetUsersByTeamDocument, options);
        }
export type GetUsersByTeamQueryHookResult = ReturnType<typeof useGetUsersByTeamQuery>;
export type GetUsersByTeamLazyQueryHookResult = ReturnType<typeof useGetUsersByTeamLazyQuery>;
export type GetUsersByTeamSuspenseQueryHookResult = ReturnType<typeof useGetUsersByTeamSuspenseQuery>;
export type GetUsersByTeamQueryResult = Apollo.QueryResult<GetUsersByTeamQuery, GetUsersByTeamQueryVariables>;
export const CreateTeamDocument = gql`
    mutation CreateTeam($name: String!) {
  createTeam(name: $name) {
    id
    name
  }
}
    `;
export type CreateTeamMutationFn = Apollo.MutationFunction<CreateTeamMutation, CreateTeamMutationVariables>;

/**
 * __useCreateTeamMutation__
 *
 * To run a mutation, you first call `useCreateTeamMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateTeamMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createTeamMutation, { data, loading, error }] = useCreateTeamMutation({
 *   variables: {
 *      name: // value for 'name'
 *   },
 * });
 */
export function useCreateTeamMutation(baseOptions?: Apollo.MutationHookOptions<CreateTeamMutation, CreateTeamMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateTeamMutation, CreateTeamMutationVariables>(CreateTeamDocument, options);
      }
export type CreateTeamMutationHookResult = ReturnType<typeof useCreateTeamMutation>;
export type CreateTeamMutationResult = Apollo.MutationResult<CreateTeamMutation>;
export type CreateTeamMutationOptions = Apollo.BaseMutationOptions<CreateTeamMutation, CreateTeamMutationVariables>;
export const DeleteTeamDocument = gql`
    mutation DeleteTeam($teamId: ID!) {
  deleteTeam(teamId: $teamId)
}
    `;
export type DeleteTeamMutationFn = Apollo.MutationFunction<DeleteTeamMutation, DeleteTeamMutationVariables>;

/**
 * __useDeleteTeamMutation__
 *
 * To run a mutation, you first call `useDeleteTeamMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteTeamMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteTeamMutation, { data, loading, error }] = useDeleteTeamMutation({
 *   variables: {
 *      teamId: // value for 'teamId'
 *   },
 * });
 */
export function useDeleteTeamMutation(baseOptions?: Apollo.MutationHookOptions<DeleteTeamMutation, DeleteTeamMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteTeamMutation, DeleteTeamMutationVariables>(DeleteTeamDocument, options);
      }
export type DeleteTeamMutationHookResult = ReturnType<typeof useDeleteTeamMutation>;
export type DeleteTeamMutationResult = Apollo.MutationResult<DeleteTeamMutation>;
export type DeleteTeamMutationOptions = Apollo.BaseMutationOptions<DeleteTeamMutation, DeleteTeamMutationVariables>;
export const AddUsersToTeamDocument = gql`
    mutation AddUsersToTeam($input: UpdateTeamInput!) {
  addUsersToTeam(input: $input) {
    id
  }
}
    `;
export type AddUsersToTeamMutationFn = Apollo.MutationFunction<AddUsersToTeamMutation, AddUsersToTeamMutationVariables>;

/**
 * __useAddUsersToTeamMutation__
 *
 * To run a mutation, you first call `useAddUsersToTeamMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddUsersToTeamMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addUsersToTeamMutation, { data, loading, error }] = useAddUsersToTeamMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddUsersToTeamMutation(baseOptions?: Apollo.MutationHookOptions<AddUsersToTeamMutation, AddUsersToTeamMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddUsersToTeamMutation, AddUsersToTeamMutationVariables>(AddUsersToTeamDocument, options);
      }
export type AddUsersToTeamMutationHookResult = ReturnType<typeof useAddUsersToTeamMutation>;
export type AddUsersToTeamMutationResult = Apollo.MutationResult<AddUsersToTeamMutation>;
export type AddUsersToTeamMutationOptions = Apollo.BaseMutationOptions<AddUsersToTeamMutation, AddUsersToTeamMutationVariables>;
export const RemoveUsersFromTeamDocument = gql`
    mutation RemoveUsersFromTeam($input: UpdateTeamInput!) {
  removeUsersFromTeam(input: $input) {
    id
  }
}
    `;
export type RemoveUsersFromTeamMutationFn = Apollo.MutationFunction<RemoveUsersFromTeamMutation, RemoveUsersFromTeamMutationVariables>;

/**
 * __useRemoveUsersFromTeamMutation__
 *
 * To run a mutation, you first call `useRemoveUsersFromTeamMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveUsersFromTeamMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeUsersFromTeamMutation, { data, loading, error }] = useRemoveUsersFromTeamMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRemoveUsersFromTeamMutation(baseOptions?: Apollo.MutationHookOptions<RemoveUsersFromTeamMutation, RemoveUsersFromTeamMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveUsersFromTeamMutation, RemoveUsersFromTeamMutationVariables>(RemoveUsersFromTeamDocument, options);
      }
export type RemoveUsersFromTeamMutationHookResult = ReturnType<typeof useRemoveUsersFromTeamMutation>;
export type RemoveUsersFromTeamMutationResult = Apollo.MutationResult<RemoveUsersFromTeamMutation>;
export type RemoveUsersFromTeamMutationOptions = Apollo.BaseMutationOptions<RemoveUsersFromTeamMutation, RemoveUsersFromTeamMutationVariables>;
export const AllUserGroupsForUserManagementDocument = gql`
    query AllUserGroupsForUserManagement($userId: ID) {
  allUserGroups(userId: $userId) {
    id
    name
    userIds
    createdBy
    updatedBy
    createdAt
    updatedAt
  }
}
    `;

/**
 * __useAllUserGroupsForUserManagementQuery__
 *
 * To run a query within a React component, call `useAllUserGroupsForUserManagementQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllUserGroupsForUserManagementQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllUserGroupsForUserManagementQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useAllUserGroupsForUserManagementQuery(baseOptions?: Apollo.QueryHookOptions<AllUserGroupsForUserManagementQuery, AllUserGroupsForUserManagementQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AllUserGroupsForUserManagementQuery, AllUserGroupsForUserManagementQueryVariables>(AllUserGroupsForUserManagementDocument, options);
      }
export function useAllUserGroupsForUserManagementLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AllUserGroupsForUserManagementQuery, AllUserGroupsForUserManagementQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AllUserGroupsForUserManagementQuery, AllUserGroupsForUserManagementQueryVariables>(AllUserGroupsForUserManagementDocument, options);
        }
// @ts-ignore
export function useAllUserGroupsForUserManagementSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<AllUserGroupsForUserManagementQuery, AllUserGroupsForUserManagementQueryVariables>): Apollo.UseSuspenseQueryResult<AllUserGroupsForUserManagementQuery, AllUserGroupsForUserManagementQueryVariables>;
export function useAllUserGroupsForUserManagementSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AllUserGroupsForUserManagementQuery, AllUserGroupsForUserManagementQueryVariables>): Apollo.UseSuspenseQueryResult<AllUserGroupsForUserManagementQuery | undefined, AllUserGroupsForUserManagementQueryVariables>;
export function useAllUserGroupsForUserManagementSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AllUserGroupsForUserManagementQuery, AllUserGroupsForUserManagementQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AllUserGroupsForUserManagementQuery, AllUserGroupsForUserManagementQueryVariables>(AllUserGroupsForUserManagementDocument, options);
        }
export type AllUserGroupsForUserManagementQueryHookResult = ReturnType<typeof useAllUserGroupsForUserManagementQuery>;
export type AllUserGroupsForUserManagementLazyQueryHookResult = ReturnType<typeof useAllUserGroupsForUserManagementLazyQuery>;
export type AllUserGroupsForUserManagementSuspenseQueryHookResult = ReturnType<typeof useAllUserGroupsForUserManagementSuspenseQuery>;
export type AllUserGroupsForUserManagementQueryResult = Apollo.QueryResult<AllUserGroupsForUserManagementQuery, AllUserGroupsForUserManagementQueryVariables>;
export const AllRolesDocument = gql`
    query AllRoles {
  allRoles {
    id
    auth0Id
    name
    description
  }
}
    `;

/**
 * __useAllRolesQuery__
 *
 * To run a query within a React component, call `useAllRolesQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllRolesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllRolesQuery({
 *   variables: {
 *   },
 * });
 */
export function useAllRolesQuery(baseOptions?: Apollo.QueryHookOptions<AllRolesQuery, AllRolesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AllRolesQuery, AllRolesQueryVariables>(AllRolesDocument, options);
      }
export function useAllRolesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AllRolesQuery, AllRolesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AllRolesQuery, AllRolesQueryVariables>(AllRolesDocument, options);
        }
// @ts-ignore
export function useAllRolesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<AllRolesQuery, AllRolesQueryVariables>): Apollo.UseSuspenseQueryResult<AllRolesQuery, AllRolesQueryVariables>;
export function useAllRolesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AllRolesQuery, AllRolesQueryVariables>): Apollo.UseSuspenseQueryResult<AllRolesQuery | undefined, AllRolesQueryVariables>;
export function useAllRolesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AllRolesQuery, AllRolesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AllRolesQuery, AllRolesQueryVariables>(AllRolesDocument, options);
        }
export type AllRolesQueryHookResult = ReturnType<typeof useAllRolesQuery>;
export type AllRolesLazyQueryHookResult = ReturnType<typeof useAllRolesLazyQuery>;
export type AllRolesSuspenseQueryHookResult = ReturnType<typeof useAllRolesSuspenseQuery>;
export type AllRolesQueryResult = Apollo.QueryResult<AllRolesQuery, AllRolesQueryVariables>;
export const UsersCountDocument = gql`
    query UsersCount($input: FiltersForUsersCount) {
  usersCount(input: $input) {
    count
  }
}
    `;

/**
 * __useUsersCountQuery__
 *
 * To run a query within a React component, call `useUsersCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useUsersCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUsersCountQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUsersCountQuery(baseOptions?: Apollo.QueryHookOptions<UsersCountQuery, UsersCountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UsersCountQuery, UsersCountQueryVariables>(UsersCountDocument, options);
      }
export function useUsersCountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UsersCountQuery, UsersCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UsersCountQuery, UsersCountQueryVariables>(UsersCountDocument, options);
        }
// @ts-ignore
export function useUsersCountSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<UsersCountQuery, UsersCountQueryVariables>): Apollo.UseSuspenseQueryResult<UsersCountQuery, UsersCountQueryVariables>;
export function useUsersCountSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<UsersCountQuery, UsersCountQueryVariables>): Apollo.UseSuspenseQueryResult<UsersCountQuery | undefined, UsersCountQueryVariables>;
export function useUsersCountSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<UsersCountQuery, UsersCountQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<UsersCountQuery, UsersCountQueryVariables>(UsersCountDocument, options);
        }
export type UsersCountQueryHookResult = ReturnType<typeof useUsersCountQuery>;
export type UsersCountLazyQueryHookResult = ReturnType<typeof useUsersCountLazyQuery>;
export type UsersCountSuspenseQueryHookResult = ReturnType<typeof useUsersCountSuspenseQuery>;
export type UsersCountQueryResult = Apollo.QueryResult<UsersCountQuery, UsersCountQueryVariables>;
export const UsersByUserGroupDocument = gql`
    query UsersByUserGroup($input: FilterForUsersByUserGroup, $pageInfo: PageInfo, $usersCountInput: FiltersForUsersCount) {
  usersCount(input: $usersCountInput) {
    count
  }
  usersByUserGroup(input: $input, pageInfo: $pageInfo) {
    id
    email
    picture
    name
    connection
    roleIds {
      id
      name
      description
      auth0Id
      permissions
    }
  }
}
    `;

/**
 * __useUsersByUserGroupQuery__
 *
 * To run a query within a React component, call `useUsersByUserGroupQuery` and pass it any options that fit your needs.
 * When your component renders, `useUsersByUserGroupQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUsersByUserGroupQuery({
 *   variables: {
 *      input: // value for 'input'
 *      pageInfo: // value for 'pageInfo'
 *      usersCountInput: // value for 'usersCountInput'
 *   },
 * });
 */
export function useUsersByUserGroupQuery(baseOptions?: Apollo.QueryHookOptions<UsersByUserGroupQuery, UsersByUserGroupQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UsersByUserGroupQuery, UsersByUserGroupQueryVariables>(UsersByUserGroupDocument, options);
      }
export function useUsersByUserGroupLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UsersByUserGroupQuery, UsersByUserGroupQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UsersByUserGroupQuery, UsersByUserGroupQueryVariables>(UsersByUserGroupDocument, options);
        }
// @ts-ignore
export function useUsersByUserGroupSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<UsersByUserGroupQuery, UsersByUserGroupQueryVariables>): Apollo.UseSuspenseQueryResult<UsersByUserGroupQuery, UsersByUserGroupQueryVariables>;
export function useUsersByUserGroupSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<UsersByUserGroupQuery, UsersByUserGroupQueryVariables>): Apollo.UseSuspenseQueryResult<UsersByUserGroupQuery | undefined, UsersByUserGroupQueryVariables>;
export function useUsersByUserGroupSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<UsersByUserGroupQuery, UsersByUserGroupQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<UsersByUserGroupQuery, UsersByUserGroupQueryVariables>(UsersByUserGroupDocument, options);
        }
export type UsersByUserGroupQueryHookResult = ReturnType<typeof useUsersByUserGroupQuery>;
export type UsersByUserGroupLazyQueryHookResult = ReturnType<typeof useUsersByUserGroupLazyQuery>;
export type UsersByUserGroupSuspenseQueryHookResult = ReturnType<typeof useUsersByUserGroupSuspenseQuery>;
export type UsersByUserGroupQueryResult = Apollo.QueryResult<UsersByUserGroupQuery, UsersByUserGroupQueryVariables>;
export const GetAuth0ConnectionsDocument = gql`
    query GetAuth0Connections($applicationId: String!) {
  auth0Connections: getAuth0Connections(applicationId: $applicationId) {
    id
    name
  }
}
    `;

/**
 * __useGetAuth0ConnectionsQuery__
 *
 * To run a query within a React component, call `useGetAuth0ConnectionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAuth0ConnectionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAuth0ConnectionsQuery({
 *   variables: {
 *      applicationId: // value for 'applicationId'
 *   },
 * });
 */
export function useGetAuth0ConnectionsQuery(baseOptions: Apollo.QueryHookOptions<GetAuth0ConnectionsQuery, GetAuth0ConnectionsQueryVariables> & ({ variables: GetAuth0ConnectionsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAuth0ConnectionsQuery, GetAuth0ConnectionsQueryVariables>(GetAuth0ConnectionsDocument, options);
      }
export function useGetAuth0ConnectionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAuth0ConnectionsQuery, GetAuth0ConnectionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAuth0ConnectionsQuery, GetAuth0ConnectionsQueryVariables>(GetAuth0ConnectionsDocument, options);
        }
// @ts-ignore
export function useGetAuth0ConnectionsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetAuth0ConnectionsQuery, GetAuth0ConnectionsQueryVariables>): Apollo.UseSuspenseQueryResult<GetAuth0ConnectionsQuery, GetAuth0ConnectionsQueryVariables>;
export function useGetAuth0ConnectionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAuth0ConnectionsQuery, GetAuth0ConnectionsQueryVariables>): Apollo.UseSuspenseQueryResult<GetAuth0ConnectionsQuery | undefined, GetAuth0ConnectionsQueryVariables>;
export function useGetAuth0ConnectionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAuth0ConnectionsQuery, GetAuth0ConnectionsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAuth0ConnectionsQuery, GetAuth0ConnectionsQueryVariables>(GetAuth0ConnectionsDocument, options);
        }
export type GetAuth0ConnectionsQueryHookResult = ReturnType<typeof useGetAuth0ConnectionsQuery>;
export type GetAuth0ConnectionsLazyQueryHookResult = ReturnType<typeof useGetAuth0ConnectionsLazyQuery>;
export type GetAuth0ConnectionsSuspenseQueryHookResult = ReturnType<typeof useGetAuth0ConnectionsSuspenseQuery>;
export type GetAuth0ConnectionsQueryResult = Apollo.QueryResult<GetAuth0ConnectionsQuery, GetAuth0ConnectionsQueryVariables>;
export const RemoveUsersFromUserGroupDocument = gql`
    mutation RemoveUsersFromUserGroup($input: AddRemoveUsersToFromUserGroupInput) {
  removeUsersFromUserGroup(input: $input) {
    id
    name
    userIds
    createdBy
    updatedBy
    createdAt
    updatedAt
  }
}
    `;
export type RemoveUsersFromUserGroupMutationFn = Apollo.MutationFunction<RemoveUsersFromUserGroupMutation, RemoveUsersFromUserGroupMutationVariables>;

/**
 * __useRemoveUsersFromUserGroupMutation__
 *
 * To run a mutation, you first call `useRemoveUsersFromUserGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveUsersFromUserGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeUsersFromUserGroupMutation, { data, loading, error }] = useRemoveUsersFromUserGroupMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRemoveUsersFromUserGroupMutation(baseOptions?: Apollo.MutationHookOptions<RemoveUsersFromUserGroupMutation, RemoveUsersFromUserGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveUsersFromUserGroupMutation, RemoveUsersFromUserGroupMutationVariables>(RemoveUsersFromUserGroupDocument, options);
      }
export type RemoveUsersFromUserGroupMutationHookResult = ReturnType<typeof useRemoveUsersFromUserGroupMutation>;
export type RemoveUsersFromUserGroupMutationResult = Apollo.MutationResult<RemoveUsersFromUserGroupMutation>;
export type RemoveUsersFromUserGroupMutationOptions = Apollo.BaseMutationOptions<RemoveUsersFromUserGroupMutation, RemoveUsersFromUserGroupMutationVariables>;
export const InviteUsersDocument = gql`
    mutation InviteUsers($input: InviteUsersInput) {
  inviteUsers(input: $input) {
    createdUsers {
      email
      status
      id
    }
    failedUsers {
      email
      errorMessage
    }
  }
}
    `;
export type InviteUsersMutationFn = Apollo.MutationFunction<InviteUsersMutation, InviteUsersMutationVariables>;

/**
 * __useInviteUsersMutation__
 *
 * To run a mutation, you first call `useInviteUsersMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInviteUsersMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [inviteUsersMutation, { data, loading, error }] = useInviteUsersMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useInviteUsersMutation(baseOptions?: Apollo.MutationHookOptions<InviteUsersMutation, InviteUsersMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InviteUsersMutation, InviteUsersMutationVariables>(InviteUsersDocument, options);
      }
export type InviteUsersMutationHookResult = ReturnType<typeof useInviteUsersMutation>;
export type InviteUsersMutationResult = Apollo.MutationResult<InviteUsersMutation>;
export type InviteUsersMutationOptions = Apollo.BaseMutationOptions<InviteUsersMutation, InviteUsersMutationVariables>;
export const CreateUserGroupDocument = gql`
    mutation CreateUserGroup($input: CreateUserGroupInput) {
  createUserGroup(input: $input) {
    id
    name
    userIds
    createdBy
    updatedBy
    createdAt
    updatedAt
  }
}
    `;
export type CreateUserGroupMutationFn = Apollo.MutationFunction<CreateUserGroupMutation, CreateUserGroupMutationVariables>;

/**
 * __useCreateUserGroupMutation__
 *
 * To run a mutation, you first call `useCreateUserGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateUserGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createUserGroupMutation, { data, loading, error }] = useCreateUserGroupMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateUserGroupMutation(baseOptions?: Apollo.MutationHookOptions<CreateUserGroupMutation, CreateUserGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateUserGroupMutation, CreateUserGroupMutationVariables>(CreateUserGroupDocument, options);
      }
export type CreateUserGroupMutationHookResult = ReturnType<typeof useCreateUserGroupMutation>;
export type CreateUserGroupMutationResult = Apollo.MutationResult<CreateUserGroupMutation>;
export type CreateUserGroupMutationOptions = Apollo.BaseMutationOptions<CreateUserGroupMutation, CreateUserGroupMutationVariables>;
export const AllStructuresForUserManagementDocument = gql`
    query AllStructuresForUserManagement {
  allStructures {
    id
    name
    coverImagePath
    userGroups {
      id
      name
    }
  }
}
    `;

/**
 * __useAllStructuresForUserManagementQuery__
 *
 * To run a query within a React component, call `useAllStructuresForUserManagementQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllStructuresForUserManagementQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllStructuresForUserManagementQuery({
 *   variables: {
 *   },
 * });
 */
export function useAllStructuresForUserManagementQuery(baseOptions?: Apollo.QueryHookOptions<AllStructuresForUserManagementQuery, AllStructuresForUserManagementQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AllStructuresForUserManagementQuery, AllStructuresForUserManagementQueryVariables>(AllStructuresForUserManagementDocument, options);
      }
export function useAllStructuresForUserManagementLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AllStructuresForUserManagementQuery, AllStructuresForUserManagementQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AllStructuresForUserManagementQuery, AllStructuresForUserManagementQueryVariables>(AllStructuresForUserManagementDocument, options);
        }
// @ts-ignore
export function useAllStructuresForUserManagementSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<AllStructuresForUserManagementQuery, AllStructuresForUserManagementQueryVariables>): Apollo.UseSuspenseQueryResult<AllStructuresForUserManagementQuery, AllStructuresForUserManagementQueryVariables>;
export function useAllStructuresForUserManagementSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AllStructuresForUserManagementQuery, AllStructuresForUserManagementQueryVariables>): Apollo.UseSuspenseQueryResult<AllStructuresForUserManagementQuery | undefined, AllStructuresForUserManagementQueryVariables>;
export function useAllStructuresForUserManagementSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AllStructuresForUserManagementQuery, AllStructuresForUserManagementQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AllStructuresForUserManagementQuery, AllStructuresForUserManagementQueryVariables>(AllStructuresForUserManagementDocument, options);
        }
export type AllStructuresForUserManagementQueryHookResult = ReturnType<typeof useAllStructuresForUserManagementQuery>;
export type AllStructuresForUserManagementLazyQueryHookResult = ReturnType<typeof useAllStructuresForUserManagementLazyQuery>;
export type AllStructuresForUserManagementSuspenseQueryHookResult = ReturnType<typeof useAllStructuresForUserManagementSuspenseQuery>;
export type AllStructuresForUserManagementQueryResult = Apollo.QueryResult<AllStructuresForUserManagementQuery, AllStructuresForUserManagementQueryVariables>;
export const StructuresByUserGroupDocument = gql`
    query StructuresByUserGroup($structuresInput: FiltersForStructureByUserGroup, $pageInfo: PageInfo, $input: FilterForStructures) {
  structuresByUserGroup(input: $structuresInput, pageInfo: $pageInfo) {
    id
    name
    coverImagePath
    description
  }
  structuresCount(input: $input) {
    count
  }
}
    `;

/**
 * __useStructuresByUserGroupQuery__
 *
 * To run a query within a React component, call `useStructuresByUserGroupQuery` and pass it any options that fit your needs.
 * When your component renders, `useStructuresByUserGroupQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStructuresByUserGroupQuery({
 *   variables: {
 *      structuresInput: // value for 'structuresInput'
 *      pageInfo: // value for 'pageInfo'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useStructuresByUserGroupQuery(baseOptions?: Apollo.QueryHookOptions<StructuresByUserGroupQuery, StructuresByUserGroupQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<StructuresByUserGroupQuery, StructuresByUserGroupQueryVariables>(StructuresByUserGroupDocument, options);
      }
export function useStructuresByUserGroupLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<StructuresByUserGroupQuery, StructuresByUserGroupQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<StructuresByUserGroupQuery, StructuresByUserGroupQueryVariables>(StructuresByUserGroupDocument, options);
        }
// @ts-ignore
export function useStructuresByUserGroupSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<StructuresByUserGroupQuery, StructuresByUserGroupQueryVariables>): Apollo.UseSuspenseQueryResult<StructuresByUserGroupQuery, StructuresByUserGroupQueryVariables>;
export function useStructuresByUserGroupSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<StructuresByUserGroupQuery, StructuresByUserGroupQueryVariables>): Apollo.UseSuspenseQueryResult<StructuresByUserGroupQuery | undefined, StructuresByUserGroupQueryVariables>;
export function useStructuresByUserGroupSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<StructuresByUserGroupQuery, StructuresByUserGroupQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<StructuresByUserGroupQuery, StructuresByUserGroupQueryVariables>(StructuresByUserGroupDocument, options);
        }
export type StructuresByUserGroupQueryHookResult = ReturnType<typeof useStructuresByUserGroupQuery>;
export type StructuresByUserGroupLazyQueryHookResult = ReturnType<typeof useStructuresByUserGroupLazyQuery>;
export type StructuresByUserGroupSuspenseQueryHookResult = ReturnType<typeof useStructuresByUserGroupSuspenseQuery>;
export type StructuresByUserGroupQueryResult = Apollo.QueryResult<StructuresByUserGroupQuery, StructuresByUserGroupQueryVariables>;
export const RemoveUserGroupsFromStructureDocument = gql`
    mutation RemoveUserGroupsFromStructure($input: AddRemoveStructuresToFromUserGroupsInput) {
  removeUserGroupsFromStructure(input: $input) {
    userGroups {
      id
      name
      userIds
      createdBy
      updatedBy
      createdAt
      updatedAt
    }
    structures {
      id
      name
    }
  }
}
    `;
export type RemoveUserGroupsFromStructureMutationFn = Apollo.MutationFunction<RemoveUserGroupsFromStructureMutation, RemoveUserGroupsFromStructureMutationVariables>;

/**
 * __useRemoveUserGroupsFromStructureMutation__
 *
 * To run a mutation, you first call `useRemoveUserGroupsFromStructureMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveUserGroupsFromStructureMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeUserGroupsFromStructureMutation, { data, loading, error }] = useRemoveUserGroupsFromStructureMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRemoveUserGroupsFromStructureMutation(baseOptions?: Apollo.MutationHookOptions<RemoveUserGroupsFromStructureMutation, RemoveUserGroupsFromStructureMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveUserGroupsFromStructureMutation, RemoveUserGroupsFromStructureMutationVariables>(RemoveUserGroupsFromStructureDocument, options);
      }
export type RemoveUserGroupsFromStructureMutationHookResult = ReturnType<typeof useRemoveUserGroupsFromStructureMutation>;
export type RemoveUserGroupsFromStructureMutationResult = Apollo.MutationResult<RemoveUserGroupsFromStructureMutation>;
export type RemoveUserGroupsFromStructureMutationOptions = Apollo.BaseMutationOptions<RemoveUserGroupsFromStructureMutation, RemoveUserGroupsFromStructureMutationVariables>;
export const AddUserGroupsToStructureDocument = gql`
    mutation AddUserGroupsToStructure($input: AddRemoveStructuresToFromUserGroupsInput) {
  addUserGroupsToStructure(input: $input) {
    userGroups {
      id
      name
      userIds
      createdBy
      updatedBy
      createdAt
      updatedAt
    }
    structures {
      id
      name
    }
  }
}
    `;
export type AddUserGroupsToStructureMutationFn = Apollo.MutationFunction<AddUserGroupsToStructureMutation, AddUserGroupsToStructureMutationVariables>;

/**
 * __useAddUserGroupsToStructureMutation__
 *
 * To run a mutation, you first call `useAddUserGroupsToStructureMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddUserGroupsToStructureMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addUserGroupsToStructureMutation, { data, loading, error }] = useAddUserGroupsToStructureMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddUserGroupsToStructureMutation(baseOptions?: Apollo.MutationHookOptions<AddUserGroupsToStructureMutation, AddUserGroupsToStructureMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddUserGroupsToStructureMutation, AddUserGroupsToStructureMutationVariables>(AddUserGroupsToStructureDocument, options);
      }
export type AddUserGroupsToStructureMutationHookResult = ReturnType<typeof useAddUserGroupsToStructureMutation>;
export type AddUserGroupsToStructureMutationResult = Apollo.MutationResult<AddUserGroupsToStructureMutation>;
export type AddUserGroupsToStructureMutationOptions = Apollo.BaseMutationOptions<AddUserGroupsToStructureMutation, AddUserGroupsToStructureMutationVariables>;
export const UsersByRoleIdDocument = gql`
    query UsersByRoleId($input: UsersByRoleInput, $pageInfo: PageInfo, $usersCountInput: FiltersForUsersCount) {
  usersCount(input: $usersCountInput) {
    count
  }
  usersByRoleId(input: $input, pageInfo: $pageInfo) {
    id
    email
    picture
    name
  }
}
    `;

/**
 * __useUsersByRoleIdQuery__
 *
 * To run a query within a React component, call `useUsersByRoleIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useUsersByRoleIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUsersByRoleIdQuery({
 *   variables: {
 *      input: // value for 'input'
 *      pageInfo: // value for 'pageInfo'
 *      usersCountInput: // value for 'usersCountInput'
 *   },
 * });
 */
export function useUsersByRoleIdQuery(baseOptions?: Apollo.QueryHookOptions<UsersByRoleIdQuery, UsersByRoleIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UsersByRoleIdQuery, UsersByRoleIdQueryVariables>(UsersByRoleIdDocument, options);
      }
export function useUsersByRoleIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UsersByRoleIdQuery, UsersByRoleIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UsersByRoleIdQuery, UsersByRoleIdQueryVariables>(UsersByRoleIdDocument, options);
        }
// @ts-ignore
export function useUsersByRoleIdSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<UsersByRoleIdQuery, UsersByRoleIdQueryVariables>): Apollo.UseSuspenseQueryResult<UsersByRoleIdQuery, UsersByRoleIdQueryVariables>;
export function useUsersByRoleIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<UsersByRoleIdQuery, UsersByRoleIdQueryVariables>): Apollo.UseSuspenseQueryResult<UsersByRoleIdQuery | undefined, UsersByRoleIdQueryVariables>;
export function useUsersByRoleIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<UsersByRoleIdQuery, UsersByRoleIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<UsersByRoleIdQuery, UsersByRoleIdQueryVariables>(UsersByRoleIdDocument, options);
        }
export type UsersByRoleIdQueryHookResult = ReturnType<typeof useUsersByRoleIdQuery>;
export type UsersByRoleIdLazyQueryHookResult = ReturnType<typeof useUsersByRoleIdLazyQuery>;
export type UsersByRoleIdSuspenseQueryHookResult = ReturnType<typeof useUsersByRoleIdSuspenseQuery>;
export type UsersByRoleIdQueryResult = Apollo.QueryResult<UsersByRoleIdQuery, UsersByRoleIdQueryVariables>;
export const RemoveRoleFromUsersDocument = gql`
    mutation RemoveRoleFromUsers($input: AssignRemoveRoleToFromUsersInput) {
  removeRoleFromUsers(input: $input) {
    id
    name
    auth0Id
    description
  }
}
    `;
export type RemoveRoleFromUsersMutationFn = Apollo.MutationFunction<RemoveRoleFromUsersMutation, RemoveRoleFromUsersMutationVariables>;

/**
 * __useRemoveRoleFromUsersMutation__
 *
 * To run a mutation, you first call `useRemoveRoleFromUsersMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveRoleFromUsersMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeRoleFromUsersMutation, { data, loading, error }] = useRemoveRoleFromUsersMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRemoveRoleFromUsersMutation(baseOptions?: Apollo.MutationHookOptions<RemoveRoleFromUsersMutation, RemoveRoleFromUsersMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveRoleFromUsersMutation, RemoveRoleFromUsersMutationVariables>(RemoveRoleFromUsersDocument, options);
      }
export type RemoveRoleFromUsersMutationHookResult = ReturnType<typeof useRemoveRoleFromUsersMutation>;
export type RemoveRoleFromUsersMutationResult = Apollo.MutationResult<RemoveRoleFromUsersMutation>;
export type RemoveRoleFromUsersMutationOptions = Apollo.BaseMutationOptions<RemoveRoleFromUsersMutation, RemoveRoleFromUsersMutationVariables>;
export const AssignRoleToUsersDocument = gql`
    mutation AssignRoleToUsers($input: AssignRemoveRoleToFromUsersInput) {
  assignRoleToUsers(input: $input) {
    id
    name
    auth0Id
    description
  }
}
    `;
export type AssignRoleToUsersMutationFn = Apollo.MutationFunction<AssignRoleToUsersMutation, AssignRoleToUsersMutationVariables>;

/**
 * __useAssignRoleToUsersMutation__
 *
 * To run a mutation, you first call `useAssignRoleToUsersMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAssignRoleToUsersMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [assignRoleToUsersMutation, { data, loading, error }] = useAssignRoleToUsersMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAssignRoleToUsersMutation(baseOptions?: Apollo.MutationHookOptions<AssignRoleToUsersMutation, AssignRoleToUsersMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AssignRoleToUsersMutation, AssignRoleToUsersMutationVariables>(AssignRoleToUsersDocument, options);
      }
export type AssignRoleToUsersMutationHookResult = ReturnType<typeof useAssignRoleToUsersMutation>;
export type AssignRoleToUsersMutationResult = Apollo.MutationResult<AssignRoleToUsersMutation>;
export type AssignRoleToUsersMutationOptions = Apollo.BaseMutationOptions<AssignRoleToUsersMutation, AssignRoleToUsersMutationVariables>;
export const UserDetailsDocument = gql`
    query UserDetails($userId: ID) {
  userDetails(userId: $userId) {
    user {
      email
      picture
      name
      permissions
      connection
      loginCount
      roleIds {
        name
        auth0Id
        description
        permissions
      }
    }
    userGroups {
      name
    }
    structures {
      id
      name
      coverImagePath
      description
    }
  }
}
    `;

/**
 * __useUserDetailsQuery__
 *
 * To run a query within a React component, call `useUserDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserDetailsQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useUserDetailsQuery(baseOptions?: Apollo.QueryHookOptions<UserDetailsQuery, UserDetailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserDetailsQuery, UserDetailsQueryVariables>(UserDetailsDocument, options);
      }
export function useUserDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserDetailsQuery, UserDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserDetailsQuery, UserDetailsQueryVariables>(UserDetailsDocument, options);
        }
// @ts-ignore
export function useUserDetailsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<UserDetailsQuery, UserDetailsQueryVariables>): Apollo.UseSuspenseQueryResult<UserDetailsQuery, UserDetailsQueryVariables>;
export function useUserDetailsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<UserDetailsQuery, UserDetailsQueryVariables>): Apollo.UseSuspenseQueryResult<UserDetailsQuery | undefined, UserDetailsQueryVariables>;
export function useUserDetailsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<UserDetailsQuery, UserDetailsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<UserDetailsQuery, UserDetailsQueryVariables>(UserDetailsDocument, options);
        }
export type UserDetailsQueryHookResult = ReturnType<typeof useUserDetailsQuery>;
export type UserDetailsLazyQueryHookResult = ReturnType<typeof useUserDetailsLazyQuery>;
export type UserDetailsSuspenseQueryHookResult = ReturnType<typeof useUserDetailsSuspenseQuery>;
export type UserDetailsQueryResult = Apollo.QueryResult<UserDetailsQuery, UserDetailsQueryVariables>;
export const GetDirectlyAssignedUserPermissionsDocument = gql`
    query GetDirectlyAssignedUserPermissions($userId: String!) {
  getDirectlyAssignedUserPermissions(userId: $userId) {
    description
    name
  }
}
    `;

/**
 * __useGetDirectlyAssignedUserPermissionsQuery__
 *
 * To run a query within a React component, call `useGetDirectlyAssignedUserPermissionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDirectlyAssignedUserPermissionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDirectlyAssignedUserPermissionsQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useGetDirectlyAssignedUserPermissionsQuery(baseOptions: Apollo.QueryHookOptions<GetDirectlyAssignedUserPermissionsQuery, GetDirectlyAssignedUserPermissionsQueryVariables> & ({ variables: GetDirectlyAssignedUserPermissionsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDirectlyAssignedUserPermissionsQuery, GetDirectlyAssignedUserPermissionsQueryVariables>(GetDirectlyAssignedUserPermissionsDocument, options);
      }
export function useGetDirectlyAssignedUserPermissionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDirectlyAssignedUserPermissionsQuery, GetDirectlyAssignedUserPermissionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDirectlyAssignedUserPermissionsQuery, GetDirectlyAssignedUserPermissionsQueryVariables>(GetDirectlyAssignedUserPermissionsDocument, options);
        }
// @ts-ignore
export function useGetDirectlyAssignedUserPermissionsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetDirectlyAssignedUserPermissionsQuery, GetDirectlyAssignedUserPermissionsQueryVariables>): Apollo.UseSuspenseQueryResult<GetDirectlyAssignedUserPermissionsQuery, GetDirectlyAssignedUserPermissionsQueryVariables>;
export function useGetDirectlyAssignedUserPermissionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetDirectlyAssignedUserPermissionsQuery, GetDirectlyAssignedUserPermissionsQueryVariables>): Apollo.UseSuspenseQueryResult<GetDirectlyAssignedUserPermissionsQuery | undefined, GetDirectlyAssignedUserPermissionsQueryVariables>;
export function useGetDirectlyAssignedUserPermissionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetDirectlyAssignedUserPermissionsQuery, GetDirectlyAssignedUserPermissionsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetDirectlyAssignedUserPermissionsQuery, GetDirectlyAssignedUserPermissionsQueryVariables>(GetDirectlyAssignedUserPermissionsDocument, options);
        }
export type GetDirectlyAssignedUserPermissionsQueryHookResult = ReturnType<typeof useGetDirectlyAssignedUserPermissionsQuery>;
export type GetDirectlyAssignedUserPermissionsLazyQueryHookResult = ReturnType<typeof useGetDirectlyAssignedUserPermissionsLazyQuery>;
export type GetDirectlyAssignedUserPermissionsSuspenseQueryHookResult = ReturnType<typeof useGetDirectlyAssignedUserPermissionsSuspenseQuery>;
export type GetDirectlyAssignedUserPermissionsQueryResult = Apollo.QueryResult<GetDirectlyAssignedUserPermissionsQuery, GetDirectlyAssignedUserPermissionsQueryVariables>;
export const GetAuth0PermissionsDocument = gql`
    query GetAuth0Permissions {
  getAuth0Permissions {
    name
    description
  }
}
    `;

/**
 * __useGetAuth0PermissionsQuery__
 *
 * To run a query within a React component, call `useGetAuth0PermissionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAuth0PermissionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAuth0PermissionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAuth0PermissionsQuery(baseOptions?: Apollo.QueryHookOptions<GetAuth0PermissionsQuery, GetAuth0PermissionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAuth0PermissionsQuery, GetAuth0PermissionsQueryVariables>(GetAuth0PermissionsDocument, options);
      }
export function useGetAuth0PermissionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAuth0PermissionsQuery, GetAuth0PermissionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAuth0PermissionsQuery, GetAuth0PermissionsQueryVariables>(GetAuth0PermissionsDocument, options);
        }
// @ts-ignore
export function useGetAuth0PermissionsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetAuth0PermissionsQuery, GetAuth0PermissionsQueryVariables>): Apollo.UseSuspenseQueryResult<GetAuth0PermissionsQuery, GetAuth0PermissionsQueryVariables>;
export function useGetAuth0PermissionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAuth0PermissionsQuery, GetAuth0PermissionsQueryVariables>): Apollo.UseSuspenseQueryResult<GetAuth0PermissionsQuery | undefined, GetAuth0PermissionsQueryVariables>;
export function useGetAuth0PermissionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAuth0PermissionsQuery, GetAuth0PermissionsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAuth0PermissionsQuery, GetAuth0PermissionsQueryVariables>(GetAuth0PermissionsDocument, options);
        }
export type GetAuth0PermissionsQueryHookResult = ReturnType<typeof useGetAuth0PermissionsQuery>;
export type GetAuth0PermissionsLazyQueryHookResult = ReturnType<typeof useGetAuth0PermissionsLazyQuery>;
export type GetAuth0PermissionsSuspenseQueryHookResult = ReturnType<typeof useGetAuth0PermissionsSuspenseQuery>;
export type GetAuth0PermissionsQueryResult = Apollo.QueryResult<GetAuth0PermissionsQuery, GetAuth0PermissionsQueryVariables>;
export const GetUserPermissionsByRolesDocument = gql`
    query GetUserPermissionsByRoles($userId: String!) {
  getUserPermissionsByRoles(userId: $userId) {
    name
    permissions {
      name
      description
    }
    auth0Id
    description
  }
}
    `;

/**
 * __useGetUserPermissionsByRolesQuery__
 *
 * To run a query within a React component, call `useGetUserPermissionsByRolesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserPermissionsByRolesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserPermissionsByRolesQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useGetUserPermissionsByRolesQuery(baseOptions: Apollo.QueryHookOptions<GetUserPermissionsByRolesQuery, GetUserPermissionsByRolesQueryVariables> & ({ variables: GetUserPermissionsByRolesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUserPermissionsByRolesQuery, GetUserPermissionsByRolesQueryVariables>(GetUserPermissionsByRolesDocument, options);
      }
export function useGetUserPermissionsByRolesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUserPermissionsByRolesQuery, GetUserPermissionsByRolesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUserPermissionsByRolesQuery, GetUserPermissionsByRolesQueryVariables>(GetUserPermissionsByRolesDocument, options);
        }
// @ts-ignore
export function useGetUserPermissionsByRolesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetUserPermissionsByRolesQuery, GetUserPermissionsByRolesQueryVariables>): Apollo.UseSuspenseQueryResult<GetUserPermissionsByRolesQuery, GetUserPermissionsByRolesQueryVariables>;
export function useGetUserPermissionsByRolesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetUserPermissionsByRolesQuery, GetUserPermissionsByRolesQueryVariables>): Apollo.UseSuspenseQueryResult<GetUserPermissionsByRolesQuery | undefined, GetUserPermissionsByRolesQueryVariables>;
export function useGetUserPermissionsByRolesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetUserPermissionsByRolesQuery, GetUserPermissionsByRolesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetUserPermissionsByRolesQuery, GetUserPermissionsByRolesQueryVariables>(GetUserPermissionsByRolesDocument, options);
        }
export type GetUserPermissionsByRolesQueryHookResult = ReturnType<typeof useGetUserPermissionsByRolesQuery>;
export type GetUserPermissionsByRolesLazyQueryHookResult = ReturnType<typeof useGetUserPermissionsByRolesLazyQuery>;
export type GetUserPermissionsByRolesSuspenseQueryHookResult = ReturnType<typeof useGetUserPermissionsByRolesSuspenseQuery>;
export type GetUserPermissionsByRolesQueryResult = Apollo.QueryResult<GetUserPermissionsByRolesQuery, GetUserPermissionsByRolesQueryVariables>;
export const PermissionsByRoleDocument = gql`
    query PermissionsByRole($roleId: String!) {
  permissionsByRole(roleId: $roleId) {
    key
    description
  }
}
    `;

/**
 * __usePermissionsByRoleQuery__
 *
 * To run a query within a React component, call `usePermissionsByRoleQuery` and pass it any options that fit your needs.
 * When your component renders, `usePermissionsByRoleQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePermissionsByRoleQuery({
 *   variables: {
 *      roleId: // value for 'roleId'
 *   },
 * });
 */
export function usePermissionsByRoleQuery(baseOptions: Apollo.QueryHookOptions<PermissionsByRoleQuery, PermissionsByRoleQueryVariables> & ({ variables: PermissionsByRoleQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PermissionsByRoleQuery, PermissionsByRoleQueryVariables>(PermissionsByRoleDocument, options);
      }
export function usePermissionsByRoleLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PermissionsByRoleQuery, PermissionsByRoleQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PermissionsByRoleQuery, PermissionsByRoleQueryVariables>(PermissionsByRoleDocument, options);
        }
// @ts-ignore
export function usePermissionsByRoleSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<PermissionsByRoleQuery, PermissionsByRoleQueryVariables>): Apollo.UseSuspenseQueryResult<PermissionsByRoleQuery, PermissionsByRoleQueryVariables>;
export function usePermissionsByRoleSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PermissionsByRoleQuery, PermissionsByRoleQueryVariables>): Apollo.UseSuspenseQueryResult<PermissionsByRoleQuery | undefined, PermissionsByRoleQueryVariables>;
export function usePermissionsByRoleSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PermissionsByRoleQuery, PermissionsByRoleQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PermissionsByRoleQuery, PermissionsByRoleQueryVariables>(PermissionsByRoleDocument, options);
        }
export type PermissionsByRoleQueryHookResult = ReturnType<typeof usePermissionsByRoleQuery>;
export type PermissionsByRoleLazyQueryHookResult = ReturnType<typeof usePermissionsByRoleLazyQuery>;
export type PermissionsByRoleSuspenseQueryHookResult = ReturnType<typeof usePermissionsByRoleSuspenseQuery>;
export type PermissionsByRoleQueryResult = Apollo.QueryResult<PermissionsByRoleQuery, PermissionsByRoleQueryVariables>;
export const DeleteUserGroupDocument = gql`
    mutation DeleteUserGroup($input: DeleteUserGroupInput) {
  deleteUserGroup(input: $input) {
    id
    name
    userIds
    createdBy
    updatedBy
    createdAt
    updatedAt
  }
}
    `;
export type DeleteUserGroupMutationFn = Apollo.MutationFunction<DeleteUserGroupMutation, DeleteUserGroupMutationVariables>;

/**
 * __useDeleteUserGroupMutation__
 *
 * To run a mutation, you first call `useDeleteUserGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteUserGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteUserGroupMutation, { data, loading, error }] = useDeleteUserGroupMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteUserGroupMutation(baseOptions?: Apollo.MutationHookOptions<DeleteUserGroupMutation, DeleteUserGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteUserGroupMutation, DeleteUserGroupMutationVariables>(DeleteUserGroupDocument, options);
      }
export type DeleteUserGroupMutationHookResult = ReturnType<typeof useDeleteUserGroupMutation>;
export type DeleteUserGroupMutationResult = Apollo.MutationResult<DeleteUserGroupMutation>;
export type DeleteUserGroupMutationOptions = Apollo.BaseMutationOptions<DeleteUserGroupMutation, DeleteUserGroupMutationVariables>;
export const GetUserAbilitiesDocument = gql`
    query GetUserAbilities {
  getUserAbilities
}
    `;

/**
 * __useGetUserAbilitiesQuery__
 *
 * To run a query within a React component, call `useGetUserAbilitiesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserAbilitiesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserAbilitiesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetUserAbilitiesQuery(baseOptions?: Apollo.QueryHookOptions<GetUserAbilitiesQuery, GetUserAbilitiesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUserAbilitiesQuery, GetUserAbilitiesQueryVariables>(GetUserAbilitiesDocument, options);
      }
export function useGetUserAbilitiesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUserAbilitiesQuery, GetUserAbilitiesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUserAbilitiesQuery, GetUserAbilitiesQueryVariables>(GetUserAbilitiesDocument, options);
        }
// @ts-ignore
export function useGetUserAbilitiesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetUserAbilitiesQuery, GetUserAbilitiesQueryVariables>): Apollo.UseSuspenseQueryResult<GetUserAbilitiesQuery, GetUserAbilitiesQueryVariables>;
export function useGetUserAbilitiesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetUserAbilitiesQuery, GetUserAbilitiesQueryVariables>): Apollo.UseSuspenseQueryResult<GetUserAbilitiesQuery | undefined, GetUserAbilitiesQueryVariables>;
export function useGetUserAbilitiesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetUserAbilitiesQuery, GetUserAbilitiesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetUserAbilitiesQuery, GetUserAbilitiesQueryVariables>(GetUserAbilitiesDocument, options);
        }
export type GetUserAbilitiesQueryHookResult = ReturnType<typeof useGetUserAbilitiesQuery>;
export type GetUserAbilitiesLazyQueryHookResult = ReturnType<typeof useGetUserAbilitiesLazyQuery>;
export type GetUserAbilitiesSuspenseQueryHookResult = ReturnType<typeof useGetUserAbilitiesSuspenseQuery>;
export type GetUserAbilitiesQueryResult = Apollo.QueryResult<GetUserAbilitiesQuery, GetUserAbilitiesQueryVariables>;
export const UpdateWorkflowStatusDocument = gql`
    mutation UpdateWorkflowStatus($input: UpdateWorkflowStatusInput) {
  updateWorkflowStatus(input: $input) {
    workflowStatus {
      workflowStageId
      state
      difficultyLevel
      totalTime
      idleTime
      trackedTime
      pausedBy
      assignedToUser {
        id
        name
        email
        picture
        roleIds {
          name
          auth0Id
          id
        }
      }
    }
    id
    name
  }
}
    `;
export type UpdateWorkflowStatusMutationFn = Apollo.MutationFunction<UpdateWorkflowStatusMutation, UpdateWorkflowStatusMutationVariables>;

/**
 * __useUpdateWorkflowStatusMutation__
 *
 * To run a mutation, you first call `useUpdateWorkflowStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateWorkflowStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateWorkflowStatusMutation, { data, loading, error }] = useUpdateWorkflowStatusMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateWorkflowStatusMutation(baseOptions?: Apollo.MutationHookOptions<UpdateWorkflowStatusMutation, UpdateWorkflowStatusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateWorkflowStatusMutation, UpdateWorkflowStatusMutationVariables>(UpdateWorkflowStatusDocument, options);
      }
export type UpdateWorkflowStatusMutationHookResult = ReturnType<typeof useUpdateWorkflowStatusMutation>;
export type UpdateWorkflowStatusMutationResult = Apollo.MutationResult<UpdateWorkflowStatusMutation>;
export type UpdateWorkflowStatusMutationOptions = Apollo.BaseMutationOptions<UpdateWorkflowStatusMutation, UpdateWorkflowStatusMutationVariables>;
export const WorkFlowTimeUpdatedDocument = gql`
    subscription WorkFlowTimeUpdated($structureId: ID, $zoneId: ID) {
  workFlowTimeUpdated(structureId: $structureId, zoneId: $zoneId) {
    id
    name
    box {
      min {
        x
        y
        z
      }
      max {
        x
        y
        z
      }
    }
    status
    structureId
    workflowStatus {
      workflowStageId
      state
      totalTime
      idleTime
      pausedBy
      trackedTime
      assignedToUser {
        id
        name
        email
        picture
        roleIds {
          name
          auth0Id
          id
        }
      }
    }
  }
}
    `;

/**
 * __useWorkFlowTimeUpdatedSubscription__
 *
 * To run a query within a React component, call `useWorkFlowTimeUpdatedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useWorkFlowTimeUpdatedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWorkFlowTimeUpdatedSubscription({
 *   variables: {
 *      structureId: // value for 'structureId'
 *      zoneId: // value for 'zoneId'
 *   },
 * });
 */
export function useWorkFlowTimeUpdatedSubscription(baseOptions?: Apollo.SubscriptionHookOptions<WorkFlowTimeUpdatedSubscription, WorkFlowTimeUpdatedSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<WorkFlowTimeUpdatedSubscription, WorkFlowTimeUpdatedSubscriptionVariables>(WorkFlowTimeUpdatedDocument, options);
      }
export type WorkFlowTimeUpdatedSubscriptionHookResult = ReturnType<typeof useWorkFlowTimeUpdatedSubscription>;
export type WorkFlowTimeUpdatedSubscriptionResult = Apollo.SubscriptionResult<WorkFlowTimeUpdatedSubscription>;
export const WorkflowStagesDocument = gql`
    query WorkflowStages($structureId: String) {
  structure(structureId: $structureId) {
    workflowStages {
      id
      name
      orderInWorkflow
      stageType
    }
  }
}
    `;

/**
 * __useWorkflowStagesQuery__
 *
 * To run a query within a React component, call `useWorkflowStagesQuery` and pass it any options that fit your needs.
 * When your component renders, `useWorkflowStagesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWorkflowStagesQuery({
 *   variables: {
 *      structureId: // value for 'structureId'
 *   },
 * });
 */
export function useWorkflowStagesQuery(baseOptions?: Apollo.QueryHookOptions<WorkflowStagesQuery, WorkflowStagesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<WorkflowStagesQuery, WorkflowStagesQueryVariables>(WorkflowStagesDocument, options);
      }
export function useWorkflowStagesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<WorkflowStagesQuery, WorkflowStagesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<WorkflowStagesQuery, WorkflowStagesQueryVariables>(WorkflowStagesDocument, options);
        }
// @ts-ignore
export function useWorkflowStagesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<WorkflowStagesQuery, WorkflowStagesQueryVariables>): Apollo.UseSuspenseQueryResult<WorkflowStagesQuery, WorkflowStagesQueryVariables>;
export function useWorkflowStagesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<WorkflowStagesQuery, WorkflowStagesQueryVariables>): Apollo.UseSuspenseQueryResult<WorkflowStagesQuery | undefined, WorkflowStagesQueryVariables>;
export function useWorkflowStagesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<WorkflowStagesQuery, WorkflowStagesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<WorkflowStagesQuery, WorkflowStagesQueryVariables>(WorkflowStagesDocument, options);
        }
export type WorkflowStagesQueryHookResult = ReturnType<typeof useWorkflowStagesQuery>;
export type WorkflowStagesLazyQueryHookResult = ReturnType<typeof useWorkflowStagesLazyQuery>;
export type WorkflowStagesSuspenseQueryHookResult = ReturnType<typeof useWorkflowStagesSuspenseQuery>;
export type WorkflowStagesQueryResult = Apollo.QueryResult<WorkflowStagesQuery, WorkflowStagesQueryVariables>;
export const DeleteWorkflowStageDocument = gql`
    mutation DeleteWorkflowStage($input: DeleteWorkflowStageInput) {
  deleteWorkflowStage(input: $input) {
    workflowStages {
      id
    }
  }
}
    `;
export type DeleteWorkflowStageMutationFn = Apollo.MutationFunction<DeleteWorkflowStageMutation, DeleteWorkflowStageMutationVariables>;

/**
 * __useDeleteWorkflowStageMutation__
 *
 * To run a mutation, you first call `useDeleteWorkflowStageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteWorkflowStageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteWorkflowStageMutation, { data, loading, error }] = useDeleteWorkflowStageMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteWorkflowStageMutation(baseOptions?: Apollo.MutationHookOptions<DeleteWorkflowStageMutation, DeleteWorkflowStageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteWorkflowStageMutation, DeleteWorkflowStageMutationVariables>(DeleteWorkflowStageDocument, options);
      }
export type DeleteWorkflowStageMutationHookResult = ReturnType<typeof useDeleteWorkflowStageMutation>;
export type DeleteWorkflowStageMutationResult = Apollo.MutationResult<DeleteWorkflowStageMutation>;
export type DeleteWorkflowStageMutationOptions = Apollo.BaseMutationOptions<DeleteWorkflowStageMutation, DeleteWorkflowStageMutationVariables>;
export const UpdateZoneWorkFlowStatusDocument = gql`
    mutation UpdateZoneWorkFlowStatus($input: UpdateWorkflowStatusInput) {
  updateWorkflowStatus(input: $input) {
    name
  }
}
    `;
export type UpdateZoneWorkFlowStatusMutationFn = Apollo.MutationFunction<UpdateZoneWorkFlowStatusMutation, UpdateZoneWorkFlowStatusMutationVariables>;

/**
 * __useUpdateZoneWorkFlowStatusMutation__
 *
 * To run a mutation, you first call `useUpdateZoneWorkFlowStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateZoneWorkFlowStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateZoneWorkFlowStatusMutation, { data, loading, error }] = useUpdateZoneWorkFlowStatusMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateZoneWorkFlowStatusMutation(baseOptions?: Apollo.MutationHookOptions<UpdateZoneWorkFlowStatusMutation, UpdateZoneWorkFlowStatusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateZoneWorkFlowStatusMutation, UpdateZoneWorkFlowStatusMutationVariables>(UpdateZoneWorkFlowStatusDocument, options);
      }
export type UpdateZoneWorkFlowStatusMutationHookResult = ReturnType<typeof useUpdateZoneWorkFlowStatusMutation>;
export type UpdateZoneWorkFlowStatusMutationResult = Apollo.MutationResult<UpdateZoneWorkFlowStatusMutation>;
export type UpdateZoneWorkFlowStatusMutationOptions = Apollo.BaseMutationOptions<UpdateZoneWorkFlowStatusMutation, UpdateZoneWorkFlowStatusMutationVariables>;
export const ZonesPerStatusCountDocument = gql`
    query ZonesPerStatusCount($structureId: String, $searchTerm: String) {
  zonesPerStatusCount(structureId: $structureId, searchTerm: $searchTerm) {
    status
    count
  }
}
    `;

/**
 * __useZonesPerStatusCountQuery__
 *
 * To run a query within a React component, call `useZonesPerStatusCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useZonesPerStatusCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useZonesPerStatusCountQuery({
 *   variables: {
 *      structureId: // value for 'structureId'
 *      searchTerm: // value for 'searchTerm'
 *   },
 * });
 */
export function useZonesPerStatusCountQuery(baseOptions?: Apollo.QueryHookOptions<ZonesPerStatusCountQuery, ZonesPerStatusCountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ZonesPerStatusCountQuery, ZonesPerStatusCountQueryVariables>(ZonesPerStatusCountDocument, options);
      }
export function useZonesPerStatusCountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ZonesPerStatusCountQuery, ZonesPerStatusCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ZonesPerStatusCountQuery, ZonesPerStatusCountQueryVariables>(ZonesPerStatusCountDocument, options);
        }
// @ts-ignore
export function useZonesPerStatusCountSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ZonesPerStatusCountQuery, ZonesPerStatusCountQueryVariables>): Apollo.UseSuspenseQueryResult<ZonesPerStatusCountQuery, ZonesPerStatusCountQueryVariables>;
export function useZonesPerStatusCountSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ZonesPerStatusCountQuery, ZonesPerStatusCountQueryVariables>): Apollo.UseSuspenseQueryResult<ZonesPerStatusCountQuery | undefined, ZonesPerStatusCountQueryVariables>;
export function useZonesPerStatusCountSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ZonesPerStatusCountQuery, ZonesPerStatusCountQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ZonesPerStatusCountQuery, ZonesPerStatusCountQueryVariables>(ZonesPerStatusCountDocument, options);
        }
export type ZonesPerStatusCountQueryHookResult = ReturnType<typeof useZonesPerStatusCountQuery>;
export type ZonesPerStatusCountLazyQueryHookResult = ReturnType<typeof useZonesPerStatusCountLazyQuery>;
export type ZonesPerStatusCountSuspenseQueryHookResult = ReturnType<typeof useZonesPerStatusCountSuspenseQuery>;
export type ZonesPerStatusCountQueryResult = Apollo.QueryResult<ZonesPerStatusCountQuery, ZonesPerStatusCountQueryVariables>;
export const WorkflowStagesAndZonesDocument = gql`
    query WorkflowStagesAndZones($structureId: String, $searchTerm: String) {
  structure(structureId: $structureId) {
    workflowStages {
      id
      name
      orderInWorkflow
      stageType
    }
  }
  zonesForStructure(structureId: $structureId, searchTerm: $searchTerm) {
    id
    name
    box {
      min {
        x
        y
        z
      }
      max {
        x
        y
        z
      }
    }
    status
    structureId
    workflowStatus {
      workflowStageId
      pausedBy
      state
      difficultyLevel
      assignedToUser {
        id
        name
        email
        picture
        roleIds {
          name
          auth0Id
          id
        }
      }
    }
  }
}
    `;

/**
 * __useWorkflowStagesAndZonesQuery__
 *
 * To run a query within a React component, call `useWorkflowStagesAndZonesQuery` and pass it any options that fit your needs.
 * When your component renders, `useWorkflowStagesAndZonesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWorkflowStagesAndZonesQuery({
 *   variables: {
 *      structureId: // value for 'structureId'
 *      searchTerm: // value for 'searchTerm'
 *   },
 * });
 */
export function useWorkflowStagesAndZonesQuery(baseOptions?: Apollo.QueryHookOptions<WorkflowStagesAndZonesQuery, WorkflowStagesAndZonesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<WorkflowStagesAndZonesQuery, WorkflowStagesAndZonesQueryVariables>(WorkflowStagesAndZonesDocument, options);
      }
export function useWorkflowStagesAndZonesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<WorkflowStagesAndZonesQuery, WorkflowStagesAndZonesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<WorkflowStagesAndZonesQuery, WorkflowStagesAndZonesQueryVariables>(WorkflowStagesAndZonesDocument, options);
        }
// @ts-ignore
export function useWorkflowStagesAndZonesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<WorkflowStagesAndZonesQuery, WorkflowStagesAndZonesQueryVariables>): Apollo.UseSuspenseQueryResult<WorkflowStagesAndZonesQuery, WorkflowStagesAndZonesQueryVariables>;
export function useWorkflowStagesAndZonesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<WorkflowStagesAndZonesQuery, WorkflowStagesAndZonesQueryVariables>): Apollo.UseSuspenseQueryResult<WorkflowStagesAndZonesQuery | undefined, WorkflowStagesAndZonesQueryVariables>;
export function useWorkflowStagesAndZonesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<WorkflowStagesAndZonesQuery, WorkflowStagesAndZonesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<WorkflowStagesAndZonesQuery, WorkflowStagesAndZonesQueryVariables>(WorkflowStagesAndZonesDocument, options);
        }
export type WorkflowStagesAndZonesQueryHookResult = ReturnType<typeof useWorkflowStagesAndZonesQuery>;
export type WorkflowStagesAndZonesLazyQueryHookResult = ReturnType<typeof useWorkflowStagesAndZonesLazyQuery>;
export type WorkflowStagesAndZonesSuspenseQueryHookResult = ReturnType<typeof useWorkflowStagesAndZonesSuspenseQuery>;
export type WorkflowStagesAndZonesQueryResult = Apollo.QueryResult<WorkflowStagesAndZonesQuery, WorkflowStagesAndZonesQueryVariables>;
export const CreateWorkflowStageDocument = gql`
    mutation CreateWorkflowStage($input: CreateWorkflowStageInput) {
  createWorkflowStage(input: $input) {
    workflowStages {
      id
      name
      orderInWorkflow
      stageType
    }
  }
}
    `;
export type CreateWorkflowStageMutationFn = Apollo.MutationFunction<CreateWorkflowStageMutation, CreateWorkflowStageMutationVariables>;

/**
 * __useCreateWorkflowStageMutation__
 *
 * To run a mutation, you first call `useCreateWorkflowStageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateWorkflowStageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createWorkflowStageMutation, { data, loading, error }] = useCreateWorkflowStageMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateWorkflowStageMutation(baseOptions?: Apollo.MutationHookOptions<CreateWorkflowStageMutation, CreateWorkflowStageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateWorkflowStageMutation, CreateWorkflowStageMutationVariables>(CreateWorkflowStageDocument, options);
      }
export type CreateWorkflowStageMutationHookResult = ReturnType<typeof useCreateWorkflowStageMutation>;
export type CreateWorkflowStageMutationResult = Apollo.MutationResult<CreateWorkflowStageMutation>;
export type CreateWorkflowStageMutationOptions = Apollo.BaseMutationOptions<CreateWorkflowStageMutation, CreateWorkflowStageMutationVariables>;
export const UpdateWorkflowStageDocument = gql`
    mutation UpdateWorkflowStage($input: UpdateWorkflowStageInput) {
  updateWorkflowStage(input: $input) {
    workflowStages {
      id
      name
      orderInWorkflow
      stageType
    }
  }
}
    `;
export type UpdateWorkflowStageMutationFn = Apollo.MutationFunction<UpdateWorkflowStageMutation, UpdateWorkflowStageMutationVariables>;

/**
 * __useUpdateWorkflowStageMutation__
 *
 * To run a mutation, you first call `useUpdateWorkflowStageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateWorkflowStageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateWorkflowStageMutation, { data, loading, error }] = useUpdateWorkflowStageMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateWorkflowStageMutation(baseOptions?: Apollo.MutationHookOptions<UpdateWorkflowStageMutation, UpdateWorkflowStageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateWorkflowStageMutation, UpdateWorkflowStageMutationVariables>(UpdateWorkflowStageDocument, options);
      }
export type UpdateWorkflowStageMutationHookResult = ReturnType<typeof useUpdateWorkflowStageMutation>;
export type UpdateWorkflowStageMutationResult = Apollo.MutationResult<UpdateWorkflowStageMutation>;
export type UpdateWorkflowStageMutationOptions = Apollo.BaseMutationOptions<UpdateWorkflowStageMutation, UpdateWorkflowStageMutationVariables>;
export const ZonesForStructureDocument = gql`
    query zonesForStructure($structureId: String) {
  zonesForStructure(structureId: $structureId) {
    id
    name
    status
    box {
      min {
        x
        y
        z
      }
      max {
        x
        y
        z
      }
    }
    structureId
    totalParts
    totalPoints
    totalSphericals
    workflowStatus {
      workflowStageId
      state
      assignedToUser {
        id
        name
        email
        picture
        roleIds {
          name
          auth0Id
          id
        }
      }
    }
  }
}
    `;

/**
 * __useZonesForStructureQuery__
 *
 * To run a query within a React component, call `useZonesForStructureQuery` and pass it any options that fit your needs.
 * When your component renders, `useZonesForStructureQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useZonesForStructureQuery({
 *   variables: {
 *      structureId: // value for 'structureId'
 *   },
 * });
 */
export function useZonesForStructureQuery(baseOptions?: Apollo.QueryHookOptions<ZonesForStructureQuery, ZonesForStructureQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ZonesForStructureQuery, ZonesForStructureQueryVariables>(ZonesForStructureDocument, options);
      }
export function useZonesForStructureLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ZonesForStructureQuery, ZonesForStructureQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ZonesForStructureQuery, ZonesForStructureQueryVariables>(ZonesForStructureDocument, options);
        }
// @ts-ignore
export function useZonesForStructureSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ZonesForStructureQuery, ZonesForStructureQueryVariables>): Apollo.UseSuspenseQueryResult<ZonesForStructureQuery, ZonesForStructureQueryVariables>;
export function useZonesForStructureSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ZonesForStructureQuery, ZonesForStructureQueryVariables>): Apollo.UseSuspenseQueryResult<ZonesForStructureQuery | undefined, ZonesForStructureQueryVariables>;
export function useZonesForStructureSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ZonesForStructureQuery, ZonesForStructureQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ZonesForStructureQuery, ZonesForStructureQueryVariables>(ZonesForStructureDocument, options);
        }
export type ZonesForStructureQueryHookResult = ReturnType<typeof useZonesForStructureQuery>;
export type ZonesForStructureLazyQueryHookResult = ReturnType<typeof useZonesForStructureLazyQuery>;
export type ZonesForStructureSuspenseQueryHookResult = ReturnType<typeof useZonesForStructureSuspenseQuery>;
export type ZonesForStructureQueryResult = Apollo.QueryResult<ZonesForStructureQuery, ZonesForStructureQueryVariables>;
export const ZoneAndHistoriesForZoneManagementDocument = gql`
    query zoneAndHistoriesForZoneManagement($structureId: String) {
  zonesAndHistoriesFor(structureId: $structureId) {
    _id
    name
    status
    histories {
      id
      createdBy
      eventName
      document
      collectionName
      createdAt
      createdByName
      createdByDetails {
        name
        profilePicture
      }
    }
    box {
      min {
        x
        y
        z
      }
      max {
        x
        y
        z
      }
    }
    structureId
    totalParts
    totalPoints
    totalSphericals
  }
}
    `;

/**
 * __useZoneAndHistoriesForZoneManagementQuery__
 *
 * To run a query within a React component, call `useZoneAndHistoriesForZoneManagementQuery` and pass it any options that fit your needs.
 * When your component renders, `useZoneAndHistoriesForZoneManagementQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useZoneAndHistoriesForZoneManagementQuery({
 *   variables: {
 *      structureId: // value for 'structureId'
 *   },
 * });
 */
export function useZoneAndHistoriesForZoneManagementQuery(baseOptions?: Apollo.QueryHookOptions<ZoneAndHistoriesForZoneManagementQuery, ZoneAndHistoriesForZoneManagementQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ZoneAndHistoriesForZoneManagementQuery, ZoneAndHistoriesForZoneManagementQueryVariables>(ZoneAndHistoriesForZoneManagementDocument, options);
      }
export function useZoneAndHistoriesForZoneManagementLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ZoneAndHistoriesForZoneManagementQuery, ZoneAndHistoriesForZoneManagementQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ZoneAndHistoriesForZoneManagementQuery, ZoneAndHistoriesForZoneManagementQueryVariables>(ZoneAndHistoriesForZoneManagementDocument, options);
        }
// @ts-ignore
export function useZoneAndHistoriesForZoneManagementSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ZoneAndHistoriesForZoneManagementQuery, ZoneAndHistoriesForZoneManagementQueryVariables>): Apollo.UseSuspenseQueryResult<ZoneAndHistoriesForZoneManagementQuery, ZoneAndHistoriesForZoneManagementQueryVariables>;
export function useZoneAndHistoriesForZoneManagementSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ZoneAndHistoriesForZoneManagementQuery, ZoneAndHistoriesForZoneManagementQueryVariables>): Apollo.UseSuspenseQueryResult<ZoneAndHistoriesForZoneManagementQuery | undefined, ZoneAndHistoriesForZoneManagementQueryVariables>;
export function useZoneAndHistoriesForZoneManagementSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ZoneAndHistoriesForZoneManagementQuery, ZoneAndHistoriesForZoneManagementQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ZoneAndHistoriesForZoneManagementQuery, ZoneAndHistoriesForZoneManagementQueryVariables>(ZoneAndHistoriesForZoneManagementDocument, options);
        }
export type ZoneAndHistoriesForZoneManagementQueryHookResult = ReturnType<typeof useZoneAndHistoriesForZoneManagementQuery>;
export type ZoneAndHistoriesForZoneManagementLazyQueryHookResult = ReturnType<typeof useZoneAndHistoriesForZoneManagementLazyQuery>;
export type ZoneAndHistoriesForZoneManagementSuspenseQueryHookResult = ReturnType<typeof useZoneAndHistoriesForZoneManagementSuspenseQuery>;
export type ZoneAndHistoriesForZoneManagementQueryResult = Apollo.QueryResult<ZoneAndHistoriesForZoneManagementQuery, ZoneAndHistoriesForZoneManagementQueryVariables>;
export const UpdateZoneStatusDocument = gql`
    mutation UpdateZoneStatus($input: UpdateZoneStatusInput) {
  updateZoneStatus(input: $input) {
    createdBy
    currentStatus
    prevStatus
    referenceId
  }
}
    `;
export type UpdateZoneStatusMutationFn = Apollo.MutationFunction<UpdateZoneStatusMutation, UpdateZoneStatusMutationVariables>;

/**
 * __useUpdateZoneStatusMutation__
 *
 * To run a mutation, you first call `useUpdateZoneStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateZoneStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateZoneStatusMutation, { data, loading, error }] = useUpdateZoneStatusMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateZoneStatusMutation(baseOptions?: Apollo.MutationHookOptions<UpdateZoneStatusMutation, UpdateZoneStatusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateZoneStatusMutation, UpdateZoneStatusMutationVariables>(UpdateZoneStatusDocument, options);
      }
export type UpdateZoneStatusMutationHookResult = ReturnType<typeof useUpdateZoneStatusMutation>;
export type UpdateZoneStatusMutationResult = Apollo.MutationResult<UpdateZoneStatusMutation>;
export type UpdateZoneStatusMutationOptions = Apollo.BaseMutationOptions<UpdateZoneStatusMutation, UpdateZoneStatusMutationVariables>;
export const UpdateWorkflowTimeAndStateDocument = gql`
    mutation UpdateWorkflowTimeAndState($input: UpdateWorkflowTimeAndStateInput) {
  updateWorkflowTimeAndState(input: $input) {
    workflowStatus {
      workflowStageId
      state
      difficultyLevel
      totalTime
      idleTime
      trackedTime
      assignedToUser {
        id
        name
        email
        picture
        roleIds {
          name
          auth0Id
          id
        }
      }
    }
  }
}
    `;
export type UpdateWorkflowTimeAndStateMutationFn = Apollo.MutationFunction<UpdateWorkflowTimeAndStateMutation, UpdateWorkflowTimeAndStateMutationVariables>;

/**
 * __useUpdateWorkflowTimeAndStateMutation__
 *
 * To run a mutation, you first call `useUpdateWorkflowTimeAndStateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateWorkflowTimeAndStateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateWorkflowTimeAndStateMutation, { data, loading, error }] = useUpdateWorkflowTimeAndStateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateWorkflowTimeAndStateMutation(baseOptions?: Apollo.MutationHookOptions<UpdateWorkflowTimeAndStateMutation, UpdateWorkflowTimeAndStateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateWorkflowTimeAndStateMutation, UpdateWorkflowTimeAndStateMutationVariables>(UpdateWorkflowTimeAndStateDocument, options);
      }
export type UpdateWorkflowTimeAndStateMutationHookResult = ReturnType<typeof useUpdateWorkflowTimeAndStateMutation>;
export type UpdateWorkflowTimeAndStateMutationResult = Apollo.MutationResult<UpdateWorkflowTimeAndStateMutation>;
export type UpdateWorkflowTimeAndStateMutationOptions = Apollo.BaseMutationOptions<UpdateWorkflowTimeAndStateMutation, UpdateWorkflowTimeAndStateMutationVariables>;
export const ZonesForStructureCsvDocument = gql`
    query ZonesForStructureCSV($structureId: String) {
  zonesForStructureCSV(structureId: $structureId)
}
    `;

/**
 * __useZonesForStructureCsvQuery__
 *
 * To run a query within a React component, call `useZonesForStructureCsvQuery` and pass it any options that fit your needs.
 * When your component renders, `useZonesForStructureCsvQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useZonesForStructureCsvQuery({
 *   variables: {
 *      structureId: // value for 'structureId'
 *   },
 * });
 */
export function useZonesForStructureCsvQuery(baseOptions?: Apollo.QueryHookOptions<ZonesForStructureCsvQuery, ZonesForStructureCsvQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ZonesForStructureCsvQuery, ZonesForStructureCsvQueryVariables>(ZonesForStructureCsvDocument, options);
      }
export function useZonesForStructureCsvLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ZonesForStructureCsvQuery, ZonesForStructureCsvQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ZonesForStructureCsvQuery, ZonesForStructureCsvQueryVariables>(ZonesForStructureCsvDocument, options);
        }
// @ts-ignore
export function useZonesForStructureCsvSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ZonesForStructureCsvQuery, ZonesForStructureCsvQueryVariables>): Apollo.UseSuspenseQueryResult<ZonesForStructureCsvQuery, ZonesForStructureCsvQueryVariables>;
export function useZonesForStructureCsvSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ZonesForStructureCsvQuery, ZonesForStructureCsvQueryVariables>): Apollo.UseSuspenseQueryResult<ZonesForStructureCsvQuery | undefined, ZonesForStructureCsvQueryVariables>;
export function useZonesForStructureCsvSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ZonesForStructureCsvQuery, ZonesForStructureCsvQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ZonesForStructureCsvQuery, ZonesForStructureCsvQueryVariables>(ZonesForStructureCsvDocument, options);
        }
export type ZonesForStructureCsvQueryHookResult = ReturnType<typeof useZonesForStructureCsvQuery>;
export type ZonesForStructureCsvLazyQueryHookResult = ReturnType<typeof useZonesForStructureCsvLazyQuery>;
export type ZonesForStructureCsvSuspenseQueryHookResult = ReturnType<typeof useZonesForStructureCsvSuspenseQuery>;
export type ZonesForStructureCsvQueryResult = Apollo.QueryResult<ZonesForStructureCsvQuery, ZonesForStructureCsvQueryVariables>;
export const SphericalsPerZoneDocument = gql`
    query SphericalsPerZone($structureId: String) {
  sphericalsPerZone(structureId: $structureId) {
    totalSphericals
    zoneId
  }
}
    `;

/**
 * __useSphericalsPerZoneQuery__
 *
 * To run a query within a React component, call `useSphericalsPerZoneQuery` and pass it any options that fit your needs.
 * When your component renders, `useSphericalsPerZoneQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSphericalsPerZoneQuery({
 *   variables: {
 *      structureId: // value for 'structureId'
 *   },
 * });
 */
export function useSphericalsPerZoneQuery(baseOptions?: Apollo.QueryHookOptions<SphericalsPerZoneQuery, SphericalsPerZoneQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SphericalsPerZoneQuery, SphericalsPerZoneQueryVariables>(SphericalsPerZoneDocument, options);
      }
export function useSphericalsPerZoneLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SphericalsPerZoneQuery, SphericalsPerZoneQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SphericalsPerZoneQuery, SphericalsPerZoneQueryVariables>(SphericalsPerZoneDocument, options);
        }
// @ts-ignore
export function useSphericalsPerZoneSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<SphericalsPerZoneQuery, SphericalsPerZoneQueryVariables>): Apollo.UseSuspenseQueryResult<SphericalsPerZoneQuery, SphericalsPerZoneQueryVariables>;
export function useSphericalsPerZoneSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SphericalsPerZoneQuery, SphericalsPerZoneQueryVariables>): Apollo.UseSuspenseQueryResult<SphericalsPerZoneQuery | undefined, SphericalsPerZoneQueryVariables>;
export function useSphericalsPerZoneSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SphericalsPerZoneQuery, SphericalsPerZoneQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SphericalsPerZoneQuery, SphericalsPerZoneQueryVariables>(SphericalsPerZoneDocument, options);
        }
export type SphericalsPerZoneQueryHookResult = ReturnType<typeof useSphericalsPerZoneQuery>;
export type SphericalsPerZoneLazyQueryHookResult = ReturnType<typeof useSphericalsPerZoneLazyQuery>;
export type SphericalsPerZoneSuspenseQueryHookResult = ReturnType<typeof useSphericalsPerZoneSuspenseQuery>;
export type SphericalsPerZoneQueryResult = Apollo.QueryResult<SphericalsPerZoneQuery, SphericalsPerZoneQueryVariables>;
export const AllUsersForZonesDocument = gql`
    query AllUsersForZones($pageInfo: PageInfo, $input: FilterForUsers) {
  allUsers(pageInfo: $pageInfo, input: $input) {
    id
    email
    picture
    name
    roleIds {
      id
      name
    }
  }
}
    `;

/**
 * __useAllUsersForZonesQuery__
 *
 * To run a query within a React component, call `useAllUsersForZonesQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllUsersForZonesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllUsersForZonesQuery({
 *   variables: {
 *      pageInfo: // value for 'pageInfo'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAllUsersForZonesQuery(baseOptions?: Apollo.QueryHookOptions<AllUsersForZonesQuery, AllUsersForZonesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AllUsersForZonesQuery, AllUsersForZonesQueryVariables>(AllUsersForZonesDocument, options);
      }
export function useAllUsersForZonesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AllUsersForZonesQuery, AllUsersForZonesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AllUsersForZonesQuery, AllUsersForZonesQueryVariables>(AllUsersForZonesDocument, options);
        }
// @ts-ignore
export function useAllUsersForZonesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<AllUsersForZonesQuery, AllUsersForZonesQueryVariables>): Apollo.UseSuspenseQueryResult<AllUsersForZonesQuery, AllUsersForZonesQueryVariables>;
export function useAllUsersForZonesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AllUsersForZonesQuery, AllUsersForZonesQueryVariables>): Apollo.UseSuspenseQueryResult<AllUsersForZonesQuery | undefined, AllUsersForZonesQueryVariables>;
export function useAllUsersForZonesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AllUsersForZonesQuery, AllUsersForZonesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AllUsersForZonesQuery, AllUsersForZonesQueryVariables>(AllUsersForZonesDocument, options);
        }
export type AllUsersForZonesQueryHookResult = ReturnType<typeof useAllUsersForZonesQuery>;
export type AllUsersForZonesLazyQueryHookResult = ReturnType<typeof useAllUsersForZonesLazyQuery>;
export type AllUsersForZonesSuspenseQueryHookResult = ReturnType<typeof useAllUsersForZonesSuspenseQuery>;
export type AllUsersForZonesQueryResult = Apollo.QueryResult<AllUsersForZonesQuery, AllUsersForZonesQueryVariables>;
export const AssignZoneToUserDocument = gql`
    mutation AssignZoneToUser($input: UpdateWorkflowStatusInput) {
  updateWorkflowStatus(input: $input) {
    id
  }
}
    `;
export type AssignZoneToUserMutationFn = Apollo.MutationFunction<AssignZoneToUserMutation, AssignZoneToUserMutationVariables>;

/**
 * __useAssignZoneToUserMutation__
 *
 * To run a mutation, you first call `useAssignZoneToUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAssignZoneToUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [assignZoneToUserMutation, { data, loading, error }] = useAssignZoneToUserMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAssignZoneToUserMutation(baseOptions?: Apollo.MutationHookOptions<AssignZoneToUserMutation, AssignZoneToUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AssignZoneToUserMutation, AssignZoneToUserMutationVariables>(AssignZoneToUserDocument, options);
      }
export type AssignZoneToUserMutationHookResult = ReturnType<typeof useAssignZoneToUserMutation>;
export type AssignZoneToUserMutationResult = Apollo.MutationResult<AssignZoneToUserMutation>;
export type AssignZoneToUserMutationOptions = Apollo.BaseMutationOptions<AssignZoneToUserMutation, AssignZoneToUserMutationVariables>;
export const GetAssemblyServiceAndPipeSpecDocument = gql`
    query getAssemblyServiceAndPipeSpec($assemblyId: String) {
  assembly(assemblyId: $assemblyId) {
    id
    service {
      group
      code
    }
    pipeSpec {
      spec
    }
  }
}
    `;

/**
 * __useGetAssemblyServiceAndPipeSpecQuery__
 *
 * To run a query within a React component, call `useGetAssemblyServiceAndPipeSpecQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAssemblyServiceAndPipeSpecQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAssemblyServiceAndPipeSpecQuery({
 *   variables: {
 *      assemblyId: // value for 'assemblyId'
 *   },
 * });
 */
export function useGetAssemblyServiceAndPipeSpecQuery(baseOptions?: Apollo.QueryHookOptions<GetAssemblyServiceAndPipeSpecQuery, GetAssemblyServiceAndPipeSpecQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAssemblyServiceAndPipeSpecQuery, GetAssemblyServiceAndPipeSpecQueryVariables>(GetAssemblyServiceAndPipeSpecDocument, options);
      }
export function useGetAssemblyServiceAndPipeSpecLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAssemblyServiceAndPipeSpecQuery, GetAssemblyServiceAndPipeSpecQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAssemblyServiceAndPipeSpecQuery, GetAssemblyServiceAndPipeSpecQueryVariables>(GetAssemblyServiceAndPipeSpecDocument, options);
        }
// @ts-ignore
export function useGetAssemblyServiceAndPipeSpecSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetAssemblyServiceAndPipeSpecQuery, GetAssemblyServiceAndPipeSpecQueryVariables>): Apollo.UseSuspenseQueryResult<GetAssemblyServiceAndPipeSpecQuery, GetAssemblyServiceAndPipeSpecQueryVariables>;
export function useGetAssemblyServiceAndPipeSpecSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAssemblyServiceAndPipeSpecQuery, GetAssemblyServiceAndPipeSpecQueryVariables>): Apollo.UseSuspenseQueryResult<GetAssemblyServiceAndPipeSpecQuery | undefined, GetAssemblyServiceAndPipeSpecQueryVariables>;
export function useGetAssemblyServiceAndPipeSpecSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAssemblyServiceAndPipeSpecQuery, GetAssemblyServiceAndPipeSpecQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAssemblyServiceAndPipeSpecQuery, GetAssemblyServiceAndPipeSpecQueryVariables>(GetAssemblyServiceAndPipeSpecDocument, options);
        }
export type GetAssemblyServiceAndPipeSpecQueryHookResult = ReturnType<typeof useGetAssemblyServiceAndPipeSpecQuery>;
export type GetAssemblyServiceAndPipeSpecLazyQueryHookResult = ReturnType<typeof useGetAssemblyServiceAndPipeSpecLazyQuery>;
export type GetAssemblyServiceAndPipeSpecSuspenseQueryHookResult = ReturnType<typeof useGetAssemblyServiceAndPipeSpecSuspenseQuery>;
export type GetAssemblyServiceAndPipeSpecQueryResult = Apollo.QueryResult<GetAssemblyServiceAndPipeSpecQuery, GetAssemblyServiceAndPipeSpecQueryVariables>;
export const GetStructureNameDocument = gql`
    query getStructureName($structureId: String!) {
  structure(structureId: $structureId) {
    id
    name
  }
}
    `;

/**
 * __useGetStructureNameQuery__
 *
 * To run a query within a React component, call `useGetStructureNameQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetStructureNameQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetStructureNameQuery({
 *   variables: {
 *      structureId: // value for 'structureId'
 *   },
 * });
 */
export function useGetStructureNameQuery(baseOptions: Apollo.QueryHookOptions<GetStructureNameQuery, GetStructureNameQueryVariables> & ({ variables: GetStructureNameQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetStructureNameQuery, GetStructureNameQueryVariables>(GetStructureNameDocument, options);
      }
export function useGetStructureNameLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetStructureNameQuery, GetStructureNameQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetStructureNameQuery, GetStructureNameQueryVariables>(GetStructureNameDocument, options);
        }
// @ts-ignore
export function useGetStructureNameSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetStructureNameQuery, GetStructureNameQueryVariables>): Apollo.UseSuspenseQueryResult<GetStructureNameQuery, GetStructureNameQueryVariables>;
export function useGetStructureNameSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetStructureNameQuery, GetStructureNameQueryVariables>): Apollo.UseSuspenseQueryResult<GetStructureNameQuery | undefined, GetStructureNameQueryVariables>;
export function useGetStructureNameSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetStructureNameQuery, GetStructureNameQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetStructureNameQuery, GetStructureNameQueryVariables>(GetStructureNameDocument, options);
        }
export type GetStructureNameQueryHookResult = ReturnType<typeof useGetStructureNameQuery>;
export type GetStructureNameLazyQueryHookResult = ReturnType<typeof useGetStructureNameLazyQuery>;
export type GetStructureNameSuspenseQueryHookResult = ReturnType<typeof useGetStructureNameSuspenseQuery>;
export type GetStructureNameQueryResult = Apollo.QueryResult<GetStructureNameQuery, GetStructureNameQueryVariables>;
export const GetAllStructuresListForBreadcrumbDocument = gql`
    query getAllStructuresListForBreadcrumb {
  allStructures {
    id
    name
    status
  }
}
    `;

/**
 * __useGetAllStructuresListForBreadcrumbQuery__
 *
 * To run a query within a React component, call `useGetAllStructuresListForBreadcrumbQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllStructuresListForBreadcrumbQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllStructuresListForBreadcrumbQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAllStructuresListForBreadcrumbQuery(baseOptions?: Apollo.QueryHookOptions<GetAllStructuresListForBreadcrumbQuery, GetAllStructuresListForBreadcrumbQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllStructuresListForBreadcrumbQuery, GetAllStructuresListForBreadcrumbQueryVariables>(GetAllStructuresListForBreadcrumbDocument, options);
      }
export function useGetAllStructuresListForBreadcrumbLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllStructuresListForBreadcrumbQuery, GetAllStructuresListForBreadcrumbQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllStructuresListForBreadcrumbQuery, GetAllStructuresListForBreadcrumbQueryVariables>(GetAllStructuresListForBreadcrumbDocument, options);
        }
// @ts-ignore
export function useGetAllStructuresListForBreadcrumbSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetAllStructuresListForBreadcrumbQuery, GetAllStructuresListForBreadcrumbQueryVariables>): Apollo.UseSuspenseQueryResult<GetAllStructuresListForBreadcrumbQuery, GetAllStructuresListForBreadcrumbQueryVariables>;
export function useGetAllStructuresListForBreadcrumbSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAllStructuresListForBreadcrumbQuery, GetAllStructuresListForBreadcrumbQueryVariables>): Apollo.UseSuspenseQueryResult<GetAllStructuresListForBreadcrumbQuery | undefined, GetAllStructuresListForBreadcrumbQueryVariables>;
export function useGetAllStructuresListForBreadcrumbSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAllStructuresListForBreadcrumbQuery, GetAllStructuresListForBreadcrumbQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAllStructuresListForBreadcrumbQuery, GetAllStructuresListForBreadcrumbQueryVariables>(GetAllStructuresListForBreadcrumbDocument, options);
        }
export type GetAllStructuresListForBreadcrumbQueryHookResult = ReturnType<typeof useGetAllStructuresListForBreadcrumbQuery>;
export type GetAllStructuresListForBreadcrumbLazyQueryHookResult = ReturnType<typeof useGetAllStructuresListForBreadcrumbLazyQuery>;
export type GetAllStructuresListForBreadcrumbSuspenseQueryHookResult = ReturnType<typeof useGetAllStructuresListForBreadcrumbSuspenseQuery>;
export type GetAllStructuresListForBreadcrumbQueryResult = Apollo.QueryResult<GetAllStructuresListForBreadcrumbQuery, GetAllStructuresListForBreadcrumbQueryVariables>;
export const AllCommentsGenericDocument = gql`
    query AllCommentsGeneric($input: AllCommentsInput) {
  allComments(input: $input) {
    id
    key
    text
    isEdited
    status
    updatedAt
    structureId
    createdByDetails {
      name
      profilePicture
    }
    createdBy
    createdAt
    collectionName
    metadata
  }
}
    `;

/**
 * __useAllCommentsGenericQuery__
 *
 * To run a query within a React component, call `useAllCommentsGenericQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllCommentsGenericQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllCommentsGenericQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAllCommentsGenericQuery(baseOptions?: Apollo.QueryHookOptions<AllCommentsGenericQuery, AllCommentsGenericQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AllCommentsGenericQuery, AllCommentsGenericQueryVariables>(AllCommentsGenericDocument, options);
      }
export function useAllCommentsGenericLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AllCommentsGenericQuery, AllCommentsGenericQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AllCommentsGenericQuery, AllCommentsGenericQueryVariables>(AllCommentsGenericDocument, options);
        }
// @ts-ignore
export function useAllCommentsGenericSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<AllCommentsGenericQuery, AllCommentsGenericQueryVariables>): Apollo.UseSuspenseQueryResult<AllCommentsGenericQuery, AllCommentsGenericQueryVariables>;
export function useAllCommentsGenericSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AllCommentsGenericQuery, AllCommentsGenericQueryVariables>): Apollo.UseSuspenseQueryResult<AllCommentsGenericQuery | undefined, AllCommentsGenericQueryVariables>;
export function useAllCommentsGenericSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AllCommentsGenericQuery, AllCommentsGenericQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AllCommentsGenericQuery, AllCommentsGenericQueryVariables>(AllCommentsGenericDocument, options);
        }
export type AllCommentsGenericQueryHookResult = ReturnType<typeof useAllCommentsGenericQuery>;
export type AllCommentsGenericLazyQueryHookResult = ReturnType<typeof useAllCommentsGenericLazyQuery>;
export type AllCommentsGenericSuspenseQueryHookResult = ReturnType<typeof useAllCommentsGenericSuspenseQuery>;
export type AllCommentsGenericQueryResult = Apollo.QueryResult<AllCommentsGenericQuery, AllCommentsGenericQueryVariables>;
export const CreateCommentDocument = gql`
    mutation CreateComment($input: CreateCommentInput!) {
  createComment(input: $input) {
    text
    structureId
    createdByDetails {
      name
      profilePicture
    }
  }
}
    `;
export type CreateCommentMutationFn = Apollo.MutationFunction<CreateCommentMutation, CreateCommentMutationVariables>;

/**
 * __useCreateCommentMutation__
 *
 * To run a mutation, you first call `useCreateCommentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCommentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCommentMutation, { data, loading, error }] = useCreateCommentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateCommentMutation(baseOptions?: Apollo.MutationHookOptions<CreateCommentMutation, CreateCommentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateCommentMutation, CreateCommentMutationVariables>(CreateCommentDocument, options);
      }
export type CreateCommentMutationHookResult = ReturnType<typeof useCreateCommentMutation>;
export type CreateCommentMutationResult = Apollo.MutationResult<CreateCommentMutation>;
export type CreateCommentMutationOptions = Apollo.BaseMutationOptions<CreateCommentMutation, CreateCommentMutationVariables>;
export const DeleteCommentDocument = gql`
    mutation DeleteComment($structureId: ID, $commentId: ID) {
  deleteComment(structureId: $structureId, commentId: $commentId) {
    id
  }
}
    `;
export type DeleteCommentMutationFn = Apollo.MutationFunction<DeleteCommentMutation, DeleteCommentMutationVariables>;

/**
 * __useDeleteCommentMutation__
 *
 * To run a mutation, you first call `useDeleteCommentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCommentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteCommentMutation, { data, loading, error }] = useDeleteCommentMutation({
 *   variables: {
 *      structureId: // value for 'structureId'
 *      commentId: // value for 'commentId'
 *   },
 * });
 */
export function useDeleteCommentMutation(baseOptions?: Apollo.MutationHookOptions<DeleteCommentMutation, DeleteCommentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteCommentMutation, DeleteCommentMutationVariables>(DeleteCommentDocument, options);
      }
export type DeleteCommentMutationHookResult = ReturnType<typeof useDeleteCommentMutation>;
export type DeleteCommentMutationResult = Apollo.MutationResult<DeleteCommentMutation>;
export type DeleteCommentMutationOptions = Apollo.BaseMutationOptions<DeleteCommentMutation, DeleteCommentMutationVariables>;
export const CommentAddedDocument = gql`
    subscription CommentAdded($structureId: ID, $referenceId: ID) {
  commentAdded(structureId: $structureId, referenceId: $referenceId) {
    id
    text
    isEdited
    status
    updatedAt
    structureId
    createdByDetails {
      name
      profilePicture
    }
    createdBy
    createdAt
    collectionName
  }
}
    `;

/**
 * __useCommentAddedSubscription__
 *
 * To run a query within a React component, call `useCommentAddedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useCommentAddedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCommentAddedSubscription({
 *   variables: {
 *      structureId: // value for 'structureId'
 *      referenceId: // value for 'referenceId'
 *   },
 * });
 */
export function useCommentAddedSubscription(baseOptions?: Apollo.SubscriptionHookOptions<CommentAddedSubscription, CommentAddedSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<CommentAddedSubscription, CommentAddedSubscriptionVariables>(CommentAddedDocument, options);
      }
export type CommentAddedSubscriptionHookResult = ReturnType<typeof useCommentAddedSubscription>;
export type CommentAddedSubscriptionResult = Apollo.SubscriptionResult<CommentAddedSubscription>;
export const CommentDeletedDocument = gql`
    subscription CommentDeleted($structureId: ID, $referenceId: ID) {
  commentDeleted(structureId: $structureId, referenceId: $referenceId) {
    id
  }
}
    `;

/**
 * __useCommentDeletedSubscription__
 *
 * To run a query within a React component, call `useCommentDeletedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useCommentDeletedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCommentDeletedSubscription({
 *   variables: {
 *      structureId: // value for 'structureId'
 *      referenceId: // value for 'referenceId'
 *   },
 * });
 */
export function useCommentDeletedSubscription(baseOptions?: Apollo.SubscriptionHookOptions<CommentDeletedSubscription, CommentDeletedSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<CommentDeletedSubscription, CommentDeletedSubscriptionVariables>(CommentDeletedDocument, options);
      }
export type CommentDeletedSubscriptionHookResult = ReturnType<typeof useCommentDeletedSubscription>;
export type CommentDeletedSubscriptionResult = Apollo.SubscriptionResult<CommentDeletedSubscription>;
export const DecksForDeckListDocument = gql`
    query DecksForDeckList($structureId: ID) {
  allDecks(structureId: $structureId) {
    id
    name
    resourcePath
    heightRange
    heightStep
  }
}
    `;

/**
 * __useDecksForDeckListQuery__
 *
 * To run a query within a React component, call `useDecksForDeckListQuery` and pass it any options that fit your needs.
 * When your component renders, `useDecksForDeckListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDecksForDeckListQuery({
 *   variables: {
 *      structureId: // value for 'structureId'
 *   },
 * });
 */
export function useDecksForDeckListQuery(baseOptions?: Apollo.QueryHookOptions<DecksForDeckListQuery, DecksForDeckListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DecksForDeckListQuery, DecksForDeckListQueryVariables>(DecksForDeckListDocument, options);
      }
export function useDecksForDeckListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DecksForDeckListQuery, DecksForDeckListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DecksForDeckListQuery, DecksForDeckListQueryVariables>(DecksForDeckListDocument, options);
        }
// @ts-ignore
export function useDecksForDeckListSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<DecksForDeckListQuery, DecksForDeckListQueryVariables>): Apollo.UseSuspenseQueryResult<DecksForDeckListQuery, DecksForDeckListQueryVariables>;
export function useDecksForDeckListSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DecksForDeckListQuery, DecksForDeckListQueryVariables>): Apollo.UseSuspenseQueryResult<DecksForDeckListQuery | undefined, DecksForDeckListQueryVariables>;
export function useDecksForDeckListSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DecksForDeckListQuery, DecksForDeckListQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DecksForDeckListQuery, DecksForDeckListQueryVariables>(DecksForDeckListDocument, options);
        }
export type DecksForDeckListQueryHookResult = ReturnType<typeof useDecksForDeckListQuery>;
export type DecksForDeckListLazyQueryHookResult = ReturnType<typeof useDecksForDeckListLazyQuery>;
export type DecksForDeckListSuspenseQueryHookResult = ReturnType<typeof useDecksForDeckListSuspenseQuery>;
export type DecksForDeckListQueryResult = Apollo.QueryResult<DecksForDeckListQuery, DecksForDeckListQueryVariables>;
export const GetActiveDeploymentForPlatformDocument = gql`
    query getActiveDeploymentForPlatform($input: StructureFilters!) {
  allStructures(input: $input) {
    id
    name
    isActive
    platform {
      id
    }
  }
}
    `;

/**
 * __useGetActiveDeploymentForPlatformQuery__
 *
 * To run a query within a React component, call `useGetActiveDeploymentForPlatformQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetActiveDeploymentForPlatformQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetActiveDeploymentForPlatformQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetActiveDeploymentForPlatformQuery(baseOptions: Apollo.QueryHookOptions<GetActiveDeploymentForPlatformQuery, GetActiveDeploymentForPlatformQueryVariables> & ({ variables: GetActiveDeploymentForPlatformQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetActiveDeploymentForPlatformQuery, GetActiveDeploymentForPlatformQueryVariables>(GetActiveDeploymentForPlatformDocument, options);
      }
export function useGetActiveDeploymentForPlatformLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetActiveDeploymentForPlatformQuery, GetActiveDeploymentForPlatformQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetActiveDeploymentForPlatformQuery, GetActiveDeploymentForPlatformQueryVariables>(GetActiveDeploymentForPlatformDocument, options);
        }
// @ts-ignore
export function useGetActiveDeploymentForPlatformSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetActiveDeploymentForPlatformQuery, GetActiveDeploymentForPlatformQueryVariables>): Apollo.UseSuspenseQueryResult<GetActiveDeploymentForPlatformQuery, GetActiveDeploymentForPlatformQueryVariables>;
export function useGetActiveDeploymentForPlatformSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetActiveDeploymentForPlatformQuery, GetActiveDeploymentForPlatformQueryVariables>): Apollo.UseSuspenseQueryResult<GetActiveDeploymentForPlatformQuery | undefined, GetActiveDeploymentForPlatformQueryVariables>;
export function useGetActiveDeploymentForPlatformSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetActiveDeploymentForPlatformQuery, GetActiveDeploymentForPlatformQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetActiveDeploymentForPlatformQuery, GetActiveDeploymentForPlatformQueryVariables>(GetActiveDeploymentForPlatformDocument, options);
        }
export type GetActiveDeploymentForPlatformQueryHookResult = ReturnType<typeof useGetActiveDeploymentForPlatformQuery>;
export type GetActiveDeploymentForPlatformLazyQueryHookResult = ReturnType<typeof useGetActiveDeploymentForPlatformLazyQuery>;
export type GetActiveDeploymentForPlatformSuspenseQueryHookResult = ReturnType<typeof useGetActiveDeploymentForPlatformSuspenseQuery>;
export type GetActiveDeploymentForPlatformQueryResult = Apollo.QueryResult<GetActiveDeploymentForPlatformQuery, GetActiveDeploymentForPlatformQueryVariables>;
export const GetUserPreferencesForUnitSelectionDocument = gql`
    query GetUserPreferencesForUnitSelection {
  getUserPreferences {
    unit
  }
}
    `;

/**
 * __useGetUserPreferencesForUnitSelectionQuery__
 *
 * To run a query within a React component, call `useGetUserPreferencesForUnitSelectionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserPreferencesForUnitSelectionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserPreferencesForUnitSelectionQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetUserPreferencesForUnitSelectionQuery(baseOptions?: Apollo.QueryHookOptions<GetUserPreferencesForUnitSelectionQuery, GetUserPreferencesForUnitSelectionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUserPreferencesForUnitSelectionQuery, GetUserPreferencesForUnitSelectionQueryVariables>(GetUserPreferencesForUnitSelectionDocument, options);
      }
export function useGetUserPreferencesForUnitSelectionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUserPreferencesForUnitSelectionQuery, GetUserPreferencesForUnitSelectionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUserPreferencesForUnitSelectionQuery, GetUserPreferencesForUnitSelectionQueryVariables>(GetUserPreferencesForUnitSelectionDocument, options);
        }
// @ts-ignore
export function useGetUserPreferencesForUnitSelectionSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetUserPreferencesForUnitSelectionQuery, GetUserPreferencesForUnitSelectionQueryVariables>): Apollo.UseSuspenseQueryResult<GetUserPreferencesForUnitSelectionQuery, GetUserPreferencesForUnitSelectionQueryVariables>;
export function useGetUserPreferencesForUnitSelectionSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetUserPreferencesForUnitSelectionQuery, GetUserPreferencesForUnitSelectionQueryVariables>): Apollo.UseSuspenseQueryResult<GetUserPreferencesForUnitSelectionQuery | undefined, GetUserPreferencesForUnitSelectionQueryVariables>;
export function useGetUserPreferencesForUnitSelectionSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetUserPreferencesForUnitSelectionQuery, GetUserPreferencesForUnitSelectionQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetUserPreferencesForUnitSelectionQuery, GetUserPreferencesForUnitSelectionQueryVariables>(GetUserPreferencesForUnitSelectionDocument, options);
        }
export type GetUserPreferencesForUnitSelectionQueryHookResult = ReturnType<typeof useGetUserPreferencesForUnitSelectionQuery>;
export type GetUserPreferencesForUnitSelectionLazyQueryHookResult = ReturnType<typeof useGetUserPreferencesForUnitSelectionLazyQuery>;
export type GetUserPreferencesForUnitSelectionSuspenseQueryHookResult = ReturnType<typeof useGetUserPreferencesForUnitSelectionSuspenseQuery>;
export type GetUserPreferencesForUnitSelectionQueryResult = Apollo.QueryResult<GetUserPreferencesForUnitSelectionQuery, GetUserPreferencesForUnitSelectionQueryVariables>;
export const UpdatePreferencesDocument = gql`
    mutation UpdatePreferences($input: UpdateUserPreferencesInput) {
  updateUserPreferences(input: $input) {
    preferences {
      unit
    }
  }
}
    `;
export type UpdatePreferencesMutationFn = Apollo.MutationFunction<UpdatePreferencesMutation, UpdatePreferencesMutationVariables>;

/**
 * __useUpdatePreferencesMutation__
 *
 * To run a mutation, you first call `useUpdatePreferencesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePreferencesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePreferencesMutation, { data, loading, error }] = useUpdatePreferencesMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdatePreferencesMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePreferencesMutation, UpdatePreferencesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePreferencesMutation, UpdatePreferencesMutationVariables>(UpdatePreferencesDocument, options);
      }
export type UpdatePreferencesMutationHookResult = ReturnType<typeof useUpdatePreferencesMutation>;
export type UpdatePreferencesMutationResult = Apollo.MutationResult<UpdatePreferencesMutation>;
export type UpdatePreferencesMutationOptions = Apollo.BaseMutationOptions<UpdatePreferencesMutation, UpdatePreferencesMutationVariables>;
export const LocationDocument = gql`
    query location($locationId: String) {
  location(locationId: $locationId) {
    id
    deck {
      id
      name
      resourcePath
      cadTransform
    }
    name
    depthResourcePath
    depthResource
    resourcePath
    resource
    deckPlan {
      id
      coordinates
    }
  }
}
    `;

/**
 * __useLocationQuery__
 *
 * To run a query within a React component, call `useLocationQuery` and pass it any options that fit your needs.
 * When your component renders, `useLocationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLocationQuery({
 *   variables: {
 *      locationId: // value for 'locationId'
 *   },
 * });
 */
export function useLocationQuery(baseOptions?: Apollo.QueryHookOptions<LocationQuery, LocationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LocationQuery, LocationQueryVariables>(LocationDocument, options);
      }
export function useLocationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LocationQuery, LocationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LocationQuery, LocationQueryVariables>(LocationDocument, options);
        }
// @ts-ignore
export function useLocationSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<LocationQuery, LocationQueryVariables>): Apollo.UseSuspenseQueryResult<LocationQuery, LocationQueryVariables>;
export function useLocationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<LocationQuery, LocationQueryVariables>): Apollo.UseSuspenseQueryResult<LocationQuery | undefined, LocationQueryVariables>;
export function useLocationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<LocationQuery, LocationQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<LocationQuery, LocationQueryVariables>(LocationDocument, options);
        }
export type LocationQueryHookResult = ReturnType<typeof useLocationQuery>;
export type LocationLazyQueryHookResult = ReturnType<typeof useLocationLazyQuery>;
export type LocationSuspenseQueryHookResult = ReturnType<typeof useLocationSuspenseQuery>;
export type LocationQueryResult = Apollo.QueryResult<LocationQuery, LocationQueryVariables>;
export const GroupedReportsDocument = gql`
    query GroupedReports($input: reportsInput) {
  groupedReports(input: $input) {
    groupName
    groupId
    count
  }
}
    `;

/**
 * __useGroupedReportsQuery__
 *
 * To run a query within a React component, call `useGroupedReportsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGroupedReportsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGroupedReportsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGroupedReportsQuery(baseOptions?: Apollo.QueryHookOptions<GroupedReportsQuery, GroupedReportsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GroupedReportsQuery, GroupedReportsQueryVariables>(GroupedReportsDocument, options);
      }
export function useGroupedReportsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GroupedReportsQuery, GroupedReportsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GroupedReportsQuery, GroupedReportsQueryVariables>(GroupedReportsDocument, options);
        }
// @ts-ignore
export function useGroupedReportsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GroupedReportsQuery, GroupedReportsQueryVariables>): Apollo.UseSuspenseQueryResult<GroupedReportsQuery, GroupedReportsQueryVariables>;
export function useGroupedReportsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GroupedReportsQuery, GroupedReportsQueryVariables>): Apollo.UseSuspenseQueryResult<GroupedReportsQuery | undefined, GroupedReportsQueryVariables>;
export function useGroupedReportsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GroupedReportsQuery, GroupedReportsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GroupedReportsQuery, GroupedReportsQueryVariables>(GroupedReportsDocument, options);
        }
export type GroupedReportsQueryHookResult = ReturnType<typeof useGroupedReportsQuery>;
export type GroupedReportsLazyQueryHookResult = ReturnType<typeof useGroupedReportsLazyQuery>;
export type GroupedReportsSuspenseQueryHookResult = ReturnType<typeof useGroupedReportsSuspenseQuery>;
export type GroupedReportsQueryResult = Apollo.QueryResult<GroupedReportsQuery, GroupedReportsQueryVariables>;
export const CreateNewReportDocument = gql`
    mutation createNewReport($input: createNewReportInput) {
  createNewReport(input: $input) {
    createdAt
    id
    name
    status
    dueDate
    startDate
    actionStatus
    type
    workpackNumber
  }
}
    `;
export type CreateNewReportMutationFn = Apollo.MutationFunction<CreateNewReportMutation, CreateNewReportMutationVariables>;

/**
 * __useCreateNewReportMutation__
 *
 * To run a mutation, you first call `useCreateNewReportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateNewReportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createNewReportMutation, { data, loading, error }] = useCreateNewReportMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateNewReportMutation(baseOptions?: Apollo.MutationHookOptions<CreateNewReportMutation, CreateNewReportMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateNewReportMutation, CreateNewReportMutationVariables>(CreateNewReportDocument, options);
      }
export type CreateNewReportMutationHookResult = ReturnType<typeof useCreateNewReportMutation>;
export type CreateNewReportMutationResult = Apollo.MutationResult<CreateNewReportMutation>;
export type CreateNewReportMutationOptions = Apollo.BaseMutationOptions<CreateNewReportMutation, CreateNewReportMutationVariables>;
export const CreateBulkReportsDocument = gql`
    mutation CreateBulkReports($input: createNewReportInput) {
  createBulkReports(input: $input) {
    createdAt
    id
    name
    status
    dueDate
    startDate
    actionStatus
    type
    workpackNumber
  }
}
    `;
export type CreateBulkReportsMutationFn = Apollo.MutationFunction<CreateBulkReportsMutation, CreateBulkReportsMutationVariables>;

/**
 * __useCreateBulkReportsMutation__
 *
 * To run a mutation, you first call `useCreateBulkReportsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateBulkReportsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createBulkReportsMutation, { data, loading, error }] = useCreateBulkReportsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateBulkReportsMutation(baseOptions?: Apollo.MutationHookOptions<CreateBulkReportsMutation, CreateBulkReportsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateBulkReportsMutation, CreateBulkReportsMutationVariables>(CreateBulkReportsDocument, options);
      }
export type CreateBulkReportsMutationHookResult = ReturnType<typeof useCreateBulkReportsMutation>;
export type CreateBulkReportsMutationResult = Apollo.MutationResult<CreateBulkReportsMutation>;
export type CreateBulkReportsMutationOptions = Apollo.BaseMutationOptions<CreateBulkReportsMutation, CreateBulkReportsMutationVariables>;
export const GenerateReportPdfDocument = gql`
    mutation generateReportPdf($reportIds: [ID!]) {
  generateReportPdf(reportIds: $reportIds) {
    downloadUrl
    filename
  }
}
    `;
export type GenerateReportPdfMutationFn = Apollo.MutationFunction<GenerateReportPdfMutation, GenerateReportPdfMutationVariables>;

/**
 * __useGenerateReportPdfMutation__
 *
 * To run a mutation, you first call `useGenerateReportPdfMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGenerateReportPdfMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generateReportPdfMutation, { data, loading, error }] = useGenerateReportPdfMutation({
 *   variables: {
 *      reportIds: // value for 'reportIds'
 *   },
 * });
 */
export function useGenerateReportPdfMutation(baseOptions?: Apollo.MutationHookOptions<GenerateReportPdfMutation, GenerateReportPdfMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GenerateReportPdfMutation, GenerateReportPdfMutationVariables>(GenerateReportPdfDocument, options);
      }
export type GenerateReportPdfMutationHookResult = ReturnType<typeof useGenerateReportPdfMutation>;
export type GenerateReportPdfMutationResult = Apollo.MutationResult<GenerateReportPdfMutation>;
export type GenerateReportPdfMutationOptions = Apollo.BaseMutationOptions<GenerateReportPdfMutation, GenerateReportPdfMutationVariables>;
export const FilteredOptionsDocument = gql`
    query FilteredOptions($templateId: ID!, $fieldKey: String!, $fieldId: ID, $q: String, $count: Int, $skip: Int, $limit: Int) {
  filteredOptions(
    templateId: $templateId
    fieldKey: $fieldKey
    fieldId: $fieldId
    q: $q
    count: $count
    skip: $skip
    limit: $limit
  ) {
    options
  }
}
    `;

/**
 * __useFilteredOptionsQuery__
 *
 * To run a query within a React component, call `useFilteredOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFilteredOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFilteredOptionsQuery({
 *   variables: {
 *      templateId: // value for 'templateId'
 *      fieldKey: // value for 'fieldKey'
 *      fieldId: // value for 'fieldId'
 *      q: // value for 'q'
 *      count: // value for 'count'
 *      skip: // value for 'skip'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useFilteredOptionsQuery(baseOptions: Apollo.QueryHookOptions<FilteredOptionsQuery, FilteredOptionsQueryVariables> & ({ variables: FilteredOptionsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FilteredOptionsQuery, FilteredOptionsQueryVariables>(FilteredOptionsDocument, options);
      }
export function useFilteredOptionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FilteredOptionsQuery, FilteredOptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FilteredOptionsQuery, FilteredOptionsQueryVariables>(FilteredOptionsDocument, options);
        }
// @ts-ignore
export function useFilteredOptionsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<FilteredOptionsQuery, FilteredOptionsQueryVariables>): Apollo.UseSuspenseQueryResult<FilteredOptionsQuery, FilteredOptionsQueryVariables>;
export function useFilteredOptionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FilteredOptionsQuery, FilteredOptionsQueryVariables>): Apollo.UseSuspenseQueryResult<FilteredOptionsQuery | undefined, FilteredOptionsQueryVariables>;
export function useFilteredOptionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FilteredOptionsQuery, FilteredOptionsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FilteredOptionsQuery, FilteredOptionsQueryVariables>(FilteredOptionsDocument, options);
        }
export type FilteredOptionsQueryHookResult = ReturnType<typeof useFilteredOptionsQuery>;
export type FilteredOptionsLazyQueryHookResult = ReturnType<typeof useFilteredOptionsLazyQuery>;
export type FilteredOptionsSuspenseQueryHookResult = ReturnType<typeof useFilteredOptionsSuspenseQuery>;
export type FilteredOptionsQueryResult = Apollo.QueryResult<FilteredOptionsQuery, FilteredOptionsQueryVariables>;
export const AllPaintRegionsForFilterAndSearchPanelDocument = gql`
    query AllPaintRegionsForFilterAndSearchPanel($input: FindAllPaintRegionsInput!) {
  allPaintRegions(input: $input) {
    id
    name
    paintRegionGroupId
  }
}
    `;

/**
 * __useAllPaintRegionsForFilterAndSearchPanelQuery__
 *
 * To run a query within a React component, call `useAllPaintRegionsForFilterAndSearchPanelQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllPaintRegionsForFilterAndSearchPanelQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllPaintRegionsForFilterAndSearchPanelQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAllPaintRegionsForFilterAndSearchPanelQuery(baseOptions: Apollo.QueryHookOptions<AllPaintRegionsForFilterAndSearchPanelQuery, AllPaintRegionsForFilterAndSearchPanelQueryVariables> & ({ variables: AllPaintRegionsForFilterAndSearchPanelQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AllPaintRegionsForFilterAndSearchPanelQuery, AllPaintRegionsForFilterAndSearchPanelQueryVariables>(AllPaintRegionsForFilterAndSearchPanelDocument, options);
      }
export function useAllPaintRegionsForFilterAndSearchPanelLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AllPaintRegionsForFilterAndSearchPanelQuery, AllPaintRegionsForFilterAndSearchPanelQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AllPaintRegionsForFilterAndSearchPanelQuery, AllPaintRegionsForFilterAndSearchPanelQueryVariables>(AllPaintRegionsForFilterAndSearchPanelDocument, options);
        }
// @ts-ignore
export function useAllPaintRegionsForFilterAndSearchPanelSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<AllPaintRegionsForFilterAndSearchPanelQuery, AllPaintRegionsForFilterAndSearchPanelQueryVariables>): Apollo.UseSuspenseQueryResult<AllPaintRegionsForFilterAndSearchPanelQuery, AllPaintRegionsForFilterAndSearchPanelQueryVariables>;
export function useAllPaintRegionsForFilterAndSearchPanelSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AllPaintRegionsForFilterAndSearchPanelQuery, AllPaintRegionsForFilterAndSearchPanelQueryVariables>): Apollo.UseSuspenseQueryResult<AllPaintRegionsForFilterAndSearchPanelQuery | undefined, AllPaintRegionsForFilterAndSearchPanelQueryVariables>;
export function useAllPaintRegionsForFilterAndSearchPanelSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AllPaintRegionsForFilterAndSearchPanelQuery, AllPaintRegionsForFilterAndSearchPanelQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AllPaintRegionsForFilterAndSearchPanelQuery, AllPaintRegionsForFilterAndSearchPanelQueryVariables>(AllPaintRegionsForFilterAndSearchPanelDocument, options);
        }
export type AllPaintRegionsForFilterAndSearchPanelQueryHookResult = ReturnType<typeof useAllPaintRegionsForFilterAndSearchPanelQuery>;
export type AllPaintRegionsForFilterAndSearchPanelLazyQueryHookResult = ReturnType<typeof useAllPaintRegionsForFilterAndSearchPanelLazyQuery>;
export type AllPaintRegionsForFilterAndSearchPanelSuspenseQueryHookResult = ReturnType<typeof useAllPaintRegionsForFilterAndSearchPanelSuspenseQuery>;
export type AllPaintRegionsForFilterAndSearchPanelQueryResult = Apollo.QueryResult<AllPaintRegionsForFilterAndSearchPanelQuery, AllPaintRegionsForFilterAndSearchPanelQueryVariables>;
export const GetVersionsDocument = gql`
    query GetVersions($input: VersionInput) {
  allVersions(input: $input) {
    id
    structureId
    referenceId
    updatedData
    previousData
    collectionName
    lastModifiedFor
    lastModifiedBy
    lastModifiedByUser {
      id
      name
      picture
      email
      connection
      roleIds {
        name
        auth0Id
        id
      }
    }
    createdAt
  }
}
    `;

/**
 * __useGetVersionsQuery__
 *
 * To run a query within a React component, call `useGetVersionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetVersionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetVersionsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetVersionsQuery(baseOptions?: Apollo.QueryHookOptions<GetVersionsQuery, GetVersionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetVersionsQuery, GetVersionsQueryVariables>(GetVersionsDocument, options);
      }
export function useGetVersionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetVersionsQuery, GetVersionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetVersionsQuery, GetVersionsQueryVariables>(GetVersionsDocument, options);
        }
// @ts-ignore
export function useGetVersionsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetVersionsQuery, GetVersionsQueryVariables>): Apollo.UseSuspenseQueryResult<GetVersionsQuery, GetVersionsQueryVariables>;
export function useGetVersionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetVersionsQuery, GetVersionsQueryVariables>): Apollo.UseSuspenseQueryResult<GetVersionsQuery | undefined, GetVersionsQueryVariables>;
export function useGetVersionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetVersionsQuery, GetVersionsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetVersionsQuery, GetVersionsQueryVariables>(GetVersionsDocument, options);
        }
export type GetVersionsQueryHookResult = ReturnType<typeof useGetVersionsQuery>;
export type GetVersionsLazyQueryHookResult = ReturnType<typeof useGetVersionsLazyQuery>;
export type GetVersionsSuspenseQueryHookResult = ReturnType<typeof useGetVersionsSuspenseQuery>;
export type GetVersionsQueryResult = Apollo.QueryResult<GetVersionsQuery, GetVersionsQueryVariables>;
export const RollbackVersionDocument = gql`
    mutation RollbackVersion($input: RollbackVersionInput) {
  rollbackVersion(input: $input) {
    id
  }
}
    `;
export type RollbackVersionMutationFn = Apollo.MutationFunction<RollbackVersionMutation, RollbackVersionMutationVariables>;

/**
 * __useRollbackVersionMutation__
 *
 * To run a mutation, you first call `useRollbackVersionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRollbackVersionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [rollbackVersionMutation, { data, loading, error }] = useRollbackVersionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRollbackVersionMutation(baseOptions?: Apollo.MutationHookOptions<RollbackVersionMutation, RollbackVersionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RollbackVersionMutation, RollbackVersionMutationVariables>(RollbackVersionDocument, options);
      }
export type RollbackVersionMutationHookResult = ReturnType<typeof useRollbackVersionMutation>;
export type RollbackVersionMutationResult = Apollo.MutationResult<RollbackVersionMutation>;
export type RollbackVersionMutationOptions = Apollo.BaseMutationOptions<RollbackVersionMutation, RollbackVersionMutationVariables>;
export const WorkpackForKpiTrackerDocument = gql`
    query WorkpackForKpiTracker($workpackId: String) {
  workpack(workpackId: $workpackId) {
    id
    name
  }
}
    `;

/**
 * __useWorkpackForKpiTrackerQuery__
 *
 * To run a query within a React component, call `useWorkpackForKpiTrackerQuery` and pass it any options that fit your needs.
 * When your component renders, `useWorkpackForKpiTrackerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWorkpackForKpiTrackerQuery({
 *   variables: {
 *      workpackId: // value for 'workpackId'
 *   },
 * });
 */
export function useWorkpackForKpiTrackerQuery(baseOptions?: Apollo.QueryHookOptions<WorkpackForKpiTrackerQuery, WorkpackForKpiTrackerQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<WorkpackForKpiTrackerQuery, WorkpackForKpiTrackerQueryVariables>(WorkpackForKpiTrackerDocument, options);
      }
export function useWorkpackForKpiTrackerLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<WorkpackForKpiTrackerQuery, WorkpackForKpiTrackerQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<WorkpackForKpiTrackerQuery, WorkpackForKpiTrackerQueryVariables>(WorkpackForKpiTrackerDocument, options);
        }
// @ts-ignore
export function useWorkpackForKpiTrackerSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<WorkpackForKpiTrackerQuery, WorkpackForKpiTrackerQueryVariables>): Apollo.UseSuspenseQueryResult<WorkpackForKpiTrackerQuery, WorkpackForKpiTrackerQueryVariables>;
export function useWorkpackForKpiTrackerSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<WorkpackForKpiTrackerQuery, WorkpackForKpiTrackerQueryVariables>): Apollo.UseSuspenseQueryResult<WorkpackForKpiTrackerQuery | undefined, WorkpackForKpiTrackerQueryVariables>;
export function useWorkpackForKpiTrackerSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<WorkpackForKpiTrackerQuery, WorkpackForKpiTrackerQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<WorkpackForKpiTrackerQuery, WorkpackForKpiTrackerQueryVariables>(WorkpackForKpiTrackerDocument, options);
        }
export type WorkpackForKpiTrackerQueryHookResult = ReturnType<typeof useWorkpackForKpiTrackerQuery>;
export type WorkpackForKpiTrackerLazyQueryHookResult = ReturnType<typeof useWorkpackForKpiTrackerLazyQuery>;
export type WorkpackForKpiTrackerSuspenseQueryHookResult = ReturnType<typeof useWorkpackForKpiTrackerSuspenseQuery>;
export type WorkpackForKpiTrackerQueryResult = Apollo.QueryResult<WorkpackForKpiTrackerQuery, WorkpackForKpiTrackerQueryVariables>;
export const AllWorklogsTemplatesForKpiTrackerDocument = gql`
    query AllWorklogsTemplatesForKpiTracker($input: LogsTemplateInput!) {
  allLogsTemplates(input: $input) {
    id
    name
    sections {
      id
      key
      title
      sectionUnit
      order
      defaultOpen
      fieldKeys
      displayInLogging
    }
    fields {
      id
      key
      name
      sectionKey
      displayInLogAggregation
      isDerived
      fieldDescription
      fieldUnit
      roundToDecimal
    }
  }
}
    `;

/**
 * __useAllWorklogsTemplatesForKpiTrackerQuery__
 *
 * To run a query within a React component, call `useAllWorklogsTemplatesForKpiTrackerQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllWorklogsTemplatesForKpiTrackerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllWorklogsTemplatesForKpiTrackerQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAllWorklogsTemplatesForKpiTrackerQuery(baseOptions: Apollo.QueryHookOptions<AllWorklogsTemplatesForKpiTrackerQuery, AllWorklogsTemplatesForKpiTrackerQueryVariables> & ({ variables: AllWorklogsTemplatesForKpiTrackerQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AllWorklogsTemplatesForKpiTrackerQuery, AllWorklogsTemplatesForKpiTrackerQueryVariables>(AllWorklogsTemplatesForKpiTrackerDocument, options);
      }
export function useAllWorklogsTemplatesForKpiTrackerLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AllWorklogsTemplatesForKpiTrackerQuery, AllWorklogsTemplatesForKpiTrackerQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AllWorklogsTemplatesForKpiTrackerQuery, AllWorklogsTemplatesForKpiTrackerQueryVariables>(AllWorklogsTemplatesForKpiTrackerDocument, options);
        }
// @ts-ignore
export function useAllWorklogsTemplatesForKpiTrackerSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<AllWorklogsTemplatesForKpiTrackerQuery, AllWorklogsTemplatesForKpiTrackerQueryVariables>): Apollo.UseSuspenseQueryResult<AllWorklogsTemplatesForKpiTrackerQuery, AllWorklogsTemplatesForKpiTrackerQueryVariables>;
export function useAllWorklogsTemplatesForKpiTrackerSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AllWorklogsTemplatesForKpiTrackerQuery, AllWorklogsTemplatesForKpiTrackerQueryVariables>): Apollo.UseSuspenseQueryResult<AllWorklogsTemplatesForKpiTrackerQuery | undefined, AllWorklogsTemplatesForKpiTrackerQueryVariables>;
export function useAllWorklogsTemplatesForKpiTrackerSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AllWorklogsTemplatesForKpiTrackerQuery, AllWorklogsTemplatesForKpiTrackerQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AllWorklogsTemplatesForKpiTrackerQuery, AllWorklogsTemplatesForKpiTrackerQueryVariables>(AllWorklogsTemplatesForKpiTrackerDocument, options);
        }
export type AllWorklogsTemplatesForKpiTrackerQueryHookResult = ReturnType<typeof useAllWorklogsTemplatesForKpiTrackerQuery>;
export type AllWorklogsTemplatesForKpiTrackerLazyQueryHookResult = ReturnType<typeof useAllWorklogsTemplatesForKpiTrackerLazyQuery>;
export type AllWorklogsTemplatesForKpiTrackerSuspenseQueryHookResult = ReturnType<typeof useAllWorklogsTemplatesForKpiTrackerSuspenseQuery>;
export type AllWorklogsTemplatesForKpiTrackerQueryResult = Apollo.QueryResult<AllWorklogsTemplatesForKpiTrackerQuery, AllWorklogsTemplatesForKpiTrackerQueryVariables>;
export const AssemblyTemplatesDocument = gql`
    query AssemblyTemplates($structureId: ID, $type: TemplateTypeEnum) {
  allTemplates(structureId: $structureId, type: $type) {
    id
  }
}
    `;

/**
 * __useAssemblyTemplatesQuery__
 *
 * To run a query within a React component, call `useAssemblyTemplatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useAssemblyTemplatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAssemblyTemplatesQuery({
 *   variables: {
 *      structureId: // value for 'structureId'
 *      type: // value for 'type'
 *   },
 * });
 */
export function useAssemblyTemplatesQuery(baseOptions?: Apollo.QueryHookOptions<AssemblyTemplatesQuery, AssemblyTemplatesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AssemblyTemplatesQuery, AssemblyTemplatesQueryVariables>(AssemblyTemplatesDocument, options);
      }
export function useAssemblyTemplatesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AssemblyTemplatesQuery, AssemblyTemplatesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AssemblyTemplatesQuery, AssemblyTemplatesQueryVariables>(AssemblyTemplatesDocument, options);
        }
// @ts-ignore
export function useAssemblyTemplatesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<AssemblyTemplatesQuery, AssemblyTemplatesQueryVariables>): Apollo.UseSuspenseQueryResult<AssemblyTemplatesQuery, AssemblyTemplatesQueryVariables>;
export function useAssemblyTemplatesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AssemblyTemplatesQuery, AssemblyTemplatesQueryVariables>): Apollo.UseSuspenseQueryResult<AssemblyTemplatesQuery | undefined, AssemblyTemplatesQueryVariables>;
export function useAssemblyTemplatesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AssemblyTemplatesQuery, AssemblyTemplatesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AssemblyTemplatesQuery, AssemblyTemplatesQueryVariables>(AssemblyTemplatesDocument, options);
        }
export type AssemblyTemplatesQueryHookResult = ReturnType<typeof useAssemblyTemplatesQuery>;
export type AssemblyTemplatesLazyQueryHookResult = ReturnType<typeof useAssemblyTemplatesLazyQuery>;
export type AssemblyTemplatesSuspenseQueryHookResult = ReturnType<typeof useAssemblyTemplatesSuspenseQuery>;
export type AssemblyTemplatesQueryResult = Apollo.QueryResult<AssemblyTemplatesQuery, AssemblyTemplatesQueryVariables>;
export const LogEntriesPerDateDocument = gql`
    query LogEntriesPerDate($input: LogEntriesPerDateInput!) {
  logEntriesPerDate(input: $input) {
    fieldKey
    total
  }
}
    `;

/**
 * __useLogEntriesPerDateQuery__
 *
 * To run a query within a React component, call `useLogEntriesPerDateQuery` and pass it any options that fit your needs.
 * When your component renders, `useLogEntriesPerDateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLogEntriesPerDateQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useLogEntriesPerDateQuery(baseOptions: Apollo.QueryHookOptions<LogEntriesPerDateQuery, LogEntriesPerDateQueryVariables> & ({ variables: LogEntriesPerDateQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LogEntriesPerDateQuery, LogEntriesPerDateQueryVariables>(LogEntriesPerDateDocument, options);
      }
export function useLogEntriesPerDateLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LogEntriesPerDateQuery, LogEntriesPerDateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LogEntriesPerDateQuery, LogEntriesPerDateQueryVariables>(LogEntriesPerDateDocument, options);
        }
// @ts-ignore
export function useLogEntriesPerDateSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<LogEntriesPerDateQuery, LogEntriesPerDateQueryVariables>): Apollo.UseSuspenseQueryResult<LogEntriesPerDateQuery, LogEntriesPerDateQueryVariables>;
export function useLogEntriesPerDateSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<LogEntriesPerDateQuery, LogEntriesPerDateQueryVariables>): Apollo.UseSuspenseQueryResult<LogEntriesPerDateQuery | undefined, LogEntriesPerDateQueryVariables>;
export function useLogEntriesPerDateSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<LogEntriesPerDateQuery, LogEntriesPerDateQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<LogEntriesPerDateQuery, LogEntriesPerDateQueryVariables>(LogEntriesPerDateDocument, options);
        }
export type LogEntriesPerDateQueryHookResult = ReturnType<typeof useLogEntriesPerDateQuery>;
export type LogEntriesPerDateLazyQueryHookResult = ReturnType<typeof useLogEntriesPerDateLazyQuery>;
export type LogEntriesPerDateSuspenseQueryHookResult = ReturnType<typeof useLogEntriesPerDateSuspenseQuery>;
export type LogEntriesPerDateQueryResult = Apollo.QueryResult<LogEntriesPerDateQuery, LogEntriesPerDateQueryVariables>;
export const UpdateLogEntryDocument = gql`
    mutation UpdateLogEntry($input: UpdateLogEntryInput!) {
  updateLogEntry(input: $input) {
    id
    shift
    logDate
  }
}
    `;
export type UpdateLogEntryMutationFn = Apollo.MutationFunction<UpdateLogEntryMutation, UpdateLogEntryMutationVariables>;

/**
 * __useUpdateLogEntryMutation__
 *
 * To run a mutation, you first call `useUpdateLogEntryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateLogEntryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateLogEntryMutation, { data, loading, error }] = useUpdateLogEntryMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateLogEntryMutation(baseOptions?: Apollo.MutationHookOptions<UpdateLogEntryMutation, UpdateLogEntryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateLogEntryMutation, UpdateLogEntryMutationVariables>(UpdateLogEntryDocument, options);
      }
export type UpdateLogEntryMutationHookResult = ReturnType<typeof useUpdateLogEntryMutation>;
export type UpdateLogEntryMutationResult = Apollo.MutationResult<UpdateLogEntryMutation>;
export type UpdateLogEntryMutationOptions = Apollo.BaseMutationOptions<UpdateLogEntryMutation, UpdateLogEntryMutationVariables>;
export const UpsertLogEntryDocument = gql`
    mutation UpsertLogEntry($input: UpsertLogEntryInput!) {
  upsertLogEntry(input: $input) {
    id
    shift
    logDate
  }
}
    `;
export type UpsertLogEntryMutationFn = Apollo.MutationFunction<UpsertLogEntryMutation, UpsertLogEntryMutationVariables>;

/**
 * __useUpsertLogEntryMutation__
 *
 * To run a mutation, you first call `useUpsertLogEntryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertLogEntryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertLogEntryMutation, { data, loading, error }] = useUpsertLogEntryMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpsertLogEntryMutation(baseOptions?: Apollo.MutationHookOptions<UpsertLogEntryMutation, UpsertLogEntryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpsertLogEntryMutation, UpsertLogEntryMutationVariables>(UpsertLogEntryDocument, options);
      }
export type UpsertLogEntryMutationHookResult = ReturnType<typeof useUpsertLogEntryMutation>;
export type UpsertLogEntryMutationResult = Apollo.MutationResult<UpsertLogEntryMutation>;
export type UpsertLogEntryMutationOptions = Apollo.BaseMutationOptions<UpsertLogEntryMutation, UpsertLogEntryMutationVariables>;
export const GetAggregatedKpiLogEntriesDocument = gql`
    query GetAggregatedKpiLogEntries($input: AggregatedKpiLogEntriesInput!, $pageInfo: PageInfo) {
  getAggregatedKpiLogEntries(input: $input, pageInfo: $pageInfo) {
    endDate
    logDate
    startDate
    fields {
      value
      fieldKey
    }
    fieldTotals {
      total
      fieldKey
    }
  }
}
    `;

/**
 * __useGetAggregatedKpiLogEntriesQuery__
 *
 * To run a query within a React component, call `useGetAggregatedKpiLogEntriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAggregatedKpiLogEntriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAggregatedKpiLogEntriesQuery({
 *   variables: {
 *      input: // value for 'input'
 *      pageInfo: // value for 'pageInfo'
 *   },
 * });
 */
export function useGetAggregatedKpiLogEntriesQuery(baseOptions: Apollo.QueryHookOptions<GetAggregatedKpiLogEntriesQuery, GetAggregatedKpiLogEntriesQueryVariables> & ({ variables: GetAggregatedKpiLogEntriesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAggregatedKpiLogEntriesQuery, GetAggregatedKpiLogEntriesQueryVariables>(GetAggregatedKpiLogEntriesDocument, options);
      }
export function useGetAggregatedKpiLogEntriesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAggregatedKpiLogEntriesQuery, GetAggregatedKpiLogEntriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAggregatedKpiLogEntriesQuery, GetAggregatedKpiLogEntriesQueryVariables>(GetAggregatedKpiLogEntriesDocument, options);
        }
// @ts-ignore
export function useGetAggregatedKpiLogEntriesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetAggregatedKpiLogEntriesQuery, GetAggregatedKpiLogEntriesQueryVariables>): Apollo.UseSuspenseQueryResult<GetAggregatedKpiLogEntriesQuery, GetAggregatedKpiLogEntriesQueryVariables>;
export function useGetAggregatedKpiLogEntriesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAggregatedKpiLogEntriesQuery, GetAggregatedKpiLogEntriesQueryVariables>): Apollo.UseSuspenseQueryResult<GetAggregatedKpiLogEntriesQuery | undefined, GetAggregatedKpiLogEntriesQueryVariables>;
export function useGetAggregatedKpiLogEntriesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAggregatedKpiLogEntriesQuery, GetAggregatedKpiLogEntriesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAggregatedKpiLogEntriesQuery, GetAggregatedKpiLogEntriesQueryVariables>(GetAggregatedKpiLogEntriesDocument, options);
        }
export type GetAggregatedKpiLogEntriesQueryHookResult = ReturnType<typeof useGetAggregatedKpiLogEntriesQuery>;
export type GetAggregatedKpiLogEntriesLazyQueryHookResult = ReturnType<typeof useGetAggregatedKpiLogEntriesLazyQuery>;
export type GetAggregatedKpiLogEntriesSuspenseQueryHookResult = ReturnType<typeof useGetAggregatedKpiLogEntriesSuspenseQuery>;
export type GetAggregatedKpiLogEntriesQueryResult = Apollo.QueryResult<GetAggregatedKpiLogEntriesQuery, GetAggregatedKpiLogEntriesQueryVariables>;
export const GetLogEntryCardsDocument = gql`
    query GetLogEntryCards($input: LogEntryCardsInput!) {
  getLogEntryCards(input: $input) {
    icon
    key
    roundToDecimal
    subtitle {
      icon
      iconPosition
      value
      unitPosition
      unit
      text
    }
    title
    unit
    unitPosition
    value
  }
}
    `;

/**
 * __useGetLogEntryCardsQuery__
 *
 * To run a query within a React component, call `useGetLogEntryCardsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLogEntryCardsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLogEntryCardsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetLogEntryCardsQuery(baseOptions: Apollo.QueryHookOptions<GetLogEntryCardsQuery, GetLogEntryCardsQueryVariables> & ({ variables: GetLogEntryCardsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLogEntryCardsQuery, GetLogEntryCardsQueryVariables>(GetLogEntryCardsDocument, options);
      }
export function useGetLogEntryCardsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetLogEntryCardsQuery, GetLogEntryCardsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLogEntryCardsQuery, GetLogEntryCardsQueryVariables>(GetLogEntryCardsDocument, options);
        }
// @ts-ignore
export function useGetLogEntryCardsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetLogEntryCardsQuery, GetLogEntryCardsQueryVariables>): Apollo.UseSuspenseQueryResult<GetLogEntryCardsQuery, GetLogEntryCardsQueryVariables>;
export function useGetLogEntryCardsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetLogEntryCardsQuery, GetLogEntryCardsQueryVariables>): Apollo.UseSuspenseQueryResult<GetLogEntryCardsQuery | undefined, GetLogEntryCardsQueryVariables>;
export function useGetLogEntryCardsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetLogEntryCardsQuery, GetLogEntryCardsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetLogEntryCardsQuery, GetLogEntryCardsQueryVariables>(GetLogEntryCardsDocument, options);
        }
export type GetLogEntryCardsQueryHookResult = ReturnType<typeof useGetLogEntryCardsQuery>;
export type GetLogEntryCardsLazyQueryHookResult = ReturnType<typeof useGetLogEntryCardsLazyQuery>;
export type GetLogEntryCardsSuspenseQueryHookResult = ReturnType<typeof useGetLogEntryCardsSuspenseQuery>;
export type GetLogEntryCardsQueryResult = Apollo.QueryResult<GetLogEntryCardsQuery, GetLogEntryCardsQueryVariables>;
export const GetWorkpackAttachmentsPerDateDocument = gql`
    query GetWorkpackAttachmentsPerDate($input: WorkpackAttachmentsPerDateInput) {
  getWorkpackAttachmentsPerDate(input: $input) {
    id
    uuid
    resourcePath
    caption
    fileName
    imagePosition
    logDate
    name
    size
    type
    uploadStatus
    url
  }
}
    `;

/**
 * __useGetWorkpackAttachmentsPerDateQuery__
 *
 * To run a query within a React component, call `useGetWorkpackAttachmentsPerDateQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWorkpackAttachmentsPerDateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWorkpackAttachmentsPerDateQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetWorkpackAttachmentsPerDateQuery(baseOptions?: Apollo.QueryHookOptions<GetWorkpackAttachmentsPerDateQuery, GetWorkpackAttachmentsPerDateQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetWorkpackAttachmentsPerDateQuery, GetWorkpackAttachmentsPerDateQueryVariables>(GetWorkpackAttachmentsPerDateDocument, options);
      }
export function useGetWorkpackAttachmentsPerDateLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetWorkpackAttachmentsPerDateQuery, GetWorkpackAttachmentsPerDateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetWorkpackAttachmentsPerDateQuery, GetWorkpackAttachmentsPerDateQueryVariables>(GetWorkpackAttachmentsPerDateDocument, options);
        }
// @ts-ignore
export function useGetWorkpackAttachmentsPerDateSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetWorkpackAttachmentsPerDateQuery, GetWorkpackAttachmentsPerDateQueryVariables>): Apollo.UseSuspenseQueryResult<GetWorkpackAttachmentsPerDateQuery, GetWorkpackAttachmentsPerDateQueryVariables>;
export function useGetWorkpackAttachmentsPerDateSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetWorkpackAttachmentsPerDateQuery, GetWorkpackAttachmentsPerDateQueryVariables>): Apollo.UseSuspenseQueryResult<GetWorkpackAttachmentsPerDateQuery | undefined, GetWorkpackAttachmentsPerDateQueryVariables>;
export function useGetWorkpackAttachmentsPerDateSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetWorkpackAttachmentsPerDateQuery, GetWorkpackAttachmentsPerDateQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetWorkpackAttachmentsPerDateQuery, GetWorkpackAttachmentsPerDateQueryVariables>(GetWorkpackAttachmentsPerDateDocument, options);
        }
export type GetWorkpackAttachmentsPerDateQueryHookResult = ReturnType<typeof useGetWorkpackAttachmentsPerDateQuery>;
export type GetWorkpackAttachmentsPerDateLazyQueryHookResult = ReturnType<typeof useGetWorkpackAttachmentsPerDateLazyQuery>;
export type GetWorkpackAttachmentsPerDateSuspenseQueryHookResult = ReturnType<typeof useGetWorkpackAttachmentsPerDateSuspenseQuery>;
export type GetWorkpackAttachmentsPerDateQueryResult = Apollo.QueryResult<GetWorkpackAttachmentsPerDateQuery, GetWorkpackAttachmentsPerDateQueryVariables>;
export const UpdateKpiFiltersInPlatformPreferencesDocument = gql`
    mutation UpdateKpiFiltersInPlatformPreferences($input: UpdateUserPlatformPreferencesInput) {
  updateUserPlatformPreferences(input: $input) {
    preferences {
      platform
    }
  }
}
    `;
export type UpdateKpiFiltersInPlatformPreferencesMutationFn = Apollo.MutationFunction<UpdateKpiFiltersInPlatformPreferencesMutation, UpdateKpiFiltersInPlatformPreferencesMutationVariables>;

/**
 * __useUpdateKpiFiltersInPlatformPreferencesMutation__
 *
 * To run a mutation, you first call `useUpdateKpiFiltersInPlatformPreferencesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateKpiFiltersInPlatformPreferencesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateKpiFiltersInPlatformPreferencesMutation, { data, loading, error }] = useUpdateKpiFiltersInPlatformPreferencesMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateKpiFiltersInPlatformPreferencesMutation(baseOptions?: Apollo.MutationHookOptions<UpdateKpiFiltersInPlatformPreferencesMutation, UpdateKpiFiltersInPlatformPreferencesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateKpiFiltersInPlatformPreferencesMutation, UpdateKpiFiltersInPlatformPreferencesMutationVariables>(UpdateKpiFiltersInPlatformPreferencesDocument, options);
      }
export type UpdateKpiFiltersInPlatformPreferencesMutationHookResult = ReturnType<typeof useUpdateKpiFiltersInPlatformPreferencesMutation>;
export type UpdateKpiFiltersInPlatformPreferencesMutationResult = Apollo.MutationResult<UpdateKpiFiltersInPlatformPreferencesMutation>;
export type UpdateKpiFiltersInPlatformPreferencesMutationOptions = Apollo.BaseMutationOptions<UpdateKpiFiltersInPlatformPreferencesMutation, UpdateKpiFiltersInPlatformPreferencesMutationVariables>;
export const UploadWorkpackAttachmentsDocument = gql`
    mutation UploadWorkpackAttachments($input: UploadWorkpackAttachmentsInput) {
  uploadWorkpackAttachments(input: $input) {
    id
    resourcePath
    url
    uuid
  }
}
    `;
export type UploadWorkpackAttachmentsMutationFn = Apollo.MutationFunction<UploadWorkpackAttachmentsMutation, UploadWorkpackAttachmentsMutationVariables>;

/**
 * __useUploadWorkpackAttachmentsMutation__
 *
 * To run a mutation, you first call `useUploadWorkpackAttachmentsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUploadWorkpackAttachmentsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [uploadWorkpackAttachmentsMutation, { data, loading, error }] = useUploadWorkpackAttachmentsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUploadWorkpackAttachmentsMutation(baseOptions?: Apollo.MutationHookOptions<UploadWorkpackAttachmentsMutation, UploadWorkpackAttachmentsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UploadWorkpackAttachmentsMutation, UploadWorkpackAttachmentsMutationVariables>(UploadWorkpackAttachmentsDocument, options);
      }
export type UploadWorkpackAttachmentsMutationHookResult = ReturnType<typeof useUploadWorkpackAttachmentsMutation>;
export type UploadWorkpackAttachmentsMutationResult = Apollo.MutationResult<UploadWorkpackAttachmentsMutation>;
export type UploadWorkpackAttachmentsMutationOptions = Apollo.BaseMutationOptions<UploadWorkpackAttachmentsMutation, UploadWorkpackAttachmentsMutationVariables>;
export const RemoveWorkpackAttachmentsDocument = gql`
    mutation RemoveWorkpackAttachments($input: RemoveWorkpackAttachmentsInput!) {
  removeWorkpackAttachments(input: $input) {
    name
    id
  }
}
    `;
export type RemoveWorkpackAttachmentsMutationFn = Apollo.MutationFunction<RemoveWorkpackAttachmentsMutation, RemoveWorkpackAttachmentsMutationVariables>;

/**
 * __useRemoveWorkpackAttachmentsMutation__
 *
 * To run a mutation, you first call `useRemoveWorkpackAttachmentsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveWorkpackAttachmentsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeWorkpackAttachmentsMutation, { data, loading, error }] = useRemoveWorkpackAttachmentsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRemoveWorkpackAttachmentsMutation(baseOptions?: Apollo.MutationHookOptions<RemoveWorkpackAttachmentsMutation, RemoveWorkpackAttachmentsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveWorkpackAttachmentsMutation, RemoveWorkpackAttachmentsMutationVariables>(RemoveWorkpackAttachmentsDocument, options);
      }
export type RemoveWorkpackAttachmentsMutationHookResult = ReturnType<typeof useRemoveWorkpackAttachmentsMutation>;
export type RemoveWorkpackAttachmentsMutationResult = Apollo.MutationResult<RemoveWorkpackAttachmentsMutation>;
export type RemoveWorkpackAttachmentsMutationOptions = Apollo.BaseMutationOptions<RemoveWorkpackAttachmentsMutation, RemoveWorkpackAttachmentsMutationVariables>;
export const UpdateWorkpackAttachmentFileStatusDocument = gql`
    mutation UpdateWorkpackAttachmentFileStatus($input: InputUpdateFileForWorkpack) {
  updateWorkpackAttachmentFileStatus(input: $input) {
    id
    name
  }
}
    `;
export type UpdateWorkpackAttachmentFileStatusMutationFn = Apollo.MutationFunction<UpdateWorkpackAttachmentFileStatusMutation, UpdateWorkpackAttachmentFileStatusMutationVariables>;

/**
 * __useUpdateWorkpackAttachmentFileStatusMutation__
 *
 * To run a mutation, you first call `useUpdateWorkpackAttachmentFileStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateWorkpackAttachmentFileStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateWorkpackAttachmentFileStatusMutation, { data, loading, error }] = useUpdateWorkpackAttachmentFileStatusMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateWorkpackAttachmentFileStatusMutation(baseOptions?: Apollo.MutationHookOptions<UpdateWorkpackAttachmentFileStatusMutation, UpdateWorkpackAttachmentFileStatusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateWorkpackAttachmentFileStatusMutation, UpdateWorkpackAttachmentFileStatusMutationVariables>(UpdateWorkpackAttachmentFileStatusDocument, options);
      }
export type UpdateWorkpackAttachmentFileStatusMutationHookResult = ReturnType<typeof useUpdateWorkpackAttachmentFileStatusMutation>;
export type UpdateWorkpackAttachmentFileStatusMutationResult = Apollo.MutationResult<UpdateWorkpackAttachmentFileStatusMutation>;
export type UpdateWorkpackAttachmentFileStatusMutationOptions = Apollo.BaseMutationOptions<UpdateWorkpackAttachmentFileStatusMutation, UpdateWorkpackAttachmentFileStatusMutationVariables>;
export const LogEntriesByReferenceDocument = gql`
    query LogEntriesByReference($input: FindLogEntriesByReferenceInput!) {
  logEntriesByReference(input: $input) {
    id
  }
}
    `;

/**
 * __useLogEntriesByReferenceQuery__
 *
 * To run a query within a React component, call `useLogEntriesByReferenceQuery` and pass it any options that fit your needs.
 * When your component renders, `useLogEntriesByReferenceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLogEntriesByReferenceQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useLogEntriesByReferenceQuery(baseOptions: Apollo.QueryHookOptions<LogEntriesByReferenceQuery, LogEntriesByReferenceQueryVariables> & ({ variables: LogEntriesByReferenceQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LogEntriesByReferenceQuery, LogEntriesByReferenceQueryVariables>(LogEntriesByReferenceDocument, options);
      }
export function useLogEntriesByReferenceLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LogEntriesByReferenceQuery, LogEntriesByReferenceQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LogEntriesByReferenceQuery, LogEntriesByReferenceQueryVariables>(LogEntriesByReferenceDocument, options);
        }
// @ts-ignore
export function useLogEntriesByReferenceSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<LogEntriesByReferenceQuery, LogEntriesByReferenceQueryVariables>): Apollo.UseSuspenseQueryResult<LogEntriesByReferenceQuery, LogEntriesByReferenceQueryVariables>;
export function useLogEntriesByReferenceSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<LogEntriesByReferenceQuery, LogEntriesByReferenceQueryVariables>): Apollo.UseSuspenseQueryResult<LogEntriesByReferenceQuery | undefined, LogEntriesByReferenceQueryVariables>;
export function useLogEntriesByReferenceSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<LogEntriesByReferenceQuery, LogEntriesByReferenceQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<LogEntriesByReferenceQuery, LogEntriesByReferenceQueryVariables>(LogEntriesByReferenceDocument, options);
        }
export type LogEntriesByReferenceQueryHookResult = ReturnType<typeof useLogEntriesByReferenceQuery>;
export type LogEntriesByReferenceLazyQueryHookResult = ReturnType<typeof useLogEntriesByReferenceLazyQuery>;
export type LogEntriesByReferenceSuspenseQueryHookResult = ReturnType<typeof useLogEntriesByReferenceSuspenseQuery>;
export type LogEntriesByReferenceQueryResult = Apollo.QueryResult<LogEntriesByReferenceQuery, LogEntriesByReferenceQueryVariables>;